webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(108);








var url = window.API_URL;

var getClient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_fp__["memoize"])(function () {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: url + '/api/v1'
  });
});

var getFrontendHelperClient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_fp__["memoize"])(function () {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: url + '/frontend-helper'
  });
});

/* harmony default export */ __webpack_exports__["a"] = ({
  get client() {
    return getClient();
  },
  get frontendHelperClient() {
    return getFrontendHelperClient();
  },
  get authHeader() {
    var token = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.token || '';
    return 'Bearer ' + token;
  },
  get versionHeader() {
    return window.VERSION_NUMBER || '';
  },
  get backendVersionHeader() {
    if (window.SITE_CONFIG) {
      return window.SITE_CONFIG.backend_version;
    }
    return '';
  },
  get pathHeader() {
    var path = '';
    if (__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app && __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app._route) {
      path = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].app._route.fullPath;
    } else {
      path = window.location.hash && window.location.hash.length > 0 ? window.location.hash.substring(1) : window.location.pathname;
    }
    return path;
  },
  get authHeaderSimple() {
    var user = localStorage.getItem('admin_user');
    return user;
  },
  get authParameter() {
    var user = localStorage.getItem('admin_user');
    if (user) {
      var parts = user.split(':');
      var u = window.btoa(parts[0]);
      var p = window.btoa(parts[1]);
      return u + ':' + p;
    }
    return '';
  },
  get authSimpleParameter() {
    var user = localStorage.getItem('admin_user');
    if (user) {
      return user;
    }
    return '';
  },
  get langHeader() {
    return localStorage.getItem('language') || (window.SITE_CONFIG ? window.SITE_CONFIG.languages.default : 'sv');
  },
  get onsiteParameter() {
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.isOnSite) {
      return '&onsite=1';
    }
    return '';
  },
  addLanguage: function addLanguage(path) {
    var urlpath = path;
    if (path.indexOf('?') === -1) {
      urlpath = urlpath + '?lang=' + this.langHeader;
    } else {
      urlpath = urlpath + '&lang=' + this.langHeader;
    }
    urlpath = '' + urlpath + this.onsiteParameter;
    return urlpath;
  },
  get: function get(path) {
    var _this = this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.client.get(_this.addLanguage(path), {
                params: params,
                headers: {
                  Authorization: _this.authHeader,
                  'X-Authorization-Simple': _this.authHeaderSimple,
                  'X-Path': _this.pathHeader,
                  'X-Version': _this.versionHeader,
                  'X-B-version': _this.backendVersionHeader
                }
              });

            case 2:
              return _context.abrupt('return', _context.sent.data);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  post: function post(path) {
    var _this2 = this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.client.post(_this2.addLanguage(path), {
                params: params
              }, {
                headers: {
                  Authorization: _this2.authHeader,
                  'X-Authorization-Simple': _this2.authHeaderSimple,
                  'X-Path': _this2.pathHeader,
                  'X-Version': _this2.versionHeader,
                  'X-B-version': _this2.backendVersionHeader
                }
              });

            case 2:
              return _context2.abrupt('return', _context2.sent.data);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  postFile: function postFile(path) {
    var _this3 = this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.client.post(_this3.addLanguage(path), params, {
                headers: {
                  Authorization: _this3.authHeader,
                  'X-Authorization-Simple': _this3.authHeaderSimple,
                  'X-Path': _this3.pathHeader,
                  'X-Version': _this3.versionHeader,
                  'X-B-version': _this3.backendVersionHeader,
                  'Content-Type': 'multipart/form-data'
                }
              });

            case 2:
              return _context3.abrupt('return', _context3.sent.data);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  frontendHelper: function frontendHelper(path) {
    var _this4 = this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.frontendHelperClient.post(path, {
                params: params
              }, {
                headers: {
                  Authorization: _this4.authHeader,
                  'X-Authorization-Simple': _this4.authHeaderSimple,
                  'X-Path': _this4.pathHeader,
                  'X-Version': _this4.versionHeader,
                  'X-B-version': _this4.backendVersionHeader
                }
              });

            case 2:
              return _context4.abrupt('return', _context4.sent.data);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getRaw: function getRaw(path) {
    var _this5 = this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.client.get(_this5.addLanguage(path), {
                params: params,
                headers: {
                  Authorization: _this5.authHeader,
                  'X-Authorization-Simple': _this5.authHeaderSimple,
                  'X-Path': _this5.pathHeader,
                  'X-Version': _this5.versionHeader,
                  'X-B-version': _this5.backendVersionHeader
                }
              });

            case 2:
              return _context5.abrupt('return', _context5.sent.data);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getUrl: function getUrl(path) {
    var urlLocal = window.API_URL;
    var baseURL = urlLocal + '/api/v1';
    return '' + baseURL + path;
  }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(891),
  /* scopeId */
  "data-v-0913ad93",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)
__webpack_require__(688)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  "data-v-733f8dbc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)
__webpack_require__(605)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(920),
  /* scopeId */
  "data-v-22344c9b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  "data-v-5198fb4d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(894),
  /* scopeId */
  "data-v-0b8a44cb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(579)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(897),
  /* scopeId */
  "data-v-0cabfd66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(721)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  "data-v-cd0e0e3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(657)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(967),
  /* scopeId */
  "data-v-47895ee0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return filterUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dayCountExcludeClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasClosedDaysInRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return endDateIncludeClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatAccomodationsFilterDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp__);








var filterUnit = function filterUnit(accomodationsFilter) {
  return function (unit) {
    var queryRegeExReplace = new RegExp(/[^a-z0-9åäö]/, 'igm');

    var unitTitle = (unit.display_name || unit.description_title) + (unit.subtitle ? ' - ' + unit.subtitle : '');
    unitTitle = unitTitle.toLowerCase();
    unitTitle = unitTitle.replaceAll(queryRegeExReplace, '');

    var titleMatching = true;

    if (accomodationsFilter.freeSearch) {
      var query = accomodationsFilter.freeSearch.toLowerCase();
      query = query.replaceAll(queryRegeExReplace, '');
      titleMatching = unitTitle.match(new RegExp(query, 'igm'));
    }

    var locationMatching = true;
    if (accomodationsFilter.locationId) {
      var areaText = accomodationsFilter.locationId.toString().substr(0, 5);
      var area = accomodationsFilter.locationId.toString().substr(5);
      if (areaText === 'area-') {
        locationMatching = unit.facility_id === parseInt(area, 10);
      } else {
        locationMatching = unit.pool.id === accomodationsFilter.locationId;
      }
    }

    var dateMatching = true;
    if (accomodationsFilter.date.startDate && accomodationsFilter.date.endDate) {
      var ids = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(accomodationsFilter.availabelIds);
      if (ids && ids.length) {
        dateMatching = ids.indexOf('' + unit.id) !== -1;
      }
    }

    var bedMatching = true;
    if (accomodationsFilter.beds > 1) {
      bedMatching = unit.beds + (unit.extra_beds || 0) >= accomodationsFilter.beds;
    }

    var bedRoomMatching = true;
    if (accomodationsFilter.bedrooms > 1) {
      bedRoomMatching = unit.bedrooms >= accomodationsFilter.bedrooms;
    }

    var digitalIncheckMatch = true;

    if (window.SITE_CONFIG.settings.SettingLockTypes.active) {
      digitalIncheckMatch = !accomodationsFilter.direct_incheck || unit.lock_type_id;
    } else {
      digitalIncheckMatch = !accomodationsFilter.direct_incheck || unit.direct_incheck;
    }

    return bedMatching && bedRoomMatching && (!accomodationsFilter.sauna || unit.sauna) && digitalIncheckMatch && (!accomodationsFilter.pets || unit.pets_allowed) && (!accomodationsFilter.chargeStation || unit.charging_post) && (!accomodationsFilter.cleaning || unit.final_cleaning_included) && (!accomodationsFilter.fireplace || unit.fireplace) && (!accomodationsFilter.dishwasher || unit.dishwasher) && (!accomodationsFilter.dryer_cabinet || unit.dryer_cabinet) && (!accomodationsFilter.washing_machine || unit.washing_machine) && (!accomodationsFilter.internet || unit.internet) && (!accomodationsFilter.child_friendly || unit.child_friendly) && locationMatching && dateMatching && titleMatching;
  };
};

var titleCase = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_fp__["flow"])([__WEBPACK_IMPORTED_MODULE_3_lodash_fp__["lowerCase"], __WEBPACK_IMPORTED_MODULE_3_lodash_fp__["upperFirst"]]);

var dayCountExcludeClosed = function dayCountExcludeClosed(start, end) {
  if (!start || !end) {
    return 0;
  }

  var range = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.range(start, end);
  var validDays = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(range.by('day')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var day = _step.value;

      var formatted = day.format('YYYY-MM-DD');
      if (window.SITE_CONFIG.season.winter.closed.indexOf(formatted) === -1) {
        validDays.push(formatted);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return validDays.length;
};

var hasClosedDaysInRange = function hasClosedDaysInRange(start, days) {
  if (!start || !days) {
    return false;
  }

  var newEnd = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start).add(days - 1, 'days');

  var range = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.range(start, newEnd);
  var invalidDays = [];

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(range.by('day')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var day = _step2.value;

      var formatted = day.format('YYYY-MM-DD');
      if (window.SITE_CONFIG.season.winter.closed.indexOf(formatted) > -1) {
        invalidDays.push(formatted);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return invalidDays.length ? true : false;
};

var endDateIncludeClosed = function endDateIncludeClosed(start, days) {
  if (!start) {
    return null;
  }
  if (!days) {
    return null;
  }

  if (days <= 1) {
    return null;
  }

  var newStart = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start);
  var day = newStart.clone();
  var dayCount = 0;
  var iterations = 0;

  while (dayCount < days && iterations <= 180) {
    iterations += 1;
    day.add(1, 'days');
    var formatted = day.format('YYYY-MM-DD');
    if (window.SITE_CONFIG.season.winter.closed.indexOf(formatted) === -1) {
      dayCount += 1;
    }
  }

  return day.subtract(1, 'days');
};


var formatAccomodationsFilterDate = function formatAccomodationsFilterDate(startDate, endDate) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(startDate).format('D/M') + ' \u2013 ' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(endDate).format('D/M');
};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(918),
  /* scopeId */
  "data-v-20d448b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    browserLanguage: function browserLanguage() {
      return this.getBrowserLanguage(window.navigator.language);
    },
    browserCountry: function browserCountry() {
      var parts = this.browserLanguage.split('-');
      var c = parts[0];

      if (parts.length === 2) {
        c = parts[1];
      }

      return c;
    },
    browserSimpleLanguage: function browserSimpleLanguage() {
      return this.getBrowserSimpleLanguage(this.browserLanguage);
    },
    theCurrentLanguage: function theCurrentLanguage() {
      if (localStorage.getItem('language')) {
        return localStorage.getItem('language');
      }

      return this.getBrowserSimpleLanguage(this.browserLanguage);
    },
    browserSimpleCountry: function browserSimpleCountry() {
      return this.getBrowserSimpleCountry(this.browserCountry);
    },
    theCurrentCountry: function theCurrentCountry() {
      if (localStorage.getItem('country')) {
        return localStorage.getItem('country');
      }

      var lang = this.theCurrentLanguage;
      console.log(lang);

      var bLang = this.getBrowserLanguage(lang);
      console.log(bLang);

      var country = this.getBrowserSimpleCountry(bLang);
      console.log(country);

      if (['DK', 'FI', 'NO', 'SE'] !== -1) {
        return country;
      }

      return 'other';
    }
  },
  methods: {
    getBrowserSimpleLanguage: function getBrowserSimpleLanguage(input) {
      var parts = input.split('-');
      var c = parts[0];

      if (parts.length === 2) {
        c = parts[0];
      }

      return c;
    },
    getBrowserSimpleCountry: function getBrowserSimpleCountry(input) {
      var parts = input.split('-');
      var c = parts[0];

      if (parts.length === 2) {
        c = parts[1];
      }

      return c;
    },
    getBrowserLanguage: function getBrowserLanguage(input) {
      var language = input;

      if (language.indexOf('-') !== -1) {
        return language;
      }

      if (language === 'sv') {
        return 'sv-SE';
      }

      if (language === 'da') {
        return 'da-DK';
      }

      if (language === 'fi') {
        return 'fi-FI';
      }

      if (language === 'no') {
        return 'nb-NO';
      }

      return 'en-GB';
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.type = '';
    this.quantity = 0;
    this.price = 0;
    this.confirmed = false;
    this.meta = {};
    this.belongsTo = -1;
    this.editableQuantity = true;
    this.discountedPrices = {};
    this.discountedPrice = null;

    return true;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'totalPrice',
    value: function totalPrice() {
      return this.quantity * this.price;
    }
  }], [{
    key: 'number',
    value: function number(no) {
      return parseInt(no || 0, 10);
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validStartDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validRangeDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var validStartDate = function validStartDate(context) {
  return function (startDate) {
    var validStartDates = context.validStartDates;

    var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
    var formatted = date.format('YYYY-MM-DD');
    if (validStartDates) {
      return validStartDates.indexOf(formatted) !== -1;
    }
    return false;
  };
};

var validEndDate = function validEndDate(context) {
  return function (endDate) {
    var validEndDates = context.validEndDates;

    var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
    var formatted = date.format('YYYY-MM-DD');
    if (validEndDates) {
      return validEndDates.indexOf(formatted) !== -1;
    }
    return false;
  };
};

var validRangeDate = function validRangeDate(context) {
  return function (value) {
    var startDate = context.startDate,
        days = context.days,
        validStartDates = context.validStartDates;

    var rangeStart = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).subtract(1, 'days');
    var rangeEnd = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).add(days, 'days');
    var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);

    var validFromStartDate = validStartDates.indexOf(date.format('YYYY-MM-DD')) > -1;

    if (date.isAfter(rangeStart) && date.isBefore(rangeEnd) && validFromStartDate) {
      return true;
    }
    return false;
  };
};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(896),
  /* scopeId */
  "data-v-0c88c1fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(714)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  "data-v-c63627b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  "data-v-f010d2ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    currentRealAccomodationIndex: function currentRealAccomodationIndex() {
      if (typeof this.$route.query.no === 'undefined') {
        return -1;
      }
      var no = parseInt(this.$route.query.no, 10);

      if (isNaN(no)) {
        return -1;
      }

      var max = this.$store.state.cart.accomodations.length;

      no = Math.min(no, max);
      no = Math.max(no, -1);

      return no;
    },
    accomodationIndex: function accomodationIndex() {
      return Math.max(this.currentRealAccomodationIndex, 0);
    }
  }
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(711)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  "data-v-b878891e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  "data-v-53ee9e52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(919),
  /* scopeId */
  "data-v-216b2fe4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_CartObject__ = __webpack_require__(32);







var AccomodationCartItem = function (_CartItem) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AccomodationCartItem, _CartItem);

  function AccomodationCartItem() {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AccomodationCartItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AccomodationCartItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AccomodationCartItem)).call(this));

    _this.type = 'ACCOMODATION';
    _this.poolLid = null;
    _this.unitLid = null;
    _this.period = null;
    _this.week = null;
    _this.site = null;
    _this.adults = 0;
    _this.seniors = 0;
    _this.youths = 0;
    _this.children = 0;
    _this.capacity = 0;
    _this.editableQuantity = false;

    return _ret = true, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AccomodationCartItem, null, [{
    key: 'peopleCount',
    value: function peopleCount(model) {
      return __WEBPACK_IMPORTED_MODULE_5__classes_CartObject__["a" /* default */].number(model.adults) + __WEBPACK_IMPORTED_MODULE_5__classes_CartObject__["a" /* default */].number(model.youths) + __WEBPACK_IMPORTED_MODULE_5__classes_CartObject__["a" /* default */].number(model.children) + __WEBPACK_IMPORTED_MODULE_5__classes_CartObject__["a" /* default */].number(model.seniors);
    }
  }]);

  return AccomodationCartItem;
}(__WEBPACK_IMPORTED_MODULE_5__classes_CartObject__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AccomodationCartItem);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    timelineSteps: function timelineSteps() {
      var step = 1;
      if (this.$route.name === 'accomodation list') {
        step = 1;
      } else if (this.$route.name === 'confirm-accomodation') {
        step = 2;
      } else if (this.$route.name === 'addons') {
        step = 3;
      } else if (this.$route.name === 'shopping cart') {
        step = 4;
      }

      var confirmedAccomodations = this.$store.state.cart.accomodations.filter(function (a) {
        return a.confirmed;
      }).length;

      var objects = [{
        title: 'Våra boenden',
        complete: step >= 1 ? step > 1 ? 2 : 1 : 0,
        url: { name: 'accomodation list' }
      }, {
        title: 'Boende',
        complete: step >= 2 ? step > 2 ? 2 : 1 : 0,
        url: { name: 'confirm-accomodation', query: { no: this.accomodationIndex } },
        clickable: confirmedAccomodations
      }, {
        title: 'Tillval',
        complete: step >= 3 ? step > 3 ? 2 : 1 : 0,
        url: { name: 'addons', query: { no: this.accomodationIndex } },
        clickable: confirmedAccomodations
      }, {
        title: 'Betalning',
        complete: step >= 4 ? step > 4 ? 2 : 1 : 0,
        url: { name: 'shopping cart' },
        clickable: confirmedAccomodations
      }];

      return objects;
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pickAccomodation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return refreshCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addAccomodationSkipasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return confirmAccomodation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return confirmSkipasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unconfirmSkipasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addSkipasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return accomodationPeriodPick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return refreshFavorites; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addFavorite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return removeFavorite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return clearCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setUserCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dontAwaitFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return awaitFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveCartLocking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_AccomodationCartItem__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_AddonCartItem__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_SkiPassAccomodationCartItem__ = __webpack_require__(318);






var pickAccomodation = function pickAccomodation($, value) {
  $.cart.accomodations = $.cart.accomodations.filter(function (a) {
    return a.confirmed;
  });

  if (typeof value.no === 'number' && !isNaN(value.no) && value.no > -1 && $.cart.accomodations[value.no]) {
    $.cart.accomodations[value.no].period = value.period;
    $.cart.accomodations[value.no].week = value.week;
    $.cart.accomodations[value.no].price = value.price;
    if (value.pool_lid) {
      $.cart.accomodations[value.no].poolLid = value.pool_lid;
    }
    if (value.unit_lid) {
      $.cart.accomodations[value.no].unitLid = value.unit_lid;
    }
    if (value.capacity) {
      $.cart.accomodations[value.no].capacity = value.capacity;
    }
    if (value.unit) {
      $.cart.accomodations[value.no].name = (value.unit.display_name || value.unit.description_title) + (value.unit.subtitle ? ' - ' + value.unit.subtitle : '');

      if (value.unit.pool) {
        $.cart.accomodations[value.no].pool_name = value.unit.pool.display_name || value.unit.pool.name;
      }
    }

    $.cart.accomodations[value.no].site = value.site;

    $.cart.accomodations[value.no].unit_code = value.unit_code;
    $.cart.accomodations[value.no].description_title = value.description_title;
  } else {
    var item = new __WEBPACK_IMPORTED_MODULE_1__classes_AccomodationCartItem__["a" /* default */]();
    item.poolLid = value.pool_lid;
    item.unitLid = value.unit_lid;
    item.period = value.period;
    item.week = value.week;
    if (value.unit) {
      item.name = (value.unit.display_name || value.unit.description_title) + (value.unit.subtitle ? ' - ' + value.unit.subtitle : '');

      if (value.unit.pool) {
        item.pool_name = value.unit.pool.display_name || value.unit.pool.name;
      }
    }
    item.capacity = value.capacity;
    item.quantity = 1;
    item.price = value.price;

    item.site = value.site;

    item.unit_code = value.unit_code;
    item.description_title = value.description_title;

    $.cart.accomodations.push(item);
  }

  $.cart.currentAccomodationIndex = $.cart.accomodations.length - 1;
};

var refreshCart = function refreshCart($) {
  var confirmedAccomodations = $.cart.accomodations.filter(function (obj) {
    return obj.confirmed;
  }).reduce(function (current, obj) {
    return parseInt(obj.quantity, 10) + current;
  }, 0);

  var confirmedSkipasses = $.cart.skipasses.filter(function (obj) {
    return obj.confirmed && obj.type !== 'SKIPASS-ACCO';
  }).reduce(function (current, obj) {
    return parseInt(obj.quantity, 10) + current;
  }, 0);

  var confirmedSkipasses2 = $.cart.skipasses.filter(function (obj) {
    return obj.confirmed && obj.type === 'SKIPASS-ACCO';
  }).reduce(function (current, obj) {
    return parseInt(obj.adults, 10) + parseInt(obj.children, 10) + parseInt(obj.youths, 10) + current;
  }, 0);

  var confirmedAddons = $.cart.addons.filter(function (obj) {
    return obj.confirmed;
  }).reduce(function (current, obj) {
    return parseInt(obj.quantity, 10) + current;
  }, 0);

  var confirmedRentals = $.cart.rentals.filter(function (obj) {
    return obj.confirmed;
  }).reduce(function (current, obj) {
    return parseInt(obj.quantity, 10) + current;
  }, 0);

  var confirmedSkischools = $.cart.skischools.filter(function (obj) {
    return obj.confirmed;
  }).reduce(function (current, obj) {
    return parseInt(obj.quantity, 10) + current;
  }, 0);

  var confirmedActivities = 0;
  if ($.cart.activities && $.cart.activities.length) {
    confirmedActivities = $.cart.activities.filter(function (obj) {
      return obj.confirmed;
    }).reduce(function (current, obj) {
      return parseInt(obj.quantity, 10) + current;
    }, 0);
  }

  var rentalConfig = window.SITE_CONFIG && window.SITE_CONFIG.rental;
  if (rentalConfig && rentalConfig.delivery_fee_active) {
    var feePoolLid = rentalConfig.delivery_fee_pool_lid;
    var feePrice = rentalConfig.delivery_fee_price;
    var feeName = rentalConfig.delivery_fee_name;

    var hasDeliveryRental = $.cart.rentals.some(function (r) {
      return r.confirmed && r.delivery;
    });

    var parentHasFee = false;
    if ($.cart.addToOrder && $.cart.addToOrder.lines) {
      parentHasFee = $.cart.addToOrder.lines.some(function (l) {
        return l.status !== 'C' && parseInt(l.poolId, 10) === parseInt(feePoolLid, 10);
      });
    }
    var confirmedAccomodation = $.cart.accomodations.find(function (a) {
      return a.confirmed;
    });
    if (confirmedAccomodation && confirmedAccomodation.parent_has_delivery_fee) {
      parentHasFee = true;
    }
    if ($.cart.parent_has_delivery_fee) {
      parentHasFee = true;
    }

    if (!$.cart.products) {
      $.cart.products = [];
    }

    var feeProductIndex = $.cart.products.findIndex(function (p) {
      return parseInt(p.poolId, 10) === parseInt(feePoolLid, 10);
    });

    if (hasDeliveryRental && !parentHasFee) {
      if (feeProductIndex === -1) {
        $.cart.products.push({
          type: 'PRODUCT',
          poolId: feePoolLid,
          name: feeName,
          price: feePrice,
          quantity: 1,
          confirmed: true
        });
      } else {
        $.cart.products[feeProductIndex].price = feePrice;
        $.cart.products[feeProductIndex].name = feeName;
        $.cart.products[feeProductIndex].quantity = 1;
        $.cart.products[feeProductIndex].confirmed = true;
      }
    } else if (feeProductIndex > -1) {
      $.cart.products.splice(feeProductIndex, 1);
    }
  }

  var sum = confirmedAccomodations + confirmedSkipasses + confirmedSkipasses2 + confirmedAddons + confirmedRentals + confirmedSkischools + confirmedActivities;

  $.cartSum = sum;

  if (sum) {
    if (document.querySelectorAll('.cart-counter')) {
      var divs = document.querySelectorAll('.cart-counter');
      for (var i = 0; i < divs.length; ++i) {
        divs[i].innerHTML = sum;
      }
    }
  } else if (document.querySelectorAll('.cart-counter')) {
    var _divs = document.querySelectorAll('.cart-counter');
    for (var _i = 0; _i < _divs.length; ++_i) {
      _divs[_i].innerHTML = '';
    }
  }
};

var addAccomodationSkipasses = function addAccomodationSkipasses($, value) {
  var skipass = new __WEBPACK_IMPORTED_MODULE_3__classes_SkiPassAccomodationCartItem__["a" /* default */]();

  skipass.adults = value.adults;
  skipass.youths = value.youths;
  skipass.children = value.children;
  skipass.seniors = value.seniors;
  skipass.days = value.days;

  skipass.belongsTo = value.belongsTo;

  $.cart.skipasses.push(skipass);

  refreshCart($);
};

var confirmAccomodation = function confirmAccomodation($, value) {
  var index = value.index;
  $.cart.accomodations[index].confirmed = true;
  $.cart.accomodations[index].adults = parseInt(value.adults, 10);
  $.cart.accomodations[index].youths = parseInt(value.youths, 10);
  $.cart.accomodations[index].children = parseInt(value.children, 10);
  $.cart.accomodations[index].seniors = parseInt(value.seniors, 10) || 0;

  var currentSkipassIndex = -1;
  $.cart.skipasses.forEach(function (skipass, localIndex) {
    if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === value.index) {
      currentSkipassIndex = localIndex;
    }
  });

  if (currentSkipassIndex === -1) {
    addAccomodationSkipasses($, {
      adults: $.cart.accomodations[index].adults,
      youths: $.cart.accomodations[index].youths,
      children: $.cart.accomodations[index].children,
      seniors: $.cart.accomodations[index].seniors || 0,
      days: value.days,
      belongsTo: index
    });
  }

  $.cart.currentSkipassIndex = $.cart.skipasses.length - 1;
  refreshCart($);
};

var confirmSkipasses = function confirmSkipasses($, value) {
  var index = value.index;
  $.cart.skipasses[index].confirmed = true;
  $.cart.skipasses[index].adultLid = value.adultLid;
  $.cart.skipasses[index].youthLid = value.youthLid;
  $.cart.skipasses[index].childLid = value.childLid;
  $.cart.skipasses[index].seniorLid = value.seniorLid;

  $.cart.deliveryTo = value.deliveryTo;

  $.cart.skipasses[index].hideadults = !parseInt($.cart.skipasses[index].adults, 10);
  $.cart.skipasses[index].hideyouths = !parseInt($.cart.skipasses[index].youths, 10);
  $.cart.skipasses[index].hidechildren = !parseInt($.cart.skipasses[index].children, 10);
  $.cart.skipasses[index].hideseniors = !parseInt($.cart.skipasses[index].seniors, 10);

  $.cart.skipasses[index].delivery_type = value.deliveryType;
  $.cart.skipasses[index].site = value.site;

  if (value.days) {
    $.cart.skipasses[index].days = parseInt(value.days, 10);
  }

  refreshCart($);
};

var unconfirmSkipasses = function unconfirmSkipasses($) {
  var index = $.cart.currentSkipassIndex;
  $.cart.skipasses[index].confirmed = false;
  refreshCart($);
};

var addAddon = function addAddon($, payload) {
  var addon = new __WEBPACK_IMPORTED_MODULE_2__classes_AddonCartItem__["a" /* default */]();
  addon.quantity = parseInt(payload.qtySelected, 10);
  addon.lid = payload.lid;
  addon.confirmed = true;
  addon.title = payload.arttext;
  addon.price = parseFloat(payload.aprice);
  addon.rut = payload.rut;
  addon.hide_for_guest = payload.hide_for_guest;

  addon.locked = payload.locked;

  if ($.cart.ssn && payload.rut) {
    addon.discount = {
      type: 'percentage',
      code: 'rut',
      amount: 50
    };
  } else {
    addon.discount = null;
  }

  addon.editableQuantity = payload.max_qty > 1;

  addon.belongsTo = payload.belongsTo;

  var index = $.cart.addons.findIndex(function (a) {
    return a.lid === addon.lid && a.belongsTo === addon.belongsTo;
  });

  if (index > -1) {
    $.cart.addons.splice(index, 1);
  }

  $.cart.addons.push(addon);

  $.cart.currentAddonIndex = $.cart.addons.length - 1;
  refreshCart($);
};

var removeAddon = function removeAddon($, payload) {
  var index = $.cart.addons.findIndex(function (addon) {
    return addon.lid === payload.lid && addon.belongsTo === payload.belongsTo;
  });

  if (index > -1) {
    $.cart.addons.splice(index, 1);
  }

  var rutAddons = $.cart.addons.filter(function (localAddon) {
    return localAddon.rut;
  });

  if (!rutAddons.length) {
    $.cart.ssn = null;
  }
  refreshCart($);
};

var addSkipasses = function addSkipasses($, payload) {
  var skipass = new __WEBPACK_IMPORTED_MODULE_3__classes_SkiPassAccomodationCartItem__["a" /* default */]();
  skipass.adults = 0;
  skipass.youths = 0;
  skipass.children = 0;
  skipass.seniors = 0;
  skipass.confirmed = true;

  skipass[payload.age] = parseInt(payload.number, 10);
  skipass.days = parseInt(payload.days, 10);

  $.cart.skipasses.push(skipass);

  $.cart.currentSkipassIndex = $.cart.skipasses.length - 1;
};

var accomodationPeriodPick = function accomodationPeriodPick($, value) {
  $.tempCartAccomodation = value;
};

var refreshFavorites = function refreshFavorites($) {
  if ($.favorites.length) {
    if (document.querySelectorAll('.favorite-conter')) {
      var divs = document.querySelectorAll('.favorite-counter');
      for (var i = 0; i < divs.length; ++i) {
        divs[i].innerHTML = $.favorites.length;
      }
    }
  } else if (document.querySelectorAll('.favorite-conter')) {
    var _divs2 = document.querySelectorAll('.favorite-counter');
    for (var _i2 = 0; _i2 < _divs2.length; ++_i2) {
      _divs2[_i2].innerHTML = '';
    }
  }
};

var addFavorite = function addFavorite($, value) {
  $.favorites.push(value);
  refreshFavorites($);
};

var removeFavorite = function removeFavorite($, value) {
  $.favorites.splice(value, 1);
  refreshFavorites($);
};

var makeid = function makeid() {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (var i = 0; i < 12; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

var clearCart = function clearCart($) {
  $.cart.accomodations = [];
  $.cart.addons = [];
  $.cart.skipasses = [];
  $.cart.rentals = [];
  $.cart.skischools = [];
  $.cart.products = [];
  $.cart.pincode = null;
  $.cart.campaignCode = null;
  $.cart.codeRequiresExtraInfo = null;
  $.cart.codeExtraInfo = '';
  $.cart.ssn = null;
  $.cart.addToOrder = {};
  $.cart.deliveryTo = {};
  $.cart.parent_has_delivery_fee = false;
  $.cart.receipt = null;

  $.cart.phone = null;
  $.cart.email = null;
  $.cart.name = null;
  $.cart.notes = null;

  $.cart.rentalDateRestriction = {};

  $.lockingActive = false;
  $.lockingBeforeTime = false;
  $.lockingCode = false;

  $.pincode = '';
  $.campaignCode = '';

  $.user_code = makeid();

  document.body.classList.remove('klarna-checkout-fso-open');
  refreshCart($);
};

var setUserCode = function setUserCode($, code) {
  $.user_code = code;
};

var setUser = function setUser($, user) {
  $.user.token = user.token;
};

var dontAwaitFilter = function dontAwaitFilter($) {
  $.isAwaitingFilter = false;
};

var awaitFilter = function awaitFilter($, payload) {
  var defaultOptions = {
    waitForUser: false,
    callback: null
  };

  var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultOptions, payload);

  if (options.waitForUser) {
    $.isAwaitingUserSince = new Date();

    setTimeout(function () {
      var now = new Date();
      var diff = now - $.isAwaitingUserSince;

      if (diff < 1000) {
        return;
      }

      $.isAwaitingFilter = true;
      setTimeout(function () {
        dontAwaitFilter($);

        if (options.callback && typeof options.callback === 'function') {
          options.callback();
        }
      }, 250);
    }, 1001);
  } else {
    $.isAwaitingFilter = true;
    setTimeout(function () {
      dontAwaitFilter($);
    }, 250);
  }
};

var saveCartLocking = function saveCartLocking($, payload) {
  if (payload.code && payload.code !== 'undefined') {
    $.lockingCode = payload.code;
    $.lockingActive = true;
  } else {
    $.lockingCode = null;
  }

  if (payload.beforeTime && payload.beforeTime !== 'undefined') {
    $.lockingBeforeTime = payload.beforeTime;
  } else {
    $.lockingBeforeTime = null;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(927),
  /* scopeId */
  "data-v-29593774",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(738)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  "data-v-f8d22e08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(733)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  "data-v-eac1490c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(740)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  "data-v-fc85d242",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(667)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  "data-v-5520a7e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_localstorage__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_methods_defaultAccomodationsFilter__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_methods_getters_accomodation__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_methods_getters_rental__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_methods_mutations_skipass__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_methods_getters_pass__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_methods_getters_log_in__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_methods_mutations_log_in__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_methods_mutations_skischool__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_methods_mutations_booking__ = __webpack_require__(329);




































__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* default */]);

var initialState = {
  accomodationsFilter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_fp__["cloneDeep"])(__WEBPACK_IMPORTED_MODULE_9__store_methods_defaultAccomodationsFilter__["a" /* default */]),
  skiSchoolFilter: {},
  tempCartAccomodation: {},
  showDatepicker: false,
  showFilters: false,
  showMap: false,
  showSearch: false,
  openModals: [],
  openTimeoutModals: [],
  currentRequests: 0,
  devSettings: {},
  favorites: [],
  user: {
    token: '',
    object: {}
  },
  cartSum: '',
  cart: {
    accomodations: [],
    currentAccomodationIndex: 0,
    skipasses: [],
    currentSkipassIndex: 0,
    addons: [],
    currentAddonIndex: 0,
    rentals: [],
    currentRentalIndex: 0,
    skischools: [],
    pincode: null,
    campaignCode: null,
    codeRequiresExtraInfo: false,
    codeExtraInfo: '',
    ssn: null,
    products: [],
    deliveryTo: {},
    addToOrder: {}
  },
  user_code: null,
  skiSchoolBooking: {},
  isOnSite: false,
  isDebugging: false,
  isOnWhichSite: false,
  isAwaitingFilter: false,
  onsite_key: '',
  resetPasswordSuccessMessage: '',
  phone: null,
  email: null,
  name: null,
  lastName: '',
  notes: null
};

function updateBodyModalAwareness(modal) {
  if (modal) {
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }
}

var mutations = {
  increaseCurrentRequests: function increaseCurrentRequests(state) {
    state.currentRequests += 1;
  },
  decreaseCurrentRequests: function decreaseCurrentRequests(state) {
    state.currentRequests -= 1;
  },
  currentRequests: function currentRequests(state) {
    return state.currentRequests;
  },

  changeFreeSearch: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["a" /* changeFreeSearch */],
  changeRooms: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["b" /* changeRooms */],
  changeBeds: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["c" /* changeBeds */],
  toggleDatepicker: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["d" /* toggleDatepicker */],
  toggleFilters: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["e" /* toggleFilters */],
  toggleMap: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["f" /* toggleMap */],
  toggleFilterSwitch: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["g" /* toggleFilterSwitch */],
  toggleSkiSchoolFilterSwitch: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["h" /* toggleSkiSchoolFilterSwitch */],
  toggleSkiSchoolFilterAgeSwitch: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["i" /* toggleSkiSchoolFilterAgeSwitch */],
  toggleSkiSchoolSubFilter: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["j" /* toggleSkiSchoolSubFilter */],
  resetAccomodationsFilter: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["k" /* resetAccomodationsFilter */],
  toggleSearch: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["l" /* toggleSearch */],
  setAccomodationsFilterStartDate: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["m" /* setAccomodationsFilterStartDate */],
  setAccomodationsFilterEndDate: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["n" /* setAccomodationsFilterEndDate */],
  setAccomodationsAvailableIds: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["o" /* setAccomodationsAvailableIds */],
  setFilterLocationId: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["p" /* setFilterLocationId */],
  awaitFilter: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["a" /* awaitFilter */],
  dontAwaitFilter: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["b" /* dontAwaitFilter */],
  resetSkiSchoolFilter: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["q" /* resetSkiSchoolFilter */],
  saveCartLocking: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["c" /* saveCartLocking */],
  changeSorting: __WEBPACK_IMPORTED_MODULE_10__store_methods_mutations_search__["r" /* changeSorting */],

  pickAccomodation: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["d" /* pickAccomodation */],
  confirmAccomodation: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["e" /* confirmAccomodation */],
  confirmSkipasses: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["f" /* confirmSkipasses */],
  unconfirmSkipasses: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["g" /* unconfirmSkipasses */],
  addAddon: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["h" /* addAddon */],
  removeAddon: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["i" /* removeAddon */],
  addAccomodationSkipasses: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["j" /* addAccomodationSkipasses */],
  addSkipasses: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["k" /* addSkipasses */],
  addFavorite: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["l" /* addFavorite */],
  removeFavorite: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["m" /* removeFavorite */],
  refreshFavorites: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["n" /* refreshFavorites */],
  refreshCart: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["o" /* refreshCart */],
  clearCart: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["p" /* clearCart */],
  setUser: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["q" /* setUser */],

  setUserCode: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["r" /* setUserCode */],

  setSkischoolFilter: __WEBPACK_IMPORTED_MODULE_19__store_methods_mutations_skischool__["a" /* setSkischoolFilter */],
  setSkischoolFilterAttribute: __WEBPACK_IMPORTED_MODULE_19__store_methods_mutations_skischool__["b" /* setSkischoolFilterAttribute */],

  accomodationPeriodPick: __WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["s" /* accomodationPeriodPick */],

  addRentalPeople: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["a" /* addRentalPeople */],
  updateRentalPerson: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["b" /* updateRentalPerson */],
  updateRentalPersonMeasurements: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["c" /* updateRentalPersonMeasurements */],
  updateRentalPersonSkier: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["d" /* updateRentalPersonSkier */],
  addProducts: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["e" /* addProducts */],
  confirmRental: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["f" /* confirmRental */],
  completeGuides: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["g" /* completeGuides */],
  addRentalAddon: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["h" /* addRentalAddon */],
  removeRentalAddon: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["i" /* removeRentalAddon */],
  setOnSite: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["j" /* setOnSite */],
  setOffSite: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["k" /* setOffSite */],
  setGuideCompleted: __WEBPACK_IMPORTED_MODULE_13__store_methods_mutations_rental__["l" /* setGuideCompleted */],

  addSkiPassPeople: __WEBPACK_IMPORTED_MODULE_15__store_methods_mutations_skipass__["a" /* addSkiPassPeople */],
  updateSkiPassPerson: __WEBPACK_IMPORTED_MODULE_15__store_methods_mutations_skipass__["b" /* updateSkiPassPerson */],
  confirmSkiPass: __WEBPACK_IMPORTED_MODULE_15__store_methods_mutations_skipass__["c" /* confirmSkiPass */],
  completeSkipassGuides: __WEBPACK_IMPORTED_MODULE_15__store_methods_mutations_skipass__["d" /* completeSkipassGuides */],
  addProduct: __WEBPACK_IMPORTED_MODULE_15__store_methods_mutations_skipass__["e" /* addProduct */],

  addSkiSchoolToCart: __WEBPACK_IMPORTED_MODULE_19__store_methods_mutations_skischool__["c" /* addSkiSchoolToCart */],
  addActivitityToCart: __WEBPACK_IMPORTED_MODULE_19__store_methods_mutations_skischool__["d" /* addActivitityToCart */],
  consolidateSkiSchoolInCart: __WEBPACK_IMPORTED_MODULE_19__store_methods_mutations_skischool__["e" /* consolidateSkiSchoolInCart */],

  updateUserDetails: __WEBPACK_IMPORTED_MODULE_20__store_methods_mutations_booking__["a" /* updateUserDetails */],

  removeCartItem: function removeCartItem(state, payload) {
    state.cart[payload.type].splice(payload.index, 1);
    state.cart.currentSkipassIndex = state.cart.skipasses.length - 1;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_methods_mutations_accomodation__["o" /* refreshCart */])(state);
  },
  openModal: function openModal(state, _ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        component = _ref2[0],
        params = _ref2[1];

    var newModal = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, params, {
      component: component
    });

    if (state.openModals.length) {
      var last = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state.openModals[state.openModals.length - 1]);
      var theNew = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(newModal);
      if (last === theNew) {
        updateBodyModalAwareness(state.openModals.length);
        return true;
      }
    }

    state.openModals = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.openModals), [newModal]);
    updateBodyModalAwareness(state.openModals.length);
    return true;
  },
  openTimeoutModal: function openTimeoutModal(state, _ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        component = _ref4[0],
        params = _ref4[1];

    var newModal = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, params, {
      component: component
    });
    if (!state.openTimeoutModals.length) {
      state.openTimeoutModals = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.openTimeoutModals), [newModal]);
      updateBodyModalAwareness(state.openTimeoutModals.length);
    }
  },
  closeModal: function closeModal(state) {
    state.openModals = state.openModals.slice(0, -1);
    updateBodyModalAwareness(state.openModals.length);
  },
  closeTimeoutModal: function closeTimeoutModal(state) {
    state.openTimeoutModals = state.openTimeoutModals.slice(0, -1);
    updateBodyModalAwareness(state.openModals.length);
  },
  closeAllModals: function closeAllModals(state) {
    state.openModals = [];
    updateBodyModalAwareness();
  },
  saveDevSettings: function saveDevSettings(state, payload) {
    state.devSettings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.devSettings, payload);
  },

  updatePincode: __WEBPACK_IMPORTED_MODULE_20__store_methods_mutations_booking__["b" /* updatePincode */],
  updateCampaignCode: __WEBPACK_IMPORTED_MODULE_20__store_methods_mutations_booking__["c" /* updateCampaignCode */],
  updateCampaignCodeExtraInfo: __WEBPACK_IMPORTED_MODULE_20__store_methods_mutations_booking__["d" /* updateCampaignCodeExtraInfo */],
  updateResetPasswordSuccessMessage: __WEBPACK_IMPORTED_MODULE_18__store_methods_mutations_log_in__["a" /* updateResetPasswordSuccessMessage */]
};

var actions = {};

var getters = {
  bedsCount: function bedsCount(state) {
    return state.accomodationsFilter.beds;
  },
  getFreeSearch: function getFreeSearch(state) {
    return state.accomodationsFilter.freeSearch;
  },
  roomsCount: function roomsCount(state) {
    return state.accomodationsFilter.bedrooms;
  },
  datepickerToggle: function datepickerToggle(state) {
    return state.showDatepicker;
  },
  filtersToggle: function filtersToggle(state) {
    return state.showFilters;
  },
  searchToggle: function searchToggle(state) {
    return state.showSearch;
  },
  mapToggle: function mapToggle(state) {
    return state.showMap;
  },
  cart: function cart(state) {
    return state.cart;
  },
  currentModal: function currentModal(state) {
    return state.openModals[state.openModals.length - 1];
  },
  currentTimeoutModal: function currentTimeoutModal(state) {
    return state.openTimeoutModals[0];
  },
  confirmedAccomodations: __WEBPACK_IMPORTED_MODULE_12__store_methods_getters_accomodation__["a" /* confirmedAccomodations */],
  favoriteAccommodations: __WEBPACK_IMPORTED_MODULE_12__store_methods_getters_accomodation__["b" /* favoriteAccommodations */],
  loggedIn: __WEBPACK_IMPORTED_MODULE_12__store_methods_getters_accomodation__["c" /* loggedIn */],
  isAwaitingFilter: __WEBPACK_IMPORTED_MODULE_12__store_methods_getters_accomodation__["d" /* isAwaitingFilter */],
  accomodationsFilterEndDate: __WEBPACK_IMPORTED_MODULE_12__store_methods_getters_accomodation__["e" /* accomodationsFilterEndDate */],
  accomodationsFilter: __WEBPACK_IMPORTED_MODULE_12__store_methods_getters_accomodation__["f" /* accomodationsFilter */],
  confirmedRentals: __WEBPACK_IMPORTED_MODULE_14__store_methods_getters_rental__["a" /* confirmedRentals */],
  guidedRentals: __WEBPACK_IMPORTED_MODULE_14__store_methods_getters_rental__["b" /* guidedRentals */],
  confirmedPasses: __WEBPACK_IMPORTED_MODULE_16__store_methods_getters_pass__["a" /* confirmedPasses */],
  guidedPasses: __WEBPACK_IMPORTED_MODULE_16__store_methods_getters_pass__["b" /* guidedPasses */],
  devSettings: function devSettings(state) {
    return state.devSettings;
  },
  resetPasswordSuccessMessage: __WEBPACK_IMPORTED_MODULE_17__store_methods_getters_log_in__["a" /* resetPasswordSuccessMessage */]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* default */].Store({
  plugins: [__WEBPACK_IMPORTED_MODULE_7_vuex_localstorage___default()({
    namespace: 'branas-booking',
    initialState: {},

    expires: 7 * 24 * 60 * 60 * 1e3
  })],
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    orderTypeSingle: function orderTypeSingle() {
      if (this.loading) {
        return '';
      }
      console.log(this.order);
      if (this.order.details.rows) {
        var rows = this.order.details.rows;

        if (rows.accomodation && rows.accomodation.length) {
          return 'accomodation';
        }
        if (rows.rental && rows.rental.length) {
          return 'rental';
        }
        if (rows.skipass && rows.skipass.length) {
          return 'skipass';
        }
        if (rows.skischool && rows.skischool.length) {
          return 'skischool';
        }
        if (rows.addon && rows.addon.length) {
          return 'addon';
        }
      }

      return 'other';
    },
    orderTypes: function orderTypes() {
      var types = [];

      if (this.loading) {
        return types;
      }

      if (this.order.details.rows) {
        var rows = this.order.details.rows;

        if (rows.accomodation && rows.accomodation.length) {
          types.push('accomodation');
        }
        if (rows.rental && rows.rental.length) {
          types.push('rental');
        }
        if (rows.skipass && rows.skipass.length) {
          types.push('skipass');
        }
        if (rows.skischool && rows.skischool.length) {
          types.push('skischool');
        }
        if (rows.addon && rows.addon.length) {
          types.push('addon');
        }
        if (rows.other && rows.other.length) {
          types.push('other');
        }
      } else {
        types.push('other');
      }

      return types;
    },
    orderTypeVisual: function orderTypeVisual() {
      if (this.loading) {
        return '';
      }

      var map = {
        accomodation: 'Boende',
        rental: 'Skidhyra',
        skipass: 'Liftkort',
        skischool: 'Skidskola',
        addon: 'Tillval',
        skischule: 'Skidskola',
        other: 'Bokning'
      };

      var oTypes = this.orderTypes;

      return oTypes.map(function (type) {
        return map[type];
      }).join(' + ');
    }
  },
  methods: {
    extradetails: function extradetails(type) {
      var _this = this;

      if (this.loading) {
        return [];
      }

      var list = (this.order.details.rows[type] || []).slice();

      list = list.map(function (row) {
        var skiername = (row.skiername || '').toLowerCase().trim();
        var details = _this.skierAttributes(row);
        var arrival = row.arrival;
        var departure = row.departure;

        if (type === 'skischool') {
          skiername = (row.people_as_string || '').toLowerCase().trim();
          details = '-';
        }

        var sorter = skiername + '-' + details + '-' + arrival + '-' + departure;
        var group1 = '' + skiername;
        var group2 = details + '-' + arrival + '-' + departure;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, row, {
          sorter: sorter,
          group1: group1,
          group2: group2
        });
      });

      var sorted = list.sort(function (a, b) {
        var aSort = a.sorter;
        var bSort = b.sorter;

        if (aSort < bSort) {
          return -1;
        }
        if (aSort > bSort) {
          return 1;
        }
        return 0;
      });

      var grouped = {};

      sorted.forEach(function (row) {
        var group1 = row.group1;
        var group2 = row.group2;

        if (typeof grouped[group1] === 'undefined') {
          grouped[group1] = {};
        }

        if (typeof grouped[group1][group2] === 'undefined') {
          grouped[group1][group2] = [];
        }

        grouped[group1][group2].push(row);
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(grouped);
    },
    concatenatedList: function concatenatedList(list) {
      var s = list.filter(function (row) {
        return row.value;
      }).map(function (row, index) {
        return ((index > 0 ? row.title.toLowerCase() : row.title) + ' ' + row.value + ' ' + row.suffix).trim();
      }).join(', ');

      if (!s) {
        return '';
      }

      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    skierAttributes: function skierAttributes(detail) {
      if (detail && detail.productname && detail.productname.toLowerCase().indexOf('utkörning') !== -1) {
        return '';
      }
      return this.concatenatedList([{
        title: 'Längd',
        value: detail.skierheight,
        suffix: 'cm'
      }, {
        title: 'Vikt',
        value: detail.skierweight,
        suffix: 'kg'
      }, {
        title: 'Skostorlek',
        value: detail.skiershoe,
        suffix: ''
      }]);
    },
    schoolerAttributes: function schoolerAttributes(detail) {
      return this.concatenatedList([{
        title: 'Start:',
        value: detail.start_time,
        suffix: ''
      }, {
        title: 'Plats:',
        value: detail.location,
        suffix: ''
      }]);
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    timelineSteps: function timelineSteps() {
      var _this = this;

      var steps = [];
      var $this = this;

      var rentals = this.$store.state.cart.rentals.length;

      var confirmedRentals = this.$store.state.cart.rentals.filter(function (a) {
        return a.guideCompleted;
      }).length;

      this.$store.state.cart.rentals.forEach(function (person, index) {
        var no = index + 1;
        var skiier = _this.$i18n.t('general.skier');
        var p = {
          title: person.name || skiier + ' ' + no,
          complete: 0,
          url: { name: 'ski rental person', params: { person: index } },
          clickable: person.guideCompleted
        };

        if (person.guideFullyCompleted) {
          p.complete = 2;
        }

        if (parseInt($this.$route.params.person, 10) === index) {
          p.complete = 1;
        }

        if ($this.currentIndex === index && person.products.length) {
          p.complete = 1;
        }

        steps.push(p);
      });

      if (steps.length > 6) {
        steps = [{
          title: this.$i18n.t('general.cta.book'),
          complete: 2,
          url: { name: 'ski rental overview' },
          clickable: confirmedRentals
        }];

        if (parseInt($this.$route.params.person, 10) >= 0) {
          steps[0].complete = 1;
          confirmedRentals = -1;
        }
      }

      steps.push({
        title: this.$i18n.t('general.overview'),
        complete: confirmedRentals === rentals ? 1 : 0,
        url: { name: 'ski rental overview' },
        clickable: confirmedRentals
      });

      return steps;
    }
  }
});

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(689)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  "data-v-75a11a10",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(944),
  /* scopeId */
  "data-v-38e3eb5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)
__webpack_require__(598)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(915),
  /* scopeId */
  "data-v-1eefcb94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(968),
  /* scopeId */
  "data-v-47f77a83",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(698)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(959),
  /* scopeId */
  "data-v-423a9206",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(702)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  "data-v-9fbfdca4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_StartPage__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_StartPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Pages_StartPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pages_Accomodation_AccomodationsPage__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pages_Accomodation_AccomodationsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Pages_Accomodation_AccomodationsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_Accomodation_AccomodationsConfirm__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pages_Accomodation_AccomodationsConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Pages_Accomodation_AccomodationsConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_Accomodation_AccomodationsCompare__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Pages_Accomodation_AccomodationsCompare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Pages_Accomodation_AccomodationsCompare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_Accomodation_AddonsPage__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pages_Accomodation_AddonsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Pages_Accomodation_AddonsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Admin_Accomodation__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Admin_Accomodation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Admin_Accomodation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_SkiRental_SkiRentalOnSitePage__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pages_SkiRental_SkiRentalOnSitePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Pages_SkiRental_SkiRentalOnSitePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_SkiRental_SkiRentalPage__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pages_SkiRental_SkiRentalPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Pages_SkiRental_SkiRentalPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Pages_SkiRental_SkiRentalUser__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Pages_SkiRental_SkiRentalUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Pages_SkiRental_SkiRentalUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pages_SkiRental_SkiRentalUserProducts__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Pages_SkiRental_SkiRentalUserProducts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Pages_SkiRental_SkiRentalUserProducts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Pages_SkiRental_SkiRentalUserOverview__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Pages_SkiRental_SkiRentalUserOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Pages_SkiRental_SkiRentalUserOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Pages_SkiRental_SkiRentalConfirm__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Pages_SkiRental_SkiRentalConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Pages_SkiRental_SkiRentalConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Pages_SkiPass_SkiPassPage__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Pages_SkiPass_SkiPassPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Pages_SkiPass_SkiPassPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Pages_SkiPass_SkiPassOnSitePage__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Pages_SkiPass_SkiPassOnSitePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Pages_SkiPass_SkiPassOnSitePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Pages_SkiPass_SkiPassUser__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Pages_SkiPass_SkiPassUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Pages_SkiPass_SkiPassUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Pages_SkiPass_SkiPassUserOverview__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Pages_SkiPass_SkiPassUserOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Pages_SkiPass_SkiPassUserOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Pages_SkiPass_SkiPassConfirm__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Pages_SkiPass_SkiPassConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Pages_SkiPass_SkiPassConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Pages_SkiSchool_SkiSchoolPage__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Pages_SkiSchool_SkiSchoolPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Pages_SkiSchool_SkiSchoolPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Pages_SkiSchool_SkiSchoolOverview__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Pages_SkiSchool_SkiSchoolOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Pages_SkiSchool_SkiSchoolOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Pages_ActivitiesPage__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Pages_ActivitiesPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Pages_ActivitiesPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Pages_OnSitePage__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Pages_OnSitePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Pages_OnSitePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Pages_MyPages_MyPage__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Pages_MyPages_MyPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Pages_MyPages_MyPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Pages_MyPages_LoginPage__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Pages_MyPages_LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Pages_MyPages_LoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Pages_MyPages_AdminPage__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Pages_MyPages_AdminPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Pages_MyPages_AdminPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Pages_RequestResetPassword__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Pages_RequestResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Pages_RequestResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Pages_ResetPassword__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Pages_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Pages_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Pages_MyPages_MyPageJourney__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Pages_MyPages_MyPageJourney___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Pages_MyPages_MyPageJourney__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Pages_MyPages_MyPageBookings__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Pages_MyPages_MyPageBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Pages_MyPages_MyPageBookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Pages_MyPages_MyBooking__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Pages_MyPages_MyBooking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Pages_MyPages_MyBooking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Pages_MyPages_MyBookingV2__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Pages_MyPages_MyBookingV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Pages_MyPages_MyBookingV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Pages_MyPages_MyPageDetails__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Pages_MyPages_MyPageDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Pages_MyPages_MyPageDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Pages_MyPages_MyPagePassword__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Pages_MyPages_MyPagePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Pages_MyPages_MyPagePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Pages_MyPages_MyPageLogout__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Pages_MyPages_MyPageLogout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Pages_MyPages_MyPageLogout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Pages_ShoppingCartPage__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Pages_ShoppingCartPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Pages_ShoppingCartPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Pages_CheckoutPage__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Pages_CheckoutPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Pages_CheckoutPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Admin_Settings__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Admin_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Admin_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Admin_CommandSyncer__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Admin_CommandSyncer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Admin_CommandSyncer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Admin_EmailReport__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Admin_EmailReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Admin_EmailReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Admin_GdprCleanup__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Admin_GdprCleanup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_Admin_GdprCleanup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Admin_Texts__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Admin_Texts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_Admin_Texts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Admin_OrderList__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Admin_OrderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_Admin_OrderList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Admin_OrderSingle__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Admin_OrderSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_Admin_OrderSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Admin_Translation__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Admin_Translation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_Admin_Translation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Admin_Notifications__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Admin_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_Admin_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Pages_PaymentPage__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Pages_PaymentPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_Pages_PaymentPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Pages_PaymentServiceCheckoutConfirmationPage__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Pages_PaymentServiceCheckoutConfirmationPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_Pages_PaymentServiceCheckoutConfirmationPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Pages_PayedWithCodeConfirmationPage__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Pages_PayedWithCodeConfirmationPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_Pages_PayedWithCodeConfirmationPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Pages_PayedExternally__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Pages_PayedExternally___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_Pages_PayedExternally__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__store__ = __webpack_require__(79);







































































__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.path.match(/\/boenden/) && from.path.match(/\/boenden/)) {
      return null;
    }
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/dela/:category/:parameters',
    name: 'share',
    redirect: function redirect(to) {
      var category = to.params.category;
      var parms = to.params.parameters;
      if (category === 'j') {
        return '/jamfor-boenden?boenden=' + parms;
      }
      return '/';
    }
  }, {
    path: '/',
    name: 'start',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Pages_StartPage___default.a
  }, {
    path: '/boenden',
    name: 'accomodation list',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Pages_Accomodation_AccomodationsPage___default.a,
    children: [{
      path: 'info/:poolId/:unitId',
      name: 'accomodation info',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true
      }
    }, {
      path: 'info/:slug',
      name: 'accomodation info on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true
      }
    }, {
      path: 'info/:poolId/:unitId/:arrival/:departure',
      name: 'accomodation info with price',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true
      }
    }, {
      path: 'info/:slug/:arrival/:departure',
      name: 'accomodation info with price on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true
      }
    }, {
      path: 'pris/:poolId/:unitId',
      name: 'accomodation price',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice___default.a,
      meta: {
        isModal: true
      }
    }, {
      path: 'pris/:slug',
      name: 'accomodation price on slug',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice___default.a,
      meta: {
        isModal: true
      }
    }]
  }, {
    path: '/jamfor-boenden',
    name: 'compare-accomodations',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Pages_Accomodation_AccomodationsCompare___default.a,
    meta: {
      forceTop: true
    },
    children: [{
      path: 'info/:poolId/:unitId',
      name: 'compare-accomodations accomodation info',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation info'
      }
    }, {
      path: 'info/:slug',
      name: 'compare-accomodations accomodation info on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation info on slug'
      }
    }, {
      path: 'pris/:poolId/:unitId',
      name: 'compare-accomodations accomodation price',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation price'
      }
    }, {
      path: 'pris/:slug',
      name: 'compare-accomodations accomodation price on slug',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation price on slug'
      }
    }]
  }, {
    path: '/boenden/bekrafta',
    name: 'confirm-accomodation',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Pages_Accomodation_AccomodationsConfirm___default.a,
    meta: {
      forceTop: true
    },
    children: [{
      path: 'info/:slug',
      name: 'confirm-accomodation accomodation info',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation info'
      }
    }, {
      path: 'info/:slug',
      name: 'confirm-accomodation accomodation info on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation info on slug'
      }
    }, {
      path: 'info/:slug/:arrival/:departure',
      name: 'confirm-accomodation accomodation info with price',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation info with price'
      }
    }, {
      path: 'info/:slug/:arrival/:departure',
      name: 'confirm-accomodation accomodation info with price on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation with price on slug'
      }
    }, {
      path: 'pris/:slug',
      name: 'confirm-accomodation accomodation price',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation price'
      }
    }, {
      path: 'pris/:slug',
      name: 'confirm-accomodation accomodation price on slug',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Pages_Accomodation_AccomodationsPagePrice___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation price on slug'
      }
    }]
  }, {
    path: '/boenden/tillval',
    name: 'addons',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Pages_Accomodation_AddonsPage___default.a
  }, {
    path: '/boenden/tillval-tillagg',
    name: 'addons extra',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Pages_Accomodation_AddonsPage___default.a
  }, {
    path: '/boenden/bilder',
    name: 'accomodation image list',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Pages_Accomodation_AccomodationsPage___default.a,
    meta: {
      view: 'images'
    },
    children: [{
      path: 'info/:slug',
      name: 'accomodations accomodation images info on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation info on slug',
        view: 'images'
      }
    }, {
      path: 'info/:slug/:arrival/:departure',
      name: 'confirm-accomodation accomodation info image with price on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true,
        cssPage: 'accomodation with price on slug',
        view: 'images'
      }
    }]
  }, {
    path: '/pa-plats',
    name: 'on site',
    component: __WEBPACK_IMPORTED_MODULE_26__components_Pages_OnSitePage___default.a
  }, {
    path: '/skidhyra-pa-plats',
    name: 'ski rental on site',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Pages_SkiRental_SkiRentalOnSitePage___default.a
  }, {
    path: '/skidhyra',
    name: 'ski rental',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Pages_SkiRental_SkiRentalPage___default.a
  }, {
    path: '/skidhyra/oversikt',
    name: 'ski rental overview',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Pages_SkiRental_SkiRentalUserOverview___default.a
  }, {
    path: '/skidhyra/bekrafta',
    name: 'ski rental confirm',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Pages_SkiRental_SkiRentalConfirm___default.a
  }, {
    path: '/skidhyra/:person',
    name: 'ski rental person',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Pages_SkiRental_SkiRentalUser___default.a
  }, {
    path: '/skidhyra/:person/produkter',
    name: 'ski rental person search',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Pages_SkiRental_SkiRentalUserProducts___default.a
  }, {
    path: '/liftkort',
    name: 'ski pass',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Pages_SkiPass_SkiPassPage___default.a
  }, {
    path: '/liftkort-pa-plats',
    name: 'ski pass on site',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Pages_SkiPass_SkiPassOnSitePage___default.a
  }, {
    path: '/liftkort/oversikt',
    name: 'ski pass overview',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Pages_SkiPass_SkiPassUserOverview___default.a
  }, {
    path: '/liftkort/bekrafta',
    name: 'ski pass confirm',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Pages_SkiPass_SkiPassConfirm___default.a
  }, {
    path: '/liftkort/:person',
    name: 'ski pass person',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Pages_SkiPass_SkiPassUser___default.a
  }, {
    path: '/skidskola',
    name: 'ski school',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Pages_SkiSchool_SkiSchoolPage___default.a
  }, {
    path: '/cykelskola',
    name: 'bike school',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Pages_SkiSchool_SkiSchoolPage___default.a
  }, {
    path: '/skidskola-pa-plats',
    name: 'ski school overview on site',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Pages_SkiSchool_SkiSchoolOverview___default.a
  }, {
    path: '/skidskola/oversikt',
    name: 'ski school overview',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Pages_SkiSchool_SkiSchoolOverview___default.a
  }, {
    path: '/cykelskola/oversikt',
    name: 'bike school overview',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Pages_SkiSchool_SkiSchoolOverview___default.a
  }, {
    path: '/aktiviteter',
    name: 'activities',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Pages_ActivitiesPage___default.a
  }, {
    path: '/aktiviteter/boka/:pool',
    name: 'activities book',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Pages_ActivitiesPage___default.a
  }, {
    path: '/konto/aterstall-losenord',
    name: 'request reset password',
    component: __WEBPACK_IMPORTED_MODULE_30__components_Pages_RequestResetPassword___default.a
  }, {
    path: '/konto/skapa-losenord',
    name: 'request new password',
    component: __WEBPACK_IMPORTED_MODULE_30__components_Pages_RequestResetPassword___default.a
  }, {
    path: '/konto/nytt-losenord/:token',
    name: 'reset password',
    component: __WEBPACK_IMPORTED_MODULE_31__components_Pages_ResetPassword___default.a
  }, {
    path: '/konto/skapa-losenord/:token',
    name: 'create password',
    component: __WEBPACK_IMPORTED_MODULE_31__components_Pages_ResetPassword___default.a
  }, {
    path: '/logga-in',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_28__components_Pages_MyPages_LoginPage___default.a
  }, {
    path: '/admin',
    name: 'admin',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Pages_MyPages_AdminPage___default.a,
    redirect: function redirect() {
      return '/admin/settings';
    },
    meta: {
      requiresAdmin: true
    },
    children: [{
      path: 'translations',
      name: 'admin-translations',
      component: __WEBPACK_IMPORTED_MODULE_48__components_Admin_Translation___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'accomodations',
      name: 'admin-accomodations',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Admin_Accomodation___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'settings',
      name: 'admin-settings',
      component: __WEBPACK_IMPORTED_MODULE_41__components_Admin_Settings___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'command-sync',
      name: 'admin-command-sync',
      component: __WEBPACK_IMPORTED_MODULE_42__components_Admin_CommandSyncer___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'email-report',
      name: 'admin-email-report',
      component: __WEBPACK_IMPORTED_MODULE_43__components_Admin_EmailReport___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'gdpr-cleanup',
      name: 'admin-gdpr-cleanup',
      component: __WEBPACK_IMPORTED_MODULE_44__components_Admin_GdprCleanup___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'texts',
      name: 'admin-texts',
      component: __WEBPACK_IMPORTED_MODULE_45__components_Admin_Texts___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'notifications',
      name: 'admin-notifications',
      component: __WEBPACK_IMPORTED_MODULE_49__components_Admin_Notifications___default.a,
      meta: {
        requiresAdmin: true
      }
    }, {
      path: 'stats/orders',
      name: 'admin-stats-orders',
      component: __WEBPACK_IMPORTED_MODULE_46__components_Admin_OrderList___default.a,
      meta: {
        requiresAdmin: true
      },
      children: [{
        path: ':orderId',
        name: 'admin-stats-orders-detail',
        component: __WEBPACK_IMPORTED_MODULE_47__components_Admin_OrderSingle___default.a,
        meta: {
          requiresAdmin: true
        }
      }]
    }]
  }, {
    path: '/mina-sidor/resa/:bookingNumber',
    name: 'my journey booking',
    component: __WEBPACK_IMPORTED_MODULE_35__components_Pages_MyPages_MyBookingV2___default.a,
    meta: {
      page: 'journey'
    },
    children: [{
      path: 'boende/:slug',
      name: 'my journey accomodation info on slug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Pages_Accomodation_AccomodationsPageInfo___default.a,
      meta: {
        isModal: true
      }
    }, {
      path: 'detaljer',
      name: 'my journey detailed',
      component: __WEBPACK_IMPORTED_MODULE_34__components_Pages_MyPages_MyBooking___default.a,
      meta: {
        page: 'bookings',
        isModal: true
      }
    }]
  }, {
    path: '/mina-sidor',
    name: 'my pages',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Pages_MyPages_MyPage___default.a,
    redirect: function redirect() {
      return '/mina-sidor/resa';
    },
    children: [{
      path: 'resa',
      name: 'my pages journey',
      component: __WEBPACK_IMPORTED_MODULE_32__components_Pages_MyPages_MyPageJourney___default.a,
      meta: {
        page: 'journey',
        isSub: true
      }
    }, {
      path: 'uppgifter',
      name: 'my pages details',
      component: __WEBPACK_IMPORTED_MODULE_36__components_Pages_MyPages_MyPageDetails___default.a,
      meta: {
        page: 'details',
        isSub: true
      }
    }, {
      path: 'bokningar',
      name: 'my pages bookings',
      component: __WEBPACK_IMPORTED_MODULE_33__components_Pages_MyPages_MyPageBookings___default.a,
      meta: {
        page: 'bookings'
      },
      children: [{
        path: ':bookingNumber',
        name: 'my booking detailed',
        component: __WEBPACK_IMPORTED_MODULE_34__components_Pages_MyPages_MyBooking___default.a,
        meta: {
          page: 'bookings',
          isSub: true,
          isModal: true
        }
      }]
    }, {
      path: 'losenord',
      name: 'my pages password',
      component: __WEBPACK_IMPORTED_MODULE_37__components_Pages_MyPages_MyPagePassword___default.a,
      meta: {
        page: 'password',
        isSub: true
      }
    }, {
      path: 'logga-ut',
      name: 'my pages logout',
      component: __WEBPACK_IMPORTED_MODULE_38__components_Pages_MyPages_MyPageLogout___default.a,
      meta: {
        page: 'logout',
        isSub: true
      }
    }]
  }, {
    path: '/varukorg',
    name: 'shopping cart',
    component: __WEBPACK_IMPORTED_MODULE_39__components_Pages_ShoppingCartPage___default.a
  }, {
    path: '/kassa',
    name: 'checkout',
    component: __WEBPACK_IMPORTED_MODULE_40__components_Pages_CheckoutPage___default.a
  }, {
    path: '/betala/bekraftelse',
    name: 'payment confirmation',
    component: __WEBPACK_IMPORTED_MODULE_51__components_Pages_PaymentServiceCheckoutConfirmationPage___default.a
  }, {
    path: '/betalat/bekraftalse',
    name: 'payed externally',
    component: __WEBPACK_IMPORTED_MODULE_53__components_Pages_PayedExternally___default.a
  }, {
    path: '/betala/bekraftelse-kod',
    name: 'payedwithcode',
    component: __WEBPACK_IMPORTED_MODULE_52__components_Pages_PayedWithCodeConfirmationPage___default.a
  }, {
    path: '/betala',
    name: 'payment',
    component: __WEBPACK_IMPORTED_MODULE_50__components_Pages_PaymentPage___default.a
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta && to.meta.requiresAdmin) {
    if (!__WEBPACK_IMPORTED_MODULE_54__store__["a" /* default */].state.user.isAdmin && !localStorage.getItem('admin_user')) {
      return next('/logga-in?admin=1');
    }
  }

  var regex1 = new RegExp('^/skidhyra-pa-plats|/skidhyra/|/skidskola-pa-plats|/pa-plats|/liftkort-pa-plats|/pa-plats|/liftkort/');
  var url = '/pa-plats?site=' + __WEBPACK_IMPORTED_MODULE_54__store__["a" /* default */].state.isOnWhichSite;
  if (__WEBPACK_IMPORTED_MODULE_54__store__["a" /* default */].state.isOnSite && !to.fullPath.match(regex1)) {
    return next(url);
  }
  if (to.name === 'ski rental' && from.name === 'ski rental person') {
    var stage = from.matched[0].instances.default.stage;
    if (stage <= 13 || window.screenSize() > window.screenMobile) {
      if (confirm(window.SITE_CONFIG.translations.general['cancel-booking-question-text'])) {
        __WEBPACK_IMPORTED_MODULE_54__store__["a" /* default */].state.cart.rentals = [];
        return next();
      }
      return next(false);
    }
    if (stage === 16) {
      from.matched[0].instances.default.stage = 13;
    } else if (stage === 20) {
      from.matched[0].instances.default.stage = 16;
    } else if (stage === 30) {
      from.matched[0].instances.default.stage = 20;
    } else if (stage === 40) {
      from.matched[0].instances.default.stage = 30;
    }
    return next(false);
  }

  return next();
});

router.afterEach(function (to, from) {
  var path = to.path;
  var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, to.query);
  delete query.flow;
  delete query.no;
  delete query.d;
  delete query.c;

  var host = window.location.host;

  var url = 'https://' + host + '/bokning' + path;

  query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (key) {
    return key + '=' + query[key];
  }).join('&');

  if (query.length > 1) {
    url = url + '?' + query;
  }

  console.log(url);

  if (to.query.debug) {
    __WEBPACK_IMPORTED_MODULE_54__store__["a" /* default */].state.isDebugging = true;
  }

  document.body.classList.remove('modal-opened');

  if (window.jQuery) {
    window.jQuery('nav.main-nav').removeClass('active');
    window.jQuery('body').removeClass('is-navigating');
  }

  if (to.meta.isModal) {
    document.body.classList.add('modal-opened');
  }

  if (!to.meta.forceTop) {
    if (from.meta.isModal || from.meta.isSub) {
      return;
    }
    if (to.meta.isModal || to.meta.isSub) {
      return;
    }
  }
  var myDiv = document.getElementById('app');
  if (myDiv) {
    myDiv.scrollTop = 0;
  }
  document.body.scrollTop = 0;
  scroll(0, 0);

  __WEBPACK_IMPORTED_MODULE_54__store__["a" /* default */].commit('closeAllModals');
  __WEBPACK_IMPORTED_MODULE_54__store__["a" /* default */].commit('closeTimeoutModal');
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(898),
  /* scopeId */
  "data-v-0d464bfa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createValidMeasurements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);


var createValidMeasurements = function createValidMeasurements(config, $t) {
  var lengthOptions = [];
  var weightOptions = [];
  var shoeSizeOptions = [];
  var clothSizeOptions = [];
  var clothOptionGroups = {};

  var i = config.cmMin;
  var max = config.cmMax;
  var interval = config.cmInterval || 5;
  var cmlang = $t('skirental.measurements.centimeter-short');
  while (i <= max) {
    var title = i + ' ' + cmlang;
    var subtitle = '';
    if (i === config.cmMin) {
      subtitle = $t('skirental.rules.or-shorter', { measurement: '' });
    } else if (i === config.cmMax) {
      subtitle = $t('skirental.rules.or-longer', { measurement: '' });
    }
    lengthOptions.push({
      title: title,
      subtitle: subtitle,
      value: i
    });
    i += interval;
  }

  i = config.kgMin;
  max = config.kgMax;
  interval = config.kgInterval || 5;
  var kg = $t('skirental.measurements.kilogram-short');
  while (i <= max) {
    var _title = i + ' ' + kg;
    var _subtitle = '';
    if (i === config.kgMin) {
      _subtitle = $t('skirental.rules.or-less', { measurement: '' });
    } else if (i === config.kgMax) {
      _subtitle = $t('skirental.rules.or-more', { measurement: '' });
    }
    weightOptions.push({
      title: _title,
      subtitle: _subtitle,
      value: i
    });
    i += interval;
  }

  i = Math.max(24, config.shoeMin);
  max = Math.min(52, config.shoeMax);
  interval = config.shoeInterval || 1;

  var table = {
    24: ['24', '15.0'],
    25: ['25', '15.5'],
    26: ['26', '16.5'],
    27: ['27', '17.0'],
    28: ['28', '17.5'],
    29: ['29', '18.5'],
    30: ['30', '19.5'],
    31: ['31', '20.5'],
    32: ['32', '21.5'],
    33: ['33', '22.0'],
    34: ['34', '22.5'],
    35: ['35', '23.0'],
    36: ['36', '23.5'],
    37: ['37', '24.0'],
    38: ['38', '24.5'],
    39: ['39', '25.0'],
    40: ['40', '26.0'],
    41: ['41', '26.5'],
    42: ['42', '27.5'],
    43: ['43', '28.0'],
    44: ['44', '28.5'],
    45: ['45', '29.5'],
    46: ['46', '30.5'],
    47: ['47', '31.0'],
    48: ['48', '32.0'],
    49: ['49', '33.0']
  };

  while (i <= max) {
    var size = table[i];
    var _subtitle2 = size[1].toLocaleString('arab', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });
    var cm = $t('skirental.measurements.centimeter-short');
    shoeSizeOptions.push({
      title: size[0],
      subtitle: _subtitle2 + ' ' + cm,
      value: i
    });
    i += interval;
  }

  clothOptionGroups.adult = [{ title: 'XS', value: 'XS', subtitle: '' }, { title: 'S', value: 'S', subtitle: '' }, { title: 'M', value: 'M', subtitle: '' }, { title: 'L', value: 'L', subtitle: '' }, { title: 'XL', value: 'XL', subtitle: '' }, { title: 'XXL', value: 'XXL', subtitle: '' }, { title: 'XXXL', value: 'XXXL', subtitle: '' }, { title: 'XXXXL', value: 'XXXXL', subtitle: '' }, { title: 'XXXXXL', value: 'XXXXXL', subtitle: '' }];

  clothOptionGroups.child_youth = [{ title: '122-128', value: '122-128', subtitle: '' }, { title: '134-140', value: '134-140', subtitle: '' }, { title: '146-152', value: '146-152', subtitle: '' }, { title: '158-164', value: '158-164', subtitle: '' }];

  if (config.clothGroup && clothOptionGroups[config.clothGroup]) {
    clothSizeOptions = clothOptionGroups[config.clothGroup];
  } else {
    clothSizeOptions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(clothOptionGroups.adult), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(clothOptionGroups.child_youth));
  }

  return {
    lengthOptions: lengthOptions,
    weightOptions: weightOptions,
    shoeSizeOptions: shoeSizeOptions,
    clothSizeOptions: clothSizeOptions
  };
};

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getAccommodationDateRange: function getAccommodationDateRange() {
      var accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.cart.accomodations));
      var confirmed = accomodations.filter(function (accomodation) {
        return accomodation.confirmed;
      });

      var start = null;
      var end = null;

      if (!confirmed.length) {
        if (!this.$store.state.cart.addToOrder || !this.$store.state.cart.addToOrder.dateStart) {
          return false;
        }

        start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.state.cart.addToOrder.dateStart);
        end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.state.cart.addToOrder.dateEnd);
      } else {
        start = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.min(confirmed.map(function (accomodation) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(accomodation.period.date_arrival);
        }));
        end = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.max(confirmed.map(function (accomodation) {
          return __WEBPACK_IMPORTED_MODULE_1_moment___default()(accomodation.period.date_departure);
        }));
      }

      return { start: start, end: end };
    },
    getAccommodationDateRangeAsDates: function getAccommodationDateRangeAsDates() {
      var range = this.getAccommodationDateRange();

      if (!range) {
        return false;
      }

      var loopStart = __WEBPACK_IMPORTED_MODULE_1_moment___default()(range.start).toDate();
      var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(range.end).toDate();

      var current = loopStart;

      var newArray = [];

      while (current <= end) {
        current = __WEBPACK_IMPORTED_MODULE_1_moment___default()(current);
        if (this.SITE_CONFIG.season.winter.closed.indexOf(current.format('YYYY-MM-DD')) === -1) {
          newArray.push(current.format('YYYY-MM-DD'));
        }
        current = current.add(1, 'days').toDate();
      }

      return newArray;
    },
    getDatesWithAccommodationRestrictions: function getDatesWithAccommodationRestrictions($dates) {
      var range = this.getAccommodationDateRange();
      var newDates = $dates;

      if (range !== false) {
        var allowedDates = this.getAccommodationDateRangeAsDates();
        newDates = newDates.filter(function (date) {
          var m = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD');
          return allowedDates.find(function (allowedDate) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(allowedDate).isSame(m, 'day');
          });
        });
      }

      return newDates;
    },
    areDatesWithinAccommodationRange: function areDatesWithinAccommodationRange($start, $end) {
      var range = this.getAccommodationDateRange();

      if (!range) {
        return true;
      }

      var start = range.start,
          end = range.end;


      if (!$start || !$end) {
        return false;
      }

      var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()($start);
      var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()($end);

      if (startDate.isBefore(start, 'day')) {
        return -1;
      }

      if (startDate.isAfter(end, 'day')) {
        return -2;
      }

      if (endDate.isAfter(end, 'day')) {
        return -3;
      }

      return true;
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      availableWishes: []
    };
  },

  methods: {
    getWishes: function getWishes() {
      var w = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.availableWishes));

      if (w.length > 0) {
        w.push({
          key: 'none',
          label: 'Inga särskilda önskemål'
        });
      }

      return w;
    },
    getWishesAsList: function getWishesAsList(wishes) {
      if (!wishes) {
        return [];
      }

      var availableWishes = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.availableWishes));
      availableWishes.push({
        key: 'none',
        label: 'Inga särskilda önskemål'
      });

      var wishKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(wishes).filter(function (key) {
        return wishes[key] === true;
      });
      var wishLabels = availableWishes.filter(function (wish) {
        return wishKeys.indexOf(wish.key) !== -1;
      }).map(function (wish) {
        return wish.label;
      });

      if (wishes.freeText && wishes.freeText.trim() !== '') {
        wishLabels.push(wishes.freeText);
      }

      return wishLabels;
    },
    getWishesAsListForSave: function getWishesAsListForSave(wishes) {
      if (!wishes) {
        return '';
      }

      var availableWishes = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.availableWishes));
      availableWishes.push({
        key: 'none',
        label: 'Inga särskilda önskemål'
      });

      var wishKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(wishes).filter(function (key) {
        return wishes[key] === true;
      });
      var wishLabels = availableWishes.filter(function (wish) {
        return wishKeys.indexOf(wish.key) !== -1;
      }).map(function (wish) {
        return wish.label;
      });

      if (wishes.freeText && wishes.freeText.trim() !== '') {
        wishLabels.push(wishes.freeText);
      }

      for (var i = 0; i < wishLabels.length; i++) {
        wishLabels[i] = wishLabels[i].replace(/\.$/, '').trim();
      }

      return wishLabels.join('. ');
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    timelineSteps: function timelineSteps() {
      var _this = this;

      var steps = [];
      var $this = this;

      var skipasses = this.$store.state.cart.skipasses.filter(function (a) {
        return a.type !== 'SKIPASS-ACCO';
      }).length;

      var confirmedSkipasses = this.$store.state.cart.skipasses.filter(function (a) {
        return a.guideCompleted && a.type === '';
      }).length;

      this.$store.state.cart.skipasses.filter(function (a) {
        return a.type !== 'SKIPASS-ACCO';
      }).forEach(function (person, index) {
        var no = index + 1;
        var skiier = _this.$i18n.t('general.skier');
        var p = {
          title: person.name || skiier + ' ' + no,
          complete: 0,
          url: { name: 'ski pass person', params: { person: index }, query: $this.$route.query },
          clickable: person.guideCompleted
        };

        if (person.guideCompleted) {
          p.complete = 2;
        }

        if (parseInt($this.$route.params.person, 10) === index) {
          p.complete = 1;
        }

        if ($this.currentIndex === index) {
          p.complete = 1;
        }

        steps.push(p);
      });

      steps.push({
        title: this.$i18n.t('general.cta.confirm'),
        complete: confirmedSkipasses === skipasses ? 1 : 0,
        url: { name: 'ski pass overview', query: $this.$route.query },
        clickable: confirmedSkipasses
      });

      return steps;
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultAccomodationsFilter = {
  freeSearch: '',
  beds: 1,
  bedrooms: 1,
  chargeStation: false,
  cleaning: false,
  date: {
    startDate: null,
    endDate: null
  },
  dishwasher: false,
  fireplace: false,
  dryer_cabinet: false,
  washing_machine: false,
  pets: false,
  sauna: false,
  direct_incheck: false,
  internet: false,
  poolId: 0,
  locationId: 0,
  availabelIds: [],
  sorting: '',
  child_friendly: false
};

/* harmony default export */ __webpack_exports__["a"] = (defaultAccomodationsFilter);

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(960),
  /* scopeId */
  "data-v-426f8f14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(950),
  /* scopeId */
  "data-v-3dd00418",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(691)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  "data-v-7d4ce944",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(597)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(914),
  /* scopeId */
  "data-v-1e958f98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  "data-v-e46a5426",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(942),
  /* scopeId */
  "data-v-35d18c86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(672)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  "data-v-5cfaf89e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(735)
__webpack_require__(736)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  "data-v-f1a2ead2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(890),
  /* scopeId */
  "data-v-07865c16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(700)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  "data-v-9ea1162c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(924),
  /* scopeId */
  "data-v-26572a70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(939),
  /* scopeId */
  "data-v-32500baf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export theFunction */
var host = window.location.host;

var match = host.match(/(branas|kungsberget|vallasen|ulricehamn|uc|tolvmannabacken|storstenshojden|brf-bgb)/);

if (match && match[0] === 'uc') {
  match[0] = 'ulricehamn';
}

if (match && match[0] === 'brf-bgb') {
  match[0] = 'branas';
}

if (match) {
  window.SITE_BRANDING = match[0];
}

if (!window.SITE_BRANDING) {
  console.error('No matching site!');
}

var theFunction = function theFunction() {};

/* harmony default export */ __webpack_exports__["a"] = (theFunction);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export theFunction */
var theFunction = function theFunction() {
  var map = {
    'bokning17.branas.advanttest.se': ['', '', ''],
    'berget.chip.branas.se': ['', '', ''],
    'dalen.chip.branas.se': ['', '', ''],
    'byn.chip.branas.se': ['', '', ''],
    'branas.se': ['UA-5893735-5', '1179337702109576', 'G-JL1S2GRQCM'],
    'www.branas.se': ['UA-5893735-5', '1179337702109576', 'G-JL1S2GRQCM'],

    'bokning17.kungsberget.advanttest.se': ['', '', ''],
    'webchip.kungsberget.se': ['', '', ''],
    'kungsberget.se': ['UA-5893735-6', '1508535329161278', 'G-0GLC602TE0'],
    'www.kungsberget.se': ['UA-5893735-6', '1508535329161278', 'G-0GLC602TE0'],

    'bokning17.vallasen.advanttest.se': ['', '', ''],
    'chip.vallasen.se': ['', '', ''],
    'vallasen.advanttest.se': ['', '', ''],
    'test.vallasen.se': ['', '', ''],
    'www.vallasen.se': ['', '', ''],
    'vallasen.se': ['', '', ''],

    'bokning17.ulricehamn.advanttest.se': ['', '', ''],

    'localhost:8080': ['UA-117770016-1', '181347042533425', 'G-HITTAPA']
  };

  var host = window.location.host;

  var analytics = map[host];

  if (!analytics) {
    console.log('Inget GA-id');
    analytics = ['', '', ''];
  }

  window.GA_ID = analytics[0] || '';
  window.GA4_ID = analytics[2] || '';
  window.FBP_ID = analytics[1] || '';
};

theFunction();

/* harmony default export */ __webpack_exports__["a"] = (theFunction);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export theFunction */
var map = {
  'hyra.branas.se': 'https://booking-api-branas.branasgruppen.se',

  'www.branas.se': 'https://booking-api-branas.branasgruppen.se',
  'branas.se': 'https://booking-api-branas.branasgruppen.se',

  'bokning17.branas.testversion.se': 'http://api.bokning17.branas.testversion.se',
  'branas.testversion.se': 'http://api.bokning17.branas.testversion.se',
  'www-dev.branas.se': 'http://api.bokning17.branas.testversion.se',
  'hyra.kungsberget.se': 'https://booking-api-kungsberget.branasgruppen.se',

  'www.kungsberget.se': 'https://booking-api-kungsberget.branasgruppen.se',
  'kungsberget.se': 'https://booking-api-kungsberget.branasgruppen.se',

  'bokning17.kungsberget.testversion.se': 'http://api.bokning17.kungsberget.testversion.se',
  'kungsberget.testversion.se': 'http://api.bokning17.kungsberget.testversion.se',
  'www-dev.kungsberget.se': 'http://api.bokning17.kungsberget.testversion.se',
  'localhost:3000': 'https://branas-booking-backend.ddev.site',
  'localhost:7080': 'https://branas-booking-backend.ddev.site',
  'branas-webb-branas.ddev.site': 'https://branas-booking-backend.ddev.site',
  'branas-webb-kungsberget.ddev.site': 'https://branas-booking-backend.ddev.site' };

var host = window.location.host;

if (!window.API_URL) {
  if (localStorage.getItem('branas/api_url')) {
    window.API_URL = localStorage.getItem('branas/api_url');
  } else {
    window.API_URL = map[host];
  }
}

if (!window.API_URL) {
  console.error('No matching API URL!');
}

var theFunction = function theFunction() {};

/* harmony default export */ __webpack_exports__["a"] = (theFunction);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export theFunction */
function getBrowser() {
  var ua = navigator.userAgent;
  var tem = void 0;
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: tem[1] || '' };
  }

  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: 'Opera', version: tem[1] };
    }
  }

  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

  tem = ua.match(/version\/(\d+)/i);
  if (tem !== null) {
    M.splice(1, 1, tem[1]);
  }

  if (M[0] === 'MSIE') {
    M[0] = 'IE';
  }

  return {
    name: M[0],
    version: M[1]
  };
}

var theFunction = function theFunction() {
  var browser = getBrowser().name.toLowerCase();
  var version = getBrowser().version;
  var class1 = ' browser-' + browser;
  var class2 = ' browser-version-' + version;
  document.body.className += class1;
  document.body.className += class2;
};

/* harmony default export */ __webpack_exports__["a"] = (theFunction);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export theFunction */
var theFunction = function theFunction() {
  window._trackEcommerce = function (event, data) {
    if (typeof window.dataLayer === 'undefined') {
      return;
    }

    dataLayer.push({ "event": event, ecommerce: data });
  };

  window.trackAddToCart = function (line) {
    var gtagItems = [];

    var sum = 0;

    (line.lines || []).forEach(function (product) {
      console.log('Adding item ' + product.id);

      gtagItems.push({
        item_id: product.id,
        item_name: product.title,
        item_category: product.category,
        item_category2: product.category2 || '',
        price: product.price,
        quantity: product.quantity
      });

      sum = sum + product.price * product.quantity;
    });

    window._trackEcommerce('add_to_cart', {
      value: sum,
      currency: "SEK",
      items: gtagItems
    });
  };

  window.trackViewItem = function (line) {
    var gtagItems = [];

    var sum = 0;

    (line.lines || []).forEach(function (product) {
      console.log('Viewing item ' + product.id);

      gtagItems.push({
        item_id: product.id,
        item_name: product.title,
        item_category: product.category,
        item_category2: product.category2 || '',
        price: product.price,
        quantity: product.quantity
      });

      sum = sum + product.price * product.quantity;
    });

    window._trackEcommerce('view_item', {
      value: sum,
      currency: "SEK",
      items: gtagItems
    });
  };

  window.trackViewCart = function (lines, currency, sum) {
    var gtagItems = [];

    (lines || []).forEach(function (item) {
      console.log('Adding item ' + item.sku);

      gtagItems.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.type,
        item_category2: item.category2 || '',
        price: item.price,
        quantity: item.quantity
      });
    });

    window._trackEcommerce('view_cart', {
      value: sum,
      currency: currency,
      items: gtagItems
    });
  };

  window.BEGIN_CHECKOUT_TRACKED = false;

  window.trackBeginCheckout = function (data, orderId, sum) {
    if (window.BEGIN_CHECKOUT_TRACKED) {
      console.log('skipping tracking due to already tracked');
      return;
    }

    window.BEGIN_CHECKOUT_TRACKED = true;

    var gtagItems = [];

    (data || []).forEach(function (item) {
      console.log('Adding item ' + item.sku);

      gtagItems.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.type,
        item_category2: item.category2 || '',
        price: item.price,
        quantity: item.quantity
      });
    });

    window._trackEcommerce('begin_checkout', {
      transaction_id: orderId,
      value: sum,
      currency: "SEK",
      items: gtagItems
    });
  };

  window.trackPurchase = function (data, orderId, sum, customer) {
    var gtagItems = [];

    (data || []).forEach(function (item) {
      console.log('Adding item ' + item.sku);

      gtagItems.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.type,
        item_category2: item.category2 || '',
        price: item.price,
        quantity: item.quantity
      });
    });

    window._trackEcommerce('purchase', {
      transaction_id: orderId,
      value: sum,
      currency: "SEK",
      items: gtagItems,
      sha256_email_address: customer.email || '',
      sha256_phone_number: customer.mobilePhoneNumber || '',
      address: {
        sha256_first_name: customer.billingAddress && customer.billingAddress.firstName ? customer.billingAddress.firstName : '',
        sha256_last_name: customer.billingAddress && customer.billingAddress.lastName ? customer.billingAddress.lastName : '',
        street: customer.billingAddress && customer.billingAddress.address ? customer.billingAddress.address : '',
        city: customer.billingAddress && customer.billingAddress.city ? customer.billingAddress.city : '',
        postal_code: customer.billingAddress && customer.billingAddress.postalCode ? customer.billingAddress.postalCode : '',
        country: customer.billingAddress && customer.billingAddress.country ? customer.billingAddress.country : ''
      }
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (theFunction);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export theFunction */
__webpack_require__(323);

var theFunction = function theFunction() {};

/* harmony default export */ __webpack_exports__["a"] = (theFunction);

/***/ }),
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(607)
__webpack_require__(608)
__webpack_require__(609)
__webpack_require__(610)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(922),
  /* scopeId */
  "data-v-25441132",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_CartObject__ = __webpack_require__(32);






var AddonCartItem = function (_CartItem) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AddonCartItem, _CartItem);

  function AddonCartItem() {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AddonCartItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AddonCartItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AddonCartItem)).call(this));

    _this.type = 'ADDON';
    _this.lid = null;
    _this.title = null;

    return _ret = true, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  return AddonCartItem;
}(__WEBPACK_IMPORTED_MODULE_4__classes_CartObject__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AddonCartItem);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_CartObject__ = __webpack_require__(32);






var ProductCartItem = function (_CartItem) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ProductCartItem, _CartItem);

  function ProductCartItem() {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ProductCartItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProductCartItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ProductCartItem)).call(this));

    _this.type = 'PRODUCT';
    _this.name = '';
    _this.poolId = '';

    return _ret = true, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  return ProductCartItem;
}(__WEBPACK_IMPORTED_MODULE_4__classes_CartObject__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ProductCartItem);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_CartObject__ = __webpack_require__(32);






var SkiPassAccomodationCartItem = function (_CartItem) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SkiPassAccomodationCartItem, _CartItem);

  function SkiPassAccomodationCartItem() {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkiPassAccomodationCartItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkiPassAccomodationCartItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkiPassAccomodationCartItem)).call(this));

    _this.type = 'SKIPASS-ACCO';
    _this.adults = 0;
    _this.youths = 0;
    _this.children = 0;
    _this.seniors = 0;
    _this.adultsPrice = 0;
    _this.youthsPrice = 0;
    _this.childrenPrice = 0;
    _this.seniorsPrice = 0;
    _this.days = 0;
    _this.editing = false;

    return _ret = true, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  return SkiPassAccomodationCartItem;
}(__WEBPACK_IMPORTED_MODULE_4__classes_CartObject__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SkiPassAccomodationCartItem);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_CartObject__ = __webpack_require__(32);






var SkiPassCartItem = function (_CartItem) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SkiPassCartItem, _CartItem);

  function SkiPassCartItem() {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkiPassCartItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkiPassCartItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkiPassCartItem)).call(this));

    _this.type = 'SKIPASS';
    _this.guideCompleted = false;
    _this.name = '';
    _this.age = 0;
    _this.category = '';
    _this.subCategory = '';
    _this.type = '';
    _this.searchPackage = '';
    _this.days = 0;
    _this.startDate = null;
    _this.cardNumber = null;
    _this.refill = false;
    _this.deliveryType = '';
    _this.site = '';
    _this.poolLid = 0;
    _this.editableQuantity = false;

    return _ret = true, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  return SkiPassCartItem;
}(__WEBPACK_IMPORTED_MODULE_4__classes_CartObject__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SkiPassCartItem);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_CartObject__ = __webpack_require__(32);






var SkiRentalCartItem = function (_CartItem) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SkiRentalCartItem, _CartItem);

  function SkiRentalCartItem() {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkiRentalCartItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkiRentalCartItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkiRentalCartItem)).call(this));

    _this.type = 'SKIRENTAL';
    _this.guideCompleted = false;
    _this.name = '';
    _this.age = 0;
    _this.category = '';
    _this.subCategory = '';
    _this.type = '';
    _this.searchPackage = '';
    _this.days = 0;
    _this.startDate = null;
    _this.priceType = 'day';
    _this.products = [];
    _this.addons = [];
    _this.lengthCm = null;
    _this.weight = null;
    _this.shoeSize = null;
    _this.jacketsize = null;
    _this.pantsize = null;
    _this.possibleAddons = [];
    _this.delivery = false;
    _this.site = null;
    _this.insurance = null;
    _this.editing = false;
    _this.editableQuantity = false;
    _this.wishes = {
      wideCalf: false,
      wideFoot: false,
      softShoes: false,
      hardShoes: false,
      shortTurn: false,
      longTurn: false,
      startSki: false,
      startSnowboard: false,
      preferedFootLeft: false,
      preferedFootRight: false,
      freeText: ''
    };

    return _ret = true, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  return SkiRentalCartItem;
}(__WEBPACK_IMPORTED_MODULE_4__classes_CartObject__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SkiRentalCartItem);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_CartObject__ = __webpack_require__(32);






var SkiSchoolCartItem = function (_CartItem) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SkiSchoolCartItem, _CartItem);

  function SkiSchoolCartItem() {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkiSchoolCartItem);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkiSchoolCartItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkiSchoolCartItem)).call(this));

    _this.type = 'SKISCHOOL';
    _this.name = '';
    _this.pool_lid = '';
    _this.activity_lid = '';
    _this.people = [];
    _this.site = null;
    _this.date = null;
    _this.time = null;
    _this.days = 0;
    _this.guardian = '';
    _this.phone = '';

    return _ret = true, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  return SkiSchoolCartItem;
}(__WEBPACK_IMPORTED_MODULE_4__classes_CartObject__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SkiSchoolCartItem);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deprecated_UnitInfoModal__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deprecated_UnitInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__deprecated_UnitInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deprecated_UnitPriceModal__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deprecated_UnitPriceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__deprecated_UnitPriceModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartHighFiveModal__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CartHighFiveModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CartHighFiveModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartHighFiveAccomodationModal__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartHighFiveAccomodationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CartHighFiveAccomodationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccomodationCompareShare__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccomodationCompareShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AccomodationCompareShare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CheckoutLoginModal__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CheckoutLoginModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CheckoutLoginModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DatepickerRangeModal__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DatepickerRangeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DatepickerRangeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GeneralModal__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GeneralModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__GeneralModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SkiRentalPickDate__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SkiRentalPickDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SkiRentalPickDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SkiPassPickDate__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SkiPassPickDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SkiPassPickDate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SkiPassPickDateKeycard__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SkiPassPickDateKeycard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SkiPassPickDateKeycard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TimeoutModal__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TimeoutModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__TimeoutModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SkiPassRefill__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SkiPassRefill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SkiPassRefill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SkiRentalCategories__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SkiRentalCategories___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SkiRentalCategories__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SkiRentalWishes__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SkiRentalWishes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__SkiRentalWishes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SkiSchoolWishes__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SkiSchoolWishes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__SkiSchoolWishes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SkiRentalFoot__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SkiRentalFoot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__SkiRentalFoot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddonInfoModal__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddonInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__AddonInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SkipassInfo__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SkipassInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__SkipassInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MapModalkungsberget__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MapModalkungsberget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__MapModalkungsberget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MapModalbranas__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MapModalbranas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__MapModalbranas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MovieModal__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MovieModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__MovieModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AccomodationSkipass__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AccomodationSkipass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__AccomodationSkipass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SkiSchoolLocationMap__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SkiSchoolLocationMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__SkiSchoolLocationMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SkiSchoolFaq__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SkiSchoolFaq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__SkiSchoolFaq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SkiSchoolInfo__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SkiSchoolInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__SkiSchoolInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SkiSchoolBooking__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SkiSchoolBooking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__SkiSchoolBooking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SkiSchoolPicker__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SkiSchoolPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__SkiSchoolPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SkiRentalConfirm__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SkiRentalConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__SkiRentalConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SummerConfirmationModal__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SummerConfirmationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__SummerConfirmationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__OnSitePayment__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__OnSitePayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__OnSitePayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__RutModal__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__RutModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__RutModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__IncludedInPriceModal__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__IncludedInPriceModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__IncludedInPriceModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__SkipassPrices__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__SkipassPrices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__SkipassPrices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__CreatingOrder__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__CreatingOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__CreatingOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__SecondAccomodationModal__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__SecondAccomodationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__SecondAccomodationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SkiPassConfirm__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SkiPassConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__SkiPassConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__BookingCancelled__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__BookingCancelled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__BookingCancelled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ReclaimReservationsModal__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ReclaimReservationsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__ReclaimReservationsModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__AdminSyncFields__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__AdminSyncFields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__AdminSyncFields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__QrModal__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__QrModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__QrModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__SlideshowModal__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__SlideshowModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__SlideshowModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__AdminMultiSelectModal__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__AdminMultiSelectModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__AdminMultiSelectModal__);












































/* harmony default export */ __webpack_exports__["a"] = ({
  UnitInfoModal: __WEBPACK_IMPORTED_MODULE_0__deprecated_UnitInfoModal___default.a,
  UnitPriceModal: __WEBPACK_IMPORTED_MODULE_1__deprecated_UnitPriceModal___default.a,
  CartHighFiveModal: __WEBPACK_IMPORTED_MODULE_2__CartHighFiveModal___default.a,
  CartHighFiveAccomodationModal: __WEBPACK_IMPORTED_MODULE_3__CartHighFiveAccomodationModal___default.a,
  AccomodationCompareShare: __WEBPACK_IMPORTED_MODULE_4__AccomodationCompareShare___default.a,
  CheckoutLoginModal: __WEBPACK_IMPORTED_MODULE_5__CheckoutLoginModal___default.a,
  DatepickerRangeModal: __WEBPACK_IMPORTED_MODULE_6__DatepickerRangeModal___default.a,
  GeneralModal: __WEBPACK_IMPORTED_MODULE_7__GeneralModal___default.a,
  SkiRentalPickDate: __WEBPACK_IMPORTED_MODULE_8__SkiRentalPickDate___default.a,
  SkiPassRefill: __WEBPACK_IMPORTED_MODULE_12__SkiPassRefill___default.a,
  SkiPassPickDate: __WEBPACK_IMPORTED_MODULE_9__SkiPassPickDate___default.a,
  SkiPassPickDateKeycard: __WEBPACK_IMPORTED_MODULE_10__SkiPassPickDateKeycard___default.a,
  TimeoutModal: __WEBPACK_IMPORTED_MODULE_11__TimeoutModal___default.a,
  SkiRentalWishes: __WEBPACK_IMPORTED_MODULE_14__SkiRentalWishes___default.a,
  SkiSchoolWishes: __WEBPACK_IMPORTED_MODULE_15__SkiSchoolWishes___default.a,
  SkiRentalFoot: __WEBPACK_IMPORTED_MODULE_16__SkiRentalFoot___default.a,
  SkiRentalCategories: __WEBPACK_IMPORTED_MODULE_13__SkiRentalCategories___default.a,
  AddonInfoModal: __WEBPACK_IMPORTED_MODULE_17__AddonInfoModal___default.a,
  SkipassInfo: __WEBPACK_IMPORTED_MODULE_18__SkipassInfo___default.a,
  MapModalbranas: __WEBPACK_IMPORTED_MODULE_20__MapModalbranas___default.a,
  MapModalkungsberget: __WEBPACK_IMPORTED_MODULE_19__MapModalkungsberget___default.a,
  MovieModal: __WEBPACK_IMPORTED_MODULE_21__MovieModal___default.a,
  AccomodationSkipass: __WEBPACK_IMPORTED_MODULE_22__AccomodationSkipass___default.a,
  SkiSchoolLocationMap: __WEBPACK_IMPORTED_MODULE_23__SkiSchoolLocationMap___default.a,
  SkiSchoolFaq: __WEBPACK_IMPORTED_MODULE_24__SkiSchoolFaq___default.a,
  SkiSchoolInfo: __WEBPACK_IMPORTED_MODULE_25__SkiSchoolInfo___default.a,
  SkiSchoolBooking: __WEBPACK_IMPORTED_MODULE_26__SkiSchoolBooking___default.a,
  SkiSchoolPicker: __WEBPACK_IMPORTED_MODULE_27__SkiSchoolPicker___default.a,
  SkiRentalConfirm: __WEBPACK_IMPORTED_MODULE_28__SkiRentalConfirm___default.a,
  OnSitePayment: __WEBPACK_IMPORTED_MODULE_30__OnSitePayment___default.a,
  RutModal: __WEBPACK_IMPORTED_MODULE_31__RutModal___default.a,
  IncludedInPriceModal: __WEBPACK_IMPORTED_MODULE_32__IncludedInPriceModal___default.a,
  SkipassPrices: __WEBPACK_IMPORTED_MODULE_33__SkipassPrices___default.a,
  CreatingOrder: __WEBPACK_IMPORTED_MODULE_34__CreatingOrder___default.a,
  SecondAccomodationModal: __WEBPACK_IMPORTED_MODULE_35__SecondAccomodationModal___default.a,
  SkiPassConfirm: __WEBPACK_IMPORTED_MODULE_36__SkiPassConfirm___default.a,
  BookingCancelled: __WEBPACK_IMPORTED_MODULE_37__BookingCancelled___default.a,
  ReclaimReservationsModal: __WEBPACK_IMPORTED_MODULE_38__ReclaimReservationsModal___default.a,
  AdminSyncFields: __WEBPACK_IMPORTED_MODULE_39__AdminSyncFields___default.a,
  SummerConfirmationModal: __WEBPACK_IMPORTED_MODULE_29__SummerConfirmationModal___default.a,
  QrModal: __WEBPACK_IMPORTED_MODULE_40__QrModal___default.a,
  SlideshowModal: __WEBPACK_IMPORTED_MODULE_41__SlideshowModal___default.a,
  AdminMultiSelectModal: __WEBPACK_IMPORTED_MODULE_42__AdminMultiSelectModal___default.a
});

/***/ }),
/* 323 */
/***/ (function(module, exports) {

function bookingIsLoggedIn() {
  var storage = localStorage.getItem('branas-booking-default');

  if (!storage) {
    return false;
  }

  storage = JSON.parse(storage);
  if (!storage) {
    return false;
  }

  var data = JSON.parse(storage.value);
  if (!data) {
    return false;
  }

  var user = data.user;
  if (!user) {
    return false;
  }

  if (!user.token) {
    return false;
  }

  return true;
}

function bookingCheckLoggedInIcon(e) {
  var loggedIn = bookingIsLoggedIn();

  if (e && typeof e.detail !== 'undefined') {
    loggedIn = e.detail;
  }

  if (loggedIn) {
    document.querySelector('#login-link a').innerHTML = '<i class="fal fa-user"></i> <span>Mina sidor</span>';
  } else {
    document.querySelector('#login-link a').innerHTML = '<i class="fal fa-lock-alt"></i> <span>Logga in</span>';
  }
}

function bookingStartup() {}

window.bookingIsLoggedIn = bookingIsLoggedIn;

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ripple_directive__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_agile__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_mask__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_i18n__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_filters__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bugsnag_js__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bugsnag_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bugsnag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bugsnag_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_izitoast__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_izitoast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_izitoast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_izitoast_dist_css_iziToast_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_izitoast_dist_css_iziToast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_izitoast_dist_css_iziToast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_components_Icon__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_calculate_on_site_url__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_set_backend_url__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_ga_id__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_stats__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_user__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_set_body_browser__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__App__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mixins_languageDetector__ = __webpack_require__(31);




var getConfig = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var detector, language, lang, data, skiSchoolFilter, i, messages, i18n;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            detector = __WEBPACK_IMPORTED_MODULE_26__mixins_languageDetector__["a" /* default */];
            language = localStorage.getItem('language');

            if (['sv', 'da', 'en'].indexOf(language || '') === -1) {
              lang = detector.methods.getBrowserSimpleLanguage(detector.methods.getBrowserLanguage(window.navigator.language));


              if (['sv', 'da', 'en'].indexOf(lang || '') === -1) {
                language = 'sv';
              } else {
                language = lang;
              }
            }

            localStorage.setItem('language', language);

            __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.locale(language);

            _context.next = 7;
            return __WEBPACK_IMPORTED_MODULE_22__classes_API__["a" /* default */].get('config');

          case 7:
            data = _context.sent;

            window.SITE_CONFIG = data;

            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
              computed: {
                SITE_CONFIG: function SITE_CONFIG() {
                  return window.SITE_CONFIG;
                }
              },
              methods: {
                FEATURE_IS_ACTIVE: function FEATURE_IS_ACTIVE(feature) {
                  return window.SITE_CONFIG.features[feature] && window.SITE_CONFIG.features[feature];
                },
                FEATURE_IS_NOT_ACTIVE: function FEATURE_IS_NOT_ACTIVE(feature) {
                  return typeof window.SITE_CONFIG.features[feature] === 'undefined' || !window.SITE_CONFIG.features[feature];
                },
                SETTING: function SETTING(setting) {
                  return window.SITE_CONFIG.settings[setting] || null;
                }
              }
            });

            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin({
              methods: {
                number: function number(input) {
                  return parseInt(input, 10) || 0;
                }
              }
            });

            skiSchoolFilter = {};

            for (i in window.SITE_CONFIG.skischool.ages) {
              if (!__WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].state.skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]]) {
                skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]] = false;
              } else {
                skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]] = __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].state.skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]];
              }
            }
            for (i in window.SITE_CONFIG.skischool.levels) {
              if (!__WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].state.skiSchoolFilter[i]) {
                skiSchoolFilter[i] = false;
              } else {
                skiSchoolFilter[i] = __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].state.skiSchoolFilter[i];
              }
            }
            skiSchoolFilter.date = __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].state.skiSchoolFilter.date || null;
            __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].commit('setSkischoolFilter', skiSchoolFilter);
            messages = {};

            messages[language] = {};

            messages[language] = window.SITE_CONFIG.translations;

            i18n = new __WEBPACK_IMPORTED_MODULE_9_vue_i18n__["a" /* default */]({
              locale: language,
              messages: messages });

            new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
              el: '#app',
              router: __WEBPACK_IMPORTED_MODULE_24__router__["a" /* default */],
              store: __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */],
              template: '<App/>',
              components: { App: __WEBPACK_IMPORTED_MODULE_23__App___default.a },
              i18n: i18n
            });

          case 21:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getConfig() {
    return _ref.apply(this, arguments);
  };
}();


























__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_calculate_on_site_url__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_set_backend_url__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_ga_id__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_stats__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_user__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_set_body_browser__["a" /* default */])();









var bugsnagClient = __WEBPACK_IMPORTED_MODULE_11_bugsnag_js___default()('fd8bdcec90ef947041b02b76794ed7c4');
bugsnagClient.use(__WEBPACK_IMPORTED_MODULE_12_bugsnag_vue___default()(__WEBPACK_IMPORTED_MODULE_3_vue__["default"]));

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive('ripple', __WEBPACK_IMPORTED_MODULE_4_vue_ripple_directive__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive('mask', __WEBPACK_IMPORTED_MODULE_7_v_mask__["a" /* VueMaskDirective */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_agile__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue2_filters___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_izitoast___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('v-map', __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet___default.a.Map);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('v-tilelayer', __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet___default.a.TileLayer);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('v-marker', __WEBPACK_IMPORTED_MODULE_8_vue2_leaflet___default.a.Marker);

__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.locale('sv');

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_15__components_components_Icon___default.a);

var dateFormatting = function dateFormatting(value, format) {
  var v = value;
  var f = format;

  if (!v) {
    return '';
  }

  if (!f) {
    f = 'D[/]M';
  }

  var formatMap = {
    day: 'D',
    week: 'W',
    'weekday-short': 'ddd',
    weekday: 'dddd',
    month: 'MMMM',
    short: 'D[/]M',
    long: 'D MMMM',
    iso: 'YYYY-MM-DD',
    'short-with-time': 'D[/]M HH:mm',
    'short-with-full-time': 'D[/]M HH:mm:ss'
  };

  if (formatMap[f]) {
    f = formatMap[f];
  }

  return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(v).format(f);
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('date', dateFormatting);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('dateRange', function (value, format, separator) {
  var a = dateFormatting(value[0], format);
  var b = dateFormatting(value[1], format);

  if (a === b) {
    return a;
  }
  return a + (separator || '-') + b;
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('moment', function (value) {
  return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(value);
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('fromNow', function (value) {
  return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(value).fromNow();
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('capitalize', function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('join', function (value) {
  return value.join(', ');
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('weekday', function (value) {
  var days = ['s', 'm', 'tu', 'w', 'th', 'f', 'sa', 'su'];
  if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    return value.map(function (v) {
      return window.SITE_CONFIG.translations.general.weekdays.long[days[v]];
    });
  }
  return window.SITE_CONFIG.translations.general.weekdays.long[days[value]];
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('currency', function (value, config) {
  var options = config;

  if (typeof options === 'undefined') {
    options = {};
  }

  var v = value;
  var s = typeof options.symbol === 'undefined' ? true : options.symbol;
  var f = options.freeIfZero || false;

  if (typeof s === 'undefined') {
    s = true;
  }

  if (typeof v === 'undefined') {
    return '';
  }

  if (v === null) {
    return '';
  }

  v = parseFloat(v.toString().replace(',', '.'));
  v = Math.round(v);

  if (v === 0 && f) {
    return window.SITE_CONFIG.translations.general.free.toUpperCase();
  }

  return v.toLocaleString('sv') + (s ? ':-' : '');
});

window.screenMobile = 690;
window.screenTablet = 995;
window.screenDesktop = 1440;

window.screenSize = function () {
  return window.innerWidth;
};

document.body.classList.add('booking-web');

getConfig();

window.VERSION_NUMBER = 107;

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirmedAccomodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return favoriteAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isAwaitingFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return accomodationsFilterEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return accomodationsFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



var confirmedAccomodations = function confirmedAccomodations($) {
  var accomodations = $.cart.accomodations;
  return accomodations.filter(function (accomodation) {
    var confirmed = accomodation.confirmed;
    return confirmed;
  });
};

var loggedIn = function loggedIn($) {
  return !!$.user.token;
};

var favoriteAccommodations = function favoriteAccommodations($) {
  return $.favorites;
};

var isAwaitingFilter = function isAwaitingFilter($) {
  return $.isAwaitingFilter;
};

var accomodationsFilterEndDate = function accomodationsFilterEndDate($) {
  return $.accomodationsFilter.date.endDate;
};

var accomodationsFilter = function accomodationsFilter($) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()($.accomodationsFilter);
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetPasswordSuccessMessage; });
var resetPasswordSuccessMessage = function resetPasswordSuccessMessage($) {
  return $.resetPasswordSuccessMessage;
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirmedPasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return guidedPasses; });


var confirmedPasses = function confirmedPasses($) {
  return $.cart.skipasses.filter(function (pass) {
    return pass.confirmed;
  });
};

var guidedPasses = function guidedPasses($) {
  return $.cart.skipasses.filter(function (pass) {
    return pass.guideCompleted;
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirmedRentals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return guidedRentals; });


var confirmedRentals = function confirmedRentals($) {
  return $.cart.rentals.filter(function (rental) {
    return rental.confirmed;
  });
};

var guidedRentals = function guidedRentals($) {
  return $.cart.rentals.filter(function (rental) {
    return rental.guideCompleted;
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updatePincode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateCampaignCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateCampaignCodeExtraInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateUserDetails; });


var updatePincode = function updatePincode($, payload) {
  $.cart.pincode = payload;
};

var updateCampaignCode = function updateCampaignCode($, payload) {
  $.cart.pincode = payload.pincode;
  $.cart.campaignCode = payload.campaignCode;
  $.cart.codeRequiresExtraInfo = payload.codeRequiresExtraInfo;
  $.cart.codeExtraInfo = payload.codeExtraInfo;

  for (var i in payload.skipasses) {
    try {
      $.cart.skipasses[i].discountedPrice = payload.skipasses[i].discountedPrice;
      $.cart.skipasses[i].discountedPrices = payload.skipasses[i].discountedPrices;
    } catch (e) {
      console.log(e);
    }
  }

  var rentalProductTypes = ['products', 'addons'];

  for (var _i in payload.rentals) {
    for (var iTyp in rentalProductTypes) {
      var typ = rentalProductTypes[iTyp];

      for (var ii in payload.rentals[_i][typ]) {
        try {
          $.cart.rentals[_i][typ][ii].discountedPrice = payload.rentals[_i][typ][ii].discountedPrice;
        } catch (e) {
          console.log(e);
        }
      }
    }
  }
};

var updateCampaignCodeExtraInfo = function updateCampaignCodeExtraInfo($, payload) {
  $.cart.codeExtraInfo = payload.codeExtraInfo;
};

var updateUserDetails = function updateUserDetails($, payload) {
  console.log(payload);
  $.cart.email = payload.email;
  $.cart.phone = payload.phone.toString().replaceAll(' ', '').replaceAll('-', '');
  $.cart.name = payload.name;
  $.cart.lastName = payload.lastName;
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateResetPasswordSuccessMessage; });


var updateResetPasswordSuccessMessage = function updateResetPasswordSuccessMessage($, payload) {
  $.resetPasswordSuccessMessage = payload;
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addRentalPeople; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateRentalPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateRentalPersonMeasurements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateRentalPersonSkier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setGuideCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return completeGuides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return confirmRental; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addRentalAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeRentalAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setOnSite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setOffSite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_SkiRentalCartItem__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_methods_mutations_accomodation__ = __webpack_require__(64);




var addRentalPeople = function addRentalPeople($, payload) {
  var i = 0;
  if (!payload.append) {
    $.cart.rentals = [];
  }

  $.cart.deliveryTo = payload.deliveryTo;
  $.cart.parent_has_delivery_fee = payload.parent_has_delivery_fee || false;

  while (i < payload.peopleCount) {
    var item = new __WEBPACK_IMPORTED_MODULE_0__classes_SkiRentalCartItem__["a" /* default */]();
    item.startDate = payload.pickedStartDate;
    item.days = payload.numberOfDays;
    item.delivery = payload.delivery;
    item.priceType = payload.priceType;

    $.cart.rentals.push(item);
    i += 1;
  }

  $.cart.currentRentalIndex = 0;
};

var updateRentalPerson = function updateRentalPerson($, payload) {
  var index = payload.index;

  if (payload.forceOverwrite || !payload.guideCompleted) {
    var item = $.cart.rentals[index];
    if (!item) {
      return;
    }
    item.name = payload.name;
    item.age = payload.age;
    item.category = payload.category;
    item.subCategory = payload.subCategory;
    item.type = payload.type;
    item.searchPackage = payload.searchPackage;
    item.startDate = payload.startDate;
    item.days = payload.days;
    item.priceType = payload.priceType;
  }
};

var updateRentalPersonMeasurements = function updateRentalPersonMeasurements($, payload) {
  var index = payload.index;

  var item = $.cart.rentals[index];

  if (!item) {
    return;
  }

  item.lengthCm = payload.lengthCm;
  item.weight = payload.weight;
  item.shoeSize = payload.shoeSize;
  item.clothsize = payload.clothsize;

  item.skier = payload.skier;
};

var updateRentalPersonSkier = function updateRentalPersonSkier($, payload) {
  var index = payload.index;

  var item = $.cart.rentals[index];

  if (!item) {
    return;
  }

  item.skier = payload.skier;
};

var addProducts = function addProducts($, payload) {
  var index = payload.index;
  var products = payload.products;

  var item = $.cart.rentals[index];
  item.quantity = 1;
  item.products = [];
  item.guideCompleted = true;

  products.forEach(function (product) {
    item.products.push(product);
  });
};

var setGuideCompleted = function setGuideCompleted($, payload) {
  var index = payload.index;

  var item = $.cart.rentals[index];
  item.quantity = 1;
  item.guideCompleted = true;
};

var completeGuides = function completeGuides($) {
  $.cart.rentals.forEach(function (rental) {
    if (rental.age) {
      var sum = rental.products.reduce(function (b, product) {
        var price = b + product.price;
        return price;
      }, 0) + rental.addons.reduce(function (b, product) {
        var price = b + product.price;
        return price;
      }, 0);
      rental.guideFullyCompleted = true;
      rental.price = sum;
    }
  });
};

var confirmRental = function confirmRental($, payload) {
  completeGuides($);
  $.cart.rentals.forEach(function (rental) {
    rental.possibleAddons = [];
    if (rental.guideFullyCompleted) {
      rental.confirmed = true;
    }
    rental.site = payload.site;
    rental.pickupTime = payload.pickupTime;
    rental.phone = payload.phone;

    var key = '';
    var keyWithout = 'price_' + rental.days;
    var keyWithInsurance = 'price_insurance_' + rental.days;
    if (rental.insurance) {
      key = keyWithInsurance;
    } else {
      key = keyWithout;
    }

    if (rental.priceType && rental.priceType === 'night') {
      key = key + '_night';
    }

    if (!window.SITE_CONFIG.rental.insurance_per_product) {
      if (rental.products.length) {
        rental.insuranceSum = parseInt(rental.products[0][keyWithInsurance], 10) - parseInt(rental.products[0][keyWithout], 10);
      } else if (rental.addons.length) {
        rental.insuranceSum = parseInt(rental.addons[0][keyWithInsurance], 10) - parseInt(rental.addons[0][keyWithout], 10);
      } else {
        rental.insuranceSum = 0;
      }
    } else {
      rental.products.forEach(function (product, i) {
        rental.products[i].price = parseInt(product[key], 10);
      });
      rental.addons.forEach(function (product, i) {
        rental.addons[i].price = parseInt(product[key], 10);
      });
    }

    var sum = rental.products.reduce(function (b, product) {
      var price = b + product.price;
      return price;
    }, 0) + rental.addons.reduce(function (b, product) {
      var price = b + product.price;
      return price;
    }, 0);

    rental.price = sum;
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_methods_mutations_accomodation__["o" /* refreshCart */])($);
};

var addRentalAddon = function addRentalAddon($, payload) {
  var index = payload.index;
  var product = payload.product;

  var item = $.cart.rentals[index];
  item.addons.push(product);
};

var removeRentalAddon = function removeRentalAddon($, payload) {
  var index = payload.index;
  var product = payload.product;

  var item = $.cart.rentals[index];

  var theIndex = -1;
  item.addons.forEach(function (addon, i) {
    if (addon.pool_lid === product.pool_lid) {
      theIndex = i;
    }
  });

  item.addons.splice(theIndex, 1);
};

var setOnSite = function setOnSite($) {
  $.isOnSite = true;
};

var setOffSite = function setOffSite($) {
  $.isOnSite = false;
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeFreeSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeRooms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeBeds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleDatepicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setFilterLocationId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return changeSorting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleFilterSwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleSkiSchoolFilterSwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleSkiSchoolFilterAgeSwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toggleSkiSchoolSubFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetAccomodationsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return resetSkiSchoolFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toggleSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setAccomodationsFilterStartDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setAccomodationsFilterEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setAccomodationsAvailableIds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_methods_defaultAccomodationsFilter__ = __webpack_require__(120);






var changeFreeSearch = function changeFreeSearch($, value) {
  $.accomodationsFilter.freeSearch = value;
};

var changeRooms = function changeRooms($, value) {
  $.accomodationsFilter.bedrooms = value;
};

var changeBeds = function changeBeds($, value) {
  $.accomodationsFilter.beds = value;
};

var toggleDatepicker = function toggleDatepicker($) {
  $.showDatepicker = !$.showDatepicker;
};

var toggleFilters = function toggleFilters($, value) {
  $.showFilters = value;
};

var toggleMap = function toggleMap($, value) {
  $.showMap = value;
};

var setFilterLocationId = function setFilterLocationId($, value) {
  $.accomodationsFilter.locationId = value;
};

var changeSorting = function changeSorting($, payload) {
  $.accomodationsFilter.sorting = payload.value;
};

var toggleFilterSwitch = function toggleFilterSwitch($, payload) {
  $.accomodationsFilter[payload.key] = payload.value;
};

var toggleSkiSchoolFilterSwitch = function toggleSkiSchoolFilterSwitch($, payload) {
  if (typeof payload === 'undefined' || parseInt(payload.key.substr(0, 1), 10) || payload.key === 'reset') {
    for (var i in window.SITE_CONFIG.skischool.ages) {
      $.skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]] = false;
    }
    for (var i in window.SITE_CONFIG.skischool.levels) {
      $.skiSchoolFilter[i] = false;
    }

    $.skiSchoolFilter.date = null;
  }

  if (payload && payload.key !== 'reset') {
    $.skiSchoolFilter[payload.key] = payload.value;
  }
};

var toggleSkiSchoolFilterAgeSwitch = function toggleSkiSchoolFilterAgeSwitch($, payload) {
  $.skiSchoolFilter.ages[payload.key] = payload.value;
};

var toggleSkiSchoolSubFilter = function toggleSkiSchoolSubFilter($, payload) {
  $.skiSchoolFilter.childrenSub[payload.key] = payload.value;
};

var resetAccomodationsFilter = function resetAccomodationsFilter($, filter) {
  if (filter) {
    $.accomodationsFilter[filter] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_fp__["cloneDeep"])(__WEBPACK_IMPORTED_MODULE_2__store_methods_defaultAccomodationsFilter__["a" /* default */][filter]);
  } else {
    for (var index in $.accomodationsFilter) {
      var cloned = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_fp__["cloneDeep"])(__WEBPACK_IMPORTED_MODULE_2__store_methods_defaultAccomodationsFilter__["a" /* default */][index]);
      if ($.cart.addToOrder && $.cart.addToOrder.number && index === 'date') {} else {
        $.accomodationsFilter[index] = cloned;
      }
    }
  }
  if (filter === 'date') {
    $.accomodationsFilter.availabelIds = [];
  }
};

var resetSkiSchoolFilter = function resetSkiSchoolFilter($, filter) {
  if (filter) {
    $.skiSchoolFilter[filter] = false;
  } else {
    for (var index in $.skiSchoolFilter) {
      $.skiSchoolFilter[index] = false;
    }
  }
};

var toggleSearch = function toggleSearch($, value) {
  $.showSearch = value;
};

var setAccomodationsFilterStartDate = function setAccomodationsFilterStartDate($, value) {
  $.accomodationsFilter.date.startDate = value;
  if (!value || $.accomodationsFilter.date.endDate && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dates__["c" /* validEndDate */])({
    startDate: $.accomodationsFilter.date.startDate
  })($.accomodationsFilter.date.endDate)) {
    $.accomodationsFilter.date.endDate = null;
  }
};

var setAccomodationsFilterEndDate = function setAccomodationsFilterEndDate($, value) {
  $.accomodationsFilter.date.endDate = value;
};

var setAccomodationsAvailableIds = function setAccomodationsAvailableIds($, ids) {
  $.accomodationsFilter.availabelIds = ids;
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addSkiPassPeople; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateSkiPassPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return completeSkipassGuides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return confirmSkiPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addProduct; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_SkiPassCartItem__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_ProductCartItem__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_methods_mutations_accomodation__ = __webpack_require__(64);





var addSkiPassPeople = function addSkiPassPeople($, payload) {
  if (!payload.append) {
    $.cart.skipasses = $.cart.skipasses.filter(function (skipass) {
      return skipass.type === 'SKIPASS-ACCO';
    });
  }

  var i = 0;
  while (i < payload.peopleCount) {
    var item = new __WEBPACK_IMPORTED_MODULE_0__classes_SkiPassCartItem__["a" /* default */]();
    item.days = payload.numberOfDays;
    item.quantity = 1;

    $.cart.skipasses.push(item);
    i += 1;
  }
};

var updateSkiPassPerson = function updateSkiPassPerson($, payload) {
  var index = parseInt(payload.index, 10);

  var indexToUpdate = -1;
  var iterator = -1;
  $.cart.skipasses.forEach(function (skipass, i) {
    if (skipass.type !== 'SKIPASS-ACCO') {
      iterator += 1;

      if (iterator === index) {
        indexToUpdate = i;
      }
    }
  });

  var item = $.cart.skipasses[indexToUpdate];
  item.age = payload.age;
  item.days = payload.days;
  item.price = payload.price;
  item.title = payload.title;
  item.guideCompleted = payload.guideCompleted;
  item.guideFullyCompleted = payload.guideFullyCompleted;
  item.completed = payload.completed;
  item.refill = payload.refill;
  item.cardNumber = payload.keycardNumber;
  item.cardPrefix = payload.keycardNumberPrefix;
  item.keycardPrice = payload.keycard;
  item.poolLid = payload.poolLid;
  item.pass = payload.pass;
};

var completeSkipassGuides = function completeSkipassGuides($) {
  $.cart.skipasses.forEach(function (skipass) {
    if (skipass.age) {
      skipass.guideCompleted = true;
      skipass.guideFullyCompleted = true;
    }
  });
};

var confirmSkiPass = function confirmSkiPass($, data) {
  completeSkipassGuides($);

  if (typeof data.deliveryTo !== 'undefined') {
    $.cart.deliveryTo = data.deliveryTo;
  }

  $.cart.skipasses.forEach(function (skipass) {
    skipass.possibleAddons = [];
    skipass.deliveryType = data.type;
    skipass.site = data.site;
    if (skipass.guideFullyCompleted) {
      skipass.confirmed = true;
      skipass.date_arrival = data.date;
    }
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_methods_mutations_accomodation__["o" /* refreshCart */])($);
};

var addProduct = function addProduct($, payload) {
  if (!$.cart.products) {
    $.cart.products = [];
  }

  var foundItem = $.cart.products.findIndex(function (el) {
    return el.poolId === payload.poolId;
  });

  if (foundItem === -1) {
    var item = new __WEBPACK_IMPORTED_MODULE_1__classes_ProductCartItem__["a" /* default */]();
    item.quantity = payload.quantity;
    item.name = payload.name;
    item.poolId = payload.poolId;
    item.price = payload.price;
    item.confirmed = true;

    $.cart.products.push(item);
  } else {
    $.cart.products[foundItem].quantity += payload.quantity;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_methods_mutations_accomodation__["o" /* refreshCart */])($);
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addSkiSchoolToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return consolidateSkiSchoolInCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addActivitityToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setSkischoolFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setSkischoolFilterAttribute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_SkiSchoolCartItem__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_methods_mutations_accomodation__ = __webpack_require__(64);






var addSkiSchoolToCart = function addSkiSchoolToCart($, payload) {
  var item = new __WEBPACK_IMPORTED_MODULE_2__classes_SkiSchoolCartItem__["a" /* default */]();

  item.pool_lid = payload.pool_lid;
  item.people = payload.people;

  item.confirmed = true;

  item.date = payload.date;
  item.days = payload.days;
  item.site = payload.site;
  item.activity_lid = payload.activity_lid;
  item.time = payload.time;

  item.name = payload.name;

  item.guardian = payload.guardian;
  item.phone = payload.phone;

  item.price = Math.round(parseFloat(payload.price));

  item.quantity = payload.quantity;

  $.cart.skischools.push(item);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_methods_mutations_accomodation__["o" /* refreshCart */])($);

  $.skiSchoolBooking = {};
};

var consolidateSkiSchoolInCart = function consolidateSkiSchoolInCart($, payload) {
  var indexToUpdate = '';
  var indexesToRemove = [];

  console.log(payload);

  for (var i in $.cart.skischools) {
    if (payload.activity_lid === $.cart.skischools[i].activity_lid) {
      indexesToRemove.push(i);
    }
  }

  if (indexesToRemove.length) {
    var first = indexesToRemove.shift();
    indexToUpdate = first;

    var tempSchools = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()($.cart.skischools));

    for (var i in indexesToRemove) {
      var index = indexesToRemove[i];
      for (var ii in tempSchools[index].people) {
        tempSchools[indexToUpdate].people.push(tempSchools[index].people[ii]);
      }
    }

    for (var i in indexesToRemove) {
      var _index = indexesToRemove[i];
      tempSchools.splice(_index, 1);
    }

    tempSchools[indexToUpdate].price = payload.price;
    tempSchools[indexToUpdate].quantity = tempSchools[indexToUpdate].people.length;

    console.log(tempSchools);

    $.cart.skischools = tempSchools;
  }
};

var addActivitityToCart = function addActivitityToCart($, payload) {
  var item = new __WEBPACK_IMPORTED_MODULE_2__classes_SkiSchoolCartItem__["a" /* default */]();

  item.pool_lid = payload.pool_lid;
  item.people = payload.people;

  item.confirmed = true;

  item.date = payload.date;
  item.days = payload.days;
  item.site = payload.site;
  item.activity_lid = payload.activity_lid;
  item.time = payload.time;

  item.name = payload.name;

  item.guardian = payload.guardian;
  item.phone = payload.phone;

  item.price = Math.round(parseFloat(payload.price));

  item.quantity = payload.quantity;

  if (!$.cart.activities) {
    $.cart.activities = [];
  }

  $.cart.activities.push(item);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_methods_mutations_accomodation__["o" /* refreshCart */])($);

  $.skiSchoolBooking = {};
};

var setSkischoolFilter = function setSkischoolFilter($, filter) {
  $.skiSchoolFilter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, filter);
};

var setSkischoolFilterAttribute = function setSkischoolFilterAttribute($, filter) {
  $.skiSchoolFilter[filter.property] = filter.value;
};

/* unused harmony default export */ var _unused_webpack_default_export = ('bar');

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_handlers__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_preparations__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_props__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_watchers__ = __webpack_require__(762);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'agile',

	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_handlers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_preparations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_watchers__["a" /* default */]],

	data: function data() {
		return {
			slides: [],
			slidesClonedBefore: [],
			slidesClonedAfter: [],
			autoplayInterval: null,
			autoplayTimeout: null,
			pauseAutoPlay: false,
			autoplayStart: null,
			autoplayRemaining: null,

			currentSlide: null,
			mouseDown: false,
			dragStartX: 0,
			dragStartY: 0,
			dragDistance: 0,
			swipeDistance: 50,
			translateX: 0,
			transitionDelay: 0,
			widthWindow: 0,
			widthContainer: 0,
			widthSlide: 0,
			settings: {}
		};
	},


	computed: {
		canGoToPrev: function canGoToPrev() {
			return this.settings.infinite || this.currentSlide > 0;
		},

		canGoToNext: function canGoToNext() {
			return this.settings.infinite || this.currentSlide < this.slidesCount - 1;
		},

		clonedSlides: function clonedSlides() {
			return !this.settings.unagile && !this.settings.fade && this.settings.infinite;
		},

		breakpoints: function breakpoints() {
			return !this.initialSettings.responsive ? [] : this.initialSettings.responsive.map(function (item) {
				return item.breakpoint;
			});
		},

		currentBreakpoint: function currentBreakpoint() {
			var _this = this;

			var breakpoints = this.breakpoints.map(function (item) {
				return item;
			}).reverse();
			return this.initialSettings.mobileFirst ? breakpoints.find(function (item) {
				return item < _this.widthWindow;
			}) || 0 : breakpoints.find(function (item) {
				return item > _this.widthWindow;
			}) || null;
		},

		allSlides: function allSlides() {
			return this.clonedSlides ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.slidesClonedBefore), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.slides), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.slidesClonedAfter)) : this.slides;
		},

		slidesCount: function slidesCount() {
			return this.slides.length;
		},

		allSlidesCount: function allSlidesCount() {
			return this.allSlides.length;
		},

		marginX: function marginX() {
			var marginX = this.clonedSlides ? this.slidesCount * this.widthSlide : 0;

			if (this.settings.centerMode) {
				marginX -= (Math.floor(this.settings.slidesToShow / 2) - +(this.settings.slidesToShow % 2 === 0)) * this.widthSlide;
			}

			return this.settings.rtl ? marginX : -1 * marginX;
		}
	},

	created: function created() {
		if (this.options) {
			for (var key in this.options) {
				this.initialSettings[key] = this.options[key];
			}
		}

		if (this.initialSettings.responsive) {
			this.initialSettings.responsive.sort(this.compare);
		}

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.settings, this.initialSettings);
	},
	mounted: function mounted() {
		window.addEventListener('resize', this.getWidth);

		this.$refs.track.addEventListener('touchstart', this.handleMouseDown);
		this.$refs.track.addEventListener('touchend', this.handleMouseUp);
		this.$refs.track.addEventListener('touchmove', this.handleMouseMove);
		this.$refs.track.addEventListener('mousedown', this.handleMouseDown);
		this.$refs.track.addEventListener('mouseup', this.handleMouseUp);
		this.$refs.track.addEventListener('mousemove', this.handleMouseMove);

		this.reload();
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.getWidth);

		this.$refs.track.removeEventListener('touchstart', this.handleMouseDown);
		this.$refs.track.removeEventListener('touchend', this.handleMouseUp);
		this.$refs.track.removeEventListener('touchmove', this.handleMouseMove);
		this.$refs.track.removeEventListener('mousedown', this.handleMouseDown);
		this.$refs.track.removeEventListener('mouseup', this.handleMouseUp);
		this.$refs.track.removeEventListener('mousemove', this.handleMouseMove);

		this.disableAutoPlay();
	},


	methods: {
		reload: function reload() {
			this.getWidth();
			this.prepareSettings();
			this.prepareSlides();
			this.prepareCarousel();
			this.toggleFade();
		},
		toggleFade: function toggleFade() {
			var enabled = !this.settings.unagile && this.settings.fade;

			for (var i = 0; i < this.slidesCount; i++) {
				this.slides[i].style.transition = enabled ? 'opacity ' + this.settings.timing + ' ' + this.settings.speed + 'ms' : 'none';
				this.slides[i].style.transform = enabled ? 'translate(-' + i * this.widthSlide + 'px)' : 'none';
			}
		},
		toggleAutoPlay: function toggleAutoPlay() {
			var _this2 = this;

			var enabled = !this.settings.unagile && this.settings.autoplay;

			if (!this.autoplayInterval && enabled) {
				this.autoplayInterval = setInterval(function () {
					if (!document.hidden) {
						if (!_this2.canGoToNext) {
							_this2.disableAutoPlay();
						} else {
							_this2.goToNext();
						}
					}
				}, this.settings.autoplaySpeed);
			} else {
				this.disableAutoPlay();
			}
		},
		restartAutoPlay: function restartAutoPlay() {
			this.disableAutoPlay();
			this.toggleAutoPlay();
		},
		disableAutoPlay: function disableAutoPlay() {
			clearInterval(this.autoplayInterval);
			this.autoplayInterval = null;
		},
		clearAutoPlayPause: function clearAutoPlayPause() {
			clearTimeout(this.autoplayTimeout);
			this.autoplayRemaining = null;
		},
		disableScroll: function disableScroll() {
			document.ontouchmove = function (e) {
				return e.preventDefault();
			};
		},
		enableScroll: function enableScroll() {
			document.ontouchmove = function () {
				return true;
			};
		},
		getCurrentSlide: function getCurrentSlide() {
			return this.currentSlide;
		},
		getCurrentBreakpoint: function getCurrentBreakpoint() {
			return this.currentBreakpoint;
		},
		getCurrentSettings: function getCurrentSettings() {
			return this.settings;
		},
		getInitialSettings: function getInitialSettings() {
			return this.initialSettings;
		},
		goToNext: function goToNext() {
			if (this.canGoToNext) {
				this.goTo(this.currentSlide + 1);
			}
		},
		goToPrev: function goToPrev() {
			if (this.canGoToPrev) {
				this.goTo(this.currentSlide - 1);
			}
		},
		goTo: function goTo(n) {
			var _this3 = this;

			var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var asNav = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			if (this.settings.unagile) {
				return false;
			}

			if (!asNav) {
				this.settings.asNavFor.forEach(function (carousel) {
					if (carousel) {
						carousel.goTo(n, transition, true);
					}
				});
			}

			var realNextSlide = n;

			if (transition) {
				if (this.settings.infinite && n < 0) {
					realNextSlide = this.slidesCount - 1;
				} else if (n >= this.slidesCount) {
					realNextSlide = 0;
				}

				this.$emit('beforeChange', { currentSlide: this.currentSlide, nextSlide: realNextSlide });

				this.currentSlide = realNextSlide;

				if (n !== realNextSlide) {
					setTimeout(function () {
						_this3.goTo(realNextSlide, false);
					}, this.settings.speed);
				}
			}

			var translateX = !this.settings.fade ? n * this.widthSlide * this.settings.slidesToScroll : 0;
			this.transitionDelay = transition ? this.speed : 0;
			this.translateX = this.settings.rtl ? translateX : -1 * translateX;
		}
	}
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_AddonBookingHeader__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_AddonBookingHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_AddonBookingHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_WebFooter__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_WebFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_WebFooter__);















function updateBodyModalAwareness(modal) {
  if (modal) {
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    Cart: __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart___default.a
  }, __WEBPACK_IMPORTED_MODULE_7__components_modals__["a" /* default */], {
    WebFooter: __WEBPACK_IMPORTED_MODULE_8__components_components_WebFooter___default.a,
    AddonBookingHeader: __WEBPACK_IMPORTED_MODULE_6__components_parts_AddonBookingHeader___default.a
  }),
  mounted: function mounted() {
    this.refreshFavorites();
    this.refreshCart();
    this.closeAllModals();
    this.closeTimeoutModal();
    this.dontAwaitFilter();

    if (!this.$store.state.user_code) {
      this.setUserCode(this.makeid());
    }

    if (this.SITE_CONFIG.env === 'local') {
      this.startEnvironmentCheck();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['refreshFavorites', 'refreshCart', 'closeTimeoutModal', 'closeAllModals', 'dontAwaitFilter', 'setUserCode']), {
    startEnvironmentCheck: function startEnvironmentCheck() {
      var _this = this;

      setInterval(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('config/env-check');

              case 3:
                res = _context.sent;

                if (res.is_production !== _this.SITE_CONFIG.is_production) {
                  window.location.reload();
                }
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      })), 5000);
    },
    setLanguage: function setLanguage(lang) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localStorage.setItem('language', lang);

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('translations');

              case 3:
                data = _context2.sent;

                try {
                  _this2.$i18n.setLocaleMessage(lang.value, data.translations);
                } catch (e) {
                  console.log(e);
                }

                window.SITE_CONFIG.translations = data.translations;

                try {
                  _this2.$i18n.locale = lang;
                } catch (e) {
                  console.log(e);
                }

                document.querySelector('html').setAttribute('lang', lang);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    makeid: function makeid() {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (var i = 0; i < 12; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['currentModal', 'currentTimeoutModal']), {
    languages: function languages() {
      var langs = [];
      langs.push(this.SITE_CONFIG.languages.default);
      this.SITE_CONFIG.languages.other.forEach(function (lang) {
        langs.push(lang);
      });
      return langs;
    },
    getCurrentModal: function getCurrentModal() {
      updateBodyModalAwareness(this.currentModal);
      return this.currentModal;
    },
    getCurrentTimeoutModal: function getCurrentTimeoutModal() {
      updateBodyModalAwareness(this.currentModal);
      return this.currentTimeoutModal;
    },
    currentRoute: function currentRoute() {
      return (this.$route.meta.cssPage || this.$route.name || '').toLowerCase().replace(/[^a-z0-9]/g, '-');
    },
    apiUrl: function apiUrl() {
      return window.API_URL;
    }
  })
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Scanner',

  props: {
    onSuccess: {
      type: Function
    }
  },
  data: function data() {
    return {
      loading: false,
      error: null,
      stream: null,
      scanResult: '',
      scanInterval: null,
      scanning: false,
      scanRawResult: '',
      isOpen: true,
      starting: false,
      partialOk: false,
      waitingForClose: false
    };
  },
  mounted: function mounted() {
    this.starting = true;
    this.startCamera();
  },
  beforeDestroy: function beforeDestroy() {
    console.log('Shutting down scanner...');
    this.stopCamera();
    if (this.scanInterval) clearInterval(this.scanInterval);
  },

  computed: {
    formattedResult: function formattedResult() {
      var data = this.scanResult;

      if (data.length === 23) {
        return data.slice(0, 2) + '-' + data.slice(2, 6) + '-' + data.slice(6, 10) + '-' + data.slice(10, 14) + '-' + data.slice(14, 18) + '-' + data.slice(18, 22) + '-' + data.slice(22);
      }

      if (data.length < 12) {
        return '';
      }

      return '';
    }
  },
  methods: {
    shutdown: function shutdown() {
      this.stopCamera();
    },
    startCamera: function startCamera() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var constraints;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.error = null;
                constraints = {
                  video: { facingMode: 'environment' }
                };
                _context.next = 5;
                return navigator.mediaDevices.getUserMedia(constraints);

              case 5:
                _this.stream = _context.sent;

                _this.$refs.video.srcObject = _this.stream;
                _context.next = 9;
                return _this.$refs.video.play();

              case 9:
                _this.starting = false;
                _this.startScanning();
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this.error = 'Kontrollera att kameran har tillåtelse att användas i webbläsaren.';
                _this.scanning = false;
                _this.starting = false;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    },
    stopCamera: function stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
        this.stream = null;
      }
      this.scanning = false;
    },
    startScanning: function startScanning() {
      this.scanInterval = setInterval(this.captureAndScan, 700);
      this.scanning = true;
    },
    stopScanning: function stopScanning() {
      clearInterval(this.scanInterval);
      this.stopCamera();
      this.waitingForClose = false;
    },
    captureAndScan: function captureAndScan() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var video, w, h, scanW, scanH, scanX, scanY, canvas, ctx, imageData, i, avg, _ref, text, numbers, match;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this2.$refs.video || _this2.loading)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                if (!_this2.waitingForClose) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                video = _this2.$refs.video;
                w = video.videoWidth;
                h = video.videoHeight;

                if (!(!w || !h)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return');

              case 9:
                scanW = Math.floor(w * 0.95);
                scanH = Math.floor(h * 0.1);
                scanX = Math.floor((w - scanW) / 2);
                scanY = Math.floor((h - scanH) / 2);
                canvas = document.createElement('canvas');

                canvas.width = scanW;
                canvas.height = scanH;
                ctx = canvas.getContext('2d');

                ctx.drawImage(video, scanX, scanY, scanW, scanH, 0, 0, scanW, scanH);
                imageData = ctx.getImageData(0, 0, scanW, scanH);

                for (i = 0; i < imageData.data.length; i += 4) {
                  avg = (imageData.data[i] + imageData.data[i + 1] + imageData.data[i + 2]) / 3;

                  imageData.data[i] = avg;
                  imageData.data[i + 1] = avg;
                  imageData.data[i + 2] = avg;
                }
                ctx.putImageData(imageData, 0, 0);

                _this2.loading = true;
                _context2.prev = 22;
                _context2.next = 25;
                return window.Tesseract.recognize(canvas.toDataURL('image/jpeg', 0.7), 'eng');

              case 25:
                _ref = _context2.sent;
                text = _ref.data.text;


                _this2.scanRawResult = text;
                numbers = text.replace(/\D/g, '');
                match = null;

                if (numbers.length === 20 + 2 + 1) {
                  match = [numbers];
                }

                _this2.partialOk = false;

                if (match) {
                  _this2.scanResult = match[0];

                  if (_this2.onSuccess) {
                    _this2.waitingForClose = true;
                    _this2.onSuccess(_this2.formattedResult.replace(/-/g, ''));
                  }
                } else if (numbers.length >= 12) {
                  _this2.scanResult = numbers;
                  _this2.partialOk = true;
                }
                _context2.next = 37;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t0 = _context2['catch'](22);

              case 37:
                _this2.loading = false;

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[22, 35]]);
      }))();
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Loading__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default.a
  },
  data: function data() {
    return {
      pools: [],
      webpools: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data, pools;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/grouped?all=1');

            case 2:
              _ref = _context.sent;
              data = _ref.data;
              pools = _ref.pools;

              _this.pools = data;
              _this.webpools = pools;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {},
  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      try {
        return string.charAt(0).toUpperCase() + string.slice(1);
      } catch (e) {
        return string;
      }
    },
    updatePool: function updatePool(pool) {
      var what = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].post('/admin/update-pool', {
        id: pool.id,
        display_name: pool.display_name,
        image: pool.image,
        image_thumbnail: pool.image_thumbnail,
        video: pool.video,
        hide_map: pool.hide_map,
        map_link: pool.map_link,
        short_description: pool.short_description,
        bullet_points: pool.bullet_points,
        check_in_time: pool.check_in_time,
        check_out_time: pool.check_out_time
      });

      what = this.capitalizeFirstLetter(what);
      this.$toast.success(what + ' för ' + (pool.display_name || pool.name) + ' uppdaterades', 'Område uppdaterat', {
        position: 'topRight'
      });
    },
    updateUnit: function updateUnit(unit) {
      var what = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].post('/admin/update-unit', {
        id: unit.id,
        display_name: unit.display_name,
        subtitle: unit.subtitle,
        image: unit.image,
        use_unit_count: unit.use_unit_count,
        webpool_id: unit.webpool_id,
        check_in_time: unit.check_in_time,
        check_out_time: unit.check_out_time,
        price_type: unit.price_type,
        night_storage: unit.night_storage,
        has_mandatory_cleaning: unit.has_mandatory_cleaning
      });

      what = this.capitalizeFirstLetter(what);
      this.$toast.success(what + ' för ' + (unit.display_name || unit.description_title) + ' uppdaterades', 'Enhet uppdaterad', {
        position: 'topRight'
      });
    },
    openUnit: function openUnit(unit) {
      var link = this.$router.resolve('/boenden/info/' + unit.slug);
      window.open(link.href, '_blank');
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Loading__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default.a
  },
  data: function data() {
    return {
      logs: [],
      shouldNotify: [],
      notified: [],
      intervalRef: null,
      count: 100
    };
  },
  mounted: function mounted() {
    this.getList();
    this.intervalRef = setInterval(this.getList, 10000);
  },
  destroyed: function destroyed() {
    clearInterval(this.intervalRef);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal']), {
    moment: function moment(arg) {
      return __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(arg, 'UTC').tz('Europe/Stockholm');
    },
    notifyMe: function notifyMe(log) {
      var notification = null;
      var msg = {
        title: log.name,
        body: log.success ? 'Har kört klart!' : 'Gick inget bra :(',
        icon: 'https://www.branas.se/app/themes/branas/build/images/icons/apple-touch-icon-180x180-precomposed.png',
        image: 'https://www.branas.se/app/themes/branas/build/images/icons/apple-touch-icon-180x180-precomposed.png',
        badge: 'https://www.branas.se/app/themes/branas/build/images/icons/apple-touch-icon-180x180-precomposed.png'
      };
      if (!('Notification' in window)) {
        alert('This browser does not support desktop notification');
      } else if (Notification.permission === 'granted') {
        notification = new Notification(msg.title, msg);
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          if (permission === 'granted') {
            notification = new Notification(msg.title, msg);
          }
        });
      }
      console.log(notification);
    },
    getList: function getList(addMore) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (typeof addMore !== 'undefined' && addMore === true) {
                  _this.count = _this.count + 100;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/admin/command-logs?count=' + _this.count);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.logs = data;

                _this.logs.forEach(function (log) {
                  if (_this.shouldNotify.indexOf(log.id) !== -1) {
                    if (log.success) {
                      _this.shouldNotify.splice(_this.shouldNotify.indexOf(log.id), 1);
                      _this.notified.push(log.id);
                      _this.notifyMe(log);
                    }
                  } else if (!log.success && !log.failed) {
                    _this.shouldNotify.push(log.id);
                  }
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    sync: function sync(command, args1, args2) {
      this.openModal(['AdminSyncFields', {
        command: command,
        args1: args1,
        args2: args2
      }]);
    }
  }),
  computed: {}
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      from: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      to: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'months').format('YYYY-MM-DD'),
      code: '',
      days_min: '',
      days_max: '',
      order_sources: {
        web: true,
        mobile: true
      },
      line_types: {
        equipment: true,
        accomodation: true,
        accomodation_addon: true,
        equipment_addon: true,
        skipass: true,
        accomodation_skipass: true,
        skischool: true,
        skipass_keycard: true,

        product: true
      }
    };
  },

  computed: {
    currentDomain: function currentDomain() {
      return this.SITE_CONFIG.site + '.se';
    },
    orderSourceOptions: function orderSourceOptions() {
      return [{ value: 'web', text: 'Via webb' }, { value: 'mobile', text: 'Via hyra.' + this.currentDomain }];
    },
    lineTypeOptions: function lineTypeOptions() {
      return [{ value: 'equipment', text: 'Utrustning' }, { value: 'equipment_addon', text: 'Utrustningstillval' }, { value: '___equipment', text: 'disabled' }, { value: 'skipass', text: 'Liftkort' }, { value: 'accomodation_skipass', text: 'Boendeliftkort' }, { value: 'skipass_keycard', text: 'Keycard' }, { value: 'product', text: 'Produkt' }, { value: '___skipass', text: 'disabled' }, { value: 'accomodation', text: 'Boende' }, { value: 'accomodation_addon', text: 'Boendetillval' }, { value: '___accomodation', text: 'disabled' }, { value: 'skischool', text: 'Skidskola' }];
    }
  },
  methods: {
    showInfo: function showInfo() {
      this.$toast.info('Exporten laddas snart ned. Stäng inte fönstret', 'Förbereder', {
        position: 'topRight'
      });
    },
    getReportEmailLink: function getReportEmailLink() {
      var reportUrl = __WEBPACK_IMPORTED_MODULE_1__classes_API__["a" /* default */].getUrl(this.getBaseLink() + '&report=emails');
      return reportUrl;
    },
    getReportEmailExtendedLink: function getReportEmailExtendedLink() {
      var reportUrl = __WEBPACK_IMPORTED_MODULE_1__classes_API__["a" /* default */].getUrl(this.getBaseLink() + '&view=line&report=emails-extended');
      return reportUrl;
    },
    getReportCodesWithExtraInfoLink: function getReportCodesWithExtraInfoLink() {
      var reportUrl = __WEBPACK_IMPORTED_MODULE_1__classes_API__["a" /* default */].getUrl(this.getBaseLink() + '&report=codes_with_extra_info');
      return reportUrl;
    },
    getBaseLink: function getBaseLink() {
      var _this = this;

      var auth = __WEBPACK_IMPORTED_MODULE_1__classes_API__["a" /* default */].authSimpleParameter;
      var sources = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.order_sources).filter(function (key) {
        return _this.order_sources[key];
      }).join(',');
      var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.line_types).filter(function (key) {
        return _this.line_types[key];
      }).join(',');
      var daysMin = this.days_min || '';
      var daysMax = this.days_max || '';
      return '/stats/orders?start=' + this.from + '&end=' + this.to + '&payment_code=' + this.code + '&property=arrival&page=1&pp=99999&payed=yes&auth-simple=' + auth + '&order_sources=' + sources + '&types=' + types + '&days_min=' + daysMin + '&days_max=' + daysMax;
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_4__components_components_Dropdown___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default.a
  },
  data: function data() {
    return {
      validStartDates: [],
      pickedStartDate: null,
      loading: false
    };
  },
  mounted: function mounted() {
    this.validStartDates = [];

    var loopStart = __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(1, 'year').toDate();
    var current = loopStart;
    var end = __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(1, 'month').toDate();
    var next = null;

    if (!this.pickedStartDate) {
      this.pickedStartDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(1, 'month').toDate();
    }

    while (current < end) {
      next = __WEBPACK_IMPORTED_MODULE_7_moment___default()(current).add(1, 'days');
      this.validStartDates.push(next.format('YYYY-MM-DD'));
      current = next.toDate();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal']), {
    formatDate: function formatDate() {
      if (this.pickedStartDate) {
        return __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.pickedStartDate).format('D MMMM YYYY');
      }
      return 'Välj rensningsdag';
    },
    datepickerRangeModal: function datepickerRangeModal() {
      this.openModal(['DatepickerRangeModal', {
        validDates: this.validStartDates,
        pickedEndDate: null,
        onClose: this.selectDates,
        night: false,
        startDateOnly: true,
        allowPrevious: true,
        terminology: 'Välj',
        info: 'Välj datum',
        infoOnPicked: 'Välj slutdatum',
        showAllMonths: true
      }]);
    },
    selectDates: function selectDates(start, end) {
      if (!start) {
        return;
      }
      this.pickedStartDate = start;
      this.pickedEndDate = end;
      if (!end) {
        this.pickedEndDate = start;
      }
    },
    dateClear: function dateClear() {
      this.pickedStartDate = null;
      this.pickedEndDate = null;
    },
    clean: function clean() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, success;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].post('/orders/gdpr-cleanup', {
                  start: _this.pickedStartDate
                });

              case 3:
                _ref = _context.sent;
                success = _ref.success;


                _this.loading = false;

                return _context.abrupt('return', success);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  computed: {}
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Loading__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default.a
  },
  data: function data() {
    return {
      data: [],
      types: {}
    };
  },
  mounted: function mounted() {
    this.sync();
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['openModal']), {
    sync: function sync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ids, types, _ref, data, meta;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ids = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this.types).filter(function (n) {
                  return n.active;
                }).map(function (n) {
                  return n.key;
                });
                types = ids.join(',');
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('notifications?types=' + types);

              case 4:
                _ref = _context.sent;
                data = _ref.data;
                meta = _ref.meta;

                _this.data = data;

                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.types).length === 0) {
                  _this.types = meta.levels;
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filterSync: function filterSync(index) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.types[index].active = !_this2.types[index].active;_context2.next = 3;
                return _this2.sync();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  filters: {
    nl2br: function nl2br(value) {
      return value.replace('\n', '<br>');
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_10__components_components_Loading___default.a
  },
  data: function data() {
    return {
      data: [],
      pickedStartDate: null,
      pickedEndDate: null,
      validStartDates: [],
      property: 'created_at',
      order: 'DESC',
      currentIndex: -1,

      excel_url: '',

      pages: [],
      page: 1,
      count: 0,
      total: 0,
      from: 0,
      to: 0,

      searchQuery: '',

      perPage: '50',
      perPageOptions: [{
        title: '5',
        value: '5'
      }, {
        title: '50',
        value: '50'
      }, {
        title: '100',
        value: '100'
      }, {
        title: '500',
        value: '500'
      }, {
        title: '1000',
        value: '1000'
      }],

      sortKey: 'created_at',
      reverse: true,
      search: '',

      loading: false,

      selectedTypes: {},

      selectedPayed: {},
      selectedPayTypes: {},
      selectedSubPayTypes: {},
      selectedOrderSources: {},

      propertyValues: [{
        title: 'Skapad',
        value: 'created_at'
      }, {
        title: 'Ankomst',
        value: 'arrival'
      }, {
        title: 'Avresa',
        value: 'departure'
      }],

      showDirectSearch: false,

      groupBy: 'head',
      groupOptions: [{
        title: 'Huvud',
        value: 'head'
      }, {
        title: 'Rad',
        value: 'line'
      }],

      types: [{
        title: 'Utrustn.',
        value: 'equipment',
        module: 'skiletting'
      }, {
        title: 'Utrustn. tillv.',
        value: 'equipment_addon',
        module: 'skiletting'
      }, {
        title: 'Skidskola',
        value: 'skischool',
        module: 'school'
      }, {
        title: 'Liftkort',
        value: 'skipass',
        module: 'skipass'
      }, {
        title: 'Oladdat',
        value: 'product',
        module: 'skiletting'
      }, {
        title: 'Keycard',
        value: 'skipass_keycard',
        module: 'skipass'
      }, {
        title: 'Boende',
        value: 'accomodation',
        module: 'accomodation'
      }, {
        title: 'Bo. tillv.',
        value: 'accomodation_addon',
        module: 'accomodation'
      }, {
        title: 'Bo. liftkort',
        value: 'accomodation_skipass',
        module: 'skipass'
      }],

      payedYesno: [{
        title: 'Ja',
        value: 'yes'
      }, {
        title: 'Nej',
        value: 'no'
      }],

      payTypes: [{
        title: 'Collector',
        value: 'collector'
      }, {
        title: 'Kort på plats',
        value: 'chip'
      }, {
        title: 'Kontant',
        value: 'onsite'
      }, {
        title: 'Klarna',
        value: 'klarna'
      }],

      subPayTypes: [{
        title: 'Swish',
        value: 'swish'
      }, {
        title: 'Kort',
        value: 'card'
      }, {
        title: 'Kod',
        value: 'code'
      }, {
        title: 'Annat',
        value: 'other'
      }],

      orderSources: [{
        title: 'Web',
        value: 'web'
      }, {
        title: 'On site',
        value: 'onsite'
      }, {
        title: 'Mobilhyra',
        value: 'mobile'
      }],

      meta: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var loopStart, current, end, next;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getFromUrl();

              _this.validStartDates = [];

              loopStart = __WEBPACK_IMPORTED_MODULE_11_moment___default()().subtract(1, 'year').toDate();
              current = loopStart;
              end = __WEBPACK_IMPORTED_MODULE_11_moment___default()().add(1, 'year').toDate();
              next = null;


              if (!_this.pickedStartDate) {
                _this.pickedStartDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()().toDate();
              }
              if (!_this.pickedEndDate) {
                _this.pickedEndDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()().toDate();
              }

              while (current < end) {
                next = __WEBPACK_IMPORTED_MODULE_11_moment___default()(current).add(1, 'days');
                _this.validStartDates.push(next.format('YYYY-MM-DD'));
                current = next.toDate();
              }

              _this.fetch();

              if (localStorage.getItem('admin_show_direct_search')) {
                _this.showDirectSearch = true;
              }

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    sum: function sum() {
      return this.meta.sum;
    },
    sumSkischool: function sumSkischool() {
      return this.meta.sumSkischool;
    },
    sumSkirental: function sumSkirental() {
      return this.meta.sumSkirental;
    },
    getExcelReportLink: function getExcelReportLink() {
      var auth = __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].authSimpleParameter;
      var reportUrl = __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].getUrl(this.excel_url + '&page=1&pp=10000&report=excel&auth-simple=' + auth);
      return reportUrl;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['openModal']), {
    changePage: function changePage(page) {
      this.page = page;
      this.updateUrl();
      this.fetch();
    },
    getFromUrl: function getFromUrl() {
      var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      this.pickedStartDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(query.pickedStartDate) || null;
      this.pickedEndDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(query.pickedEndDate) || null;
      this.property = query.property || '';
      this.order = query.order || '';
      this.groupBy = query.groupBy || '';
      this.page = query.page || '';
      this.perPage = query.pp || '';

      if (!this.pickedStartDate.isValid()) {
        this.pickedStartDate = null;
      }

      if (!this.pickedEndDate.isValid()) {
        this.pickedEndDate = null;
      }

      var selectedTypes = (query.selectedTypes || '').split(',');
      var $this = this;
      selectedTypes.forEach(function (value) {
        $this.toggleType(value);
      });

      var selectedPayed = (query.selectedPayed || '').split(',');
      selectedPayed.forEach(function (value) {
        $this.toggledPayed(value);
      });

      var selectedPayTypes = (query.selectedPayTypes || '').split(',');
      selectedPayTypes.forEach(function (value) {
        $this.togglePayType(value);
      });

      var selectedSubPayTypes = (query.selectedSubPayTypes || '').split(',');
      selectedSubPayTypes.forEach(function (value) {
        $this.toggleSubPayType(value);
      });

      var selectedOrderSources = (query.selectedOrderSources || '').split(',');
      selectedOrderSources.forEach(function (value) {
        $this.toggleOrderSource(value);
      });
    },
    updateUrl: function updateUrl() {
      var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      query.pickedStartDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.pickedStartDate).format('YYYY-MM-DD') || '';
      query.pickedEndDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.pickedEndDate).format('YYYY-MM-DD') || '';
      query.property = this.property || '';
      query.order = this.order || '';
      query.groupBy = this.groupBy || '';
      query.selectedTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedTypes).join(',') || '';
      query.selectedPayed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedPayed).join(',') || '';
      query.selectedPayTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedPayTypes).join(',') || '';
      query.selectedOrderSources = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.selectedOrderSources).join(',') || '';
      query.page = this.page;
      query.pp = this.perPage;

      this.$router.push({
        name: this.$route.name,
        query: query
      });
    },
    fetch: function fetch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var start, end, types, payed, payedTypes, subPayedTypes, orderSources, queryName, url, _ref, data, meta;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.updateUrl();
                _this2.loading = true;
                start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this2.pickedStartDate).format('YYYY-MM-DD');
                end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this2.pickedEndDate).format('YYYY-MM-DD');
                types = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.selectedTypes).join(',');
                payed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.selectedPayed).join(',');
                payedTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.selectedPayTypes).join(',');
                subPayedTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.selectedSubPayTypes).join(',');
                orderSources = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.selectedOrderSources).join(',');
                queryName = _this2.searchQueryName || '';
                url = '/stats/orders?start=' + start + '&end=' + end + '&property=' + _this2.property + '&order=' + _this2.order + '&view=' + _this2.groupBy + '&types=' + types + '&page=' + _this2.page + '&pp=' + _this2.perPage;

                url = url + '&payed=' + payed + '&payed_types=' + payedTypes + '&sub_payed_types=' + subPayedTypes + '&order_sources=' + orderSources + '&name=' + queryName;
                _this2.excel_url = url;

                _context2.next = 15;
                return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get(url);

              case 15:
                _ref = _context2.sent;
                data = _ref.data;
                meta = _ref.meta;

                _this2.pages = meta.pagesArray;
                _this2.total = meta.total;
                _this2.count = meta.count;
                _this2.from = meta.from;
                _this2.to = meta.to;
                _this2.data = data;
                _this2.loading = false;

                _this2.meta = meta;

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setSortBy: function setSortBy(sortKey) {
      this.reverse = this.sortKey === sortKey ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    selectDates: function selectDates(start, end) {
      if (!start) {
        return;
      }
      this.pickedStartDate = start;
      this.pickedEndDate = end;
      if (!end) {
        this.pickedEndDate = start;
      }
      this.fetch();
    },
    formatDate: function formatDate() {
      var start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.pickedStartDate).format('D/M');
      var end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.pickedEndDate).format('D/M');
      return start + ' - ' + end;
    },
    datepickerRangeModal: function datepickerRangeModal() {
      this.openModal(['DatepickerRangeModal', {
        clickOutside: false,
        validDates: this.validStartDates,
        pickedStartDate: this.pickedStartDate,
        pickedEndDate: this.pickedEndDate,
        onClose: this.selectDates,
        onPickStart: this.setEndDates,
        night: [],
        allowPrevious: true,
        terminology: 'Välj',
        info: 'Välj datum',
        infoOnPicked: 'Välj slutdatum',
        showAllMonths: true
      }]);
    },
    dateClear: function dateClear() {
      this.pickedStartDate = null;
      this.pickedEndDate = null;
    },
    setEndDates: function setEndDates() {
      var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        resolve(365);
      });
      return promise;
    },
    openOrder: function openOrder(order) {
      this.$router.push({
        name: 'admin-stats-orders-detail',
        params: {
          orderId: order.id
        }
      });
    },
    toggleType: function toggleType(value) {
      if (this.selectedTypes[value]) {
        this.$delete(this.selectedTypes, value);
      } else {
        this.$set(this.selectedTypes, value, true);
      }
      this.fetch();
    },
    toggledPayed: function toggledPayed(value) {
      if (this.selectedPayed[value]) {
        this.$delete(this.selectedPayed, value);
      } else {
        this.$set(this.selectedPayed, value, true);
      }
      this.fetch();
    },
    togglePayType: function togglePayType(value) {
      if (this.selectedPayTypes[value]) {
        this.$delete(this.selectedPayTypes, value);
      } else {
        this.$set(this.selectedPayTypes, value, true);
      }
      this.fetch();
    },
    toggleSubPayType: function toggleSubPayType(value) {
      if (this.selectedSubPayTypes[value]) {
        this.$delete(this.selectedSubPayTypes, value);
      } else {
        this.$set(this.selectedSubPayTypes, value, true);
      }
      this.fetch();
    },
    toggleOrderSource: function toggleOrderSource(value) {
      if (this.selectedOrderSources[value]) {
        this.$delete(this.selectedOrderSources, value);
      } else {
        this.$set(this.selectedOrderSources, value, true);
      }
      this.fetch();
    },
    doSearch: function doSearch() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('/order/search?q=' + _this3.searchQuery);

              case 2:
                _ref2 = _context3.sent;
                data = _ref2.data;

                _this3.openOrder(data);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  })
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a
  },
  data: function data() {
    return {
      order: {},
      changes: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.fetch();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    url: function url() {
      return window.location.host + window.location.pathname;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal']), {
    fetch: function fetch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, data, changes;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/stats/orders/' + _this2.$route.params.orderId);

              case 2:
                _ref = _context2.sent;
                data = _ref.data;
                changes = _ref.changes;

                _this2.order = data;
                _this2.changes = changes;

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeModalLocal: function closeModalLocal() {
      this.$router.go(-1);
    }
  })
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SwitchButton: __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton___default.a
  },
  props: ['setting'],
  data: function data() {
    return {
      localSetting: [],
      loading: false,
      expanded: false,
      sortingEnabled: false,
      originalValueBackup: null,
      draggedIndex: null,
      dragOverIndex: null
    };
  },
  mounted: function mounted() {
    this.localSetting = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.setting);
    this.transformSetting();
  },

  methods: {
    updateSetting: function updateSetting(setting) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;

                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/admin/setting/' + setting.key, {
                  data: setting.value,
                  in_use: setting.in_use
                });

              case 4:
                _ref = _context.sent;
                data = _ref.data;


                _this.localSetting.db.value = data;
                _this.localSetting.db.updated_at = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm:ss');
                _this.transformSetting();

                _this.$toast.success('Inställningen är sparad', 'Sparat', {
                  position: 'topRight'
                });
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](1);

                _this.$toast.error('Inställningen sparades inte', 'Fel', {
                  position: 'topRight'
                });

              case 15:

                _this.loading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 12]]);
      }))();
    },
    transformSetting: function transformSetting() {
      if (this.localSetting.editor === 'boolean') {
        this.localSetting.db.value = this.localSetting.db.value === '1' || this.localSetting.db.value === true;
      }
    },
    toggle: function toggle(e) {
      this.localSetting.db.value = e.value ? 1 : 0;
      this.updateSetting(this.localSetting.db);
    },
    enableSorting: function enableSorting() {
      this.originalValueBackup = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.localSetting.db.value));
      this.sortingEnabled = true;
    },
    saveSorting: function saveSorting() {
      this.sortingEnabled = false;
      this.originalValueBackup = null;
      this.updateSetting(this.localSetting.db);
    },
    cancelSorting: function cancelSorting() {
      this.localSetting.db.value = this.originalValueBackup;
      this.sortingEnabled = false;
      this.originalValueBackup = null;
    },
    dragStart: function dragStart(event, index) {
      if (!this.sortingEnabled) return;
      this.draggedIndex = index;

      event.dataTransfer.effectAllowed = 'move';
    },
    dragEnter: function dragEnter(index) {
      if (!this.sortingEnabled) return;
      var lastIndex = this.localSetting.db.value.length - 1;
      if (index < lastIndex) {
        this.dragOverIndex = index;
      }
    },
    dragEnd: function dragEnd() {
      this.draggedIndex = null;
      this.dragOverIndex = null;
    },
    dropRow: function dropRow(event, index) {
      if (!this.sortingEnabled) return;
      var lastIndex = this.localSetting.db.value.length - 1;
      if (index >= lastIndex || this.draggedIndex === index) {
        this.dragOverIndex = null;
        this.draggedIndex = null;
        return;
      }

      var draggedRow = this.localSetting.db.value[this.draggedIndex];
      this.localSetting.db.value.splice(this.draggedIndex, 1);
      this.localSetting.db.value.splice(index, 0, draggedRow);
      this.draggedIndex = null;
      this.dragOverIndex = null;
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Admin_Setting__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Admin_Setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Admin_Setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Loading__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default.a,
    Setting: __WEBPACK_IMPORTED_MODULE_6__components_Admin_Setting___default.a
  },
  data: function data() {
    return {
      settings: [],
      show_winter: true,
      show_summer: true,
      freesearch: '',
      loaded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/settings');

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              _this.settings = data;
              _this.loaded = true;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {},
  methods: {
    showSetting: function showSetting(setting) {
      if (setting.season) {
        if (!this.show_winter && setting.season === 'winter') {
          return false;
        }

        if (!this.show_summer && setting.season === 'summer') {
          return false;
        }
      }

      if (this.freesearch) {
        var dbValue = setting.db && setting.db.value ? setting.db.value : '';

        if ((typeof dbValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(dbValue)) === 'object') {
          dbValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dbValue);
        }

        var stringToSearch = [setting.title, setting.description, setting.value, setting.db && setting.db.example ? setting.db.example : '', setting.db && setting.db.default_value ? setting.db.default_value : '', dbValue, setting.db && setting.db.key ? setting.db.key : ''].join(' ').toLowerCase();

        return stringToSearch.match(this.freesearch.toLowerCase());
      }

      return true;
    },
    getTitle: function getTitle(key) {
      var titles = {
        styling: 'Utseende',
        payment: 'Betalning',
        dates: 'Datum',
        open: 'Öppet/stängt',
        accommodation: 'Boende',
        system: 'System',
        texts: 'Texter',
        skischool: 'Skidskola',
        mypage: 'Mina sidor',
        rental: 'Hyra'
      };

      if (titles[key]) {
        return titles[key];
      }

      return key.charAt(0).toUpperCase() + key.slice(1);
    },
    getHelp: function getHelp(group) {
      var titles = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(group.entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var firstGroup = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(firstGroup.entries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var setting = _step2.value;

              titles.push(setting.title);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return titles.join(', ');
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default.a
  },
  data: function data() {
    return {
      loading: false,
      texts: [],
      missingTexts: [],
      categories: [],
      bikeHeightCategories: [],
      category: 'accomodationaddon',
      cats: {
        accomodationaddon: 'Boendetillval',
        pagetexts: 'Sidtexter',
        skilettingproduct: 'Skidhyra',
        skischoolgroup: 'Skidskolegrupp'
      },
      selectedLanguage: 'sv',
      languages: ['sv', 'en', 'da'],
      sort: 'id1',
      availableSorts: [{
        value: 'id1',
        text: 'Pool-ID'
      }, {
        value: 'number2',
        text: 'Ordning'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.fetchData();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    flag: function flag() {
      var _this2 = this;

      var flagUrl = '';
      this.SITE_CONFIG.languages.full.forEach(function (lang) {
        if (lang.value === _this2.selectedLanguage) {
          flagUrl = lang.flag;
        }
      });

      return flagUrl;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    friendlySkiSchoolGroupId: function friendlySkiSchoolGroupId(id) {
      if (!id) return '';

      return id.replace(/\./, '#1').replace(/\./, '-').replace(/\./, ' år').replace('group#1', 'Grupp, ').replace('private#1', 'Privat, ').replace('snowboard#1', 'Snowboard, ').replace(' årgreen', ' år, nivå 1 (grön)').replace(' årblue', ' år, nivå 2 (blå)').replace(' årred_snolek', ' år, snölek').replace(' årred', ' år, nivå 3 (röd)').replace(' år_private_1', ' år, nivå 1').replace(' år_private_2', ' år, nivå 2').replace(' år_private_3', ' år, nivå 3').replace(' år_private_', ' år, privat').replace(' årblack', ' år, nivå 4 (svart)');
    },
    setCat: function setCat(cat) {
      this.category = cat;
      this.sort = cat === 'skilettingproduct' ? 'number2' : 'id1';
      this.fetchData();
    },
    add: function add() {
      this.texts.push({
        category: this.category,
        slug: '',
        id1: '',
        id2: '',
        id3: '',
        text1: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text2: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text3: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text4: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text5: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text6: '',
        text7: '',
        number1: null,
        number2: 999,
        number3: 9
      });

      this.$toast.warning('OBS! Sparas inte förrän du skrivit något', 'Tillagd text', {
        position: 'topRight'
      });
    },
    addFromMissing: function addFromMissing(text, index) {
      this.missingTexts.splice(index, 1);
      this.texts.push({
        category: 'skischoolgroup',
        slug: '',
        id1: text.id1,
        id2: '',
        id3: '',
        pool_ids: text.pool_ids || [],
        product_names: text.product_names || [],
        text1: { sv: '', en: '', da: '' },
        text2: { sv: '', en: '', da: '' },
        text3: { sv: '', en: '', da: '' },
        text4: { sv: '', en: '', da: '' },
        text5: { sv: '', en: '', da: '' },
        text6: '',
        text7: '',
        number1: null,
        number2: 999,
        number3: 9
      });
      this.$toast.info('Skidskolegruppen lades till i listan ovan. Fyll i text och spara.', 'Tillagd', {
        position: 'topRight'
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['openModal']), {
    getCategoryName: function getCategoryName(id) {
      var found = this.bikeHeightCategories.find(function (c) {
        return String(c.id) === String(id);
      });
      return found ? found.name : id;
    },
    getSelectedCategories: function getSelectedCategories(json1) {
      if (!json1) return [];
      if (Array.isArray(json1)) return json1;
      try {
        var decoded = JSON.parse(json1);
        return Array.isArray(decoded) ? decoded : [];
      } catch (e) {
        return [];
      }
    },
    openSelectModal: function openSelectModal(text) {
      var _this3 = this;

      var currentSelection = this.getSelectedCategories(text.json1);
      this.openModal(['AdminMultiSelectModal', {
        title: 'Välj längdkategorier',
        options: this.bikeHeightCategories,
        selected: currentSelection,
        click: function click(selectedIds) {
          text.json1 = selectedIds;
          _this3.updateText(text);
        }
      }]);
    },
    updateText: function updateText(text) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, error, data, forceReload;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.loading = true;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/admin/update-texts', text);

              case 3:
                _ref = _context2.sent;
                error = _ref.error;
                data = _ref.data;
                forceReload = _ref.forceReload;


                if (error) {
                  _this4.$toast.error(error, 'Fel', {
                    position: 'topRight'
                  });
                } else {
                  text.id = data.id;

                  _this4.$toast.success('Texten sparades', 'Sparat', {
                    position: 'topRight'
                  });
                }
                _this4.loading = false;

                if (forceReload) {
                  _this4.fetchData();
                }

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    fetchData: function fetchData() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, data, categories, missingTexts, bikeHeightCategories;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.loading = true;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/texts?sort=' + _this5.sort + '&category=' + _this5.category);

              case 3:
                _ref2 = _context3.sent;
                data = _ref2.data;
                categories = _ref2.categories;
                missingTexts = _ref2.missingTexts;
                bikeHeightCategories = _ref2.bikeHeightCategories;

                _this5.texts = data.map(function (text) {
                  if (text.category === 'skischoolgroup') {
                    var newText = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, text);
                    ['text1', 'text2', 'text3', 'text4', 'text5'].forEach(function (field) {
                      newText[field] = JSON.parse(newText[field] || '{}') || '';
                    });
                    return newText;
                  }
                  return text;
                });
                _this5.categories = categories;
                _this5.missingTexts = missingTexts;
                _this5.bikeHeightCategories = bikeHeightCategories || [];
                _this5.loading = false;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    }
  })
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Loading__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default.a
  },
  data: function data() {
    return {
      settings: [],
      loading: false
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    download: function download(url) {
      window.open(url, '_blank');
    },
    generateTranslations: function generateTranslations() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/admin/translations?lang=sv');

              case 3:
                _this.loading = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    generateTranslationsFromFiles: function generateTranslationsFromFiles() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/admin/translations?lang=sv&from-files=1');

              case 3:
                _this2.loading = false;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getFile: function getFile(lang) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var auth, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/admin/get-auth-key');

              case 3:
                auth = _context3.sent;
                url = __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].getUrl('/admin/translations-excel?lang=' + lang + '&auth=' + auth);

                _this3.download(url);
                _this3.loading = false;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    uploadFile: function uploadFile() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var file, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                file = document.querySelector('#file');

                if (file.files.length) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt('return');

              case 3:

                _this4.loading = true;

                formData = new FormData();

                formData.append('file', file.files[0]);

                _context4.next = 8;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].postFile('/admin/translations-update', formData);

              case 8:
                _this4.loading = false;

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Loading__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SwitchButton: __WEBPACK_IMPORTED_MODULE_5__components_components_SwitchButton___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default.a
  },
  data: function data() {
    return {
      accomodations: [],
      onlyDifferences: false,
      fromMemory: true,
      loading: false
    };
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.load();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['removeFavorite', 'openModal', 'closeModal', 'awaitFilter']), {
    goToAccomodations: function goToAccomodations() {
      this.$router.push('/boenden');
    },
    removeFavoriteLocal: function removeFavoriteLocal(payload) {
      var _this2 = this;

      var $this = this;
      if ($this.fromMemory) {
        $this.openModal(['GeneralModal', {
          type: 'confirm',
          content: 'Vill du ta bort boendet från din jämförelselista?',
          yes: function yes() {
            $this.closeModal();
            $this.removeFavorite(payload);
            _this2.load();
          },
          no: function no() {
            $this.closeModal();
          }
        }]);
      } else {
        var query = this.$route.query.boenden.split(',');
        query.splice(payload, 1);
        this.$router.replace({ query: {
            boenden: query.join(',')
          } });
        this.load();
      }
    },
    changeValue: function changeValue(v) {
      this.awaitFilter();
      this.onlyDifferences = v.value;
    },
    load: function load() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var accomodations, i, fav, _ref, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                accomodations = null;


                if (_this3.$route.query.boenden && _this3.$route.query.boenden.length) {
                  accomodations = _this3.$route.query.boenden.split(',');
                  _this3.fromMemory = false;
                } else {
                  accomodations = _this3.favoriteAccommodations;
                  _this3.fromMemory = true;
                }

                _this3.accomodations = [];
                _context2.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(accomodations);

              case 5:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 16;
                  break;
                }

                i = _context2.t1.value;
                fav = accomodations[i];

                if (!(i < 3)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/units/' + fav + '/info-by-id');

              case 11:
                _ref = _context2.sent;
                data = _ref.data;

                _this3.accomodations.push(data);

              case 14:
                _context2.next = 5;
                break;

              case 16:

                _this3.loading = false;

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    differs: function differs(prop) {
      var picked = [];
      for (var i in this.accomodations) {
        var unit = this.accomodations[i];
        picked.push(unit[prop]);
      }

      var first = picked[0];
      var ret = picked.every(function (element) {
        return element === first;
      });
      return !ret;
    },
    openInfo: function openInfo(unit) {
      this.$router.push({ path: '/jamfor-boenden/info/' + unit.slug + '?flow=jamfor-boenden' });
    },
    openMap: function openMap(unit) {
      this.openModal(['MapModal' + this.SITE_CONFIG.site, {
        locationId: unit.facility ? unit.facility.id : null,
        areaId: unit.pool.id,
        type: 'view'
      }]);
    },
    goBack: function goBack() {
      window.history.go(-1);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['favoriteAccommodations', 'isAwaitingFilter']))
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_accomodationIndex__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accomodationTimelineSteps__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_OutlineButton__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_components_OutlineButton__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline___default.a,
    CounterButton: __WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton___default.a,
    OutlineButton: __WEBPACK_IMPORTED_MODULE_12__components_components_OutlineButton___default.a,
    AccomodationPeriodConfirm: __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_accomodationIndex__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_accomodationTimelineSteps__["a" /* default */]],
  data: function data() {
    return {
      unit: {},
      adults: 0,
      seniors: 0,
      youths: 0,
      children: 0,
      cartObject: {},
      externalCheck: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.adults = _this.cartAccomodationObject.adults;
              _this.seniors = _this.cartAccomodationObject.seniors || 0;
              _this.youths = _this.cartAccomodationObject.youths;
              _this.children = _this.cartAccomodationObject.children;

              _this.$nextTick(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_3__classes_API__["a" /* default */].get('/units/' + _this.poolLid + '/' + _this.unitLid + '/info');

                      case 2:
                        _ref2 = _context.sent;
                        data = _ref2.data;

                        _this.unit = data;

                        window.trackViewItem({
                          title: _this.unit.description_title,
                          lines: [{
                            id: _this.unit.unit_code || _this.unit.name_corrected,
                            title: _this.unit.description_title,
                            category: 'accomodation',
                            category2: _this.unit && _this.unit.pool ? _this.unit.pool.name : '',
                            quantity: 1,
                            price: _this.cartAccomodationObject.price
                          }]
                        });

                      case 6:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              })));

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['cart']), {
    noOfVisitors: function noOfVisitors() {
      return this.adults + this.seniors + this.youths + this.children;
    },
    cartAccomodationObject: function cartAccomodationObject() {
      if (this.cart.accomodations[this.accomodationIndex]) {
        return this.cart.accomodations[this.accomodationIndex];
      }
      return {};
    },
    poolLid: function poolLid() {
      return this.cartAccomodationObject.poolLid;
    },
    unitLid: function unitLid() {
      return this.cartAccomodationObject.unitLid;
    },
    arrival: function arrival() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        return this.cartAccomodationObject.period.date_arrival;
      }
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.$store.state.accomodationsFilter.date.startDate).format('YYYY-MM-DD');
    },
    departure: function departure() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        return this.cartAccomodationObject.period.date_departure;
      }
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.$store.state.accomodationsFilter.date.endDate).format('YYYY-MM-DD');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapMutations */])(['confirmAccomodation', 'openModal', 'closeModal', 'saveCartLocking']), {
    setExternalSuccess: function setExternalSuccess(period) {
      this.externalCheck = period.available;
    },
    showModal: function showModal() {
      return this.$route.params.pool;
    },
    noOfDays: function noOfDays() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        var a = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.cartAccomodationObject.period.date_arrival);
        var b = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.cartAccomodationObject.period.date_departure);
        return b.diff(a, 'days') + 1;
      }

      return 0;
    },
    addToCart: function addToCart() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var $this, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this2.noOfVisitors <= 0)) {
                  _context3.next = 3;
                  break;
                }

                _this2.openModal(['GeneralModal', {
                  title: 'Välj antal personer',
                  content: '<p>För att det ska bli lättare i nästa steg behöver du välja hur många personer i olika åldrar ni är.</p>'
                }]);
                return _context3.abrupt('return', false);

              case 3:
                $this = _this2;
                url = '/units/' + _this2.unit.pool_lid + '/' + _this2.unit.unit_lid + '/reserve/' + _this2.arrival + '/' + _this2.departure;


                if (_this2.$store.state.lockingCode) {
                  url = url + '/' + _this2.$store.state.lockingCode;
                }

                __WEBPACK_IMPORTED_MODULE_3__classes_API__["a" /* default */].get(url).then(function (result) {
                  if (!result.success) {
                    $this.openModal(['GeneralModal', {
                      title: 'Bokningstillgänglighet',
                      content: '<p>' + result.reason + '</p>',
                      buttons: [{
                        title: 'Okej',
                        class: '',
                        click: function click() {
                          $this.closeModal();
                        }
                      }]
                    }]);
                    return false;
                  }

                  _this2.saveCartLocking({
                    code: result.code,
                    beforeTime: result.before_time
                  });

                  if (_this2.noOfVisitors > _this2.cartAccomodationObject.capacity) {
                    $this.openModal(['GeneralModal', {
                      title: 'Många resenärer',
                      content: '<p>Du har valt att ni \xE4r totalt ' + _this2.noOfVisitors + ' personer. Detta boende har kapacitet f\xF6r ' + _this2.cartAccomodationObject.capacity + ' personer.</p>',
                      buttons: [{
                        title: 'Okej, ändra',
                        class: 'small',
                        click: function click() {
                          $this.closeModal();
                        }
                      }]
                    }]);
                  } else {
                    _this2.moveOn();
                  }

                  return true;
                });

                return _context3.abrupt('return', true);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    trackCart: function trackCart() {
      window.trackAddToCart({
        title: this.cartAccomodationObject.description_title,
        lines: [{
          id: this.cartAccomodationObject.unit_code,
          title: this.cartAccomodationObject.description_title,
          category: 'accomodation',
          category2: this.cartAccomodationObject.pool_name || '',
          quantity: 1,
          price: this.cartAccomodationObject.price
        }]
      });
    },
    moveOn: function moveOn() {
      var _this3 = this;

      this.closeModal();

      var confirmed = this.cart.accomodations.filter(function (a) {
        return a.confirmed;
      });
      var datesOkay = !confirmed.length || confirmed[0].period.date_arrival === this.cartAccomodationObject.period.date_arrival && confirmed[0].period.date_departure === this.cartAccomodationObject.period.date_departure;

      if (!datesOkay) {
        var $this = this;
        this.openModal(['GeneralModal', {
          content: 'Du är på väg att boka ett andra boende. Detta måste bokas under samma period som ditt första.',
          buttons: [{
            title: 'Okej, låt mig ändra datum',
            click: function click() {
              $this.trackCart();
              $this.$router.push({
                path: '/boenden/bekrafta/pris/' + _this3.unit.slug + '?flow=boenden%2Fbekrafta'
              });
              $this.closeModal();
            },
            class: 'small'
          }, {
            title: 'Gå till varukorgen',
            click: function click() {
              $this.$router.push({ name: 'shopping cart' });
              $this.closeModal();
            },
            class: 'small white border'
          }]
        }]);

        return false;
      }

      this.confirmAccomodation({
        index: this.accomodationIndex,
        adults: this.adults,
        seniors: this.seniors,
        youths: this.youths,
        children: this.children,
        days: this.noOfDays()
      });

      this.trackCart();

      this.$router.push({ name: 'addons', query: { no: this.accomodationIndex } });
      return true;
    },
    changeAdults: function changeAdults(value) {
      this.adults = value;
    },
    changeSeniors: function changeSeniors(value) {
      this.seniors = value;
    },
    changeYouths: function changeYouths(value) {
      this.youths = value;
    },
    changeChildren: function changeChildren(value) {
      this.children = value;
    },
    validated: function validated() {
      return this.externalCheck && this.noOfVisitors;
    }
  })
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_List_Filter_AccomodationsFilter__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_List_Filter_AccomodationsFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_List_Filter_AccomodationsFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_parts_Accomodation_List_AccomodationsList__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_parts_Accomodation_List_AccomodationsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_parts_Accomodation_List_AccomodationsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_parts_Accomodation_List_Filter_AccomodationsFilterInfo__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_parts_Accomodation_List_Filter_AccomodationsFilterInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_parts_Accomodation_List_Filter_AccomodationsFilterInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_TextInput__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_Note__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_accomodationTimelineSteps__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(3);



























var someUnit = function someUnit(predicate) {
  return function (pool) {
    return pool && pool.units && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__["some"])(predicate, pool.units);
  };
};

var filterPools = function filterPools(accomodationsFilter) {
  var unitFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* filterUnit */])(accomodationsFilter);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__["flow"])([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__["filter"])(someUnit(unitFilter))]);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AccomodationsFilter: __WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_List_Filter_AccomodationsFilter___default.a,
    AccomodationsFilterInfo: __WEBPACK_IMPORTED_MODULE_10__components_parts_Accomodation_List_Filter_AccomodationsFilterInfo___default.a,
    AccomodationsList: __WEBPACK_IMPORTED_MODULE_9__components_parts_Accomodation_List_AccomodationsList___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_15__components_components_Modal___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_14__components_components_Timeline___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_11__components_components_TextInput___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_12__components_components_Loading___default.a,
    Note: __WEBPACK_IMPORTED_MODULE_13__components_components_Note___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_accomodationTimelineSteps__["a" /* default */]],
  data: function data() {
    return {
      filterObject: {},
      countTotal: 0,
      countMatches: 0,
      pools: [],
      loading: true,
      locations: [],
      cancellationInsuranceEnabled: false
    };
  },
  beforeMount: function beforeMount() {
    if (__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.$store.state.accomodationsFilter.date.startDate).isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()())) {
      console.log('Too early');
      this.$store.state.accomodationsFilter.date.startDate = null;
      this.$store.state.accomodationsFilter.date.endDate = null;
    }

    if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.number) {
      this.$store.state.accomodationsFilter.date.startDate = this.$store.state.cart.addToOrder.dateStart;
      this.$store.state.accomodationsFilter.date.endDate = this.$store.state.cart.addToOrder.dateEnd;
    }

    if (this.$route.meta.view && this.$route.meta.view === 'images') {
      this.$store.state.accomodationView = 'images';
    }

    if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.$route.query).length) {
      this.resetAccomodationsFilter();
    }

    if (this.$route.query.date1) {
      this.$store.state.accomodationsFilter.date.startDate = this.$route.query.date1;
    }
    if (this.$route.query.date2) {
      this.$store.state.accomodationsFilter.date.endDate = this.$route.query.date2;
    }
    if (this.$route.query.people) {
      this.$store.state.accomodationsFilter.beds = parseInt(this.$route.query.people, 10);
    }
    if (this.$route.query.area) {
      this.$store.state.accomodationsFilter.locationId = parseInt(this.$route.query.area, 10);
    }

    this.cancellationInsuranceEnabled = this.SITE_CONFIG.accomodations.cancellation_insurance.free;
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, meta, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.increaseCurrentRequests();
              _this.loading = true;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('/grouped');

            case 4:
              _ref = _context.sent;
              meta = _ref.meta;
              data = _ref.data;

              _this.decreaseCurrentRequests();
              _this.loading = false;
              _this.pools = data;
              _this.locations = meta.locations;

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["a" /* mapMutations */])(['increaseCurrentRequests', 'decreaseCurrentRequests', 'currentRequests', 'changeFreeSearch', 'openModal', 'resetAccomodationsFilter']), {
    showModal: function showModal() {
      return this.$route.params.pool;
    },
    checkForModals: function checkForModals($this) {
      if (!$this.$route) {
        return;
      }
      if ($this.$route.name === 'accomodation price') {
        $this.openModal(['UnitPriceModal', {
          pool_lid: $this.$route.params.poolId,
          unit_lid: $this.$route.params.unitId
        }]);
      }
      if ($this.$route.name === 'accomodation info' || $this.$route.name === 'accomodation info with price') {
        if ($this.$route.name === 'accomodation info with price') {
          $this.openModal(['UnitInfoModal', {
            pool_lid: $this.$route.params.poolId,
            unit_lid: $this.$route.params.unitId,
            arrival: $this.$route.params.arrival,
            departure: $this.$route.params.departure
          }]);
        } else {
          $this.openModal(['UnitInfoModal', {
            pool_lid: $this.$route.params.poolId,
            unit_lid: $this.$route.params.unitId
          }]);
        }
      }
    },
    goToNormal: function goToNormal() {
      this.$store.state.accomodationView = '';
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapGetters */])(['getFreeSearch', 'isAwaitingFilter']), {
    filteredPools: function filteredPools() {
      return filterPools(this.$store.state.accomodationsFilter)(this.pools);
    },
    unitCount: function unitCount() {
      var unitFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* filterUnit */])(this.$store.state.accomodationsFilter);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__["sumBy"])(function (pool) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__["filter"])(unitFilter, pool.units).length;
      }, this.filteredPools);
    },
    poolCount: function poolCount() {
      return this.filteredPools.length;
    }
  })
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Slideshow__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accomodationIndex__ = __webpack_require__(51);
















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default.a,
    UnitFacts: __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts___default.a,
    AccomodationPeriodConfirm: __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default.a,
    Vimeo: __WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_10__components_components_Loading___default.a,
    Slideshow: __WEBPACK_IMPORTED_MODULE_9__components_components_Slideshow___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accomodationIndex__["a" /* default */]],
  data: function data() {
    return {
      activeTab: 'info',
      unit: null,
      loaded: false,
      period: null,
      arrival: null,
      departure: null,
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _query, data, query;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$route.query.no === undefined || _this.$route.query.no === '') {
                _query = _this.$route.query;

                _query.no = _this.currentRealAccomodationIndex;

                setTimeout(function () {
                  _this.$router.replace({
                    name: _this.$route.name,
                    query: _query
                  });
                }, 1);
              }

              _this.loading = true;
              data = {};
              query = '?arrival=' + _this.$route.params.arrival + '&departure=' + _this.$route.params.departure;

              if (!_this.$route.params.slug) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/units/' + _this.$route.params.slug + '/info' + query);

            case 7:
              data = _context.sent;
              _context.next = 13;
              break;

            case 10:
              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/units/' + _this.$route.params.poolId + '/' + _this.$route.params.unitId + '/info' + query);

            case 12:
              data = _context.sent;

            case 13:

              _this.loaded = true;
              _this.unit = data.data;

              _this.arrival = _this.$route.params.arrival;
              _this.departure = _this.$route.params.departure;
              _this.loading = false;

              if (_this.$route.meta.view && _this.$route.meta.view === 'images') {
                _this.activeTab = 'images';
                _this.$store.state.accomodationView = 'images';
              }

              window.trackViewItem({
                title: _this.unit.description_title,
                lines: [{
                  id: _this.unit.unit_code || _this.unit.name_corrected,
                  title: _this.unit.description_title,
                  category: 'accomodation',
                  category2: _this.unit && _this.unit.pool ? _this.unit.pool.name : '',
                  quantity: 1,
                  price: _this.unit.lowest_price
                }]
              });

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['confirmedAccomodations', 'favoriteAccommodations'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setPeriod: function setPeriod(period) {
      if (period.available) {
        this.period = period;
      } else {
        this.period = null;
      }
    },
    closeModalLocal: function closeModalLocal() {
      if (this.$route.query.flow) {
        this.$router.push({ path: '/' + this.$route.query.flow });
      } else {
        this.$router.go(-1);
      }
    },
    setTab: function setTab(tab) {
      if (tab === 'map') {
        this.openModal(['MapModal' + this.SITE_CONFIG.site, {
          locationId: this.unit.facility ? this.unit.facility.id : null,
          areaId: this.unit.pool ? this.unit.pool.id : null,
          map_link: this.unit.pool.map_link
        }]);
      } else {
        this.activeTab = tab;
      }
    },
    openPriceList: function openPriceList(unit) {
      var url = encodeURIComponent('boenden/info/' + unit.slug);
      this.$router.push({ path: '/boenden/pris/' + unit.slug + '?flow=' + url });
    },
    isFavorite: function isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    toggleFavorite: function toggleFavorite(unitId) {
      var _this2 = this;

      var index = this.favoriteAccommodations.indexOf(unitId);
      if (index > -1) {
        this.removeFavorite(index);
      } else {
        var $this = this;
        var favoriteCount = this.favoriteAccommodations.length;
        if (favoriteCount >= 3) {
          this.openModal(['GeneralModal', {
            title: 'Max 3 favoritboenden',
            content: '<p>Du kan endast spara 3 favoritboenden.</p>',
            buttons: [{
              title: 'Okej',
              class: 'small',
              click: function click() {
                $this.closeModal();
              }
            }]
          }]);
        } else {
          this.addFavorite(unitId);
          if (favoriteCount === 2) {
            this.openModal(['GeneralModal', {
              title: '3 favoriter',
              content: 'Du har nu 3 favoriter tillagda för jämförelse, du kan inte lägga till fler. Vill du jämföra dem nu?',
              buttons: [{
                title: 'Ja, jämför',
                class: '',
                click: function click() {
                  _this2.$router.push({ name: 'compare-accomodations' });
                }
              }, {
                title: 'Nej, fortsätt leta',
                class: 'white border',
                click: function click() {
                  _this2.closeModal();
                }
              }]
            }]);
          }
        }
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal', 'openModal', 'accomodationPeriodPick', 'accomodationPeriodPick', 'closeModal', 'closeAllModals', 'openModal', 'pickAccomodation', 'addFavorite', 'removeFavorite']), {
    didChooseAccomodation: function didChooseAccomodation(payload) {
      var p = payload;
      p.unit = this.unit;
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      var no = this.currentRealAccomodationIndex;
      if (no === -1) {
        no = this.$store.state.cart.accomodations.filter(function (accomodation) {
          return accomodation.confirmed;
        }).length;
      }
      p.no = no;

      console.log(no);
      console.log(p);

      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;

      this.pickAccomodation(p);

      this.$router.push({ name: 'confirm-accomodation', query: { d: new Date().getTime(), no: no } });
    },
    chooseAccomodation: function chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    nl2br: function nl2br(input) {
      var breakTag = '<br>';
      return input.toString().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    goToNormal: function goToNormal() {
      this.$store.state.accomodationView = '';
      this.closeModalLocal();
    }
  })
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_DatepickerRangeModal__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_DatepickerRangeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_DatepickerRangeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_deprecated_OutlineButton__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_deprecated_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_deprecated_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_accomodationIndex__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_popperjs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_popperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_popperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_popperjs_dist_css_vue_popper_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_popperjs_dist_css_vue_popper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_popperjs_dist_css_vue_popper_css__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_components_Modal___default.a,
    popper: __WEBPACK_IMPORTED_MODULE_14_vue_popperjs___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default.a,
    DatepickerRangeModal: __WEBPACK_IMPORTED_MODULE_9__components_modals_DatepickerRangeModal___default.a,
    OutlineButton: __WEBPACK_IMPORTED_MODULE_12__components_deprecated_OutlineButton___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_accomodationIndex__["a" /* default */]],
  data: function data() {
    return {
      unit: null,
      meta_periods: null,
      meta_special: null,
      meta_weeks: null,
      meta_super_titles: null,
      meta_super_titles_colspan: null,
      indexes: [],
      meta_updated: null,
      loaded: false,
      loading: false,
      firstPrice: {},
      cartAccomodationObject: {},
      activeTab: 1,
      validStartDatesSummer: [],
      validStartDatesWinter: [],
      validStartDatesNextWinter: [],
      disabledDays: [],
      specialDays: [],
      calendarOpen: false,
      winterCalendarOpen: false,
      summerCalendarOpen: false,
      nextWinterCalendarOpen: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var query, _ref, data;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (typeof _this.$route.query.no === 'undefined' || _this.$route.query.no === '') {
                query = _this.$route.query;

                query.no = _this.currentRealAccomodationIndex;

                setTimeout(function () {
                  _this.$router.replace({
                    name: _this.$route.name,
                    query: query
                  });
                }, 1);
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get('/dates/valid-start-dates?view=object&accomodation=' + _this.$route.params.slug);

            case 3:
              _ref = _context.sent;
              data = _ref.data;


              __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(data).forEach(function (element) {
                if (element[1].free === 1) {
                  if (element[1].date_arrival >= _this.SITE_CONFIG.season.winter.start && element[1].date_arrival <= _this.SITE_CONFIG.season.winter.end) {
                    _this.validStartDatesWinter.push(element[1].date_arrival);
                  }

                  console.log('next winter active', !!_this.SITE_CONFIG.next_season.winter.is_active);

                  if (!!_this.SITE_CONFIG.next_season.winter.is_active && element[1].date_arrival >= _this.SITE_CONFIG.next_season.winter.start && element[1].date_arrival <= _this.SITE_CONFIG.next_season.winter.end) {
                    console.log('checking next winter');
                    _this.validStartDatesNextWinter.push(element[1].date_arrival);
                  }

                  if (element[1].date_arrival >= _this.SITE_CONFIG.season.summer.start && element[1].date_arrival <= _this.SITE_CONFIG.season.summer.end) {
                    _this.validStartDatesSummer.push(element[1].date_arrival);
                  }
                } else {
                  _this.disabledDays.push(element[1].date_arrival);
                }
              });

              _this.specialDays = _this.SITE_CONFIG.season.summer.special;

              _context.next = 9;
              return _this.loadPrices('null');

            case 9:
              _this.loaded = true;


              if (_this.SITE_CONFIG.site === 'kungsberget') {
                _this.activeTab = 2;
              }

              _this.$nextTick(function () {
                if (_this.confirmedAccomodations.length) {
                  _this.openModal(['SecondAccomodationModal', {
                    unitPreview: _this.unit
                  }]);
                } else if (_this.$store.state.cart.addToOrder && _this.$store.state.cart.addToOrder.dateStart) {
                  _this.openModal(['SecondAccomodationModal', {
                    unitPreview: _this.unit
                  }]);
                }
              });

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    closedMessage: function closedMessage() {
      return this.SITE_CONFIG.modules_open.accomodation.closed_message || this.SITE_CONFIG.closed_message || 'Anläggningen är tyvärr stängd.';
    },
    open: function open() {
      if (typeof this.SITE_CONFIG.modules_open.accomodation.open !== 'undefined') {
        return this.SITE_CONFIG.modules_open.accomodation.open;
      }
      return this.SITE_CONFIG.is_open;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['confirmedAccomodations', 'cart']), {
    editing: function editing() {
      return !isNaN(parseInt(this.$route.query.no, 10));
    },
    confirmedAccomodations: function confirmedAccomodations() {
      return this.cart.accomodations.filter(function (a) {
        return a.confirmed;
      });
    },
    validPeriod: function validPeriod() {
      var index = this.$route.query.no;
      if (typeof index === 'undefined') {
        index = -1;
      }

      var confirmedAccomodations = this.cart.accomodations.filter(function (a, i) {
        return a.confirmed && parseInt(index, 10) !== i;
      });

      var validPeriod = '';
      if (confirmedAccomodations.length) {
        validPeriod = confirmedAccomodations[0].period.date_arrival + '-' + confirmedAccomodations[0].period.date_departure;
      }

      return validPeriod;
    },
    sortedSpecialPrices: function sortedSpecialPrices() {
      var specialPrices = null;
      var newArray = [];
      specialPrices = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.unit.prices_special);

      for (var i in specialPrices) {
        if (specialPrices[i]) {
          newArray.push(specialPrices[i]);
        }
      }

      newArray.sort(function (a, b) {
        if (!a.period) {
          return 0;
        }

        if (a.period.date_arrival < b.period.date_arrival) {
          return -1;
        }

        if (a.period.date_arrival > b.period.date_arrival) {
          return 1;
        }

        if (a.period.date_departure < b.period.date_departure) {
          return -1;
        }

        if (a.period.date_departure > b.period.date_departure) {
          return 1;
        }

        return 0;
      });

      return newArray;
    },
    notes: function notes() {
      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      }

      var notes = [];

      for (var i in this.unit.prices) {
        for (var ii in this.unit.prices[i].periods) {
          var note = this.unit.prices[i].periods[ii].note;
          if (note) {
            notes.push(note);
          }
        }
      }

      return notes.filter(onlyUnique);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    setTab: function setTab(tab) {
      this.activeTab = tab;
    },
    belongsToCol: function belongsToCol(index) {
      return this.indexes[index] + 1;
    },
    loadPrices: function loadPrices(type) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, urlInfo, _ref2, _data, _ref3, data, firstKey, currentAccomodationIndex, iterator;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                url = '/units/' + _this2.$route.params.poolId + '/' + _this2.$route.params.unitId + '/prices';


                if (_this2.$route.params.slug) {
                  url = '/units/' + _this2.$route.params.slug + '/prices';
                }

                if (!(type === 'refresh')) {
                  _context2.next = 7;
                  break;
                }

                url = url + '/refresh';
                _context2.next = 14;
                break;

              case 7:
                urlInfo = '/units/' + _this2.$route.params.poolId + '/' + _this2.$route.params.unitId + '/info';

                if (_this2.$route.params.slug) {
                  urlInfo = '/units/' + _this2.$route.params.slug + '/info';
                }
                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get(urlInfo);

              case 11:
                _ref2 = _context2.sent;
                _data = _ref2.data;

                _this2.unit = _data;

              case 14:
                _context2.next = 16;
                return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get(url);

              case 16:
                _ref3 = _context2.sent;
                data = _ref3.data;


                _this2.unit = data.accomodations;
                _this2.meta_periods = data.meta_periods;
                _this2.meta_special = data.meta_special;
                _this2.meta_weeks = data.meta_weeks;
                _this2.meta_super_titles = data.meta_super_titles;
                _this2.meta_super_titles_colspan = data.meta_super_titles_colspan;
                _this2.meta_updated = data.meta_updated;
                firstKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this2.unit.prices)[10];

                _this2.firstPrice = _this2.unit.prices[firstKey];

                if (_this2.$store.state.tempCartAccomodation && _this2.$store.state.tempCartAccomodation.type) {
                  _this2.cartAccomodationObject = _this2.$store.state.tempCartAccomodation;
                } else {
                  currentAccomodationIndex = _this2.currentRealAccomodationIndex;

                  if (currentAccomodationIndex > -1) {
                    _this2.cartAccomodationObject = _this2.cart.accomodations[currentAccomodationIndex];
                  }
                }

                _this2.indexes = [];
                iterator = 0;

                _this2.meta_super_titles_colspan.forEach(function (v) {
                  var i = _this2.indexes.length;
                  var end = _this2.indexes.length + parseInt(v, 10);
                  while (i < end) {
                    _this2.indexes.push(iterator);
                    i += 1;
                  }
                  iterator += 1;
                });

                if (type === 'refresh') {
                  _this2.loaded = true;
                }

                _this2.loading = false;

                window.trackViewItem({
                  title: _this2.unit.description_title,
                  lines: [{
                    id: _this2.unit.unit_code || _this2.unit.name_corrected,
                    title: _this2.unit.description_title,
                    category: 'accomodation',
                    category2: _this2.unit && _this2.unit.pool ? _this2.unit.pool.name : '',
                    quantity: 1,
                    price: _this2.unit.lowest_price
                  }]
                });

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateEndDate: function updateEndDate(value) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var formatted, _ref4, data, validEndDates, inValidEndDates;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                formatted = __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).format('YYYY-MM-DD');
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get('/dates/valid-end-dates/' + formatted + '?view=object&accomodation=' + _this3.$route.params.slug);

              case 3:
                _ref4 = _context3.sent;
                data = _ref4.data;
                validEndDates = [];
                inValidEndDates = [];

                __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(data).forEach(function (element) {
                  if (element[1].free === 1) {
                    validEndDates.push(element[1].date_departure);
                  } else {
                    inValidEndDates.push(element[1].date_departure);
                  }
                });

                return _context3.abrupt('return', {
                  valid: validEndDates,
                  invalid: inValidEndDates
                });

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onPicked: function onPicked(a, b, c, d) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var $this, start, end, diff, includesClosedDate, i, dateToCheck;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                $this = _this4;
                start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(a);
                end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(b);
                diff = end.diff(start, 'days');
                includesClosedDate = false;
                i = 0;


                while (i <= diff) {
                  dateToCheck = start.clone().add(i, 'days').format('YYYY-MM-DD');

                  console.log(dateToCheck);

                  if (_this4.SITE_CONFIG.season.summer.special.indexOf(dateToCheck) === -1) {
                    includesClosedDate = true;
                  }

                  i += 1;
                }

                if (d && includesClosedDate) {
                  _this4.openModal(['SummerConfirmationModal', {
                    startDate: a,
                    endDate: b,
                    click: function click() {
                      $this.doChangeEndDate(a, b);
                    },
                    cancel: function cancel() {
                      console.log('Closing');
                    }
                  }]);

                  _this4.openModal(['GeneralModal', {}]);
                } else {
                  _this4.doChangeEndDate(a, b);
                }

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    doChangeEndDate: function doChangeEndDate(a, b) {
      var _this5 = this;

      console.log('Period selected');
      console.log(a, b);

      var url = '/units/' + this.unit.pool_lid + '/' + this.unit.unit_lid + '/prices';

      var start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(a).format('YYYY-MM-DD');
      var end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(b).format('YYYY-MM-DD');

      url = url + '/' + start + '/' + end;

      __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get(url).then(function (payload) {
        var period = null;

        for (var _i in payload.data.accomodations.prices) {
          if (payload.data.accomodations.prices[_i]) {
            period = payload.data.accomodations.prices[_i];
          }
        }

        for (var _i2 in payload.data.accomodations.prices_summer) {
          if (payload.data.accomodations.prices_summer[_i2]) {
            period = payload.data.accomodations.prices_summer[_i2];
          }
        }

        for (var _i3 in payload.data.accomodations.prices_extra) {
          if (payload.data.accomodations.prices_extra[_i3]) {
            period = payload.data.accomodations.prices_extra[_i3].period;
          }
        }

        for (var _i4 in payload.data.accomodations.prices_special) {
          if (payload.data.accomodations.prices_special[_i4]) {
            period = payload.data.accomodations.prices_special[_i4].period;
          }
        }

        if (!period) {
          return false;
        }

        _this5.chooseAccomodation({
          pool_lid: _this5.unit.pool_lid,
          unit_lid: _this5.unit.unit_lid,
          period: period,
          week: period.week,
          name: _this5.unit.display_name || _this5.unit.description_title,
          capacity: _this5.unit.capacity,
          price: period.price
        });

        return true;
      });
    },
    moment: function moment(d) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(d);
    },
    closeModalLocal: function closeModalLocal() {
      if (this.$route.query.flow) {
        if (this.$route.query.flow.substr(0, 12) === 'boenden/info') {
          this.$router.push({ path: '/' + this.$route.query.flow + '?flow=boenden&no=' + this.$route.query.no });
        } else {
          this.$router.push({ path: '/' + this.$route.query.flow + '?no=' + this.$route.query.no });
        }
      } else {
        this.$router.push({ path: '/boenden?no=' + this.$route.query.no });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'pickAccomodation']), {
    didChooseAccomodation: function didChooseAccomodation(payload) {
      var no = this.currentRealAccomodationIndex;
      var p = payload;

      p.unit = this.unit;
      p.no = parseInt(this.$route.query.no, 10);

      if (p.no === -1) {
        no = this.$store.state.cart.accomodations.filter(function (a) {
          return a.confirmed;
        }).length;
      } else {
        no = p.no;
      }

      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;

      this.pickAccomodation(p);
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      var url = this.$route.path.substr(1);

      if (this.$route.query.flow === 'boenden') {
        var arrival = __WEBPACK_IMPORTED_MODULE_11_moment___default()(payload.period.date_arrival).format('YYYY-MM-DD');
        var departure = __WEBPACK_IMPORTED_MODULE_11_moment___default()(payload.period.date_departure).format('YYYY-MM-DD');
        this.$router.push({ path: '/boenden/info/' + this.unit.slug + '/' + arrival + '/' + departure + '?flow=' + url, query: { no: no } });
      } else {
        this.$router.push({ name: 'confirm-accomodation', query: { no: no } });
      }
    },
    chooseAccomodation: function chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    showDates: function showDates(periods) {
      var lines = [];
      lines = [];
      this.meta_periods.forEach(function (period) {
        if (periods['_' + period.period_dbid].date_arrival && periods['_' + period.period_dbid].date_departure) {
          var arrival = __WEBPACK_IMPORTED_MODULE_11_moment___default()(periods['_' + period.period_dbid].date_arrival).format('D/M');
          var departure = __WEBPACK_IMPORTED_MODULE_11_moment___default()(periods['_' + period.period_dbid].date_departure).format('D/M');
          if (!periods['_' + period.period_dbid].hide) {
            lines.push('<b>' + period.days + ':</b> ' + arrival + ' - ' + departure);
          }
        }
      });

      return lines.join('<br>');
    },
    toggleCalendar: function toggleCalendar() {
      this.calendarOpen = !this.calendarOpen;
    },
    toggleWinterCalendar: function toggleWinterCalendar() {
      this.winterCalendarOpen = !this.winterCalendarOpen;
      if (this.winterCalendarOpen) {
        this.summerCalendarOpen = false;
        this.nextWinterCalendarOpen = false;
      }
    },
    toggleSummerCalendar: function toggleSummerCalendar() {
      this.summerCalendarOpen = !this.summerCalendarOpen;
      if (this.summerCalendarOpen) {
        this.winterCalendarOpen = false;
        this.nextWinterCalendarOpen = false;
      }
    },
    toggleNextWinterCalendar: function toggleNextWinterCalendar() {
      this.nextWinterCalendarOpen = !this.nextWinterCalendarOpen;
      console.log(this.nextWinterCalendarOpen);
      if (this.nextWinterCalendarOpen) {
        this.summerCalendarOpen = false;
        this.winterCalendarOpen = false;
      }
    },
    startMonth: function startMonth(season) {
      var now = __WEBPACK_IMPORTED_MODULE_11_moment___default()().format('YYYY-MM-DD');
      var date = now;

      if (season === 'winter') {
        var length = this.validStartDatesWinter.length;
        date = length ? this.validStartDatesWinter[0] : now;
      } else if (season === 'next_winter') {
        var _length = this.validStartDatesNextWinter.length;
        date = _length ? this.validStartDatesNextWinter[0] : now;
      } else if (season === 'summer') {
        var _length2 = this.validStartDatesSummer.length;
        date = _length2 ? this.validStartDatesSummer[0] : now;
      }

      return Math.max(now, date);
    },
    getButtonOrderFor: function getButtonOrderFor(season) {
      var firstWinter = this.validStartDatesWinter.length ? this.validStartDatesWinter[0] : '9999-10-31';
      var firstSummer = this.validStartDatesSummer.length ? this.validStartDatesSummer[0] : '9999-11-31';
      var firstNextWinter = this.validStartDatesNextWinter.length ? this.validStartDatesNextWinter[0] : '9999-12-31';

      var checkValue = '';

      if (season === 'winter') {
        checkValue = firstWinter;
      } else if (season === 'summer') {
        checkValue = firstSummer;
      } else if (season === 'next_winter') {
        checkValue = firstNextWinter;
      }

      var sorted = [firstWinter, firstSummer, firstNextWinter].sort();

      return sorted.indexOf(checkValue) + 1 || 0;
    },
    getButtonLabelFor: function getButtonLabelFor(season) {
      var start = '';
      var end = '';
      var label = 'Datum';

      if (season === 'winter') {
        start = this.SITE_CONFIG.season.winter.start;
        end = this.SITE_CONFIG.season.winter.end;
        label = 'Vinter';
      } else if (season === 'summer') {
        start = this.SITE_CONFIG.season.summer.start;
        end = this.SITE_CONFIG.season.summer.end;
        label = 'Sommar';
      } else if (season === 'next_winter') {
        start = this.SITE_CONFIG.next_season.winter.start;
        end = this.SITE_CONFIG.next_season.winter.end;
        label = 'Vinter';
      }

      var yearStart = __WEBPACK_IMPORTED_MODULE_11_moment___default()(start).format('YYYY');
      var yearEnd = __WEBPACK_IMPORTED_MODULE_11_moment___default()(end).format('YYYY');

      if (yearStart === yearEnd) {
        return label + ' ' + yearStart;
      }

      return label + ' ' + yearStart + '/' + yearEnd;
    }
  }),
  filters: {
    weekday: function weekday(dt) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(dt).format('ddd');
    },
    dt: function dt(_dt) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(_dt).format('D[/]M');
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_accomodationTimelineSteps__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_accomodationIndex__ = __webpack_require__(51);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addonspage',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline___default.a,
    SwitchButton: __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_accomodationTimelineSteps__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_accomodationIndex__["a" /* default */]],
  data: function data() {
    return {
      cartAccomodationObject: {},
      cartSkipassObject: {},
      showingSkipassModal: false,
      adultDays: 0,
      youthDays: 0,
      childrenDays: 0,
      adults: 0,
      youths: 0,
      children: 0,
      addons: [],
      adultPricelistPrice: 0,
      youthPricelistPrice: 0,
      cancellationInsurance: null,
      markInsurance: false,
      markLate: false,
      cancellationInsuranceObject: {},
      lateArrivalObject: {},
      lateArrival: null,
      cancellationInsuranceEnabled: false,
      groceryBags: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.name === 'addons') {
      if (!this.cart.accomodations.length) {
        this.$router.replace({ name: 'accomodation list' });
        return;
      }

      if (!this.cart.accomodations[0].confirmed) {
        this.$router.replace({ name: 'confirm-accomodation' });
        return;
      }
    }

    this.$nextTick(function () {
      var currentSkipassIndex = -1;
      var $this = _this;
      _this.cart.skipasses.forEach(function (skipass, index) {
        if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === $this.accomodationIndex && skipass.confirmed) {
          currentSkipassIndex = index;
        }
      });

      if (currentSkipassIndex === -1 && _this.SITE_CONFIG.accomodations.skipass_campaign_active && $this.$route.name !== 'addons extra') {
        _this.openModal(['AccomodationSkipass', {}]);
      }
    });

    var currentAccomodationIndex = this.accomodationIndex;

    if (!this.isAddonBooking) {
      this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];
    } else {
      this.cartAccomodationObject = {
        poolLid: this.$route.query.pool,
        unitLid: this.$route.query.unit,
        period: {
          date_arrival: this.$route.query.arrival,
          date_departure: this.$route.query.departure
        },
        adults: parseInt(this.$route.query.adults, 10),
        youths: parseInt(this.$route.query.youths, 10),
        children: parseInt(this.$route.query.children, 10),
        seniors: parseInt(this.$route.query.seniors, 10)
      };
    }

    var currentSkipassIndex = this.cart.currentSkipassIndex;

    if (this.$route.name === 'addons') {
      this.cartSkipassObject = this.cart.skipasses[currentSkipassIndex];
    } else if (this.$route.name === 'addons extra') {
      this.cartSkipassObject = {
        adults: parseInt(this.$route.query.adults, 10),
        youths: parseInt(this.$route.query.youths, 10),
        children: parseInt(this.$route.query.children, 10)
      };
    }

    if (this.isAddonBooking) {
      this.cancellationInsuranceEnabled = false;
    } else {
      this.cancellationInsuranceEnabled = true;
    }

    this.getAddons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['cart']), {
    isAddonBooking: function isAddonBooking() {
      return this.$route.name === 'addons extra';
    },
    isSummerSeason: function isSummerSeason() {
      var month = 12;
      try {
        month = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.cartAccomodationObject.period.date_arrival);
      } catch (e) {
        return false;
      }

      if (month.get('month') >= 4 && month.get('month') <= 10) {
        return true;
      }

      return false;
    },
    lateArrivalTime: function lateArrivalTime() {
      if (this.SITE_CONFIG.site === 'kungsberget') {
        return '18:00';
      }

      return '17:00';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    validated: function validated() {
      var cancellation = this.cancellationInsurance === true || this.cancellationInsurance === false;
      var late = this.lateArrival === true || this.lateArrival === false;

      if (this.isAddonBooking) {
        cancellation = true;
      }

      if (!this.lateArrivalObject) {
        late = true;
      }

      if (!this.cancellationInsuranceEnabled || !this.cancellationInsuranceObject) {
        cancellation = true;
      }

      return cancellation && late;
    },
    icon: function icon(_icon) {
      var icons = {
        1022: 'linneset',
        1031: 'stadning',
        1027: 'barnsang',
        1025: 'barnstol',
        1156: 'baddning' };

      return icons[_icon] ? icons[_icon] : 'none';
    },
    getAddons: function getAddons() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, _ref, data, meta_skipasses, cancellationInsurance, lateArrival, groceryBags, $this, cancelIndex, arrivalIndex;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/units/' + _this2.cartAccomodationObject.poolLid + '/' + _this2.cartAccomodationObject.unitLid + '/addons/' + _this2.cartAccomodationObject.period.date_arrival + '/' + _this2.cartAccomodationObject.period.date_departure + '/' + _this2.cartAccomodationObject.adults + '/' + _this2.cartAccomodationObject.youths + '/' + _this2.cartAccomodationObject.children + '/' + _this2.cartAccomodationObject.seniors;


                if (_this2.$store.state.cart.addToOrder && _this2.$store.state.cart.addToOrder.numeric) {
                  url = url + '?order=' + _this2.$store.state.cart.addToOrder.numeric + '&order-line-group=' + _this2.$store.state.cart.addToOrder.accomodationGroup;
                }
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get(url);

              case 4:
                _ref = _context.sent;
                data = _ref.data;
                meta_skipasses = _ref.meta_skipasses;
                cancellationInsurance = _ref.cancellationInsurance;
                lateArrival = _ref.lateArrival;
                groceryBags = _ref.groceryBags;
                $this = _this2;

                _this2.addons = data.map(function (addon) {
                  var a = addon;
                  a.qtySelected = 1;


                  var index = _this2.cart.addons.findIndex(function (localAddon) {
                    return localAddon.lid === a.lid && localAddon.belongsTo === $this.accomodationIndex;
                  });

                  a.added = index !== -1;

                  if (a.added) {
                    a.qtySelected = _this2.cart.addons[index].quantity;
                  }

                  if (a.auto === 'T' && !_this2.isAddonBooking) {
                    if (!a.added) {
                      _this2.chooseArticle(addon, true);
                    }
                  }

                  if (!addon.added && addon.max_qty > 1 && !addon.single_count) {
                    a.qtySelected = _this2.cartSkipassObject.adults + _this2.cartSkipassObject.youths + _this2.cartSkipassObject.children + (_this2.cartSkipassObject.seniors || 0);

                    if (a.default_qty) {
                      a.qtySelected = a.default_qty;
                    }
                  }

                  if (!addon.added && addon.included) {
                    a.qtySelected = 0;
                  }

                  return a;
                });

                _this2.groceryBags = groceryBags.map(function (addon) {
                  var a = addon;
                  a.qtySelected = 1;

                  var index = _this2.cart.addons.findIndex(function (localAddon) {
                    return localAddon.lid === a.lid && localAddon.belongsTo === $this.accomodationIndex;
                  });

                  a.added = index !== -1;

                  return a;
                });

                _this2.lateArrivalObject = lateArrival;
                _this2.cancellationInsuranceObject = cancellationInsurance;

                cancelIndex = _this2.cart.addons.findIndex(function (localAddon) {
                  return localAddon.lid === $this.cancellationInsuranceObject.lid && localAddon.belongsTo === $this.accomodationIndex;
                });


                if (cancelIndex !== -1) {
                  _this2.cancellationInsurance = true;
                }

                if (!_this2.isAddonBooking && _this2.cancellationInsuranceObject && _this2.cancellationInsuranceObject.free) {
                  _this2.cancellationInsurance = true;
                  _this2.unmarkInsuranceError();
                }

                arrivalIndex = _this2.cart.addons.findIndex(function (localAddon) {
                  return localAddon.lid === $this.lateArrivalObject.lid && localAddon.belongsTo === $this.accomodationIndex;
                });


                if (arrivalIndex !== -1) {
                  _this2.lateArrival = true;
                }

                if (meta_skipasses.adult.separate_days) {
                  _this2.adultPricelistPrice = Math.round(parseFloat(meta_skipasses.adult.separate_days.aprice, 10));
                } else if (meta_skipasses.adult.week) {
                  _this2.adultPricelistPrice = Math.round(parseFloat(meta_skipasses.adult.week.aprice, 10));
                } else {
                  _this2.adultPricelistPrice = 0;
                }

                if (meta_skipasses.youth.separate_days) {
                  _this2.youthPricelistPrice = Math.round(parseFloat(meta_skipasses.youth.separate_days.aprice, 10));
                } else if (meta_skipasses.youth.week) {
                  _this2.youthPricelistPrice = Math.round(parseFloat(meta_skipasses.youth.week.aprice, 10));
                } else {
                  _this2.youthPricelistPrice = 0;
                }

                _this2.cartSkipassObject.adultsPrice = _this2.adultPricelistPrice;
                _this2.cartSkipassObject.youthsPrice = _this2.youthPricelistPrice;

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['confirmSkipasses', 'unconfirmSkipasses', 'addAddon', 'removeAddon', 'addSkipasses', 'openModal', 'closeModal']), {
    doChooseArticle: function doChooseArticle(addon) {
      addon.added = true;
      addon.belongsTo = this.accomodationIndex;
      addon.locked = addon.auto === 'T';

      if (this.isAddonBooking) {
        addon.belongsTo = -2;
      }

      this.addAddon(addon);
    },
    chooseArticle: function chooseArticle(addon, force) {
      var $this = this;

      if (force) {
        $this.doChooseArticle(addon);
      }

      if (addon.qtySelected) {
        if (addon.rut) {
          this.openModal(['RutModal', {
            click: function click() {
              $this.doChooseArticle(addon);
            },
            cancel: function cancel() {
              $this.doChooseArticle(addon);
            }
          }]);
        } else if (addon.included) {
          this.openModal(['IncludedInPriceModal', {
            addon: addon,
            click: function click() {
              $this.doChooseArticle(addon);
            }
          }]);
        } else {
          this.doChooseArticle(addon);
        }
      } else {
        this.openModal(['GeneralModal', {
          title: 'Välj antal',
          content: '<p>Du måste välj hur många du vill ha.</p>'
        }]);
      }
    },
    toggleArticle: function toggleArticle(addon) {
      if (addon.auto === 'T') {
        return false;
      }

      addon.added = !addon.added;

      if (!addon.qtySelected) {
        addon.qtySelected = 1;
      }

      if (addon.added) {
        this.chooseArticle(addon);
      } else {
        this.removeArticle(addon);
      }

      return true;
    },
    removeArticle: function removeArticle(addon) {
      addon.added = false;
      addon.belongsTo = this.accomodationIndex;

      if (this.isAddonBooking) {
        addon.belongsTo = -2;
      }

      this.removeAddon(addon);
    },
    infoPopup: function infoPopup(addon) {
      this.openModal(['AddonInfoModal', {
        addon: addon
      }]);
    },
    next: function next() {
      var $this = this;
      if (this.validated()) {
        if (!this.cancellationInsurance && !this.isAddonBooking) {
          this.openModal(['GeneralModal', {
            title: 'Avbeställningsskydd',
            content: '<p>Du har tackat <b>nej</b> till av- och ombokningsförsäkring.</p><p><b>Du har då inte möjlighet att:</b> <p>Byta boende boka om till annan period eller avboka och få pengarna tillbaka enligt gällande bokningsvillkor.</p>',
            buttons: [{
              title: 'Jag vill ändra',
              class: 'small white border',
              click: function click() {
                $this.closeModal();
              }
            }, {
              title: 'Jag förstår',
              class: 'small',
              click: function click() {
                $this.closeModal();
                $this.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref: 'accomodation' } });
              }
            }]
          }]);
        } else {
          this.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref: 'accomodation' } });
        }
      } else {
        var title = '';
        var content = '';
        if (this.cancellationInsurance !== true && this.cancellationInsurance !== false) {
          title = 'Vill du ha Avbeställningskydd?';
          content = '<p>Du behöver ta ställning till om du vill ha avbeställningsskydd eller inte.</p>';
          $this.markInsurance = true;
        } else if (this.lateArrival !== true && this.lateArrival !== false) {
          title = 'Kommer du sent?';
          content = '<p>Du behöver svara på om du kommer sent till anläggningen eller inte.</p>';
          $this.markLate = true;
        }
        this.openModal(['GeneralModal', {
          title: title,
          content: content,
          buttons: [{
            title: 'Okej, låt mig välja',
            class: 'small',
            click: function click() {
              $this.closeModal();
            }
          }]
        }]);
      }
    },
    openLateCheckinInfo: function openLateCheckinInfo() {
      var $this = this;
      this.openModal(['GeneralModal', {
        title: 'Sen incheckning',
        content: '<p>Om du vet att du kommer checka in efter ' + this.lateArrivalTime + ' s\xE5 kryssa i Ja',
        buttons: [{
          title: 'Okej',
          class: 'small',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    adultPrice: function adultPrice() {
      var price = this.cartSkipassObject.adults * this.adultPricelistPrice;

      if (price) {
        return price;
      }

      return 0;
    },
    youthPrice: function youthPrice() {
      var price = this.cartSkipassObject.youths * this.youthPricelistPrice;

      if (price) {
        return price;
      }

      return 0;
    },
    totalPrice: function totalPrice() {
      return this.adultPrice() + this.youthPrice();
    },
    noOfSkipasses: function noOfSkipasses() {
      var skipasses = parseInt(this.cartSkipassObject.adults, 10) + parseInt(this.cartSkipassObject.youths, 10) + parseInt(this.cartSkipassObject.children, 10);

      if (skipasses) {
        return skipasses;
      }

      return 0;
    },
    noOfDays: function noOfDays() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        var a = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.cartAccomodationObject.period.date_arrival);
        var b = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.cartAccomodationObject.period.date_departure);
        return b.diff(a, 'days') + 1;
      }

      return 0;
    },
    cartSkipasses: function cartSkipasses() {
      this.confirmSkipasses();
    },
    removeSkipasses: function removeSkipasses() {
      this.unconfirmSkipasses();
    },
    modalSkipasses: function modalSkipasses() {
      this.showingSkipassModal = true;
    },
    addSkipassToCart: function addSkipassToCart(age, days, number) {
      this.addSkipasses({ age: age, days: days, number: number });
    },
    toggleLate: function toggleLate(v) {
      var obj = this.lateArrivalObject;
      obj.title = 'Sen ankomst';
      obj.qtySelected = 1;

      obj.belongsTo = this.accomodationIndex;

      if (this.isAddonBooking) {
        obj.belongsTo = -2;
      }

      if (v.value) {
        this.addAddon(obj);
      } else {
        this.removeAddon(obj);
      }
    },
    validatedSkipasses: function validatedSkipasses() {
      return this.noOfSkipasses();
    },
    unmarkInsuranceError: function unmarkInsuranceError() {
      this.markInsurance = false;

      var obj = this.cancellationInsuranceObject;
      obj.title = 'Avbeställningskydd';
      obj.qtySelected = 1;

      obj.belongsTo = this.accomodationIndex;

      if (this.cancellationInsurance) {
        this.addAddon(obj, this.accomodationIndex);
      } else {
        this.removeAddon(obj);
      }
    },
    unmarkLateError: function unmarkLateError() {
      this.markLate = false;
    }
  })
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      message: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.params.pool) {
      setTimeout(function () {
        _this.openModal(['SkiSchoolBooking', {
          pool: parseInt(_this.$route.params.pool, 10),
          id: 0,
          activity: true
        }]);
      }, 1);
    } else {
      this.message = this.$i18n.t('skischool.no-acitivities-found');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['openModal']))
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orders: [],
      user: {}
    };
  },

  components: {
    Login: __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    activeTab: function activeTab() {
      return this.$route.meta.page;
    }
  }),
  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, user;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/account/user');

              case 2:
                _ref = _context.sent;
                user = _ref.user;

                if (user) {
                  _this.user = user;
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    can: function can(what) {
      return this.user['can_' + what];
    },
    login: function login() {
      this.fetch();
    }
  },
  mounted: function mounted() {
    this.from = __WEBPACK_IMPORTED_MODULE_6_moment___default()().startOf('isoweek').format('YYYY-MM-DD');
    this.to = __WEBPACK_IMPORTED_MODULE_6_moment___default()().endOf('isoweek').format('YYYY-MM-DD');
    this.fetch();
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_payments_Login__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orders: [],
      user: {}
    };
  },

  components: {
    Login: __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    activeTab: function activeTab() {
      return this.$route.meta.page;
    }
  }),
  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, user;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/account/user');

              case 2:
                _ref = _context.sent;
                user = _ref.user;

                if (user) {
                  _this.user = user;
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    login: function login() {
      this.fetch();
      if (this.$store.state.user.isAdmin || localStorage.getItem('admin_user')) {
        this.$router.push('/admin');
      } else {
        this.$router.push('/mina-sidor');
      }
    },
    logout: function logout() {
      this.$router.push('/');
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Cart__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_parts_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CompletedBookings__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CompletedBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_CompletedBookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_API__ = __webpack_require__(4);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cart: __WEBPACK_IMPORTED_MODULE_4__components_parts_Cart___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline___default.a,
    CompletedBookings: __WEBPACK_IMPORTED_MODULE_6__components_parts_CompletedBookings___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_components_Modal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default.a
  },
  data: function data() {
    return {
      loading: false,
      order: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    showQrCodeButton: function showQrCodeButton() {
      if (this.loading) {
        return false;
      }

      if (!this.order) {
        return false;
      }

      if (!this.order.qrCodes) {
        return false;
      }

      if (this.order.qrCodes.length === 0) {
        return false;
      }

      return true;
    },
    onlyMore: function onlyMore() {
      return this.$route.params.onlyMore;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'closeModal']), {
    reloadParent: function reloadParent() {
      this.$emit('reload', true);
    },
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__classes_API__["a" /* default */].get('/order/' + _this.$route.params.bookingNumber);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.order = data;
                _this.loading = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    localClose: function localClose() {
      if (this.$route.query.flow) {
        var flowUri = decodeURI(this.$route.query.flow);
        this.$router.replace({ path: flowUri });
        return;
      }

      if (this.$route.name === 'my booking') {
        this.$router.replace({ name: 'my pages bookings' });
      } else {
        this.$router.replace({ name: 'my pages journey' });
      }
    },
    openQrModal: function openQrModal() {
      this.openModal(['QrModal', {
        order: this.order
      }]);
    }
  }),
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_Cart__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parts_CompletedBookings__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parts_CompletedBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_parts_CompletedBookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_UnitFacts__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_UnitFacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_UnitFacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_Checkbox_v2__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_Checkbox_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_components_Checkbox_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_PrettyOrderDetails__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_PrettyOrderDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_components_PrettyOrderDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_components_Back_v2__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_components_Back_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_components_Back_v2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_my_order__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);

























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cart: __WEBPACK_IMPORTED_MODULE_6__components_parts_Cart___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline___default.a,
    CompletedBookings: __WEBPACK_IMPORTED_MODULE_8__components_parts_CompletedBookings___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_9__components_components_Modal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_10__components_components_Loading___default.a,
    UnitFacts: __WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_UnitFacts___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_12__components_components_Checkbox_v2___default.a,
    PrettyOrderDetails: __WEBPACK_IMPORTED_MODULE_13__components_components_PrettyOrderDetails___default.a,
    Back: __WEBPACK_IMPORTED_MODULE_14__components_components_Back_v2___default.a
  },
  data: function data() {
    return {
      loading: true,
      loadingAddons: true,
      order: {},
      categories: {},
      accomodation: null,
      hasAddons: [],
      openRental: false,
      openSkipass: false,
      openSkischool: false,
      addons: []
    };
  },

  computed: {
    displayDate: function displayDate() {
      if (this.loading) {
        return 'Laddar...';
      }

      var arrival = __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.order.details.firstDate);
      var departure = __WEBPACK_IMPORTED_MODULE_17_moment___default()(this.order.details.lastDate);
      var today = __WEBPACK_IMPORTED_MODULE_17_moment___default()();
      var diff = departure.diff(arrival, 'days');
      var todayDiff = Math.abs(today.diff(arrival, 'days'));

      if (this.order.status === 'active') {
        return 'Dag ' + (todayDiff + 1) + ' av ' + (diff + 1) + '...';
      } else if (this.order.status === 'upcoming') {
        if (todayDiff <= 30) {
          return 'Bara ' + (todayDiff + 1) + ' dagar kvar...';
        }
        return 'Bara ' + (todayDiff + 1) + ' dagar kvar...';
      }

      return 'Din resa';
    },
    showQrCodeButton: function showQrCodeButton() {
      if (this.loading) {
        return false;
      }

      if (!this.order) {
        return false;
      }

      if (!this.order.details) {
        return false;
      }

      if (!this.order.details.qrCodes) {
        return false;
      }

      if (this.order.details.qrCodes.length === 0) {
        return false;
      }

      return true;
    },
    hasValidCodes: function hasValidCodes() {
      return this.order.details.qrCodes.map(function (code) {
        return !!code.ordernumber;
      }).filter(function (code) {
        return code;
      }).length > 0;
    },
    hasCodes: function hasCodes() {
      return this.order.details.qrCodes.length > 0;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['openModal', 'closeModal']), {
    openQrModal: function openQrModal() {
      this.openModal(['QrModal', {
        order: this.order.details
      }]);
    },
    links: function links(id) {
      var allLinks = this.SITE_CONFIG.settings['mypages-links' + id];

      var newLinks = [];

      var currentTypes = this.orderTypes;

      for (var i = 0; i < allLinks.length; i++) {
        var categories = allLinks[i].categories;

        for (var ii in categories) {
          if (currentTypes.indexOf(categories[ii]) !== -1) {
            newLinks.push(allLinks[i]);
            break;
          }
        }
      }

      return newLinks;
    },
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data, categories;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__classes_API__["a" /* default */].get('/order-v2/' + _this.$route.params.bookingNumber);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.order = data;
                _this.loading = false;

                categories = {
                  accomodation: {
                    title: 'Boende',
                    has: false,
                    slug: 'accomodation',
                    product_slug: '',
                    link: '/boenden'
                  },
                  skipass: {
                    title: 'Liftkort',
                    has: false,
                    slug: 'skipass',
                    product_slug: '',
                    link: '/liftkort?quick=1'
                  },
                  rental: {
                    title: 'Utrustning',
                    has: false,
                    slug: 'rental',
                    product_slug: '',
                    link: '/skidhyra'
                  },
                  skischool: {
                    title: 'Skidskola',
                    has: false,
                    slug: 'skischool',
                    product_slug: '',
                    link: '/skidskola/oversikt'
                  }
                };


                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.order.details.rows).forEach(function (row) {
                  if (categories[row]) {
                    categories[row].has = true;

                    if (!categories[row].product_slug && row === 'accomodation') {
                      categories[row].product_slug = _this.order.details.rows.accomodation[0].accommodation.slug;
                      _this.accomodation = _this.order.details.rows.accomodation[0];
                    }
                  }
                });

                _this.categories = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(categories);

                if (_this.accomodation) {
                  _this.fetchAddons();
                }

                _this.addons = [];
                if (_this.order.details.rows.addon) {
                  _this.hasAddons = _this.order.details.rows.addon.map(function (addon) {
                    return '' + addon.pool;
                  });
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchAddons: function fetchAddons() {
      var _this2 = this;

      var a = this.accomodation.accommodation;
      var arrival = this.accomodation.date_arrival.substr(0, 10);
      var departure = this.accomodation.date_departure.substr(0, 10);

      __WEBPACK_IMPORTED_MODULE_16__classes_API__["a" /* default */].get('/units/' + a.pool_lid + '/' + a.unit_lid + '/addons/' + arrival + '/' + departure + '?for-order=' + this.order.resvid).then(function (response) {
        _this2.addons = [];

        if (response.cancellationInsurance) {
          _this2.addons.push(response.cancellationInsurance);
        }
        if (response.lateArrival) {
          _this2.addons.push(response.lateArrival);
        }
        response.data.forEach(function (addon) {
          _this2.addons.push(addon);
        });
        response.groceryBags.forEach(function (addon) {
          _this2.addons.push(addon);
        });
      });
    },
    goToBooking: function goToBooking(number) {
      var currentUri = encodeURI(this.$route.path);
      this.$router.push('/mina-sidor/resa/' + number + '/detaljer?flow=' + currentUri);
    },
    goToAccommodation: function goToAccommodation(slug) {
      var url = this.$route.path.substr(1);
      this.$router.push({ path: '/mina-sidor/resa/' + this.order.headlid + '/boende/' + slug + '?flow=' + url });
    },
    bookMoreWithLink: function bookMoreWithLink(link, localOrder) {
      var lines = [];
      if (localOrder.details && localOrder.details.rows) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(localOrder.details.rows).forEach(function (rowGroup) {
          rowGroup.forEach(function (row) {
            lines.push({
              poolId: row.pool,
              status: row.cancelled ? 'C' : 'B'
            });
          });
        });
      }

      var orderData = {
        number: localOrder.resvid,
        numeric: localOrder.headlid,
        dateStart: localOrder.details.dateStart,
        dateEnd: localOrder.details.dateEnd,
        hasAccommodation: false,
        lines: lines
      };

      var parentAccommodation = localOrder.details.rows && localOrder.details.rows.accomodation && localOrder.details.rows.accomodation[0];
      if (parentAccommodation) {
        orderData.hasAccommodation = true;
        orderData.accomodationRow = parentAccommodation.row;
        orderData.accomodationName = parentAccommodation.name;
        orderData.accomodationDateArrival = parentAccommodation.arrival;
        orderData.accomodationDateDeparture = parentAccommodation.departure;
        orderData.accomodationGroup = parentAccommodation.group;
        orderData.helperPool = parentAccommodation.pool;
        orderData.helperUnit = parentAccommodation.unit;
      }

      this.$store.state.cart.addToOrder = orderData;

      this.$router.push(link);
    },
    bookMore: function bookMore(bookingType, localOrder) {
      var category = this.categories.find(function (cat) {
        return cat.slug === bookingType;
      });

      this.bookMoreWithLink(category.link, localOrder);
    },
    bookAddon: function bookAddon() {
      var row = this.accomodation;

      this.$store.state.cart.addToOrder = {
        number: this.order.resvid,
        numeric: this.order.headlid,
        accomodationRow: row.row,
        accomodationName: row.name,
        accomodationDateArrival: row.arrival,
        accomodationDateDeparture: row.departure,
        accomodationGroup: row.group
      };

      this.$router.push({
        name: 'addons extra',
        query: {
          pool: row.pool,
          unit: row.unit,
          arrival: row.arrival,
          departure: row.departure,
          name: row.name,
          adults: parseInt(row.adults, 10),
          youths: parseInt(row.youths, 10),
          children: parseInt(row.children, 10),
          seniors: parseInt(row.seniors, 10) || 0
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({ name: 'my pages journey' });
    }
  }),
  mounted: function mounted() {
    this.fetch();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_my_order__["a" /* default */]]
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_payments_Login__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orders: [],
      user: {}
    };
  },

  components: {
    Login: __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    activeTab: function activeTab() {
      return this.$route.meta.page;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['setUser', 'updateResetPasswordSuccessMessage']), {
    goToRouteWithName: function goToRouteWithName(name) {
      this.$router.push({ name: name });
    },
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, user, error;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/account/user');

              case 2:
                _ref = _context.sent;
                user = _ref.user;
                error = _ref.error;

                if (user) {
                  _this.user = user;
                }

                if (error || !user) {
                  _this.setUser({
                    token: null
                  });

                  _this.$emit('logout', true);

                  document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: false }));

                  _this.$router.push({ name: 'login' });

                  setTimeout(function () {
                    window.location.reload();
                  }, 200);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    login: function login() {
      this.fetch();
      this.goToRouteWithName('my pages journey');
    }
  }),
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_PrettyOrder__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_PrettyOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_PrettyOrder__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orders: {
        active: [],
        upcoming: [],
        archived: []
      },
      user: {},
      loading: false
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default.a,
    PrettyOrder: __WEBPACK_IMPORTED_MODULE_4__components_components_PrettyOrder___default.a
  },
  computed: {
    activeOrders: function activeOrders() {
      return this.orders.active;
    },
    upcomingOrders: function upcomingOrders() {
      return this.orders.upcoming;
    },
    archivedOrders: function archivedOrders() {
      return this.orders.archived;
    }
  },
  methods: {
    fetch: function fetch(hideLoading) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, user, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!hideLoading) {
                  _this.loading = true;
                }
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/account/user');

              case 3:
                _ref = _context.sent;
                user = _ref.user;

                if (!user) {
                  _context.next = 12;
                  break;
                }

                _this.user = user;
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/orders/archived');

              case 9:
                _ref2 = _context.sent;
                data = _ref2.data;

                _this.orders = data;

              case 12:
                if (!hideLoading) {
                  _this.loading = false;
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goToBooking: function goToBooking(no) {
      var currentUri = encodeURI(this.$route.path);
      this.$router.push('/mina-sidor/bokningar/' + no + '?flow=' + currentUri);
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_checkdigit__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_checkdigit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_checkdigit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Note__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_measurements__ = __webpack_require__(116);















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orders: [],
      user: {},
      loading: false,
      errorMessage: '',
      countries: [],
      skiers: [],
      skipasses: [],
      activeTab: 'details'
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default.a,
    Note: __WEBPACK_IMPORTED_MODULE_8__components_components_Note___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    filteredCountries: function filteredCountries() {
      var _this = this;

      var countries = this.countries.filter(function (country) {
        return country.value !== '----';
      });

      var match = countries.filter(function (country) {
        return country.value === _this.user.addr5;
      });

      if (match.length) {
        return countries;
      }

      countries.push({
        value: '',
        title: '[ Inget valt ]'
      });

      return countries;
    },
    skiersAsSelect: function skiersAsSelect() {
      return this.skiers.map(function (s) {
        return {
          value: s.guid,
          title: s.first_name || 'Ingen åkare'
        };
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'closeModal']), {
    fetch: function fetch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, user, skiers, skipasses;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/account/user');

              case 3:
                _ref = _context.sent;
                user = _ref.user;
                skiers = _ref.skiers;
                skipasses = _ref.skipasses;

                if (user) {
                  _this2.user = user;
                }
                _this2.skiers = skiers;
                _this2.skipasses = skipasses;
                _this2.loading = false;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    preValidate: function preValidate(intent) {
      var _this3 = this;

      if (intent === 'skiers') {
        var valid = true;
        this.skiers.forEach(function (skier, index) {
          if (!valid) return;
          if (!skier.deleted_at) {
            if (!skier.first_name || skier.first_name.trim() === '') {
              _this3.errorMessage = 'Alla åkare måste ha ett förnamn.';
              valid = false;
              return;
            }

            var skierName = skier.first_name || '\xC5kare #' + (index + 1);

            if (skier.age && skier.age.toString().trim() !== '') {
              if (isNaN(parseInt(skier.age, 10))) {
                _this3.errorMessage = skierName + ' m\xE5ste ha en giltig \xE5lder';
                valid = false;
                return;
              }
              if (parseInt(skier.age, 10) < 0 || parseInt(skier.age, 10) > 130) {
                _this3.errorMessage = skierName + ' m\xE5ste ha en giltig \xE5lder';
                valid = false;
                return;
              }
            }

            var allowedMeasurements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_measurements__["a" /* createValidMeasurements */])({
              cmMin: 85,
              cmMax: 195,
              cmInterval: 1,
              kgMin: 15,
              kgMax: 130,
              kgInterval: 1,
              shoeMin: 24,
              shoeMax: 49,
              shoeInterval: 1
            }, _this3.$i18n.t.bind(_this3.$i18n));

            if (skier.measurement_height && skier.measurement_height.toString().trim() !== '') {
              var heightOptions = allowedMeasurements.lengthOptions.map(function (l) {
                return l.value;
              });
              if (!heightOptions.includes(parseInt(skier.measurement_height, 10))) {
                var min = allowedMeasurements.lengthOptions[0].value;
                var max = allowedMeasurements.lengthOptions[allowedMeasurements.lengthOptions.length - 1].value;
                _this3.errorMessage = skierName + ' m\xE5ste ha en giltig l\xE4ngd mellan ' + min + '-' + max + ' cm';
                valid = false;
                return;
              }
            }

            if (skier.measurement_weight && skier.measurement_weight.toString().trim() !== '') {
              var weightOptions = allowedMeasurements.weightOptions.map(function (w) {
                return w.value;
              });
              if (!weightOptions.includes(parseInt(skier.measurement_weight, 10))) {
                var _min = allowedMeasurements.weightOptions[0].value;
                var _max = allowedMeasurements.weightOptions[allowedMeasurements.weightOptions.length - 1].value;
                _this3.errorMessage = skierName + ' m\xE5ste ha en giltig vikt mellan ' + _min + '-' + _max + ' kg';
                valid = false;
                return;
              }
            }

            if (skier.measurement_shoe_size && skier.measurement_shoe_size.toString().trim() !== '') {
              var shoeSizeOptions = allowedMeasurements.shoeSizeOptions.map(function (s) {
                return s.value;
              });
              if (!shoeSizeOptions.includes(parseInt(skier.measurement_shoe_size, 10))) {
                var _min2 = allowedMeasurements.shoeSizeOptions[0].value;
                var _max2 = allowedMeasurements.shoeSizeOptions[allowedMeasurements.shoeSizeOptions.length - 1].value;
                _this3.errorMessage = skierName + ' m\xE5ste ha en giltig skostorlek mellan ' + _min2 + '-' + _max2;
                valid = false;
                return;
              }
            }

            if (skier.measurement_clothsize && skier.measurement_clothsize.toString().trim() !== '') {
              var clothSizes = allowedMeasurements.clothSizeOptions.map(function (c) {
                return c.value;
              });
              if (!clothSizes.includes(skier.measurement_clothsize)) {
                _this3.errorMessage = skierName + ' m\xE5ste ha en giltig kl\xE4dstorlek. V\xE4lj mellan: ' + clothSizes.join(' / ');
                valid = false;
              }
            }
          }
        });
        if (!valid) return false;
      }

      if (intent === 'passes') {
        var _valid = true;
        this.skipasses.forEach(function (skipass, index) {
          if (!_valid) return;

          var passname = skipass.name || 'Liftkort #' + (index + 1);

          if (!skipass.deleted_at) {
            if (!skipass.number || skipass.number.trim() === '') {
              _this3.errorMessage = passname + ' m\xE5ste ha ett nummer.';
              _valid = false;
              return;
            }

            if (!/^[\d-]+$/.test(skipass.number)) {
              _this3.errorMessage = passname + ' f\xE5r endast inneh\xE5lla siffror och bindestreck.';
              _valid = false;
              return;
            }

            var fullNumberWithoutDashes = skipass.number.replace(/-/g, '');

            if (fullNumberWithoutDashes.length < 23) {
              _this3.errorMessage = passname + ' m\xE5ste vara exakt 23 siffror l\xE5ngt (inklusive 01/30 i b\xF6rjan).';
              _valid = false;
              return;
            }

            if (!fullNumberWithoutDashes.startsWith('01') && !fullNumberWithoutDashes.startsWith('30')) {
              _this3.errorMessage = passname + ' m\xE5ste b\xF6rja med 01 eller 30.';
              _valid = false;
              return;
            }

            if (__WEBPACK_IMPORTED_MODULE_4_checkdigit___default.a.mod10.isValid(fullNumberWithoutDashes) === false) {
              _this3.errorMessage = passname + ' har ett ogiltigt nummer. Kontrollera att numret \xE4r korrekt.';
              _valid = false;
            }
          }
        });
        if (!_valid) return false;
      }

      return true;
    },
    save: function save() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var intent, _ref2, success, errorMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.loading = true;
                intent = 'details';


                if (_this4.activeTab === 'skiers') {
                  intent = 'skiers';
                } else if (_this4.activeTab === 'passes') {
                  intent = 'passes';
                }

                if (_this4.preValidate(intent)) {
                  _context2.next = 6;
                  break;
                }

                _this4.loading = false;
                return _context2.abrupt('return');

              case 6:
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].post('/account/update?intent=' + intent, {
                  user: _this4.user,
                  skiers: _this4.skiers,
                  skipasses: _this4.skipasses
                });

              case 8:
                _ref2 = _context2.sent;
                success = _ref2.success;
                errorMessage = _ref2.errorMessage;

                _this4.loading = false;
                if (!success) {
                  _this4.errorMessage = errorMessage;
                } else {
                  _this4.errorMessage = '';

                  _this4.openModal(['GeneralModal', {
                    title: 'Sparat',
                    content: 'Dina uppgifter har sparats.'
                  }]);

                  _this4.fetch();
                }

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    fetchCountries: function fetchCountries() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('countries');

              case 2:
                data = _context3.sent;

                _this5.countries = data;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    createNewSkier: function createNewSkier() {
      this.skiers.push({
        age: '',
        first_name: '',
        last_name: '',
        measurement_height: '',
        measurement_weight: '',
        measurement_shoe_size: '',
        measurement_clothsize: ''
      });
    },
    createNewSkipass: function createNewSkipass() {
      this.skipasses.push({
        name: '',
        number: '',
        skier_guid: ''
      });
    },
    deleteSkier: function deleteSkier(skier, index) {
      var name = skier.first_name || 'åkaren';
      var $this = this;

      this.openModal(['GeneralModal', {
        title: 'Radera',
        content: '<p>Vill du verkligen ta bort ' + name.trim() + '?</p>',
        buttons: [{
          title: 'Ja',
          class: '',
          click: function click() {
            $this.$set($this.skiers, index, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, skier, {
              deleted_at: true
            }));
            $this.closeModal();
          }
        }]
      }]);
    },
    deleteSkipass: function deleteSkipass(skipass, index) {
      var name = skipass.name ? skipass.name + ' (' + skipass.number + ')' : skipass.number;
      if (!name || name.trim() === '') {
        name = 'liftkortet';
      }
      var $this = this;

      this.openModal(['GeneralModal', {
        title: 'Radera',
        content: '<p>Vill du verkligen ta bort ' + name.trim() + '?</p>',
        buttons: [{
          title: 'Ja',
          class: '',
          click: function click() {
            $this.$set($this.skipasses, index, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, skipass, {
              deleted_at: true
            }));
            $this.closeModal();
          }
        }]
      }]);
    }
  }),
  mounted: function mounted() {
    this.fetch();
    this.fetchCountries();
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_PrettyOrder__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_PrettyOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_PrettyOrder__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orders: {
        active: [],
        upcoming: [],
        archived: []
      },
      categories: {},
      user: {},
      loading: false
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_components_Loading___default.a,
    PrettyOrder: __WEBPACK_IMPORTED_MODULE_5__components_components_PrettyOrder___default.a
  },
  computed: {
    activeOrders: function activeOrders() {
      return this.orders.active;
    },
    upcomingOrders: function upcomingOrders() {
      return this.orders.upcoming;
    },
    archivedOrders: function archivedOrders() {
      return this.orders.archived;
    }
  },
  methods: {
    fetch: function fetch(hideLoading) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, user, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!hideLoading) {
                  _this.loading = true;
                }
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__classes_API__["a" /* default */].get('/account/user');

              case 3:
                _ref = _context.sent;
                user = _ref.user;

                if (!user) {
                  _context.next = 12;
                  break;
                }

                _this.user = user;
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_3__classes_API__["a" /* default */].get('/orders/upcoming-and-active');

              case 9:
                _ref2 = _context.sent;
                data = _ref2.data;

                _this.orders = data;

              case 12:
                if (!hideLoading) {
                  _this.loading = false;
                }

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goToBooking: function goToBooking(no) {
      this.$router.push({ name: 'my booking', params: { bookingNumber: no } });
    },
    bookMoreWithLink: function bookMoreWithLink(link, localOrder) {
      var lines = [];
      if (localOrder.details && localOrder.details.rows) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(localOrder.details.rows).forEach(function (rowGroup) {
          rowGroup.forEach(function (row) {
            lines.push({
              poolId: row.pool,
              status: row.cancelled ? 'C' : 'B'
            });
          });
        });
      }

      var orderData = {
        number: localOrder.resvid,
        numeric: localOrder.headlid,
        dateStart: localOrder.details.dateStart,
        dateEnd: localOrder.details.dateEnd,
        hasAccommodation: false,
        lines: lines
      };

      var parentAccommodation = localOrder.details.rows && localOrder.details.rows.accomodation && localOrder.details.rows.accomodation[0];
      if (parentAccommodation) {
        orderData.hasAccommodation = true;
        orderData.accomodationRow = parentAccommodation.row;
        orderData.accomodationName = parentAccommodation.name;
        orderData.accomodationDateArrival = parentAccommodation.arrival;
        orderData.accomodationDateDeparture = parentAccommodation.departure;
        orderData.accomodationGroup = parentAccommodation.group;
        orderData.helperPool = parentAccommodation.pool;
        orderData.helperUnit = parentAccommodation.unit;
      }

      this.$store.state.cart.addToOrder = orderData;

      this.$router.push(link);
    },
    bookMore: function bookMore(bookingType, localOrder) {
      var category = this.categories.find(function (cat) {
        return cat.slug === bookingType;
      });

      this.bookMoreWithLink(category.link, localOrder);
    }
  },
  mounted: function mounted() {
    this.fetch();

    var categories = {
      skipass: {
        title: 'Liftkort',
        has: false,
        slug: 'skipass',
        product_slug: '',
        link: '/liftkort?quick=1'
      },
      skischool: {
        title: 'Skidskola',
        has: false,
        slug: 'skischool',
        product_slug: '',
        link: '/skidskola/oversikt'
      },
      rental: {
        title: 'Utrustning',
        has: false,
        slug: 'rental',
        product_slug: '',
        link: '/skidhyra'
      },
      accomodation: {
        title: 'Boende',
        has: false,
        slug: 'accomodation',
        product_slug: '',
        link: '/boenden'
      }
    };

    this.categories = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(categories);
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_payments_Login__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    Login: __WEBPACK_IMPORTED_MODULE_0__components_payments_Login___default.a
  },
  computed: {},
  methods: {
    login: function login() {
      this.$router.push({ name: 'my pages' });
    }
  },
  mounted: function mounted() {
    this.$refs.login.logout();
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Loading__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {
        current_password: '',
        new_password: '',
        new_password_confirm: ''
      },
      loading: false,
      errorMessage: ''
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal']), {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, success, errorMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/account/update-password', _this.user);

              case 3:
                _ref = _context.sent;
                success = _ref.success;
                errorMessage = _ref.errorMessage;

                if (!success) {
                  _this.errorMessage = errorMessage;
                } else {
                  _this.errorMessage = '';
                  _this.new_password = '';
                  _this.new_password_confirm = '';

                  _this.openModal(['GeneralModal', {
                    title: 'Sparat',
                    content: 'Ditt nya lösenord har sparats.'
                  }]);
                }

                _this.loading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  mounted: function mounted() {}
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_LanguageSwitcher__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      intervalRef: null,
      resetSecondsLeft: 0,
      showEmptyPage: false,
      loading: false,
      hasPickedLanguage: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['guidedRentals']), {
    onlySkirental: function onlySkirental() {
      if (this.SITE_CONFIG.skischool.onsite) {
        return false;
      }
      if (this.SITE_CONFIG.skipass.onsite) {
        return false;
      }
      return true;
    }
  }),
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_components_Loading___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_4__components_components_LanguageSwitcher___default.a
  },
  created: function created() {
    window.addEventListener('mousemove', this.resetTimer);
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('keyup', this.resetTimer);

    var refresh = parseInt(this.$route.query.refresh, 10);

    if (this.$route.query.refresh && refresh === 1) {
      this.showEmptyPage = true;
    }
  },
  destroyed: function destroyed() {
    clearInterval(this.intervalRef);
  },
  mounted: function mounted() {
    var _this = this;

    this.setOnSite();
    this.clearCart();

    var refresh = parseInt(this.$route.query.refresh, 10);

    if (this.$route.query.key) {
      this.$store.state.onsite_key = this.$route.query.key;
    }

    if (this.$route.query.refresh && refresh === 1) {
      localStorage.setItem('language', 'sv');

      var route = {
        name: this.$route.name,
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query)
      };
      route.query.refresh = 0;
      this.$router.replace(route);
      window.location.reload();
      return;
    }

    this.$store.state.isOnWhichSite = this.$route.query.site;
    if (!this.$route.query.site) {
      alert('Lägg på en site med ?site=X');
      return;
    }

    this.resetTimer();

    this.$nextTick(function () {
      _this.intervalRef = setInterval(function () {
        _this.resetSecondsLeft -= 1;
        if (_this.resetSecondsLeft < 0) {
          window.location.reload();
        }
      }, 1000);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapMutations */])(['openModal', 'closeModal', 'setOnSite', 'clearCart']), {
    setLoading: function setLoading() {
      this.loading = true;
    },
    pickedLanguage: function pickedLanguage() {
      this.hasPickedLanguage = true;
      this.loading = false;

      if (this.onlySkirental) {
        this.goToSkirental();
      }
    },
    resetTimer: function resetTimer() {
      this.resetSecondsLeft = 5 * 60;
    },
    goToSkirental: function goToSkirental() {
      this.$router.replace({
        path: '/skidhyra-pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 0
        }
      });
    },
    goToSkischool: function goToSkischool() {
      this.$router.replace({
        path: '/skidskola-pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 0
        }
      });
    },
    goToSkipass: function goToSkipass() {
      this.$router.replace({
        path: '/liftkort-pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 0
        }
      });
    }
  })
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {},
  data: function data() {
    return {
      reservationNumber: null,
      customerNumber: null,
      paymentReference: null,
      paymentMethod: null,
      paymentAmount: null,
      paymentConfirmed: null
    };
  },
  mounted: function mounted() {
    this.reservationNumber = this.$route.query.booking;
    this.customerNumber = this.$route.query.customer;
    this.paymentReference = this.$route.query.reference;
    this.paymentMethod = this.$route.query.method;
    this.paymentAmount = this.$route.query.paidamount;
    this.paymentConfirmed = this.$route.query.confirmed;
  },

  methods: {}
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {},
  data: function data() {
    return {
      number: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, order_number;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/payments/order-creating-status?code=' + _this.$route.query.code);

            case 2:
              _ref = _context.sent;
              order_number = _ref.order_number;

              _this.number = order_number;

              _this.clearCart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['clearCart']))
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_payments_CollectorCheckout__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_payments_CollectorCheckout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_payments_CollectorCheckout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_KlarnaCheckout__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_KlarnaCheckout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_payments_KlarnaCheckout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_payments_OrderCheckForCancellation__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_payments_OrderCheckForCancellation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_payments_OrderCheckForCancellation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_BookingTimer__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_BookingTimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_BookingTimer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_API__ = __webpack_require__(4);














/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {
    CollectorCheckout: __WEBPACK_IMPORTED_MODULE_4__components_payments_CollectorCheckout___default.a,
    KlarnaCheckout: __WEBPACK_IMPORTED_MODULE_5__components_payments_KlarnaCheckout___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default.a,
    OrderCheckForCancellation: __WEBPACK_IMPORTED_MODULE_6__components_payments_OrderCheckForCancellation___default.a,
    BookingTimer: __WEBPACK_IMPORTED_MODULE_8__components_components_BookingTimer___default.a
  },
  data: function data() {
    return {
      loading: false,
      country: 'se',
      purchaseCompleted: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var orderId, code, _ref, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$root.$on('cancel-payment', function () {
                _this.cancel();
              });

              orderId = _this.$route.query.order || 0;
              code = _this.$route.query.code || '';
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_9__classes_API__["a" /* default */].get('/orders/get?order=' + orderId + '&code=' + code);

            case 5:
              _ref = _context.sent;
              data = _ref.data;


              _this.country = data.country;

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'closeModal', 'closeAllModals']), {
    cancel: function cancel() {
      var $this = this;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('general.cancel-payment'),
        buttons: [{
          title: this.$i18n.t('general.yes'),
          class: 'small',
          click: function click() {
            $this.loading = true;
            $this.closeAllModals();
            $this.doCancel();
          }
        }, {
          title: this.$i18n.t('general.no'),
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    doCancel: function doCancel() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__classes_API__["a" /* default */].post('cancel-order/' + _this2.$route.query.order + '/' + _this2.$route.query.code);

              case 3:
                _this2.loading = false;
                _this2.$router.replace('/varukorg');

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handlePurchaseCompleted: function handlePurchaseCompleted(_ref2) {
      var checkout_session_id = _ref2.checkout_session_id;

      var extraFrame = document.querySelector('body > div > .collector-checkout-iframe');

      this.purchaseCompleted = true;

      if (extraFrame) {
        extraFrame.remove();
      }

      this.$router.replace({ path: '/betala/bekraftelse', query: { checkout_session_id: checkout_session_id } });
    }
  })
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_payments_CollectorCheckoutConfirmation__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_payments_CollectorCheckoutConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_payments_CollectorCheckoutConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_payments_KlarnaCheckoutConfirmation__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_payments_KlarnaCheckoutConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_payments_KlarnaCheckoutConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_payments_OrderCheckForCancellation__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_payments_OrderCheckForCancellation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_payments_OrderCheckForCancellation__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {
    CollectorCheckoutConfirmation: __WEBPACK_IMPORTED_MODULE_0__components_payments_CollectorCheckoutConfirmation___default.a,
    KlarnaCheckoutConfirmation: __WEBPACK_IMPORTED_MODULE_1__components_payments_KlarnaCheckoutConfirmation___default.a,
    OrderCheckForCancellation: __WEBPACK_IMPORTED_MODULE_2__components_payments_OrderCheckForCancellation___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Loading__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {
        email: ''
      },
      loading: false,
      errorMessage: ''
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn', 'resetPasswordSuccessMessage']), {
    isNew: function isNew() {
      return this.$route.name.match(/new/);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'updateResetPasswordSuccessMessage']), {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, _ref, success, errorMessage, successMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                data = {
                  email: _this.user.email,
                  is_new: _this.isNew
                };
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/account/request-reset-password', data);

              case 4:
                _ref = _context.sent;
                success = _ref.success;
                errorMessage = _ref.errorMessage;
                successMessage = _ref.successMessage;


                if (!success) {
                  _this.errorMessage = errorMessage;
                } else {
                  _this.errorMessage = '';
                  _this.updateResetPasswordSuccessMessage(successMessage);
                  _this.$router.push('/logga-in');
                }

                _this.loading = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  mounted: function mounted() {}
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Loading__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {
        new_password: ''
      },
      loading: false,
      errorMessage: '',
      successMessage: ''
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_components_Loading___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    isNew: function isNew() {
      return this.$route.name.match(/create/);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'setUser']), {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, token, success, errorMessage;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/account/reset-password', {
                  token: _this.$route.params.token,
                  password: _this.user.new_password
                });

              case 3:
                _ref = _context.sent;
                token = _ref.token;
                success = _ref.success;
                errorMessage = _ref.errorMessage;


                if (!success) {
                  _this.errorMessage = errorMessage;
                } else {
                  _this.setUser({
                    token: token
                  });
                  _this.$emit('login', success);

                  _this.$router.push({ name: 'my pages' });
                }

                _this.loading = false;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  mounted: function mounted() {}
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_payments_CheckoutCodeModal__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_payments_CheckoutCodeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_payments_CheckoutCodeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_accomodationTimelineSteps__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_languageDetector__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Cart: __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline___default.a,
    CompletedBookings: __WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings___default.a,
    CheckoutCodeModal: __WEBPACK_IMPORTED_MODULE_8__components_payments_CheckoutCodeModal___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_accomodationTimelineSteps__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_languageDetector__["a" /* default */]],
  data: function data() {
    return {
      secondsLeft: 0,
      openRelatedOrders: [],
      openRelatedOrdersLoaded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['loggedIn', 'cart']), {
    isCartEmpty: function isCartEmpty() {
      var products = ['accomodations', 'addons', 'rentals', 'skipasses', 'skischools', 'products'];

      return products.every(this.isProductNotInCart);
    },
    canUseCode: function canUseCode() {
      return !this.isCartEmpty;
    },
    language: function language() {
      return this.browserLanguage;
    },
    country: function country() {
      return this.browserCountry;
    },
    showTryPayment: function showTryPayment() {
      return !this.isCartEmpty;
    },
    enableTryPayment: function enableTryPayment() {
      var isAddToOrder = this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric;

      if (this.$store.state.cart.codeRequiresExtraInfo && !this.$store.state.cart.codeExtraInfo) {
        return false;
      }

      if (!isAddToOrder) {
        return true;
      }

      return this.openRelatedOrders.length === 0 && this.openRelatedOrdersLoaded;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query['show-confirmation']) {
      if (this.$route.query.ref === 'accomodation') {
        var accomodations = this.$store.state.cart.accomodations;
        var currentWinter = true;

        if (accomodations.length) {
          var arrival = accomodations[0].period.date_arrival;
          var winterDates = this.SITE_CONFIG.season.winter;

          currentWinter = false;

          if (arrival >= winterDates.start && arrival <= winterDates.end) {
            currentWinter = true;
          }
        }

        var isAddTo = this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric;
        if (currentWinter && this.SITE_CONFIG.modules_open.skiletting.open && !isAddTo) {
          this.$nextTick(function () {
            _this.openModal(['CartHighFiveAccomodationModal', {
              ref: _this.$route.query.ref,
              text: _this.$route.query.text
            }]);
          });
        } else {
          this.$nextTick(function () {
            _this.openModal(['CartHighFiveModal', {
              ref: _this.$route.query.ref,
              text: _this.$route.query.text
            }]);
          });
        }
      } else {
        this.$nextTick(function () {
          _this.openModal(['CartHighFiveModal', {
            ref: _this.$route.query.ref,
            text: _this.$route.query.text
          }]);
        });
      }
    }
    if (this.$route.query.pay) {
      this.$nextTick(function () {
        _this.goToPayment();
      });
    }

    var isAddToOrder = this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric;

    if (isAddToOrder) {
      __WEBPACK_IMPORTED_MODULE_11__classes_API__["a" /* default */].get('/orders/open-addon-orders/' + this.$store.state.cart.addToOrder.numeric).then(function (response) {
        _this.openRelatedOrders = response.data;
        _this.openRelatedOrdersLoaded = true;
      });
    }

    this.trackCart();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal', 'closeModal']), {
    removeOrderLink: function removeOrderLink() {
      var $this = this;
      this.openModal(['GeneralModal', {
        content: this.$i18n.t('general.remove-order-connection-text'),
        buttons: [{
          title: this.$i18n.t('general.remove-order-connection-title'),
          class: 'small',
          click: function click() {
            $this.$store.state.cart.deliveryTo = {};

            for (var i in $this.$store.state.cart.rentals) {
              $this.$store.state.cart.rentals[i].delivery = false;
              $this.$store.state.cart.rentals[i].site = null;
            }
            for (var _i in $this.$store.state.cart.skipasses) {
              $this.$store.state.cart.skipasses[_i].delivery_type = 'pickup';
              $this.$store.state.cart.skipasses[_i].deliveryType = 'pickup';
              $this.$store.state.cart.skipasses[_i].site = null;
            }

            $this.$store.state.cart.addToOrder = {};
            $this.closeModal();
            window.location.reload();
          }
        }, {
          title: this.$i18n.t('general.go-back'),
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    checkAvailability: function checkAvailability() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fullSuccess, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, school, peopleCount, _ref, success;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fullSuccess = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.$store.state.cart.skischools);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 17;
                  break;
                }

                school = _step.value;
                peopleCount = school.people.length;
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_11__classes_API__["a" /* default */].get('/skischool/check-availability/' + school.activity_lid + '/' + peopleCount + '/' + _this2.$store.state.lockingCode);

              case 11:
                _ref = _context.sent;
                success = _ref.success;

                if (!success) {
                  fullSuccess = false;
                }

              case 14:
                _iteratorNormalCompletion = true;
                _context.next = 6;
                break;

              case 17:
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 23:
                _context.prev = 23;
                _context.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context.prev = 26;

                if (!_didIteratorError) {
                  _context.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context.finish(26);

              case 30:
                return _context.finish(23);

              case 31:
                return _context.abrupt('return', fullSuccess);

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    reserve: function reserve() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var fullSuccess, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, school, peopleCount, _ref2, success;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fullSuccess = true;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 4;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.$store.state.cart.skischools);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 17;
                  break;
                }

                school = _step2.value;
                peopleCount = school.people.length;
                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_11__classes_API__["a" /* default */].get('/skischool/reserve/' + school.activity_lid + '/' + peopleCount + '/' + _this3.$store.state.lockingCode);

              case 11:
                _ref2 = _context2.sent;
                success = _ref2.success;

                if (!success) {
                  fullSuccess = false;
                }

              case 14:
                _iteratorNormalCompletion2 = true;
                _context2.next = 6;
                break;

              case 17:
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 23:
                _context2.prev = 23;
                _context2.prev = 24;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 26:
                _context2.prev = 26;

                if (!_didIteratorError2) {
                  _context2.next = 29;
                  break;
                }

                throw _iteratorError2;

              case 29:
                return _context2.finish(26);

              case 30:
                return _context2.finish(23);

              case 31:
                return _context2.abrupt('return', fullSuccess);

              case 32:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 19, 23, 31], [24,, 26, 30]]);
      }))();
    },
    createOrderAndRedirect: function createOrderAndRedirect() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var available, reserved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                available = true;

                if (available) {
                  reserved = true;

                  if (reserved) {
                    _this4.openModal(['CreatingOrder']);
                  } else {
                    _this4.openModal(['GeneralModal', {
                      content: _this4.$i18n.t('general.reservation-fail')
                    }]);
                  }
                } else {
                  _this4.openModal(['GeneralModal', {
                    content: _this4.$i18n.t('general.reservation-fail')
                  }]);
                }

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    trackCart: function trackCart() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref3, currency, lines, total;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__classes_API__["a" /* default */].frontendHelper('/get-cart-for-ga', {
                  cart: _this5.$store.state.cart
                });

              case 3:
                _ref3 = _context4.sent;
                currency = _ref3.currency;
                lines = _ref3.lines;
                total = _ref3.total;


                window.trackViewCart(lines, currency, total);
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 10]]);
      }))();
    },
    tryPayment: function tryPayment() {
      if (__WEBPACK_IMPORTED_MODULE_12_moment___default.a.utc('' + this.$store.state.lockingBeforeTime, 'YYYY-MM-DD HH:mm:ss').diff(__WEBPACK_IMPORTED_MODULE_12_moment___default()(), 'seconds') <= 0) {
        this.openModal(['ReclaimReservationsModal', {
          continueToPayment: this.goToPayment
        }]);
      } else {
        this.goToPayment();
      }
    },
    goToPayment: function goToPayment() {
      this.$store.state.cart.language = this.language;
      this.$store.state.cart.country = this.country;

      if (this.loggedIn) {
          this.createOrderAndRedirect();
        } else {
        this.openModal(['CheckoutLoginModal', {
          goToPayment: this.createOrderAndRedirect
        }]);
      }
    },
    isProductNotInCart: function isProductNotInCart(product) {
      var val = this.cart[product].filter(function (a) {
        return a.confirmed;
      }).length;
      return !val;
    },
    cancelOrder: function cancelOrder(index) {
      var _this6 = this;

      var order = this.openRelatedOrders[index];

      this.openRelatedOrders[index].vue_working_status = true;

      __WEBPACK_IMPORTED_MODULE_11__classes_API__["a" /* default */].post('cancel-order/' + order.id + '/' + order.code).then(function () {
        _this6.openRelatedOrders.splice(index, 1);
      });
    }
  })
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nextIndex: 0,
      currentIndex: 0,
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen'
      },
      categories: {},
      validStartDates: [],
      allAddons: []
    };
  },

  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, meta;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/skiletting/search?age=type=' + _this.selectedType + '&level=' + _this.selectedLevel + '&category=' + _this.selectedCategory + '&addon=1');

            case 2:
              _ref = _context.sent;
              meta = _ref.meta;

              _this.categories = meta.categories_all;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    people: function people() {
      return this.$store.state.cart.rentals;
    },
    sum: function sum() {
      return this.people.reduce(function (a, person) {
        return a + person.products.reduce(function (b, product) {
          return b + product.price;
        }, 0) + person.addons.reduce(function (b, product) {
          return b + product.price;
        }, 0);
      }, 0);
    },
    steps: function steps() {
      var steps = [];
      var $this = this;
      this.$store.state.cart.rentals.forEach(function (person, index) {
        var no = index + 1;
        var p = {
          title: person.name || '\xC5kare ' + no,
          complete: 0
        };
        if (person.guideCompleted) {
          p.complete = 2;
        }
        if ($this.currentIndex === index) {
          p.complete = 1;
        }
        steps.push(p);
      });
      steps.push({
        title: 'Bekräfta',
        complete: 0
      });
      return steps;
    },
    wishesLabels: function wishesLabels() {
      return {};
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'confirmRental', 'completeGuides', 'addRentalAddon', 'addRentalPeople', 'confirmRentals']), {
    dateRange: function dateRange(person) {
      var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(person.startDate).format('D MMMM');
      var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(person.startDate).add(person.days - 1, 'days').format('D MMMM');
      return start + ' - ' + end;
    }
  })
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_OnSiteFooter__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_OnSiteFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_OnSiteFooter__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OnSiteFooter: __WEBPACK_IMPORTED_MODULE_2__components_components_OnSiteFooter___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['guidedPasses'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['openModal', 'closeModal']), {
    open: function open() {
      this.doTheOpening();
    },
    doTheOpening: function doTheOpening() {
      this.openModal(['SkiPassPickDate']);
    }
  }),
  mounted: function mounted() {
    this.open();
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Collapsable__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Collapsable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Collapsable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Skipass_Page__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Skipass_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Skipass_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Collapsable: __WEBPACK_IMPORTED_MODULE_4__components_components_Collapsable___default.a,
    Page: __WEBPACK_IMPORTED_MODULE_5__components_parts_Skipass_Page___default.a
  },
  data: function data() {
    return {
      expanded: [],
      quick: false,
      faqs: [{
        question: 'Så fungerar det med liftkort',
        answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
      }, {
        question: 'Här köper du liftkort',
        answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
      }, {
        question: 'Tips - undvik köer, köp dina liftkort på webben!',
        answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
      }],
      pageContent: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['guidedPasses'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'closeModal']), {
    open: function open(modal) {
      this.doTheOpening(modal);
    },
    goToLoading: function goToLoading() {
      window.location.href = this.SITE_CONFIG.skipass.load_url;
    },
    doTheOpening: function doTheOpening(modal) {
      if (modal) {
        this.openModal([modal]);
        return;
      }

      if (this.$route.query.onlykeycard) {
        this.openModal(['SkiPassPickDateKeycard']);
      } else {
        this.openModal(['SkiPassPickDate']);
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('page/skipass');

            case 2:
              response = _context.sent;

              _this.pageContent = response;

              if (_this.$route.query.quick) {
                setTimeout(_this.doTheOpening, 1);
                _this.quick = true;
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Datepicker__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_skipassTimelineSteps__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_8__components_components_Datepicker___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_9__components_components_Timeline___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_skipassTimelineSteps__["a" /* default */]],
  data: function data() {
    return {
      name: '',
      selectedAge: '',
      selectedDays: {},
      stage: 10,
      selectedCategory: '',
      selectedSubCategory: '',
      selectedType: '',
      searchPackage: '',
      validatedName: false,
      refill: false,
      keycardNumber: '',
      keycardNumberPrefix: '',
      pass: {},
      daysRemote: null,
      titles: {},
      keycard: null,
      keycardObject: null,
      daysOriginal: [],
      options: [{
        value: 'children',
        title: 'Barn',
        subtitle: '(0-6 år)'
      }, {
        value: 'youths',
        title: 'Ungdom',
        subtitle: '(7-17 år)'
      }, {
        value: 'adults',
        title: 'Vuxen',
        subtitle: '(18-64 år)'
      }, {
        value: 'seniors',
        title: 'Senior',
        subtitle: '(18+ år)'
      }],

      categories_all: [],
      categories_main: [],
      categories_other: [],
      delivery: false,
      products: {},
      allProducts: [],
      asterisks: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var years;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              years = _this.$i18n.t('general.years');

              _this.options[0].subtitle = _this.SITE_CONFIG.skipass.ages.children + ' ' + years;
              _this.options[1].subtitle = _this.SITE_CONFIG.skipass.ages.youths + ' ' + years;
              _this.options[2].subtitle = _this.SITE_CONFIG.skipass.ages.adults + ' ' + years;
              _this.options[3].subtitle = _this.SITE_CONFIG.skipass.ages.seniors + ' ' + years;

              if (!_this.SITE_CONFIG.skipass.ages.seniors) {
                _this.options.splice(3, 1);
              }

              if (_this.SITE_CONFIG.skipass.load_enabled) {
                _this.products.load = {
                  title: 'Ladda liftkort'
                };
              }

              _this.products.buy = {
                title: 'Köp nytt liftkort'
              };


              if (_this.SITE_CONFIG.skipass.parents_enabled) {
                _this.options.push({
                  value: 'parents',
                  title: 'Föräldrakort',
                  subtitle: 'Kan delas av föräldrar'
                });
              }

              _this.remount();

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    isSeason: function isSeason() {
      if (this.selectedDays && this.selectedDays.value) {
        return this.selectedDays.value.indexOf('7') === 2 || this.selectedDays.value.indexOf('8') === 2 || this.selectedDays.value.indexOf('9') === 2 || this.selectedDays.value.indexOf('10') === 2 || this.selectedDays.value.indexOf('11') === 2 || this.selectedDays.value.indexOf('12') === 2 || this.selectedDays.value.indexOf('13') === 2;
      }
      return false;
    },
    days: function days() {
      var days = [];

      if (this.daysRemote) {
        var category = this.selectedAge;
        var age = {
          children: 'children',
          youths: 'youths',
          adults: 'adults',
          parents: 'parents',
          seniors: 'seniors'
        };
        age = age[category];

        if (typeof age === 'undefined') {
          return this.daysOriginal;
        }

        var i = void 0;

        var seasonSeparator = false;
        var specialSeparator = false;
        var normalSeparator = false;
        var discountSeparator = false;
        var premiereSeparator = false;

        for (i in this.daysRemote) {
          var day = this.daysRemote[i][age];

          if (!day || !__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(day.days)) {
            continue;
          }

          var title = this.titles[i];
          var asterisk = day.header_text;

          if (!title) {
            continue;
          }

          var price = Math.round(parseFloat(day.price));

          if (asterisk && !discountSeparator) {
            discountSeparator = true;
            days.push({
              title: this.$route.query.onlyseason ? this.asterisks[1].text : this.asterisks[0].text,
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0
            });
          }

          if (day.is_season && !seasonSeparator) {
            seasonSeparator = true;
            days.push({
              title: 'Säsong',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0
            });
          }

          if (day.is_premiere && !premiereSeparator) {
            premiereSeparator = true;
            days.push({
              title: 'Premiär',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0
            });
          }

          if (!day.variant && !normalSeparator && this.SITE_CONFIG.site === 'kungsberget' || !day.variant && !specialSeparator && this.SITE_CONFIG.site === 'branas') {
            if (this.SITE_CONFIG.site === 'kungsberget') {
              normalSeparator = true;
            }
            if (this.SITE_CONFIG.site === 'branas') {
              specialSeparator = true;
            }
            days.push({
              title: 'Dygn',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0
            });
          }

          if (this.SITE_CONFIG.site === 'kungsberget' && day.variant && !day.is_premiere && !specialSeparator) {
            specialSeparator = true;
            days.push({
              title: 'Special',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0
            });
          }

          days.push({
            title: title,
            subtitle: '',
            price1: price + ':-',
            price: price,
            marked: this.daysRemote[i].special_text ? price ? true : false : false,
            value: i,
            pool_lid: day.pool_lid
          });
        }


        return days;
      }

      return this.daysOriginal;
    },
    filtered: function filtered() {
      var _this2 = this;

      return this.allProducts.filter(function (product) {
        var selectedCategory = _this2.selectedSubCategory || _this2.selectedCategory;
        return (!_this2.selectedAge || product.age === _this2.selectedAge) && (!selectedCategory || product.categories.find(function (category) {
          return selectedCategory === category.slug;
        })) && (!_this2.selectedType || product.type === _this2.selectedType);
      });
    },
    categories: function categories() {
      var cats = {};

      this.allProducts.forEach(function (product) {
        product.categories.forEach(function (category) {
          cats[category.slug] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, category);
          if (category.parent) {
            cats[category.parent.slug] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, category.parent);
          }
        });
      });

      return cats;
    },
    subCategories: function subCategories() {
      var cats = {};

      this.allProducts.forEach(function (product) {
        product.categories.forEach(function (category) {
          if (category.parent) {
            cats[category.slug] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, category);
          }
        });
      });

      return cats;
    },
    validStartDate: function validStartDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__dates__["a" /* validStartDate */])({
        validStartDates: this.validStartDates
      });
    }
  },
  watch: {
    '$route.params.person': function $routeParamsPerson() {
      this.remount();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['openModal', 'updateSkiPassPerson', 'closeModal']), {
    remount: function remount() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var person, _ref, data, keycard, titles, asterisks, price;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                person = _this3.$store.state.cart.skipasses.filter(function (skipass) {
                  return skipass.type !== 'SKIPASS-ACCO';
                })[_this3.$route.params.person];
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_13__classes_API__["a" /* default */].frontendHelper('skipass/list?only-season=' + _this3.$route.query.onlyseason, {
                  cart: _this3.$store.state.cart
                });

              case 3:
                _ref = _context2.sent;
                data = _ref.data;
                keycard = _ref.keycard;
                titles = _ref.titles;
                asterisks = _ref.asterisks;


                _this3.daysRemote = data;
                _this3.keycardObject = keycard;
                _this3.titles = titles;
                _this3.asterisks = asterisks;

                if (_this3.keycardObject && _this3.keycardObject.price > 0) {
                  price = Math.round(_this3.keycardObject.price, 10);

                  if (_this3.products && _this3.products.buy) {
                    _this3.products.buy.title = 'K\xF6p nytt liftkort och keycard (' + price + ':-)';
                  }
                }

                _this3.name = person.name;
                _this3.loading = true;
                _this3.setAge(person.age);

                _this3.mountedDateLogic();

                if (person.guideCompleted) {
                  _this3.selectedType = 'buy';
                  if (person.refill) {
                    _this3.keycardNumber = person.cardNumber || '';
                    _this3.keycardNumberPrefix = person.cardPrefix || '';
                    _this3.refill = true;
                    _this3.keycard = null;
                    _this3.selectedType = 'load';
                    _this3.pass = person.pass || false;
                    console.log('person', person);
                  }
                }
                _this3.loading = false;

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    changedDate: function changedDate(v, a) {
      this.selectedDays = v;
      this.update();
    },
    setType: function setType(t) {
      if (t === 'buy') {
        this.refill = false;

        if (this.keycardObject) {
          this.keycard = Math.round(parseFloat(this.keycardObject.price)) || 0;
        } else {
          this.keycard;
        }

        var content = 'Du hämtar kortet i infocentret.';

        if (this.has('accomodations', true) || this.has('rentals', true) || this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.number) {
          content = 'Liftkortet ligger i ditt välkomstkuvert vid ankomst.';
        }

        if (['vallasen', 'ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(this.SITE_CONFIG.site) !== -1) {
          this.next();
        } else if (__WEBPACK_IMPORTED_MODULE_14_moment___default()().isSameOrBefore(__WEBPACK_IMPORTED_MODULE_14_moment___default()(this.SITE_CONFIG.skipass.season_campaign_end))) {
          this.next();
        } else {
          this.next();
        }
      } else {
        var $this = this;
        this.openModal(['SkiPassRefill', {
          prefillPrefix: this.keycardNumberPrefix || '',
          prefillNumber: this.keycardNumber || '',
          pass: this.pass || null,
          onSetNumber: function onSetNumber(prefix, number, pass) {
            $this.keycardNumberPrefix = prefix;
            $this.keycardNumber = number;
            $this.pass = pass;
            $this.refill = true;
            $this.keycard = null;
            $this.next();
          }
        }]);
      }
    },
    mountedDateLogic: function mountedDateLogic() {

      var days = null;
      var person = this.$store.state.cart.skipasses[this.$route.params.person];

      if (person.days) {
        days = person.days;
      } else {
        var accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.cart.accomodations));
        var confirmed = accomodations.filter(function (accomodation) {
          return accomodation.confirmed;
        });

        var personBefore = this.$store.state.cart.skipasses[this.$route.params.person - 1];
        if (personBefore) {
          days = personBefore.days;
        } else if (confirmed.length) {
          var start = __WEBPACK_IMPORTED_MODULE_14_moment___default()(confirmed[0].period.date_arrival);
          var enddate = __WEBPACK_IMPORTED_MODULE_14_moment___default()(confirmed[0].period.date_departure);

          this.pickedStartDate = start.toDate();
          this.pickedEndDate = enddate.toDate();
          days = Math.min(6, __WEBPACK_IMPORTED_MODULE_14_moment___default()(this.pickedEndDate).diff(this.pickedStartDate, 'days') + 1);
          if (days === 6) {
            days = '6-8';
          }
        }
      }

      if (days) {
        this.changedDate(this.days.find(function (day) {
          return day.value === days;
        }));
      }
    },
    setAge: function setAge(value) {

      if (!this.loading) {
        if (this.selectedAge) {
          this.selectedAge = '';
        } else {
          this.selectedAge = value;

          this.mountedDateLogic();
        }
      } else {
        this.selectedAge = value;
      }

      this.update();
    },
    update: function update(c) {

      var guideCompleted = c;
      var guideFullyCompleted = c;
      var completed = c;

      if (!this.selectedDays) {
        return;
      }

      if (this.loading) {
        return;
      }

      this.updateSkiPassPerson({
        index: this.$route.params.person,
        age: this.selectedAge,
        days: this.selectedDays ? this.selectedDays.value : 0,
        price: this.selectedDays ? this.selectedDays.price : 0,
        refill: this.refill,
        keycardNumber: this.keycardNumber,
        keycardNumberPrefix: this.keycardNumberPrefix,
        guideCompleted: guideCompleted,
        guideFullyCompleted: guideFullyCompleted,
        completed: completed,
        keycard: this.keycard || 0,
        title: this.selectedDays.title,
        poolLid: this.selectedDays.pool_lid,
        pass: this.pass
      });
    },
    next: function next() {
      this.update(true);
      this.closeModal();
      this.$router.push({
        name: 'ski pass overview',
        query: this.$route.query
      });

      window.trackViewItem({
        title: 'Liftkort',
        lines: [{
          id: this.selectedDays ? this.selectedDays.pool_lid : 0,
          title: 'Liftkort',
          category: 'equipment',
          quantity: 1,
          price: this.selectedDays ? this.selectedDays.price : 0
        }]
      });
    },
    moment: function moment(string) {
      return __WEBPACK_IMPORTED_MODULE_14_moment___default()(string);
    },
    has: function has(what, confirmed) {
      if (!this.$store.state.cart[what]) {
        return false;
      }
      return this.$store.state.cart[what].filter(function (a) {
        return confirmed ? a.confirmed : true;
      }).length;
    }
  })
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_FilterListItem__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_FilterListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_FilterListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_skipassTimelineSteps__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_checkdigit__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_checkdigit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_checkdigit__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nextIndex: 0,
      currentIndex: 0,
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen',
        seniors: 'Senior'
      },
      titles: {},
      daysRemote: null,
      categories: {},
      validStartDates: [],
      allAddons: [],
      daysOriginal: [],
      options: [{
        value: 'children',
        title: 'Barn',
        subtitle: '(0-6 år)'
      }, {
        value: 'youths',
        title: 'Ungdom',
        subtitle: '(7-17 år)'
      }, {
        value: 'adults',
        title: 'Vuxen',
        subtitle: '(18-64 år)'
      }, {
        value: 'seniors',
        title: 'Senior',
        subtitle: '(65+ år)'
      }],
      pattern: '####-####-####-####-####-#',
      placeholder: '0000-0000-0000-0000-0000-0'
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_skipassTimelineSteps__["a" /* default */]],
  components: {
    Timeline: __WEBPACK_IMPORTED_MODULE_5__components_components_Timeline___default.a,
    FilterListItem: __WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_FilterListItem___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_7__components_components_LanguageSwitcher___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var years, _ref, data, keycard, titles, completed, fullyCompleted;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              years = _this.$i18n.t('general.years');

              _this.options[0].subtitle = _this.SITE_CONFIG.skipass.ages.children + ' ' + years;
              _this.options[1].subtitle = _this.SITE_CONFIG.skipass.ages.youths + ' ' + years;
              _this.options[2].subtitle = _this.SITE_CONFIG.skipass.ages.adults + ' ' + years;
              _this.options[3].subtitle = _this.SITE_CONFIG.skipass.ages.seniors + ' ' + years;

              if (_this.SITE_CONFIG.skipass.parents_enabled) {
                _this.options.push({
                  value: 'parents',
                  title: 'Föräldrakort',
                  subtitle: 'Kan delas av föräldrar'
                });
                _this.ages.parents = 'Föräldrar';
              }

              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get('skipass/list?only-season=' + _this.$route.query.onlyseason);

            case 8:
              _ref = _context.sent;
              data = _ref.data;
              keycard = _ref.keycard;
              titles = _ref.titles;

              _this.daysRemote = data;
              _this.keycardObject = keycard;
              _this.titles = titles;

              completed = _this.people.filter(function (person) {
                return person.guideCompleted;
              });
              fullyCompleted = _this.people.filter(function (person) {
                return person.guideFullyCompleted;
              });

              _this.nextIndex = completed.length;
              _this.currentIndex = fullyCompleted.length;

              if (completed.length === _this.people.length) {
                _this.nextIndex = 0;
              }

              if (!completed.length) {
                if (_this.people.length) {
                  _this.$router.replace({ name: 'ski pass person', query: _this.$route.query, params: { person: '0' } });
                } else {
                  _this.$router.push({ name: 'ski pass overview', query: _this.$route.query });
                }
              }

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    people: function people() {
      return this.$store.state.cart.skipasses.filter(function (skipass) {
        return skipass.type !== 'SKIPASS-ACCO';
      });
    },
    keycardOptions: function keycardOptions() {
      return [{
        title: '01',
        value: '01'
      }, {
        title: '30',
        value: '30'
      }];
    },
    sum: function sum() {
      return this.people.reduce(function (a, person) {
        return a + person.price + (person.keycardPrice ? person.keycardPrice : 0);
      }, 0);
    },
    steps: function steps() {
      var steps = [];
      var $this = this;
      this.$store.state.cart.skipasses.forEach(function (person, index) {
        var no = index + 1;
        var p = {
          title: person.name || '\xC5kare ' + no,
          complete: 0
        };
        if (person.guideCompleted) {
          p.complete = 2;
        }
        steps.push(p);
      });
      steps.push({
        title: 'Bekräfta',
        complete: 0
      });
      return steps;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal', 'confirmSkiPass', 'addSkiPassPeople', 'completeSkipassGuides', 'closeModal']), {
    validate: function validate() {
      var _this2 = this;

      var validated = false;

      this.$store.state.cart.skipasses.forEach(function (person) {
        if (!person.age) {
          validated = false;
          return;
        }
        if (!person.days) {
          validated = false;
          return;
        }
        if (person.refill) {
          if (!_this2.validateKeycardNumber(person)) {
            validated = false;
            return;
          }
        }

        validated = true;
      });

      return validated;
    },
    updatePrice: function updatePrice(days) {
      var person = this.people[this.currentIndex];
      var index = this.$store.state.cart.skipasses.indexOf(person);
      var $days = this.days(person.age);
      var $day = $days.filter(function (day) {
        return day.value === days;
      });
      this.$store.state.cart.skipasses[index].days = days;
      this.$store.state.cart.skipasses[index].price = Math.round(parseFloat($day[0].price));
    },
    changedDate: function changedDate(v) {
      this.updatePrice(v.value);
    },
    daysLabel: function daysLabel(age, no) {
      var days = this.days(age).filter(function (day) {
        return day.value === no;
      });
      if (days.length) {
        return days[0].title;
      }
      return days;
    },
    setAge: function setAge(person, option) {
      if (person.age) {
        person.age = null;
      } else {
        person.age = option.value;
      }
      this.updatePrice(person.days);
    },
    addPerson: function addPerson() {
      this.addSkiPassPeople({
        peopleCount: 1,
        append: true
      });
      this.completeSkipassGuides();
      var next = this.people.length - 1;

      this.$router.push({ name: 'ski pass person', query: this.$route.query, params: { person: next } });
    },
    remove: function remove(index) {
      var _this3 = this;

      var $this = this;
      this.openModal(['GeneralModal', {
        title: 'Är du säker?',
        content: 'Vill du verkligen radera \xE5kare ' + (index + 1) + '?',
        buttons: [{
          title: 'Ja',
          class: 'small',
          click: function click() {
            $this.currentIndex = 0;

            var indexToRemove = -1;
            var iterator = -1;
            $this.$store.state.cart.skipasses.forEach(function (skipass, i) {
              if (skipass.type !== 'SKIPASS-ACCO') {
                iterator += 1;

                if (iterator === index) {
                  indexToRemove = i;
                }
              }
            });

            $this.$store.state.cart.skipasses.splice(indexToRemove, 1);

            var completed = _this3.people.filter(function (person) {
              return person.guideCompleted;
            });

            if (!completed.length) {
              if (_this3.people.length) {
                _this3.$router.replace({ name: 'ski pass person', query: _this3.$route.query, params: { person: '0' } });
              } else {
                _this3.$router.push('/liftkort?quick=1');
              }
            }

            $this.closeModal();
          }
        }, {
          title: 'Nej',
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    setActive: function setActive(item) {
      this.currentIndex = item;
    },
    next: function next() {
      this.$router.replace({ name: 'ski pass person', query: this.$route.query, params: { person: this.nextIndex } });
    },
    goToUser: function goToUser(index) {
      this.$router.push({ name: 'ski pass person', query: this.$route.query, params: { person: index } });
    },
    doSkipass: function doSkipass() {
      this.openModal(['SkiPassConfirm']);
    },
    dateRange: function dateRange(person) {
      var start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(person.startDate).format('D MMMM');
      var end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(person.startDate).add(person.days - 1, 'days').format('D MMMM');
      return start + ' - ' + end;
    },
    validateKeycardNumber: function validateKeycardNumber(person) {
      var fullNumber = ('' + person.cardPrefix + person.cardNumber).replace(/-/g, '');
      var validated = fullNumber ? __WEBPACK_IMPORTED_MODULE_12_checkdigit___default.a.mod10.isValid(fullNumber) : false;
      return fullNumber.length === 23 && validated;
    },
    errorKeycardNumber: function errorKeycardNumber(person) {
      var fullNumber = ('' + person.cardPrefix + person.cardNumber).replace(/-/g, '');
      var validated = fullNumber ? __WEBPACK_IMPORTED_MODULE_12_checkdigit___default.a.mod10.isValid(fullNumber) : false;
      return fullNumber.length === 23 && !validated;
    },
    days: function days(localAge) {
      var days = [];

      if (this.daysRemote) {
        var category = localAge;
        var age = {
          children: 'children',
          youths: 'youths',
          adults: 'adults',
          parents: 'parents',
          seniors: 'seniors'
        };
        age = age[category];

        if (typeof age === 'undefined') {
          return this.daysOriginal;
        }

        var i = void 0;

        var seasonSeparator = false;
        var specialSeparator = false;

        for (i in this.daysRemote) {
          var day = this.daysRemote[i][age];

          if (!day || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(day.days)) {
            continue;
          }

          var title = this.titles[i];

          if (!title) {
            continue;
          }

          var price = Math.round(parseFloat(day.price));

          if (day.is_season && !seasonSeparator) {
            seasonSeparator = true;
            days.push({
              title: '',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: ''
            });
          }

          if (!day.variant && !specialSeparator) {
            specialSeparator = true;
            days.push({
              title: '',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: ''
            });
          }

          days.push({
            title: title,
            subtitle: '',
            price1: price + ':-',
            price: price,
            marked: false,
            value: i
          });
        }


        return days;
      }

      return this.daysOriginal;
    }
  })
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nextIndex: 0,
      currentIndex: 0,
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen'
      },
      categories: {},
      validStartDates: [],
      allAddons: []
    };
  },

  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, meta;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/skiletting/search?age=type=' + _this.selectedType + '&level=' + _this.selectedLevel + '&category=' + _this.selectedCategory + '&addon=1');

            case 2:
              _ref = _context.sent;
              meta = _ref.meta;

              _this.categories = meta.categories_all;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    people: function people() {
      return this.$store.state.cart.rentals;
    },
    sum: function sum() {
      return this.people.reduce(function (a, person) {
        return a + person.products.reduce(function (b, product) {
          return b + product.price;
        }, 0) + person.addons.reduce(function (b, product) {
          return b + product.price;
        }, 0);
      }, 0);
    },
    steps: function steps() {
      var steps = [];
      var $this = this;
      this.$store.state.cart.rentals.forEach(function (person, index) {
        var no = index + 1;
        var p = {
          title: person.name || '\xC5kare ' + no,
          complete: 0
        };
        if (person.guideCompleted) {
          p.complete = 2;
        }
        if ($this.currentIndex === index) {
          p.complete = 1;
        }
        steps.push(p);
      });
      steps.push({
        title: 'Bekräfta',
        complete: 0
      });
      return steps;
    },
    wishesLabels: function wishesLabels() {
      return {
        wideCalf: 'Bred vad',
        wideFoot: 'Bred fot',
        softShoes: 'Mjuka pjäxor',
        hardShoes: 'Hårda pjäxor',
        shortTurn: 'Kortsväng',
        longTurn: 'Långsväng',
        preferedFootLeft: 'Vänster fram',
        preferedFootRight: 'Höger fram',
        freeText: 'Eget önskemål'
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'confirmRental', 'completeGuides', 'addRentalAddon', 'addRentalPeople', 'confirmRentals']), {
    dateRange: function dateRange(person) {
      var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()(person.startDate).format('D MMMM');
      var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(person.startDate).add(person.days - 1, 'days').format('D MMMM');
      return start + ' - ' + end;
    }
  })
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_OnSiteFooter__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_OnSiteFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_OnSiteFooter__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      intervalRef: null,
      resetSecondsLeft: 0
    };
  },

  components: {
    OnSiteFooter: __WEBPACK_IMPORTED_MODULE_3__components_components_OnSiteFooter___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['guidedRentals'])),
  created: function created() {
    window.addEventListener('mousemove', this.resetTimer);
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('keyup', this.resetTimer);
  },
  destroyed: function destroyed() {
    clearInterval(this.intervalRef);
  },
  mounted: function mounted() {
    var _this = this;

    this.setOnSite();
    this.clearCart();

    var refresh = parseInt(this.$route.query.refresh, 10);

    if (this.$route.query.key) {
      this.$store.state.onsite_key = this.$route.query.key;
    }

    if (this.$route.query.refresh && refresh === 1) {
      var route = {
        name: this.$route.name,
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.query)
      };
      route.query.refresh = 0;
      this.$router.replace(route);
      window.location.reload();
      return;
    }

    this.$store.state.isOnWhichSite = this.$route.query.site;
    if (!this.$route.query.site) {
      alert('Lägg på en site med ?site=X');
      return;
    }

    this.resetTimer();

    this.$nextTick(function () {
      _this.intervalRef = setInterval(function () {
        _this.resetSecondsLeft -= 1;
        if (_this.resetSecondsLeft < 0) {
          window.location.reload();
        }
      }, 1000);

      _this.openModal(['SkiRentalPickDate', {
        type: 'without-delivery'
      }]);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapMutations */])(['openModal', 'closeModal', 'setOnSite', 'clearCart']), {
    resetTimer: function resetTimer() {
      this.resetSecondsLeft = 5 * 60;
    },
    goBack: function goBack() {
      this.$router.replace({ name: 'on site' });
    }
  })
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_SkiRentalDiscount__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_SkiRentalDiscount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_SkiRentalDiscount__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SkiRentalDiscount: __WEBPACK_IMPORTED_MODULE_5__components_components_SkiRentalDiscount___default.a
  },
  data: function data() {
    return {
      TEXTS: {},
      pageContent: '',
      quick: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['guidedRentals'])),
  mounted: function mounted() {
    if (this.$route.query.quick) {
      if (this.$route.query.delivery) {
        setTimeout(this.openWithDelivery, 1);
      } else {
        setTimeout(this.openWithoutDelivery, 1);
      }
      this.quick = true;
    } else {
      setTimeout(this.openWithoutDelivery, 1);
      this.quick = true;
    }

    this.getTexts();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'closeModal', 'setOffSite']), {
    getTexts: function getTexts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('texts/ski-rental');

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                _this.TEXTS = data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openWithDelivery: function openWithDelivery() {
      this.doTheOpening('with-delivery');
    },
    openWithoutDelivery: function openWithoutDelivery() {
      this.doTheOpening('without-delivery');
    },
    doTheOpening: function doTheOpening(type) {
      this.openModal(['SkiRentalPickDate', {
        type: type
      }]);
    }
  })
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_Note__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_components_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_rentalTimelineSteps__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_components_OnSiteFooter__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_components_OnSiteFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_components_OnSiteFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_components_Back__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_components_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_components_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_components_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);































/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_9__components_components_Datepicker___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_10__components_components_Timeline___default.a,
    OnSiteFooter: __WEBPACK_IMPORTED_MODULE_16__components_components_OnSiteFooter___default.a,
    Back: __WEBPACK_IMPORTED_MODULE_17__components_components_Back___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_18__components_components_LanguageSwitcher___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_12__components_payments_Login___default.a,
    Note: __WEBPACK_IMPORTED_MODULE_13__components_components_Note___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_rentalTimelineSteps__["a" /* default */]],
  data: function data() {
    return {
      name: '',
      selectedAge: '',
      pickedStartDate: null,
      selectedDays: 0,
      stage: 10,
      selectedCategory: '',
      selectedSubCategory: '',
      selectedType: '',
      searchPackage: '',
      validatedName: false,
      options: [{
        value: 'children',
        title: 'Barn',
        subtitle: '(0-6 år)'
      }, {
        value: 'youths',
        title: 'Ungdom',
        subtitle: '(7-17 år)'
      }, {
        value: 'adults',
        title: 'Vuxen',
        subtitle: '(18-64 år)'
      }, {
        value: 'seniors',
        title: 'Senior',
        subtitle: '65+ år'
      }],
      categories_all: [],
      categories_main: [],
      categories_other: [],
      delivery: false,
      allProducts: [],
      priceType: 'day',
      showedWarning: false,
      possibleWithStorage: false,
      deliveryMessages: [],
      tabSaved: false,
      loadingSkiers: false,
      skiers: [],
      skierId: '',
      skier: {}
    };
  },

  watch: {
    tabSaved: function tabSaved(value) {
      if (!value) {
        this.skierId = '';
        this.skier = {};
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var years, person, pool, unit, _ref, success;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              years = _this.$i18n.t('general.years');

              _this.options[0].subtitle = _this.SITE_CONFIG.skipass.ages.children + ' ' + years;
              _this.options[1].subtitle = _this.SITE_CONFIG.skipass.ages.youths + ' ' + years;
              _this.options[2].subtitle = _this.SITE_CONFIG.skipass.ages.adults + ' ' + years;
              _this.options[3].subtitle = _this.SITE_CONFIG.skipass.ages.seniors + ' ' + years;

              if (!_this.SITE_CONFIG.skipass.ages.seniors) {
                _this.options.splice(3, 1);
              }

              _this.options[0].title = _this.$i18n.t('general.ages.child');
              _this.options[1].title = _this.$i18n.t('general.ages.youth');
              _this.options[2].title = _this.$i18n.t('general.ages.adult');

              person = _this.$store.state.cart.rentals[_this.$route.params.person];

              if (!person) {
                person = {};
              }

              _this.name = person.name;
              _this.priceType = person.priceType;
              _this.loading = true;
              _this.validateStep10();
              _context.next = 17;
              return _this.mountedDateLogic();

            case 17:

              _this.setAge(person.age);
              _this.setCategory1(person.category);
              _this.pickedCategory(person.subCategory);
              _this.setType(person.type);
              _this.setPackage(person.searchPackage);
              _this.loading = false;

              _this.delivery = person.delivery;

              if (!(_this.$store.state.cart.rentals[0].deliveryTo && _this.$store.state.cart.rentals[0].deliveryTo.pool_lid)) {
                _context.next = 32;
                break;
              }

              pool = _this.$store.state.cart.rentals[0].deliveryTo.pool_lid;
              unit = _this.$store.state.cart.rentals[0].deliveryTo.unit_lid;
              _context.next = 29;
              return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('equipment-storage-available/' + pool + '/' + unit);

            case 29:
              _ref = _context.sent;
              success = _ref.success;

              _this.possibleWithStorage = success;

            case 32:

              _this.deliveryMessages = [];
              _this.SITE_CONFIG.delivery_messages.forEach(function (message) {
                if (message[2]) {
                  if (__WEBPACK_IMPORTED_MODULE_21_moment___default()(message[2]).isAfter(__WEBPACK_IMPORTED_MODULE_21_moment___default()().toString())) {
                    _this.deliveryMessages.push(message[1]);
                  }
                } else if (message[3] && message[3] === 'fee') {
                  if (_this.SITE_CONFIG.rental.delivery_fee_active) {
                    _this.deliveryMessages.push(message[1].replace('{fee}', _this.SITE_CONFIG.rental.delivery_fee_price));
                  }
                } else if (message[3] && message[3] === 'no_fee') {
                  if (!_this.SITE_CONFIG.rental.delivery_fee_active) {
                    _this.deliveryMessages.push(message[1]);
                  }
                } else {
                  _this.deliveryMessages.push(message[1]);
                }
              });

              _context.next = 36;
              return _this.reload();

            case 36:
              _context.next = 38;
              return _this.fetchSkiers();

            case 38:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['loggedIn']), {
    filtered: function filtered() {
      var _this2 = this;

      return this.allProducts.filter(function (product) {
        var selectedCategory = _this2.selectedSubCategory || _this2.selectedCategory;
        return (!_this2.selectedAge || product.age === _this2.selectedAge || product.age === 'all') && (!selectedCategory || product.categories.filter(function (category) {
          return selectedCategory === category.slug;
        }).length) && (!_this2.selectedType || product.type === _this2.selectedType);
      });
    },
    categories: function categories() {
      var _this3 = this;

      var cats = {};

      this.allProducts.forEach(function (product) {
        product.categories.forEach(function (category) {
          if (_this3.SITE_CONFIG.site === 'tolvmannabacken' || _this3.SITE_CONFIG.site === 'storstenshojden') {
            if (product.addon && category.slug !== 'protection') {
              return;
            }
          }

          var slug = category.slug;

          cats[category.slug] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, category);
          if (category.parent) {
            cats[category.parent.slug] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, category.parent);
            slug = category.parent.slug;
          }

          cats[slug].name = _this3.$i18n.t('general.category-' + slug);
        });
      });

      console.log(cats);

      var orderedCats = __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.orderBy(cats, ['id'], ['asc']);
      return orderedCats;
    },
    subCategories: function subCategories() {
      var cats = {};

      this.allProducts.forEach(function (product) {
        product.categories.forEach(function (category) {
          if (category.parent) {
            cats[category.slug] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, category);
          }
        });
      });

      if (this.selectedAge === 'children' || this.selectedAge === 'youths') {
        delete cats.telemark;
      }
      if (this.selectedAge === 'children') {
        delete cats.snowblades;
      }

      return cats;
    },
    validStartDate: function validStartDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__dates__["a" /* validStartDate */])({
        validStartDates: this.validStartDates
      });
    },
    products: function products() {
      var description = this.$i18n.t('skirental.category-descriptions.package');

      if (this.selectedCategory === 'alpine') {
        description = this.$i18n.t('skirental.category-descriptions.alpine');
      } else if (this.selectedCategory === 'snowboard') {
        description = this.$i18n.t('skirental.category-descriptions.snowboard');
      } else if (this.selectedSubCategory === 'cross_country') {
        description = this.$i18n.t('skirental.category-descriptions.cross_country');
      } else if (this.selectedSubCategory === 'telemark') {
        description = this.$i18n.t('skirental.category-descriptions.telemark');
      } else if (this.selectedSubCategory === 'snowblades') {
        description = this.$i18n.t('skirental.category-descriptions.snowblades');
      } else if (this.selectedSubCategory === 'clothes') {
        description = this.$i18n.t('skirental.category-descriptions.clothes');
      }

      var packages = this.filtered.filter(function (a) {
        return a.package;
      }).length;
      var single = this.filtered.filter(function (a) {
        return a.single;
      }).length;

      var r = {};

      if (packages) {
        r.package = {
          title: this.$i18n.t('skirental.category-types.package'),
          description: description
        };
      }
      if (single) {
        r.single = {
          title: this.$i18n.t('skirental.category-types.single'),
          description: this.$i18n.t('skirental.category-types.single-text')
        };
      }

      return r;
    },
    currentStepValid: function currentStepValid() {
      if (this.stage === 10 || this.stage === 13) {
        return this.name && this.selectedDays;
      } else if (this.stage === 16) {
        return this.selectedAge;
      } else if (this.stage === 20) {
        return this.selectedCategory;
      } else if (this.stage === 30) {
        return this.selectedType;
      } else if (this.stage === 40) {
        return this.searchPackage;
      }
      return false;
    },
    skiersAsSelect: function skiersAsSelect() {
      return this.skiers.map(function (s) {
        return {
          value: s.guid,
          title: (s.first_name || '') + ' ' + (s.last_name || '')
        };
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['openModal', 'updateRentalPerson', 'updateRentalPersonMeasurements', 'closeModal']), {
    reload: function reload() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var date, days;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                date = '';

                if (_this4.pickedStartDate) {
                  date = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this4.pickedStartDate).format('YYYY-MM-DD');
                }
                days = _this4.selectedDays;

                _this4.setCategoriesFromSearch(date, days);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    setCategoriesFromSearch: function setCategoriesFromSearch() {
      var _this5 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var age = options.age ? 'age=' + options.age : false;
      var category = options.category ? 'category=' + options.category : false;
      var date = options.date ? 'date=' + options.date : false;
      var days = options.days ? 'days=' + options.days : false;

      var requestUrl = '';
      requestUrl = [age, category, date, days].filter(Boolean).join('&');

      __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('/skiletting/search?' + requestUrl).then(function (response) {
        _this5.allProducts = response.data;
        _this5.categories_all = response.meta.categories_all;
        _this5.categories_main = response.meta.categories_main;
        _this5.categories_other = response.meta.categories_other;
      });
    },
    goBack: function goBack() {
      if (window.screenSize() > window.screenMobile) {
        if (this.$route.params.person.toString() === '0') {
          this.$router.push({ name: 'ski rental' });
          return;
        }

        this.$router.push({ name: 'ski rental overview' });
      }

      if (this.stage === 10 || this.stage === 13) {
        this.$router.push({ name: 'ski rental overview' });
      } else if (this.stage === 16) {
        this.stage = 13;
      } else if (this.stage === 20) {
        this.stage = 16;
      } else if (this.stage === 30) {
        this.stage = 20;
      } else if (this.stage === 40) {
        this.stage = 30;
      }
    },
    goForward: function goForward() {
      if (this.stage === 10 || this.stage === 13) {
        this.stage = 16;
      } else if (this.stage === 16) {
        this.stage = 20;
      } else if (this.stage === 20) {
        this.stage = 30;
      } else if (this.stage === 30) {
        this.stage = 40;
      } else if (this.stage === 40) {
        this.next();
      }
    },
    showProduct: function showProduct(key) {
      var show = false;
      this.allProducts.forEach(function (product) {
        if (product[key]) {
          show = true;
        }
      });
      return show;
    },
    validateName: function validateName(e) {
      if (this.name.length) {
        this.validatedName = true;
      } else {
        this.validatedName = false;
      }
      e.stopPropagation();
    },
    inValidateName: function inValidateName() {
      this.validatedName = false;
    },
    focusName: function focusName() {
      this.$refs.nameInput.focus();
    },
    selectDates: function selectDates(start, end, type) {
      var _this6 = this;

      if (start) {
        this.pickedStartDate = start;
      } else {
        return;
      }
      var newEnd = end;
      if (!newEnd) {
        newEnd = start;
      }
      this.selectedDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib__["b" /* dayCountExcludeClosed */])(start, newEnd);
      this.priceType = type;
      this.stage = Math.max(this.stage, 16);

      this.validateDate();

      this.$store.state.cart.rentals.forEach(function (person, index) {
        _this6.$store.state.cart.rentals[index].days = _this6.selectedDays;
        _this6.$store.state.cart.rentals[index].startDate = _this6.pickedStartDate;
      });

      if (this.skierId && this.skier.age_category && this.selectedAge) {
        this.refreshProductsFromAge(this.selectedAge);
        this.update();
        this.stage = Math.max(this.stage, 20);
      }
    },
    openWarningModal: function openWarningModal() {
      var $this = this;
      this.openModal(['GeneralModal', {
        title: this.stage < 13 ? this.$i18n.t('general.pick-skier-name') : this.$i18n.t('general.pick-date'),
        content: this.stage < 13 ? this.$i18n.t('skirental.rules.pick-skiers-name') : this.$i18n.t('skirental.rules.pick-date'),
        buttons: [{
          title: this.$i18n.t('general.okay'),
          class: 'small',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    datepickerRangeModal: function datepickerRangeModal() {
      if (this.stage >= 13) {
        var endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib__["d" /* endDateIncludeClosed */])(this.pickedStartDate, this.selectedDays);
        this.openModal(['DatepickerRangeModal', {
          validDates: this.validStartDates,
          pickedStartDate: this.pickedStartDate,
          pickedEndDate: endDate,
          onClose: this.selectDates,
          onPickStart: this.setEndDates,
          onPickStartInfo: this.setDateInfo,
          night: this.SITE_CONFIG.season.winter.night,
          open: this.SITE_CONFIG.modules_open.skiletting.open,
          closed_message: this.SITE_CONFIG.modules_open.skiletting.closed_message,
          type: 'skiletting',
          disableSingle: this.delivery
        }]);
      } else {
        this.openWarningModal();
      }
    },
    setEndDates: function setEndDates(startDate) {
      var _this7 = this;

      if (!startDate) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve(_this7.SITE_CONFIG.rental.days_max);
        });
      }
      var d = __WEBPACK_IMPORTED_MODULE_21_moment___default()(startDate).format('YYYY-MM-DD');
      return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('/skiletting/get-end-day-limit/' + d);
    },
    setDateInfo: function setDateInfo(startDate) {
      var _this8 = this;

      var d = __WEBPACK_IMPORTED_MODULE_21_moment___default()(startDate).format('YYYY-MM-DD');

      if (!startDate) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve('');
        });
      }

      if (this.SITE_CONFIG.site === 'kungsberget') {
        __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('config/is-skipass-date-allowed?date=' + d).then(function (payload) {
          if (!payload.data && !_this8.showedWarning) {
            _this8.showedWarning = true;
            var $this = _this8;
            _this8.openModal(['GeneralModal', {
              title: '',
              content: '<p>Vi \xE4r fullbokade ' + d + ', av den anledningen kan du inte boka liftkort eller k\xF6pa p\xE5 plats.</p><p>Anl\xE4ggningens boendeg\xE4ster och s\xE4songskortsg\xE4ster har alltid platser reserverade.</p><p><b>Vill du forts\xE4tta boka utrustning f\xF6r ' + d + '?</b></p>',
              buttons: [{
                title: 'Fortsätt bokning',
                class: 'small',
                click: function click() {
                  $this.closeModal();
                }
              }, {
                title: 'Avbryt bokning',
                class: 'small white border',
                click: function click() {
                  window.history.back();
                }
              }]
            }]);
          }
        });
      }
      if (this.SITE_CONFIG.site !== 'ulricehamn') {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve('');
        });
      }

      return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('/skiletting/first-time/' + d);
    },
    dateClear: function dateClear() {
      this.pickedStartDate = null;
      this.selectedDays = null;
      this.stage = 13;
    },
    formatDate: function formatDate() {
      var selectedDays = Math.round(this.selectedDays || 0);
      var start = this.pickedStartDate ? __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.pickedStartDate).format('D/M') : '';
      var end = this.pickedStartDate ? __WEBPACK_IMPORTED_MODULE_21_moment___default()(this.pickedStartDate).add(selectedDays - 1, 'days').format('D/M') : '';

      var hours = this.$i18n.t('skirental.day-options.hours', { hours: this.SITE_CONFIG.rental.night_hours });
      var day = this.$i18n.t('general.day');
      var days = this.$i18n.t('general.days');
      if (selectedDays) {
        if (selectedDays === 1) {
          if (this.priceType === 'night') {
            return hours + ' <span class="thin">(' + start + ')</span>';
          }
          return selectedDays + ' ' + day + ' <span class="thin">(' + start + ')</span>';
        }

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib__["e" /* hasClosedDaysInRange */])(this.pickedStartDate, selectedDays)) {
          return selectedDays + ' ' + days;
        }
        return selectedDays + ' ' + days + ' <span class="thin">(' + start + ' - ' + end + ')</span>';
      }
      return this.$i18n.t('general.pick-ski-date');
    },
    pickDate: function pickDate(payload) {
      this.$refs.dateDropdown.close();
      this.pickedStartDate = new Date(payload);
    },
    mountedDateLogic: function mountedDateLogic() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var loopStart, end, next, date, days, currentPerson, allAccomodations, allConfirmed, firstPossibleDate, tz, now, current, person, accomodations, confirmed, personBefore, original, start, startOk, enddate, iterator, itLength;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this9.validStartDates = [];
                loopStart = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.SITE_CONFIG.season.winter.start).subtract(1, 'day').toDate();
                end = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.SITE_CONFIG.season.winter.end).toDate();
                next = null;


                if (_this9.$store.state.cart.addToOrder && _this9.$store.state.cart.addToOrder.dateStart) {
                  if (__WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.$store.state.cart.addToOrder.dateStart).subtract(1, 'day').toDate() >= loopStart) {
                    loopStart = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.$store.state.cart.addToOrder.dateStart).subtract(1, 'day').toDate();
                  }
                  if (__WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.$store.state.cart.addToOrder.dateEnd).toDate() <= end) {
                    end = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.$store.state.cart.addToOrder.dateEnd).toDate();
                  }
                }

                date = null;
                days = null;
                currentPerson = _this9.$store.state.cart.rentals[_this9.$route.params.person];

                if (!currentPerson) {
                  currentPerson = {};
                }

                allAccomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.$store.state.cart.accomodations));
                allConfirmed = allAccomodations.filter(function (accomodation) {
                  return accomodation.confirmed;
                });


                if (_this9.$store.state.cart.addToOrder && _this9.$store.state.cart.addToOrder.dateStart) {
                  date = _this9.$store.state.cart.addToOrder.dateStart;
                  days = Math.round(__WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.$store.state.cart.addToOrder.dateEnd).diff(_this9.$store.state.cart.addToOrder.dateStart) / 60 / 60 / 24 / 1000) + 1;
                } else if (currentPerson.delivery) {
                  if (allConfirmed.length) {
                    if (allConfirmed[0].arrival) {
                      date = allConfirmed[0].arrival;
                      days = Math.round(__WEBPACK_IMPORTED_MODULE_21_moment___default()(allConfirmed[0].departure).diff(allConfirmed[0].arrival) / 60 / 60 / 24 / 1000) + 1;
                    } else {
                      date = allConfirmed[0].period.date_arrival;
                      days = Math.round(__WEBPACK_IMPORTED_MODULE_21_moment___default()(allConfirmed[0].period.date_departure).diff(allConfirmed[0].period.date_arrival) / 60 / 60 / 24 / 1000) + 1;
                    }
                  }
                }

                if (date) {
                  _this9.$store.state.cart.rentalDateRestriction = {
                    date: date,
                    days: days
                  };
                } else {
                  _this9.$store.state.cart.rentalDateRestriction = {};
                }

                if (_this9.$store.state.cart.rentalDateRestriction.date && _this9.$store.state.cart.rentalDateRestriction.days) {
                  loopStart = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.$store.state.cart.rentalDateRestriction.date).subtract(1, 'day').toDate();
                  end = __WEBPACK_IMPORTED_MODULE_21_moment___default()(loopStart).add(_this9.$store.state.cart.rentalDateRestriction.days, 'day').toDate();

                  firstPossibleDate = loopStart;


                  if (_this9.SITE_CONFIG.site === 'branas') {
                    firstPossibleDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()().add(1, 'day');
                  } else if (_this9.SITE_CONFIG.site === 'kungsberget') {
                    firstPossibleDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()().add(2, 'day');
                  }

                  tz = __WEBPACK_IMPORTED_MODULE_21_moment___default.a.tz.guess(true);
                  now = __WEBPACK_IMPORTED_MODULE_21_moment___default.a.tz(__WEBPACK_IMPORTED_MODULE_21_moment___default()(), tz);


                  if (now.hours() >= 12) {
                    firstPossibleDate = firstPossibleDate.add(1, 'day');
                  }

                  if (firstPossibleDate > loopStart) {
                    loopStart = firstPossibleDate.toDate();
                  }
                }

                current = loopStart;


                while (current < end) {
                  next = __WEBPACK_IMPORTED_MODULE_21_moment___default()(current).add(1, 'days');
                  if (_this9.SITE_CONFIG.season.winter.closed.indexOf(next.format('YYYY-MM-DD')) === -1) {
                    _this9.validStartDates.push(next.format('YYYY-MM-DD'));
                  }
                  current = next.toDate();
                }

                person = _this9.$store.state.cart.rentals[_this9.$route.params.person];


                if (!person) {
                  person = {};
                }

                if (!person.startDate) {
                  _context3.next = 25;
                  break;
                }

                _this9.pickedStartDate = person.startDate;
                _this9.selectedDays = person.days;
                if (window.screenSize() > window.screenMobile) {
                  if (_this9.name) {
                    _this9.stage = 16;
                  }
                } else if (_this9.name) {
                  _this9.stage = 13;
                }

                _this9.startMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.pickedStartDate).toDate();
                _context3.next = 56;
                break;

              case 25:
                accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.$store.state.cart.accomodations));
                confirmed = accomodations.filter(function (accomodation) {
                  return accomodation.confirmed;
                });
                personBefore = _this9.$store.state.cart.rentals[_this9.$route.params.person - 1];

                if (!personBefore) {
                  _context3.next = 35;
                  break;
                }

                _this9.pickedStartDate = personBefore.startDate;
                _this9.selectedDays = personBefore.days;
                _this9.startMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.pickedStartDate).toDate();
                _this9.priceType = personBefore.priceType;
                _context3.next = 56;
                break;

              case 35:
                if (!confirmed.length) {
                  _context3.next = 53;
                  break;
                }

                original = __WEBPACK_IMPORTED_MODULE_21_moment___default()(confirmed[0].period.date_arrival);
                start = null;
                startOk = false;
                enddate = __WEBPACK_IMPORTED_MODULE_21_moment___default()(confirmed[0].period.date_departure);
                iterator = 0;
                itLength = _this9.validStartDates.length;

              case 42:
                if (!(iterator < itLength)) {
                  _context3.next = 50;
                  break;
                }

                start = original.clone().add(iterator, 'days');

                if (!(_this9.validStartDates.indexOf(start.format('YYYY-MM-DD')) !== -1)) {
                  _context3.next = 47;
                  break;
                }

                startOk = true;
                return _context3.abrupt('break', 50);

              case 47:
                iterator += 1;
                _context3.next = 42;
                break;

              case 50:

                if (startOk) {
                  _this9.pickedStartDate = start.toDate();
                  _this9.pickedEndDate = enddate.toDate();
                  _this9.selectedDays = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.pickedEndDate).diff(_this9.pickedStartDate, 'days') + 1;

                  _this9.startMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this9.pickedStartDate).toDate();
                } else {
                  _this9.pickedStartDate = null;
                  _this9.selectedDays = null;

                  _this9.startMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()().toDate();
                }
                _context3.next = 56;
                break;

              case 53:
                _this9.pickedStartDate = null;
                _this9.selectedDays = null;

                _this9.startMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()().toDate();

              case 56:
                _context3.next = 58;
                return _this9.validateDate();

              case 58:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    },
    validateStep10: function validateStep10() {
      if (this.name) {
        if (this.selectedDays && window.screenSize() > window.screenMobile) {
          this.stage = 16;
        } else {
          this.stage = 13;
        }
        if (!this.loading) {
          this.selectedAge = null;
          this.selectedCategory = null;
          this.selectedSubCategory = null;
          this.selectedType = null;
          this.update();
        }
      }
    },
    validateStep13: function validateStep13() {
      if (this.name) {
        this.stage = 16;
        if (!this.loading) {
          this.selectedAge = null;
          this.selectedCategory = null;
          this.selectedSubCategory = null;
          this.selectedType = null;
          this.update();
        }
      }
    },
    validateStep16: function validateStep16() {
      if (this.selectedAge) {
        this.stage = 20;
        if (!this.loading) {
          this.selectedCategory = null;
          this.selectedSubCategory = null;
          this.selectedType = null;
          this.update();
        }
      }
    },
    pickedCategory: function pickedCategory(v) {
      var _this10 = this;

      this.selectedSubCategory = v;
      if (!this.loading) {
        if (this.selectedSubCategory === 'snowblades') {
          this.$nextTick(function () {
            var $this = _this10;
            _this10.openModal(['GeneralModal', {
              title: _this10.$i18n.t('skirental.special-rules.snowblades.title'),
              content: _this10.$i18n.t('skirental.special-rules.snowblades.content'),
              buttons: [{
                title: _this10.$i18n.t('general.i-understand'),
                class: 'small',
                click: function click() {
                  $this.closeModal();
                }
              }]
            }]);
          });
        } else if (this.selectedSubCategory === 'cross_country' && (this.selectedAge === 'children' || this.selectedAge === 'youths') && this.SITE_CONFIG.site === 'branas') {
          this.$nextTick(function () {
            var $this = _this10;
            _this10.openModal(['GeneralModal', {
              title: _this10.$i18n.t('skirental.special-rules.crosscountry-children-branas.title'),
              content: _this10.$i18n.t('skirental.special-rules.crosscountry-children-branas.content'),
              buttons: [{
                title: _this10.$i18n.t('general.i-understand'),
                class: 'small',
                click: function click() {
                  $this.closeModal();
                }
              }]
            }]);
          });
        }

        this.refreshProductsFromCategory(this.selectedAge, this.selectedSubCategory);

        this.selectedType = null;
        this.update();
      }
    },
    setCategory1: function setCategory1(category) {
      var _this11 = this;

      if (this.selectedCategory) {
        this.selectedCategory = '';
      } else {
        this.selectedCategory = category;
      }

      if (this.selectedCategory) {
        this.stage = 30;
      } else if (!this.loading) {
        this.stage = 20;
      }

      this.selectedSubCategory = null;
      this.selectedType = null;

      if (!this.loading) {
        this.update();

        if (this.selectedCategory === 'snowboard' && this.selectedAge === 'children') {
          var _$this = this;
          this.openModal(['GeneralModal', {
            title: this.$i18n.t('skirental.special-rules.snowboard-children.title'),
            content: this.$i18n.t('skirental.special-rules.snowboard-children.content'),
            buttons: [{
              title: this.$i18n.t('general.i-understand'),
              class: 'small',
              click: function click() {
                _$this.closeModal();
              }
            }]
          }]);
        } else if (this.selectedCategory === 'alpine' && this.selectedAge === 'children' && ['storstenshojden', 'tolvmannabacken'].indexOf(this.SITE_CONFIG.site) !== -1) {
          this.$nextTick(function () {
            var $this = _this11;
            _this11.openModal(['GeneralModal', {
              title: 'Hjälm ingår',
              content: 'Hjälm ingår i våra skidpaket för barn 0-6 år.',
              buttons: [{
                title: _this11.$i18n.t('general.i-understand'),
                class: 'small',
                click: function click() {
                  $this.closeModal();
                }
              }]
            }]);
          });
        }
      }

      if (this.selectedSubCategory) {
        this.refreshProductsFromCategory(this.selectedAge, this.selectedSubCategory);
      } else {
        this.refreshProductsFromAge(this.selectedAge);
      }

      var $this = this;
      if (this.selectedCategory === 'other' && !this.loading) {
        this.openModal(['SkiRentalCategories', {
          click: $this.pickedCategory,
          options: $this.subCategories
        }]);
      }

      if (this.selectedCategory === 'skipass' && !this.loading) {
        this.next();
      }
    },
    refreshProductsFromAge: function refreshProductsFromAge(age) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var date, days;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                date = '';

                if (_this12.pickedStartDate) {
                  date = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this12.pickedStartDate).format('YYYY-MM-DD');
                }
                days = _this12.selectedDays;

                _this12.setCategoriesFromSearch({ age: age, date: date, days: days });

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this12);
      }))();
    },
    refreshProductsFromCategory: function refreshProductsFromCategory(age, category) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var date, days;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                date = '';

                if (_this13.pickedStartDate) {
                  date = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this13.pickedStartDate).format('YYYY-MM-DD');
                }
                days = _this13.selectedDays;

                _this13.setCategoriesFromSearch({ age: age, date: date, days: days, category: category });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this13);
      }))();
    },
    setAge: function setAge(value, skipWarning) {
      if (!this.loading) {
        if (this.stage < 16 && (typeof skipWarning === 'undefined' || !skipWarning)) {
          this.openWarningModal();
          return;
        }
      }

      if (this.selectedAge) {
        this.selectedAge = '';
      } else {
        this.selectedAge = value;
      }

      if (this.selectedAge) {
        this.stage = 20;
      } else if (!this.loading) {
        this.stage = 16;
      }

      if (!this.selectedDays) {
        this.stage = 13;
      }

      this.selectedCategory = null;
      this.selectedSubCategory = null;
      this.selectedType = null;

      this.refreshProductsFromAge(this.selectedAge);
      if (!this.loading) {
        this.update();
      }
    },
    update: function update(forceOverwrite) {
      if (!this.loading) {
        this.updateRentalPerson({
          index: this.$route.params.person,
          name: (this.name || '').toString().toUpperCase(),
          age: this.selectedAge,
          category: this.selectedCategory,
          subCategory: this.selectedSubCategory,
          type: this.selectedType,
          searchPackage: this.pickLevel() ? this.searchPackage : '',
          startDate: this.pickedStartDate,
          days: this.selectedDays,
          priceType: this.priceType,
          forceOverwrite: forceOverwrite
        });
      }
    },
    next: function next() {
      if (!this.selectedDays) {
        this.openModal(['GeneralModal', {
          title: this.$i18n.t('skirental.rules.pick-date-title'),
          content: this.$i18n.t('skirental.rules.pick-date')
        }]);
        return;
      }

      this.update(true);

      var index = parseInt(this.$route.params.person, 10) || 0;
      if (this.selectedCategory === 'skipass' && !this.loading) {
        this.$store.state.cart.rentals[index].onlySkipass = true;
      } else {
        this.$store.state.cart.rentals[index].onlySkipass = false;
      }

      this.$router.push({
        path: '/skidhyra/' + this.$route.params.person + '/produkter',
        query: {
          age: this.selectedAge,
          category: this.selectedSubCategory || this.selectedCategory,
          type: this.selectedType,
          level: this.pickLevel() ? this.searchPackage : ''
        }
      });
    },
    pickLevel: function pickLevel() {
      if (!this.SITE_CONFIG.rental.use_levels) {
        return false;
      }
      return this.selectedType === 'package' && this.selectedCategory === 'alpine' && (this.selectedAge === 'youths' || this.selectedAge === 'adults' || this.selectedAge === 'children' || this.selectedAge === 'seniors');
    },
    setType: function setType(type) {
      if (this.selectedType) {
        this.selectedType = '';
      } else {
        this.selectedType = type;
      }

      if (this.selectedType === 'package') {
        this.stage = 40;
      } else if (!this.loading) {
        this.stage = 30;
      }

      var specialCombo = this.pickLevel();

      if (this.loading) {
        if (!specialCombo) {
          this.selectedType = null;
          if (this.stage === 40) {
            this.stage = 30;
          }
        } else {
          this.searchPackage = null;
        }
      }

      if (!this.loading && specialCombo) {
        this.update();
      } else if (!this.loading && this.selectedType) {
        this.next();
      }
    },
    setPackage: function setPackage(p) {
      this.searchPackage = p;
      if (this.searchPackage) {
        this.stage = 50;
      }

      if (this.loading) {
        if (this.stage === 50) {
          this.searchPackage = null;
          this.stage = 40;
        }
      }

      if (!this.loading) {
        this.next();
      }
    },
    remove: function remove() {
      var $this = this;
      var index = $this.$route.params.person;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('skirental.remove-confirmation', { skier: this.name }),
        buttons: [{
          title: this.$i18n.t('general.yes'),
          class: 'small',
          click: function click() {
            $this.$store.state.cart.rentals.splice(index, 1);
            $this.closeModal();
            $this.$router.push({ name: 'ski rental overview' });
          }
        }, {
          title: this.$i18n.t('general.no'),
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    validateDate: function validateDate() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var start, _ref2, success;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this14.pickedStartDate && _this14.selectedDays)) {
                  _context6.next = 7;
                  break;
                }

                start = __WEBPACK_IMPORTED_MODULE_21_moment___default()(_this14.pickedStartDate).format('YYYY-MM-DD');
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('config/is-rental-dates-allowed?date=' + start + '&days=' + _this14.selectedDays);

              case 4:
                _ref2 = _context6.sent;
                success = _ref2.success;

                if (!success) {
                  _this14.pickedStartDate = null;
                  _this14.selectedDays = null;
                  _this14.startMonth = __WEBPACK_IMPORTED_MODULE_21_moment___default()().toDate();
                  _this14.pickedEndDate = null;
                }

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this14);
      }))();
    },
    fetchSkiers: function fetchSkiers() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _ref3, skiers;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this15.loadingSkiers = true;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('/account/user');

              case 3:
                _ref3 = _context7.sent;
                skiers = _ref3.skiers;

                _this15.skiers = skiers || [];
                _this15.loadingSkiers = false;

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this15);
      }))();
    },
    onLogin: function onLogin() {
      this.fetchSkiers();
    },
    setSkier: function setSkier(value) {
      var skier = this.skiers.find(function (s) {
        return s.guid === value.value;
      });
      this.skier = skier || {};

      if (!skier) {
        this.name = '';
        this.selectedAge = null;
        this.validateName(new Event('input'));
        this.validateStep10({});
        this.setAge(null);
        this.updateMeasurements(null, null, null, null, null);
        return;
      }

      this.name = (skier.first_name || '') + ' ' + (skier.last_name || '');

      var age = skier.age_category;

      this.validateName(new Event('input'));
      this.validateStep10({});
      this.setAge(age, true);
      this.updateMeasurements(skier.measurement_height, skier.measurement_weight, skier.measurement_shoe_size, skier.measurement_clothsize, skier);
    },
    updateMeasurements: function updateMeasurements(height, weight, shoeSize, clothsize, skier) {
      this.updateRentalPersonMeasurements({
        index: this.$route.params.person,
        lengthCm: parseInt(height, 10) || null,
        weight: parseInt(weight, 10) || null,
        shoeSize: parseInt(shoeSize, 10) || null,
        clothsize: clothsize || null,
        skier: skier
      });
    }
  })
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Back__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_List_Filter_FilterListItem__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_List_Filter_FilterListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_List_Filter_FilterListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_rentalTimelineSteps__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_measurements__ = __webpack_require__(116);
























/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      people: [],
      nextIndex: 0,
      currentIndex: 0,
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen'
      },
      lengthOptions: {},
      categories: {},
      validStartDates: [],
      allAddons: [],
      touched: {},
      helmet_id: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_rentalTimelineSteps__["a" /* default */]],
  components: {
    Timeline: __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline___default.a,
    FilterListItem: __WEBPACK_IMPORTED_MODULE_11__components_parts_Accomodation_List_Filter_FilterListItem___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown___default.a,
    OnSiteFooter: __WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter___default.a,
    Back: __WEBPACK_IMPORTED_MODULE_10__components_components_Back___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_12__components_components_LanguageSwitcher___default.a
  },
  mounted: function mounted() {
    this.ages = {
      children: this.$i18n.t('general.ages.child'),
      youths: this.$i18n.t('general.ages.youth'),
      adults: this.$i18n.t('general.ages.adult')
    };

    this.reMount();
  },

  computed: {
    sum: function sum() {
      var total = this.people.reduce(function (a, person) {
        return a + person.products.reduce(function (b, product) {
          return b + product.price;
        }, 0) + person.addons.reduce(function (b, product) {
          return b + product.price;
        }, 0);
      }, 0);
      if (this.SITE_CONFIG.rental.delivery_fee_active && this.hasDelivery && !this.parentHasFee) {
        total += parseFloat(this.SITE_CONFIG.rental.delivery_fee_price) || 0;
      }
      return total;
    },
    parentHasFee: function parentHasFee() {
      if (this.$store.state.cart.parent_has_delivery_fee) {
        return true;
      }
      var feePoolLid = this.SITE_CONFIG.rental.delivery_fee_pool_lid;
      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.lines) {
        return this.$store.state.cart.addToOrder.lines.some(function (l) {
          return l.status !== 'C' && parseInt(l.poolId, 10) === parseInt(feePoolLid, 10);
        });
      }

      var accomodations = this.$store.state.cart.accomodations || [];
      var confirmed = accomodations.filter(function (a) {
        return a.confirmed;
      });
      if (confirmed.length && confirmed[0].parent_has_delivery_fee) {
        return true;
      }
      return false;
    },
    hasDelivery: function hasDelivery() {
      return this.people.some(function (r) {
        return r.guideCompleted && r.delivery;
      });
    },
    wishesLabels: function wishesLabels() {
      return {
        wideCalf: this.$i18n.t('skirental.wishes.options.wideCalf'),
        wideFoot: this.$i18n.t('skirental.wishes.options.wideFoot'),
        softShoes: this.$i18n.t('skirental.wishes.options.softShoes'),
        hardShoes: this.$i18n.t('skirental.wishes.options.hardShoes'),
        shortTurn: this.$i18n.t('skirental.wishes.options.shortTurn'),
        longTurn: this.$i18n.t('skirental.wishes.options.longTurn'),
        startSki: this.$i18n.t('skirental.wishes.options.skis'),
        startSnowboard: this.$i18n.t('skirental.wishes.options.snowboard'),
        preferedFootLeft: this.$i18n.t('skirental.wishes.options.preferedFootLeft'),
        preferedFootRight: this.$i18n.t('skirental.wishes.options.preferedFootRight'),
        freeText: this.$i18n.t('skirental.wishes.own')
      };
    },
    guideCompleted: function guideCompleted() {
      return this.people.filter(function (person) {
        return person.guideCompleted;
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['openModal', 'confirmRental', 'completeGuides', 'addRentalAddon', 'removeRentalAddon', 'addRentalPeople', 'closeModal', 'closeAllModals', 'clearCart', 'setGuideCompleted']), {
    required: function required(index, type) {
      var person = this.people[index];

      var weight = false;
      var length = false;
      var shoesize = false;
      var pantsize = false;
      var jacketsize = false;
      var clothsize = false;

      person.products.forEach(function (product) {
        weight = product.required.weight ? true : weight;
        length = product.required.lengthCm ? true : length;
        shoesize = product.required.shoesize ? true : shoesize;
        pantsize = product.required.pantsize ? true : pantsize;
        jacketsize = product.required.jacketsize ? true : jacketsize;
        clothsize = product.required.clothsize ? true : clothsize;
      });

      person.addons.forEach(function (addon) {
        weight = addon.required.weight ? true : weight;
        length = addon.required.lengthCm ? true : length;
        shoesize = addon.required.shoesize ? true : shoesize;
        pantsize = addon.required.pantsize ? true : pantsize;
        jacketsize = addon.required.jacketsize ? true : jacketsize;
        clothsize = addon.required.clothsize ? true : clothsize;
      });

      if (type === 'weight') {
        return weight;
      }
      if (type === 'lengthCm') {
        return length;
      }
      if (type === 'shoeSize') {
        return shoesize;
      }
      if (type === 'pantsize') {
        return pantsize;
      }
      if (type === 'jacketsize') {
        return jacketsize;
      }
      if (type === 'clothsize') {
        return clothsize;
      }

      return false;
    },
    productSizes: function productSizes(person, type) {
      var sizes = [];

      person.products.forEach(function (product) {
        console.log('SkiRentalUserOverview.vue productSizes', product, type);
        product[type].forEach(function (size) {
          sizes.push(size);
        });
      });

      person.addons.forEach(function (addon) {
        addon[type].forEach(function (size) {
          sizes.push(size);
        });
      });

      var newSizes = sizes.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });

      return newSizes.map(function (size) {
        return {
          value: size,
          title: size
        };
      });
    },
    reMount: function reMount() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var shoeMinChildren, loopStart, current, end, next, completed, fullyCompleted, _ref, meta, index, $this, person, category, date, _ref2, data, buy;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.$route.query['add-more']) {
                  _this.addPerson(true);
                }

                shoeMinChildren = 25;


                if (_this.SITE_CONFIG.site === 'branas') {
                  shoeMinChildren = 24;
                }

                _this.lengthOptions.children = _this.createValidMeasurements({
                  cmMin: 85,
                  cmMax: 150,
                  kgMin: 15,
                  kgMax: 45,
                  shoeMin: shoeMinChildren,
                  shoeMax: 39,
                  clothGroup: 'child_youth'
                });
                _this.lengthOptions.youths = _this.createValidMeasurements({
                  cmMin: 120,
                  cmMax: 185,
                  kgMin: 25,
                  kgMax: 100,
                  shoeMin: 32,
                  shoeMax: 49,
                  clothGroup: 'child_youth'
                });
                _this.lengthOptions.adults = _this.createValidMeasurements({
                  cmMin: 120,
                  cmMax: 195,
                  kgMin: 40,
                  kgMax: 130,
                  shoeMin: 32,
                  shoeMax: 49,
                  clothGroup: 'adult'
                });
                _this.lengthOptions.seniors = _this.createValidMeasurements({
                  cmMin: 120,
                  cmMax: 195,
                  kgMin: 40,
                  kgMax: 130,
                  shoeMin: 32,
                  shoeMax: 49,
                  clothGroup: 'adult'
                });

                _this.validStartDates = [];
                loopStart = __WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.SITE_CONFIG.season.winter.start).subtract(1, 'day').toDate();
                current = loopStart;
                end = __WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.SITE_CONFIG.season.winter.end).toDate();
                next = null;


                while (current < end) {
                  next = __WEBPACK_IMPORTED_MODULE_15_moment___default()(current).add(1, 'days');
                  if (_this.SITE_CONFIG.season.winter.closed.indexOf(next.format('YYYY-MM-DD')) === -1) {
                    _this.validStartDates.push(next.format('YYYY-MM-DD'));
                  }
                  current = next.toDate();
                }

                _this.people = _this.$store.state.cart.rentals;completed = _this.people.filter(function (person) {
                  return person.guideCompleted;
                });
                fullyCompleted = _this.people.filter(function (person) {
                  return person.guideFullyCompleted;
                });

                _this.nextIndex = completed.length;
                _this.currentIndex = fullyCompleted.length;

                if (completed.length === _this.people.length) {
                  _this.nextIndex = 0;
                }

                if (!completed.length) {
                  _this.$router.replace({ name: 'ski rental' });
                }

                _context.next = 22;
                return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/skiletting/search?age=&type=' + _this.selectedType + '&level=' + _this.selectedLevel + '&category=' + _this.selectedCategory + '&addon=1');

              case 22:
                _ref = _context.sent;
                meta = _ref.meta;

                _this.categories = meta.categories_all;
                _this.helmet_id = meta.helmet_id;

                index = 0;
                $this = _this;
                _context.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this.people);

              case 29:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 46;
                  break;
                }

                index = _context.t1.value;
                person = _this.people[index];

                if (person.onlySkipass) {
                  _context.next = 44;
                  break;
                }

                category = person.subCategory || person.category;
                date = '';

                if (person.startDate) {
                  date = __WEBPACK_IMPORTED_MODULE_15_moment___default()(person.startDate).format('YYYY-MM-DD');
                }
                _context.next = 38;
                return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/skiletting/search?age=' + person.age + '&addon=1&days=' + person.days + '&date=' + date + '&addon-filter-category=' + category);

              case 38:
                _ref2 = _context.sent;
                data = _ref2.data;
                buy = _ref2.buy;

                _this.people[index].possibleAddons = data;
                _this.people[index].possibleBuy = [];
                buy.forEach(function (product) {
                  var newProduct = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, product);
                  newProduct.buy = true;
                  _this.people[index].possibleBuy.push(newProduct);
                });

              case 44:
                _context.next = 29;
                break;

              case 46:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    lengthOptionsCalculated: function lengthOptionsCalculated(person) {
      if (person.category === 'snowboard') {
        return this.lengthOptions[person.age].lengthOptions.filter(function (v) {
          return v.value >= 100;
        });
      }
      if (this.SITE_CONFIG.site === 'kungsberget') {
        if (person.subCategory === 'cross_country') {
          return this.lengthOptions[person.age].lengthOptions.filter(function (v) {
            return v.value >= 135;
          });
        }
      }

      var code = person.products.map(function (p) {
        return p.code;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).join('|');

      if (code === 'WE RYGGSKYDD') {
        return this.lengthOptions[person.age].lengthOptions.filter(function (v) {
          return v.value >= 110;
        });
      }
      if (code === 'WE SKIDKLÄDER' || code === 'WE HYRKLÄDER SET' || code === 'WE HYRKLÄDER JACKA' || code === 'WE HYRKLÄDER BYXA' || code === 'WE SKIDJACKA' || code === 'WE SKIDBYXA') {
        return this.lengthOptions[person.age].lengthOptions.filter(function (v) {
          return v.value >= 125;
        });
      }
      return this.lengthOptions[person.age].lengthOptions;
    },
    shoesizeOptionsCalculated: function shoesizeOptionsCalculated(person) {
      if (this.SITE_CONFIG.site === 'vallasen') {
        if (person.category === 'snowboard') {
          return this.lengthOptions[person.age].shoeSizeOptions.filter(function (v) {
            return v.value >= 33;
          });
        }
      }
      if (this.SITE_CONFIG.site === 'kungsberget') {
        if (person.subCategory === 'cross_country') {
          return this.lengthOptions[person.age].shoeSizeOptions.filter(function (v) {
            return v.value >= 33 && v.value <= 47;
          });
        }
      }
      return this.lengthOptions[person.age].shoeSizeOptions;
    },
    createValidMeasurements: function createValidMeasurements(config) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_measurements__["a" /* createValidMeasurements */])(config, this.$i18n.t.bind(this.$i18n));
    },
    touch: function touch(index, key) {
      if (!this.touched[index]) {
        this.touched[index] = {};
        this.$set(this.touched, index, {});
      }
      this.$set(this.touched[index], key, true);
    },
    showError: function showError(index, key, considerTouched) {
      if (!this.required(index, key)) {
        return '';
      }

      if (considerTouched) {
        if (!this.touched[index] || !this.touched[index][key]) {
          return '';
        }
      }

      var person = this.people[index];
      var value = person[key];
      var min = 0;
      var max = 0;

      var cols = {
        weight: this.$i18n.t('skirental.measurements.weight'),
        lengthCm: this.$i18n.t('skirental.measurements.length'),
        shoeSize: this.$i18n.t('skirental.measurements.shoesize'),
        pantsize: 'Byxstorlek',
        jacketsize: 'Jackstorlek',
        clothsize: 'Klädstorlek'
      };

      if (key === 'weight') {
        min = this.lengthOptions[person.age].weightOptions[0].value;
        max = this.lengthOptions[person.age].weightOptions[this.lengthOptions[person.age].weightOptions.length - 1].value;
      }
      if (key === 'lengthCm') {
        min = this.lengthOptionsCalculated(person);
        max = this.lengthOptionsCalculated(person)[this.lengthOptionsCalculated(person).length - 1];
        min = min[0].value;
        max = max.value;
      }
      if (key === 'shoeSize') {
        min = this.lengthOptions[person.age].shoeSizeOptions[0].value;
        max = this.lengthOptions[person.age].shoeSizeOptions[this.lengthOptions[person.age].shoeSizeOptions.length - 1].value;
      }

      var title = cols[key];

      if (!value) {
        return this.$i18n.t('skirental.rules.mandatory', { field: title });
      }

      if (key === 'pantsize' || key === 'jacketsize') {
        return '';
      }

      if (value < min) {
        return this.$i18n.t('skirental.rules.min', { field: title, min: min });
      }
      if (value > max) {
        return this.$i18n.t('skirental.rules.max', { field: title, max: max });
      }

      return '';
    },
    addPerson: function addPerson(replace) {
      this.touchAll();
      if (!this.validate()) {
        return false;
      }

      var peopleToClone = this.$store.state.cart.rentals.filter(function (rental) {
        return rental.guideCompleted;
      });

      this.addRentalPeople({
        peopleCount: 1,
        pickedStartDate: peopleToClone[0].startDate,
        numberOfDays: peopleToClone[0].days,
        delivery: peopleToClone[0].delivery,
        deliveryTo: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, peopleToClone[0].deliveryTo),
        append: true,
        priceType: peopleToClone[0].priceType
      });
      this.completeGuides();
      var next = this.$store.state.cart.rentals.length - 1;

      if (replace) {
        this.$router.replace({ path: '/skidhyra/' + next });
      } else {
        this.$router.push({ path: '/skidhyra/' + next });
      }
    },
    productIsAdded: function productIsAdded(personIndex, product) {
      var addons = this.people[personIndex].addons;
      var isMatch = false;
      addons.forEach(function (addon) {
        if (addon.pool_lid === product.pool_lid) {
          isMatch = true;
        }
      });
      return isMatch;
    },
    showProduct: function showProduct(personIndex, product) {
      var products = this.people[personIndex].products;
      var show = true;
      var ids = [this.helmet_id];

      this.people[personIndex].products.forEach(function (userProduct) {
        if (userProduct.includes_helmet) {
          if (ids.indexOf(product.pool_lid) !== -1) {
            show = false;
          }
        }
        if (userProduct.pool_lid === product.pool_lid) {
          show = false;
        }
      });

      return show;
    },
    addAddon: function addAddon(personIndex, product, keep) {
      var newProduct = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, product);
      if (!this.productIsAdded(personIndex, product)) {
        var days = this.people[personIndex].days;
        var prefix = this.people[personIndex].priceType === 'night' ? '_night' : '';
        newProduct.price = newProduct.prices['' + days + prefix].normal;
        newProduct.price_insurance = newProduct.prices['' + days + prefix].with_insurance;
        this.addRentalAddon({
          index: personIndex,
          product: newProduct
        });
      } else if (!keep) {
        this.removeRentalAddon({
          index: personIndex,
          product: newProduct
        });
      }

      var addons = this.people[personIndex].addons.filter(function (p) {
        return p.categories.filter(function (c) {
          return c.slug === 'skipass';
        }).length ? false : true;
      });
      var products = this.people[personIndex].products.filter(function (p) {
        return p.categories.filter(function (c) {
          return c.slug === 'skipass';
        }).length ? false : true;
      });

      var sum = addons.length + products.length;

      this.$store.state.cart.rentals[personIndex].onlySkipass = !sum;
    },
    removeWish: function removeWish(personIndex, wishIndex) {
      var _this2 = this;

      var confirm = false;

      if (wishIndex === 'freeText') {
        this.openModal(['GeneralModal', {
          title: 'Är du säker?',
          content: 'Vill du ta bort f\xF6ljande \xF6nskem\xE5l? <br><br> "' + this.people[personIndex].wishes[wishIndex] + '"',
          yes: function yes() {
            _this2.people[personIndex].wishes[wishIndex] = '';
            _this2.closeModal();
          },
          no: function no() {
            _this2.closeModal();
          }
        }]);
      } else {
        this.people[personIndex].wishes[wishIndex] = false;
      }
    },
    pickWishes: function pickWishes(payload) {
      for (var i in payload) {
        this.people[this.currentIndex].wishes[i] = payload[i];
      }
    },
    openWishes: function openWishes() {
      this.openModal(['SkiRentalWishes', {
        click: this.pickWishes,
        person: this.people[this.currentIndex],
        wishes: this.people[this.currentIndex].wishes
      }]);
    },
    remove: function remove(index) {
      var $this = this;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('skirental.remove-confirmation', { skier: this.people[index].name }),
        buttons: [{
          title: this.$i18n.t('general.yes'),
          class: 'small',
          click: function click() {
            $this.currentIndex = 0;
            $this.$store.state.cart.rentals.splice(index, 1);
            $this.reMount();
            $this.closeModal();
          }
        }, {
          title: this.$i18n.t('general.no'),
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    selectDates: function selectDates(start, end, type) {
      if (start) {
        this.$store.state.cart.rentals[this.currentIndex].startDate = start;
        var newEnd = end;
        if (!newEnd) {
          newEnd = start;
        }

        this.$store.state.cart.rentals[this.currentIndex].priceType = type;
        this.$store.state.cart.rentals[this.currentIndex].days = __WEBPACK_IMPORTED_MODULE_15_moment___default()(newEnd).diff(start, 'days') + 1;

        this.updatePrices();
      }

      this.people[this.currentIndex].editing = false;
    },
    updatePrices: function updatePrices() {
      var person = this.$store.state.cart.rentals[this.currentIndex];
      var newProducts = [];
      var newAddons = [];
      var prefix = person.priceType === 'night' ? '_night' : '';
      person.products.forEach(function (product) {
        var newProduct = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, product);
        newProduct.price = parseInt(product['price_' + person.days + prefix], 10);
        newProducts.push(newProduct);
      });
      person.addons.forEach(function (addon) {
        var newAddon = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, addon);
        newAddon.price = parseInt(addon['price_' + person.days + prefix], 10);
        newAddons.push(newAddon);
      });
      person.products = newProducts;
      person.addons = newAddons;
    },
    changeDate: function changeDate() {
      var person = this.$store.state.cart.rentals[this.currentIndex];
      this.people[this.currentIndex].editing = true;
      this.openModal(['DatepickerRangeModal', {
        validDates: this.validStartDates,
        pickedStartDate: person.startDate,
        pickedEndDate: person.days > 1 ? __WEBPACK_IMPORTED_MODULE_15_moment___default()(person.startDate).add(person.days - 1, 'days') : null,
        onClose: this.selectDates,
        onPickStart: this.setEndDates,
        night: this.SITE_CONFIG.season.winter.night
      }]);
    },
    setEndDates: function setEndDates() {
      var _this3 = this;

      var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        resolve(_this3.SITE_CONFIG.rental.days_max);
      });
      return promise;
    },
    dateRange: function dateRange(person) {
      var start = __WEBPACK_IMPORTED_MODULE_15_moment___default()(person.startDate).toDate();
      var end = __WEBPACK_IMPORTED_MODULE_15_moment___default()(person.startDate).add(person.days - 1, 'days').toDate();
      return [start, end];
    },
    setActive: function setActive(item) {
      this.currentIndex = item;
    },
    next: function next() {
      this.touchAll();
      if (!this.validate()) {
        return false;
      }
      this.completeGuides();
      this.$router.push({ path: '/skidhyra/' + this.nextIndex });
    },
    addUsersToCart: function addUsersToCart(config) {
      this.confirmRental(config);
      if (config.onlySave) {
        return;
      }
      if (config.noRedirect) {
        this.createOrderAndRedirect();
        return;
      }
      if (this.$store.state.isOnSite) {
        return;
      }

      var products = [];
      this.$store.state.cart.rentals.forEach(function (rental) {
        rental.products.forEach(function (addon) {
          products.push(addon);
        });
        rental.addons.forEach(function (addon) {
          products.push(addon);
        });
      });

      window.trackAddToCart({
        title: 'Skidhyra',
        lines: products.map(function (product) {
          return {
            id: product.pool_lid,
            title: product.code,
            category: 'equipment',
            quantity: 1,
            price: product.price
          };
        })
      });

      this.closeModal();

      if (config.payDirect) {
        this.$router.push({ path: '/varukorg?pay=1' });
      } else {
        this.$router.push({ path: '/varukorg?show-confirmation=1&ref=skirental' });
      }
      return;
    },
    createOrderAndRedirect: function createOrderAndRedirect() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.openModal(['CreatingOrder']);

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    touchAll: function touchAll() {
      var $this = this;
      this.people.forEach(function (person, index) {
        $this.$set($this.touched, index, {});
        $this.$set($this.touched[index], 'lengthCm', true);
        $this.$set($this.touched[index], 'weight', true);
        $this.$set($this.touched[index], 'shoeSize', true);
        $this.$set($this.touched[index], 'pantsize', true);
        $this.$set($this.touched[index], 'jacketsize', true);
        $this.$set($this.touched[index], 'clothsize', true);
      });
    },
    doRental: function doRental() {
      this.touchAll();
      if (!this.validate()) {
        return false;
      }
      this.openModal(['SkiRentalConfirm', {
        done: this.addUsersToCart
      }]);
    },
    addons: function addons() {
      return this.allAddons;
    },
    validate: function validate() {
      var _this5 = this;

      var validated = true;
      var $this = this;
      this.people.forEach(function (person, index) {
        if (person.guideCompleted) {
          var invalid = _this5.showError(index, 'lengthCm') || _this5.showError(index, 'weight') || _this5.showError(index, 'shoeSize') || _this5.showError(index, 'pantsize') || _this5.showError(index, 'jacketsize') || _this5.showError(index, 'clothsize');
          if (invalid) {
            validated = false;
          }
          if (!person.addons.length && !person.products.length) {
            validated = false;
          }
        }
      });
      return validated;
    },
    goBack: function goBack() {
      var person = this.people[this.currentIndex];
      if (typeof person === 'undefined') {
        var people = this.people.filter(function (person) {
          return person.guideCompleted;
        });
        person = people[people.length - 1];
        this.currentIndex = people.length - 1;
      }
      this.$router.push('/skidhyra/' + this.currentIndex + '/produkter?age=' + person.age + '&category=' + person.category + '&type=' + person.type + '&level=' + person.searchPackage);
    },
    infoPopup: function infoPopup(item) {
      this.openModal(['GeneralModal', {
        title: item.name,
        content: item.description
      }]);
    },
    hasClosedDaysInRange: function hasClosedDaysInRange(person) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib__["e" /* hasClosedDaysInRange */])(person.startDate, person.days);
    }
  })
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_OnSiteFooter__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_OnSiteFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_OnSiteFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Back__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_rentalTimelineSteps__ = __webpack_require__(82);



















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      allProducts: [],
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen',
        seniors: 'Senior'
      },
      selectedAge: null,
      selectedCategory: null,
      selectedSubCategory: null,
      selectedType: null,
      selectedPackage: null,
      selectedProducts: [],
      selectedProductsBackup: [],
      selectedLevel: null,
      categories: {},
      showPackageInfo: false,
      loading: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_rentalTimelineSteps__["a" /* default */]],
  components: {
    Timeline: __WEBPACK_IMPORTED_MODULE_6__components_components_Timeline___default.a,
    OnSiteFooter: __WEBPACK_IMPORTED_MODULE_7__components_components_OnSiteFooter___default.a,
    Back: __WEBPACK_IMPORTED_MODULE_9__components_components_Back___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_10__components_components_LanguageSwitcher___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.ages = {
                children: _this.$i18n.t('general.ages.child'),
                youths: _this.$i18n.t('general.ages.youth'),
                adults: _this.$i18n.t('general.ages.adult'),
                seniors: _this.$i18n.t('general.ages.senior')
              };

              _this.startup();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {},
  watch: {
    $route: function $route() {
      this.startup();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    startup: function startup() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var days, date, _ref, data, meta, buy;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _this2.person = _this2.$store.state.cart.rentals[_this2.$route.params.person];
                days = _this2.person.days;


                _this2.selectedAge = _this2.$route.query.age;
                _this2.selectedCategory = _this2.$route.query.category;
                _this2.selectedSubCategory = _this2.$route.query.category2;
                _this2.selectedType = _this2.$route.query.type;
                _this2.selectedPackage = _this2.$route.query.package;
                _this2.selectedLevel = _this2.$route.query.level;

                date = '';

                if (_this2.person.startDate) {
                  date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this2.person.startDate).format('YYYY-MM-DD');
                }

                _context2.next = 13;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/skiletting/search?age=' + _this2.selectedAge + '&type=' + _this2.selectedType + '&level=' + _this2.selectedLevel + '&category=' + _this2.selectedCategory + '&date=' + date + '&days=' + days);

              case 13:
                _ref = _context2.sent;
                data = _ref.data;
                meta = _ref.meta;
                buy = _ref.buy;

                _this2.allProducts = data;
                _this2.categories = meta.categories_all;

                buy.forEach(function (product) {
                  product.buy = true;
                  _this2.allProducts.push(product);
                });

                _this2.loading = false;

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'addProducts', 'closeModal']), {
    infoPopup: function infoPopup(item) {
      var suffix = '';

      this.openModal(['GeneralModal', {
        title: item.name,
        content: item.description
      }]);

      suffix = this.person.priceType === 'night' ? '_night' : '';

      window.trackViewItem({
        title: 'Skidhyra',
        lines: [{
          id: item.pool_lid,
          title: item.code,
          category: 'equipment',
          quantity: 1,
          price: item['price_' + this.person.days + suffix]
        }]
      });
    },
    setActive: function setActive(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var index, suffix, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                index = _this3.selectedProducts.indexOf(item);

                if (index !== -1) {
                  _this3.selectedProducts.splice(index, 1);
                } else {
                  suffix = '';


                  _this3.selectedProducts.push(item);

                  suffix = _this3.person.priceType === 'night' ? '_night' : '';

                  window.trackViewItem({
                    title: 'Skidhyra',
                    lines: [{
                      id: item.pool_lid,
                      title: item.code,
                      category: 'equipment',
                      quantity: 1,
                      price: item['price_' + _this3.person.days + suffix]
                    }]
                  });
                }

                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].frontendHelper('skirental/check-for-package?age=' + _this3.selectedAge, _this3.selectedProducts);

              case 4:
                data = _context3.sent;

                _this3.showPackageInfo = data.package;

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    goToPackages: function goToPackages() {
      this.$router.push({
        path: '/skidhyra/' + this.$route.params.person + '/produkter',
        query: {
          age: this.$route.query.age,
          category: this.$route.query.category,
          category2: this.$route.query.category2,
          type: 'package',
          package: this.$route.query.package,
          level: this.$route.query.level,
          'from-single': 1
        }
      });

      this.selectedProducts = [];
      this.showPackageInfo = false;
    },
    goToSingle: function goToSingle() {
      this.$router.push({
        path: '/skidhyra/' + this.$route.params.person + '/produkter',
        query: {
          age: this.$route.query.age,
          category: this.$route.query.category,
          category2: this.$route.query.category2,
          type: 'single',
          package: this.$route.query.package,
          level: this.$route.query.level
        }
      });

      this.selectedProducts = [];
      this.showPackageInfo = true;
    },
    pickedProducts: function pickedProducts() {
      if (this.typeObject && this.typeObject.data) {
        return this.typeObject.data.filter(function (item) {
          return item.picked;
        });
      }
      return [];
    },
    next: function next() {
      var _this4 = this;

      var products = [];
      this.allProducts.forEach(function (item) {
        var index = _this4.selectedProducts.indexOf(item);
        var product = item;
        if (index !== -1) {
          product.price = product.prices[_this4.person.days + (_this4.person.priceType === 'night' ? '_night' : '')].normal;
          product.price_insurance = product.prices[_this4.person.days + (_this4.person.priceType === 'night' ? '_night' : '')].with_insurance;
          products.push(product);
        }
      });

      this.addProducts({
        index: this.$route.params.person,
        products: products
      });
      this.$router.push({ name: 'ski rental overview' });
    },
    remove: function remove() {
      var $this = this;
      var index = $this.$route.params.person;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('skirental.remove-confirmation', { skier: this.person.name }),
        buttons: [{
          title: this.$i18n.t('general.yes'),
          class: 'small',
          click: function click() {
            $this.$store.state.cart.rentals.splice(index, 1);
            $this.closeModal();
            $this.$router.push({ name: 'ski rental overview' });
          }
        }, {
          title: this.$i18n.t('general.no'),
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    goBack: function goBack() {
      this.$router.push('/skidhyra/' + this.$route.params.person);
    }
  })
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolList__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_SkiSchool_SkiSchoolFilter__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_SkiSchool_SkiSchoolFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_parts_SkiSchool_SkiSchoolFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_SkiSchool_SkiSchoolFilterInfo__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_SkiSchool_SkiSchoolFilterInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_SkiSchool_SkiSchoolFilterInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_deprecated_OutlineButton__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_deprecated_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_deprecated_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(3);





















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SkiSchoolList: __WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolList___default.a,
    SkiSchoolFilter: __WEBPACK_IMPORTED_MODULE_4__components_parts_SkiSchool_SkiSchoolFilter___default.a,
    SkiSchoolFilterInfo: __WEBPACK_IMPORTED_MODULE_5__components_parts_SkiSchool_SkiSchoolFilterInfo___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default.a,
    OutlineButton: __WEBPACK_IMPORTED_MODULE_7__components_deprecated_OutlineButton___default.a,
    OnSiteFooter: __WEBPACK_IMPORTED_MODULE_8__components_components_OnSiteFooter___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_9__components_components_LanguageSwitcher___default.a
  },
  data: function data() {
    return {
      data: [],
      count: 0,
      loading: false,
      expanded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.SITE_CONFIG.closed_modules.school) {
      this.openModal(['GeneralModal', {
        content: this.SITE_CONFIG.closed_modules.school,
        ok: function ok() {
          _this.$router.go(-1);
        },
        closeModal: function closeModal() {
          _this.$router.go(-1);
        }
      }]);
      return;
    }

    if (this.$route.query.type === 'snowboard') {
      for (var i in this.$store.state.skiSchoolFilter) {
        if (this.$store.state.skiSchoolFilter[i]) {
          if (i === 'date') {
            this.$store.state.skiSchoolFilter[i] = null;
          } else if (parseInt(i.substr(0, 1))) {
            this.$store.state.skiSchoolFilter[i] = false;
          } else {
            this.$store.state.skiSchoolFilter[i] = false;
          }
        }
      }
    }

    this.change();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapGetters */])(['isAwaitingFilter']), {
    isWinter: function isWinter() {
      return this.$route.name === 'ski school overview';
    },
    isSummer: function isSummer() {
      return this.$route.name === 'bike school overview';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapMutations */])(['openModal']), {
    openFaq: function openFaq() {
      this.openModal(['SkiSchoolFaq', {}]);
    },
    change: function change() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var query, date, i, season, _ref, data, count;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                query = '';
                date = '';


                for (i in _this2.$store.state.skiSchoolFilter) {
                  if (_this2.$store.state.skiSchoolFilter[i]) {
                    if (i === 'date') {
                      date = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this2.$store.state.skiSchoolFilter[i]).format('YYYY-MM-DD');
                      query += '&date=' + date;
                    } else if (parseInt(i.substr(0, 1))) {
                      query += '&ages[]=' + i;
                    } else {
                      query += '&level[]=' + i;
                    }
                  }
                }

                query += '&cat=' + _this2.$route.query.type;

                season = _this2.isSummer ? 'summer' : 'winter';
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get('/skischool/search?' + query + '&group=1&btype=' + season);

              case 8:
                _ref = _context.sent;
                data = _ref.data;
                count = _ref.count;

                _this2.data = data;
                _this2.count = count;
                _this2.loading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  })
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_deprecated_OutlineButton__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_deprecated_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_deprecated_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    OutlineButton: __WEBPACK_IMPORTED_MODULE_3__components_deprecated_OutlineButton___default.a
  },
  data: function data() {
    return {
      schools: [{
        name: this.$i18n.t('skischool.types-singular.group'),
        list: [this.$i18n.t('skischool.advantages.1'), this.$i18n.t('skischool.advantages.2'), this.$i18n.t('skischool.advantages.3')],
        image: 'gruppskidskola.jpg',
        bookable: true,
        type: 'group',
        show: false
      }, {
        name: this.$i18n.t('skischool.types-singular.private'),
        list: [this.$i18n.t('skischool.advantages.4'), this.$i18n.t('skischool.advantages.5'), this.$i18n.t('skischool.advantages.6')],
        image: 'privatskidskola.jpg',
        bookable: true,
        type: 'private',
        show: false
      }, {
        name: this.$i18n.t('skischool.types-singular.snowboard'),
        list: [this.$i18n.t('skischool.advantages.7'), this.$i18n.t('skischool.advantages.8'), this.$i18n.t('skischool.advantages.9')],
        image: 'snowboard.jpg',
        bookable: true,
        type: 'snowboard',
        show: false
      }],
      pageContent: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal', 'closeModal', 'toggleSkiSchoolFilterSwitch']), {
    openLocationMap: function openLocationMap() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.openModal(['SkiSchoolLocationMap', {
                  markers: _this.SITE_CONFIG.skischool.coordinates
                }]);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openFaq: function openFaq() {
      this.openModal(['SkiSchoolFaq', {}]);
    },
    openBooking: function openBooking(type) {
      this.$router.replace({ path: this.$route.path, query: { type: type } });
      this.openModal(['SkiSchoolPicker', {
        type: type
      }]);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.toggleSkiSchoolFilterSwitch();
              _this2.$store.state.skiSchoolFilter.red = false;
              _this2.$store.state.skiSchoolFilter.yellow = false;
              _this2.$store.state.skiSchoolFilter.green = false;
              _this2.$store.state.skiSchoolFilter.blue = false;
              _this2.$store.state.skiSchoolFilter.black = false;
              _this2.$store.state.skiSchoolFilter.date = false;

              _this2.schools[0].show = _this2.SITE_CONFIG.skischool.types.group;
              _this2.schools[1].show = _this2.SITE_CONFIG.skischool.types.private;
              _this2.schools[2].show = _this2.SITE_CONFIG.skischool.types.snowboard;

              if (_this2.SITE_CONFIG.site === 'vallasen' || _this2.SITE_CONFIG.site === 'ulricehamn') {
                _this2.schools[2].list = [_this2.$i18n.t('skischool.advantages.10')];
              }

              _this2.pageContent = '';

              if (_this2.$route.name === 'bike school') {
                _this2.$router.replace({ name: 'bike school overview' });
              }

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      msg: 'Välkommen till Branäs bokning',
      api_url: ''
    };
  },
  mounted: function mounted() {
    this.api_url = this.devSettings.api_url;

    if (this.SITE_CONFIG.env === 'production') {
      if (this.SITE_CONFIG.site === 'branas' || this.SITE_CONFIG.site === 'kungsberget') {
        this.$router.replace({ name: 'accomodation list' });
      } else {
        this.$router.replace({ name: 'ski rental' });
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['devSettings'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['saveDevSettings', 'clearCart']), {
    updateSettings: function updateSettings() {
      this.saveDevSettings({
        api_url: this.api_url
      });
    },
    clean: function clean() {
      localStorage.removeItem('branas-booking-default');
      window.location.reload();
    },
    cleanCart: function cleanCart() {
      this.clearCart();
    },
    setLocal: function setLocal() {
      var defaultUrl = localStorage.getItem('branas/api_url') || 'https://branas-booking-backend.ddev.site';
      var url = window.prompt('Sätt URL (t.ex. https://branas-booking-backend.ddev.site)', defaultUrl);

      if (url) {
        localStorage.setItem('branas/api_url', url);
      }

      window.location.reload();
    }
  })
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['clicked', 'text'],
  methods: {
    click: function click() {
      if (this.clicked) {
        this.clicked();
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Back__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_components_Back__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['clicked', 'text'],
  components: {
    Back: __WEBPACK_IMPORTED_MODULE_0__components_components_Back___default.a
  },
  methods: {
    click: function click() {
      if (this.clicked) {
        this.clicked();
      } else {
        this.$router.go(-1);
      }
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    currentlyPaying: {
      default: false
    }
  },
  components: {},
  data: function data() {
    return {
      time: '',
      seconds: 0,
      intervalRef: null
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'markReservationsAsLost', 'saveCartLocking']), {
    tryAgain: function tryAgain() {
      var _this = this;

      if (!this.$store.state.lockingActive) {
        return false;
      }

      this.closeAllModals();

      var props = {};

      if (this.currentlyPaying || this.$route.name === 'payment') {
        props.forceSyncAll = true;
      }

      setTimeout(function () {
        _this.openModal(['BookingCancelled', props]);
      }, 1);

      this.$store.state.lockingActive = false;

      return true;
    },
    calculate_time: function calculate_time() {
      this.seconds = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc('' + this.$store.state.lockingBeforeTime, 'YYYY-MM-DD HH:mm:ss').diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(), 'seconds') - 2;

      if (this.seconds === 0) {
        this.tryAgain();
      }

      var m = 0;
      var s = 0;

      if (this.seconds >= 60) {
        m = Math.floor(this.seconds / 60);
        s = this.seconds - m * 60;
      } else {
        m = 0;
        s = this.seconds;
      }

      if (m < 10) {
        if (!m) {
          m = 0;
        } else {
          m = '0' + m;
        }
      }
      if (s < 10) {
        s = '0' + s;
      }

      this.time = m + ':' + s;

      this.$emit('update', this.seconds);
    },
    extend_time: function extend_time() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var order, orderCode, _ref, code, before_time;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                order = _this2.$route.query.order;
                orderCode = _this2.$route.query.code;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].post('extend-time/' + _this2.$store.state.lockingCode + '?order=' + order + '&code=' + orderCode);

              case 4:
                _ref = _context.sent;
                code = _ref.code;
                before_time = _ref.before_time;


                _this2.saveCartLocking({
                  code: code,
                  beforeTime: before_time
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }),
  computed: {
    activeLock: function activeLock() {
      return this.seconds > 0 && this.$store.state.lockingActive;
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  template: '#radio-wrapper',
  props: {
    value: {
      default: false
    },
    label: {},
    labelPosition: {
      default: 'before'
    },
    type: {
      default: 'radio'
    },
    color: {
      default: 'green'
    },
    sublabel: {
      default: ''
    },
    size: {
      default: 22
    },
    below: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    style: function style() {
      if (this.value) {
        return 'background-image: url("https://static.booking.branasgruppen.se/static/svg/check-' + this.color + '.svg");width:' + this.size + 'px;height:' + this.size + 'px;';
      }
      return 'width:' + this.size + 'px;height:' + this.size + 'px;';
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  template: '#radio-wrapper',
  props: {
    valuebinder: {},
    value: {},
    label: {},
    labelPosition: {
      default: 'before'
    },
    type: {
      default: 'radio'
    },
    color: {
      default: 'blue'
    },
    sublabel: {
      default: ''
    },
    size: {
      default: 22
    },
    below: {
      default: false
    },
    disabled: {
      default: false
    },
    specialClass: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    updateValue: function updateValue(e) {
      if (this.value === this.valuebinder) {
        this.$emit('update:valuebinder', null);
      } else {
        this.$emit('update:valuebinder', this.value);
      }
      this.$emit('click', e);
      this.$emit('clicked', e);
    }
  },
  computed: {
    style: function style() {
      if (this.valuebinder === this.value) {
        return 'background-image: url("https://static.booking.branasgruppen.se/static/svg/check-' + this.color + '.svg");width:' + this.size + 'px;height:' + this.size + 'px;';
      }
      return 'width:' + this.size + 'px;height:' + this.size + 'px;';
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {},
    content: {}
  },
  data: function data() {
    return {
      expanded: false
    };
  },

  computed: {},
  methods: {
    toggle: function toggle() {
      this.expanded = !this.expanded;
    },
    isActive: function isActive() {
      return this.expanded;
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    default: {},
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    suffix: {
      type: String,
      default: '+'
    },
    inline: {
      type: Boolean,
      default: false
    },
    count: {}
  },
  data: function data() {
    return {};
  },

  computed: {
    getCount: function getCount() {
      return this.count;
    }
  },
  methods: {
    add: function add() {
      if (this.count < this.max) {
        this.count += 1;
        this.$emit('changedCount', this.count);
      }
    },
    subtract: function subtract() {
      if (this.count > this.min) {
        this.count -= 1;
        this.$emit('changedCount', this.count);
      }
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__ = __webpack_require__(31);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {},
    showTitle: {
      default: true
    }
  },
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default.a
  },
  data: function data() {
    return {
      countries: [],
      pickedCountry: false,
      selectedCountry: {}
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__["a" /* default */]],
  computed: {
    label: function label() {
      if (this.selectedCountry && this.selectedCountry.value) {
        return '<div class="flag" style="background-image:url(' + this.selectedCountry.flag + ');"></div> ' + this.selectedCountry.title;
      }
      return 'Select country';
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var country, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              country = 'SE';


              if (localStorage.getItem('country')) {
                country = localStorage.getItem('country');
              } else {
                country = _this.theCurrentCountry;
              }

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('countries');

            case 4:
              data = _context.sent;

              _this.countries = data;

              _this.setCountry(_this.countries.filter(function (item) {
                return item.value === country;
              })[0]);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setCountry: function setCountry(lang) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.selectedCountry = lang;
                _this2.$emit('clickedcountry', lang.value);

                localStorage.setItem('country', lang.value);

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('translations');

              case 5:
                data = _context2.sent;

                try {
                  _this2.$i18n.setLocaleMessage(lang.value, data.translations);
                } catch (e) {
                  console.log(e);
                }

                window.SITE_CONFIG.translations = data.translations;

                try {
                  _this2.$i18n.locale = lang.value;
                } catch (e) {
                  console.log(e);
                }

                document.querySelector('html').setAttribute('lang', lang.value);

                _this2.pickedCountry = true;
                _this2.$emit('pickedcountry', lang.value);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changedCountry: function changedCountry(lang) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.setCountry(lang);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__ = __webpack_require__(31);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {},
    showTitle: {
      default: true
    }
  },
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default.a
  },
  data: function data() {
    return {
      countries: [],
      pickedCountry: false,
      selectedCountry: {}
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__["a" /* default */]],
  computed: {
    label: function label() {
      if (this.selectedCountry && this.selectedCountry.value) {
        return this.selectedCountry.title;
      }
      return 'Select country';
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var country, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              country = 'SE';


              if (localStorage.getItem('country')) {
                country = localStorage.getItem('country');
              } else {
                country = _this.theCurrentCountry;
              }

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('countries');

            case 4:
              data = _context.sent;

              _this.countries = data;

              _this.setCountry(_this.countries.filter(function (item) {
                return item.value === country;
              })[0]);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setCountry: function setCountry(lang) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.selectedCountry = lang;
                _this2.$emit('clickedcountry', lang.value);

                localStorage.setItem('country', lang.value);

                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('translations');

              case 5:
                data = _context2.sent;

                try {
                  _this2.$i18n.setLocaleMessage(lang.value, data.translations);
                } catch (e) {
                  console.log(e);
                }

                window.SITE_CONFIG.translations = data.translations;

                try {
                  _this2.$i18n.locale = lang.value;
                } catch (e) {
                  console.log(e);
                }

                document.querySelector('html').setAttribute('lang', lang.value);

                _this2.pickedCountry = true;
                _this2.$emit('pickedcountry', lang.value);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changedCountry: function changedCountry(lang) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.setCountry(lang);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_range__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_popperjs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_popperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_popperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_popperjs_dist_css_vue_popper_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_popperjs_dist_css_vue_popper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_popperjs_dist_css_vue_popper_css__);









var moment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_0_moment___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    popper: __WEBPACK_IMPORTED_MODULE_2_vue_popperjs___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default.a
  },
  props: {
    value: {},
    valueEnd: {},
    type: {},
    range: {
      default: false
    },
    selectRange: {
      default: false
    },
    validDate: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    validRangeDate: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    startMonth: {
      default: ''
    },
    allowPrevious: {
      default: false
    },
    disabledDays: {
      default: false
    },
    specialDays: {
      default: false
    },
    showAllMonths: {
      default: false
    }
  },
  data: function data() {
    return {
      currentMonth: null,
      validMonths: []
    };
  },
  beforeMount: function beforeMount() {
    if (!this.currentMonth) {
      this.currentMonth = moment(this.value || undefined).startOf('month').toDate();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$refs.monthDropdown.setValue({ value: moment(this.currentMonth).format('YYYY-MM-DD') }, true);

    console.log('Datepicker', this.specialDays);

    this.$nextTick(function () {
      if (_this.value) {
        _this.currentMonth = moment(_this.value).startOf('month').toDate();
        _this.$refs.monthDropdown.setValue({ value: moment(_this.currentMonth).format('YYYY-MM-DD') }, true);
      } else if (_this.startMonth) {
        _this.currentMonth = moment(_this.startMonth).startOf('month').toDate();
        console.log(_this.startMonth);
        console.log(_this.currentMonth);
        _this.$refs.monthDropdown.setValue({ value: moment(_this.startMonth).format('YYYY-MM-DD') }, true);
      } else {
        var date = false;
        var _i = 0;
        while (_i < 365) {
          date = moment().add(_i, 'days');
          if (_this.validRangeDate(date)) {
            break;
          }
          date = undefined;
          _i += 1;
        }
        _this.currentMonth = moment(date).startOf('month').toDate();
        _this.$refs.monthDropdown.setValue({ value: moment(_this.currentMonth).format('YYYY-MM-DD') }, true);
      }

      var i = 0;
      _this.validMonths = [];
      var lastMonth = 0;
      while (i < 365) {
        var _date = moment().add(i, 'days');
        if (_this.validRangeDate(_date)) {
          var key = moment(_date).startOf('month').format('YYYY-MM-DD');
          if (lastMonth !== key) {
            _this.validMonths.push({
              value: key,
              title: moment(_date).startOf('month').format('MMMM YYYY')
            });
          }
          lastMonth = key;
        }
        _date = undefined;
        i += 1;
      }

      if (_this.showAllMonths) {
        _this.validMonths = [];

        i = -12;

        while (i < 12) {
          var _date2 = moment().add(i, 'months');
          var _key = moment(_date2).startOf('month').format('YYYY-MM-DD');

          _this.validMonths.push({
            value: _key,
            title: moment(_date2).startOf('month').format('MMMM YYYY')
          });

          i += 1;
        }
      }

      _this.$emit('month-change', { month: _this.currentMonth });
    });
  },

  computed: {
    month: function month() {
      return moment(this.currentMonth).format('MMMM');
    },
    monthForDropdown: function monthForDropdown() {
      return moment(this.currentMonth).format('YYYY-MM-DD');
    },
    year: function year() {
      return moment(this.currentMonth).format('YYYY');
    },
    days: function days() {
      return [{ label: this.$i18n.t('general.weekdays.short.m') }, { label: this.$i18n.t('general.weekdays.short.tu') }, { label: this.$i18n.t('general.weekdays.short.w') }, { label: this.$i18n.t('general.weekdays.short.th') }, { label: this.$i18n.t('general.weekdays.short.f') }, { label: this.$i18n.t('general.weekdays.short.sa') }, { label: this.$i18n.t('general.weekdays.short.su') }];
    },
    weeks: function weeks() {
      var _this2 = this;

      var month = moment.range(moment(this.currentMonth), moment(this.currentMonth).endOf('month'));

      var visibleRange = moment.range(moment(this.currentMonth).startOf('isoWeek'), moment(this.currentMonth).endOf('month').endOf('isoWeek'));

      var visibleDays = [];

      var date = visibleRange.start.add(-1, 'days');
      var i = 0;
      var max = visibleRange.end.diff(date, 'days');

      while (i < max) {
        date = moment(date).add(1, 'days').toDate();
        visibleDays.push(moment(date));
        i += 1;
      }

      var mapped = visibleDays.map(function (day) {
        return {
          label: day.format('D'),
          visible: day.within(month),
          value: day.toDate(),
          enabled: (_this2.selectRange && _this2.value ? _this2.validRangeDate(day) : _this2.validDate(day)) && (day.isSame(moment(), 'day') || day.isAfter(moment()) || _this2.allowPrevious),
          active: day.isSame(_this2.value, 'day'),
          activeRange: day.isBetween(_this2.value, _this2.valueEnd),
          activeEnd: day.isSame(_this2.valueEnd, 'day'),
          current: day.isSame(moment(), 'day'),
          unavailable: _this2.inArray(day.format('YYYY-MM-DD'), _this2.disabledDays),
          special: _this2.inArray(day.format('YYYY-MM-DD'), _this2.specialDays)
        };
      });

      var chunked = [[]];
      var chunk = 0;
      mapped.forEach(function (day, index) {
        if (index && index % 7 === 0) {
          chunk += 1;
          chunked[chunk] = [];
        }
        chunked[chunk].push(day);
      });

      var newMapped = chunked.map(function (days) {
        return {
          days: days
        };
      });

      return newMapped;
    },
    canGoToPrevious: function canGoToPrevious() {
      return this.getRelatedMonth(this.currentMonth, -1);
    },
    canGoToNext: function canGoToNext() {
      return this.getRelatedMonth(this.currentMonth, 1);
    }
  },
  methods: {
    inArray: function inArray(needle, haystack) {
      var i = 0;
      var length = haystack.length;
      for (i = 0; i < length; i += 1) {
        if (haystack[i] === needle) return true;
      }
      return false;
    },
    setValue: function setValue(day) {
      var localValue = day.value;

      if (day.active) {
        localValue = null;
      }

      if (this.selectRange && this.value) {
        if (this.valueEnd) {
          this.$emit('change', localValue);
          this.$emit('change-end', null);
        } else if (localValue <= this.value) {
          this.$emit('change', localValue);
          this.$emit('change-end', null);
        } else {
          this.$emit('change-end', localValue);
        }
      } else {
        this.$emit('change', localValue);
        this.valueEnd = null;
        this.$emit('change-end', null);
      }
    },
    prevMonth: function prevMonth() {
      var previousMonth = this.getRelatedMonth(this.currentMonth, -1);

      if (previousMonth) {
        this.currentMonth = moment(previousMonth).toDate();
        this.$refs.monthDropdown.setValue({ value: moment(previousMonth).format('YYYY-MM-DD') }, true);
        this.$emit('month-change', { month: this.currentMonth });
      }
    },
    nextMonth: function nextMonth() {
      var nextMonth = this.getRelatedMonth(this.currentMonth, 1);

      if (nextMonth) {
        this.currentMonth = moment(nextMonth).toDate();
        this.$refs.monthDropdown.setValue({ value: moment(nextMonth).format('YYYY-MM-DD') }, true);
        this.$emit('month-change', { month: this.currentMonth });
      }
    },
    getRelatedMonth: function getRelatedMonth(date, add) {
      var currentDate = moment(date).format('YYYY-MM-DD');
      var validMonths = this.validMonths;

      for (var i in validMonths) {
        if (validMonths.hasOwnProperty(i)) {
          var validDate = moment(validMonths[i].value).format('YYYY-MM-DD');

          if (validDate === currentDate) {
            if (validMonths[parseInt(i, 10) + add]) {
              return validMonths[parseInt(i, 10) + add].value;
            }
          }
        }
      }


      return null;
    },
    updateMonth: function updateMonth() {
      var _this3 = this;

      this.$nextTick(function () {
        var date = moment(_this3.value || undefined).toDate();
        var found = false;
        var max = 300;
        var i = 0;
        while (!found) {
          date = moment(date).add(1, 'days').toDate();
          if (_this3.validRangeDate(date)) {
            found = true;
          }
          if (i >= max) {
            found = true;
          }
          i += 1;
        }
        if (i < 300) {
          var diff = moment(date).startOf('month').diff(moment(_this3.value).startOf('month'), 'months');
          i = 0;
          while (i < diff) {
            _this3.nextMonth();
            i += 1;
          }
        }
      });
    },
    showPopper: function showPopper(day) {
      if (!day.unavailable) {
        return false;
      }

      if (day.active) {
        return false;
      }

      if (day.activeRange) {
        return false;
      }

      if (day.activeEnd) {
        return false;
      }

      if (day.current) {
        return false;
      }

      return true;
    },
    updateMonthFromPicker: function updateMonthFromPicker(e) {
      this.currentMonth = moment(e.value).toDate();
      this.$emit('month-change', { month: this.currentMonth });
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(26);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  computed: {
    formattedValue: function formattedValue() {
      var _ref = this.value || {},
          startDate = _ref.startDate,
          endDate = _ref.endDate;

      if (startDate && endDate) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib__["a" /* formatAccomodationsFilterDate */])(startDate, endDate);
      }
      return this.$i18n.t('general.whenever');
    },
    isSelected: function isSelected() {
      return this.value.startDate && this.value.endDate;
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_components_Checkbox__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_0__components_components_Checkbox___default.a
  },
  props: {
    valuebinder: {},
    value: {},
    label: {},
    options: {
      default: []
    },
    prefixicon: {},
    prefixiconValidated: {},
    type: {
      default: 'large'
    },
    allowEmpty: {
      default: true
    },
    boldLabel: {
      default: false
    },
    valueSuffix: {
      default: ''
    },
    onclick: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    validated: {
      default: false
    },
    combo: {
      default: false
    },
    classList: {
      default: ''
    },
    error: {
      default: false
    },
    showLabelSubtitle: {
      default: true
    },
    withBackground: {
      default: false
    },
    valueAsLabel: {
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false,
      search: '',
      tempValue: null,
      optionHeight: 0
    };
  },
  created: function created() {
    window.addEventListener('resize', this.setOptionsHeight);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.setOptionsHeight);
  },

  methods: {
    stopper: function stopper(e) {
      this.open(e);
    },
    open: function open(e) {
      this.isOpen = true;
      this.updateBody();
      this.setOptionsHeight();
      e.stopPropagation();
    },
    clicked: function clicked(e) {
      this.$emit('clicked', e);
    },
    toggle: function toggle(e) {
      this.isOpen = !this.isOpen;
      this.updateBody();
      this.clicked(e);
      this.setOptionsHeight();
      e.stopPropagation();
    },
    clickSuffix: function clickSuffix(e) {
      var _this = this;

      if (this.allowEmpty) {
        if (this.validated) {
          this.$emit('clicked-suffix', e);
          e.stopPropagation();
          this.$nextTick(function () {
            if (_this.valuebinder) {
              _this.setValue({});
            }
          });
        } else {
          this.toggle(e);
        }
      } else {
        this.toggle(e);
      }
    },
    close: function close() {
      this.isOpen = false;
      this.$emit('closed');
      this.updateBody();
    },
    setValue: function setValue(option, skipEmit) {
      this.tempValue = option.value;
      this.search = option.value;

      if (typeof skipEmit === 'undefined' || !skipEmit) {
        this.$emit('update:valuebinder', option.value);
        this.$emit('changed', option);
        this.$emit('input', option.value);
        this.$emit('touch');
        this.close();
      }
    },
    setValueFromTyping: function setValueFromTyping($event, option) {
      this.tempValue = option.value;
      this.$emit('update:valuebinder', option.value);
      this.$emit('changed', option.value);
      this.$emit('input', option.value);
      this.$emit('touch');

      if ($event.keyCode === 13) {
        this.close();
      }
    },
    updateBody: function updateBody() {
      if (this.isOpen) {
        document.body.classList.add('dropdown-opened');
        if (this.withBackground) {
          document.body.classList.add('dropdown-opened--with-background');
        }
        document.addEventListener('click', this.documentClick);
      } else {
        document.body.classList.remove('dropdown-opened');
        document.body.classList.remove('dropdown-opened--with-background');
        document.removeEventListener('click', this.documentClick);
      }
    },
    setOptionsHeight: function setOptionsHeight() {
      var _this2 = this;

      this.$nextTick(function () {
        var $el = _this2.$refs.options;
        if ($el) {
          var top = $el.getBoundingClientRect().top;
          var height = window.innerHeight;
          _this2.optionHeight = height - top - 10;
        }
      });
    },
    documentClick: function documentClick(e) {
      if (e.target !== this.$el && !this.$el.contains(e.target)) {
        e.stopPropagation();
        this.close();
      }
    }
  },
  mounted: function mounted() {
    if (this.value) {
      this.valuebinder = this.value;
    }
    this.tempValue = this.valuebinder;
  },

  computed: {
    valuebinderComputed: function valuebinderComputed() {
      return this.tempValue;
    },
    selectedLabel: function selectedLabel() {
      var $this = this;

      if (this.type === 'language') {
        return '' + this.label;
      }

      if (this.type === 'country') {
        return '' + this.label;
      }

      var selected = (this.options || []).filter(function (option) {
        return $this.valuebinderComputed === option.value;
      });
      if (selected.length) {
        var title = selected[0].title;
        if (selected[0].subtitle && this.showLabelSubtitle) {
          return '<b>' + title + '</b> <span class="thin">' + selected[0].subtitle + '</span>';
        }
        return '' + title;
      }

      if (this.combo && this.valuebinder) {
        return '<b>' + this.valuebinder + '</b>';
      }

      if (this.valueAsLabel && this.valuebinder) {
        return '<b>' + this.valuebinder + '</b>';
      }

      if (this.boldLabel) {
        return '' + this.label;
      }

      return this.label;
    },
    filteredOptions: function filteredOptions() {
      var $this = this;
      var reg = new RegExp($this.search, 'i');

      if (!this.combo) {
        return this.options || [];
      }

      if (this.validated) {
        return this.options || [];
      }

      var options = (this.options || []).filter(function (option) {
        return option.value.toString().match(reg) || option.title.toString().match(reg);
      });

      if ((!options || !options.length) && this.search) {
        return this.options;
      }

      return options;
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    name: {
      default: ''
    },
    scale: {
      default: 1
    },
    ariaHidden: {
      default: true
    },
    alt: {
      default: ''
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {},
  computed: {
    className: function className() {
      return this.name.replace(/ /g, '-').replace(/[^A-Za-z0-9-]/g, '');
    },
    altText: function altText() {
      return this.alt || 'Illustration av ' + this.name.replace(/-/g, ' ');
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {},
    placeholder: {},
    keyenter: {
      type: Function
    },
    type: {
      default: 'normal'
    },
    label: {
      default: ''
    },
    required: {}
  },
  data: function data() {
    return {
      text: this.value
    };
  },

  methods: {
    changeText: function changeText(event) {
      this.text = event.target.value;
      this.$emit('change', this.text);
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {},
    showTitle: {
      default: true
    }
  },
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default.a
  },
  data: function data() {
    return {
      languages: [],
      pickedLanguage: false,
      selectedLanguage: {}
    };
  },

  computed: {
    label: function label() {
      if (this.selectedLanguage && this.selectedLanguage.value) {
        return '<div class="flag" style="background-image:url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + this.selectedLanguage.flag + '.svg);"></div> ' + this.selectedLanguage.title;
      }
      return 'Select language';
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.SITE_CONFIG.languages.full.forEach(function (lang) {
      _this.languages.push(lang);
    });

    var lang = this.$i18n.locale;
    this.selectedLanguage = this.languages.filter(function (item) {
      return item.value === lang;
    })[0];
  },

  methods: {
    setLanguage: function setLanguage(lang) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.selectedLanguage = lang;
                _this2.$emit('clickedlanguage', lang.value);

                localStorage.setItem('language', lang.value);
                __WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(lang.value);

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('translations');

              case 6:
                data = _context.sent;

                try {
                  _this2.$i18n.setLocaleMessage(lang.value, data.translations);
                } catch (e) {
                  console.log(e);
                }

                window.SITE_CONFIG.translations = data.translations;

                try {
                  _this2.$i18n.locale = lang.value;
                } catch (e) {
                  console.log(e);
                }

                document.querySelector('html').setAttribute('lang', lang.value);

                _this2.pickedLanguage = true;
                _this2.$emit('pickedlanguage', lang.value);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    changedLanguage: function changedLanguage(lang) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.setLanguage(lang);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      default: null
    },
    show: {
      default: false
    },
    static: {
      default: false
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    if (!this.text) {
      this.text = this.$i18n.t('general.loading');
    }
  },

  methods: {},
  computed: {}
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Back__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_components_Back__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    wide: {
      default: false
    },
    fullwide: {
      default: false
    },
    width: {
      default: '100%'
    },
    setClass: {
      default: ''
    },
    showClose: {
      default: true
    },
    closeText: {
      default: ''
    },
    minWidth: {
      default: '100px'
    },
    normalWidth: {
      default: 'auto'
    },
    zIndex: {
      default: 99999
    },
    clickOutside: {
      default: true
    }
  },
  components: {
    Back: __WEBPACK_IMPORTED_MODULE_0__components_components_Back___default.a
  },
  methods: {
    close: function close() {
      this.$emit('close', false);
    },
    closeFromOuterClick: function closeFromOuterClick(e) {
      if (this.clickOutside) {
        var content = document.getElementById('modal-container-content');
        if (e.target !== content && content && !content.contains(e.target)) {
          e.stopPropagation();
          this.close();
        }
      }
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {},
  methods: {}
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Icon__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_components_Icon__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: 'center'
    },
    color: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'strong'
    },
    icon: {
      type: String,
      default: ''
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0__components_components_Icon___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {},
  computed: {
    colorClass: function colorClass() {
      if (this.color === 'blue') {
        return 'notification--blue';
      }
      if (this.color === 'white') {
        return 'notification--white';
      }
      if (this.color === 'warning') {
        return 'notification--warning';
      }

      return '';
    },
    alignClass: function alignClass() {
      if (this.align === 'center') {
        return 'center';
      }

      return '';
    },
    elementTag: function elementTag() {
      return this.tag;
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_TimeoutModal__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_TimeoutModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modals_TimeoutModal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    cancelPath: {
      default: '/pa-plats'
    }
  },
  components: {
    TimeoutModal: __WEBPACK_IMPORTED_MODULE_2__components_modals_TimeoutModal___default.a
  },
  data: function data() {
    return {
      seconds: 0,
      inactivitySeconds: 60,
      inactivityLeft: 60,
      resetSeconds: 120,
      resetSecondsLeft: 120,
      intervalRef: null,
      showTimeoutModal: false
    };
  },
  created: function created() {
    window.addEventListener('mousemove', this.resetTimer);
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('keyup', this.resetTimer);
    window.addEventListener('terminaltexts', this.resetTimerAndClose);
    window.addEventListener('paysuccess', this.resetTimerAndClose);
    window.addEventListener('payfail', this.resetTimerAndClose);
    window.addEventListener('syncing', this.resetTimerAndClose);
    window.addEventListener('syncprogress', this.resetTimerAndClose);
    window.addEventListener('syncsuccess', this.resetTimerAndClose);
    this.startTimer();
  },
  destroyed: function destroyed() {
    window.removeEventListener('mousemove', this.resetTimer);
    window.removeEventListener('click', this.resetTimer);
    window.removeEventListener('keyup', this.resetTimer);
    window.removeEventListener('terminaltexts', this.resetTimerAndClose);
    window.removeEventListener('paysuccess', this.resetTimerAndClose);
    window.removeEventListener('payfail', this.resetTimerAndClose);
    window.removeEventListener('syncing', this.resetTimerAndClose);
    window.removeEventListener('syncprogress', this.resetTimerAndClose);
    window.removeEventListener('syncsuccess', this.resetTimerAndClose);
    this.clearTimer();
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['clearCart', 'openModal', 'openTimeoutModal', 'closeTimeoutModal', 'closeModal', 'closeAllModals']), {
    startTimer: function startTimer() {
      var _this = this;

      var $this = this;
      $this.intervalRef = setInterval(function () {
        $this.inactivityLeft -= 1;
        if ($this.inactivityLeft < 0) {
          $this.resetSecondsLeft -= 1;
          _this.openTheModal();
        }
        if ($this.resetSecondsLeft < 0) {
          $this.cancelWithoutConfirmation();
        }
      }, 1000);
    },
    clearTimer: function clearTimer() {
      clearInterval(this.intervalRef);
    },
    resetTimer: function resetTimer() {
      while (this.inactivityLeft < this.inactivitySeconds) {
        this.inactivityLeft += 1;
      }
      while (this.resetSecondsLeft < this.resetSeconds) {
        this.resetSecondsLeft += 1;
      }
    },
    resetTimerAndClose: function resetTimerAndClose() {
      this.resetTimer();
      this.closeTimeoutModal();
    },
    openTheModal: function openTheModal() {
      this.openTimeoutModal(['TimeoutModal', {
        seconds: this.secondsLeftBeforeCancel,
        cancel: this.cancel,
        continue: this.resetTimerAndClose,
        inactive: this.isInactive,
        zIndex: 100015
      }]);
    },
    secondsLeftBeforeCancel: function secondsLeftBeforeCancel() {
      return this.resetSecondsLeft;
    },
    isInactive: function isInactive() {
      return this.inactivityLeft < 0;
    },
    cancelWithoutConfirmation: function cancelWithoutConfirmation() {
      this.closeAllModals();
      this.closeTimeoutModal();
      this.clearCart();

      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('cancelpay', true, true, {});
      document.dispatchEvent(evt);

      this.$router.replace({
        path: this.cancelPath,
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 1
        }
      });
    },
    cancel: function cancel() {
      var $this = this;
      this.openModal(['GeneralModal', {
        zIndex: 20,
        title: this.$i18n.t('general.cancel-booking-question-title'),
        content: this.$i18n.t('general.cancel-booking-question-text'),
        yes: function yes() {
          $this.closeAllModals();
          $this.closeTimeoutModal();
          $this.clearCart();

          var evt = document.createEvent('CustomEvent');
          evt.initCustomEvent('cancelpay', true, true, {});
          document.dispatchEvent(evt);

          $this.$router.replace({
            path: $this.cancelPath || '/pa-plats',
            query: {
              site: $this.$store.state.isOnWhichSite,
              refresh: 1
            }
          });
        },
        no: function no() {
          $this.closeTimeoutModal();
          $this.closeModal();
        }
      }]);
    }
  })
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: {},
    icon: {},
    active: {},
    iconscale: {
      type: Number,
      default: 1
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_parts_Accomodation_UnitFacts__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_parts_Accomodation_UnitFacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_parts_Accomodation_UnitFacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_CompletedBookings__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_CompletedBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_parts_CompletedBookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_PrettyOrderDetails__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_PrettyOrderDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_PrettyOrderDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_my_order__ = __webpack_require__(81);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    order: {
      default: {}
    },
    bookMoreCallback: {
      default: function _default() {}
    }
  },
  components: {
    UnitFacts: __WEBPACK_IMPORTED_MODULE_0__components_parts_Accomodation_UnitFacts___default.a,
    CompletedBookings: __WEBPACK_IMPORTED_MODULE_1__components_parts_CompletedBookings___default.a,
    PrettyOrderDetails: __WEBPACK_IMPORTED_MODULE_2__components_components_PrettyOrderDetails___default.a
  },
  data: function data() {
    return {
      loading: false
    };
  },
  mounted: function mounted() {},

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_my_order__["a" /* default */]],
  methods: {
    followLink: function followLink(linkObject) {
      var method = linkObject.function[0];
      var argument = linkObject.function[1];

      if (method === 'goToBooking') {
        this.goToBooking(argument);
      } else if (method === 'bookMore') {
        this.bookMore(argument);
      } else if (method === 'goToAccommodation') {
        this.goToAccommodation(argument);
      } else if (method === 'bookAddon') {
        this.bookAddon(argument);
      } else if (method === 'goToLink') {
        window.open(argument, '_blank');
      }
    },
    goToBooking: function goToBooking(no) {
      this.$router.push({ name: 'my journey booking', params: { bookingNumber: no } });
    },
    bookMore: function bookMore(no) {
      this.$router.push({ name: 'my journey booking', params: { bookingNumber: no, onlyMore: true } });
    },
    goToAccommodation: function goToAccommodation(slug) {
      var url = this.$route.path.substr(1);
      this.$router.push({ path: '/mina-sidor/resa/boende/' + slug + '?flow=' + url });
    },
    bookMoreCb: function bookMoreCb(data, data2) {
      this.bookMoreCallback(data, data2);
    },
    bookAddon: function bookAddon(row) {
      this.$store.state.cart.addToOrder = {
        number: this.order.resvid,
        numeric: this.order.headlid,
        accomodationRow: row.row,
        accomodationName: row.name,
        accomodationDateArrival: row.arrival,
        accomodationDateDeparture: row.departure,
        accomodationGroup: row.group
      };

      this.$router.push({
        name: 'addons extra',
        query: {
          pool: row.pool,
          unit: row.unit,
          arrival: row.arrival,
          departure: row.departure,
          name: row.name,
          adults: parseInt(row.adults, 10),
          youths: parseInt(row.youths, 10),
          children: parseInt(row.children, 10),
          seniors: parseInt(row.seniors, 10) || 0
        }
      });
    }
  },
  computed: {
    links: function links() {
      var _this = this;

      var links = [];

      links.push({
        function: ['goToBooking', this.order.headlid],
        text: 'Visa detaljer',
        class: ''
      });

      if (this.order.details.can_add_to_booking && this.SITE_CONFIG.add_to_booking_open) {
        links.push({
          function: ['bookMore', this.order.headlid],
          text: 'Lägg till',
          class: 'white'
        });
      }

      if (this.order.details.rows) {
        if (this.order.details.rows.accomodation && this.order.details.rows.accomodation.length) {
          var localLinks = this.order.details.rows.accomodation.map(function (row) {
            var aName = 'boendet';
            if (_this.order.details.rows.accomodation.length > 1) {
              aName = row.accommodation.display_name || row.accommodation.description_title;
            }

            return {
              function: ['goToAccommodation', row.accommodation.slug],
              text: 'L\xE4s mer om ' + aName,
              class: 'white'
            };
          });

          links = links.concat(localLinks);

          localLinks = this.order.details.rows.accomodation.map(function (row) {
            var aName = '';
            if (_this.order.details.rows.accomodation.length > 1) {
              aName = row.accommodation.display_name || row.accommodation.description_title;
              aName = ' f\xF6r ' + aName;
            }

            if (_this.order.details.can_add_to_booking && _this.SITE_CONFIG.add_to_booking_open) {
              return {
                function: ['bookAddon', row],
                text: 'Boka tillval' + aName,
                class: 'white'
              };
            }

            return null;
          }).filter(function (a) {
            return a !== null;
          });

          links = links.concat(localLinks);

          links.push({
            function: ['goToLink', 'https://www.branas.se/info-till-boendegast/'],
            text: 'Om att bo hos oss',
            class: 'white'
          });

          links.push({
            function: ['goToLink', 'https://www.branas.se/bra-att-veta__trashed/in-och-utcheckning/'],
            text: 'In- och utcheckning',
            class: 'white'
          });
        }

        if (this.order.details.rows.rental && this.order.details.rows.rental.length) {
          links.push({
            function: ['goToLink', 'https://www.branas.se/hyra-skidor/'],
            text: 'Om hyra',
            class: 'white'
          });
        }

        if (this.order.details.rows.skipass && this.order.details.rows.skipass.length) {
          links.push({
            function: ['goToLink', 'https://www.branas.se/skidakning-i-branas/liftkort/'],
            text: 'Om liftkort',
            class: 'white'
          });
        }

        if (this.order.details.rows.skischool && this.order.details.rows.skischool.length) {
          links.push({
            function: ['goToLink', 'https://www.branas.se/skidskola-i-branas/'],
            text: 'Om skidskola',
            class: 'white'
          });
        }

        if (this.order.status === 'upcoming') {
          links.push({
            function: ['goToLink', 'https://www.branas.se/bra-att-veta__trashed/infor-resan/'],
            text: 'Inför resan',
            class: 'white'
          });
        }
      }

      links.push({
        function: ['goToLink', 'https://www.branas.se/gastservice/kontakta-oss/'],
        text: 'Kontakt',
        class: 'white'
      });

      return links;
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_my_order__ = __webpack_require__(81);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    order: {
      default: {}
    },
    types: {
      default: []
    },
    variant: {
      default: 'normal'
    },
    openRental: {
      default: false
    },
    openSkipass: {
      default: false
    },
    openSkischool: {
      default: false
    },
    bookMoreCallback: {
      default: function _default() {}
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_my_order__["a" /* default */]],
  methods: {
    bookMore: function bookMore(bookingType) {
      this.bookMoreCallback(bookingType, this.order);
    }
  },
  computed: {}
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    product: {},
    price: {},
    discounted: {}
  },
  data: function data() {
    return {
      price_original: 0,
      price_discounted: null
    };
  },

  computed: {
    isDiscounted: function isDiscounted() {
      return this.priceOriginal !== this.priceDiscounted;
    },
    priceOriginal: function priceOriginal() {
      if (this.product) {
        return this.product.price_per_piece * this.product.quantity;
      }

      return this.price;
    },
    priceDiscounted: function priceDiscounted() {
      var discounted = this.priceOriginal;

      if (this.product) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.product.discounted_price_per_piece)) {
          discounted = this.product.discounted_price_per_piece * this.product.quantity;
        } else {
          return this.priceOriginal;
        }
      } else {
        console.log(this.discounted);
        discounted = this.discounted;
      }

      if (discounted < 0) {
        return this.priceOriginal;
      }

      if (isNaN(discounted)) {
        return this.priceOriginal;
      }

      return discounted;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    clickLink: ''
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {
    goTo: function goTo(path) {
      this.$router.push({ path: path });
    },
    goToLink: function goToLink() {
      if (this.clickLink) {
        this.goTo(this.clickLink);
      }
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['images', 'fullsize', 'image'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    SlideshowNested: __WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['openModal']), {
    openFullSlideShow: function openFullSlideShow(index) {
      this.openModal(['SlideshowModal', {
        images: this.images,
        image: index
      }]);
    },
    syncThumbnails: function syncThumbnails(event) {
      this.$refs.thumbnails.goTo(event.nextSlide);
    }
  }),
  data: function data() {
    return {
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        speed: 200,
        timing: 'linear',
        slidesToShow: 1
      },
      options2: {
        autoplay: false,
        slidesToShow: this.fullsize ? 3 : 3,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: this.fullsize ? 6 : 4
          }
        }, {
          breakpoint: 1200,
          settings: {
            slidesToShow: this.fullsize ? 8 : 4
          }
        }, {
          breakpoint: 1600,
          settings: {
            slidesToShow: this.fullsize ? 10 : 4
          }
        }]
      },
      modalIsOpen: false,
      showNow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.asNavFor1.push(this.$refs.thumbnails);
    this.asNavFor2.push(this.$refs.main);

    if (this.fullsize) {
      var $this = this;

      setTimeout(function () {
        $this.showNow = true;

        setTimeout(function () {
          $this.$refs.main.goTo(_this.image);
        }, 100);
      }, 100);
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



var DEF_CHECKED_COLOR = '#43a46b';
var DEF_UNCHECKED_COLOR = '#ecf5f8';

var DEF_CHECKED_LABEL = 'on';
var DEF_UNCHECKED_LABEL = 'off';

var CORE_SIZE = 22;

var DEFAULT_HEIGHT = 13;
var DEFAULT_WIDTH = 35;
var objectHas = function objectHas(object, title) {
  return (typeof object === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(object)) === 'object' && object.hasOwnProperty(title);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToggleButton',
  props: {
    store: {
      type: String
    },
    icon: {
      type: String,
      default: ''
    },
    iconscale: {
      type: Number,
      default: 1
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    sync: {
      type: Boolean,
      default: false
    },
    scale: {
      type: Number,
      default: 1
    },
    color: {
      type: [String, Object],
      validator: function validator(value) {
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
          return value.checked || value.unchecked;
        }

        return typeof value === 'string';
      }
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(value) {
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
          return value.checked || value.unchecked;
        }

        return typeof value === 'boolean';
      }
    },
    labelPosition: {
      default: 'before'
    },
    width: {
      type: Number,
      default: DEFAULT_WIDTH
    }
  },
  computed: {
    colorChecked: function colorChecked() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.color) !== 'object') {
        return this.color || DEF_CHECKED_COLOR;
      }

      return objectHas(this.color, 'checked') ? this.color.checked : DEF_CHECKED_COLOR;
    },
    colorUnchecked: function colorUnchecked() {
      return objectHas(this.color, 'unchecked') ? this.color.unchecked : DEF_UNCHECKED_COLOR;
    },
    colorCurrent: function colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },
    labelChecked: function labelChecked() {
      return objectHas(this.labels, 'checked') ? this.labels.checked : DEF_CHECKED_LABEL;
    },
    labelUnchecked: function labelUnchecked() {
      return objectHas(this.labels, 'unchecked') ? this.labels.unchecked : DEF_UNCHECKED_LABEL;
    },
    coreStyle: function coreStyle() {
      return {
        'background-color': this.colorCurrent,

        '--toggle-width': this.width + 'px',
        '--toggle-transform-distance': this.width - CORE_SIZE + 'px'
      };
    },
    componentStyle: function componentStyle() {
      return {
        'transform': 'scale(' + this.scale + ')'
      };
    }
  },
  watch: {
    value: function value(_value) {
      if (this.sync) {
        this.toggled = _value;
      }
    }
  },
  data: function data() {
    return {
      toggled: this.value
    };
  },

  methods: {
    toggle: function toggle(event) {
      this.toggled = !this.toggled;
      this.$emit('toggle', { key: this.store, 'value': this.toggled });
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['current'],
  computed: {
    icon: function icon() {
      return ['sort-down', 'sort', 'sort-up'][this.current + 1];
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {},
    placeholder: {},
    keyenter: {
      type: Function
    },
    type: {
      default: 'normal'
    }
  },
  data: function data() {
    return {
      text: this.value
    };
  },

  methods: {
    changeText: function changeText(event) {
      this.text = event.target.value;
      this.$emit('change', this.text);
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_BookingTimer__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_components_BookingTimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_components_BookingTimer__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BookingTimer: __WEBPACK_IMPORTED_MODULE_0__components_components_BookingTimer___default.a
  },
  props: {
    steps: {},
    theme: {
      default: 'dark'
    },
    showTimeLine: {
      default: true
    },
    showBookingTimer: {
      default: true
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: {
    clickable: function clickable(step) {
      return step.complete === 2 && step.url || step.clickable;
    },
    goTo: function goTo(step) {
      if (this.clickable(step)) {
        this.$router.push(step.url);
      }
    },
    update: function update(value) {
      if (value >= 0) {
        this.showBookingTimer = true;
      } else {
        this.showBookingTimer = false;
      }
    }
  },
  computed: {}
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['url'],
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var url = _this.url;

      if (!url) {
        return;
      }

      if (url.includes('vimeo.com')) {
        var vimeoBaseUrl = 'https://player.vimeo.com/video/';
        var vimeoId = url.match(/[0-9]+/);

        url = '' + vimeoBaseUrl + vimeoId;
      } else if (url.includes('player.mediadelivery.net')) {
        url = url.replace('/play/', '/embed/');
      }

      var ifrm = document.createElement('iframe');
      ifrm.setAttribute('src', url);
      ifrm.setAttribute('border', '0');
      ifrm.setAttribute('frameborder', '0');

      ifrm.setAttribute('webkitAllowFullScreen', '');
      ifrm.setAttribute('mozallowfullscreen', '');
      ifrm.setAttribute('allowFullScreen', '');
      ifrm.setAttribute('allow', 'fullscreen');

      _this.$el.appendChild(ifrm);
    });
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_TimeoutModal__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_TimeoutModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_TimeoutModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    cancelPath: {
      default: '/'
    }
  },
  components: {
    TimeoutModal: __WEBPACK_IMPORTED_MODULE_5__components_modals_TimeoutModal___default.a
  },
  data: function data() {
    return {
      seconds: 0,
      intervalRef: null,
      intervalRef2: null,
      showTimeoutModal: false,
      time: '',
      lastActive: null,
      touchSeconds: 14,
      pendingRequest: false
    };
  },
  created: function created() {
    window.addEventListener('click', this.setLastActive);
    window.addEventListener('keyup', this.setLastActive);

    this.lastActive = new Date();
    this.touchOrder();

    this.touchSeconds = this.SITE_CONFIG.timeout.touch;

    this.intervalRef = setInterval(this.calculate_time, 1000);
    this.intervalRef2 = setInterval(this.touchOrder, this.touchSeconds * 1000);
  },
  destroyed: function destroyed() {
    window.removeEventListener('click', this.setLastActive);
    window.removeEventListener('keyup', this.setLastActive);

    clearInterval(this.intervalRef);
    clearInterval(this.intervalRef2);
  },
  mounted: function mounted() {},

  computed: {
    currentlyPaying: function currentlyPaying() {
      return this.$route.name === 'payment';
    },
    activeLock: function activeLock() {
      return this.$store.state.lockingActive;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['clearCart', 'openModal', 'openTimeoutModal', 'closeTimeoutModal', 'closeModal', 'closeAllModals', 'saveCartLocking']), {
    setLastActive: function setLastActive() {
      var diff = __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.lastActive), 'seconds');
      if (diff >= this.touchSeconds + 5 && diff > 0 && this.seconds > 0) {
        this.doTheTouch();
      }

      this.lastActive = new Date();
    },
    touchOrder: function touchOrder() {
      var diff = __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.lastActive), 'seconds');
      if (diff < this.touchSeconds && this.seconds > 0) {
        this.doTheTouch();
      }
    },
    doTheTouch: function doTheTouch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var order, orderCode, _ref, code, before_time;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.pendingRequest = true;

                order = _this.$route.query.order;
                orderCode = _this.$route.query.code;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].post('extend-time/' + _this.$store.state.lockingCode + '?order=' + order + '&code=' + orderCode);

              case 5:
                _ref = _context.sent;
                code = _ref.code;
                before_time = _ref.before_time;


                _this.saveCartLocking({
                  code: code,
                  beforeTime: before_time
                });

                _this.pendingRequest = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    calculate_time: function calculate_time() {
      if (!this.activeLock) {
        return false;
      }

      this.seconds = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc('' + this.$store.state.lockingBeforeTime, 'YYYY-MM-DD HH:mm:ss').diff(__WEBPACK_IMPORTED_MODULE_4_moment___default()(), 'seconds') - 2;

      var showTimeoutSeconds = this.SITE_CONFIG.timeout.lock_show;

      if (this.currentlyPaying) {
        showTimeoutSeconds = this.SITE_CONFIG.timeout.lock_show_payment;
      }

      if (this.seconds <= showTimeoutSeconds && this.seconds > 0 && !this.pendingRequest) {
        this.showWarning();
      }

      if (this.seconds <= 0 && !this.pendingRequest) {
        this.tryAgain();
      }

      var m = 0;
      var s = 0;

      if (this.seconds >= 60) {
        m = Math.floor(this.seconds / 60);
        s = this.seconds - m * 60;
      } else {
        m = 0;
        s = this.seconds;
      }

      if (m < 10) {
        if (!m) {
          m = 0;
        } else {
          m = '0' + m;
        }
      }
      if (s < 10) {
        s = '0' + s;
      }

      this.time = m + ':' + s;

      this.$emit('update', this.seconds);

      return true;
    },
    secondsFunction: function secondsFunction() {
      return this.seconds;
    },
    showWarning: function showWarning() {
      var $this = this;

      this.openTimeoutModal(['TimeoutModal', {
        seconds: this.secondsFunction,
        cancel: function cancel() {
          $this.closeTimeoutModal();
        },
        continue: this.resetTimerAndClose,
        inactive: function inactive() {
          return true;
        },
        zIndex: 100015
      }]);
    },
    resetTimerAndClose: function resetTimerAndClose() {
      this.touchOrder();
      this.closeTimeoutModal();
    },
    tryAgain: function tryAgain() {
      var _this2 = this;

      if (!this.$store.state.lockingActive) {
        return false;
      }

      this.closeAllModals();
      this.closeTimeoutModal();

      var props = {};

      if (this.currentlyPaying || this.$route.name === 'payment') {
        props.forceSyncAll = true;
      }

      setTimeout(function () {
        _this2.openModal(['BookingCancelled', props]);
      }, 1);

      this.$store.state.lockingActive = false;

      return true;
    }
  })
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: {},
    closeLabel: {},
    icon: {},
    status: {},

    iconscale: {
      type: Number,
      default: 1
    }
  },
  computed: {
    getStatus: function getStatus() {
      return !this.status;
    }
  },
  methods: {
    toggleClick: function toggleClick() {
      this.getStatus = !this.getStatus;
      this.$emit('clicked', this.getStatus);
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default.a,
    UnitFacts: __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_UnitFacts___default.a,
    AccomodationPeriodConfirm: __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default.a,
    Vimeo: __WEBPACK_IMPORTED_MODULE_8__components_components_Vimeo___default.a
  },
  data: function data() {
    return {
      activeTab: 'info',
      unit: null,
      loaded: false,
      price: null,
      arrival: null,
      departure: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = {};

              if (!_this.$route.params.slug) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/units/' + _this.$route.params.slug + '/info');

            case 4:
              data = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/units/' + _this.$route.params.poolId + '/' + _this.$route.params.unitId + '/info');

            case 9:
              data = _context.sent;

            case 10:
              _this.loaded = true;
              _this.unit = data.data;

              _this.arrival = _this.params.arrival;
              _this.departure = _this.params.departure;

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['confirmedAccomodations', 'favoriteAccommodations'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    closeModalLocal: function closeModalLocal() {
      if (this.$route.query.ref) {
        this.$router.push({ path: '/' + this.$route.query.flow });
      }
      this.closeModal();
    },
    setTab: function setTab(tab) {
      if (tab === 'map') {
        this.openModal(['MapModal' + this.SITE_CONFIG.site, {
          locationId: this.unit.facility.id
        }]);
      } else {
        this.activeTab = tab;
      }
    },
    isFavorite: function isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    toggleFavorite: function toggleFavorite(unitId) {
      var index = this.favoriteAccommodations.indexOf(unitId);
      if (index > -1) {
        this.removeFavorite(index);
      } else {
        var $this = this;
        var favoriteCount = this.favoriteAccommodations.length;
        if (favoriteCount >= 3) {
          this.openModal(['GeneralModal', {
            title: 'Max 3 favoritboenden',
            content: '<p>Du kan endast spara 3 favoritboenden.</p>',
            buttons: [{
              title: 'Okej',
              class: 'small',
              click: function click() {
                $this.closeModal();
              }
            }]
          }]);
        } else {
          this.addFavorite(unitId);
        }
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal', 'openModal', 'accomodationPeriodPick', 'accomodationPeriodPick', 'closeModal', 'closeAllModals', 'openModal', 'pickAccomodation', 'addFavorite', 'removeFavorite']), {
    didChooseAccomodation: function didChooseAccomodation(payload) {
      var p = payload;
      p.unit = this.unit;
      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;
      this.pickAccomodation(p);
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      var no = this.$store.state.cart.accomodations.length - 1;
      this.$router.push({ name: 'confirm-accomodation', query: { d: new Date().getTime(), no: no } });
    },
    chooseAccomodation: function chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    nl2br: function nl2br(input) {
      var breakTag = '<br>';
      return input.toString().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
  })
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_popperjs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_popperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_popperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_popperjs_dist_css_vue_popper_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_popperjs_dist_css_vue_popper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_popperjs_dist_css_vue_popper_css__);














/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    popper: __WEBPACK_IMPORTED_MODULE_8_vue_popperjs___default.a
  },
  data: function data() {
    return {
      unit: null,
      meta_periods: null,
      meta_special: null,
      meta_weeks: null,
      meta_super_titles: null,
      meta_updated: null,
      loaded: false,
      firstPrice: {},
      cartAccomodationObject: {}
    };
  },
  mounted: function mounted() {
    this.loadPrices('null');
    this.loaded = true;
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['confirmedAccomodations', 'cart'])),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    loadPrices: function loadPrices(type) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, urlInfo, _ref, _data, _ref2, data, firstKey, currentAccomodationIndex;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = '/units/' + _this.params.pool_lid + '/' + _this.params.unit_lid + '/prices';

                if (!(type === 'refresh')) {
                  _context.next = 5;
                  break;
                }

                url = url + '/refresh';
                _context.next = 11;
                break;

              case 5:
                urlInfo = '/units/' + _this.params.pool_lid + '/' + _this.params.unit_lid + '/info';
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get(urlInfo);

              case 8:
                _ref = _context.sent;
                _data = _ref.data;

                _this.unit = _data;

              case 11:
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get(url);

              case 13:
                _ref2 = _context.sent;
                data = _ref2.data;


                _this.unit = data.accomodations;
                _this.meta_periods = data.meta_periods;
                _this.meta_special = data.meta_special;
                _this.meta_weeks = data.meta_weeks;
                _this.meta_super_titles = data.meta_super_titles;
                _this.meta_updated = data.meta_updated;
                firstKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.unit.prices)[10];

                _this.firstPrice = _this.unit.prices[firstKey];

                if (_this.$store.state.tempCartAccomodation && _this.$store.state.tempCartAccomodation.type) {
                  _this.cartAccomodationObject = _this.$store.state.tempCartAccomodation;
                } else {
                  currentAccomodationIndex = _this.cart.currentAccomodationIndex;

                  _this.cartAccomodationObject = _this.cart.accomodations[currentAccomodationIndex];
                }

                if (type === 'refresh') {
                  _this.loaded = true;
                }

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closeModalLocal: function closeModalLocal() {
      if (this.$route.query.ref) {
        this.$router.push({ path: '/' + this.$route.query.flow });
      }
      this.closeModal();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'pickAccomodation']), {
    didChooseAccomodation: function didChooseAccomodation(payload) {
      var p = payload;
      p.unit = this.unit;
      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;
      this.pickAccomodation(p);
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      var no = this.$store.state.cart.accomodations.length - 1;
      this.$router.push({ name: 'confirm-accomodation', query: { d: new Date().getTime(), no: no } });
    },
    chooseAccomodation: function chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    showDates: function showDates(periods) {
      var lines = [];
      lines = [];
      this.meta_periods.forEach(function (period) {
        var arrival = __WEBPACK_IMPORTED_MODULE_7_moment___default()(periods[period.period_dbid].date_arrival).format('D/M');
        var departure = __WEBPACK_IMPORTED_MODULE_7_moment___default()(periods[period.period_dbid].date_departure).format('D/M');
        lines.push('<b>' + period.days + ':</b> ' + arrival + ' - ' + departure);
      });

      return lines.join('<br>');
    }
  })
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.$refs.copyText.select();
  },

  computed: {
    link: function link() {
      var protocol = window.location.protocol;
      var host = window.location.host;
      var page = window.location.pathname;

      var accomodations = this.params.accomodations;
      return protocol + '//' + host + page + '#/dela/j/' + accomodations;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    copy: function copy() {
      this.$refs.copyText.select();
      document.execCommand('copy');
    }
  })
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_API__ = __webpack_require__(4);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addonspage',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_7__components_components_Timeline___default.a,
    SwitchButton: __WEBPACK_IMPORTED_MODULE_8__components_components_SwitchButton___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_11__components_components_Checkbox___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_9__components_components_Loading___default.a
  },
  data: function data() {
    return {
      cartAccomodationObject: {},
      cartSkipassObject: {},
      showingSkipassModal: false,
      adultDays: 0,
      seniorDays: 0,
      youthDays: 0,
      childrenDays: 0,
      adults: 0,
      youths: 0,
      children: 0,
      addons: [],
      adultPricelistPrice: 0,
      seniorPricelistPrice: 0,
      youthPricelistPrice: 0,
      childPricelistPrice: 0,
      adultOriginalPrice: 0,
      seniorOriginalPrice: 0,
      youthOriginalPrice: 0,
      childOriginalPrice: 0,
      keycardPrice: 0,
      cancellationInsurance: null,
      markInsurance: false,
      cancellationInsuranceObject: {},
      lateArrivalObject: {},
      adultLid: null,
      youthLid: null,
      seniorLid: null,
      childLid: null,
      loading: false,
      skipassBlocked: false,
      deliveryAllowed: false,
      discount_date: null,
      discount_date_pretty: null,
      delivery_type: 'delivery',
      site: ''
    };
  },
  mounted: function mounted() {
    this.discount_date = '30/9 2019';
    this.discount_date_pretty = '30 september';

    if (this.SITE_CONFIG.site === 'kungsberget') {
      this.discount_date = '31/10 2019';
      this.discount_date_pretty = '31 oktober';
    }

    var currentAccomodationIndex = this.accomodationIndex;

    if (this.$route.name === 'addons') {
      this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];
    } else {
      this.cartAccomodationObject = {
        poolLid: this.$route.query.pool,
        unitLid: this.$route.query.unit,
        name: this.$route.query.name,
        period: {
          date_arrival: this.$route.query.arrival,
          date_departure: this.$route.query.departure
        },
        adults: parseInt(this.$route.query.adults, 10),
        youths: parseInt(this.$route.query.youths, 10),
        seniors: parseInt(this.$route.query.seniors, 10),
        children: parseInt(this.$route.query.children, 10)
      };
    }

    if (this.cartAccomodationObject && this.cartAccomodationObject.site) {
      if (this.cartAccomodationObject.site === 2007) {
        this.site = 'by';
      } else if (this.cartAccomodationObject.site === 2006) {
        this.site = 'berg';
      }
    }

    var currentSkipassIndex = -1;
    this.cart.skipasses.forEach(function (skipass, index) {
      if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === currentAccomodationIndex) {
        currentSkipassIndex = index;
      }
    });

    if (currentSkipassIndex === -1) {
      this.addAccomodationSkipasses({
        days: this.noOfDays(),
        adults: this.cartAccomodationObject.adults || 0,
        seniors: this.cartAccomodationObject.seniors || 0,
        youths: this.cartAccomodationObject.youths || 0,
        children: this.cartAccomodationObject.children || 0,
        belongsTo: currentAccomodationIndex
      });

      currentSkipassIndex = 0;
    }
    this.cartSkipassObject = this.cart.skipasses[currentSkipassIndex];
    if (this.cartSkipassObject.seniors === null) {
      this.cartSkipassObject.seniors = 0;
    }

    this.getAddons();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['cart']), {
    accomodationIndex: function accomodationIndex() {
      if (typeof this.$route.query.no === 'undefined') {
        return 0;
      }
      var no = parseInt(this.$route.query.no, 10);

      if (no === -2) {
        return null;
      }

      if (!no) {
        return 0;
      }

      if (isNaN(no)) {
        return 0;
      }

      return no;
    },
    skiPassAccomodationAfterCheckinText: function skiPassAccomodationAfterCheckinText() {
      return 'Efter incheckning i boendet. Liftkorten levereras med nycklarna.';
    },
    skiPassAccomodationBeforeCheckinText: function skiPassAccomodationBeforeCheckinText() {
      return 'Före incheckning i boendet. Liftkorten hämtas i skidhyran.';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    validated: function validated() {
      if (this.cancellationInsurance === true) {
        return true;
      } else if (this.cancellationInsurance === false) {
        return true;
      }
      return false;
    },
    getAddons: function getAddons() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, _ref, data, meta_skipasses, cancellationInsurance, lateArrival, keycardPrice, deliveryAllowed;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$nextTick(function () {
                  if (!_this.loading) {
                    _this.loading = true;
                  }
                });

                url = '/units/' + _this.cartAccomodationObject.poolLid + '/' + _this.cartAccomodationObject.unitLid + '/addons/' + _this.cartAccomodationObject.period.date_arrival + '/' + _this.cartAccomodationObject.period.date_departure;


                if (_this.$store.state.cart.addToOrder && _this.$store.state.cart.addToOrder.numeric) {
                  url = url + '?order=' + _this.$store.state.cart.addToOrder.numeric + '&order-line-group=' + _this.$store.state.cart.addToOrder.accomodationGroup;
                }
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get(url);

              case 5:
                _ref = _context.sent;
                data = _ref.data;
                meta_skipasses = _ref.meta_skipasses;
                cancellationInsurance = _ref.cancellationInsurance;
                lateArrival = _ref.lateArrival;
                keycardPrice = _ref.keycardPrice;
                deliveryAllowed = _ref.deliveryAllowed;


                if (deliveryAllowed) {
                  _this.deliveryAllowed = true;
                  _this.delivery_type = 'delivery';
                } else {
                  _this.deliveryAllowed = false;
                  _this.delivery_type = 'pickup';
                }

                if (_this.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) {
                  _this.deliveryAllowed = false;
                  _this.delivery_type = 'pickup';
                }

                _this.addons = data.map(function (addon) {
                  var start = parseInt(addon.min_qty, 10);
                  var end = parseInt(addon.max_qty, 10);

                  var a = addon;
                  a.options = [];
                  while (start <= end) {
                    if (!start) {
                      a.options.push({ title: 'ANTAL', value: 0 });
                    } else {
                      a.options.push({ title: start + ' st', value: start });
                    }
                    start += 1;
                  }
                  return a;
                });

                _this.lateArrivalObject = lateArrival;
                _this.cancellationInsuranceObject = cancellationInsurance;

                if (meta_skipasses.adult.separate_days) {
                  _this.adultPricelistPrice = Math.round(parseFloat(meta_skipasses.adult.separate_days.aprice, 10));
                  _this.adultLid = meta_skipasses.adult.separate_days.lid;
                  _this.adultOriginalPrice = meta_skipasses.adult.separate_days.original;
                } else if (meta_skipasses.adult.week) {
                  _this.adultPricelistPrice = Math.round(parseFloat(meta_skipasses.adult.week.aprice, 10));
                  _this.adultLid = meta_skipasses.adult.week.lid;
                  _this.adultOriginalPrice = meta_skipasses.adult.week.original;
                } else {
                  _this.adultPricelistPrice = 0;
                  _this.adultOriginalPrice = 0;
                }

                if (meta_skipasses.senior && meta_skipasses.senior.separate_days) {
                  _this.seniorPricelistPrice = Math.round(parseFloat(meta_skipasses.senior.separate_days.aprice, 10));
                  _this.seniorLid = meta_skipasses.senior.separate_days.lid;
                  _this.seniorOriginalPrice = meta_skipasses.senior.separate_days.original;
                } else if (meta_skipasses.senior && meta_skipasses.senior.week) {
                  _this.seniorPricelistPrice = Math.round(parseFloat(meta_skipasses.senior.week.aprice, 10));
                  _this.seniorLid = meta_skipasses.senior.week.lid;
                  _this.seniorOriginalPrice = meta_skipasses.senior.week.original;
                } else {
                  _this.seniorPricelistPrice = 0;
                  _this.seniorOriginalPrice = 0;
                  _this.cartSkipassObject.seniors = 0;
                }

                if (meta_skipasses.youth.separate_days) {
                  _this.youthPricelistPrice = Math.round(parseFloat(meta_skipasses.youth.separate_days.aprice, 10));
                  _this.youthLid = meta_skipasses.youth.separate_days.lid;
                  _this.youthOriginalPrice = meta_skipasses.youth.separate_days.original;
                } else if (meta_skipasses.youth.week) {
                  _this.youthPricelistPrice = Math.round(parseFloat(meta_skipasses.youth.week.aprice, 10));
                  _this.youthLid = meta_skipasses.youth.week.lid;
                  _this.youthOriginalPrice = meta_skipasses.youth.week.original;
                } else {
                  _this.youthPricelistPrice = 0;
                  _this.youthOriginalPrice = 0;
                }

                if (meta_skipasses.child.separate_days) {
                  _this.childPricelistPrice = Math.round(parseFloat(meta_skipasses.child.separate_days.aprice, 10));
                  _this.childLid = meta_skipasses.child.separate_days.lid;
                  _this.childOriginalPrice = meta_skipasses.child.separate_days.original;
                } else if (meta_skipasses.child.week) {
                  _this.childPricelistPrice = Math.round(parseFloat(meta_skipasses.child.week.aprice, 10));
                  _this.childLid = meta_skipasses.child.week.lid;
                  _this.childOriginalPrice = meta_skipasses.child.week.original;
                } else {
                  _this.childPricelistPrice = 0;
                  _this.childOriginalPrice = 0;
                }

                _this.cartSkipassObject.adultsPrice = _this.adultPricelistPrice;
                _this.cartSkipassObject.seniorsPrice = _this.seniorPricelistPrice;
                _this.cartSkipassObject.youthsPrice = _this.youthPricelistPrice;
                _this.cartSkipassObject.childrenPrice = _this.childPricelistPrice;

                _this.keycardPrice = keycardPrice;
                if (!_this.adultPricelistPrice || !_this.youthPricelistPrice) {
                  _this.closeModal();
                }

                _this.loading = false;

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['confirmSkipasses', 'unconfirmSkipasses', 'addAddon', 'removeAddon', 'addSkipasses', 'addAccomodationSkipasses', 'openModal', 'closeModal']), {
    chooseArticle: function chooseArticle(addon) {
      if (addon.qtySelected) {
        addon.added = true;
        this.addAddon(addon);
      } else {
        this.openModal(['GeneralModal', {
          title: 'Välj antal',
          content: '<p>Du måste välj hur många du vill ha.</p>'
        }]);
      }
    },
    removeArticle: function removeArticle(addon) {
      addon.added = false;
      this.removeAddon(addon);
    },
    infoPopup: function infoPopup(addon) {
      this.openModal(['AddonInfoModal', {
        addon: addon
      }]);
    },
    next: function next() {
      var $this = this;
      if (this.validated()) {
        if (!this.cancellationInsurance) {
          this.openModal(['GeneralModal', {
            title: 'Avbeställningsskydd',
            content: '<p>Du har tackat <b>nej</b> till av- och ombokningsförsäkring.</p><p>Du har då inte möjlighet att: byta boende boka om till annan period eller avboka och få pengarna tillbaka enligt gällande bokningsvillkor.</p>',
            buttons: [{
              title: 'Jag vill ändra',
              class: 'small white border',
              click: function click() {
                $this.closeModal();
              }
            }, {
              title: 'Jag förstår',
              class: 'small',
              click: function click() {
                $this.closeModal();
                $this.openModal(['CartHighFiveModal', {}]);
              }
            }]
          }]);
        } else {
          this.openModal(['CartHighFiveModal', {}]);
        }
      } else {
        this.openModal(['GeneralModal', {
          title: 'Vill du ha Avbeställningskydd?',
          content: '<p>Du behöver ta ställning till om du vill ha avbeställningsskydd eller inte.</p>',
          buttons: [{
            title: 'Okej, låt mig välja',
            class: 'small',
            click: function click() {
              $this.markInsurance = true;
              $this.closeModal();
            }
          }]
        }]);
      }
    },
    openLateCheckinInfo: function openLateCheckinInfo() {
      var $this = this;
      this.openModal(['GeneralModal', {
        title: 'Sen incheckning',
        content: '<p>Sen incheckning, från 17. Pris 0:-</p><p>Lorem ipsum orem ipsum orem ipsum orem ipsum. Lorem ipsum orem ipsum orem ipsum orem ipsum.',
        buttons: [{
          title: 'Okej',
          class: 'small',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    adultPrice: function adultPrice(includeKeycard) {
      var price = this.cartSkipassObject.adults * this.adultPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - this.cartSkipassObject.adults * this.keycardPrice;
      }

      return 0;
    },
    seniorPrice: function seniorPrice(includeKeycard) {
      var price = (this.cartSkipassObject.seniors || 0) * this.seniorPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - (this.cartSkipassObject.seniors || 0) * this.keycardPrice;
      }

      return 0;
    },
    youthPrice: function youthPrice(includeKeycard) {
      var price = this.cartSkipassObject.youths * this.youthPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - this.cartSkipassObject.youths * this.keycardPrice;
      }

      return 0;
    },
    childPrice: function childPrice(includeKeycard) {
      var price = this.cartSkipassObject.children * this.childPricelistPrice;

      if (price && includeKeycard) {
        return price;
      }

      if (price) {
        return price - this.cartSkipassObject.children * this.keycardPrice;
      }

      return 0;
    },
    keycardTotalPrice: function keycardTotalPrice() {
      var qty = parseInt(this.cartSkipassObject.adults, 10) + parseInt(this.cartSkipassObject.youths, 10) + parseInt(this.cartSkipassObject.children, 10) + parseInt(this.cartSkipassObject.seniors || 0, 10);

      var price = this.keycardPrice * qty;

      if (price) {
        return price;
      }

      return 0;
    },
    totalPrice: function totalPrice() {
      return this.adultPrice(true) + this.youthPrice(true) + this.childPrice(true) + this.seniorPrice(true);
    },
    originalPrice: function originalPrice() {
      return (this.adultPrice(true) + this.youthPrice(true) + this.childPrice(true) + this.seniorPrice(true)) / 0.9;
    },
    noOfSkipasses: function noOfSkipasses() {
      var skipasses = parseInt(this.cartSkipassObject.adults, 10) + parseInt(this.cartSkipassObject.seniors, 10) + parseInt(this.cartSkipassObject.youths, 10) + parseInt(this.cartSkipassObject.children, 10);

      if (skipasses) {
        return skipasses;
      }

      return 0;
    },
    noOfDays: function noOfDays() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        var a = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.cartAccomodationObject.period.date_arrival);
        var b = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.cartAccomodationObject.period.date_departure);

        var premiereStart = this.SITE_CONFIG.season.winter.premiere_weekend_start;
        var premiereEnd = this.SITE_CONFIG.season.winter.premiere_weekend_end;

        var extraPremiereActive = this.SITE_CONFIG.season.winter.extra_premiere_weekend_active;
        var extraPremiereStart = this.SITE_CONFIG.season.winter.extra_premiere_weekend_start;
        var extraPremiereEnd = this.SITE_CONFIG.season.winter.extra_premiere_weekend_end;

        if (a.format('YYYY-MM-DD') === premiereStart && b.format('YYYY-MM-DD') === premiereEnd) {
          return b.diff(a, 'days');
        }

        if (extraPremiereActive && a.format('YYYY-MM-DD') === extraPremiereStart && b.format('YYYY-MM-DD') === extraPremiereEnd) {
          return b.diff(a, 'days');
        }

        return b.diff(a, 'days') + 1;
      }

      return 0;
    },
    cartSkipasses: function cartSkipasses() {
      var currentAccomodationIndex = this.accomodationIndex;
      var currentSkipassIndex = -1;
      var accObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.cartAccomodationObject);

      if (this.$route.name === 'addons') {
        this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];

        this.cart.skipasses.forEach(function (skipass, index) {
          if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === currentAccomodationIndex) {
            currentSkipassIndex = index;
          }
        });

        accObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          pool_lid: this.cartAccomodationObject.poolLid,
          unit_lid: this.cartAccomodationObject.unitLid,
          name: this.cartAccomodationObject.name
        });
      } else {
        currentSkipassIndex = 0;

        accObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
          pool_lid: this.cartAccomodationObject.poolLid,
          unit_lid: this.cartAccomodationObject.unitLid,
          name: this.cartAccomodationObject.name
        });
      }

      this.confirmSkipasses({
        index: currentSkipassIndex,
        adultLid: this.adultLid,
        seniorLid: this.seniorLid,
        youthLid: this.youthLid,
        childLid: this.childLid,
        days: this.noOfDays(),
        deliveryType: this.delivery_type,
        deliveryTo: {
          pool_lid: accObject.pool_lid,
          unit_lid: accObject.unit_lid,
          name: accObject.name
        },
        site: this.site
      });
      this.closeModal();
    },
    removeSkipasses: function removeSkipasses() {
      this.unconfirmSkipasses();
    },
    modalSkipasses: function modalSkipasses() {
      this.showingSkipassModal = true;
    },
    addSkipassToCart: function addSkipassToCart(age, days, number) {
      this.addSkipasses({ age: age, days: days, number: number });
    },
    toggleLate: function toggleLate(v) {
      var obj = this.lateArrivalObject;
      obj.title = 'Sen ankomst';
      obj.qtySelected = 1;

      if (v.value) {
        this.addAddon(obj);
      } else {
        this.removeAddon(obj);
      }
    },
    validatedSkipasses: function validatedSkipasses() {
      if (this.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) {
        return this.noOfSkipasses();
      }

      var siteOkay = this.delivery_type === 'delivery' || this.site;
      return this.noOfSkipasses() && siteOkay;
    },
    unmarkInsuranceError: function unmarkInsuranceError() {
      this.markInsurance = false;

      var obj = this.cancellationInsuranceObject;
      obj.title = 'Avbeställningskydd';
      obj.qtySelected = 1;

      if (this.cancellationInsurance) {
        this.addAddon(obj);
      } else {
        this.removeAddon(obj);
      }
    }
  })
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_3__components_components_Dropdown___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {
    isAddonBooking: function isAddonBooking() {
      return this.$route.name === 'addons extra';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'pickAccomodation', 'addAddon', 'removeAddon']), {
    goTo: function goTo(path) {
      this.closeModal();
      this.$router.push({ path: path });
    },
    chooseArticle: function chooseArticle(addon) {
      if (addon.qtySelected) {
        addon.added = true;

        if (this.isAddonBooking) {
          addon.belongsTo = -2;
        }

        this.addAddon(addon);
        this.closeModal();
      } else {
        this.openModal(['GeneralModal', {
          title: 'Välj antal',
          content: '<p>Du måste välj hur många du vill ha.</p>'
        }]);
      }
    },
    removeArticle: function removeArticle(addon) {
      addon.added = false;
      this.removeAddon(addon);
    }
  })
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox___default.a
  },
  data: function data() {
    return {
      localSelection: {}
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var selectedList = this.params.selected || [];
    this.params.options.forEach(function (opt) {
      _this.$set(_this.localSelection, opt.id, selectedList.includes(opt.id) || selectedList.includes(Number(opt.id)) || selectedList.includes(String(opt.id)));
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeModal']), {
    save: function save() {
      var _this2 = this;

      var selectedIds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.localSelection).filter(function (key) {
        return _this2.localSelection[key];
      }).map(function (key) {
        return isNaN(Number(key)) ? key : Number(key);
      });

      this.params.click(selectedIds);
      this.closeModal();
    }
  })
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_API__ = __webpack_require__(4);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default.a,
    SwitchButton: __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton___default.a
  },
  data: function data() {
    return {
      outParams: {},
      pools: [],
      accomodationFilter: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var i, _ref, data;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (i in _this.params.args1) {
                _this.outParams[i] = _this.params.args1[i][2];
              }
              if (!(_this.params.args1 && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this.params.args1).length)) {
                _context.next = 9;
                break;
              }

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_8__classes_API__["a" /* default */].get('/grouped?simple=2');

            case 4:
              _ref = _context.sent;
              data = _ref.data;

              _this.pools = data;
              _context.next = 9;
              break;

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    filteredPools: function filteredPools() {
      var $filter = this.accomodationFilter.toLocaleLowerCase();
      var pools = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.pools));

      return pools.filter(function (e) {
        var poolMatch = (e.display_name || e.name).toLocaleLowerCase().match($filter);

        e.units = e.units.filter(function (ee) {
          return (ee.description_title + ee.name + ee.display_name + ee.subtitle + ee.pool_lid + e.unit_lid).toLocaleLowerCase().match($filter);
        });

        return e.units.length || poolMatch;
      });
    },
    selectedCount: function selectedCount() {
      var count = 0;
      var pools = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.pools));

      pools.forEach(function (pool) {
        var units = pool.units.filter(function (unit) {
          return unit.active;
        });
        count += units.length;
      });

      return count;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['closeModal']), {
    goOn: function goOn() {
      this.doTheSync(this.params.command);
    },
    toggle: function toggle(payload) {
      this.outParams[payload.key] = payload.value;

      console.log(this.outParams);
    },
    setPoolActive: function setPoolActive(id, p) {
      var $this = this;
      var $pool = $this.pools.find(function (pool) {
        return pool.id === id;
      });

      var count = p.units.length;
      var max = $pool.unit_count;

      $pool.units.forEach(function (unit, index) {
        $pool.units[index].active = !$pool.units[index].active;
      });

      this.outParams.accomodationId = this.getAccomodations().join(',');

      if (count !== max) {
        alert('Omr\xE5det du har valt ut inneh\xE5ller ' + max + ' boenden, men ditt filter gav bara ' + count + '. Alla ' + max + ' boenden markerades nu.');
      }
    },
    setUnitActive: function setUnitActive(id, poolId) {
      var $this = this;
      var $pool = $this.pools.find(function (pool) {
        return pool.id === poolId;
      });
      var $unit = $pool.units.find(function (unit) {
        return unit.id === id;
      });

      $unit.active = !$unit.active;

      this.outParams.accomodationId = this.getAccomodations().join(',');
    },
    getAccomodations: function getAccomodations() {
      var pools = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.pools));
      var ids = [];

      pools.forEach(function (pool) {
        var units = pool.units.filter(function (unit) {
          return unit.active;
        });

        units.forEach(function (unit) {
          ids.push(unit.id);
        });
      });

      return ids;
    },
    updateArg1: function updateArg1(e, key) {
      this.outParams[key] = e.target.value;
    },
    doTheSync: function doTheSync(command) {
      var newArgs1 = {};
      var newArgs2 = {};

      for (var i in this.params.args1) {
        if (this.params.args1[i]) {
          var arg = this.params.args1[i];
          if (arg[0] === 'accomodation' && this.outParams[i]) {
            newArgs1[i] = this.outParams[i];
          } else if (arg[0] === 'switch' && this.outParams[i]) {
            newArgs2[i] = this.outParams[i];
          } else if (arg[0] === 'text' && this.outParams[i]) {
            newArgs2[i] = this.outParams[i];
          }
        }
      }

      for (var _i in this.params.args2) {
        if (this.params.args2[_i]) {
          newArgs2[this.params.args2[_i]] = true;
        }
      }

      __WEBPACK_IMPORTED_MODULE_8__classes_API__["a" /* default */].post('/admin/run-sync-command', {
        command: command,
        args1: newArgs1,
        args2: newArgs2
      });

      this.$toast.info('Synkronisering startad', 'Kommando: ' + command, {
        position: 'topRight'
      });

      this.closeModal();
    }
  })
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals']), {
    localCloseModal: function localCloseModal() {},
    goToCart: function goToCart() {
      this.closeAllModals();
      this.$router.replace({ name: 'shopping cart' });
    }
  })
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_SkiRentalDiscount__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_SkiRentalDiscount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_SkiRentalDiscount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_AccomodationCartItem__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default.a,
    CompletedBookings: __WEBPACK_IMPORTED_MODULE_7__components_parts_CompletedBookings___default.a,
    SkiRentalDiscount: __WEBPACK_IMPORTED_MODULE_8__components_components_SkiRentalDiscount___default.a,
    CounterButton: __WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton___default.a
  },
  data: function data() {
    return {
      peopleCount: 1,
      accomodation: null,
      unit: {},
      arrival: '',
      departure: '',
      accomodations: [],
      loading: false,
      selectedAccomodation: null,
      possibleWithStorage: false,
      possibleWithDelivery: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    canClose: function canClose() {
      return !this.$store.state.isOnSite;
    },
    validStartDate: function validStartDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__dates__["a" /* validStartDate */])({
        validStartDates: this.validStartDates
      });
    },
    validate: function validate() {
      var errors = 0;
      errors += this.peopleCount ? 0 : 1;
      errors += this.params.type === 'with-delivery' && !this.accomodation ? 1 : 0;
      errors += this.params.type === 'with-delivery' && !this.possibleWithDelivery ? 1 : 0;
      return !errors;
    },
    accomodationsToSelect: function accomodationsToSelect() {
      var val = [];
      this.accomodations.forEach(function (accomodation, index) {
        var arrival = __WEBPACK_IMPORTED_MODULE_12_moment___default()(accomodation.arrival || accomodation.period.date_arrival).format('D[/]M');
        var departure = __WEBPACK_IMPORTED_MODULE_12_moment___default()(accomodation.departure || accomodation.period.date_departure).format('D[/]M');
        val.push({
          value: index,
          title: accomodation.unit ? accomodation.unit.display_name || accomodation.unit.description_title : accomodation.name,
          subtitle: arrival + ' - ' + departure
        });
      });
      return val;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['loggedIn', 'guidedRentals'])),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'pickAccomodation', 'addRentalPeople', 'confirmedAccomodations']), {
    localClose: function localClose() {},
    doClose: function doClose() {
      this.closeModal();
      this.$router.replace('/varukorg');
    },
    goTo: function goTo(path) {
      this.closeModal();
      this.$router.push({ path: path });
    },
    changePeople: function changePeople(payload) {
      this.peopleCount = payload;
    },
    startBooking: function startBooking() {
      var date = null;
      var days = null;

      date = this.accomodation.period.date_arrival;
      days = Math.round(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.accomodation.period.date_departure).diff(this.accomodation.period.date_arrival) / 60 / 60 / 24 / 1000) + 1;

      this.addRentalPeople({
        peopleCount: this.peopleCount,
        pickedStartDate: date,
        numberOfDays: days,
        delivery: true,
        deliveryTo: this.unit,
        append: false
      });

      if (date) {
        this.$store.state.cart.rentalDateRestriction = {
          date: date,
          days: days
        };
      } else {
        this.$store.state.cart.rentalDateRestriction = {};
      }

      this.closeAllModals();

      this.$router.push({ path: '/skidhyra/0' });
    },
    startBookingNormal: function startBookingNormal() {
      var date = null;
      var days = null;

      date = this.accomodation.period.date_arrival;
      days = Math.round(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.accomodation.period.date_departure).diff(this.accomodation.period.date_arrival) / 60 / 60 / 24 / 1000) + 1;

      this.addRentalPeople({
        peopleCount: this.peopleCount,
        pickedStartDate: date,
        numberOfDays: days,
        delivery: false,
        deliveryTo: {},
        append: false
      });

      if (date) {
        this.$store.state.cart.rentalDateRestriction = {
          date: date,
          days: days
        };
      } else {
        this.$store.state.cart.rentalDateRestriction = {};
      }

      this.closeAllModals();

      this.$router.push({ path: '/skidhyra/0' });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var accomodations, confirmed, _ref, success, _ref2, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('...reloading');
              accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.$store.state.cart.accomodations));
              confirmed = accomodations.filter(function (accomodation) {
                return accomodation.confirmed;
              });

              if (!confirmed.length) {
                _context.next = 12;
                break;
              }

              _this.accomodation = confirmed[0];
              _this.accomodations = confirmed;
              _this.unit = {
                pool_lid: _this.accomodation.poolLid,
                unit_lid: _this.accomodation.unitLid,
                name: _this.accomodation.name
              };
              _this.arrival = _this.accomodation.period.date_arrival;
              _this.departure = _this.accomodation.period.date_departure;

              _this.$nextTick(function () {
                _this.peopleCount = __WEBPACK_IMPORTED_MODULE_9__classes_AccomodationCartItem__["a" /* default */].peopleCount(confirmed[0]);
                if (_this.$refs.counterButton) {
                  _this.$refs.counterButton.count = _this.peopleCount;
                }
              });
              _context.next = 15;
              break;

            case 12:
              if (!(_this.loggedIn && _this.params.type === 'with-delivery')) {
                _context.next = 15;
                break;
              }

              _context.next = 15;
              return _this.getAccomodations();

            case 15:
              if (!_this.accomodation) {
                _context.next = 27;
                break;
              }

              _this.paramsType = 'with-delivery';

              _context.next = 19;
              return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get('equipment-storage-available/' + _this.accomodation.poolLid + '/' + _this.accomodation.unitLid);

            case 19:
              _ref = _context.sent;
              success = _ref.success;

              _this.possibleWithStorage = success;

              _context.next = 24;
              return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get('config/is-delivery-date-allowed?date=' + _this.accomodation.period.date_arrival);

            case 24:
              _ref2 = _context.sent;
              data = _ref2.data;

              _this.possibleWithDelivery = data;

            case 27:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_SkiRentalDiscount__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_SkiRentalDiscount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_SkiRentalDiscount__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    CompletedBookings: __WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings___default.a,
    SkiRentalDiscount: __WEBPACK_IMPORTED_MODULE_4__components_components_SkiRentalDiscount___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {
    message: function message() {
      if (this.ref === 'skischool') {
        return this.$i18n.t('general.cart-confirmation.skischool');
      } else if (this.ref === 'bikeschool') {
        return 'Nu är din cykelskola vald och ligger i varukorgen!';
      } else if (this.ref === 'accomodation') {
        return this.$i18n.t('general.cart-confirmation.accomodation');
      } else if (this.ref === 'skirental') {
        return this.$i18n.t('general.cart-confirmation.skirental');
      } else if (this.ref === 'skipass') {
        return this.$i18n.t('general.cart-confirmation.skipass');
      } else if (this.ref === 'activity') {
        return this.$i18n.t('general.cart-confirmation.activity');
      } else if (this.ref === 'product') {
        return 'Nu finns <b>' + this.params.text + '</b> i varukorgen!';
      }
      return '';
    },
    ref: function ref() {
      return this.params.ref;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'pickAccomodation']), {
    localClose: function localClose() {
      this.closeModal();
      this.$router.replace('/varukorg');
    },
    goTo: function goTo(path) {
      this.closeModal();
      this.$router.push({ path: path });
    }
  })
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_CountrySwitcher__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_CountrySwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_CountrySwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_languageDetector__ = __webpack_require__(31);

















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_5__components_payments_Login___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_6__components_components_Checkbox___default.a,
    CountrySwitcher: __WEBPACK_IMPORTED_MODULE_7__components_components_CountrySwitcher___default.a
  },
  data: function data() {
    return {
      type: '',
      text: '',
      yes: '',
      no: '',
      gdpr_newsletter: null,
      showCountrySelector: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, type, text, yes, no;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$i18n.locale === _this.SITE_CONFIG.languages.default) {
                localStorage.setItem('country', _this.SITE_CONFIG.countries.default.toUpperCase());
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_8__classes_API__["a" /* default */].get('texts/general_gdpr_text');

            case 3:
              _ref = _context.sent;
              type = _ref.type;
              text = _ref.text;
              yes = _ref.yes;
              no = _ref.no;

              _this.type = type;
              _this.text = text;
              _this.yes = yes;
              _this.no = no;

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_languageDetector__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    valid: function valid() {
      if (this.gdpr_newsletter === 0 || this.gdpr_newsletter === 1) {
        return true;
      }
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal']), {
    click: function click() {
      this.$store.state.cart.gdpr = {};
      this.$store.state.cart.gdpr[this.type] = this.gdpr_newsletter;
      this.closeModal();
      this.params.goToPayment();
    }
  })
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_CreatingOrder__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_CreatingOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_CreatingOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_LabelInput__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_LabelInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_LabelInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_CountrySwitcherNormal__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_CountrySwitcherNormal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_CountrySwitcherNormal__);















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default.a,
    CreatingOrder: __WEBPACK_IMPORTED_MODULE_7__components_parts_CreatingOrder___default.a,
    LabelInput: __WEBPACK_IMPORTED_MODULE_8__components_components_LabelInput___default.a,
    CountrySwitcherNormal: __WEBPACK_IMPORTED_MODULE_10__components_components_CountrySwitcherNormal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_9__components_components_Loading___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;

    var schools = this.$store.state.cart.skischools.filter(function (s) {
      return s.confirmed;
    });
    var schoolNames = schools.map(function (s) {
      return s.name;
    }).filter(function (n) {
      return n;
    });
    var schoolGuardians = schools.map(function (s) {
      return s.guardian;
    }).filter(function (n) {
      return n;
    });
    var schoolPhones = schools.map(function (s) {
      return s.phone;
    }).filter(function (n) {
      return n;
    });

    var rentals = this.$store.state.cart.rentals.filter(function (r) {
      return r.confirmed;
    });
    var rentalNames = rentals.map(function (s) {
      return s.name;
    }).filter(function (n) {
      return n;
    });
    var rentalPhones = rentals.map(function (s) {
      return s.phone;
    }).filter(function (n) {
      return n;
    });

    if (schoolNames.length) {
      this.name = schoolNames[0];
    }
    if (schoolGuardians.length) {
      this.name = schoolGuardians[0];
    }
    if (rentalNames.length) {
      this.name = rentalNames[0];
    }

    if (schoolPhones.length) {
      this.phone = schoolPhones[0];
    }
    if (rentalPhones.length) {
      this.phone = rentalPhones[0];
    }

    if (this.name) {
      var name = this.name;
      var index = name.indexOf(' ');

      if (index > 0) {
        this.name = name.slice(0, index);
        this.lastName = name.slice(index + 1);
      }
    }

    if (this.$store.state.cart.email) {
      this.email = this.$store.state.cart.email;
    }
    if (this.$store.state.cart.phone) {
      this.phone = this.$store.state.cart.phone;
    }
    if (this.$store.state.cart.name) {
      this.name = this.$store.state.cart.name;
    }


    if (this.$store.state.cart.lastName) {
      this.lastName = this.$store.state.cart.lastName;
    }

    __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/account/user').then(function (response) {
      var user = response.user;

      if (user && user.email) {
        user.name1 = user.name1 || '';
        user.name1 = user.name1.toLowerCase() === 'undefined' ? '' : user.name1;
        user.name1 = user.name1.toLowerCase() === 'null' ? '' : user.name1;
        user.name2 = user.name2 || '';
        user.name2 = user.name2.toLowerCase() === 'undefined' ? '' : user.name2;
        user.name2 = user.name2.toLowerCase() === 'null' ? '' : user.name2;

        _this.email = user.email || _this.email;
        _this.phone = user.mobile_phone || _this.phone;
        _this.name = user.name1 || '';
        _this.lastName = user.name2 || '';

        if (_this.name.toLowerCase() === 'undefined') {
          _this.name = '';
        }
        if (_this.lastName.toLowerCase() === 'undefined') {
          _this.lastName = '';
        }

        if (user.addr5) {
          _this.country = user.addr5;

          if (_this.country === 'SE') {
            _this.country = 'Sverige';
          }
        }
      }

      _this.loading = false;
    });
  },
  data: function data() {
    return {
      isCreating: false,
      phone: '',
      email: '',
      name: '',
      lastName: '',
      country: '',

      loading: false,
      errors: [],
      errors2: [],
      enableQuickLogin: '',
      smsSent: false,
      smsCode: '',
      checkingSomething: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['loggedIn']), {
    doRedirect: function doRedirect() {
      if (this.$store.state.isOnSite) {
        return false;
      }
      return true;
    },
    validated: function validated() {
      if (this.isAddonBooking) {
        return true;
      }

      if (!this.phone) {
        return false;
      }
      if (!this.email) {
        return false;
      }
      if (!this.name) {
        return false;
      }
      if (!this.lastName) {
        return false;
      }

      if (this.phone.toString().replaceAll(' ', '').replaceAll('-', '').match(/^\+[0-9]{9,13}$/) === null) {
        return false;
      }

      if (this.email.toString().match(/(.+)@(.+){2,}\.(.+){2,}/) === null) {
        return false;
      }

      if (!localStorage.getItem('country')) {
        return false;
      }

      if (this.checkingSomething) {
        return false;
      }

      return true;
    },
    isAddonBooking: function isAddonBooking() {
      return this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeModal', 'openModal', 'updateUserDetails', 'setUser']), {
    resetStatus: function resetStatus() {
      this.errors = [];
      this.errors2 = [];
      this.smsSent = false;
      this.smsCode = '';
      this.checkingSomething = false;
      this.enableQuickLogin = '';
    },
    updatePhone: function updatePhone(e) {
      this.phone = e;
      this.resetStatus();
    },
    updateEmail: function updateEmail(e) {
      this.email = e;
      this.resetStatus();
    },
    updateFirstName: function updateFirstName(e) {
      this.name = e;
    },
    updateLastName: function updateLastName(e) {
      this.lastName = e;
    },
    updateSmsCode: function updateSmsCode(e) {
      this.smsCode = e;
    },
    localCloseModal: function localCloseModal() {
      if (!this.isCreating) {
        this.closeModal();
      }
    },
    onSyncCallback: function onSyncCallback(number) {
      if (this.$store.state.isOnSite) {
        this.openModal(['OnSitePayment', {
          confirmationOnly: true,
          orderNumber: number
        }]);
      }
    },
    checkDetails: function checkDetails() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, success, errors, errorLength, i;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.updateUserDetails({
                  email: _this2.email,
                  phone: _this2.phone,
                  name: _this2.name,
                  lastName: _this2.lastName
                });

                _this2.checkingSomething = true;

                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].frontendHelper('verify-user-details', _this2.$store.state);

              case 4:
                _ref = _context.sent;
                success = _ref.success;
                errors = _ref.errors;


                _this2.checkingSomething = false;
                _this2.errors = [];

                if (!success) {
                  errorLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errors).length;


                  for (i in errors) {
                    if (errors.hasOwnProperty(i)) {
                      if (i !== 'user.exists') {
                        _this2.errors.push(errors[i].message);
                      } else {
                        console.log('user error');
                        if (errorLength === 1) {
                          _this2.enableQuickLogin = errors[i].message;
                        }
                      }
                    }
                  }
                } else {
                  _this2.isCreating = true;
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    sendCodeSms: function sendCodeSms() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, success, msg;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.checkingSomething = true;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].post('account/send-verification-code', { email: _this3.email, phone: _this3.phone });

              case 3:
                _ref2 = _context2.sent;
                success = _ref2.success;
                msg = _ref2.msg;

                _this3.checkingSomething = false;

                _this3.errors2 = [];

                if (success) {
                  _this3.smsSent = true;
                } else {
                  _this3.errors2.push(msg);
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    checkCode: function checkCode() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref3, success, user, isAdmin, token;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.checkingSomething = true;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].post('account/authenticate-verification-code', { verificationCode: _this4.smsCode, email: _this4.email, phone: _this4.phone });

              case 3:
                _ref3 = _context3.sent;
                success = _ref3.success;
                user = _ref3.user;
                isAdmin = _ref3.isAdmin;
                token = _ref3.token;

                _this4.checkingSomething = false;

                _this4.errors2 = [];

                if (success) {
                  _this4.$store.state.user = user;
                  _this4.$store.state.user.isAdmin = isAdmin;
                  _this4.$store.state.user.token = token;

                  _this4.setUser({
                    token: token
                  });

                  _this4.$emit('login', success);

                  document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));

                  _this4.resetStatus();

                  _this4.checkDetails();
                } else {
                  _this4.errors2.push('Koden stämmer inte');
                }

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    goToMyPages: function goToMyPages(e) {
      e.stopPropagation();
      e.preventDefault();
      this.closeModal();
      this.$router.push('/mina-sidor/uppgifter');
    }
  })
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_ModalFaker__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_ModalFaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_ModalFaker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Datepicker__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_popperjs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_popperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_popperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_popperjs_dist_css_vue_popper_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_popperjs_dist_css_vue_popper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_popperjs_dist_css_vue_popper_css__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    popper: __WEBPACK_IMPORTED_MODULE_12_vue_popperjs___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_7__components_components_Datepicker___default.a,
    ModalFaker: __WEBPACK_IMPORTED_MODULE_6__components_components_ModalFaker___default.a
  },
  data: function data() {
    return {
      validStartDates: [],
      validEndDates: [],
      disabledEndDates: [],
      disabledDays: [],
      specialDays: [],
      theStartDate: null,
      theEndDate: null,
      selectRange: false,
      infoMessage: '',
      isSummerSeason: false,
      disableRange: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loaded = true;
              _this.validStartDates = _this.params.validDates;
              _this.validEndDates = _this.params.validDates;
              _this.disabledDays = _this.params.disabledDays;
              _this.specialDays = _this.params.specialDays;

              if (typeof _this.params.disableRange === 'boolean') {
                _this.disableRange = _this.params.disableRange;
              }

              if (_this.params.pickedStartDate) {
                _this.theStartDate = _this.params.pickedStartDate;
                _this.$refs.pickerDate.currentMonth = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this.params.pickedStartDate).startOf('month').toDate();
                _this.selectRange = !_this.disableRange;
              } else {
                _this.$refs.pickerDate.currentMonth = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this.validStartDates[0]).startOf('month').toDate();
              }
              if (_this.params.pickedEndDate) {
                _this.theEndDate = _this.params.pickedEndDate;
                _this.selectRange = false;
              }

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    closedMessage: function closedMessage() {
      return this.params.closed_message || this.SITE_CONFIG.closed_message || this.$i18n.t('general.closed-backup');
    },
    open: function open() {
      if (typeof this.params.open !== 'undefined') {
        return this.params.open;
      }
      return this.SITE_CONFIG.is_open;
    },
    startDate: function startDate() {
      return this.theStartDate && new Date(this.theStartDate);
    },
    endDate: function endDate() {
      return this.theEndDate && new Date(this.theEndDate);
    },
    validStartDate: function validStartDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dates__["a" /* validStartDate */])({
        validStartDates: this.validStartDates
      });
    },
    validRangeDate: function validRangeDate() {
      if (this.validEndDates && this.validEndDates.length) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dates__["a" /* validStartDate */])({
          validStartDates: this.validEndDates
        });
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dates__["b" /* validRangeDate */])({
        startDate: this.startDate,
        validStartDates: this.validStartDates,
        days: this.validEndDates || 1
      });
    },
    showNight: function showNight() {
      var ymd = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.startDate).format('YYYY-MM-DD');
      if (this.params.night && this.params.night.length && this.params.night.indexOf(ymd) !== -1) {
        return true;
      }
      return false;
    },
    hasClosedDays: function hasClosedDays() {
      return true;
    },
    numberOfDays: function numberOfDays() {
      var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["b" /* dayCountExcludeClosed */])(this.startDate, this.endDate);
      var days = this.$i18n.t('general.days');

      if (diff > 1) {
        return diff + ' ' + days;
      }

      return diff;
    },
    getDisabledDays: function getDisabledDays() {
      if (this.theStartDate && !this.theEndDate) {
        return this.disabledEndDates;
      }
      return this.disabledDays;
    },
    getSpecialDays: function getSpecialDays() {
      return this.specialDays;
    },
    clickOutside: function clickOutside() {
      if (typeof this.params.clickOutside === 'undefined') {
        return true;
      }

      return this.params.clickOutside;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['setAccomodationsFilterStartDate', 'setAccomodationsFilterEndDate', 'setAccomodationsAvailableIds', 'closeModal']), {
    selectDate: function selectDate() {
      this.selectRange = !this.disableRange;
      this.chooseDates('day');
    },
    selectNight: function selectNight() {
      this.selectRange = !this.disableRange;
      this.chooseDates('night');
    },
    pickEndDate: function pickEndDate() {
      this.selectRange = !this.disableRange;
    },
    closeTheModal: function closeTheModal() {
      this.params.onClose(null, null, null, null);
      this.closeModal();
    },
    chooseDates: function chooseDates(type) {
      if (this.params.onClose) {
        this.params.onClose(this.theStartDate, this.theEndDate, type, this.isSummerSeason);
      }
      this.closeModal();
    },
    updateAvailableUnits: function updateAvailableUnits(value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var startFormatted, endFormatted, _ref, data;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                startFormatted = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this2.startDate).format('YYYY-MM-DD');
                endFormatted = __WEBPACK_IMPORTED_MODULE_11_moment___default()(value).format('YYYY-MM-DD');
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__classes_API__["a" /* default */].get('/dates/units-available/' + startFormatted + '/' + endFormatted);

              case 4:
                _ref = _context2.sent;
                data = _ref.data;

                _this2.setAccomodationsAvailableIds(data);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    changedStartDate: function changedStartDate(value) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dates;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dates = {};


                _this3.theStartDate = value;
                if (_this3.params.startDateOnly) {
                  _this3.selectRange = false;
                } else {
                  _this3.selectRange = !_this3.disableRange;
                }

                if (!_this3.params.onPickStart) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 6;
                return _this3.params.onPickStart(value);

              case 6:
                dates = _context3.sent;


                if (dates instanceof Array) {
                  _this3.validEndDates = dates;
                } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(dates)) {
                  _this3.validEndDates = dates;
                } else if (!dates) {
                  _this3.validEndDates = dates;
                } else {
                  _this3.validEndDates = dates.valid;
                  _this3.disabledEndDates = dates.invalid;
                }

              case 8:

                if (!_this3.params.startDateOnly) {
                  _this3.$refs.pickerDate.updateMonth();
                }

                if (!_this3.params.onPickStartInfo) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 12;
                return _this3.params.onPickStartInfo(value);

              case 12:
                _this3.infoMessage = _context3.sent;

                if (_this3.infoMessage.time) {
                  _this3.infoMessage = _this3.infoMessage.time;
                }

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    changedEndDate: function changedEndDate(value) {
      this.theEndDate = value;
      this.selectRange = false;
      if (this.theStartDate && !this.theEndDate) {
        if (!this.params.startDateOnly) {
          this.selectRange = !this.disableRange;
        }
      }
    },
    updateMonth: function updateMonth(e) {
      var month = __WEBPACK_IMPORTED_MODULE_11_moment___default()(e.month);

      if (month.get('month') >= 4 && month.get('month') <= 10) {
        this.isSummerSeason = true;
      } else {
        this.isSummerSeason = false;
      }
    }
  })
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal']), {
    localCloseModal: function localCloseModal() {
      if (this.params.closeModal) {
        this.params.closeModal();
        return;
      }
      this.closeModal();
    }
  }),
  mounted: function mounted() {}
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__ = __webpack_require__(31);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__["a" /* default */]],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_3__components_payments_Login___default.a
  },
  data: function data() {
    return {
      ssn: '',
      loading: false,
      error: false,
      appendedCount: 0
    };
  },
  mounted: function mounted() {
    this.ssn = this.$store.state.cart.ssn || '';
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    cancel: function cancel() {
      this.closeModal();
    },
    click: function click() {
      this.params.click();
      this.closeModal();
    }
  })
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_API__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {
      svg: '',
      styleNode: ''
    };
  },

  watch: {
    myStyleProp: function myStyleProp(val) {
      this.styleNode.textContent = val;
      return this.styleNode.textContent;
    }
  },
  mounted: function mounted() {
    if (this.params.locationId || !this.SITE_CONFIG.accomodations.show_site) {
      this.loadMap();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'changeMapLocation', 'openModal', 'setFilterLocationId', 'awaitFilter']), {
    stopper: function stopper() {},
    setLocation: function setLocation(id, isArea) {
      var newId = id;
      if (isArea) {
        newId = 'area-' + newId;
      }
      this.setFilterLocationId(newId);
      this.$emit('change', newId);
      this.awaitFilter();
      this.closeModal();
    },
    loadMap: function loadMap() {
      var $this = this;

      var overlay = this.SITE_CONFIG.accomodations.show_site ? this.params.locationId : this.SITE_CONFIG.site;

      __WEBPACK_IMPORTED_MODULE_3__classes_API__["a" /* default */].get('accommodation-map-branas-' + overlay + '.svg').then(function (result) {
        $this.svg = result;

        $this.$nextTick(function () {
          var selector = '.map-background svg > g > g';
          var gs = document.querySelectorAll(selector);
          var areaId = $this.params.areaId;

          console.log(gs);

          [].forEach.call(gs, function (g) {
            g.classList.remove('selected');

            var parts = g.id.split('-');
            if (parts[1] && areaId && parts[1].toString() === areaId.toString()) {
              g.classList.add('selected');
            }

            if ($this.params.type === 'interactive') {
              g.addEventListener('click', function (e) {
                $this.setLocation(parseInt(parts[1]));

                var gs = document.querySelectorAll(selector);
                var areaId = $this.params.areaId;

                [].forEach.call(gs, function (g) {
                  g.classList.remove('selected');
                });
                g.classList.add('selected');
              });
            }
          });
        });
      });
    },
    openMap: function openMap(id) {
      this.params.locationId = id;
      this.loadMap();
    }
  }),
  filters: {}
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_API__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {
      svg: '',
      styleNode: ''
    };
  },

  watch: {
    myStyleProp: function myStyleProp(val) {
      this.styleNode.textContent = val;
      return this.styleNode.textContent;
    }
  },
  mounted: function mounted() {
    if (this.params.locationId || !this.SITE_CONFIG.accomodations.show_site) {
      this.loadMap();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'changeMapLocation', 'openModal', 'setFilterLocationId', 'awaitFilter']), {
    stopper: function stopper() {},
    setLocation: function setLocation(id, isArea) {
      var newId = id;
      if (isArea) {
        newId = 'area-' + newId;
      }
      this.setFilterLocationId(newId);
      this.$emit('change', newId);
      this.awaitFilter();
      this.closeModal();
    },
    loadMap: function loadMap() {
      var $this = this;

      __WEBPACK_IMPORTED_MODULE_3__classes_API__["a" /* default */].get('accommodation-map-kungsberget.svg').then(function (result) {
        $this.svg = result;

        $this.$nextTick(function () {
          var selector = '.map-background svg > g > g';
          var gs = document.querySelectorAll(selector);
          var areaId = $this.params.areaId;

          console.log(gs);

          [].forEach.call(gs, function (g) {
            g.classList.remove('selected');

            var parts = g.id.split('-');
            if (parts[1] && areaId && parts[1].toString() === areaId.toString()) {
              g.classList.add('selected');
            }

            if ($this.params.type === 'interactive') {
              g.addEventListener('click', function (e) {
                $this.setLocation(parseInt(parts[1]));

                var gs = document.querySelectorAll(selector);
                var areaId = $this.params.areaId;

                [].forEach.call(gs, function (g) {
                  g.classList.remove('selected');
                });
                g.classList.add('selected');
              });
            }
          });
        });
      });
    },
    openMap: function openMap(id) {
      this.params.locationId = id;
      this.loadMap();
    }
  }),
  filters: {}
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Vimeo__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Vimeo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Vimeo__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Vimeo: __WEBPACK_IMPORTED_MODULE_3__components_components_Vimeo___default.a
  },
  data: function data() {
    return {};
  },

  watch: {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals'])),
  filters: {}
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CreatingOrder__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CreatingOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_CreatingOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_components_Modal___default.a,
    Cart: __WEBPACK_IMPORTED_MODULE_5__components_parts_Cart___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_components_Loading___default.a,
    CreatingOrder: __WEBPACK_IMPORTED_MODULE_6__components_parts_CreatingOrder___default.a
  },
  data: function data() {
    return {
      messages: [],
      showOk: false,
      showCancel: false,
      canCancel: false,
      hash: '',
      currentPaymentState: 'before-and-during-payment',
      orderNumber: '',
      eventNumber: 0,
      logs: [],
      loggerTimer: null
    };
  },
  mounted: function mounted() {
    this.log('mounted');
    this.log('aftermounted');
  },
  created: function created() {
    var _this = this;

    this.log('created');
    if (!this.params.confirmationOnly) {
      this.loggerTimer = setInterval(this.sendLogs, 2000);

      document.addEventListener('terminaltexts', this.handleTerminalTexts);
      document.addEventListener('paysuccess', this.handlePaySuccess);
      document.addEventListener('payfail', this.handlePayFail);
      document.addEventListener('paytransactionstarted', this.handlePayStarted);

      this.$nextTick(function () {
        _this.log('outer starting payment');
        _this.startPayment();
        _this.log('outer started payment');
      });
    } else {
      this.onSyncCallback(this.params.orderNumber);
    }
    this.log('aftercreated');
  },
  destroyed: function destroyed() {
    this.log('destroy');
    if (!this.params.confirmationOnly) {
      clearInterval(this.loggerTimer);
      document.removeEventListener('terminaltexts', this.handleTerminalTexts);
      document.removeEventListener('paysuccess', this.handlePaySuccess);
      document.removeEventListener('payfail', this.handlePayFail);
      document.removeEventListener('paytransactionstarted', this.handlePayStarted);
    }
    this.log('destroyed');
  },

  computed: {
    sum: function sum() {
      if (this.$store.state.isDebugging) {
        return 1;
      }

      var rentals = this.$store.state.cart.rentals.reduce(function (a, b) {
        if (b.confirmed) {
          var insurance = b.insurance ? b.insuranceSum || 0 : 0;
          return a + b.price * parseInt(b.quantity, 10) + insurance;
        }
        return a;
      }, 0);

      var schools = this.$store.state.cart.skischools.reduce(function (a, b) {
        return b.confirmed ? a + b.price * parseInt(b.quantity, 10) : a;
      }, 0);
      var passes = this.$store.state.cart.skipasses.reduce(function (a, b) {
        return b.confirmed ? a + b.price * parseInt(b.quantity, 10) : a;
      }, 0);

      return rentals + schools + passes;
    },
    tax: function tax() {
      return this.sum * 0.20;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'clearCart']), {
    resetPayment: function resetPayment() {
      this.log('resetting payment');
      this.startPayment();
      this.log('reset payment');
    },
    cancel: function cancel() {
      this.log('cancelling');
      var $this = this;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.cancel-booking-question-title'),
        content: this.$i18n.t('general.cancel-booking-question-text'),
        yes: function yes() {
          $this.closeAllModals();
          $this.clearCart();
          $this.$router.replace({
            path: '/pa-plats',
            query: {
              site: $this.$store.state.isOnWhichSite,
              refresh: 1
            }
          });
        },
        no: function no() {
          $this.closeAllModals();
        }
      }]);
    },
    cancelWithoutConfirmation: function cancelWithoutConfirmation() {
      this.log('closing modal without confirmation');
      this.closeAllModals();
      this.clearCart();
      this.$router.replace({
        path: '/pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 1
        }
      });
    },
    startPayment: function startPayment() {
      this.log('starting payment');
      var evt = document.createEvent('CustomEvent');
      var obj = {
        amount: this.sum * 100,
        vat: this.tax * 100,
        refund: 0
      };
      this.log('payment object', obj);
      evt.initCustomEvent('pay', true, true, obj);
      this.log('event', 'pay', obj);
      this.$refs.handler.dispatchEvent(evt);
      this.currentPaymentState = 'before-and-during-payment';
      this.syncPayDialog(false, false, '', '', '', '');
      this.canCancel = true;
      this.log('started payment');
    },
    syncPayDialog: function syncPayDialog(ok, cancel, row1, row2, row3, row4) {
      this.showOk = ok;
      this.showCancel = cancel;
      this.messages = [];
      this.messages.push({ message: row1 });
      this.messages.push({ message: row2 });
      this.messages.push({ message: row3 });
      this.messages.push({ message: row4 });
      this.canCancel = false;
    },
    handleTerminalTexts: function handleTerminalTexts(e) {
      this.log('recieving terminal text');
      var obj = e.detail;
      this.log('recieved terminal text', obj);
      var cancelButton = void 0;
      var okButton = void 0;
      if (obj.row2 && obj.row2.indexOf('KÖP GODKÄNT') > -1) {
        cancelButton = false;
      }
      this.syncPayDialog(okButton, cancelButton, obj.row1, obj.row2, obj.row3, obj.row4);
      this.log('synced pay dialog');
    },
    handlePaySuccess: function handlePaySuccess(e) {
      this.log('handle pay success');
      var obj = e.detail;
      this.log('recieved handle pay success', obj);
      this.hash = obj.hash;
      this.syncPayDialog(false, false, this.$i18n.t('skirental.payment-recieved-take-reciept'), '', '', '');
      this.log('synced pay dialog');
      this.createOrder();
      this.log('created order');
      this.log('sent payment ga-event');
    },
    createOrder: function createOrder() {
      this.currentPaymentState = 'syncing';
    },
    onSyncCallback: function onSyncCallback(orderNumber) {
      this.log('sync callback');
      if (orderNumber) {
        this.currentPaymentState = 'success';
        this.orderNumber = orderNumber;
        this.printBookingNumber(orderNumber);
        setTimeout(this.cancelWithoutConfirmation, 10000);
      } else {
        this.currentPaymentState = 'error-on-sync';
      }
      this.log('sync callback end');
    },
    handlePayFail: function handlePayFail(e) {
      this.log('handle pay fail');
      this.currentPaymentState = 'error';
      var obj = e.detail;
      this.log('recieved handle pay fail', obj);
      var message2 = obj.message;
      var message = void 0;

      switch (obj.reason) {
        case 1:
          message = this.$i18n.t('skirental.payment.errors.1');
          break;
        case 2:
          message = this.$i18n.t('skirental.payment.errors.2');
          break;
        case 3:
          message = this.$i18n.t('skirental.payment.errors.3');
          break;
        case 4:
          message = this.$i18n.t('skirental.payment.errors.4');
          break;
        case 5:
          message = this.$i18n.t('skirental.payment.errors.5');
          break;
        case 6:
          message = this.$i18n.t('skirental.payment.errors.6');
          break;
        case 7:
          message = this.$i18n.t('skirental.payment.errors.7');
          break;
        default:
          message = this.$i18n.t('skirental.payment.errors.default');
      }

      this.syncPayDialog(false, false, message, message2, '', '');
      this.log('synced pay fail dialog');
      this.log('sent payment fail ga-event');
    },
    handlePayStarted: function handlePayStarted(e) {
      var obj = e.detail;
      this.log('payment started with', obj);
    },
    printBookingNumber: function printBookingNumber(number) {
      if (this.SITE_CONFIG.site === 'vallasen' || this.SITE_CONFIG.site === 'ulricehamn') {
        this.log('printing booking number');
        var evt = document.createEvent('CustomEvent');
        var date = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD HH:mm:ss');
        var textBookingNumber = this.$i18n.t('general.bookingnumber');
        var siteName = this.SITE_CONFIG.site_name;
        var textDate = this.$i18n.t('general.date');
        var textSkirental = this.$i18n.t('general.skirental');

        var obj = {
          title: textBookingNumber + ' ' + number,
          text: '\n\n' + siteName + ' ' + textSkirental + '\n\n\n' + textBookingNumber + ':  ' + number + '\n\n' + textDate + ':           ' + date + '\n\n\n\n\n',
          includeCutCommand: true
        };

        this.log('printing booking number with', obj);

        evt.initCustomEvent('print', true, true, obj);

        this.log('printed booking number');
        document.dispatchEvent(evt);
      }
    },
    simulateTerminalInsert: function simulateTerminalInsert() {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('terminaltexts', true, true, { row1: 'A', row2: 'B', row3: 'C', row4: 'D' });
      document.dispatchEvent(evt);
    },
    simulateTerminalCode: function simulateTerminalCode() {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('terminaltexts', true, true, { row1: 'A', row2: 'B', row3: 'C', row4: 'D' });
      document.dispatchEvent(evt);
    },
    simulateTerminalApprove: function simulateTerminalApprove() {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('paysuccess', true, true, { hash: 'manual' });
      document.dispatchEvent(evt);
    },
    simulateTerminalCancel: function simulateTerminalCancel() {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('payfail', true, true, { reason: 1, message: 'hej, det blev fel' });
      document.dispatchEvent(evt);
    },
    localCloseModal: function localCloseModal(force) {
      this.log('closing modal');
      if (force === true) {
        this.log('force closing modals');
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent('cancelpay', true, true, {});
        this.log('sent closing event');
        document.dispatchEvent(evt);
        this.closeModal();
      }
      this.log('closed modal');
    },
    log: function log() {
      this.eventNumber += 1;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      console.log(this.eventNumber, args, this.$store.state.user_code);
      this.logs.push({
        part: 'pay-on-site',
        user: this.$store.state.user_code,
        iterator: this.eventNumber,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(args)
      });
    },
    sendLogs: function sendLogs() {
      if (this.SITE_CONFIG.rental.onsite_frontend_logger && this.logs.length) {
        var logs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.logs);
        this.logs = [];
        __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].frontendHelper('/log', {
          logs: logs,
          cart: this.$store.state.cart
        });
      }
    }
  })
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'openModal']), {
    qrUrl: function qrUrl(ordernumber) {
      return window.API_URL + '/api/v1/qr?code=' + ordernumber + '&size=200';
    }
  }),
  computed: {
    hasValidCodes: function hasValidCodes() {
      return this.params.order.qrCodes.map(function (code) {
        return !!code.ordernumber;
      }).filter(function (code) {
        return code;
      }).length > 0;
    },
    hasCodes: function hasCodes() {
      return this.params.order.qrCodes.length > 0;
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_components_Loading___default.a
  },
  data: function data() {
    return {
      accomodations: [],
      skischools: [],
      canContinue: false,
      canContinueAll: false,
      loading: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var cart;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.$store.state.cart);

              _this.accomodations = cart.accomodations.filter(function (a) {
                return a.confirmed;
              }).map(function (a) {
                a.reclaimed = false;
                return a;
              });
              _this.skischools = cart.skischools.filter(function (a) {
                return a.confirmed;
              }).map(function (a) {
                a.reclaimed = false;
                return a;
              });
              _this.rentals = cart.rentals.filter(function (a) {
                return a.confirmed;
              }).map(function (a) {
                a.reclaimed = false;
                return a;
              });
              _this.skipasses = cart.skipasses.filter(function (a) {
                return a.confirmed;
              }).map(function (a) {
                a.reclaimed = false;
                return a;
              });

              if (!(_this.accomodations.length + _this.skischools.length === 0)) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return _this.reclaim('general');

            case 8:

              if (_this.accomodations.length + _this.skischools.length + _this.rentals.length + _this.skipasses.length === 0) {
                _this.$store.state.lockingBeforeTime = null;
                _this.$store.state.lockingActive = false;
                _this.closeModal();
                setTimeout(_this.params.continueToPayment, 1);
              }

              _this.loading = false;

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal', 'closeModal', 'closeAllModals', 'saveCartLocking']), {
    reclaim: function reclaim(type, unit, index) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var $this, url, orderId, orderCode, _ref, success, code, before_time, reason, reclaimedLength, totalLength;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;

                $this = _this2;
                url = '';

                if (type === 'accomodation') {
                  url = '/units/' + unit.poolLid + '/' + unit.unitLid + '/reserve/' + unit.period.date_arrival + '/' + unit.period.date_departure;
                } else if (type === 'skischool') {
                  url = '/skischool/reserve/' + unit.activity_lid + '/' + unit.quantity;
                } else {
                  url = '/locks/reserve';
                }

                if (_this2.$store.state.lockingCode) {
                  url = url + '/' + _this2.$store.state.lockingCode;
                }

                orderId = _this2.$route.query.order || '';
                orderCode = _this2.$route.query.code || '';


                url = url + '?order=' + orderId + '&code=' + orderCode;

                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get(url);

              case 10:
                _ref = _context2.sent;
                success = _ref.success;
                code = _ref.code;
                before_time = _ref.before_time;
                reason = _ref.reason;

                if (success) {
                  _context2.next = 18;
                  break;
                }

                _this2.openModal(['GeneralModal', {
                  title: 'Bokningstillgänglighet',
                  content: '<p>' + reason + '</p>',
                  buttons: [{
                    title: 'Okej',
                    class: '',
                    click: function click() {
                      $this.closeModal();
                    }
                  }]
                }]);
                return _context2.abrupt('return', false);

              case 18:

                _this2.saveCartLocking({
                  code: code,
                  beforeTime: before_time });

                if (type === 'accomodation') {
                  _this2.accomodations[index].reclaimed = true;
                } else if (type === 'skischool') {
                  _this2.skischools[index].reclaimed = true;
                }

                _this2.canContinue = true;

                reclaimedLength = _this2.accomodations.filter(function (a) {
                  return a.reclaimed === true;
                }) + _this2.skischools.filter(function (a) {
                  return a.reclaimed === true;
                });
                totalLength = _this2.accomodations.filter(function (a) {
                  console.log(a);
                  return true;
                }) + _this2.skischools.filter(function (a) {
                  console.log(a);
                  return true;
                });


                _this2.canContinueAll = reclaimedLength.length === totalLength.length;

                _this2.loading = false;

                return _context2.abrupt('return', true);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    moment: function moment(date, format) {
      var string = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format(format);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeModalLocal: function closeModalLocal() {
      if (this.params.forceSyncAll) {
        return false;
      }

      this.closeModal();
      return true;
    },
    cancel: function cancel() {
      this.loading = true;
      this.$root.$emit('cancel-payment', true);
    }
  })
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_checkdigit__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_checkdigit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_checkdigit__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_languageDetector__["a" /* default */]],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_3__components_payments_Login___default.a
  },
  data: function data() {
    return {
      ssn: '',
      loading: false,
      error: false,
      appendedCount: 0
    };
  },
  mounted: function mounted() {
    this.ssn = this.$store.state.cart.ssn || '';
  },

  computed: {
    valid: function valid() {
      this.error = '';

      if (this.ssn.length === 10 && this.ssn.indexOf('-') === -1 && this.ssn.indexOf('-') === -1) {
        this.error = 'Angivet personnummer saknar ett streck (ÅÅÅÅMMDD-XXXX)';
        return false;
      }

      if (this.ssn.length > 13) {
        this.error = 'Angivet personnummer är för långt';
        return false;
      }

      if (this.ssn.length === 11) {
        var firstTwo = this.ssn.substr(0, 2);
        if (firstTwo !== '19' && firstTwo !== '20') {
          this.error = 'Angivet personnummer saknar de första två siffrorna';
          return false;
        }
      }

      if (this.ssn.length < 13) {
        return false;
      }

      var year = this.ssn.substr(0, 4);
      var month = this.ssn.substr(4, 2);
      var monthForDate = parseInt(month, 10) - 1;
      var day = this.ssn.substr(6, 2);
      var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()([year, monthForDate, day]);
      var lastNumber = this.ssn.substr(this.ssn.length - 1, 1);

      if (!date.isValid()) {
        this.error = 'Datumet (' + year + month + day + ') i angivet personnummer st\xE4mmer inte';
        return false;
      }

      var valid = __WEBPACK_IMPORTED_MODULE_6_checkdigit___default.a.mod10.isValid(this.ssn.substr(2, 11).replace('-', '').replace('+', ''));
      if (!valid) {
        this.error = 'Checksiffran (' + lastNumber + ') st\xE4mmer inte';
        return false;
      }

      return true;
    },
    isSwedish: function isSwedish() {
      return this.browserLanguage.indexOf(this.SITE_CONFIG.languages.default) !== -1;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    localCloseModal: function localCloseModal() {
      this.closeModal();
    },
    cancel: function cancel() {
      this.$store.state.cart.ssn = '';
      this.params.cancel();
      this.closeModal();
    },
    addDash: function addDash() {
      this.ssn = this.ssn.replace(/[^0-9-]/g, '');
      this.ssn = this.ssn.replace(/[+]/g, '-');

      var firstTwo = this.ssn.substr(0, 2);
      if (firstTwo === '19' || firstTwo === '20') {
        if ((this.ssn || '').length === 8 && !this.appendedCount) {
          this.ssn = this.ssn + '-';
          this.appendedCount += 1;
        }
      }

      if ((this.ssn || '').length === 10 && this.ssn.substr(8, 2) === '--') {
        this.ssn = this.ssn.substr(0, 9);
      }

      if ((this.ssn || '').length === 12 && this.ssn.indexOf('-') === -1 && this.ssn.indexOf('+') === -1 && !this.appendedCount) {
        var part1 = this.ssn.substr(0, 8);
        var part2 = this.ssn.substr(8, 4);
        this.ssn = part1 + '-' + part2;
      }
    },
    click: function click() {
      if (this.valid) {
        this.$store.state.cart.ssn = this.ssn;
        this.params.click();
        this.closeModal();
      }
    }
  })
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    AccomodationPeriodConfirm: __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default.a
  },
  data: function data() {
    return {
      peopleCount: 1,
      accomodation: null,
      unit: {},
      arrival: '',
      departure: '',
      accomodations: [],
      is_free: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var accomodations, confirmed, _ref, free;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.$store.state.cart.accomodations));
              confirmed = accomodations.filter(function (accomodation) {
                return accomodation.confirmed;
              });


              if (confirmed.length) {
                _this.accomodation = confirmed[0];
                _this.accomodations = confirmed;
              } else if (_this.$store.state.cart.addToOrder && _this.$store.state.cart.addToOrder.dateStart) {
                _this.accomodation = {
                  poolLid: _this.$store.state.cart.addToOrder.helperPool,
                  unitLid: _this.$store.state.cart.addToOrder.helperUnit,
                  period: {
                    date_arrival: _this.$store.state.cart.addToOrder.dateStart,
                    date_departure: _this.$store.state.cart.addToOrder.dateEnd
                  }
                };
              }

              if (!_this.accomodation) {
                _context.next = 12;
                break;
              }

              _this.unit = {
                pool_lid: _this.accomodation.poolLid,
                unit_lid: _this.accomodation.unitLid
              };
              _this.arrival = _this.accomodation.period.date_arrival;
              _this.departure = _this.accomodation.period.date_departure;

              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/units/' + _this.params.unitPreview.pool_lid + '/' + _this.params.unitPreview.unit_lid + '/is_free/' + _this.arrival + '/' + _this.departure);

            case 9:
              _ref = _context.sent;
              free = _ref.free;

              _this.is_free = free;

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeModal', 'openModal', 'addRentalPeople', 'confirmedAccomodations', 'closeAllModals']), {
    goToCart: function goToCart() {
      this.closeModal();
      this.$router.push({ path: '/varukorg' });
    },
    goToInfo: function goToInfo() {
      this.closeModal();

      this.$router.push({
        path: '/boenden/info/' + this.$route.params.slug + '/' + this.arrival + '/' + this.departure + '?no=-1'
      });
    },
    goToSearch: function goToSearch() {
      this.closeModal();
      this.$router.push({ name: 'accomodation list' });
    },
    localClose: function localClose() {
      return false;
    }
  })
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    SwitchButton: __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_7__components_components_Checkbox___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default.a
  },
  data: function data() {
    return {
      site: '',
      insurance: null,
      markInsurance: false,
      pickupTime: null,
      phone: null,
      errors: {},
      touched: {},
      pickedStartDate: null,
      validStartDates: [],
      showDate: false,
      loading: true,
      delivery_type: 'delivery',
      hasAccomodation: false,
      isSeason: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var accomodations, _ref, nonSeasonCardsData, nonSeasonCards, date, _ref2, data, _accomodations, confirmed, start, _start, now;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.hasAccomodation = false;

              if ((_this.$store.state.cart.accomodations.filter(function (a) {
                return a.confirmed;
              }).length || _this.$store.state.cart.addToOrder && _this.$store.state.cart.addToOrder.dateStart) && !_this.pickedStartDate && !_this.$store.state.tempDate) {
                console.log(_this.$store.state.cart.accomodations.filter(function (a) {
                  return a.confirmed;
                }).length);
                if (_this.$store.state.cart.accomodations.filter(function (a) {
                  return a.confirmed;
                }).length) {
                  accomodations = _this.$store.state.cart.accomodations.filter(function (a) {
                    return a.confirmed;
                  });

                  _this.pickedStartDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(accomodations[0].period.date_arrival).toDate();

                  if (accomodations[0] && accomodations[0].site) {
                    if (accomodations[0].site === 2007) {
                      _this.site = 'by';
                    } else if (accomodations[0].site === 2006) {
                      _this.site = 'berg';
                    }
                  }

                  _this.hasAccomodation = true;
                } else {
                  _this.pickedStartDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this.$store.state.cart.addToOrder.dateStart).toDate();
                }
              }

              _this.validStartDates = [];

              _this.loading = true;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_9__classes_API__["a" /* default */].post('cart/skipass/cart-non-season-cards', _this.$store.state.cart.skipasses);

            case 6:
              _ref = _context.sent;
              nonSeasonCardsData = _ref.nonSeasonCardsData;
              nonSeasonCards = nonSeasonCardsData;

              _this.loading = false;

              if (nonSeasonCards > 0) {
                _this.isSeason = false;
              }

              if (_this.SITE_CONFIG.site === 'kungsberget' && _this.SITE_CONFIG.season.winter.premiere_weekend_start) {
                date = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this.SITE_CONFIG.season.winter.premiere_weekend_start);


                if (nonSeasonCards === 0) {
                  _this.selectDates(date);
                  _this.loading = false;
                }

                _this.loading = false;
              }

              _context.next = 14;
              return __WEBPACK_IMPORTED_MODULE_9__classes_API__["a" /* default */].post('skipass/get-valid-arrival-dates', _this.$store.state.cart.skipasses);

            case 14:
              _ref2 = _context.sent;
              data = _ref2.data;

              _this.validStartDates = data;

              _this.restrictDates();

              if (!_this.pickedStartDate) {
                _this.showDate = true;

                if (_this.$store.state.tempDate) {
                  _this.pickedStartDate = _this.$store.state.tempDate;
                  _this.$store.state.tempDate = null;
                } else if (_this.$store.state.cart.addToOrder && _this.$store.state.cart.dateStart) {
                  _this.pickedStartDate = _this.$store.state.cart.addToOrder.dateStart;
                } else {
                  _accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this.$store.state.cart.accomodations));
                  confirmed = _accomodations.filter(function (accomodation) {
                    return accomodation.confirmed;
                  });


                  if (confirmed.length) {
                    start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(confirmed[0].period.date_arrival);

                    _this.pickedStartDate = start.toDate();
                    _this.hasAccomodation = true;
                    _this.showDate = false;
                  }
                }
              }

              if (['vallasen', 'ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(_this.SITE_CONFIG.site) !== -1) {
                _this.showDate = false;

                _start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this.validStartDates[0]).toDate();
                now = __WEBPACK_IMPORTED_MODULE_11_moment___default()().toDate();


                if (now > _start) {
                  _this.pickedStartDate = now;
                } else {
                  _this.pickedStartDate = _start;
                }

                console.log('Setting date to ', _this.pickedStartDate);
              }

              if (!_this.hasAccomodation) {
                _this.delivery_type = 'pickup';
              }

              if (_this.SITE_CONFIG.site === 'kungsberget') {
                _this.delivery_type = 'pickup';
              }

              if (_this.showDate === false && _this.hasAccomodation === false && _this.isSeason === false) {
                _this.addToCart();
              }

              _this.loading = false;

              if (_this.hasRefill) {
                _this.showDate = true;
              }

            case 25:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    validated: function validated() {
      var valid = true;

      if (!this.pickedStartDate) {
        valid = false;
      }

      if (this.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')) {
        var siteOkay = this.delivery_type === 'delivery' || this.site || this.hasOnlyRefill;
        if (!siteOkay && this.SITE_CONFIG.site === 'branas') {
          valid = false;
        }
      }

      return valid;
    },
    skiPassAccomodationAfterCheckinText: function skiPassAccomodationAfterCheckinText() {
      return 'Efter incheckning i boendet. Liftkorten levereras med nycklarna.';
    },
    skiPassAccomodationBeforeCheckinText: function skiPassAccomodationBeforeCheckinText() {
      return 'Före incheckning i boendet. Liftkorten hämtas i skidhyran.';
    },
    localSkipasses: function localSkipasses() {
      return this.$store.state.cart.skipasses.filter(function (s) {
        return s.type !== 'SKIPASS-ACCO';
      });
    },
    hasRefill: function hasRefill() {
      return this.localSkipasses.filter(function (s) {
        return s.refill;
      }).length;
    },
    hasOnlyRefill: function hasOnlyRefill() {
      return this.localSkipasses.filter(function (s) {
        return s.refill;
      }).length === this.localSkipasses.length;
    },
    hasNonRefill: function hasNonRefill() {
      return this.localSkipasses.filter(function (s) {
        return !s.refill;
      }).length;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'confirmSkiPass', 'saveCartLocking']), {
    restrictDates: function restrictDates() {
      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.dateStart) {
        var loopStart = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.$store.state.cart.addToOrder.dateStart).subtract(1, 'day').toDate();
        var end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.$store.state.cart.addToOrder.dateEnd).toDate();

        var current = loopStart;

        var newArray = [];

        while (current < end) {
          var next = __WEBPACK_IMPORTED_MODULE_11_moment___default()(current).add(1, 'days');
          if (this.SITE_CONFIG.season.winter.closed.indexOf(next.format('YYYY-MM-DD')) === -1 && this.validStartDates.indexOf(next.format('YYYY-MM-DD')) !== -1) {
            newArray.push(next.format('YYYY-MM-DD'));
          }
          current = next.toDate();
        }

        this.validStartDates = newArray;
      }
    },
    addToCartAndPay: function addToCartAndPay() {
      this.addToCart(true);
    },
    addToCart: function addToCart(pay) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var o, cartAccomodationObject, accObject, deliveryTo, url, _ref3, before_time, code;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.validated) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', false);

              case 2:

                if (_this2.hasOnlyRefill) {
                  _this2.delivery_type = 'pickup';
                }

                o = {
                  date: _this2.pickedStartDate,
                  type: _this2.hasAccomodation ? _this2.delivery_type : 'pickup',
                  site: _this2.site
                };


                if (_this2.delivery_type === 'delivery') {
                  cartAccomodationObject = _this2.$store.state.cart.accomodations[0];
                  accObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                    pool_lid: cartAccomodationObject.poolLid,
                    unit_lid: cartAccomodationObject.unitLid,
                    name: cartAccomodationObject.name
                  });
                  deliveryTo = {
                    pool_lid: accObject.pool_lid,
                    unit_lid: accObject.unit_lid,
                    name: accObject.name
                  };


                  if (!_this2.$store.state.cart.deliveryTo.length) {
                    o.deliveryTo = deliveryTo;
                  }
                }

                _this2.confirmSkiPass(o);

                url = '/locks/reserve';

                if (_this2.$store.state.lockingCode) {
                  url = url + '/' + _this2.$store.state.lockingCode;
                }
                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_9__classes_API__["a" /* default */].get(url);

              case 10:
                _ref3 = _context2.sent;
                before_time = _ref3.before_time;
                code = _ref3.code;


                _this2.saveCartLocking({
                  code: code,
                  beforeTime: before_time
                });

                window.trackAddToCart({
                  title: 'Liftkort',
                  lines: _this2.$store.state.cart.skipasses.map(function (product) {
                    return {
                      id: product.pool_lid,
                      title: 'Liftkort',
                      category: 'equipment',
                      quantity: 1,
                      price: product.price
                    };
                  })
                });

                if (!_this2.$store.state.isOnSite) {
                  if (pay) {
                    _this2.$router.push({ path: '/varukorg?pay=1' });
                  } else {
                    _this2.$router.push({ path: '/varukorg?show-confirmation=1&ref=skipass' });
                  }
                } else {
                  _this2.closeAllModals();

                  setTimeout(function () {
                    _this2.openModal(['OnSitePayment']);
                  }, 1);
                }

                return _context2.abrupt('return', true);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    selectDates: function selectDates(start) {
      this.pickedStartDate = start;
      this.$store.state.tempDate = this.pickedStartDate;

      console.log(this.pickedStartDate);
      console.log(this.$store.state.tempDate);
    },
    datepickerModal: function datepickerModal() {
      var info = this.$i18n.t('general.pick-extradition');
      var extra = '';
      if (this.SITE_CONFIG.site === 'branas') {
        extra = this.$i18n.t('general.pick-extradition-note-branas');
      } else if (this.SITE_CONFIG.site === 'kungsberget') {
        extra = this.$i18n.t('general.pick-extradition-note-kungsberget');
      }

      info = info + '<br>' + extra;

      this.openModal(['DatepickerRangeModal', {
        validDates: this.validStartDates,
        pickedEndDate: null,
        onClose: this.selectDates,
        night: false,
        startDateOnly: true,
        terminology: this.$i18n.t('general.pick'),
        info: info
      }]);
    },
    dateClear: function dateClear() {
      this.pickedStartDate = null;
      this.$store.state.tempDate = this.pickedStartDate;
    },
    formatDate: function formatDate() {
      if (this.pickedStartDate) {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.pickedStartDate).format('D MMMM YYYY');
      }
      return this.$i18n.t('general.pick-date');
    }
  })
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_AccomodationCartItem__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher__);













/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_components_Modal___default.a,
    CounterButton: __WEBPACK_IMPORTED_MODULE_4__components_components_CounterButton___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_5__components_components_Dropdown___default.a,
    AccomodationPeriodConfirm: __WEBPACK_IMPORTED_MODULE_7__components_parts_Accomodation_AccomodationPeriodConfirm___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher___default.a
  },
  data: function data() {
    return {
      peopleCount: 1,
      accomodation: {},
      unit: {},
      arrival: '',
      departure: '',
      hasAccomodation: false
    };
  },
  mounted: function mounted() {
    var accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.cart.accomodations));
    var confirmed = accomodations.filter(function (accomodation) {
      return accomodation.confirmed;
    });

    if (confirmed.length) {
      this.peopleCount = __WEBPACK_IMPORTED_MODULE_6__classes_AccomodationCartItem__["a" /* default */].peopleCount(confirmed[0]);
      this.hasAccomodation = true;

      if (this.$refs.counterButton) {
        this.$refs.counterButton.count = this.peopleCount;
      }
    } else if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.hasAccommodation) {
      this.hasAccomodation = true;

      if (this.$refs.counterButton) {
        this.$refs.counterButton.count = this.peopleCount;
      }
    } else {
      this.hasAccomodation = false;
    }

    var completedPasses = this.$store.state.cart.skipasses.filter(function (skipass) {
      return skipass.guideCompleted;
    });

    if (completedPasses.length) {
      this.closeModal();
      this.$router.push({ name: 'ski pass overview', query: this.$route.query });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['guidedPasses']), {
    passes: function passes() {
      return this.guidedPasses.filter(function (a) {
        return a.type === '';
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'addSkiPassPeople', 'confirmedAccomodations']), {
    localCloseModal: function localCloseModal() {
      if (!this.$store.state.isOnSite) {
        this.closeModal();
      }
    },
    validate: function validate() {
      var errors = 0;
      errors += this.peopleCount ? 0 : 1;
      return !errors;
    },
    changePeople: function changePeople(payload) {
      this.peopleCount = payload;
    },
    startBooking: function startBooking() {
      this.addSkiPassPeople({
        peopleCount: this.peopleCount,
        numberOfDays: 0,
        append: false
      });

      this.closeAllModals();

      this.$router.push({ name: 'ski pass person', query: this.$route.query, params: { person: '0' } });
    },
    goOn: function goOn() {
      this.closeModal();
      this.$router.push({ name: 'ski pass overview', query: this.$route.query });
    },
    openPriceList: function openPriceList() {
      this.openModal(['SkipassPrices']);
    },
    goToAccommodations: function goToAccommodations() {
      this.closeAllModals();
      this.$router.push({ name: 'accomodation list' });
    }
  })
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher__);














/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default.a,
    CounterButton: __WEBPACK_IMPORTED_MODULE_5__components_components_CounterButton___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_6__components_components_Dropdown___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_8__components_components_LanguageSwitcher___default.a
  },
  data: function data() {
    return {
      peopleCount: 1,
      keycard: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_7__classes_API__["a" /* default */].get('products?tag=keycard-post');

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              if (data.length) {
                _this.keycard = data[0];
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'addProduct']), {
    localCloseModal: function localCloseModal() {
      this.closeModal();
    },
    validate: function validate() {
      var errors = 0;
      errors += this.peopleCount ? 0 : 1;
      return !errors;
    },
    startBooking: function startBooking() {
      this.addProduct({
        quantity: this.peopleCount,
        price: this.keycard.price,
        poolId: this.keycard.pool_lid,
        name: this.keycard.name
      });

      this.closeAllModals();

      var name = this.keycard.name;

      this.$router.push({ path: '/varukorg?show-confirmation=1&ref=product&text=' + name });
    },
    changePeople: function changePeople(payload) {
      this.peopleCount = payload;
    }
  })
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_AccomodationPeriodConfirm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_AccomodationPeriodConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_AccomodationPeriodConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Scanner__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Scanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Scanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_checkdigit__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_checkdigit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_checkdigit__);


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    CounterButton: __WEBPACK_IMPORTED_MODULE_6__components_components_CounterButton___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default.a,
    AccomodationPeriodConfirm: __WEBPACK_IMPORTED_MODULE_8__components_parts_Accomodation_AccomodationPeriodConfirm___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_9__components_components_Checkbox___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_10__components_payments_Login___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_11__components_components_Loading___default.a,
    Scanner: __WEBPACK_IMPORTED_MODULE_12__Scanner___default.a
  },
  data: function data() {
    return {
      number: '',
      prefix: '',
      pattern: '####-####-####-####-####-#',
      placeholder: '0000-0000-0000-0000-0000-0',
      tabSaved: false,
      skipasses: [],
      cardId: '',
      loading: false,
      scanningOpen: false,
      wasScanned: false,
      scannedNumber: ''
    };
  },
  mounted: function mounted() {
    this.fetch();

    if (this.params.prefillPrefix) {
      this.prefix = this.params.prefillPrefix;
    }
    if (this.params.prefillNumber) {
      this.number = this.params.prefillNumber;
    }

    if (this.params.pass) {
      this.tabSaved = true;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn']), {
    fullNumber: function fullNumber() {
      return this.prefix + '-' + this.number;
    },
    fullNumberWithoutDashes: function fullNumberWithoutDashes() {
      return ('' + this.prefix + this.number).replace(/-/g, '');
    },
    onScannerSuccess: function onScannerSuccess() {
      var _this = this;

      return function (code) {
        _this.number = code.replace(/-/g, '').slice(2);
        _this.prefix = code.replace(/-/g, '').slice(0, 2);

        if (_this.prefix !== '01' && _this.prefix !== '30') {
          if (_this.prefix === '38') {
            _this.prefix = '30';
          } else {
            _this.prefix = '01';
          }
        }

        _this.scannedNumber = _this.fullNumber;

        _this.wasScanned = true;

        setTimeout(function () {
          if (_this.$refs.scanner && _this.$refs.scanner.shutdown) {
            _this.$refs.scanner.shutdown();
          }
          setTimeout(function () {
            _this.scanningOpen = false;
          }, 1);
        }, 1000);
      };
    },
    options: function options() {
      return [{
        title: '01',
        value: '01'
      }, {
        title: '30',
        value: '30'
      }];
    },
    skipassesAsSelect: function skipassesAsSelect() {
      return this.skipasses.map(function (s) {
        return {
          value: s.guid,
          title: s.name ? s.name + ' (' + s.number + ')' : s.number
        };
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal']), {
    fetch: function fetch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, skipasses;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/account/user');

              case 3:
                _ref = _context.sent;
                skipasses = _ref.skipasses;

                _this2.skipasses = skipasses || [];
                _this2.loading = false;

                if (_this2.params.pass) {
                  _this2.cardId = _this2.params.pass.guid;
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    validate: function validate() {
      var validated = this.fullNumberWithoutDashes ? __WEBPACK_IMPORTED_MODULE_13_checkdigit___default.a.mod10.isValid(this.fullNumberWithoutDashes) : false;
      return this.fullNumberWithoutDashes.length === 23 && validated;
    },
    error: function error() {
      var validated = this.fullNumberWithoutDashes ? __WEBPACK_IMPORTED_MODULE_13_checkdigit___default.a.mod10.isValid(this.fullNumberWithoutDashes) : false;
      if (this.fullNumberWithoutDashes.length === 23 && validated) {
        this.wasScanned = false;
      }
      return this.fullNumberWithoutDashes.length === 23 && !validated;
    },
    setNumber: function setNumber() {
      var _this3 = this;

      if (this.loggedIn) {
        var $this = this;

        this.openModal(['GeneralModal', {
          title: 'Spara liftkort',
          content: '<p>Vill du spara detta skipass till ditt konto?</p>',
          buttons: [{
            title: 'Ja',
            class: '',
            click: function click() {
              __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/account/skipasses/add', {
                number: _this3.fullNumber
              }).then(function (r) {
                _this3.params.onSetNumber(_this3.prefix, _this3.number, r.pass);
                _this3.closeModal();
              });
            }
          }, {
            title: 'Nej tack',
            class: '',
            click: function click() {
              _this3.params.onSetNumber(_this3.prefix, _this3.number);
              $this.closeModal();
            }
          }]
        }]);
      } else {
        this.params.onSetNumber(this.prefix, this.number);
        this.closeModal();
      }
    },
    useNumber: function useNumber() {
      var _this4 = this;

      var card = this.skipasses.find(function (s) {
        return s.guid === _this4.cardId;
      });
      if (card) {
        var prefix = card.number.slice(0, 2);
        var number = card.number.slice(3);

        this.params.onSetNumber(prefix, number, card);
      } else {
        console.warn('Could not find selected card ' + this.cardId);
      }
      this.closeModal();
    },
    onLogin: function onLogin() {
      this.fetch();
    },
    localCloseModal: function localCloseModal() {
      var _this5 = this;

      if (this.$refs.scanner && this.$refs.scanner.shutdown) {
        this.$refs.scanner.shutdown();
        setTimeout(function () {
          _this5.closeModal();
        }, 1);
      } else {
        this.closeModal();
      }
    }
  })
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_components_Modal___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['confirmedAccomodations'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'addRentalPeople']), {
    clicked: function clicked(key) {
      this.params.click(key);
      this.closeModal();
    }
  })
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default.a,
    SwitchButton: __WEBPACK_IMPORTED_MODULE_7__components_components_SwitchButton___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox___default.a
  },
  data: function data() {
    return {
      site: null,
      insurance: null,
      markInsurance: false,
      pickupTime: null,
      phone: null,
      errors: {},
      touched: {},
      onlySkipass: false,
      receipt: false,
      productsAvailable: null,
      times: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, only, arrival, priceType, _ref2, data;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.site = parseInt(_this.$store.state.isOnWhichSite, 10);

              if (!_this.site) {
                _this.site = _this.people[0].site;
              }
              _this.pickupTime = _this.people[0].pickupTime;
              if (['branas', 'kungsberget', 'vallasen', 'ulricehamn'].indexOf(_this.SITE_CONFIG.site) === -1) {
                _this.pickupTime = 9;
              }

              _this.phone = _this.people[0].phone;

              _this.receipt = _this.$store.state.cart.receipt;

              if (!_this.phone) {
                _this.phone = '+46';
              }

              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].frontendHelper('skirental/check-for-only-skipasses', _this.$store.state);

            case 9:
              _ref = _context.sent;
              only = _ref.only;

              _this.onlySkipass = only;

              if (!(['vallasen', 'ulricehamn'].indexOf(_this.SITE_CONFIG.site) !== -1)) {
                _context.next = 22;
                break;
              }

              arrival = __WEBPACK_IMPORTED_MODULE_10_moment___default()(_this.people[0].startDate).format('YYYY-MM-DD');
              priceType = _this.people[0].priceType;
              _context.next = 17;
              return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('skiletting/timeslots/' + arrival + '?price-type=' + priceType);

            case 17:
              _ref2 = _context.sent;
              data = _ref2.data;

              _this.times = data.map(function (time) {
                var newTime = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(time));
                newTime.title = time.label;
                newTime.value = time.time;
                newTime.available = time.available;
                return newTime;
              });
              _context.next = 23;
              break;

            case 22:
              _this.times = _this.SITE_CONFIG.rental.pickuptimes.map(function (time) {
                var newTime = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(time));
                newTime.available = 50;
                return newTime;
              });

            case 23:

              _this.checkAvailability();

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    showReceiptPicker: function showReceiptPicker() {
      return this.$store.state.isOnSite;
    },
    showInsurance: function showInsurance() {
      var _this2 = this;

      var count = 0;
      var countOverride = 0;

      this.people.forEach(function (person) {
        count += person.addons.filter(function (a) {
          return !a.buy;
        }).length;
        countOverride += _this2.offerInsurance(person);
      });
      this.people.forEach(function (person) {
        count += person.products.filter(function (a) {
          return !a.buy;
        }).length;
        countOverride += _this2.offerInsurance(person);
      });

      if (!countOverride) {
        return false;
      }

      return count;
    },
    showSaveDetails: function showSaveDetails() {
      var _this3 = this;

      var show = false;

      if (!this.$store.state.user || !this.$store.state.user.token) {
        return false;
      }

      this.people.forEach(function (person) {
        if (_this3.whatChanged(person)) {
          show = true;
        }
      });

      return show;
    },
    people: function people() {
      return this.$store.state.cart.rentals.filter(function (a) {
        return a.guideCompleted;
      });
    },
    firstBookingIsToday: function firstBookingIsToday() {
      var rentals = this.$store.state.cart.rentals.map(function (a) {
        return __WEBPACK_IMPORTED_MODULE_10_moment___default()(a.startDate).toDate();
      }).sort();
      var first = __WEBPACK_IMPORTED_MODULE_10_moment___default()(rentals[0]).format('YYYY-MM-DD');
      return first === __WEBPACK_IMPORTED_MODULE_10_moment___default()().format('YYYY-MM-DD');
    },
    canUseCode: function canUseCode() {
      return false;
    },
    validated: function validated() {
      var _this4 = this;

      if (!this.site) {
        if (!this.people[0].delivery && this.SITE_CONFIG.accomodations.show_site && !this.$store.state.isOnSite) {
          this.$set(this.errors, 'place', true);
          return false;
        }
      }
      this.$set(this.errors, 'place', false);

      if (!this.pickupTime && this.showTimePicker) {
        this.$set(this.errors, 'time', true);
        return false;
      }
      this.$set(this.errors, 'time', false);

      if (!this.phone) {
        this.$set(this.errors, 'phone', true);
        return false;
      }

      var valid = true;

      if (this.phone.toString().match(/^\+[0-9]{9,13}$/) === null) {
        this.$set(this.errors, 'phone', true);
        valid = false;
      } else {
        this.$set(this.errors, 'phone', false);
      }

      if (this.showReceiptPicker) {
        if (this.receipt !== true && this.receipt !== false) {
          this.$set(this.errors, 'receipt', true);
          valid = false;
        } else {
          this.$set(this.errors, 'receipt', false);
        }
      }

      if (this.showInsurance) {
        var $this = this;
        var count = 0;
        this.people.forEach(function (person) {
          if (person.insurance !== true && person.insurance !== false && $this.offerInsurance(person)) {
            $this.$set($this.errors, 'insurance', true);
            count += 1;
            valid = false;
          }
        });

        if (!count) {
          this.$set(this.errors, 'insurance', false);
        }
      }

      if (!this.productsAvailable) {
        return false;
      }

      var saveNoMarks = 0;

      if (!this.$store.state.user || !this.$store.state.user.token) {
        return valid;
      }

      this.people.forEach(function (person) {
        if (_this4.whatChanged(person) && person.saveDetails !== false && person.saveDetails !== true) {
          saveNoMarks += 1;
        }
      });

      if (saveNoMarks) {
        valid = false;
      }

      return valid;
    },
    totalPrice: function totalPrice() {
      var _this5 = this;

      return this.people.reduce(function (a, b) {
        return b.insurance ? a + _this5.insuranceSum(b) : a;
      }, 0);
    },
    showTimePicker: function showTimePicker() {
      if (this.SITE_CONFIG.site === 'branas') {
        return false;
      }

      if (this.people[0].delivery) {
        return false;
      }

      if (this.$store.state.isOnSite && this.firstBookingIsToday) {
        return false;
      }

      return true;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'saveCartLocking', 'updateRentalPersonSkier']), {
    openCodeModal: function openCodeModal() {
      this.touch();
      if (!this.validated) {
        return false;
      }
      this.save();


      return true;
    },
    unmarkInsuranceError: function unmarkInsuranceError() {
      this.markInsurance = false;
    },
    offerInsurance: function offerInsurance(person) {
      if (person.onlySkipass) {
        return false;
      }

      var hasInsuredProducts = false;

      person.products.forEach(function (product) {
        if (product.insurance_enabled) {
          hasInsuredProducts = true;
        }
      });

      person.addons.forEach(function (product) {
        if (product.insurance_enabled) {
          hasInsuredProducts = true;
        }
      });

      if (!hasInsuredProducts) {
        return false;
      }

      return true;
    },
    whatChanged: function whatChanged(person) {
      if (!person.skier) {
        return 'new';
      }

      var changes = [];
      if (person.age && (person.skier.age_category || '') !== (person.age || '')) {
        changes.push('age');
      }
      if (person.lengthCm && (person.skier.measurement_height || '').toString() !== (person.lengthCm || '').toString()) {
        changes.push('measurement_height');
      }
      if (person.weight && (person.skier.measurement_weight || '').toString() !== (person.weight || '').toString()) {
        changes.push('measurement_weight');
      }
      if (person.shoeSize && (person.skier.measurement_shoe_size || '').toString() !== (person.shoeSize || '').toString()) {
        changes.push('measurement_shoe_size');
      }
      if (person.clothsize && (person.skier.measurement_clothsize || '').toString() !== (person.clothsize || '').toString()) {
        changes.push('measurement_clothsize');
      }

      if (changes.length === 0) {
        this.$set(person, 'saveDetails', false);
        return null;
      }

      return changes;
    },
    whatChangedLabel: function whatChangedLabel(whatChanged) {
      if (!whatChanged) {
        return 'Oförändrad';
      }
      if (whatChanged === 'new') {
        return 'Ny åkare';
      }
      var text = whatChanged.map(function (change) {
        if (change === 'age') {
          return 'Ålder';
        }
        if (change === 'measurement_height') {
          return 'Längd';
        }
        if (change === 'measurement_weight') {
          return 'Vikt';
        }
        if (change === 'measurement_shoe_size') {
          return 'Skostrl.';
        }
        if (change === 'measurement_clothsize') {
          return 'Klädstrl.';
        }
        return change;
      }).join(', ');

      return '* ' + text;
    },
    insuranceSum: function insuranceSum(person) {
      if (!this.offerInsurance(person)) {
        return 0;
      }

      var days = person.days;
      var keyWith = 'price_insurance_' + days;
      var keyWithout = 'price_' + days;

      if (person.priceType === 'night') {
        keyWith = keyWith + '_night';
        keyWithout = keyWithout + '_night';
      }

      if (!this.SITE_CONFIG.rental.insurance_per_product) {
        var productWith = 0;
        var productWithout = 0;

        if (person.products.length) {
          productWithout = Math.round(parseFloat(person.products[0][keyWithout]));
          productWith = Math.round(parseFloat(person.products[0][keyWith]));
        } else if (person.addons.length) {
          productWithout = Math.round(parseFloat(person.addons[0][keyWithout]));
          productWith = Math.round(parseFloat(person.addons[0][keyWith]));
        }

        return productWith - productWithout;
      }

      var productsWithout = person.products.reduce(function (a, b) {
        return a + Math.round(parseFloat(b[keyWithout] || 0));
      }, 0);
      var addonsWithout = person.addons.reduce(function (a, b) {
        return a + Math.round(parseFloat(b[keyWithout] || 0));
      }, 0);

      var productsWith = person.products.reduce(function (a, b) {
        return a + Math.round(parseFloat(b[keyWith] || 0));
      }, 0);
      var addonsWith = person.addons.reduce(function (a, b) {
        return a + Math.round(parseFloat(b[keyWith] || 0));
      }, 0);

      var sumWithout = productsWithout + addonsWithout;
      var sumWith = productsWith + addonsWith;

      return sumWith - sumWithout;
    },
    save: function save() {
      this.fixPhone();
      this.$store.state.cart.receipt = this.receipt;
      if (this.params.done) {
        this.params.done({
          pickupTime: this.pickupTime,
          site: this.site,
          phone: this.phone,
          onlySave: true
        });
      }
    },
    addToCart: function addToCart(pay) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, _ref3, before_time, code, post, _ref4, success, skiers;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.fixPhone();
                _this6.$store.state.cart.receipt = _this6.receipt;

                _this6.touch();

                if (_this6.validated) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', false);

              case 5:
                url = '/locks/reserve';

                if (_this6.$store.state.lockingCode) {
                  url = url + '/' + _this6.$store.state.lockingCode;
                }
                _context2.next = 9;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get(url);

              case 9:
                _ref3 = _context2.sent;
                before_time = _ref3.before_time;
                code = _ref3.code;


                _this6.saveCartLocking({
                  code: code,
                  beforeTime: before_time
                });

                if (_this6.params.done) {
                  _this6.params.done({
                    pickupTime: _this6.pickupTime,
                    site: _this6.site,
                    phone: _this6.phone,
                    payDirect: pay
                  });
                }

                if (_this6.$store.state.isOnSite) {
                  _this6.openModal(['OnSitePayment']);
                }

                post = _this6.people.map(function (person, index) {
                  if (!person.saveDetails) {
                    return null;
                  }

                  var whatChanged = _this6.whatChanged(person);

                  if (!whatChanged) {
                    return null;
                  }

                  var data = {
                    index: index
                  };

                  if (person.skier && person.skier.guid) {
                    data.guid = person.skier.guid;
                  }

                  if (whatChanged === 'new') {
                    data.first_name = person.name;
                    data.measurement_height = person.lengthCm;
                    data.measurement_weight = person.weight;
                    data.measurement_shoe_size = person.shoeSize;
                    data.measurement_clothsize = person.clothsize;
                    data.age_category = person.age;
                  } else {
                    if (whatChanged.indexOf('age') !== -1) {
                      data.age_category = person.age;
                    }
                    if (whatChanged.indexOf('measurement_height') !== -1) {
                      data.measurement_height = person.lengthCm;
                    }
                    if (whatChanged.indexOf('measurement_weight') !== -1) {
                      data.measurement_weight = person.weight;
                    }
                    if (whatChanged.indexOf('measurement_shoe_size') !== -1) {
                      data.measurement_shoe_size = person.shoeSize;
                    }
                    if (whatChanged.indexOf('measurement_clothsize') !== -1) {
                      data.measurement_clothsize = person.clothsize;
                    }
                  }

                  return data;
                }).filter(function (a) {
                  return a !== null;
                });

                if (!post.length) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 19;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].post('/account/skiers/batch-update', post);

              case 19:
                _ref4 = _context2.sent;
                success = _ref4.success;
                skiers = _ref4.skiers;


                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(skiers).forEach(function (key) {
                  var skier = skiers[key];
                  _this6.updateRentalPersonSkier({
                    index: parseInt(key, 10),
                    skier: skier
                  });
                });

                return _context2.abrupt('return', success);

              case 24:
                return _context2.abrupt('return', true);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    addToCartAndPay: function addToCartAndPay() {
      this.addToCart(true);
    },
    validCode: function validCode() {
      if (!this.validated) {
        return false;
      }

      this.$store.state.cart.receipt = this.receipt;

      if (this.params.done) {
        this.params.done({
          pickupTime: this.pickupTime,
          site: this.site,
          phone: this.phone,
          noRedirect: true
        });
      }

      return true;
    },
    fixPhone: function fixPhone() {
      this.phone = this.phone.replace(/^0/, '+46').replace(/^\+460/, '+46').replace(/[^+\w]/g, '');
    },
    showError: function showError(key) {
      return this.errors[key] && this.touched[key];
    },
    touch: function touch() {
      this.$set(this.touched, 'place', true);
      this.$set(this.touched, 'time', true);
      this.$set(this.touched, 'phone', true);
      this.$set(this.touched, 'insurance', true);
      this.$set(this.touched, 'receipt', true);
      return this.validated;
    },
    checkAvailability: function checkAvailability() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref5, data, message, $this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this7.SITE_CONFIG.site === 'vallasen' || _this7.SITE_CONFIG.site === 'ulricehamn')) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].frontendHelper('/skirental/availability', {
                  cart: _this7.$store.state.cart
                });

              case 3:
                _ref5 = _context3.sent;
                data = _ref5.data;
                message = _ref5.message;


                _this7.productsAvailable = data;

                $this = _this7;


                if (!data) {
                  _this7.openModal(['GeneralModal', {
                    zIndex: 20,
                    title: 'Storlek',
                    content: message,
                    buttons: [{
                      title: 'Okej',
                      class: 'small',
                      click: function click() {
                        $this.closeAllModals();
                      }
                    }]
                  }]);
                }
                _context3.next = 12;
                break;

              case 11:
                _this7.productsAvailable = true;

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    openPdf: function openPdf() {
      window.open('https://cdn.branasgruppen.se/branas/app/uploads/2019/12/12110225/IPID_Skidbodarna_20190701-tosj.pdf', '_blank');
    }
  })
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var store, _ref, show;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.$store.state);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].frontendHelper('skirental/din-scale?index=' + _this.params.index, store);

            case 3:
              _ref = _context.sent;
              show = _ref.show;


              _this.showDinText = show;

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      showDinText: false
    };
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['closeModal']))
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_AccomodationCartItem__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_parts_Accomodation_AccomodationPeriodConfirm__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_parts_Accomodation_AccomodationPeriodConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_parts_Accomodation_AccomodationPeriodConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_components_LanguageSwitcher__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_components_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_components_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);























/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_components_Modal___default.a,
    CounterButton: __WEBPACK_IMPORTED_MODULE_8__components_components_CounterButton___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_9__components_components_Dropdown___default.a,
    AccomodationPeriodConfirm: __WEBPACK_IMPORTED_MODULE_14__components_parts_Accomodation_AccomodationPeriodConfirm___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_10__components_payments_Login___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_11__components_components_Loading___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_16__components_components_LanguageSwitcher___default.a
  },
  data: function data() {
    return {
      peopleCount: 1,
      accomodation: null,
      unit: {},
      arrival: '',
      departure: '',
      accomodations: [],
      foundNotAllowedDelivery: false,
      loading: false,
      selectedAccomodation: null,
      possibleWithStorage: false,
      paramsType: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.paramsType = _this.params && _this.params.type || 'without-delivery';
              _context.next = 3;
              return _this.reload();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    canClose: function canClose() {
      return !this.$store.state.isOnSite;
    },
    validStartDate: function validStartDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__dates__["a" /* validStartDate */])({
        validStartDates: this.validStartDates
      });
    },
    accomodationsToSelect: function accomodationsToSelect() {
      var val = [];
      this.accomodations.forEach(function (accomodation, index) {
        var arrival = __WEBPACK_IMPORTED_MODULE_17_moment___default()(accomodation.arrival || accomodation.period.date_arrival).format('D[/]M');
        var departure = __WEBPACK_IMPORTED_MODULE_17_moment___default()(accomodation.departure || accomodation.period.date_departure).format('D[/]M');
        val.push({
          value: index,
          title: accomodation.unit ? accomodation.unit.display_name || accomodation.unit.description_title : accomodation.name,
          subtitle: arrival + ' - ' + departure
        });
      });
      return val;
    },
    possibleWithDelivery: function possibleWithDelivery() {
      var tz = __WEBPACK_IMPORTED_MODULE_17_moment___default.a.tz.guess(true);

      var arrival = __WEBPACK_IMPORTED_MODULE_17_moment___default.a.tz(this.arrival, 'Europe/Stockholm');
      var now = __WEBPACK_IMPORTED_MODULE_17_moment___default.a.tz(__WEBPACK_IMPORTED_MODULE_17_moment___default()(), tz);
      var diff = arrival.diff(now, 'hours', true);

      if (this.SITE_CONFIG.site === 'branas') {
        if (diff <= 12) {
          return false;
        }
        return true;
      }

      if (diff < 2 * 24) {
        return false;
      }
      return true;
    },
    addonBooking: function addonBooking() {
      return !!(this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.number);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['loggedIn', 'guidedRentals'])),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'addRentalPeople', 'confirmedAccomodations']), {
    reload: function reload() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var accomodations, confirmed, _ref, success;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('...reloading');
                accomodations = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this2.$store.state.cart.accomodations));
                confirmed = accomodations.filter(function (accomodation) {
                  return accomodation.confirmed;
                });

                if (!confirmed.length) {
                  _context2.next = 12;
                  break;
                }

                _this2.accomodation = confirmed[0];
                _this2.accomodations = confirmed;
                _this2.unit = {
                  pool_lid: _this2.accomodation.poolLid,
                  unit_lid: _this2.accomodation.unitLid,
                  name: _this2.accomodation.name
                };
                _this2.arrival = _this2.accomodation.period.date_arrival;
                _this2.departure = _this2.accomodation.period.date_departure;

                _this2.$nextTick(function () {
                  _this2.peopleCount = __WEBPACK_IMPORTED_MODULE_12__classes_AccomodationCartItem__["a" /* default */].peopleCount(confirmed[0]);
                  if (_this2.$refs.counterButton) {
                    _this2.$refs.counterButton.count = _this2.peopleCount;
                  }
                });
                _context2.next = 15;
                break;

              case 12:
                if (!(_this2.loggedIn && _this2.paramsType === 'with-delivery')) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 15;
                return _this2.getAccomodations();

              case 15:

                if (_this2.guidedRentals.length) {
                  if (!_this2.$store.state.cart.addToOrder || !_this2.$store.state.cart.addToOrder.number) {
                    _this2.closeModal();
                    _this2.$router.push({ name: 'ski rental overview' });
                  }
                }

                if (!_this2.accomodation) {
                  _context2.next = 23;
                  break;
                }

                _this2.paramsType = 'with-delivery';

                _context2.next = 20;
                return __WEBPACK_IMPORTED_MODULE_13__classes_API__["a" /* default */].get('equipment-storage-available/' + _this2.accomodation.poolLid + '/' + _this2.accomodation.unitLid);

              case 20:
                _ref = _context2.sent;
                success = _ref.success;

                _this2.possibleWithStorage = success;

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getAccomodations: function getAccomodations() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url, _ref2, data, hasNotAllowed;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;

                if (!(_this3.SITE_CONFIG.site === 'branas' || _this3.SITE_CONFIG.site === 'kungsberget')) {
                  _context3.next = 11;
                  break;
                }

                url = 'orders/accomodations';

                if (_this3.$store.state.cart.addToOrder && _this3.$store.state.cart.addToOrder.numeric) {
                  url = url + '/' + _this3.$store.state.cart.addToOrder.numeric;
                }

                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_13__classes_API__["a" /* default */].get(url);

              case 6:
                _ref2 = _context3.sent;
                data = _ref2.data;
                hasNotAllowed = _ref2.hasNotAllowed;

                _this3.accomodations = data;
                _this3.foundNotAllowedDelivery = hasNotAllowed;

              case 11:
                if (_this3.accomodations.length) {
                  _this3.selectAccomodation(0);
                }
                _this3.loading = false;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    selectAccomodation: function selectAccomodation(index) {
      this.accomodation = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.accomodations[index]);
      this.accomodation.name = this.accomodation.unit ? this.accomodation.unit.display_name || this.accomodation.unit.description_title : this.accomodation.name;
      this.unit = {
        pool_lid: this.accomodation.unit ? this.accomodation.unit.pool_lid : this.accomodation.poolLid,
        unit_lid: this.accomodation.unit ? this.accomodation.unit.unit_lid : this.accomodation.unitLid,
        name: this.accomodation.unit ? this.accomodation.unit.display_name : this.accomodation.display_name
      };

      this.arrival = this.accomodation.period ? this.accomodation.period.date_arrival : this.accomodation.arrival;
      this.departure = this.accomodation.period ? this.accomodation.period.date_departure : this.accomodation.departure;
    },
    changedAccomodation: function changedAccomodation(v) {
      this.selectAccomodation(v.value);
    },
    onLogin: function onLogin() {
      this.paramsType = 'with-delivery';
      this.reload();
    },
    localCloseModal: function localCloseModal() {
      this.$router.push({ name: 'shopping cart' });
    },
    validate: function validate() {
      var errors = 0;
      errors += this.peopleCount ? 0 : 1;
      errors += this.paramsType === 'with-delivery' && !this.accomodation ? 1 : 0;
      errors += this.paramsType === 'with-delivery' && !this.possibleWithDelivery ? 1 : 0;
      return !errors;
    },
    changePeople: function changePeople(payload) {
      this.peopleCount = payload;
    },
    startBooking: function startBooking() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var date, days, orderNumber, orderNumeric, rowId, name, arrival, departure, group, pool, unit, apiOrder, lines, orderDetails, fallbackEnd;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                date = null;
                days = null;


                if (_this4.$store.state.cart.addToOrder && _this4.$store.state.cart.addToOrder.dateStart) {
                  date = _this4.$store.state.cart.addToOrder.dateStart;
                  days = Math.round(__WEBPACK_IMPORTED_MODULE_17_moment___default()(_this4.$store.state.cart.addToOrder.dateEnd).diff(_this4.$store.state.cart.addToOrder.dateStart) / 60 / 60 / 24 / 1000) + 1;
                } else if (_this4.paramsType === 'with-delivery') {
                  if (_this4.accomodation.arrival) {
                    date = _this4.accomodation.arrival;
                    days = Math.round(__WEBPACK_IMPORTED_MODULE_17_moment___default()(_this4.accomodation.departure).diff(_this4.accomodation.arrival) / 60 / 60 / 24 / 1000) + 1;
                  } else {
                    date = _this4.accomodation.period.date_arrival;
                    days = Math.round(__WEBPACK_IMPORTED_MODULE_17_moment___default()(_this4.accomodation.period.date_departure).diff(_this4.accomodation.period.date_arrival) / 60 / 60 / 24 / 1000) + 1;
                  }
                }

                _this4.addRentalPeople({
                  peopleCount: _this4.peopleCount,
                  pickedStartDate: date,
                  numberOfDays: days,
                  delivery: _this4.paramsType === 'with-delivery',
                  deliveryTo: _this4.unit,
                  parent_has_delivery_fee: !!(_this4.accomodation && _this4.accomodation.parent_has_delivery_fee),
                  append: false
                });

                if (date) {
                  _this4.$store.state.cart.rentalDateRestriction = {
                    date: date,
                    days: days
                  };
                } else {
                  _this4.$store.state.cart.rentalDateRestriction = {};
                }

                if (!(_this4.paramsType === 'with-delivery' && _this4.accomodation)) {
                  _context4.next = 35;
                  break;
                }

                orderNumber = _this4.$store.state.cart.addToOrder && _this4.$store.state.cart.addToOrder.number || _this4.accomodation.order && _this4.accomodation.order.number || _this4.accomodation.resvid;
                orderNumeric = _this4.$store.state.cart.addToOrder && _this4.$store.state.cart.addToOrder.numeric || _this4.accomodation.order && _this4.accomodation.order.ext_r360_id || _this4.accomodation.headlid;

                if (!(orderNumber && orderNumeric)) {
                  _context4.next = 35;
                  break;
                }

                rowId = _this4.accomodation.detlid || _this4.accomodation.order && _this4.accomodation.order.row;
                name = _this4.accomodation.name || _this4.accomodation.display_name;
                arrival = _this4.accomodation.arrival || _this4.accomodation.period && _this4.accomodation.period.date_arrival;
                departure = _this4.accomodation.departure || _this4.accomodation.period && _this4.accomodation.period.date_departure;
                group = _this4.accomodation.detgroup || _this4.accomodation.group;
                pool = _this4.accomodation.poollid || _this4.accomodation.poolLid;
                unit = _this4.accomodation.unitlid || _this4.accomodation.unitLid;


                _this4.loading = true;
                _context4.prev = 17;
                _context4.next = 20;
                return __WEBPACK_IMPORTED_MODULE_13__classes_API__["a" /* default */].get('/orders/get/' + orderNumeric);

              case 20:
                apiOrder = _context4.sent;
                lines = [];

                if (apiOrder && apiOrder.data && apiOrder.data.details && apiOrder.data.details.rows) {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(apiOrder.data.details.rows).forEach(function (rowGroup) {
                    rowGroup.forEach(function (row) {
                      lines.push({
                        poolId: row.pool,
                        status: row.cancelled ? 'C' : 'B'
                      });
                    });
                  });
                }

                orderDetails = apiOrder && apiOrder.data && apiOrder.data.details;
                fallbackEnd = __WEBPACK_IMPORTED_MODULE_17_moment___default()(date).add(days - 1, 'days').format('Y-m-d');


                _this4.$store.state.cart.addToOrder = {
                  number: orderNumber,
                  numeric: orderNumeric,
                  accomodationRow: rowId,
                  accomodationName: name,
                  accomodationDateArrival: arrival,
                  accomodationDateDeparture: departure,
                  accomodationGroup: group,
                  helperPool: pool,
                  helperUnit: unit,
                  dateStart: orderDetails ? orderDetails.dateStart : date,
                  dateEnd: orderDetails ? orderDetails.dateEnd : fallbackEnd,
                  hasAccommodation: true,
                  lines: lines
                };
                _context4.next = 32;
                break;

              case 28:
                _context4.prev = 28;
                _context4.t0 = _context4['catch'](17);

                console.error('Failed fetching order details to construct addToOrder', _context4.t0);

                _this4.$store.state.cart.addToOrder = {
                  number: orderNumber,
                  numeric: orderNumeric,
                  accomodationRow: rowId,
                  accomodationName: name,
                  accomodationDateArrival: arrival,
                  accomodationDateDeparture: departure,
                  accomodationGroup: group,
                  helperPool: pool,
                  helperUnit: unit
                };

              case 32:
                _context4.prev = 32;

                _this4.loading = false;
                return _context4.finish(32);

              case 35:

                _this4.closeAllModals();

                _this4.$router.push({ path: '/skidhyra/0' });

              case 37:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[17, 28, 32, 35]]);
      }))();
    },
    goOn: function goOn() {
      this.closeModal();
      this.$router.push({ path: '/skidhyra/oversikt' });
    },
    openWithoutDelivery: function openWithoutDelivery() {
      this.paramsType = 'without-delivery';
      this.accomodations = [];
      this.reload();
    },
    openWithDelivery: function openWithDelivery() {
      if (this.addonBooking) {
        this.paramsType = 'with-delivery';
        this.reload();
      } else {
        this.closeAllModals();
        this.$router.push({ name: 'my pages' });
      }
    }
  })
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_components_Modal___default.a,
    SwitchButton: __WEBPACK_IMPORTED_MODULE_2__components_components_SwitchButton___default.a
  },
  data: function data() {
    return {
      wishes: {}
    };
  },
  beforeMount: function beforeMount() {
    for (var i in this.params.wishes) {
      this.wishes[i] = this.params.wishes[i];
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['confirmedAccomodations']), {
    hasSnowboard: function hasSnowboard() {
      var codes = [];
      this.params.person.products.forEach(function (product) {
        product.categories.forEach(function (category) {
          codes.push(category.slug);
        });
      });

      return codes.indexOf('snowboard') !== -1;
    },
    hasSkis: function hasSkis() {
      var codes = [];
      this.params.person.products.forEach(function (product) {
        product.categories.forEach(function (category) {
          codes.push(category.slug);
        });
      });

      if (codes.indexOf('alpine') !== -1) {
        return true;
      }

      if (codes.indexOf('telemark') !== -1) {
        return true;
      }

      return codes.indexOf('snowblades') !== -1;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'addRentalPeople']), {
    toggle: function toggle(payload) {
      this.wishes[payload.key] = payload.value;
      this.wishes.hasWishes = false;
      for (var i in this.wishes) {
        if (this.wishes[i]) {
          this.wishes.hasWishes = true;
        }
      }
    },
    clicked: function clicked() {
      this.params.click(this.wishes);
      this.closeModal();
    }
  })
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_TextInput__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_restrictions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_schoolWishes__ = __webpack_require__(118);





















/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['params'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_components_Modal___default.a,
    DatepickerButton: __WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_8__components_components_Dropdown___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_9__components_components_TextInput___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_10__components_components_Checkbox___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_11__components_components_Loading___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_14__mixins_restrictions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_schoolWishes__["a" /* default */]],
  data: function data() {
    return {
      dates: {},
      school: {
        subtitle: 'Laddar...'
      },
      qty: 1,
      changes: 0,
      available: true,
      total_price: null,
      lockingCode: '',
      reason: null,
      bookingWarning: '',
      theBooking: {
        theDate: null,
        people: [],
        guardian: '',
        phone: '',
        time: ''
      },
      loading: true,
      loadingAvailability: false,
      alreadyBookedShowedWarning: false,
      forceAlreadyBookedMessage: false,
      currentIndex: -1
    };
  },
  beforeMount: function beforeMount() {
    this.fetch();
    this.theBooking = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.theBooking, this.$store.state.skiSchoolBooking);

    if (!this.theBooking.theDate && this.$store.state.skiSchoolFilter.date) {
      this.theBooking.theDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()(this.$store.state.skiSchoolFilter.date).toDate();
    }

    if (!this.theBooking.phone) {
      this.theBooking.phone = '+46';
    }

    if (!this.theBooking.people || !this.theBooking.people.length) {
      this.theBooking.people = [];
    }

    this.qty = this.theBooking.people.length;

    if (window.SKISCHOOL_alreadyBookedShowedWarning) {
      this.alreadyBookedShowedWarning = true;
    }
  },

  watch: {
    qty: function qty(newQty) {
      var currentQty = this.theBooking.people.length;
      var diff = newQty - currentQty;

      if (diff > 0) {
        while (diff > 0) {
          this.addPerson();
          diff -= 1;
        }
      } else if (diff < 0) {
        while (diff < 0) {
          this.removePerson();
          diff += 1;
        }
      }
      this.checkAvailability();

      if (this.school.is_private && this.alreadyBookedShowedWarning === false && newQty > 1) {
        this.forceAlreadyBookedMessage = true;
      } else {
        this.forceAlreadyBookedMessage = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      if (_this.alreadyBooked && _this.alreadyBookedShowedWarning === false) {
        _this.showAlreadyBookedModal();
      }

      _this.checkAvailability(function () {
        if (_this.$route.query.qty) {
          _this.qty = parseInt(_this.$route.query.qty, 10);
        }
      });
    }, 500);

    this.school.subtitle = this.$i18n.t('general.loading');
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['openModal', 'closeModal', 'addSkiSchoolToCart', 'addActivitityToCart', 'saveCartLocking', 'consolidateSkiSchoolInCart']), {
    showAlreadyBookedModal: function showAlreadyBookedModal() {
      var $this = this;
      window.SKISCHOOL_alreadyBookedShowedWarning = true;

      this.openModal(['GeneralModal', {
        title: 'Flera elever',
        content: this.alreadyBookedMessage,
        buttons: [{
          title: 'Okej',
          class: 'small',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    moment: function moment(d) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(d);
    },
    checkAvailability: function checkAvailability(onDone) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var success, reason, warning, price, peopleCount, ages, extraAges, _ref;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loadingAvailability = true;

                console.log('Checking availability...');
                success = true;
                reason = '';
                warning = '';
                price = null;
                peopleCount = _this2.theBooking.people.length;


                if (!peopleCount) {
                  peopleCount = _this2.school.min_participants;
                }

                if (!_this2.theBooking.time) {
                  _context.next = 18;
                  break;
                }

                ages = _this2.theBooking.people.map(function () {
                  return 30;
                }).join(',');
                extraAges = _this2.alreadyBookedAges.map(function () {
                  return 30;
                }).join(',');
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get('/skischool/check-availability/' + _this2.theBooking.time + '/' + peopleCount + '?ages=' + ages + '&extra-ages=' + extraAges);

              case 13:
                _ref = _context.sent;
                success = _ref.success;
                reason = _ref.reason;
                warning = _ref.warning;
                price = _ref.price;

              case 18:

                _this2.available = success;
                _this2.reason = reason;
                _this2.bookingWarning = warning;

                if (price) {
                  _this2.total_price = price;
                } else {
                  _this2.total_price = null;
                }

                if (typeof onDone === 'function') {
                  onDone();
                }

                _this2.loadingAvailability = false;

                return _context.abrupt('return', _this2.available);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    reserve: function reserve() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var success, code, before_time, peopleCount, _ref2, _ref3;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('Reserving...');
                success = true;
                code = '';
                before_time = '';
                peopleCount = _this3.theBooking.people.length;


                if (!peopleCount) {
                  peopleCount = _this3.school.min_participants;
                }

                if (!_this3.theBooking.time) {
                  _context2.next = 22;
                  break;
                }

                if (!_this3.$store.state.lockingCode) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 10;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get('/skischool/reserve/' + _this3.theBooking.time + '/' + peopleCount + '/' + _this3.$store.state.lockingCode);

              case 10:
                _ref2 = _context2.sent;
                success = _ref2.success;
                code = _ref2.code;
                before_time = _ref2.before_time;
                _context2.next = 22;
                break;

              case 16:
                _context2.next = 18;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get('/skischool/reserve/' + _this3.theBooking.time + '/' + peopleCount);

              case 18:
                _ref3 = _context2.sent;
                success = _ref3.success;
                code = _ref3.code;
                before_time = _ref3.before_time;

              case 22:

                if (success) {
                  _this3.saveCartLocking({
                    code: code,
                    beforeTime: before_time });
                } else {
                  _this3.reason = 'Kunde inte reservera skidskolan.';
                }

                return _context2.abrupt('return', success);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    addToCart: function addToCart() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var reserve, ref;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.reserve();

              case 2:
                reserve = _context3.sent;

                if (reserve) {
                  _context3.next = 6;
                  break;
                }

                _this4.available = false;
                return _context3.abrupt('return');

              case 6:

                if (_this4.params.activity) {
                  _this4.addActivitityToCart({
                    pool_lid: _this4.school.pool_lid,
                    people: _this4.theBooking.people,

                    date: __WEBPACK_IMPORTED_MODULE_13_moment___default()(_this4.theBooking.theDate).format('YYYY-MM-DD'),
                    days: _this4.school.actual_days,
                    site: _this4.school.site,

                    activity_lid: _this4.theBooking.time,
                    time: _this4.times.find(function (time) {
                      return time.value === _this4.theBooking.time;
                    }).title,

                    quantity: _this4.theBooking.people.length,

                    name: _this4.school.subtitle,

                    price: _this4.price,

                    guardian: _this4.theBooking.guardian,
                    phone: _this4.theBooking.phone
                  });

                  window.SKISCHOOL_alreadyBookedShowedWarning = false;

                  _this4.closeModal();
                  if (_this4.$store.state.isOnSite) {
                    _this4.openModal(['OnSitePayment']);
                  } else {
                    _this4.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref: 'activity' } });
                  }
                } else {
                  _this4.addSkiSchoolToCart({
                    pool_lid: _this4.school.pool_lid,
                    people: _this4.theBooking.people,

                    date: __WEBPACK_IMPORTED_MODULE_13_moment___default()(_this4.theBooking.theDate).format('YYYY-MM-DD'),
                    days: _this4.school.actual_days,
                    site: _this4.school.site,

                    activity_lid: _this4.theBooking.time,
                    time: _this4.times.find(function (time) {
                      return time.value === _this4.theBooking.time;
                    }).title,

                    quantity: _this4.theBooking.people.length,

                    name: _this4.school.subtitle,

                    price: _this4.price,

                    guardian: _this4.theBooking.guardian,
                    phone: _this4.theBooking.phone
                  });

                  _this4.consolidateSkiSchoolInCart({
                    activity_lid: _this4.theBooking.time,
                    price: _this4.price
                  });

                  window.SKISCHOOL_alreadyBookedShowedWarning = false;

                  _this4.closeModal();
                  if (_this4.$store.state.isOnSite) {
                    _this4.openModal(['OnSitePayment']);
                  } else {
                    ref = _this4.$route.name === 'ski school overview' ? 'skischool' : 'bikeschool';

                    _this4.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref: ref } });
                  }
                }

                window.trackAddToCart({
                  title: _this4.school.subtitle,
                  lines: [{
                    id: _this4.school.pool_lid,
                    title: _this4.school.subtitle,
                    category: 'skischool',
                    quantity: _this4.theBooking.people.length,
                    price: _this4.price
                  }]
                });

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    addPerson: function addPerson() {
      this.theBooking.people.push({ name: '', age: '', wishes: { hasWishes: false } });
    },
    removePerson: function removePerson() {
      this.theBooking.people.splice(this.theBooking.people.length - 1, 1);
    },
    fetch: function fetch() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref4, data, meta;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get('/skischool/detail?pool=' + _this5.params.pool + '&id=' + window.CURRENT_ACTIVITY_ID + '&group=' + _this5.params.presenterGroup);

              case 2:
                _ref4 = _context4.sent;
                data = _ref4.data;
                meta = _ref4.meta;

                _this5.dates = data;
                _this5.school = meta;

                _this5.availableWishes = _this5.school.wishes || [];

                _this5.$nextTick(function () {
                  if (!_this5.dates || !_this5.times.length) {
                    _this5.theBooking.time = null;
                  } else {
                    _this5.theBooking.time = _this5.times[0].value;
                  }

                  _this5.loading = false;
                });

                window.trackViewItem({
                  title: _this5.school.subtitle,
                  lines: [{
                    id: _this5.school.pool_lid,
                    title: _this5.school.subtitle,
                    category: 'skischool',
                    quantity: 1,
                    price: _this5.price
                  }]
                });

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    openDateModal: function openDateModal() {
      var _this6 = this;

      this.$store.state.skiSchoolBooking = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.theBooking);
      var $this = this;
      this.openModal(['DatepickerRangeModal', {
        validDates: this.getDatesWithAccommodationRestrictions(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.dates)),
        pickedStartDate: this.theBooking.theDate,
        pickedEndDate: null,
        onClose: function onClose(a) {
          if (a) {
            $this.$store.state.skiSchoolBooking.theDate = a;
            $this.theBooking.theDate = a;
            window.CURRENT_ACTIVITY_ID = $this.dates[__WEBPACK_IMPORTED_MODULE_13_moment___default()(a).format('YYYY-MM-DD')][0][5];
          } else {
            $this.$store.state.skiSchoolBooking.theDate = null;
            $this.theBooking.theDate = null;
            window.CURRENT_ACTIVITY_ID = null;
          }
          setTimeout(function () {
            $this.checkAvailability();
          }, 1);
        },
        startDateOnly: true,
        info: this.$i18n.t('skischool.pick-startdate-instruction'),
        open: this.params.activity ? this.SITE_CONFIG.modules_open.activities.open : this.SITE_CONFIG.modules_open.school.open,
        closed_message: this.params.activity ? this.SITE_CONFIG.modules_open.activities.closed_message : this.SITE_CONFIG.modules_open.school.closed_message,
        extraInfo: function extraInfo() {
          var accommodationDateRange = _this6.getAccommodationDateRange();
          if (accommodationDateRange !== false) {
            return ['Endast tillg\xE4ngliga datum inom ditt bokningsintervall (' + accommodationDateRange.start.format('D MMMM') + ' - ' + accommodationDateRange.end.format('D MMMM') + ') visas.'];
          }

          return [];
        }
      }]);
    },
    selectDates: function selectDates(a) {
      this.theBooking.theDate = a;
    },
    dateClear: function dateClear() {
      this.theBooking.theDate = null;
    },
    closeLocalModal: function closeLocalModal() {
      if (this.params.activity) {
        this.$router.go(-1);
      } else {
        this.closeModal();
        this.$store.state.skiSchoolBooking = {};
      }
      window.SKISCHOOL_alreadyBookedShowedWarning = false;
    },
    validated: function validated() {
      var _this7 = this;

      var valid = true;

      if (!this.theBooking.people.length) {
        return false;
      }
      if (!this.theBooking.theDate) {
        return false;
      }
      if (!this.theBooking.time) {
        return false;
      }
      if (!this.theBooking.guardian && this.showGuardian) {
        if (this.SITE_CONFIG.site === 'branas') {
          return false;
        }
        if (this.SITE_CONFIG.site === 'kungsberget') {
          return false;
        }
      }
      if (this.theBooking.phone.toString().match(/^\+[0-9]{9,13}$/) === null) {
        return false;
      }
      if (!this.$route.query.qty) {
        this.theBooking.people.forEach(function (person) {
          if (!person.name) {
            valid = false;
          }
          var age = parseInt(person.age, 10);
          if (age >= _this7.school.minage && age <= _this7.school.maxage) {
            console.log('...');
          } else {
            valid = false;
          }
        });
      }

      if (!this.available) {
        valid = false;
      }

      if (this.showComments) {
        this.theBooking.people.forEach(function (person) {
          if (!_this7.getWishesAsList(person.wishes).length) {
            valid = false;
          }
        });
      }

      return valid;
    },
    fixPhone: function fixPhone() {
      this.theBooking.phone = this.theBooking.phone.replace(/^0/, '+46').replace(/^\+460/, '+46').replace(/[^+\w]/g, '');
    },
    pickWishes: function pickWishes(payload) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        _this8.$set(_this8.theBooking.people[_this8.currentIndex].wishes, key, payload[key]);
      });
      this.theBooking.people[this.currentIndex].wishesAsText = this.getWishesAsListForSave(this.theBooking.people[this.currentIndex].wishes);
    },
    openWishes: function openWishes(index) {
      this.$store.state.skiSchoolBooking = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.theBooking);
      this.currentIndex = index;
      this.openModal(['SkiSchoolWishes', {
        click: this.pickWishes,
        person: this.theBooking.people[this.currentIndex],
        wishes: this.theBooking.people[this.currentIndex].wishes,
        poolId: this.school.pool_lid,
        availableWishes: this.availableWishes
      }]);
    }
  }),
  computed: {
    times: function times() {
      var dt = __WEBPACK_IMPORTED_MODULE_13_moment___default()(this.theBooking.theDate).format('YYYY-MM-DD');
      var dates = this.dates[dt];

      if (!dates || !dates.length) {
        return [];
      }

      dates = dates.map(function (time) {
        if (!time) {
          return {};
        }
        return {
          value: time[1],
          price: time[2],
          title: time[0].substr(0, 5),
          min: time[4] || 1,
          max: time[3] || 1
        };
      });

      return dates;
    },
    groupParticipantsRequirementText: function groupParticipantsRequirementText() {
      return this.$t('skischool.group-participants-requirement-text');
    },
    bookingNumber: function bookingNumber() {
      return '054-13 26 00';
    },
    lowParticipantCountVariationText: function lowParticipantCountVariationText() {
      return this.$t('skischool.low-participant-count-variation-text');
    },
    showGuardian: function showGuardian() {
      var underAged = this.theBooking.people.filter(function (person) {
        return person.age < 18 && person.age;
      });

      if (this.params.activity) {
        return true;
      }

      return underAged.length;
    },
    price: function price() {
      var _this9 = this;

      if (this.total_price) {
        return this.total_price / (this.theBooking.people.length || 1);
      }

      var theTime = this.times.find(function (time) {
        return time.value === _this9.theBooking.time;
      });

      if (theTime) {
        return Math.round(parseFloat(theTime.price));
      }

      return this.school.price;
    },
    min: function min() {
      var _this10 = this;

      var theTime = this.times.find(function (time) {
        return time.value === _this10.theBooking.time;
      });

      if (theTime) {
        return theTime.min;
      }

      return 0;
    },
    max: function max() {
      var _this11 = this;

      var theTime = this.times.find(function (time) {
        return time.value === _this11.theBooking.time;
      });

      if (theTime) {
        return theTime.max;
      }

      return 0;
    },
    options: function options() {
      var values = [{ value: 0, title: this.$t('general.pick') }];

      var min = this.min;
      var max = this.max;

      if (min) {
        var i = min;
        while (i <= max) {
          values.push({ value: i, title: i + ' ' + this.$t('general.pieces-short') });
          i += 1;
        }
      }

      return values;
    },
    ages: function ages() {
      var i = this.school.minage;
      var max = this.school.maxage;
      var array = [];

      while (i <= max) {
        array.push({
          value: i,
          title: i + ' ' + this.$t('general.years')
        });
        i += 1;
      }

      return array;
    },
    openCodeModal: function openCodeModal() {
      if (!this.validated()) {
        return false;
      }
      return true;
    },
    showMinParticipantsReq: function showMinParticipantsReq() {
      return this.school.is_group && this.school.maxage >= 12;
    },
    lowParticipantCountVariations: function lowParticipantCountVariations() {
      return this.school.is_group && this.school.maxage <= 10;
    },

    alreadyBooked: {
      cache: false,
      get: function get() {
        var _this12 = this;

        var schools = this.$store.state.cart.skischools;

        console.log('check forcing', this.forceAlreadyBookedMessage);

        if (this.forceAlreadyBookedMessage) {
          return true;
        }

        if (!schools) {
          return '';
        }

        if (!schools.length) {
          return '';
        }

        var filtered = schools.filter(function (school) {
          return school.activity_lid === _this12.school.activity_lid;
        });

        if (!filtered.length) {
          return '';
        }

        return true;
      }
    },
    alreadyBookedAges: {
      cache: false,
      get: function get() {
        var _this13 = this;

        var schools = this.$store.state.cart.skischools;

        if (!schools) {
          return [];
        }

        if (!schools.length) {
          return [];
        }

        var filtered = schools.filter(function (school) {
          return school.activity_lid === _this13.school.activity_lid;
        });

        if (!filtered.length) {
          return [];
        }

        return filtered.map(function (row) {
          return row.people.map(function (p) {
            return p.age ? p.age : 30;
          }).join(',');
        });
      }
    },
    alreadyBookedMessage: function alreadyBookedMessage() {
      return 'Notera att om du bokar in flera elever i samma privatlektion och samma tidpunkt så kommer dessa troligtvis att bokas i samma grupp. Ring oss på tel 054-132600 om du önskar separata privatlektioner.';
    },
    restrictionDateInfo: function restrictionDateInfo() {
      if (!this.theBooking.theDate) {
        return '';
      }

      var startDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()(this.theBooking.theDate);
      var endDate = __WEBPACK_IMPORTED_MODULE_13_moment___default()(this.theBooking.theDate).add(this.school.days - 1, 'days');

      var isValid = this.areDatesWithinAccommodationRange(startDate, endDate);
      var range = this.getAccommodationDateRange();

      if (isValid === -1) {
        return 'Du verkar ha valt skidskoledatum som startar f\xF6re din ankomst (' + range.start.format('D MMMM') + '). Innan du g\xE5r vidare, v\xE4nligen kontrollera att du har valt korrekt datum.';
      }

      if (isValid === -2) {
        return 'Du verkar ha valt skidskoledatum som startar efter din avresa (' + range.end.format('D MMMM') + '). Innan du g\xE5r vidare, v\xE4nligen kontrollera att du har valt korrekt datum.';
      }

      if (isValid === -3) {
        return 'Du verkar ha valt skidskoledatum som slutar efter din avresa (' + range.end.format('D MMMM') + '). Innan du g\xE5r vidare, v\xE4nligen kontrollera att du har valt korrekt datum.';
      }

      return '';
    },
    showComments: function showComments() {
      if (this.getWishes().length > 0) {
        return true;
      }

      return false;
    }
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Collapsable__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Collapsable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Collapsable__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Collapsable: __WEBPACK_IMPORTED_MODULE_3__components_components_Collapsable___default.a
  },
  data: function data() {
    return {
      expanded: [],
      faqs: [{
        question: 'Vilka tider har backarna öppet?',
        answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
      }, {
        question: 'Vilka backar är det som har kvällsåkning',
        answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    toggle: function toggle(index) {
      if (this.expanded.includes(index)) {
        return this.expanded.pop(index);
      }
      return this.expanded.push(index);
    },
    isActive: function isActive(index) {
      return this.expanded.includes(index);
    }
  })
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  mounted: function mounted() {
    for (var i in this.infos) {
      this.infos[i].title = this.$i18n.t('skischool.levels.' + this.infos[i].level);
    }
  },
  data: function data() {
    return {
      expanded: [],
      infos: [{
        color: '#559761',
        title: '',
        description: '',
        text: '',
        level: 'green'
      }, {
        color: 'rgba(0, 85, 128, 0.92)',
        title: '',
        description: '',
        text: '',
        level: 'blue'
      }, {
        color: '#ae1116',
        title: '',
        description: '',
        text: '',
        level: 'red'
      }, {
        color: '#262626',
        title: '',
        description: '',
        text: '',
        level: 'black'
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    toggle: function toggle(index) {
      if (this.expanded.includes(index)) {
        return this.expanded.pop(index);
      }
      return this.expanded.push(index);
    },
    isActive: function isActive(index) {
      return this.expanded.includes(index);
    }
  })
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {
      maxTop: 165,
      maxRight: 256,
      zoom: 2
    };
  },
  mounted: function mounted() {},

  computed: {
    isSummer: function isSummer() {
      return this.$route.name === 'bike school overview';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal'])),
  filters: {}
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolFilter__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolFilter__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['params'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    SkiSchoolFilter: __WEBPACK_IMPORTED_MODULE_3__components_parts_SkiSchool_SkiSchoolFilter___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    if (this.params.type === 'snowboard' || this.params.type === 'private') {
      var skiSchoolFilter = {
        date: null
      };

      for (var i in this.SITE_CONFIG.skischool.ages) {
        skiSchoolFilter[this.SITE_CONFIG.skischool.ages[i][1]] = false;
      }
      for (var i in this.SITE_CONFIG.skischool.levels) {
        skiSchoolFilter[i] = false;
      }

      this.$store.commit('setSkischoolFilter', skiSchoolFilter);


      this.startBooking();
    }
  },

  computed: {
    validated: function validated() {
      var valid = false;

      for (var i in this.$store.state.skiSchoolFilter) {
        if (this.$store.state.skiSchoolFilter[i]) {
          valid = true;
        }
      }

      return valid;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal']), {
    startBooking: function startBooking() {
      this.closeAllModals();
      this.$router.push({ path: '/skidskola/oversikt?type=' + this.params.type });
    }
  })
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_schoolWishes__ = __webpack_require__(118);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_3__components_components_Checkbox___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_schoolWishes__["a" /* default */]],
  data: function data() {
    return {
      wishes: {}
    };
  },
  beforeMount: function beforeMount() {
    for (var i in this.params.wishes) {
      this.$set(this.wishes, i, this.params.wishes[i]);
    }

    this.availableWishes = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.params.availableWishes));
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeModal']), {
    clicked: function clicked() {
      this.params.click(this.wishes);
      this.closeModal();
    }
  })
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']))
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_components_Modal___default.a
  },
  data: function data() {
    return {
      prices: [],
      asterisks: [],
      titles: {},
      activeTab: 'weekday'
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.reload();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['closeModal']), {
    switchTab: function switchTab(tab) {
      this.activeTab = tab;
      this.reload();
    },
    reload: function reload() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, data, titles, asterisks;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('skipass/list?date=' + _this2.fakeDate);

              case 2:
                _ref = _context2.sent;
                data = _ref.data;
                titles = _ref.titles;
                asterisks = _ref.asterisks;

                _this2.titles = titles;
                _this2.prices = data;
                _this2.asterisks = asterisks;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  computed: {
    showTabs: function showTabs() {
      return this.SITE_CONFIG.skipass.has_weekend_prices || this.SITE_CONFIG.skipass.has_premiere_prices;
    },
    fakeDate: function fakeDate() {
      if (this.activeTab === 'weekday') {
        return this.SITE_CONFIG.skipass.fake_weekday_date;
      } else if (this.activeTab === 'weekend') {
        return this.SITE_CONFIG.skipass.fake_weekend_date;
      } else if (this.activeTab === 'premiere') {
        return this.SITE_CONFIG.skipass.fake_premiere_date;
      }

      return '';
    }
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    Slideshow: __WEBPACK_IMPORTED_MODULE_3__components_components_Slideshow___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    localClose: function localClose() {
      this.closeModal();
    }
  })
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    localCloseModal: function localCloseModal() {
      this.params.cancel();
      this.closeModal();
    },
    cancel: function cancel() {
      this.params.cancel();
      this.closeModal();
    },
    click: function click() {
      this.params.click();
      this.closeModal();
    }
  })
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_components_Modal___default.a,
    CompletedBookings: __WEBPACK_IMPORTED_MODULE_3__components_parts_CompletedBookings___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'closeAllModals', 'openModal', 'pickAccomodation']), {
    goTo: function goTo(path) {
      this.closeModal();
      this.$router.push({ path: path });
    },
    goOn: function goOn() {
      if (this.params.continue) {
        this.params.continue();
      }
    },
    cancel: function cancel() {
      if (this.params.cancel) {
        this.params.cancel();
      }
    },
    timeLeft: function timeLeft() {
      if (this.params.seconds && this.params.seconds()) {
        var seconds = this.params.seconds();

        var m = 0;
        var s = 0;

        if (seconds >= 60) {
          m = Math.floor(seconds / 60);
          s = seconds - m * 60;
        } else {
          m = 0;
          s = seconds;
        }

        if (m < 10) {
          if (m < 0) {
            m = 0;
          } else {
            m = '0' + m;
          }
        }
        if (s < 0) {
          s = 0;
        }
        if (s < 10) {
          s = '0' + s;
        }

        return m + ':' + s;
      }
      return 'Avbruten';
    }
  })
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_OutlineButton__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_accomodationIndex__ = __webpack_require__(51);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    unit: {},
    arrival: {},
    departure: {},
    small: {
      default: false
    },
    checkAvailability: {
      default: true
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_accomodationIndex__["a" /* default */]],
  components: {
    OutlineButton: __WEBPACK_IMPORTED_MODULE_5__components_components_OutlineButton___default.a
  },
  data: function data() {
    return {
      cartAccomodationObject: {},
      adults: 0,
      youths: 0,
      children: 0,
      cartObject: {},
      period: null,
      interval: null,
      updating: false,
      mandatory_cleaning_price: 0,
      special_message: '',
      not_available_reason: ''
    };
  },
  mounted: function mounted() {
    this.updating = true;
    this.fetch();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['cart']), {
    noOfVisitors: function noOfVisitors() {
      return this.adults + this.youths + this.children;
    }
  }),
  watch: {
    arrival: function a() {
      if (!this.updating) {
        this.updating = true;
        this.fetch();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['confirmAccomodation', 'openModal']), {
    fetch: function fetch() {
      var _this = this;

      this.interval = setInterval(function () {
        if (_this.unit && _this.unit.pool_lid) {
          clearInterval(_this.interval);
          _this.updating = false;
          __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/units/' + _this.unit.pool_lid + '/' + _this.unit.unit_lid + '/prices/' + _this.arrival + '/' + _this.departure).then(function (result) {
            var price = {};
            var foundFree = 0;

            for (var i in result.data.accomodations.prices_extra) {
              if (result.data.accomodations.prices_extra.hasOwnProperty(i)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices_extra[i].period;
                  foundFree = result.data.accomodations.prices_extra[i].free;
                }
              }
            }

            for (var _i in result.data.accomodations.prices_special) {
              if (result.data.accomodations.prices_special.hasOwnProperty(_i)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices_special[_i].period;
                  foundFree = result.data.accomodations.prices_special[_i].free;
                }
              }
            }

            for (var _i2 in result.data.accomodations.prices) {
              if (result.data.accomodations.prices.hasOwnProperty(_i2)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices[_i2];
                  foundFree = result.data.accomodations.prices[_i2].free;
                }
              }
            }

            for (var _i3 in result.data.accomodations.prices_summer) {
              if (result.data.accomodations.prices_summer.hasOwnProperty(_i3)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices_summer[_i3];
                  foundFree = result.data.accomodations.prices_summer[_i3].free;
                }
              }
            }

            if (result.data.mandatory_cleaning) {
              _this.mandatory_cleaning_price = Math.round(parseFloat(result.data.mandatory_cleaning.aprice));
            } else {
              _this.mandatory_cleaning_price = 0;
            }

            if (result.data.special_message) {
              _this.special_message = result.data.special_message;
            } else {
              _this.special_message = '';
            }

            _this.period = price;

            if (_this.checkAvailability) {
              var url = '/units/' + _this.unit.pool_lid + '/' + _this.unit.unit_lid + '/check-availability/' + _this.arrival + '/' + _this.departure;
              if (_this.$store.state.lockingCode) {
                url = url + '/' + _this.$store.state.lockingCode;
              }

              __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get(url).then(function (result) {
                var period = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.period);
                period.available = result.success;
                period.not_available_reason = result.reason;

                if (!result.success) {
                  _this.not_available_reason = result.reason;
                } else {
                  _this.not_available_reason = '';
                }

                _this.$emit('gotprice', period);
              });
            } else {
              _this.mandatory_cleaning_price = 0;
            }
          });
        }
      }, 50);
    },
    showModal: function showModal() {
      return this.$route.params.pool;
    },
    addToCart: function addToCart() {
      if (this.noOfVisitors <= 0) {
        this.openModal(['GeneralModal', {
          title: 'Välj antal personer',
          content: '<p>För att det ska bli lättare i nästa steg behöver du välja hur många personer i olika åldrar ni är.</p>'
        }]);
        return false;
      }

      if (this.noOfVisitors > this.cartAccomodationObject.capacity) {
        this.openModal(['GeneralModal', {
          title: 'Många resenärer',
          content: '<p>Du har valt att ni \xE4r totalt ' + this.noOfVisitors + ' personer. Detta boende har kapacitet f\xF6r ' + this.cartAccomodationObject.capacity + ' personer.</p>'
        }]);
        return false;
      }

      this.confirmAccomodation({
        adults: this.adults,
        youths: this.youths,
        children: this.children
      });

      this.$router.push({ name: 'addons' });

      return true;
    },
    changeAdults: function changeAdults(value) {
      this.adults = value;
    },
    changeYouths: function changeYouths(value) {
      this.youths = value;
    },
    changeChildren: function changeChildren(value) {
      this.children = value;
    },
    moment: function moment(date, format) {
      var string = __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format(format);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    validated: function validated() {
      return this.noOfVisitors;
    },
    openPriceList: function openPriceList(unit) {
      if (this.$route.name === 'confirm-accomodation') {
        this.$router.push({ path: '/boenden/bekrafta/pris/' + unit.slug + '?flow=boenden/bekrafta&no=' + this.currentRealAccomodationIndex });
      } else {
        this.$router.push({ path: '/boenden/pris/' + unit.slug + '?flow=boenden&no=' + this.currentRealAccomodationIndex });
      }
    }
  })
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unitsTotal', 'unitsLeft', 'unitType', 'unitTitle', 'unitShow'],
  computed: {
    getTypeText: function getTypeText() {
      return this.unitsLeft > 1 ? 'lägenheter' : 'lägenhet';
    },
    getUnitsLeft: function getUnitsLeft() {
      return this.unitsLeft > 5 ? 'Flera' : this.unitsLeft;
    },
    getCriticalLevel: function getCriticalLevel() {
      return this.unitsLeft > 5 ? 'normal' : 'critical';
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListPool__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListPool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListPool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Note__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Note__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AccomodationsListPool: __WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListPool___default.a,
    AccomodationsListUnitsList: __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList___default.a,
    Note: __WEBPACK_IMPORTED_MODULE_5__components_components_Note___default.a
  },
  props: ['pools', 'locations'],
  methods: {
    areaTitle: function areaTitle(pool, index) {
      if (this.$store.state.accomodationsFilter.sorting && this.$store.state.accomodationsFilter.sorting.substr(0, 5) === 'site-') {
        if (index === 0) {
          return pool.units[0].facility.value;
        }

        var currentTitle = pool.units[0].facility.value;
        var previousTitle = this.filteredPools[index - 1].units[0].facility.value;

        if (currentTitle !== previousTitle) {
          return pool.units[0].facility.value;
        }
      }

      return '';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isAwaitingFilter']), {
    showLocationLabel: function showLocationLabel() {
      return this.$store.state.accomodationsFilter.sorting === 'site-2006' || this.$store.state.accomodationsFilter.sorting === 'site-2007' || this.$store.state.accomodationsFilter.sorting === 'site-2020';
    },
    filteredPools: function filteredPools() {
      var _this = this;

      var berg = 2006;
      var by = 2007;
      var mattesdalen = 2020;
      var other = 2008;
      var currentSorting = this.$store.state.accomodationsFilter.sorting;

      var mapped = this.pools.map(function (pool) {
        var newPool = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pool);
        var current = pool.units[0].facility_id;
        var map = [];

        newPool.sort_order = 0;

        if (currentSorting) {
          if (currentSorting === 'site-' + berg) {
            map['site-' + berg] = 1;
            map['site-' + by] = 2;
            map['site-' + other] = 4;
            map['site-' + mattesdalen] = 3;
          } else if (currentSorting === 'site-' + by) {
            map['site-' + berg] = 2;
            map['site-' + by] = 1;
            map['site-' + other] = 4;
            map['site-' + mattesdalen] = 3;
          } else if (currentSorting === 'site-' + mattesdalen) {
            map['site-' + berg] = 2;
            map['site-' + by] = 3;
            map['site-' + other] = 4;
            map['site-' + mattesdalen] = 1;
          }

          if (map['site-' + current]) {
            newPool.sort_order = map['site-' + current];
          }
        }

        return newPool;
      });

      if (currentSorting === 'site-' + berg || currentSorting === 'site-' + by || currentSorting === 'site-' + mattesdalen) {
        return mapped.sort(function (a, b) {
          return a.sort_order - b.sort_order;
        });
      }

      return mapped.sort(function (a, b) {
        if (currentSorting === 'price') {
          if (_this.$store.state.accomodationsFilter.date.endDate && window.prices) {
            var currentLowestPrice = 9999999;
            var theOtherLowestPrice = 9999999;

            a.units.forEach(function (unit) {
              if (window.prices[unit.id] && window.prices[unit.id] && window.prices[unit.id].price < currentLowestPrice) {
                currentLowestPrice = window.prices[unit.id].price;
              }
            });

            b.units.forEach(function (unit) {
              if (window.prices[unit.id] && window.prices[unit.id] && window.prices[unit.id].price < theOtherLowestPrice) {
                theOtherLowestPrice = window.prices[unit.id].price;
              }
            });

            if (currentLowestPrice > theOtherLowestPrice) {
              return 1;
            }
            if (currentLowestPrice < theOtherLowestPrice) {
              return -1;
            }
            return 0;
          }
          if (a.price_from > b.price_from) {
            return 1;
          }
          if (a.price_from < b.price_from) {
            return -1;
          }
          return 0;
        }

        if (currentSorting === 'alphabetical') {
          var currentTitle = a.display_name || a.name;
          var theOtherTitle = b.display_name || b.name;
          if (currentTitle > theOtherTitle) {
            return 1;
          }
          if (currentTitle < theOtherTitle) {
            return -1;
          }
          return 0;
        }

        var negative = Math.round(Math.random());
        var number = Math.round(Math.random());

        return negative ? number * -1 : number;
      });
    },
    allUnits: function allUnits() {
      var units = [];
      this.pools.forEach(function (pool) {
        pool.units.forEach(function (unit) {
          units.push(unit);
        });
      });
      return units;
    }
  }),
  data: function data() {
    return {};
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_AccomodationsListUnitsList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_AccomodationsListUnitsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_AccomodationsListUnitsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListUnitsGroup__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListUnitsGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListUnitsGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['pool', 'locations'],
  components: {
    AccomodationsListUnitsList: __WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_AccomodationsListUnitsList___default.a,
    AccomodationsListUnitsGroup: __WEBPACK_IMPORTED_MODULE_3__components_parts_Accomodation_List_AccomodationsListUnitsGroup___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['accomodationsFilterEndDate', 'accomodationsFilter']), {
    bulletPoints: function bulletPoints() {
      if (this.pool.bullet_points) {
        var pool = this.pool.bullet_points || '';
        return pool.split('\n');
      }
      return [];
    },
    filteredUnits: function filteredUnits() {
      var unitFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* filterUnit */])(this.$store.state.accomodationsFilter);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__["filter"])(unitFilter, this.pool.units);
    }
  }),
  watch: {
    accomodationsFilter: function accomodationsFilter() {
      this.calculateLowestUnitPrice();
    }
  },
  data: function data() {
    return {
      lowestUnitPrice: 0
    };
  },
  mounted: function mounted() {
    setTimeout(this.calculateLowestUnitPrice, 1);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['openModal']), {
    calculateLowestUnitPrice: function calculateLowestUnitPrice() {
      var _this = this;

      var lowest = 999999;
      if (!window.prices) {
        window.prices = {};
      }

      this.filteredUnits.forEach(function (unit) {
        if (_this.accomodationsFilterEndDate) {
          if (window.prices[unit.id] && window.prices[unit.id] && window.prices[unit.id].price < lowest) {
            lowest = window.prices[unit.id].price;
          }
        } else if (unit.price_from && unit.price_from < lowest) {
          lowest = unit.price_from;
        }
      });

      if (lowest !== 999999) {
        this.lowestUnitPrice = lowest;
      } else {
        this.lowestUnitPrice = 0;
      }
    },
    openMap: function openMap() {
      console.log(this.pool);
      this.openModal(['MapModal' + this.SITE_CONFIG.site, {
        locationId: this.pool.units[0].facility ? this.pool.units[0].facility.id : null,
        areaId: this.pool.id,
        type: 'view'
      }]);
    },
    moment: function moment(d) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(d);
    },
    openMovie: function openMovie() {
      this.openModal(['MovieModal', {
        url: this.pool.video
      }]);
    },
    openAreaMap: function openAreaMap() {
      window.open(this.pool.map_link);
    },
    openLocationInfo: function openLocationInfo() {
      this.openModal(['GeneralModal', {
        title: this.locations[this.pool.units[0].facility.id].title,
        content: this.locations[this.pool.units[0].facility.id].content
      }]);
    },
    expand: function expand() {
      this.$refs.unitList.isManuallyExpanded = !this.$refs.unitList.isManuallyExpanded;
    }
  })
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['pool'],
  components: {
    OutlineButton: __WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton___default.a,
    TableSortIndicator: __WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator___default.a,
    AccomodationsListUnitsList: __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_AccomodationsListUnitsList___default.a
  },
  data: function data() {
    return {
      sortColumn: null,
      sortReverse: false,
      isManuallyExpanded: false
    };
  },
  mounted: function mounted() {
    if (this.$store.state.accomodationsFilter.locationId) {
      this.expanded = true;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    filteredUnits: function filteredUnits() {
      var unitFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* filterUnit */])(this.$store.state.accomodationsFilter);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_fp__["filter"])(unitFilter, this.pool.units);
    },
    groupedUnits: function groupedUnits() {
      var groups = [];
      var key = 1;

      var bedGrouping = [4, 6, 8, 10, 12];

      var groupType = this.SITE_CONFIG.accomodations.display_as_group_pools[this.pool.id];

      if (groupType === 'floor') {
        this.filteredUnits.forEach(function (unit) {
          key += 1;

          var object = {
            title: unit.floor ? unit.floor.value : '',
            sorting: unit.floor ? unit.floor.value : 0,
            key: key,
            units: [unit]
          };

          var matchingIndex = false;

          var title = unit.floor ? unit.floor.value : '';

          groups.forEach(function (group, index) {
            if (title === group.title) {
              matchingIndex = index;
            }
          });

          if (matchingIndex === false) {
            groups.push(object);
          } else {
            groups[matchingIndex].units.push(unit);
          }
        });
      } else {
        this.filteredUnits.forEach(function (unit) {
          var title = '';
          var sorting = '';
          var subtitle = unit.subtitle || '';
          var capacity = unit.beds;

          if (unit.unit_lid === 10021) {
            capacity = 4;
          }

          var capacityTitle = '';

          if (capacity < bedGrouping[0]) {
            capacityTitle = '<' + bedGrouping[0] + ' b\xE4ddar';
          } else if (capacity >= bedGrouping[bedGrouping.length - 1]) {
            capacityTitle = bedGrouping[bedGrouping.length - 1] + '+ b\xE4ddar';
          } else {
            for (var i in bedGrouping) {
              var ii = parseInt(i, 10);
              if (capacity >= bedGrouping[ii]) {
                var next = bedGrouping[ii + 1];
                capacityTitle = bedGrouping[ii] + '\u2013' + next + ' b\xE4ddar';
              }
            }
          }

          if (subtitle.toLowerCase().match(/förhöjd standard/)) {
            title = 'Förhöjd standard, ';
            sorting = 100 + capacity;
          } else {
            sorting = 200 + capacity;
          }

          title = '' + title + capacityTitle;

          key += 1;

          var object = {
            title: title,
            sorting: sorting,
            key: key,
            units: [unit]
          };

          var matchingIndex = false;

          groups.forEach(function (group, index) {
            if (title === group.title) {
              matchingIndex = index;
            }
          });

          if (matchingIndex === false) {
            groups.push(object);
          } else {
            groups[matchingIndex].units.push(unit);
          }
        });
      }

      var sortedGroups = groups.sort(function (a, b) {
        if (a.sorting > b.sorting) {
          return 1;
        } else if (a.sorting < b.sorting) {
          return -1;
        }
        return 0;
      });

      return sortedGroups;
    },
    unitCount: function unitCount() {
      return this.filteredUnits.length;
    },
    expanded: function expanded() {
      if (this.$store.state.accomodationsFilter.freeSearch) {
        return true;
      }
      return this.isManuallyExpanded;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['favoriteAccommodations'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getPrice: function getPrice(id) {
      if (window.prices) {
        return window.prices[id].price;
      }

      return null;
    },
    isFavorite: function isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    sort: function sort(column) {
      if (this.sortColumn === column) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortColumn = column;
        this.sortReverse = false;
      }
    },
    moment: function moment(d) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(d);
    },
    isSorted: function isSorted(column) {
      return this.sortColumn === column ? this.sortReverse ? -1 : 1 : 0;
    },
    openPriceList: function openPriceList(unit) {
      this.$router.push({ path: '/boenden/pris/' + unit.slug + '?flow=boenden' });
    },
    openInfo: function openInfo(unit) {
      var image = '';
      if (this.$store.state.accomodationView && this.$store.state.accomodationView) {
        image = '/bilder';
      }

      if (this.$store.state.accomodationsFilter.date.endDate) {
        var arrival = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.$store.state.accomodationsFilter.date.startDate).format('YYYY-MM-DD');
        var departure = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.$store.state.accomodationsFilter.date.endDate).format('YYYY-MM-DD');
        this.$router.push({ path: '/boenden' + image + '/info/' + unit.slug + '/' + arrival + '/' + departure + '?flow=boenden' });
      } else {
        this.$router.push({ path: '/boenden' + image + '/info/' + unit.slug + '?flow=boenden' });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['accomodationPeriodPick', 'closeModal', 'closeAllModals', 'openModal', 'pickAccomodation', 'addFavorite', 'removeFavorite']))
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_AccomodationUnitsLeft__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_AccomodationUnitsLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_AccomodationUnitsLeft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['units', 'grouping'],
  components: {
    OutlineButton: __WEBPACK_IMPORTED_MODULE_2__components_components_OutlineButton___default.a,
    TableSortIndicator: __WEBPACK_IMPORTED_MODULE_3__components_components_TableSortIndicator___default.a,
    AccomodationUnitsLeft: __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_AccomodationUnitsLeft___default.a
  },
  data: function data() {
    return {
      sortColumn: null,
      sortReverse: false,
      isManuallyExpanded: false
    };
  },
  mounted: function mounted() {
    if (this.$store.state.accomodationsFilter.locationId) {
      this.expanded = true;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    filteredUnits: function filteredUnits() {
      var unitFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* filterUnit */])(this.$store.state.accomodationsFilter);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_fp__["filter"])(unitFilter, this.units);
    },
    sortedUnits: function sortedUnits() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_fp__["flow"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_fp__["compact"])([this.sortColumn ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_fp__["sortBy"])(this.sortColumn) : undefined, this.sortReverse ? __WEBPACK_IMPORTED_MODULE_5_lodash_fp__["reverse"] : undefined]))(this.filteredUnits);
    },
    unitCount: function unitCount() {
      return this.filteredUnits.length;
    },
    expanded: function expanded() {
      if (this.$store.state.accomodationsFilter.freeSearch) {
        return true;
      }
      return this.isManuallyExpanded;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['favoriteAccommodations'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getPrice: function getPrice(id) {
      if (window.prices) {
        return window.prices[id].price;
      }

      return null;
    },
    getUnitsLeft: function getUnitsLeft(id) {
      if (window.prices) {
        return window.prices[id] ? window.prices[id].count : null;
      }

      return null;
    },
    isFavorite: function isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    sort: function sort(column) {
      if (this.sortColumn === column) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortColumn = column;
        this.sortReverse = false;
      }
    },
    moment: function moment(d) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(d);
    },
    isSorted: function isSorted(column) {
      return this.sortColumn === column ? this.sortReverse ? -1 : 1 : 0;
    },
    openPriceList: function openPriceList(unit) {
      this.$router.push({ path: '/boenden/pris/' + unit.slug + '?flow=boenden' });
    },
    openInfo: function openInfo(unit) {
      var image = '';
      if (this.$store.state.accomodationView && this.$store.state.accomodationView) {
        image = '/bilder';
      }

      if (this.$store.state.accomodationsFilter.date.endDate) {
        var arrival = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.$store.state.accomodationsFilter.date.startDate).format('YYYY-MM-DD');
        var departure = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.$store.state.accomodationsFilter.date.endDate).format('YYYY-MM-DD');
        this.$router.push({ path: '/boenden' + image + '/info/' + unit.slug + '/' + arrival + '/' + departure + '?flow=boenden' });
      } else {
        this.$router.push({ path: '/boenden' + image + '/info/' + unit.slug + '?flow=boenden' });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['accomodationPeriodPick', 'closeModal', 'closeAllModals', 'openModal', 'pickAccomodation', 'addFavorite', 'removeFavorite']), {
    toggleFavorite: function toggleFavorite(unitId) {
      var _this = this;

      var index = this.favoriteAccommodations.indexOf(unitId);
      if (index > -1) {
        this.removeFavorite(index);
      } else {
        var $this = this;
        var favoriteCount = this.favoriteAccommodations.length;
        if (favoriteCount >= 3) {
          this.openModal(['GeneralModal', {
            title: 'Max 3 favoritboenden',
            content: '<p>Du kan endast spara 3 favoritboenden.</p>',
            buttons: [{
              title: 'Okej',
              class: 'small',
              click: function click() {
                $this.closeModal();
              }
            }]
          }]);
        } else {
          this.addFavorite(unitId);
          if (favoriteCount === 2) {
            this.openModal(['GeneralModal', {
              title: '3 favoriter',
              content: 'Du har nu 3 favoriter tillagda för jämförelse, du kan inte lägga till fler. Vill du jämföra dem nu?',
              buttons: [{
                title: 'Ja, jämför',
                class: '',
                click: function click() {
                  _this.$router.push({ name: 'compare-accomodations' });
                }
              }, {
                title: 'Nej, fortsätt leta',
                class: 'white border',
                click: function click() {
                  _this.closeModal();
                }
              }]
            }]);
          }
        }
      }
    }
  })
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_AccomodationsFilterSub__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_AccomodationsFilterSub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_AccomodationsFilterSub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_deprecated_OutlineButton__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_deprecated_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_deprecated_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dates__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['filterObject'],
  components: {
    DatepickerButton: __WEBPACK_IMPORTED_MODULE_7__components_components_DatepickerButton___default.a,
    OutlineButton: __WEBPACK_IMPORTED_MODULE_8__components_deprecated_OutlineButton___default.a,
    CounterButton: __WEBPACK_IMPORTED_MODULE_9__components_components_CounterButton___default.a,
    AccomodationsFilterSub: __WEBPACK_IMPORTED_MODULE_6__components_parts_Accomodation_List_Filter_AccomodationsFilterSub___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_10__components_components_Dropdown___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    date: function date() {
      return this.$store.state.accomodationsFilter.date;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['filtersToggle', 'datepickerToggle', 'bedsCount', 'roomsCount']), {
    validStartDate: function validStartDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__dates__["a" /* validStartDate */])({
        validStartDates: this.validStartDates
      });
    },
    validEndDate: function validEndDate() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__dates__["c" /* validEndDate */])({
        startDate: this.startDate,
        validEndDates: this.validEndDates
      });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$store.state.accomodationsFilter.date.endDate) {
                _this.updateAvailableUnits(_this.$store.state.accomodationsFilter.date.startDate, _this.$store.state.accomodationsFilter.date.endDate);
              }

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['changeBeds', 'changeRooms', 'toggleDatepicker', 'toggleMap', 'toggleFilters', 'openModal', 'closeModal', 'awaitFilter', 'setAccomodationsFilterStartDate', 'setAccomodationsFilterEndDate', 'setAccomodationsAvailableIds']), {
    updateEndDate: function updateEndDate(value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formatted, _ref, data, validEndDates, inValidEndDates;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formatted = __WEBPACK_IMPORTED_MODULE_13_moment___default()(value).format('YYYY-MM-DD');
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get('/dates/valid-end-dates/' + formatted + '?view=object');

              case 3:
                _ref = _context2.sent;
                data = _ref.data;
                validEndDates = [];
                inValidEndDates = [];

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (element) {
                  if (element[1].free === 1) {
                    validEndDates.push(element[1].date_departure);
                  } else {
                    inValidEndDates.push(element[1].date_departure);
                  }
                });

                return _context2.abrupt('return', {
                  valid: validEndDates,
                  invalid: inValidEndDates
                });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    openDatePicker: function openDatePicker() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, data, validStartDates, disabledDays;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get('/dates/valid-start-dates?view=object');

              case 2:
                _ref2 = _context3.sent;
                data = _ref2.data;
                validStartDates = [];
                disabledDays = [];

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (element) {
                  if (element[1].free === 1) {
                    validStartDates.push(element[1].date_arrival);
                  } else {
                    disabledDays.push(element[1].date_arrival);
                  }
                });
                _this3.validStartDates = validStartDates;
                _this3.disabledDays = disabledDays;


                _this3.openModal(['DatepickerRangeModal', {
                  validDates: _this3.validStartDates,

                  disabledDays: _this3.disabledDays,
                  specialDays: _this3.SITE_CONFIG.season.summer.special,
                  onPickStart: _this3.updateEndDate,
                  pickedStartDate: _this3.$store.state.accomodationsFilter.date.startDate,
                  pickedEndDate: _this3.$store.state.accomodationsFilter.date.endDate,
                  terminology: 'Sök',
                  onClose: function onClose(a, b, c, d) {
                    _this3.changedEndDate(a, b, c, d);
                  },
                  infoOnPicked: _this3.SITE_CONFIG.accomodations.date_picker_help.pick_end ? _this3.SITE_CONFIG.accomodations.date_picker_help.pick_end : '',
                  info: _this3.SITE_CONFIG.accomodations.date_picker_help.pick_day ? _this3.SITE_CONFIG.accomodations.date_picker_help.pick_day : '',
                  extraInfo: function extraInfo(startDate) {
                    var msg1 = '';
                    var msg2 = '';
                    var msg3 = '';
                    var msg4 = '';
                    var msg5 = _this3.SITE_CONFIG.accomodations.date_picker_help.accommodation_info ? _this3.SITE_CONFIG.accomodations.date_picker_help.accommodation_info : '';
                    var isSummer = __WEBPACK_IMPORTED_MODULE_13_moment___default()(startDate).isBetween(_this3.SITE_CONFIG.season.summer.start, _this3.SITE_CONFIG.season.summer.end, null, '[]');

                    if (isSummer && _this3.SITE_CONFIG.accomodations.date_picker_help.offert) {
                      msg2 = _this3.SITE_CONFIG.accomodations.date_picker_help.offert;
                    }
                    if (!startDate) {
                      msg2 = _this3.SITE_CONFIG.accomodations.date_limit_text;
                    }

                    var closed = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.SITE_CONFIG.season.winter.closed)).filter(function (d) {
                      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(d).startOf('day').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_13_moment___default()().startOf('day'));
                    });
                    var arrival = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.validStartDates));

                    var arrivalAndClosed = closed.filter(function (c) {
                      return arrival.indexOf(__WEBPACK_IMPORTED_MODULE_13_moment___default()(c).format('YYYY-MM-DD')) !== -1;
                    });

                    if (startDate && arrivalAndClosed.length) {
                      msg3 = '';
                      if (_this3.SITE_CONFIG.accomodations.date_picker_help.closed_slopes) {
                        msg3 = _this3.SITE_CONFIG.accomodations.date_picker_help.closed_slopes;
                      }
                    }

                    if (_this3.SITE_CONFIG.accomodations.date_picker_help.saturday && startDate && __WEBPACK_IMPORTED_MODULE_13_moment___default()(startDate).isoWeekday() === 6) {
                      msg1 = _this3.SITE_CONFIG.accomodations.date_picker_help.saturday;
                    }

                    if (_this3.SITE_CONFIG.accomodations.date_picker_help.special_info1) {
                      msg4 = _this3.SITE_CONFIG.accomodations.date_picker_help.special_info1;
                    }
                    return [msg1, msg2, msg3, msg4, msg5];
                  },
                  disableSingle: true,
                  open: _this3.SITE_CONFIG.modules_open.accomodation.open,
                  closed_message: _this3.SITE_CONFIG.modules_open.accomodation.closed_message
                }]);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    changedStartDate: function changedStartDate(value) {
      this.updateEndDate(value);
      this.awaitFilter();
    },
    updateAvailableUnits: function updateAvailableUnits(a, b) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var startFormatted, endFormatted, _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                startFormatted = __WEBPACK_IMPORTED_MODULE_13_moment___default()(a).format('YYYY-MM-DD');
                endFormatted = __WEBPACK_IMPORTED_MODULE_13_moment___default()(b).format('YYYY-MM-DD');
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12__classes_API__["a" /* default */].get('/dates/units-available/' + startFormatted + '/' + endFormatted);

              case 4:
                _ref3 = _context4.sent;
                data = _ref3.data;

                _this4.setAccomodationsAvailableIds(data);

                window.prices = data;
              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    changedEndDate: function changedEndDate(a, b, c, d) {
      var $this = this;

      var start = __WEBPACK_IMPORTED_MODULE_13_moment___default()(a);
      var end = __WEBPACK_IMPORTED_MODULE_13_moment___default()(b);
      var diff = end.diff(start, 'days');
      var includesClosedDate = false;
      var i = 0;

      while (i <= diff) {
        var dateToCheck = start.clone().add(i, 'days').format('YYYY-MM-DD');
        console.log(dateToCheck);

        if (this.SITE_CONFIG.season.summer.special.indexOf(dateToCheck) === -1) {
          includesClosedDate = true;
        }

        i += 1;
      }

      if (d && includesClosedDate) {
        this.openModal(['SummerConfirmationModal', {
          startDate: a,
          endDate: b,
          click: function click() {
            $this.doChangeEndDate(a, b);
          },
          cancel: function cancel() {
            $this.openDatePicker();
          }
        }]);

        this.openModal(['GeneralModal', {}]);
      } else {
        this.doChangeEndDate(a, b);
      }
    },
    doChangeEndDate: function doChangeEndDate(a, b) {
      this.updateAvailableUnits(a, b);
      this.setAccomodationsFilterStartDate(a);
      this.setAccomodationsFilterEndDate(b);
      this.closeModal();
      this.awaitFilter();
    },
    dateClear: function dateClear() {
      this.$store.state.accomodationsFilter.date = {
        startDate: null,
        endDate: null
      };
    },
    moment: function moment(a) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(a);
    }
  })
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_List_Filter_FilterListItem__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_List_Filter_FilterListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_List_Filter_FilterListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_API__ = __webpack_require__(4);














/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    unitCount: {},
    poolCount: {}
  },
  data: function data() {
    return {
      pools: [],
      selectedFilter: null,
      filters: [{
        value: 'random',
        title: 'Slumpad',
        explanation: 'slumpad ordning'
      }, {
        value: 'price',
        title: 'Pris',
        explanation: 'lägst pris först'
      }]
    };
  },

  components: {
    FilterListItem: __WEBPACK_IMPORTED_MODULE_5__components_parts_Accomodation_List_Filter_FilterListItem___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default.a
  },
  computed: {
    activeFilters: function activeFilters() {
      var localFilters = this.$store.state.accomodationsFilter;

      var newFilters = {};

      var filtersAsArray = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(localFilters);

      filtersAsArray.forEach(function (filter) {
        var key = filter[0];
        var value = filter[1];

        switch (key) {
          case 'beds':
          case 'bedrooms':
            if (value > 1) {
              newFilters[key] = value;
            }
            break;
          case 'date':
            if (value.startDate && value.endDate) {
              newFilters[key] = value;
            }
            break;
          case 'availabelIds':
          case 'freeSearch':
            break;
          default:
            if (value) {
              newFilters[key] = value;
            }
            break;
        }
      });

      return newFilters;
    },
    activeFiltersCount: function activeFiltersCount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_fp__["size"])(this.activeFilters);
    },
    selectedFilterObject: function selectedFilterObject() {
      var _this = this;

      var filters = this.filters.filter(function (f) {
        return f.value === _this.$store.state.accomodationsFilter.sorting;
      });

      if (filters.length) {
        return filters[0];
      }

      return this.filters[0];
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (this.SITE_CONFIG.site === 'branas') {
      this.filters.push({
        value: 'site-2006',
        title: 'Berget',
        explanation: 'boenden på Berget först'
      });
      this.filters.push({
        value: 'site-2007',
        title: 'Dalen',
        explanation: 'boenden i Dalen först'
      });
      this.filters.push({
        value: 'site-2020',
        title: 'Mattesdalen',
        explanation: 'boenden i Mattesdalen först'
      });
    }

    this.filters.push({
      value: 'alphabetical',
      title: 'A-Ö',
      explanation: 'bokstavsordning'
    });

    if (this.$store.state.accomodationsFilter.sorting) {
      var first = this.filters.find(function (value) {
        return value.value === _this2.$store.state.accomodationsFilter.sorting;
      });
      if (first) {
        this.selectedFilter = first.value;
      }
    }
  },
  mounted: function mounted() {
    this.fetchPools();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['resetAccomodationsFilter', 'awaitFilter', 'changeSorting']), {
    fetchPools: function fetchPools() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__classes_API__["a" /* default */].get('/areas');

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                _this3.pools = data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    area: function area(id) {
      var pool = {};
      if (this.pools) {
        pool = this.pools.find(function (p) {
          return id === p.id;
        });
      }
      if (pool) {
        return pool.display_name || pool.name;
      }
      return '';
    },
    reset: function reset() {
      var $this = this;
      $this.$refs.resetButton.className = 'reset-button animation';
      $this.resetAccomodationsFilter();
      this.awaitFilter();
      setTimeout(function () {
        $this.$refs.resetButton.className = 'reset-button';
      }, 1000);
    },
    changedSorting: function changedSorting(value) {
      this.changeSorting({ value: value.value });
    }
  })
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_deprecated_OutlineButton__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_deprecated_OutlineButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_deprecated_OutlineButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_CounterButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_CounterButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_CounterButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_SearchModal__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_SearchModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_SearchModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_TextInput__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { CounterButton: __WEBPACK_IMPORTED_MODULE_2__components_components_CounterButton___default.a, SwitchButton: __WEBPACK_IMPORTED_MODULE_3__components_components_SwitchButton___default.a, OutlineButton: __WEBPACK_IMPORTED_MODULE_1__components_deprecated_OutlineButton___default.a, SearchModal: __WEBPACK_IMPORTED_MODULE_4__components_parts_Accomodation_List_SearchModal___default.a, TextInput: __WEBPACK_IMPORTED_MODULE_5__components_components_TextInput___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['roomsCount', 'searchToggle', 'mapToggle', 'getFreeSearch'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['changeBeds', 'changeRooms', 'toggleSearch', 'toggleFilterSwitch', 'toggleMap', 'changeFreeSearch', 'openModal', 'awaitFilter']), {
    openMap: function openMap() {
      this.openModal(['MapModal' + this.SITE_CONFIG.site, {
        areaId: this.$store.state.accomodationsFilter.locationId || null,
        type: 'interactive'
      }]);
    }
  })
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(26);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['filter', 'value', 'label', 'icon'],
  methods: {
    click: function click() {
      this.$emit('click');
    }
  },
  computed: {
    computedIcon: function computedIcon() {
      if (this.icon) {
        return this.icon;
      }

      switch (this.filter) {
        case 'date':
          return 'calendar-blue';
        default:
          return null;
      }
    },
    computedLabel: function computedLabel() {
      if (this.label) {
        return this.label;
      }

      switch (this.filter) {
        case 'date':
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib__["a" /* formatAccomodationsFilterDate */])(this.value.startDate, this.value.endDate);
        case 'beds':
          return this.value + '+ b\xE4ddar';
        case 'bedrooms':
          return this.value + '+ sovrum';
        case 'sauna':
          return 'Bastu';
        case 'direct_incheck':
          return this.SITE_CONFIG.settings.SettingLockTypes.active ? 'Digital incheckning' : this.SITE_CONFIG.settings.SettingLockTypes.texts[1].title;
        case 'pets':
          return 'Husdjur tillåtet';
        case 'chargeStation':
          return 'Laddstolpe';
        case 'fireplace':
          return 'Öppen spis';
        case 'dishwasher':
          return 'Diskmaskin';
        case 'dryer_cabinet':
          return 'Torkskåp';
        case 'washing_machine':
          return 'Tvättmaskin';
        case 'cleaning':
          return 'Slutstäd ingår';
        case 'locationId':
          return 'Område valt';
        case 'internet':
          return 'Internet';
        case 'child_friendly':
          return 'Extra barnanpassat';
        default:
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib__["c" /* titleCase */])(this.filter) + ': ' + this.value;
      }
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['date'],
  methods: {
    close: function close() {
      this.$emit('close', false);
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unit', 'small'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    add: {
      default: false
    },
    orderNumber: {
      default: ''
    },
    dateStart: {
      default: null
    },
    dateEnd: {
      default: null
    },
    orderNumberNumeric: {
      default: 0
    },
    helperPool: {
      default: ''
    },
    helperUnit: {
      default: ''
    }
  },
  computed: {
    canRemoveConnection: function canRemoveConnection() {
      if (this.$route.name === 'payment') {
        return false;
      }
      if (this.$route.name === 'checkout') {
        return false;
      }
      if (this.$route.name === 'payment confirmation') {
        return false;
      }
      if (this.$route.name === 'payedwithcode') {
        return false;
      }
      return true;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal', 'openModal', 'clearCart']), {
    openBooking: function openBooking() {
      this.$router.push({ name: 'my booking', params: { bookingNumber: this.$store.state.cart.addToOrder.numeric } });
    },
    removeConnection: function removeConnection() {
      var $this = this;
      this.openModal(['GeneralModal', {
        title: 'Avbryt tilläggsbokning',
        content: 'Du håller just nu på att tilläggsboka. Vill du flytta det du nu har i varukorgen till en egen bokning, eller rensa varukorgen?<br><br>OBS! Oavsett vad du väljer så kommer din grundbokning att finna kvar.',
        buttons: [{
          title: 'Flytta till ny bokning',
          class: 'small',
          click: function click() {
            $this.$store.state.cart.deliveryTo = {};

            for (var i in $this.$store.state.cart.rentals) {
              $this.$store.state.cart.rentals[i].delivery = false;
              $this.$store.state.cart.rentals[i].site = null;
            }
            for (var _i in $this.$store.state.cart.skipasses) {
              $this.$store.state.cart.skipasses[_i].delivery_type = 'pickup';
              $this.$store.state.cart.skipasses[_i].deliveryType = 'pickup';
              $this.$store.state.cart.skipasses[_i].site = null;
            }

            $this.$store.state.cart.addToOrder = {};
            $this.$store.state.cart.rentalDateRestriction = {};
            $this.closeModal();
            window.location.reload();
          }
        }, {
          title: 'Rensa varukorg',
          class: 'small white border',
          click: function click() {
            $this.clearCart();
            $this.closeModal();
            window.location.reload();
          }
        }, {
          title: 'Stäng denna ruta',
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }, {
          title: 'Visa min varukorg',
          class: 'small white border',
          click: function click() {
            $this.$router.push('/varukorg');
          }
        }]
      }]);
    }
  })
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_PriceView__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_PriceView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_PriceView__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showFromStart: {
      default: false
    },
    useStorage: {
      default: true
    },
    order: {
      default: function _default() {}
    }
  },
  components: {
    PriceView: __WEBPACK_IMPORTED_MODULE_7__components_components_PriceView___default.a
  },
  data: function data() {
    return {
      showing: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['cart']), {
    localCart: function localCart() {
      if (this.useStorage) {
        return this.cart;
      }
      return this.order;
    },
    hasDelivery: function hasDelivery() {
      var delivery = false;

      this.localCart.rentals.forEach(function (a) {
        if (a.confirmed) {
          if (a.delivery || a.deliveryType === 'delivery') {
            delivery = true;
          }
        }
      });

      return delivery;
    }
  }),
  mounted: function mounted() {
    if (this.showFromStart) {
      this.showing = true;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    count: function count() {
      var _this = this;

      var accomodations = this.localCart.accomodations.reduce(function (a, b) {
        return b.confirmed ? a + 1 : a;
      }, 0);
      var skipasses = this.localCart.skipasses.reduce(function (a, b) {
        return b.confirmed ? a + _this.number(b.adults) + _this.number(b.youths) + _this.number(b.children) : a;
      }, 0);

      return accomodations + skipasses;
    },
    accomodationSkipassDiscountedPrice: function accomodationSkipassDiscountedPrice(skipass, ageSingular, agePlural) {
      var lidProperty = ageSingular + 'Lid';
      var priceProperty = ageSingular === 'child' ? 'childPrice' : agePlural + 'Price';
      var quantity = this.number(skipass[agePlural]);
      var lid = this.number(skipass[lidProperty]);
      var discountedPrice = skipass.discountedPrices && skipass.discountedPrices[lid];

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(discountedPrice) || ageSingular === 'child') {
        discountedPrice += 55;
      }

      if (discountedPrice) {
        return quantity * discountedPrice;
      }

      return quantity * skipass[priceProperty];
    },
    accomodationDiscountedPrice: function accomodationDiscountedPrice(accomodation) {
      var quantity = this.number(accomodation.quantity);

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(accomodation.discountedPrice)) {
        return accomodation.discountedPrice * quantity;
      }

      return accomodation.price * quantity;
    },
    addonDiscountedPrice: function addonDiscountedPrice(addon) {
      var quantity = this.number(addon.quantity);

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(addon.discountedPrice)) {
        return quantity * addon.discountedPrice;
      }

      return quantity * addon.price;
    },
    totalPrice: function totalPrice() {
      var _this2 = this;

      var discounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var accomodations = this.localCart.accomodations.reduce(function (a, b) {
        if (_this2.localCart.campaignCode && discounted) {
          return b.confirmed ? a + b.discountedPrice * _this2.number(b.quantity) : a;
        }
        return b.confirmed ? a + b.price * _this2.number(b.quantity) : a;
      }, 0);
      var addons = this.localCart.addons.reduce(function (a, b) {
        if (b.confirmed) {
          if (b.discount && b.discount.type === 'percentage') {
            return a + b.price * (b.discount.amount / 100) * _this2.number(b.quantity);
          }
          if (_this2.localCart.campaignCode && discounted) {
            return a + _this2.addonDiscountedPrice(b);
          }
          return a + b.price * _this2.number(b.quantity);
        }
        return a;
      }, 0);
      var skipasses = this.localCart.skipasses.reduce(function (a, b) {
        if (b.confirmed) {
          if (b.type === 'SKIPASS-ACCO') {
            if (_this2.localCart.campaignCode && discounted) {
              var _adults = _this2.accomodationSkipassDiscountedPrice(b, 'adult', 'adults');
              var _youths = _this2.accomodationSkipassDiscountedPrice(b, 'youth', 'youths');
              var _children = _this2.accomodationSkipassDiscountedPrice(b, 'child', 'children');
              var _seniors = _this2.accomodationSkipassDiscountedPrice(b, 'senior', 'seniors');
              return a + _adults + _youths + _children + _seniors;
            }

            var adults = _this2.number(b.adults) * _this2.number(b.adultsPrice);
            var youths = _this2.number(b.youths) * _this2.number(b.youthsPrice);
            var children = _this2.number(b.children) * _this2.number(b.childrenPrice);
            var seniors = _this2.number(b.seniors) * _this2.number(b.seniorsPrice);
            return a + adults + youths + children + seniors;
          }
          var price = _this2.number(discounted && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(b.discountedPrice) ? b.discountedPrice : b.price);
          return a + _this2.number(b.quantity) * (price + (b.keycardPrice ? _this2.number(b.keycardPrice) : 0));
        }
        return a;
      }, 0);
      var rentals = 0;

      if (this.SITE_CONFIG.rental.insurance_per_product) {
        if (this.localCart.campaignCode) {
          rentals = this.localCart.rentals.reduce(function (a, b) {
            return b.confirmed ? a + _this2.getProductPrice(b, discounted) * _this2.number(b.quantity) : a;
          }, 0);
        } else {
          rentals = this.localCart.rentals.reduce(function (a, b) {
            return b.confirmed ? a + b.price * _this2.number(b.quantity) : a;
          }, 0);
        }
      } else {
        rentals = this.localCart.rentals.reduce(function (a, b) {
          return b.confirmed ? a + (b.price * _this2.number(b.quantity) + (b.insurance ? b.insuranceSum : 0)) : a;
        }, 0);
      }
      var skischools = this.localCart.skischools.reduce(function (a, b) {
        return a + b.price * _this2.number(b.quantity);
      }, 0);
      var activities = (this.localCart.activities || []).reduce(function (a, b) {
        return a + b.price * _this2.number(b.quantity);
      }, 0);
      var products = (this.localCart.products || []).reduce(function (a, b) {
        return a + b.price * _this2.number(b.quantity);
      }, 0);

      return accomodations + skipasses + addons + rentals + skischools + activities + products;
    },
    getProductPrice: function getProductPrice(p) {
      var discounted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var price = 0;
      var days = p.days;

      for (var i in p.products) {
        var priceToAdd = discounted && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(p.products[i].discountedPrice) ? p.products[i].discountedPrice : this.getNestedProductPrice(days, p.products[i], p.insurance);
        price += priceToAdd;
      }

      for (var _i in p.addons) {
        var _priceToAdd = discounted && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(p.addons[_i].discountedPrice) ? p.addons[_i].discountedPrice : this.getNestedProductPrice(days, p.addons[_i], p.insurance);
        price += _priceToAdd;
      }

      return price;
    },
    getNestedProductPrice: function getNestedProductPrice(days, product, insurance) {
      if (insurance) {
        return product['price_insurance_' + days] || 0;
      }

      return product['price_' + days] || 0;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['removeCartItem', 'openModal', 'closeModal']), {
    cancel: function cancel(obj) {
      var _this3 = this;

      var $this = this;
      this.openModal(['GeneralModal', {
        content: this.$i18n.t('general.unbook-question-text'),
        no: $this.closeModal,
        yes: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _ref2, data;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    $this.$emit('loading', true);
                    _context.next = 3;
                    return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].post('/payments/cancel-order-line/' + _this3.$route.params.bookingNumber + '/' + obj.row);

                  case 3:
                    _ref2 = _context.sent;
                    data = _ref2.data;

                    $this.$emit('loadingcomplete', true);
                    $this.$emit('changed', true);
                    $this.closeModal();
                    return _context.abrupt('return', data);

                  case 9:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this3);
          }));

          return function yes() {
            return _ref.apply(this, arguments);
          };
        }()
      }]);
    },
    localRemoveCartItem: function localRemoveCartItem(obj) {
      var _this4 = this;

      var content = this.$i18n.t('general.remove-row-question-text');
      if (obj.type === 'accomodations') {
        content = this.$i18n.t('general.remove-row-question-text-accomodation');
      }

      var $this = this;
      this.openModal(['GeneralModal', {
        content: content,
        no: $this.closeModal,
        yes: function () {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var aIndex, index, pId, uId, startDate, endDate, code, _ref4, data, school, accomodationCount;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    aIndex = obj.index;

                    if (!(obj.type === 'skipasses' && obj.age)) {
                      _context2.next = 7;
                      break;
                    }

                    $this.cart.skipasses[aIndex][obj.age] = 0;
                    $this.cart.skipasses[aIndex]['hide' + obj.age] = true;

                    if (!($this.cart.skipasses[aIndex].adults || $this.cart.skipasses[aIndex].youths || $this.cart.skipasses[aIndex].children)) {
                      _context2.next = 7;
                      break;
                    }

                    $this.closeModal();
                    return _context2.abrupt('return');

                  case 7:
                    if (!(obj.type === 'accomodations')) {
                      _context2.next = 23;
                      break;
                    }

                    index = $this.cart.addons.length;

                    while (index > 0) {
                      index -= 1;
                      if ($this.cart.addons[index].belongsTo === aIndex) {
                        $this.removeCartItem({ type: 'addons', index: index });
                        console.log('Removing addon with index', index);
                      } else if ($this.cart.addons[index].belongsTo > aIndex) {
                        $this.cart.addons[index].belongsTo -= 1;
                        console.log('Lowering addon index on', index);
                      }
                    }

                    index = $this.cart.skipasses.length;
                    while (index > 0) {
                      index -= 1;
                      if ($this.cart.skipasses[index].belongsTo === aIndex) {
                        $this.removeCartItem({ type: 'skipasses', index: index });
                        console.log('Removing skipass with index', index);
                      } else if ($this.cart.skipasses[index].belongsTo > aIndex && $this.cart.skipasses[index].belongsTo !== -1) {
                        $this.cart.skipasses[index].belongsTo -= 1;
                        console.log('Lowering skipass index on', index);
                      }
                    }

                    $this.cart.rentals.forEach(function (rental, i) {
                      if ($this.cart.rentals[i].belongsTo === aIndex) {
                        $this.cart.rentals[i].belongsTo = -1;
                        console.log('Setting rental belongsto to -1, index', index);
                      } else if ($this.cart.rentals[index].belongsTo > aIndex) {
                        $this.cart.rentals[index].belongsTo -= 1;
                        console.log('Lowering rental index on', index);
                      }
                    });

                    pId = $this.cart.accomodations[aIndex].poolLid;
                    uId = $this.cart.accomodations[aIndex].unitLid;
                    startDate = $this.cart.accomodations[aIndex].period.date_arrival;
                    endDate = $this.cart.accomodations[aIndex].period.date_departure;
                    code = $this.$store.state.lockingCode;
                    _context2.next = 20;
                    return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].post('cancel-reservation/' + code + '/' + pId + '/' + uId + '/' + startDate + '/' + endDate);

                  case 20:
                    _ref4 = _context2.sent;
                    data = _ref4.data;

                    console.log(data);

                  case 23:
                    if (!(obj.type === 'skischools')) {
                      _context2.next = 27;
                      break;
                    }

                    school = $this.cart.skischools[obj.index];
                    _context2.next = 27;
                    return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/skischool/release-reservation/' + school.activity_lid + '/' + _this4.$store.state.lockingCode);

                  case 27:

                    $this.removeCartItem(obj);

                    accomodationCount = $this.cart.accomodations.filter(function (a) {
                      return a.confirmed;
                    }).length;

                    $this.$store.state.lockingActive = !!accomodationCount;

                    $this.closeModal();

                  case 31:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this4);
          }));

          return function yes() {
            return _ref3.apply(this, arguments);
          };
        }()
      }]);
    },
    edit: function edit(obj) {
      if (obj.type === 'accomodations') {
        this.$router.push({ name: 'confirm-accomodation', query: { no: obj.index } });
      }
      if (obj.type === 'addons') {
        this.$router.push({ name: 'addons', query: { no: obj.index } });
      }
      if (obj.type === 'skirentals') {
        this.$router.push({ name: 'ski rental overview' });
      }
      this.showing = false;
    },
    moment: function moment(date, format) {
      var string = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format(format);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggle: function toggle(setTo) {
      if (typeof setTo !== 'undefined') {
        this.showing = setTo;
      } else {
        this.showing = !this.showing;
      }

      this.updateIconWrapper();

      if (!this.showFromStart) {
        this.updateBody();
      }
    },
    updateBody: function updateBody() {
      var _this5 = this;

      if (this.showing) {
        document.body.classList.add('cart-opened');
        document.body.classList.add('cart-opened--with-background');
        setTimeout(function () {
          document.addEventListener('click', _this5.documentClick);
        }, 1);
      } else {
        document.body.classList.remove('cart-opened');
        document.body.classList.remove('cart-opened--with-background');
        document.removeEventListener('click', this.documentClick);
      }
    },
    documentClick: function documentClick(e) {
      if (e.target !== this.$el && !this.$el.contains(e.target)) {
        e.stopPropagation();
        this.toggle();
      }
    },
    updateIconWrapper: function updateIconWrapper() {
      if (this.showing) {
        document.getElementById('cart-icon-wrapper').className = 'active';
      } else {
        document.getElementById('cart-icon-wrapper').className = '';
      }
    },
    closeCart: function closeCart() {
      this.toggle(false);
    },
    pay: function pay() {
      this.toggle(false);
      this.$router.push({ name: 'shopping cart' });
    },
    bookAddon: function bookAddon(row) {
      this.$store.state.cart.addToOrder = {
        number: this.order.resvid,
        numeric: this.order.headlid,
        accomodationRow: row.row,
        accomodationName: row.name,
        accomodationDateArrival: row.arrival,
        accomodationDateDeparture: row.departure,
        accomodationGroup: row.group
      };

      this.$router.push({
        name: 'addons extra',
        query: {
          pool: row.pool,
          unit: row.unit,
          arrival: row.arrival,
          departure: row.departure,
          name: row.name,
          adults: parseInt(row.adults, 10),
          youths: parseInt(row.youths, 10),
          children: parseInt(row.children, 10),
          seniors: parseInt(row.seniors, 10) || 0
        }
      });
    },
    rowInfo: function rowInfo(row) {
      var $this = this;
      var people = '<p><b>\xC5kare:</b> ' + row.people_as_string + '</p>';
      var time = '<p><b>Tid:</b> ' + row.start_time + ' \u2013 ' + row.end_time + '</p>';
      var arrival = __WEBPACK_IMPORTED_MODULE_5_moment___default()(row.date_arrival).format('D MMMM');
      var departure = __WEBPACK_IMPORTED_MODULE_5_moment___default()(row.date_departure).format('D MMMM');
      var arrivalDay = __WEBPACK_IMPORTED_MODULE_5_moment___default()(row.date_arrival).format('dddd');
      var departureDay = __WEBPACK_IMPORTED_MODULE_5_moment___default()(row.date_departure).format('dddd');
      var dates = '<p><b>Datum:</b> ' + arrival + ' \u2013 ' + departure + ' (' + arrivalDay + ' \u2013 ' + departureDay + ')</p>';

      if (arrival === departure) {
        dates = '<p><b>Datum:</b> ' + arrival + ' (' + arrivalDay + ')</p>';
      }

      var place = '<p><b>Plats:</b> ' + row.location + '</p>';

      var description = row.description ? '<p>' + row.description + '</p>' : '';

      this.openModal(['GeneralModal', {
        zIndex: 20,
        title: row.name,
        content: '<p>' + description + '</p>' + place + people + dates + time,
        buttons: [{
          title: 'Stäng',
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    },
    removeDelivery: function removeDelivery() {
      var $this = this;
      this.openModal(['GeneralModal', {
        title: 'Hämta själv',
        content: 'Vill du ta bort utkörning för din bokning och hämta själv istället?',
        buttons: [{
          title: 'Jag vill hämta själv',
          class: 'small',
          click: function click() {
            $this.$store.state.cart.deliveryTo = {};

            for (var i in $this.$store.state.cart.rentals) {
              $this.$store.state.cart.rentals[i].delivery = false;
              $this.$store.state.cart.rentals[i].site = null;
            }
            for (var _i2 in $this.$store.state.cart.skipasses) {
              $this.$store.state.cart.skipasses[_i2].delivery_type = 'pickup';
              $this.$store.state.cart.skipasses[_i2].deliveryType = 'pickup';
              $this.$store.state.cart.skipasses[_i2].site = null;
            }

            $this.closeModal();
            window.location.reload();
          }
        }, {
          title: this.$i18n.t('general.go-back'),
          class: 'small white border',
          click: function click() {
            $this.closeModal();
          }
        }]
      }]);
    }
  })
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_UpdateAddress__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_UpdateAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_UpdateAddress__);










/* harmony default export */ __webpack_exports__["default"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal'])),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.alreadyLoaded) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/account/get-user-fields-for-update?checkout_session_id=' + _this.$route.query.checkout_session_id);

            case 3:
              _ref = _context.sent;
              data = _ref.data;


              if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data || {}).length) {
                _this.openModal(['GeneralModal', {
                  changes: data,
                  embed: __WEBPACK_IMPORTED_MODULE_6__components_parts_UpdateAddress___default.a
                }]);
              }

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    add: {
      default: false
    },
    orderNumber: {
      default: ''
    },
    dateStart: {
      default: null
    },
    dateEnd: {
      default: null
    },
    orderNumberNumeric: {
      default: 0
    },
    helperPool: {
      default: ''
    },
    helperUnit: {
      default: ''
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['closeModal']), {
    goTo: function goTo(path, url, skipAdd) {
      if (this.add && !skipAdd) {
        this.$store.state.cart.addToOrder = {
          number: this.orderNumber,
          numeric: this.orderNumberNumeric,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          helperPool: this.helperPool,
          helperUnit: this.helperUnit
        };
      } else if (!this.$store.state.cart.addToOrder || !this.$store.state.cart.addToOrder.number) {
        this.$store.state.cart.addToOrder = {};
      }
      this.closeModal();
      if (path) {
        this.$router.push({ path: path });
      } else {
        window.location.href = url;
      }
    },
    show: function show(what) {
      if (this.isSummer()) {
        if (what === 'accomodation') {
          return true;
        }

        return false;
      }
      var accomodations = this.$store.state.cart.accomodations;
      var currentWinter = true;

      if (accomodations.length) {
        var arrival = accomodations[0].period.date_arrival;
        var winterDates = this.SITE_CONFIG.season.winter;

        currentWinter = false;

        if (arrival >= winterDates.start && arrival <= winterDates.end) {
          currentWinter = true;
        }
      }

      if (!currentWinter) {
        if (what === 'accomodation') {
          return true;
        }
        return false;
      }

      if (what === 'keycard') {
        return true;
      }

      if (what === 'skipass') {
        if (this.add) {
          return true;
        }
        return this.SITE_CONFIG.skipass.buy_enabled || this.SITE_CONFIG.skipass.buy_enabled_when_accomodation_or_rental && (this.has('accomodations', true) || this.has('rentals', true));
      }

      if (!this.SITE_CONFIG.modules[what]) {
        return false;
      }

      if (!this.SITE_CONFIG.is_open) {
        return false;
      }

      if (!this.SITE_CONFIG.modules_open[what].open) {
        return false;
      }

      return true;
    },
    has: function has(what, confirmed) {
      var checkWhat = what;

      if (what === 'bikeschools') {
        checkWhat = 'skischools';
      }

      if (this.add) {
        return false;
      }
      if (!this.$store.state.cart[checkWhat]) {
        return false;
      }
      return this.$store.state.cart[checkWhat].filter(function (a) {
        return confirmed ? a.confirmed : true;
      }).length;
    },
    isSummer: function isSummer() {
      var accomodations = this.$store.state.cart.accomodations;
      var skischools = this.$store.state.cart.skischools;
      var summerDates = this.SITE_CONFIG.season.summer;
      var arrival = '';

      if (accomodations.length) {
        arrival = accomodations[0].period.date_arrival;

        if (arrival >= summerDates.start && arrival <= summerDates.end) {
          return true;
        }
      }

      if (skischools.length) {
        arrival = skischools[0].date;

        if (arrival >= summerDates.start && arrival <= summerDates.end) {
          return true;
        }
      }

      return false;
    }
  })
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_API__ = __webpack_require__(4);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showTexts: {
      default: true
    },
    doRedirect: {
      default: true
    },
    method: {
      default: ''
    },
    hash: {
      default: ''
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a
  },
  data: function data() {
    return {
      interval: null,
      code: null,
      order: null,
      redirect: null,
      status: 0,
      done: 0,
      errorCode: 0,
      codes: [],
      errorMessage: '',
      errorMessages: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var cart, url, _ref, data, redirect, success, message, errors, doLogout;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.code = Math.random().toString(36).substring(2);

              cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.$store.state.cart);

              cart.code = _this.code;
              cart.chip_hash = _this.hash;
              cart.key = _this.$store.state.onsite_key || '';
              cart.lockingCode = _this.$store.state.lockingCode || '';

              cart.country = localStorage.getItem('country');
              cart.language = localStorage.getItem('language');

              url = '/payments/create-order';

              if (_this.$store.state.isOnSite) {
                url = url + '?on-site=1&refresh=1';
              }

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].post(url, cart);

            case 12:
              _ref = _context.sent;
              data = _ref.data;
              redirect = _ref.redirect;
              success = _ref.success;
              message = _ref.message;
              errors = _ref.errors;
              doLogout = _ref.doLogout;

              _this.order = data;

              _this.redirect = redirect;

              if (success) {
                _context.next = 27;
                break;
              }

              _this.errorMessage = message;
              _this.errorMessages = errors;
              _this.error(message || _this.SITE_CONFIG.closed_message || _this.$i18n.t('general.closed-backup'));

              if (doLogout) {
                _this.setUser({
                  token: null
                });

                _this.$emit('logout', true);

                document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: false }));
              }

              return _context.abrupt('return');

            case 27:

              _this.interval = setTimeout(_this.reloadStatus, 3000);

            case 28:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  destroyed: function destroyed() {
    clearTimeout(this.interval);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['loggedIn']), {
    percentage: function percentage() {
      if (!this.done) {
        return 0;
      }
      var percentage = Math.round(this.done / this.status * 100) - 10;
      return Math.max(percentage, 0);
    },
    nonsense: function nonsense() {
      return this.done;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeModal', 'saveCartLocking', 'setUser', 'updateResetPasswordSuccessMessage']), {
    reloadStatus: function reloadStatus() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__classes_API__["a" /* default */].get('/payments/order-creating-status?code=' + this.code).then(function (response) {
        if (_this2.done !== response.done) {
          var evt = document.createEvent('CustomEvent');
          evt.initCustomEvent('syncing', true, true, { data: true });
          document.dispatchEvent(evt);
        }

        _this2.status = response.data;
        _this2.done = response.done;

        if (response.error) {
          _this2.error(response.error);
          _this2.codes = response.codes;
          return;
        }

        if (_this2.status === _this2.done && response.order) {
          _this2.success(response.order_number);
          return;
        }

        _this2.interval = setTimeout(_this2.reloadStatus, 3000);
      });
    },
    success: function success(orderNumber) {
      this.$emit('callback', orderNumber);

      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('syncsuccess', true, true, { data: true });
      document.dispatchEvent(evt);

      if (this.doRedirect) {
        this.$router.push({ name: this.redirect,
          query: { order: this.order.id, code: this.order.code } });
      }
    },
    error: function error(_error) {
      this.$emit('callback', false);

      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('syncerror', true, true, { data: true });
      document.dispatchEvent(evt);

      this.errorCode = _error;
    },
    localCloseModal: function localCloseModal() {}
  })
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_restrictions__ = __webpack_require__(117);

















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    startView: {},
    season: {
      default: 'winter'
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    SwitchButton: __WEBPACK_IMPORTED_MODULE_6__components_components_SwitchButton___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_8__components_components_Checkbox___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_7__components_components_Dropdown___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_restrictions__["a" /* default */]],
  data: function data() {
    return {
      dates: []
    };
  },

  computed: {
    showFilter: function showFilter() {
      if (this.season === 'summer') {
        return false;
      }
      return this.SITE_CONFIG.modules_open.school.open;
    },
    showlevels: function showlevels() {
      if (this.showLevel('yellow').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('green').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('blue').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('red').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (this.showLevel('black').indexOf(this.currentAge) !== -1) {
        return true;
      }
      if (!this.currentAge) {
        return true;
      }
      return false;
    },
    showyellow: function showyellow() {
      return false;
    },
    showgreen: function showgreen() {
      return ['4-4', '4-5', '5-6', '6-9', '7-9', '7-10', '7-15', '10-12', '10-14', '11-15', '13-99', '14-99', '16-99'];
    },
    showblue: function showblue() {
      return ['4-4', '5-6', '7-9', '7-10', '7-15', '10-14', '11-15', '15-99', '16-99'];
    },
    showred: function showred() {
      return ['5-6', '7-9', '7-10', '7-15', '10-14', '11-15', '14-99', '15-99', '16-99'];
    },
    showblack: function showblack() {
      return ['7-9', '7-10', '10-14', '11-15'];
    },
    currentAge: function currentAge() {
      for (var i in this.SITE_CONFIG.skischool.ages) {
        if (this.$store.state.skiSchoolFilter[this.SITE_CONFIG.skischool.ages[i][1]]) {
          return this.SITE_CONFIG.skischool.ages[i][1];
        }
      }

      return '';
    },
    options: function options() {
      var _this = this;

      var options = [];

      if (!this.SITE_CONFIG.skischool.types.group) {
        return options;
      }

      this.SITE_CONFIG.skischool.ages.forEach(function (age) {
        var title = age[0].replace('år', _this.$i18n.t('general.years'));

        options.push({
          title: title,
          key: age[1]
        });
      });

      return options;
    },
    levels: function levels() {
      var levels = [];

      if (!this.SITE_CONFIG.skischool.types.group) {
        return levels;
      }

      for (var i in this.SITE_CONFIG.skischool.levels) {
        var title = this.SITE_CONFIG.skischool.levels[i].replace('Nivå', this.$i18n.t('general.level'));

        levels.push({
          title: title,
          key: i
        });
      }

      return levels;
    },
    types: function types() {
      var types = [];

      if (this.SITE_CONFIG.skischool.types.group) {
        types.push({
          title: this.$i18n.t('skischool.type.group'),
          key: 'group'
        });
      }
      if (this.SITE_CONFIG.skischool.types.private) {
        types.push({
          title: this.$i18n.t('skischool.type.private'),
          key: 'private'
        });
      }
      if (this.SITE_CONFIG.skischool.types.snowboard) {
        types.push({
          title: this.$i18n.t('skischool.type.snowboard'),
          key: 'snowboard'
        });
      }

      return types;
    }
  },
  watch: {
    $route: function $route() {
      if (!this.$route.query.type) {
        this.changeType('group');
      } else {
        this.load();
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this2.$route.query.type) {
                _context.next = 4;
                break;
              }

              _this2.changeType('group');
              _context.next = 6;
              break;

            case 4:
              _context.next = 6;
              return _this2.load();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal', 'toggleSkiSchoolFilterSwitch', 'toggleSkiSchoolFilterAgeSwitch', 'toggleSkiSchoolSubFilter']), {
    load: function load() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__classes_API__["a" /* default */].get('skischool/dates?cat=' + _this3.$route.query.type + '&btype=' + _this3.season);

              case 2:
                _ref = _context2.sent;
                data = _ref.data;

                _this3.dates = data;
                _this3.restrictDates();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    restrictDates: function restrictDates() {
      this.dates = this.getDatesWithAccommodationRestrictions(this.dates);
    },
    showLevel: function showLevel(level) {
      var key = 'show' + level;
      if (this[key]) {
        return this[key];
      }

      return [];
    },
    openInfo: function openInfo() {
      this.openModal(['SkiSchoolInfo', {}]);
    },
    toggleFilter: function toggleFilter(key) {
      var date = this.$store.state.skiSchoolFilter.date;
      console.log(this.$store.state.skiSchoolFilter.date);
      this.toggleSkiSchoolFilterSwitch({
        key: key,
        value: !this.$store.state.skiSchoolFilter[key]
      });
      this.$store.state.skiSchoolFilter.date = date;
      this.$emit('change');
    },
    openDateModal: function openDateModal() {
      var _this4 = this;

      var $this = this;
      this.openModal(['DatepickerRangeModal', {
        validDates: this.dates,
        pickedStartDate: this.$store.state.skiSchoolFilter.date,
        pickedEndDate: null,
        onClose: function onClose(a) {
          $this.$store.state.skiSchoolFilter.date = a;
          $this.$emit('change');
        },
        startDateOnly: true,
        disableRange: true,
        info: this.$i18n.t('skischool.pick-startdate'),
        terminology: this.$i18n.t('general.pick-startdate'),
        open: this.SITE_CONFIG.modules_open.school.open,
        closed_message: this.SITE_CONFIG.modules_open.school.closed_message,
        extraInfo: function extraInfo() {
          var accommodationDateRange = _this4.getAccommodationDateRange();
          if (accommodationDateRange !== false) {
            return ['Endast tillg\xE4ngliga datum inom ditt bokningsintervall (' + accommodationDateRange.start.format('D MMMM') + ' - ' + accommodationDateRange.end.format('D MMMM') + ') visas.'];
          }

          return [];
        }
      }]);
    },
    dateClear: function dateClear() {
      this.$store.state.skiSchoolFilter.date = null;
      this.$emit('change');
    },
    moment: function moment(a) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(a);
    },
    changeType: function changeType(type) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var route;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                route = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this5.$route);

                route.query.type = type;

                _this5.$router.replace({
                  path: _this5.$route.path,
                  query: { type: type, c: type }
                });

                _this5.toggleFilter('reset');

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    }
  })
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_Filter_FilterListItem__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_Filter_FilterListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_Filter_FilterListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    unitCount: {},
    count: {
      default: 0
    }
  },
  components: {
    FilterListItem: __WEBPACK_IMPORTED_MODULE_2__components_parts_Accomodation_List_Filter_FilterListItem___default.a
  },
  computed: {
    activeFilters: function activeFilters() {
      var filters = {};

      for (var i in this.SITE_CONFIG.skischool.ages) {
        if (this.$store.state.skiSchoolFilter[this.SITE_CONFIG.skischool.ages[i][1]]) {
          filters[this.SITE_CONFIG.skischool.ages[i][1]] = this.SITE_CONFIG.skischool.ages[i][0];
        }
      }
      for (var i in this.SITE_CONFIG.skischool.levels) {
        if (this.$store.state.skiSchoolFilter[i]) {
          filters[i] = this.SITE_CONFIG.skischool.levels[i];
        }
      }


      if (this.$store.state.skiSchoolFilter.date) {
        filters.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.$store.state.skiSchoolFilter.date).format('D/M');
      }

      return filters;
    },
    activeFiltersCount: function activeFiltersCount() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_fp__["size"])(this.activeFilters);
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['resetSkiSchoolFilter']), {
    emit: function emit() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('change');
      });
    },
    reset: function reset() {
      var $this = this;
      $this.$refs.resetButton.className = 'reset-button animation';
      $this.resetSkiSchoolFilter();
      this.emit();
      setTimeout(function () {
        $this.$refs.resetButton.className = 'reset-button';
      }, 1000);
    }
  })
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_SkiSchool_SkiSchoolListPool__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_SkiSchool_SkiSchoolListPool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_parts_SkiSchool_SkiSchoolListPool__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    data: {
      default: []
    },
    count: {
      default: 1
    }
  },
  components: {
    SkiSchoolListPool: __WEBPACK_IMPORTED_MODULE_1__components_parts_SkiSchool_SkiSchoolListPool___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    isPrivate: function isPrivate(schools) {
      if (!schools) return false;
      var first = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(schools).map(function (k) {
        return schools[k];
      })[0];
      return !!(first && first.info && first.info.is_private);
    },
    isSnowboard: function isSnowboard(schools) {
      if (!schools) return false;
      var first = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(schools).map(function (k) {
        return schools[k];
      })[0];
      return !!(first && first.info && first.info.is_snowboard);
    },
    openBooking: function openBooking() {}
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_SkiSchool_SkiSchoolListUnitsList__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_SkiSchool_SkiSchoolListUnitsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_parts_SkiSchool_SkiSchoolListUnitsList__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['level'],
  components: {
    SkiSchoolListUnitsList: __WEBPACK_IMPORTED_MODULE_2__components_parts_SkiSchool_SkiSchoolListUnitsList___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['openModal']), {
    expand: function expand() {
      this.$refs.unitList.isManuallyExpanded = !this.$refs.unitList.isManuallyExpanded;
    },
    openVideo: function openVideo() {
      this.openModal(['MovieModal', {
        url: this.level.info.video
      }]);
    }
  })
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['courses', 'info'],
  components: {},
  data: function data() {
    return {
      isManuallyExpanded: false
    };
  },
  mounted: function mounted() {},

  computed: {
    expanded: function expanded() {
      return this.isManuallyExpanded;
    },
    showWhichDays: function showWhichDays() {
      return false;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['openModal']), {
    moment: function moment(d) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(d);
    },
    openInfo: function openInfo(course) {
      window.CURRENT_ACTIVITY_ID = course.id;
      this.openModal(['SkiSchoolBooking', {
        pool: course.pool_lid,
        presenterGroup: course.presenter_group
      }]);
    }
  })
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Collapsable__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_components_Collapsable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_components_Collapsable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Skipass_Page__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Skipass_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_parts_Skipass_Page__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Collapsable: __WEBPACK_IMPORTED_MODULE_2__components_components_Collapsable___default.a,
    Page: __WEBPACK_IMPORTED_MODULE_3__components_parts_Skipass_Page___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['guidedPasses'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['openModal']), {
    open: function open() {
      this.openModal(['SkiPassPickDate']);
    }
  })
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    config: {}
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['closeAllModals']), {
    update: function update() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var details, i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                details = {};

                _this.loading = true;

                console.log(_this.config.changes);
                for (i in _this.config.changes) {
                  details[i] = _this.config.changes[i].to;
                }
                console.log(details);
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].post('/account/update', details);

              case 7:

                _this.loading = false;

                _this.close();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    close: function close() {
      this.closeAllModals();
    },
    goToMyPages: function goToMyPages() {
      this.$router.push({
        name: 'my pages details'
      });
      this.closeAllModals();
    }
  }),
  data: function data() {
    return {
      changes: [],
      loading: false
    };
  },

  computed: {
    hasChanges: function hasChanges() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.config.changes).length;
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_payments_Login__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_payments_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_payments_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_API__ = __webpack_require__(4);













var _CODE_STATE = {
  NOT_TRIED: 0,
  CHECKING: 1,
  INVALID: 2,
  VALID: 3,
  REMOVING: 4
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    params: {}
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_components_Modal___default.a,
    Login: __WEBPACK_IMPORTED_MODULE_6__components_payments_Login___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default.a
  },
  data: function data() {
    return {
      code: '',
      isValid: _CODE_STATE.NOT_TRIED,
      errorMessage: '',
      requiresExtraInput: true,
      requiresExtraInputMessage: '',
      extraInput: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.code = _this.$store.state.cart.pincode || _this.$store.state.cart.campaignCode;

              _context.next = 3;
              return _this.reapply();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['loggedIn']), {
    cssStateClasses: function cssStateClasses() {
      return ' ' + (this.isValid === _CODE_STATE.NOT_TRIED ? ' ' : '') + (this.isValid === _CODE_STATE.CHECKING ? ' disabled' : '') + (this.isValid === _CODE_STATE.INVALID ? ' invalid' : '') + (this.isValid === _CODE_STATE.VALID ? ' valid' : '') + (this.isValid === _CODE_STATE.REMOVING ? ' disabled' : '');
    },
    CODE_STATE: function CODE_STATE() {
      return _CODE_STATE;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['updateCampaignCode', 'updateCampaignCodeExtraInfo']), {
    fetchCodeAndUpdateCart: function fetchCodeAndUpdateCart(lCode) {
      var _this2 = this;

      var forceEmptyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var endpoint, data, success, message, campaign_code, requires_extra_input, requires_extra_input_message, _ref, accomodationPrices, addonPrices, skipassPrices, rentalPrices, localCart, rentalProductTypes, i, poolLid, unitLid, combinedId, _i, _poolLid, _i2, _poolLid2, _i3, age, days, iTyp, typ, ii, _poolLid3, _localCart;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.errorMessage = '';
                _this2.loading = true;

                endpoint = forceEmptyCode ? 'remove-campaign-code' : 'apply-campaign-code';
                data = void 0;
                success = void 0;
                message = void 0;
                campaign_code = void 0;
                requires_extra_input = void 0;
                requires_extra_input_message = void 0;
                _context2.prev = 9;
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_8__classes_API__["a" /* default */].frontendHelper(endpoint, {
                  cart: _this2.$store.state.cart,
                  code: lCode
                });

              case 12:
                _ref = _context2.sent;
                data = _ref.data;
                success = _ref.success;
                message = _ref.message;
                campaign_code = _ref.campaign_code;
                requires_extra_input = _ref.requires_extra_input;
                requires_extra_input_message = _ref.requires_extra_input_message;
                _context2.next = 26;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2['catch'](9);

                _this2.errorMessage = 'Vi kunde inte kontrollera koden just nu. Försök igen eller kontakta gästservice.';
                _this2.isValid = _CODE_STATE.NOT_TRIED;
                return _context2.abrupt('return');

              case 26:

                _this2.loading = false;
                _this2.requiresExtraInput = requires_extra_input;
                _this2.requiresExtraInputMessage = requires_extra_input_message;

                if (success) {
                  accomodationPrices = data.accomodations;
                  addonPrices = data.addons;
                  skipassPrices = data.skipasses;
                  rentalPrices = data.rentals;
                  localCart = _this2.$store.state.cart;
                  rentalProductTypes = ['products', 'addons'];

                  for (i in localCart.accomodations) {
                    poolLid = localCart.accomodations[i].poolLid;
                    unitLid = localCart.accomodations[i].unitLid;
                    combinedId = poolLid + '.' + unitLid;


                    localCart.accomodations[i].discountedPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(accomodationPrices[combinedId]) ? accomodationPrices[combinedId] : null;
                  }

                  for (_i in localCart.addons) {
                    _poolLid = localCart.addons[_i].lid;


                    localCart.addons[_i].discountedPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(addonPrices[_poolLid]) ? addonPrices[_poolLid] : null;
                  }

                  for (_i2 in localCart.skipasses) {
                    _poolLid2 = localCart.skipasses[_i2].poolLid;


                    if (localCart.skipasses[_i2].type && localCart.skipasses[_i2].type === 'SKIPASS-ACCO') {
                      localCart.skipasses[_i2].discountedPrices = skipassPrices || {};
                    } else {
                      localCart.skipasses[_i2].discountedPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(skipassPrices[_poolLid2]) ? skipassPrices[_poolLid2] : null;
                    }
                  }

                  for (_i3 in localCart.rentals) {
                    age = localCart.rentals[_i3].age;
                    days = localCart.rentals[_i3].days;

                    for (iTyp in rentalProductTypes) {
                      typ = rentalProductTypes[iTyp];

                      for (ii in localCart.rentals[_i3][typ]) {
                        _poolLid3 = localCart.rentals[_i3][typ][ii].pool_lid;


                        localCart.rentals[_i3][typ][ii].discountedPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(rentalPrices[_poolLid3 + '.' + age + '.' + days]) ? rentalPrices[_poolLid3 + '.' + age + '.' + days] : null;

                        if (forceEmptyCode) {
                          localCart.rentals[_i3][typ][ii].discountedPrice = null;
                        }
                      }
                    }
                  }


                  console.log(localCart.skipasses);

                  localCart.campaignCode = _this2.code;
                  localCart.pincode = '';

                  if (typeof campaign_code === 'undefined' || !campaign_code) {
                    localCart.pincode = _this2.code;
                    localCart.campaignCode = '';
                  }

                  _this2.isValid = _CODE_STATE.VALID;

                  _this2.errorMessage = '';

                  if (forceEmptyCode) {
                    _this2.isValid = _CODE_STATE.NOT_TRIED;
                    _this2.code = '';
                    _this2.updateCampaignCode({
                      pincode: '',
                      campaignCode: '',
                      codeRequiresExtraInfo: false,
                      codeExtraInfo: '',
                      skipasses: localCart.skipasses,
                      rentals: localCart.rentals,
                      accomodations: localCart.accomodations,
                      addons: localCart.addons
                    });
                  } else {
                    _this2.updateCampaignCode({
                      pincode: localCart.pincode,
                      campaignCode: localCart.campaignCode,
                      codeRequiresExtraInfo: _this2.requiresExtraInput,
                      codeExtraInfo: '',
                      skipasses: localCart.skipasses,
                      rentals: localCart.rentals,
                      accomodations: localCart.accomodations,
                      addons: localCart.addons
                    });
                  }
                } else {
                  _localCart = _this2.$store.state.cart;


                  _this2.isValid = _CODE_STATE.INVALID;
                  _this2.errorMessage = message;

                  _this2.updateCampaignCode({
                    pincode: '',
                    campaignCode: '',
                    codeRequiresExtraInfo: false,
                    codeExtraInfo: '',
                    skipasses: _localCart.skipasses,
                    rentals: _localCart.rentals,
                    accomodations: _localCart.accomodations,
                    addons: _localCart.addons
                  });

                  if (forceEmptyCode) {
                    _this2.isValid = _CODE_STATE.VALID;

                    _this2.updateCampaignCode({
                      pincode: '',
                      campaignCode: '',
                      codeRequiresExtraInfo: false,
                      codeExtraInfo: '',
                      skipasses: _localCart.skipasses,
                      rentals: _localCart.rentals,
                      accomodations: _localCart.accomodations,
                      addons: _localCart.addons
                    });
                  }
                }

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[9, 21]]);
      }))();
    },
    updateExtraInfo: function updateExtraInfo() {
      this.updateCampaignCodeExtraInfo({
        codeExtraInfo: this.extraInput
      });
    },
    tryCode: function tryCode() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isValid = _CODE_STATE.CHECKING;
                _this3.code = (_this3.code || '').toUpperCase();

                _context3.next = 4;
                return _this3.fetchCodeAndUpdateCart(_this3.code, false);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    removeCode: function removeCode() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isValid = _CODE_STATE.REMOVING;

                _context4.next = 3;
                return _this4.fetchCodeAndUpdateCart('', true);

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    reapply: function reapply() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this5.code) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return _this5.tryCode();

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  })
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    initialPublicToken: null
  },
  data: function data() {
    return {
      publicToken: this.initialPublicToken
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicToken, src, s, _ref, data, orderId, ga;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.publicToken) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/payments/checkout-session', {
                order: _this.$route.query.order,
                code: _this.$route.query.code
              });

            case 3:
              _this.publicToken = _context.sent.publicToken;

            case 4:
              _context.t0 = _this.publicToken;

              if (_context.t0) {
                _context.next = 9;
                break;
              }

              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/payments/checkout-session', {
                order: _this.$route.query.order,
                code: _this.$route.query.code
              });

            case 8:
              _context.t0 = _context.sent.publicToken;

            case 9:
              publicToken = _context.t0;

              if (_this.publicToken) {
                src = _this.SITE_CONFIG.collector.browser_api_url.replace(/\/$/, '') + '/collector-checkout-loader.js';
                s = document.createElement('script');

                s.setAttribute('src', src);
                s.setAttribute('data-token', publicToken);
                s.setAttribute('data-version', 'v2');
                _this.$refs.code.appendChild(s);
                document.addEventListener('collectorCheckoutPurchaseCompleted', _this.handleCollectorCheckoutPurchaseCompleted);
              }

              _context.next = 13;
              return __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].get('/cart/get-for-pixel?checkout_session_id=' + _this.publicToken);

            case 13:
              _ref = _context.sent;
              data = _ref.data;
              orderId = _ref.orderId;
              ga = _ref.ga;


              console.log('Should start checkout GA');
              console.log(orderId);
              console.log(ga);
              window.trackBeginCheckout(ga, orderId, data.value);

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  unmounted: function unmounted() {
    document.removeEventListener('collectorCheckoutPurchaseCompleted', this.handleCollectorCheckoutPurchaseCompleted);
  },

  methods: {
    handleCollectorCheckoutPurchaseCompleted: function handleCollectorCheckoutPurchaseCompleted(event) {
      this.$emit('purchase-completed', {
        checkout_session_id: this.publicToken
      });
      console.log('collectorCheckoutPurchaseCompleted');
      console.log(event);
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_payments_CollectorCheckout__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_payments_CollectorCheckout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_payments_CollectorCheckout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_components_Loading__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {
    CheckUpdateAddress: __WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress___default.a,
    CollectorCheckout: __WEBPACK_IMPORTED_MODULE_7__components_payments_CollectorCheckout___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_8__components_components_Loading___default.a
  },
  data: function data() {
    return {
      snippet: null,
      signedin: false,
      error: false,
      wasSignedIn: false
    };
  },

  computed: {
    publicToken: function publicToken() {
      return this.$route.query.checkout_session_id;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var cart, _ref, data, orderId, ga, customer;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.$store.state.cart);

              _this.clearCart();

              if (!_this.$store.state.user.token) {} else {
                _this.signedin = true;
                _this.wasSignedIn = true;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/cart/get-for-pixel?checkout_session_id=' + _this.$route.query.checkout_session_id);

            case 5:
              _ref = _context.sent;
              data = _ref.data;
              orderId = _ref.orderId;
              ga = _ref.ga;
              customer = _ref.customer;


              console.log('Should start transaction');
              console.log(orderId);
              console.log(cart);
              console.log(data.value);
              window.trackPurchase(ga, orderId, data.value, customer);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal']), {
    signin: function signin() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, token, error;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/account/signin-from-order?checkout_session_id=' + _this2.$route.query.checkout_session_id);

              case 2:
                _ref2 = _context2.sent;
                token = _ref2.token;
                error = _ref2.error;


                if (token) {
                  _this2.signedin = true;
                  _this2.setUser({
                    token: token
                  });

                  document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));
                } else if (!error) {
                  _this2.signedin = false;
                  setTimeout(_this2.signin, 3000);
                } else {
                  _this2.error = error;
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    myPage: function myPage() {
      this.$router.push({
        name: 'my pages journey'
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['clearCart', 'setUser']))
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_API__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {},
  data: function data() {
    return {
      snippet: null,
      loaded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, src, s;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = encodeURIComponent(window.location.protocol + '//' + window.location.host);
              src = __WEBPACK_IMPORTED_MODULE_2__classes_API__["a" /* default */].getUrl('/payments/klarna-checkout?script-only=1&order=' + _this.$route.query.order + '&url=' + url);
              s = document.createElement('script');


              _this.createCookie('token', 'test', 1);

              s.setAttribute('src', src);
              _this.$refs.klarnaCode.appendChild(s);
              _this.loaded = true;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    createCookie: function createCookie(name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        var dateToString = date.toUTCString();
        expires = '; expires=' + dateToString;
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_API__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_components_Loading__);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {
    CheckUpdateAddress: __WEBPACK_IMPORTED_MODULE_6__components_parts_CheckUpdateAddress___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_components_Loading___default.a
  },
  data: function data() {
    return {
      snippet: null,
      loaded: false,
      signedin: false,
      error: false,
      wasSignedIn: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var cart, src, s, _ref, data, orderId, ga, customer;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.$store.state.cart);

              _this.clearCart();

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].getUrl('/payments/klarna-confirmation?checkout_session_id=' + _this.$route.query.checkout_session_id + '&script-only=1');

            case 4:
              src = _context.sent;
              s = document.createElement('script');

              s.setAttribute('src', src + '&token=' + _this.$store.state.user.token);
              _this.$refs.klarnaCode.appendChild(s);
              _this.loaded = true;

              if (!_this.$store.state.user.token) {
                _this.signin();
              } else {
                _this.signedin = true;
                _this.wasSignedIn = true;
              }

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/cart/get-for-pixel?checkout_session_id=' + _this.$route.query.checkout_session_id);

            case 12:
              _ref = _context.sent;
              data = _ref.data;
              orderId = _ref.orderId;
              ga = _ref.ga;
              customer = _ref.customer;


              console.log('Should start transaction');
              console.log(orderId);
              console.log(cart);
              console.log(data.value);
              window.trackPurchase(ga, orderId, data.value, customer);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['openModal']), {
    signin: function signin() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, token, error;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__classes_API__["a" /* default */].get('/account/signin-from-order?checkout_session_id=' + _this2.$route.query.checkout_session_id);

              case 2:
                _ref2 = _context2.sent;
                token = _ref2.token;
                error = _ref2.error;


                if (token) {
                  _this2.signedin = true;
                  _this2.setUser({
                    token: token
                  });

                  document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));
                } else if (!error) {
                  _this2.signedin = false;
                  setTimeout(_this2.signin, 3000);
                } else {
                  _this2.error = error;
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    myPage: function myPage() {
      this.$router.push({
        name: 'my pages journey'
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(['clearCart', 'setUser']))
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {},
  data: function data() {
    return {
      email: '',
      password: '',
      passwordShow: true,
      loading: false,
      error: false,
      localResetPasswordSuccessMessage: ''
    };
  },
  mounted: function mounted() {
    this.localResetPasswordSuccessMessage = this.resetPasswordSuccessMessage;
    console.log(this.localResetPasswordSuccessMessage);
    this.updateResetPasswordSuccessMessage('');
  },
  updated: function updated() {
    this.updateResetPasswordSuccessMessage('');
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['loggedIn', 'resetPasswordSuccessMessage']), {
    adminUser: function adminUser() {
      return localStorage.getItem('admin_user');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['setUser', 'updateResetPasswordSuccessMessage']), {
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, success, token, user, isAdmin;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/account/authenticate', {
                  email: _this.email,
                  password: _this.password
                });

              case 4:
                _ref = _context.sent;
                success = _ref.success;
                token = _ref.token;
                user = _ref.user;
                isAdmin = _ref.isAdmin;


                if (success) {
                  _this.$store.state.user = user;
                  _this.$store.state.user.isAdmin = isAdmin;
                  _this.$store.state.user.token = token;

                  _this.setUser({
                    token: token
                  });

                  _this.$emit('login', success);

                  document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));
                } else {
                  _this.error = true;
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](1);

                _this.error = true;

              case 15:
                _context.prev = 15;

                _this.loading = false;
                return _context.finish(15);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 12, 15, 18]]);
      }))();
    },
    loginAdmin: function loginAdmin() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, success;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].post('/account/authenticate-admin', {
                  email: _this2.email,
                  password: _this2.password
                });

              case 4:
                _ref2 = _context2.sent;
                success = _ref2.success;


                if (success) {
                  localStorage.setItem('admin_user', _this2.email + ':' + _this2.password);
                  _this2.$emit('login', success);
                } else {
                  _this2.error = true;
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this2.error = true;

              case 12:
                _context2.prev = 12;

                _this2.loading = false;
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9, 12, 15]]);
      }))();
    },
    logout: function logout() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var success;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/account/deauthenticate');

              case 3:
                success = _context3.sent;

                _this3.setUser({
                  token: null
                });
                if (success) {
                  _this3.$emit('logout', success);

                  document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: false }));
                }
                _this3.loading = false;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    logoutAdmin: function logoutAdmin() {
      this.loading = true;
      localStorage.setItem('admin_user', '');
      this.$emit('logout', true);
      this.loading = false;
    },
    goToAdmin: function goToAdmin() {
      this.$router.push('/admin');
    }
  })
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_API__ = __webpack_require__(4);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},
  components: {},
  data: function data() {
    return {
      snippet: null,
      loaded: false,
      signedin: false,
      error: false,
      timeoutReference: null
    };
  },
  created: function created() {
    this.timeoutReference = setInterval(this.checkForCancellation, 1 * 60 * 1000);
    this.checkForCancellation();
  },
  destroyed: function destroyed() {
    clearInterval(this.timeoutReference);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    checkForCancellation: function checkForCancellation() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var orderId, klarnaId, _ref, cancelled;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('Checking for cancellation...');
                orderId = _this.$route.query.order || 0;
                klarnaId = _this.$route.query.checkout_session_id || '';

                if (!klarnaId) {
                  klarnaId = window.__KLARNA_CURRENT_ORDER_ID || '';
                }
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__classes_API__["a" /* default */].get('/orders/check-for-system-cancellation/' + orderId + '?checkout_session_id=' + klarnaId);

              case 6:
                _ref = _context.sent;
                cancelled = _ref.cancelled;


                if (cancelled) {
                  clearInterval(_this.timeoutReference);
                  _this.openModal(['BookingCancelled']);
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['openModal', 'clearCart', 'setUser']))
});

/***/ }),
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */
/***/ (function(module, exports) {

module.exports = {"version":"2019c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 751 */,
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 141,
	"./af.js": 141,
	"./ar": 148,
	"./ar-dz": 142,
	"./ar-dz.js": 142,
	"./ar-kw": 143,
	"./ar-kw.js": 143,
	"./ar-ly": 144,
	"./ar-ly.js": 144,
	"./ar-ma": 145,
	"./ar-ma.js": 145,
	"./ar-sa": 146,
	"./ar-sa.js": 146,
	"./ar-tn": 147,
	"./ar-tn.js": 147,
	"./ar.js": 148,
	"./az": 149,
	"./az.js": 149,
	"./be": 150,
	"./be.js": 150,
	"./bg": 151,
	"./bg.js": 151,
	"./bm": 152,
	"./bm.js": 152,
	"./bn": 153,
	"./bn.js": 153,
	"./bo": 154,
	"./bo.js": 154,
	"./br": 155,
	"./br.js": 155,
	"./bs": 156,
	"./bs.js": 156,
	"./ca": 157,
	"./ca.js": 157,
	"./cs": 158,
	"./cs.js": 158,
	"./cv": 159,
	"./cv.js": 159,
	"./cy": 160,
	"./cy.js": 160,
	"./da": 161,
	"./da.js": 161,
	"./de": 164,
	"./de-at": 162,
	"./de-at.js": 162,
	"./de-ch": 163,
	"./de-ch.js": 163,
	"./de.js": 164,
	"./dv": 165,
	"./dv.js": 165,
	"./el": 166,
	"./el.js": 166,
	"./en-SG": 167,
	"./en-SG.js": 167,
	"./en-au": 168,
	"./en-au.js": 168,
	"./en-ca": 169,
	"./en-ca.js": 169,
	"./en-gb": 170,
	"./en-gb.js": 170,
	"./en-ie": 171,
	"./en-ie.js": 171,
	"./en-il": 172,
	"./en-il.js": 172,
	"./en-nz": 173,
	"./en-nz.js": 173,
	"./eo": 174,
	"./eo.js": 174,
	"./es": 177,
	"./es-do": 175,
	"./es-do.js": 175,
	"./es-us": 176,
	"./es-us.js": 176,
	"./es.js": 177,
	"./et": 178,
	"./et.js": 178,
	"./eu": 179,
	"./eu.js": 179,
	"./fa": 180,
	"./fa.js": 180,
	"./fi": 181,
	"./fi.js": 181,
	"./fo": 182,
	"./fo.js": 182,
	"./fr": 185,
	"./fr-ca": 183,
	"./fr-ca.js": 183,
	"./fr-ch": 184,
	"./fr-ch.js": 184,
	"./fr.js": 185,
	"./fy": 186,
	"./fy.js": 186,
	"./ga": 187,
	"./ga.js": 187,
	"./gd": 188,
	"./gd.js": 188,
	"./gl": 189,
	"./gl.js": 189,
	"./gom-latn": 190,
	"./gom-latn.js": 190,
	"./gu": 191,
	"./gu.js": 191,
	"./he": 192,
	"./he.js": 192,
	"./hi": 193,
	"./hi.js": 193,
	"./hr": 194,
	"./hr.js": 194,
	"./hu": 195,
	"./hu.js": 195,
	"./hy-am": 196,
	"./hy-am.js": 196,
	"./id": 197,
	"./id.js": 197,
	"./is": 198,
	"./is.js": 198,
	"./it": 200,
	"./it-ch": 199,
	"./it-ch.js": 199,
	"./it.js": 200,
	"./ja": 201,
	"./ja.js": 201,
	"./jv": 202,
	"./jv.js": 202,
	"./ka": 203,
	"./ka.js": 203,
	"./kk": 204,
	"./kk.js": 204,
	"./km": 205,
	"./km.js": 205,
	"./kn": 206,
	"./kn.js": 206,
	"./ko": 207,
	"./ko.js": 207,
	"./ku": 208,
	"./ku.js": 208,
	"./ky": 209,
	"./ky.js": 209,
	"./lb": 210,
	"./lb.js": 210,
	"./lo": 211,
	"./lo.js": 211,
	"./lt": 212,
	"./lt.js": 212,
	"./lv": 213,
	"./lv.js": 213,
	"./me": 214,
	"./me.js": 214,
	"./mi": 215,
	"./mi.js": 215,
	"./mk": 216,
	"./mk.js": 216,
	"./ml": 217,
	"./ml.js": 217,
	"./mn": 218,
	"./mn.js": 218,
	"./mr": 219,
	"./mr.js": 219,
	"./ms": 221,
	"./ms-my": 220,
	"./ms-my.js": 220,
	"./ms.js": 221,
	"./mt": 222,
	"./mt.js": 222,
	"./my": 223,
	"./my.js": 223,
	"./nb": 224,
	"./nb.js": 224,
	"./ne": 225,
	"./ne.js": 225,
	"./nl": 227,
	"./nl-be": 226,
	"./nl-be.js": 226,
	"./nl.js": 227,
	"./nn": 228,
	"./nn.js": 228,
	"./pa-in": 229,
	"./pa-in.js": 229,
	"./pl": 230,
	"./pl.js": 230,
	"./pt": 232,
	"./pt-br": 231,
	"./pt-br.js": 231,
	"./pt.js": 232,
	"./ro": 233,
	"./ro.js": 233,
	"./ru": 234,
	"./ru.js": 234,
	"./sd": 235,
	"./sd.js": 235,
	"./se": 236,
	"./se.js": 236,
	"./si": 237,
	"./si.js": 237,
	"./sk": 238,
	"./sk.js": 238,
	"./sl": 239,
	"./sl.js": 239,
	"./sq": 240,
	"./sq.js": 240,
	"./sr": 242,
	"./sr-cyrl": 241,
	"./sr-cyrl.js": 241,
	"./sr.js": 242,
	"./ss": 243,
	"./ss.js": 243,
	"./sv": 244,
	"./sv.js": 244,
	"./sw": 245,
	"./sw.js": 245,
	"./ta": 246,
	"./ta.js": 246,
	"./te": 247,
	"./te.js": 247,
	"./tet": 248,
	"./tet.js": 248,
	"./tg": 249,
	"./tg.js": 249,
	"./th": 250,
	"./th.js": 250,
	"./tl-ph": 251,
	"./tl-ph.js": 251,
	"./tlh": 252,
	"./tlh.js": 252,
	"./tr": 253,
	"./tr.js": 253,
	"./tzl": 254,
	"./tzl.js": 254,
	"./tzm": 256,
	"./tzm-latn": 255,
	"./tzm-latn.js": 255,
	"./tzm.js": 256,
	"./ug-cn": 257,
	"./ug-cn.js": 257,
	"./uk": 258,
	"./uk.js": 258,
	"./ur": 259,
	"./ur.js": 259,
	"./uz": 261,
	"./uz-latn": 260,
	"./uz-latn.js": 260,
	"./uz.js": 261,
	"./vi": 262,
	"./vi.js": 262,
	"./x-pseudo": 263,
	"./x-pseudo.js": 263,
	"./yo": 264,
	"./yo.js": 264,
	"./zh-cn": 265,
	"./zh-cn.js": 265,
	"./zh-hk": 266,
	"./zh-hk.js": 266,
	"./zh-tw": 267,
	"./zh-tw.js": 267
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;

/***/ }),
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(618)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(930),
  /* scopeId */
  "data-v-2c26f5c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(573)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(892),
  /* scopeId */
  "data-v-0a985d40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(900),
  /* scopeId */
  "data-v-0fcd0dc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  "data-v-6df925c1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(916),
  /* scopeId */
  "data-v-20734156",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  "data-v-5b512c79",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  "data-v-5b589f1d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(966),
  /* scopeId */
  "data-v-47557007",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(708)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  "data-v-b521bebe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)
__webpack_require__(577)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(895),
  /* scopeId */
  "data-v-0c2094a2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(908),
  /* scopeId */
  "data-v-18685b12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(621)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(933),
  /* scopeId */
  "data-v-2ef26802",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(690)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  "data-v-7802c2b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(913),
  /* scopeId */
  "data-v-1dcc39fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(567)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(886),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  "data-v-5722638b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(684)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  "data-v-70a6a688",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(739)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  "data-v-fb353b54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  "data-v-6b82a774",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(613)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(925),
  /* scopeId */
  "data-v-26c7ddc2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(723)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  "data-v-d4c9ae66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(703)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  "data-v-a6fb4a32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  "data-v-58e4c7dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(592)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(909),
  /* scopeId */
  "data-v-19943910",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(956),
  /* scopeId */
  "data-v-417ac41c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(907),
  /* scopeId */
  "data-v-17ec2a76",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(726)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  "data-v-d7376494",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(903),
  /* scopeId */
  "data-v-13b91c34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  "data-v-dfdea474",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(685)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  "data-v-70d96d52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(660)
__webpack_require__(661)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(970),
  /* scopeId */
  "data-v-4c847a1f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(731)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  "data-v-e69431f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(699)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  "data-v-9bb32af8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(964),
  /* scopeId */
  "data-v-45a14b7b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(695)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  "data-v-98b8db3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(741)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  "data-v-fefdd436",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(946),
  /* scopeId */
  "data-v-3abeccd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(718)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-c8aa54fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  "data-v-d9ed2156",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(583)
__webpack_require__(584)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(901),
  /* scopeId */
  "data-v-103f7a70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)
__webpack_require__(652)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(962),
  /* scopeId */
  "data-v-433108ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(883),
  /* scopeId */
  "data-v-00149406",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  "data-v-3dda231f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(570)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(889),
  /* scopeId */
  "data-v-0774b522",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)
__webpack_require__(679)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  "data-v-661b5616",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(696)
__webpack_require__(697)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  "data-v-9927ce20",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  "data-v-704fa42c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(732)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  "data-v-e7a4a576",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(606)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(921),
  /* scopeId */
  "data-v-2386a3b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  "data-v-5dc30a0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(706)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  "data-v-ac00dce0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(917),
  /* scopeId */
  "data-v-20a15552",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(952),
  /* scopeId */
  "data-v-3de42a08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  "data-v-60f68cac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(707)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  "data-v-ac8cde06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(910),
  /* scopeId */
  "data-v-1a423ec4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(701)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  "data-v-9eb38a80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(940),
  /* scopeId */
  "data-v-3259699a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(926),
  /* scopeId */
  "data-v-26ca5218",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(737)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  "data-v-f6408e16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(961),
  /* scopeId */
  "data-v-430d3e84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(934),
  /* scopeId */
  "data-v-2fdb0d55",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(709)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  "data-v-b5d85cd6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  "data-v-6b620a57",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  "data-v-e174130e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(923),
  /* scopeId */
  "data-v-25b28986",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(694)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  "data-v-91576fce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(969),
  /* scopeId */
  "data-v-49171e32",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(954),
  /* scopeId */
  "data-v-3fd09ece",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(936),
  /* scopeId */
  "data-v-3048d40f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(705)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  "data-v-ab494338",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(716)
__webpack_require__(715)
__webpack_require__(717)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  "data-v-c7d8566a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(911),
  /* scopeId */
  "data-v-1b2dde5f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(704)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-a8eb5b02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(566)
__webpack_require__(565)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(885),
  /* scopeId */
  "data-v-0411511a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(725)
__webpack_require__(724)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  "data-v-d64ef208",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(713)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  "data-v-bc588cd2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)
__webpack_require__(642)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(953),
  /* scopeId */
  "data-v-3fac6ed4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(963),
  /* scopeId */
  "data-v-446604c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(568)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(887),
  /* scopeId */
  "data-v-05fc0e97",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(720)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  "data-v-ca91c854",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  "data-v-658f278e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(931),
  /* scopeId */
  "data-v-2c5b6258",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(941),
  /* scopeId */
  "data-v-33eb4587",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(902),
  /* scopeId */
  "data-v-103faf18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  "data-v-4e8010ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(893),
  /* scopeId */
  "data-v-0ad815c7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(948),
  /* scopeId */
  "data-v-3b7281b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(955),
  /* scopeId */
  "data-v-40a0254e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(947),
  /* scopeId */
  "data-v-3b6b825a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(588)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(905),
  /* scopeId */
  "data-v-160bc780",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(904),
  /* scopeId */
  "data-v-13c90824",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  "data-v-5d109eab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(912),
  /* scopeId */
  "data-v-1d05b3e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(928),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(899),
  /* scopeId */
  "data-v-0d5a0b09",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(719)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  "data-v-ca6b52e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(945),
  /* scopeId */
  "data-v-3a123326",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(906),
  /* scopeId */
  "data-v-17cee0c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(665)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  "data-v-53217d59",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(949),
  /* scopeId */
  "data-v-3d57b682",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(692)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  "data-v-855b6f56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(710)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  "data-v-b770d922",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(722)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  "data-v-d38a43aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(965),
  /* scopeId */
  "data-v-4713d31f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(957),
  /* scopeId */
  "data-v-4180c938",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(617)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(929),
  /* scopeId */
  "data-v-2bd7d19c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(662)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(971),
  /* scopeId */
  "data-v-4d72bc6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(693)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  "data-v-90bd29f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(943),
  /* scopeId */
  "data-v-360db154",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(958),
  /* scopeId */
  "data-v-41819d43",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  "data-v-7210695b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(569)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(888),
  /* scopeId */
  "data-v-068ede17",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(938),
  /* scopeId */
  "data-v-322b2542",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  "data-v-64bff26d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(935),
  /* scopeId */
  "data-v-30370817",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(937),
  /* scopeId */
  "data-v-3091d445",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(884),
  /* scopeId */
  "data-v-0221c1be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(712)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-bbc432da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(620)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(932),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-blue-lift",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps,
      "theme": "light"
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.remount
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [(_vm.$route.params.person === '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-first-skier')))]) : _vm._e(), _vm._v(" "), (_vm.$route.params.person !== '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-skier-x', {
    number: parseInt(_vm.$route.params.person) + 1
  })))]) : _vm._e(), _vm._v(" "), (_vm.$route.query.onlyseason === '1') ? _c('h1', [_vm._v("Säsongskort")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: 'content'
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("Välj typ av liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "center skipass-age-wrapper"
  }, _vm._l((_vm.options), function(option) {
    return ((!_vm.selectedAge || _vm.selectedAge === option.value)) ? _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.selectedAge === option.value),
          'has-description': (option.subtitle)
      },
      on: {
        "click": function($event) {
          return _vm.setAge(option.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n            "), _c('span', [_vm._v(_vm._s(option.subtitle))])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    class: 'content center ' + (_vm.selectedAge ? '' : 'disabled')
  }, [(!_vm.$store.state.isOnSite) ? _c('div', [(_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', [_vm._v("Antal dagar / säsongskort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.day_online && !_vm.SITE_CONFIG.skipass.season_online) ? _c('h2', [_vm._v("Antal dagar")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', [_vm._v("Välj Säsongskort")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('div', [(_vm.SITE_CONFIG.skipass.day_onsite && _vm.SITE_CONFIG.skipass.season_onsite) ? _c('h2', [_vm._v("Antal dagar / säsongskort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.day_onsite && !_vm.SITE_CONFIG.skipass.season_onsite) ? _c('h2', [_vm._v("Antal dagar")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.day_onsite && _vm.SITE_CONFIG.skipass.season_onsite) ? _c('h2', [_vm._v("Välj Säsongskort")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skipass.open) ? _c('div', {
    staticClass: "blocked"
  }, [_c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skipass.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skipass.open) ? _c('div', {
    staticClass: "blocked"
  }, [_c('Dropdown', {
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "options": _vm.days,
      "validated": _vm.selectedDays && _vm.selectedDays.value,
      "value": _vm.selectedDays,
      "label": (_vm.selectedDays && _vm.selectedDays.value) ? (_vm.selectedDays.title) : 'Välj liftkort',
      "with-background": true,
      "bold-label": true
    },
    on: {
      "changed": _vm.changedDate,
      "clicked-suffix": function($event) {
        return _vm.changedDate({})
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.selectedDays && _vm.selectedDays.value && _vm.selectedDays.value.indexOf('0') === 0) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isSeason) ? _c('div', {
    staticClass: "center"
  }, [(_vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas') ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen') ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(4), _vm._v(" "), _c('p', [_vm._v("Kampanjpriserna gäller fram till 14:e december.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Ta med bokningsnumret och visa i liftkortskassan första dagen du besöker oss (när vi har öppnat), du blir då fotograferad och får ditt nya säsongskort.")])]) : _vm._e(), _vm._v(" "), (['ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(_vm.SITE_CONFIG.site) !== -1) ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Ta med bokningsnumret och visa i liftkortskassan första dagen du besöker oss (när vi har öppnat), du blir då fotograferad och får ditt nya säsongskort.")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    class: 'content type-wrapper ' + ((_vm.selectedAge && _vm.selectedDays && _vm.selectedDays.value) ? '' : 'disabled')
  }, [_c('h2', {
    staticClass: "center",
    on: {
      "click": function($event) {
        return _vm.openModal(['SkipassInfo'])
      }
    }
  }, [(_vm.SITE_CONFIG.skipass.load_enabled && !_vm.isSeason) ? _c('span', [_vm._v("\n          Ladda ditt befintliga liftkort eller\n        ")]) : _vm._e(), _vm._v("\n        köp\n        "), (_vm.isSeason) ? _c('span', [_vm._v("\n          säsongskort och\n        ")]) : _vm._e(), _vm._v("\n        keycard\n        "), _c('icon', {
    staticStyle: {
      "margin-left": "0.2em",
      "cursor": "pointer"
    },
    attrs: {
      "name": "info-white",
      "scale": 1.4
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.products), function(product, key) {
    return (((key === 'load' && _vm.isSeason) ? false : true)) ? _c('div', {
      key: key,
      class: {
        button: true,
          'small-text': true,
          wide: true,
          underlined: true,
          checked: (_vm.selectedType === key),
          'has-description': (product.description)
      },
      on: {
        "click": function($event) {
          return _vm.setType(key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(product.title) + "\n          "), _c('span', [_vm._v(_vm._s(product.description))])]) : _vm._e()
  }), 0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Vid köp av ett nytt säsongskort så hämtar du ut det på plats i Kungsbergets Infocenter och blir då fotograferad. Du kan också ladda ett Keycard som säsongskort via "), _c('a', {
    attrs: {
      "href": "http://ladda.kungsberget.se/"
    }
  }, [_vm._v("ladda.kungsberget.se")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Vid köp av ett nytt säsongskort så hämtar du ut det på plats i Branäs Infocenter och blir då fotograferad. Du kan också ladda ett Keycard som säsongskort via "), _c('a', {
    attrs: {
      "href": "http://ladda.branas.se/"
    }
  }, [_vm._v("ladda.branas.se")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Information om säsongskort")])])
}]}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "klarnaCode",
    staticStyle: {
      "overflow-x": "hidden"
    },
    attrs: {
      "id": "klarna-checkout-container"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "960px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [(_vm.SITE_CONFIG.accomodations.show_site) ? _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.locationId),
      expression: "params.locationId"
    }],
    class: 'map-background map-background--' + _vm.params.locationId + ' type--' + _vm.params.type,
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.locationId),
      expression: "params.locationId"
    }],
    staticClass: "center"
  }, [(_vm.params.map_link) ? _c('a', {
    staticClass: "button white small border map-bt",
    attrs: {
      "target": "_blank",
      "href": _vm.params.map_link
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": 2
    }
  }), _vm._v(" Se områdeskarta\n        "), _c('icon', {
    staticClass: "dowload-icon",
    attrs: {
      "name": "download",
      "scale": 1.5
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.locationId && _vm.params.type === 'interactive'),
      expression: "params.locationId && params.type === 'interactive'"
    }],
    staticClass: "center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(_vm.params.locationId === 2006) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.setLocation(2006, true)
      }
    }
  }, [_vm._v("\n        Sök på alla områden på Branäsberget\n      ")]) : _vm._e(), _vm._v(" "), (_vm.params.locationId === 2007) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.setLocation(2007, true)
      }
    }
  }, [_vm._v("\n        Sök på alla områden i Branäsdalen\n      ")]) : _vm._e(), _vm._v(" "), (_vm.params.locationId === 2020) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.setLocation(2020, true)
      }
    }
  }, [_vm._v("\n        Sök på alla områden i Mattesdalen\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.params.locationId),
      expression: "!params.locationId"
    }]
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 1.5
    }
  }), _vm._v(" Branäsberget")], 1), _vm._v(" "), _c('p', [_vm._v("I Branäsbergets stugor och lägenheter får du en fantastisk utsikt över dalen och närhet till skidåkning, pulkabackar och längdspår. Uppe på berget finns skiduthyrning, shop, livsmedelsbutik och restauranger.")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.openMap(2006)
      }
    }
  }, [_vm._v("Karta över Branäsberget")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h2', [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 1.5
    }
  }), _vm._v(" Branäsdalen")], 1), _vm._v(" "), _c('p', [_vm._v("I Branäsdalen finns både lägenheter och större fjällstugor, med nära till allt du behöver. I Branäsdalen har du nära till skiduthyrning, restaurang, shop och en livsmedelsbutik.")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.openMap(2007)
      }
    }
  }, [_vm._v("Karta över Branäsdalen")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h2', [_c('icon', {
    attrs: {
      "name": "mattesdalen",
      "scale": 1.5
    }
  }), _vm._v(" Mattesdalen")], 1), _vm._v(" "), _c('p', [_vm._v("I Mattesdalen finns både lägenheter och större, moderna fjällstugor. Bor du här har du nära till både 4-stolslift och 6-stolslift som snabbt tar dig upp till toppen och resten av skidområdet.")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.openMap(2020)
      }
    }
  }, [_vm._v("Mattesdalen")])])])]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.accomodations.show_site) ? _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      }
    }
  }, [_c('div', {
    class: 'map-background map-background--' + _vm.SITE_CONFIG.site + ' type--' + _vm.params.type,
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (this.$store.state.accomodationView && _vm.$store.state.accomodationView === 'images') ? _c('div', {
    staticClass: "notification center"
  }, [_c('p', [_vm._v("Du visar nu våra boenden i ett specialläge där du kan ladda ner bilder.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToNormal()
      }
    }
  }, [_vm._v("Gå till vanliga visningsläget")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number) ? _c('div', [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Tilläggsbokning")])]) : _c('div', [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Boka din nästa semester")])])]), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.accomodation.fully_open) ? _c('Note', {
    attrs: {
      "title": "Bokningen för vintersäsongen 26/27 är öppen",
      "color": "blue"
    }
  }, [_c('p', [_vm._v("Boenden släpps löpande fram till 1 juli.")])]) : _vm._e(), _vm._v(" "), (_vm.cancellationInsuranceEnabled && _vm.SITE_CONFIG.accomodations.cancellation_insurance.text_list) ? _c('div', {
    staticClass: "notification notification--blue center cancellation-insurance-notice",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.cancellation_insurance.text_list)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModal()) ? _c('Modal', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'waiting-for-filter': _vm.isAwaitingFilter || _vm.loading
    }
  }, [_c('AccomodationsFilter', {
    attrs: {
      "filterObject": _vm.filterObject
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('AccomodationsFilterInfo', {
    attrs: {
      "unitCount": _vm.unitCount,
      "poolCount": _vm.poolCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.isAwaitingFilter,
      "text": "Filter tillämpas"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('AccomodationsList', {
    attrs: {
      "pools": _vm.filteredPools,
      "locations": _vm.locations
    }
  }) : _vm._e(), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "427px",
      "showClose": false
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading, center: true
    }
  }, [_c('h1', [_vm._v("Din reservation har gått ut")]), _vm._v(" "), _c('p', [_vm._v("Din reservation i varukorgen har gått ut. Andra gäster kan boka det som var reserverat av dig.")]), _vm._v(" "), _c('table', [_c('thead'), _vm._v(" "), _c('tbody', [_vm._l((_vm.accomodations), function(accomodation, index) {
    return _c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(accomodation.name))]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("dateRange")([accomodation.period.date_arrival, accomodation.period.date_departure], 'D MMMM', ' - ')) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((accomodation.quantity * accomodation.price))))])]), _vm._v(" "), (!accomodation.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          return _vm.reclaim('accomodation', accomodation, index)
        }
      }
    }, [_vm._v("Reservera")])]) : _vm._e(), _vm._v(" "), (accomodation.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v("\n            Reserverad\n          ")]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.skischools), function(school, index) {
    return _c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(school.name))]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("date")(school.date, 'D MMMM')) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((school.quantity * school.price))))])]), _vm._v(" "), (!school.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          return _vm.reclaim('skischool', school, index)
        }
      }
    }, [_vm._v("Reservera")])]) : _vm._e(), _vm._v(" "), (school.reclaimed) ? _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v("\n            Reserverad\n          ")]) : _vm._e()])
  })], 2)]), _vm._v(" "), (!_vm.params.forceSyncAll) ? _c('div', [(_vm.params.continueToPayment && _vm.canContinue) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        _vm.closeModal();
        _vm.params.continueToPayment()
      }
    }
  }, [_vm._v("Fortsätt till betalning")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Stäng")])]) : _vm._e(), _vm._v(" "), (_vm.params.forceSyncAll) ? _c('div', [_c('button', {
    class: {
      small: true, border: true, disabled: !_vm.canContinueAll
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Fortsätt betalningen")]), _vm._v(" "), (!_vm.canContinueAll) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Avbryt betalning")]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.expand()
      }
    }
  }, [_c('div', {
    class: 'image item-image default-image ' + (_vm.level.info.video ? 'has-video' : '') + ' color-' + _vm.level.info.level + ' ' + (
      (_vm.level.info.minage >= 7 || _vm.level.info.is_private) ? 'young-adults' : 'children'
    ),
    style: ('background-image:url(' + _vm.level.info.image + ')')
  }, [(_vm.level.info.show_bjornbusen) ? _c('div', {
    class: {
      bjorbusen: true, 'has-subtitle': _vm.level.info.sub_title_2
    },
    style: ('background-image:url(https://static.booking.branasgruppen.se/static/img/Skidskola/skidskola-bjornbusen.png)')
  }, [_c('h2', {
    class: {
      'has-subtitle': _vm.level.info.sub_title_2
    }
  }, [_vm._v(_vm._s(_vm.level.info.sub_title_1)), (_vm.level.info.sub_title_2) ? _c('span', {
    staticClass: "smaller"
  }, [_vm._v(_vm._s(_vm.level.info.sub_title_2))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.level.info.show_badge) ? _c('span', {
    class: 'badge badge-' + ((_vm.level.info.level_virtual || '').match(/snolek$/) ? 'purple' : _vm.level.info.level)
  }, [_vm._v(_vm._s(_vm.level.info.level_name))]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'bike school overview') ? _c('div', {
    staticClass: "snow-bg"
  }) : _vm._e(), _vm._v(" "), (_vm.level.info.video) ? _c('div', {
    class: 'video-overlay ' + (_vm.level.info.show_bjornbusen ? 'video-overlay--bottom-right' : '')
  }, [_c('i', {
    staticClass: "fal fa-play-circle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openVideo($event)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details-start"
  }, [_c('p', {
    staticClass: "area-title",
    staticStyle: {
      "font-size": "1px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.level.info.special_title))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v(_vm._s(_vm.level.info.description))])]), _vm._v(" "), (_vm.level.info.prerequisites) ? _c('div', {
    staticClass: "description"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('skischool.prerequisites')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.level.info.prerequisites))])]) : _vm._e()])])]), _vm._v(" "), _c('SkiSchoolListUnitsList', {
    ref: "unitList",
    attrs: {
      "courses": _vm.level.courses,
      "info": _vm.level.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_vm._l((_vm.people), function(person, index) {
    return _c('div', [_c('div', {
      staticClass: "blue-bar"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(person.name) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "package"
    }, [(person.type === 'package') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ", paket")]) : _vm._e(), _vm._v(" "), (person.type === 'single') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ":")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.ages[person.age]) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "level"
    }, [(person.searchPackage === 'beginner') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Nybörjare")]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'intermediate') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Medelgod")]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'advanced') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Avancerad")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "date right"
    }, [_c('span', [_c('b', [_vm._v("Datum:")]), _vm._v(" " + _vm._s(_vm.dateRange(person)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "inner-width"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Längd (cm)")]), _vm._v("\n          " + _vm._s(person.lengthCm) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Vikt (kg)")]), _vm._v("\n          " + _vm._s(person.weight) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Skostorlek")]), _vm._v("\n          " + _vm._s(person.shoeSize) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, _vm._l((person.wishes), function(wish, key) {
      return (wish) ? _c('div', [_vm._v(_vm._s(_vm.wishesLabels[key]))]) : _vm._e()
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "addon--inner-width"
    }, [_c('div', {
      staticClass: "addons inner-width"
    }, [_c('div', {
      staticClass: "products"
    }, [_c('table', [_vm._l((person.products), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product && product.price) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _vm._l((person.addons), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product && product.price) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _c('tr', {
      staticClass: "total"
    }, [_c('td', [_vm._v("\n                Pris åkare " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((
      person.products.reduce(function(a, product) {
        return a + product.price
      }, 0) +
      person.addons.reduce(function(a, product) {
        return a + product.price
      }, 0)
    ))))])])])], 2)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "sum-bar"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n      Totalt:\n      "), _c('b', [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.sum)) + "\n      ")])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFilter) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "container no-padding"
  }, [(!_vm.startView) ? _c('div', {
    class: {
      column: true
    }
  }, [_c('div', {
    staticClass: "center filter-skischool"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-startdate')))]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.$store.state.skiSchoolFilter.date ? (_vm.moment(_vm.$store.state.skiSchoolFilter.date).format('D MMMM')) : _vm.$t('general.pick-startdate'),
      "bold-label": false,
      "validated": _vm.$store.state.skiSchoolFilter.date
    },
    on: {
      "clicked": _vm.openDateModal,
      "clicked-suffix": _vm.dateClear
    }
  }), _vm._v(" "), (_vm.SITE_CONFIG.translations.texts['texts-skischool-notice-about-days-' + _vm.$route.query.type]) ? _c('div', {
    staticStyle: {
      "max-width": "200px",
      "text-align": "left",
      "font-weight": "300",
      "opacity": "0.8",
      "font-size": "0.875rem"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('texts.texts-skischool-notice-about-days-' + _vm.$route.query.type)))])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.startView) ? _c('div', {
    class: {
      column: true, disabled: false
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-type')))]), _vm._v(" "), _vm._l((_vm.types), function(option) {
    return _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.$route.query.type === option.key),
      },
      on: {
        "click": function($event) {
          return _vm.changeType(option.key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.startView && _vm.$route.query.type !== 'snowboard') ? _c('div', {
    staticClass: "column age-filter"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Välj startdatum")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.$store.state.skiSchoolFilter.date ? (_vm.moment(_vm.$store.state.skiSchoolFilter.date).format('D MMMM')) : 'Välj startdatum',
      "bold-label": false,
      "validated": _vm.$store.state.skiSchoolFilter.date
    },
    on: {
      "clicked": _vm.openDateModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.options.length) ? _c('div', {
    class: {
      column: true, disabled: !(_vm.$route.query.type !== 'private' && _vm.$route.query.type !== 'snowboard')
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-age')))]), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.$store.state.skiSchoolFilter[option.key]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter(option.key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.startView && (_vm.SITE_CONFIG.site !== 'vallasen' || _vm.$route.query.type !== 'private') && _vm.levels.length) ? _c('div', {
    class: {
      column: true, disabled: !(_vm.showlevels && _vm.$route.query.type !== 'snowboard')
    }
  }, [_c('div', {
    staticClass: "center margin-filter"
  }, [_c('div', [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "label level-label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-level')))]) : _c('div', {
    staticClass: "label level-label"
  }, [_vm._v(_vm._s(_vm.$t('skischool.pick-level-2')))]), _vm._v(" "), _vm._l((_vm.levels), function(level) {
    return _c('button', {
      class: {
        'level-filter': true,
        checked: (_vm.$store.state.skiSchoolFilter[level.key]),
          disabled: (
            (_vm.$route.query.type === 'private' && _vm.SITE_CONFIG.site === 'branas') ||
            (!(_vm.showLevel(level.key).indexOf(_vm.currentAge) !== -1) && _vm.$route.query.type !== 'private')
          )
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter(level.key)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": level.key + '-circle',
        "scale": 1.8
      }
    }), _vm._v(_vm._s(level.title))], 1)
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalo",
    style: ('z-index:' + _vm.zIndex + ';')
  }, [(_vm.showClose) ? _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('icon', {
    attrs: {
      "name": "times-white",
      "scale": 5
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showClose) ? _c('Back', {
    attrs: {
      "text": _vm.closeText,
      "clicked": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outer",
    on: {
      "click": _vm.closeFromOuterClick
    }
  }, [_c('div', {
    class: {
      'container': true, 'wide': _vm.wide, 'fullwide': _vm.fullwide
    },
    style: ({
      'max-width': _vm.width
    })
  }, [_c('div', {
    class: 'content ' + this.setClass,
    style: ({
      'min-width': _vm.minWidth,
      'width': _vm.normalWidth,
      'max-width': _vm.width
    }),
    attrs: {
      "id": "modal-container-content"
    }
  }, [_c('header', [_vm._t("header")], 2), _vm._v(" "), _c('main', [_vm._t("default")], 2), _vm._v(" "), _c('footer', [_vm._t("footer")], 2)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accommodationwrapper"
  }, [_c('Loading', {
    attrs: {
      "show": !_vm.webpools.length
    }
  }), _vm._v(" "), _vm._l((_vm.pools), function(pool, index) {
    return _c('div', {
      key: index,
      class: 'admin-table-wrapper ' + (pool.active ? 'open' : 'closed')
    }, [_c('h2', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          pool.active = !pool.active
        }
      }
    }, [_vm._v(_vm._s(pool.display_name || pool.name))])]), _vm._v(" "), (pool.active) ? _c('table', {
      staticClass: "admin-table",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('tbody', [(index) ? _c('tr', [_c('td', [_c('table', {
      staticClass: "vertical-table"
    }, [_c('tr', [_c('th', [_vm._v("\n                  Namn (visas om inte visningsnamn är ifyllt, kan inte ändras härifrån)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.name),
        expression: "pool.name"
      }],
      staticClass: "large",
      attrs: {
        "disabled": "",
        "readonly": ""
      },
      domProps: {
        "value": (pool.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Visningsnamn (visas om ifyllt)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.display_name),
        expression: "pool.display_name"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.display_name)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'visningsnamn')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "display_name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Videolänk (Bunny/Vimeo)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.video),
        expression: "pool.video"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.video)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'video')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "video", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Kartlänk (PDF)\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.map_link),
        expression: "pool.map_link"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.map_link)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'karta')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "map_link", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Dölj karta\n                ")]), _vm._v(" "), _c('td', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.hide_map),
        expression: "pool.hide_map"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(pool.hide_map) ? _vm._i(pool.hide_map, null) > -1 : (pool.hide_map)
      },
      on: {
        "change": [function($event) {
          var $$a = pool.hide_map,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(pool, "hide_map", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(pool, "hide_map", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(pool, "hide_map", $$c)
          }
        }, function($event) {
          return _vm.updatePool(pool, 'kartvisning')
        }]
      }
    }), _vm._v(" Dölj karta\n                  ")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Beskrivning\n                ")]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.short_description),
        expression: "pool.short_description"
      }],
      staticClass: "large",
      attrs: {
        "rows": "6"
      },
      domProps: {
        "value": (pool.short_description)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'beskrivning')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "short_description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Punkter (en ny punkt per rad)\n                ")]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.bullet_points),
        expression: "pool.bullet_points"
      }],
      staticClass: "large",
      attrs: {
        "rows": "6"
      },
      domProps: {
        "value": (pool.bullet_points)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'USP-punkter')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "bullet_points", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Bildlänk – stor bild\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.image),
        expression: "pool.image"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.image)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'stor bild')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "image", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-preview",
      attrs: {
        "src": pool.image
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Bildlänk – miniatyrbild\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.image_thumbnail),
        expression: "pool.image_thumbnail"
      }],
      staticClass: "large",
      domProps: {
        "value": (pool.image_thumbnail)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'minitiatyrbild')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "image_thumbnail", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-preview",
      attrs: {
        "src": pool.image_thumbnail
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Incheckningstid\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.check_in_time),
        expression: "pool.check_in_time"
      }],
      domProps: {
        "value": (pool.check_in_time)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'incheckningstid')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "check_in_time", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Utcheckningstid\n                ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pool.check_out_time),
        expression: "pool.check_out_time"
      }],
      domProps: {
        "value": (pool.check_out_time)
      },
      on: {
        "change": function($event) {
          return _vm.updatePool(pool, 'utcheckningstid')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pool, "check_out_time", $event.target.value)
        }
      }
    })])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (pool.active) ? _c('table', {
      staticClass: "admin-table"
    }, [_c('tbody', [_vm._m(0, true), _vm._v(" "), _vm._l((pool.units), function(unit, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v("\n            #" + _vm._s(unit.id) + "\n          ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.show_web),
          expression: "unit.show_web"
        }],
        attrs: {
          "type": "checkbox",
          "disabled": ""
        },
        domProps: {
          "checked": Array.isArray(unit.show_web) ? _vm._i(unit.show_web, null) > -1 : (unit.show_web)
        },
        on: {
          "change": function($event) {
            var $$a = unit.show_web,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "show_web", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "show_web", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "show_web", $$c)
            }
          }
        }
      }), _vm._v(" "), (unit.show_web) ? _c('a', {
        attrs: {
          "href": "#",
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.openUnit(unit)
          }
        }
      }, [_vm._v(" Visa ")]) : _vm._e(), _vm._v(" "), (!unit.show_web) ? _c('span', [_vm._v(" Visa")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(unit.name) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(unit.description_title) + "\n          ")]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.display_name),
          expression: "unit.display_name"
        }],
        domProps: {
          "value": (unit.display_name)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'namn')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "display_name", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.subtitle),
          expression: "unit.subtitle"
        }],
        domProps: {
          "value": (unit.subtitle)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'beskrivning')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "subtitle", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.night_storage),
          expression: "unit.night_storage"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(unit.night_storage) ? _vm._i(unit.night_storage, null) > -1 : (unit.night_storage)
        },
        on: {
          "change": [function($event) {
            var $$a = unit.night_storage,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "night_storage", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "night_storage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "night_storage", $$c)
            }
          }, function($event) {
            return _vm.updateUnit(unit, 'nattförvaring')
          }]
        }
      }), _vm._v(" Nattförvaring\n            ")]), _vm._v(" "), _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.has_mandatory_cleaning),
          expression: "unit.has_mandatory_cleaning"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(unit.has_mandatory_cleaning) ? _vm._i(unit.has_mandatory_cleaning, null) > -1 : (unit.has_mandatory_cleaning)
        },
        on: {
          "change": [function($event) {
            var $$a = unit.has_mandatory_cleaning,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "has_mandatory_cleaning", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "has_mandatory_cleaning", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "has_mandatory_cleaning", $$c)
            }
          }, function($event) {
            return _vm.updateUnit(unit, 'obl. slutstäd')
          }]
        }
      }), _vm._v(" Obl. slutstäd\n            ")])]), _vm._v(" "), _c('td', [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.use_unit_count),
          expression: "unit.use_unit_count"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(unit.use_unit_count) ? _vm._i(unit.use_unit_count, null) > -1 : (unit.use_unit_count)
        },
        on: {
          "change": [function($event) {
            var $$a = unit.use_unit_count,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(unit, "use_unit_count", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(unit, "use_unit_count", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(unit, "use_unit_count", $$c)
            }
          }, function($event) {
            return _vm.updateUnit(unit, 'visning av antal kvar')
          }]
        }
      }), _vm._v(" Visa antal kvar\n            ")]), _vm._v(" "), _c('label', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.price_type),
          expression: "unit.price_type"
        }],
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(unit, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.updateUnit(unit, 'pristyp')
          }]
        }
      }, _vm._l((['thursday', 'saturday']), function(i) {
        return _c('option', {
          key: i,
          domProps: {
            "value": i
          }
        }, [_vm._v("\n                  " + _vm._s({
          thursday: '-',
          saturday: 'Lördag',
        } [i]) + "\n                ")])
      }), 0)])]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.image),
          expression: "unit.image"
        }],
        domProps: {
          "value": (unit.image)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'bild')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "image", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.webpool_id),
          expression: "unit.webpool_id"
        }],
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(unit, "webpool_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.updateUnit(unit, 'områdestillhörighet')
          }]
        }
      }, _vm._l((_vm.webpools), function(p) {
        return _c('option', {
          key: p.id,
          domProps: {
            "value": p.id
          }
        }, [_vm._v("\n                " + _vm._s(p.display_name || p.name) + "\n              ")])
      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.check_in_time),
          expression: "unit.check_in_time"
        }],
        domProps: {
          "value": (unit.check_in_time)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'incheckning')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "check_in_time", $event.target.value)
          }
        }
      }), _c('br'), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (unit.check_out_time),
          expression: "unit.check_out_time"
        }],
        domProps: {
          "value": (unit.check_out_time)
        },
        on: {
          "change": function($event) {
            return _vm.updateUnit(unit, 'utcheckning')
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(unit, "check_out_time", $event.target.value)
          }
        }
      })])])
    })], 2)]) : _vm._e()])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "header"
  }, [_c('th', [_vm._v("\n            #\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Visa webb\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Namn 1\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Namn 2\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Visningsnamn\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Kort beskrivning / Nattförvaring\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Antal kvar / Ankomst\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Bildlänk\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Område\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Tider\n          ")])])
}]}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.pick-equipment')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, _vm._l((_vm.params.options), function(option, key) {
    return _c('div', [(option) ? _c('button', {
      staticClass: "small white underlined",
      on: {
        "click": function($event) {
          return _vm.clicked(key)
        }
      }
    }, [_vm._v(_vm._s(option.name))]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTimeLine || _vm.showBookingTimer),
      expression: "showTimeLine || showBookingTimer"
    }],
    class: 'wrapper theme--' + _vm.theme
  }, [(_vm.showTimeLine) ? _c('div', {
    staticClass: "flex"
  }, [_c('ul', {
    staticClass: "timeline",
    attrs: {
      "id": "timeline",
      "aria-label": "Avklarade steg i bokningen"
    }
  }, _vm._l((_vm.steps), function(step, key) {
    return _c('li', {
      key: key,
      class: 'li complete--' + (step.complete) + ' next-complete--' + (_vm.steps[key + 1] ? _vm.steps[key + 1].complete : '')
    }, [_c('div', {
      class: {
        status: true, clickable: _vm.clickable(step)
      },
      on: {
        "click": function($event) {
          return _vm.goTo(step)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(step.title))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('BookingTimer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBookingTimer),
      expression: "showBookingTimer"
    }],
    ref: "bookingTimer",
    on: {
      "update": _vm.update
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": !_vm.loaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "2em"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freesearch),
      expression: "freesearch"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Sök"
    },
    domProps: {
      "value": (_vm.freesearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freesearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n          \n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_winter),
      expression: "show_winter"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_winter) ? _vm._i(_vm.show_winter, null) > -1 : (_vm.show_winter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_winter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_winter = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_winter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_winter = $$c
        }
      }
    }
  }), _vm._v(" Vinter\n          \n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_summer),
      expression: "show_summer"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_summer) ? _vm._i(_vm.show_summer, null) > -1 : (_vm.show_summer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_summer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_summer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_summer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_summer = $$c
        }
      }
    }
  }), _vm._v(" Sommar\n      ")])]), _vm._v(" "), _vm._l((_vm.settings), function(s, i) {
    return _c('div', {
      class: 'setting-group'
    }, [_c('div', {
      staticClass: "setting-group-title",
      on: {
        "click": function($event) {
          s.expanded = !s.expanded
        }
      }
    }, [_vm._v(_vm._s(_vm.getTitle(i)) + " "), (!s.expanded) ? _c('span', {
      staticClass: "title-helper"
    }, [_vm._v(_vm._s(_vm.getHelp(s)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      class: (s.expanded ? 'setting-list--expanded' : 'setting-list')
    }, _vm._l((s.entries), function(group) {
      return _c('div', {
        class: 'setting-group-inner'
      }, [_c('div', {
        staticClass: "inner-title"
      }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _vm._l((group.entries), function(setting) {
        return (_vm.showSetting(setting)) ? _c('div', {
          staticClass: "single-setting-wrapper"
        }, [_c('Setting', {
          attrs: {
            "setting": setting
          }
        })], 1) : _vm._e()
      })], 2)
    }), 0)])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "period-confirmation-viewer"
  }, [(_vm.period || true) ? _c('div', [_c('span', {
    class: _vm.period ? '' : 'disabled'
  }, [(!_vm.small) ? _c('OutlineButton', {
    attrs: {
      "label": "Ändra datum",
      "icon": "edit-blue",
      "iconscale": 1.5
    },
    on: {
      "click": function($event) {
        return _vm.openPriceList(_vm.unit)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'period-wrapper': true, disabled: (_vm.period && !_vm.period.free)
    }
  }, [(_vm.period) ? _c('div', {
    staticClass: "period-viewer"
  }, [_c('div', {
    staticClass: "week-viewer"
  }, [_vm._v("\n        v." + _vm._s(_vm._f("date")(_vm.period.date_arrival, 'week')) + "\n      ")]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 2.5
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("dateRange")([_vm.period.date_arrival, _vm.period.date_departure], 'weekday', ' - '))))]), _c('br'), _vm._v("\n      " + _vm._s(_vm._f("dateRange")([_vm.period.date_arrival, _vm.period.date_departure], 'long', ' - ')) + "\n    ")], 1) : _c('div', {
    staticClass: "period-viewer"
  }, [_c('div', {
    staticClass: "week-viewer"
  }, [_vm._v("\n        ...\n      ")]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 2.5
    }
  }), _vm._v(" "), (_vm.checkAvailability) ? _c('b', [_vm._v("Laddar priset...")]) : _vm._e(), _vm._v(" "), (!_vm.checkAvailability) ? _c('b', [_vm._v("Laddar...")]) : _vm._e(), _c('br'), _vm._v("\n      ...\n    ")], 1), _vm._v(" "), (!_vm.small) ? _c('div', {
    staticClass: "price-viewer"
  }, [_vm._v("\n      Pris\n      "), (_vm.cartAccomodationObject && _vm.period && _vm.period.price) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")((_vm.cartAccomodationObject && _vm.period && _vm.period.price))))]) : _c('b', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.mandatory_cleaning_price) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mandatory_cleaning_price) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v("Detta boende har obligatoriskt slutstäd. Kostnaden (" + _vm._s(_vm._f("currency")(_vm.mandatory_cleaning_price / 2)) + " med RUT-avdrag) tillkommer utöver boendepriset.")])]) : _vm._e(), _vm._v(" "), (_vm.special_message) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.special_message) ? _c('div', {
    staticClass: "alert",
    domProps: {
      "innerHTML": _vm._s(_vm.special_message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.not_available_reason) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.not_available_reason) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v(_vm._s(_vm.not_available_reason) + " "), (!_vm.updating) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.fetch()
      }
    }
  }, [_vm._v("Testa igen")]) : _vm._e(), _vm._v(".")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.period && false) ? _c('div', [_vm._v("\n    Laddar information...\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "flex"
  }, [(_vm.localResetPasswordSuccessMessage) ? _c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.localResetPasswordSuccessMessage))])]) : _vm._e()]), _vm._v(" "), _c('div'), _vm._v(" "), (!_vm.loggedIn && !_vm.$route.query.admin) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('b', [_vm._v("E-postadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Lösenord")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        Uppgifterna stämde inte. Försök igen med ett annat lösenord eller beställ ett nytt lösenord nedan.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "spacer"
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? 'Loggar in...' : 'Logga in'))])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "spacer"
  }, [_vm._v(" ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button white small underlined",
    attrs: {
      "to": {
        name: 'request reset password'
      }
    }
  }, [_vm._v("Glömt lösenord")]), _vm._v(" "), _c('router-link', {
    staticClass: "button white small underlined",
    attrs: {
      "to": {
        name: 'request new password'
      }
    }
  }, [_vm._v("Har inget lösenord")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.admin && !_vm.adminUser) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('b', [_vm._v("Admin-användare")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginAdmin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Lösenord")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginAdmin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n        Uppgifterna stämde inte. Försök igen med ett annat lösenord.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "spacer"
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.loginAdmin()
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? 'Loggar in i admin...' : 'Logga in admin'))])])]) : _vm._e(), _vm._v(" "), (_vm.adminUser) ? _c('div', [_c('hr')]) : _vm._e(), _vm._v(" "), (_vm.adminUser) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToAdmin()
      }
    }
  }, [_vm._v("Gå till admin")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Du är inloggad i admin")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small white",
    on: {
      "click": function($event) {
        return _vm.logoutAdmin()
      }
    }
  }, [_vm._v("Logga ut från admin")])])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('p', [_vm._v("Du är inloggad")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logga ut")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'icon icon--' + _vm.className,
    style: ('width:' + _vm.scale + 'em;height:' + _vm.scale + 'em;'),
    attrs: {
      "aria-hidden": _vm.ariaHidden ? 'true' : 'false'
    }
  }, [_c('img', {
    style: ('width:' + _vm.scale + 'em;height:' + _vm.scale + 'em;'),
    attrs: {
      "src": 'https://static.booking.branasgruppen.se/static/svg/' + _vm.name + '.svg',
      "aria-hidden": _vm.ariaHidden ? 'true' : 'false',
      "alt": _vm.altText
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": '740px',
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v("Välj ålder och datum")]), _vm._v(" "), _c('p', {
    staticClass: "subtext"
  }), _vm._v(" "), _c('SkiSchoolFilter', {
    attrs: {
      "start-view": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v("Visa Skidskolor "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1)]), _vm._v(" "), (_vm.SITE_CONFIG.skischool.show_site) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "map",
      "scale": 1.4
    }
  }), _vm._v(" Samlingsplatser")], 1), _vm._v(" "), _c('p', [_vm._v("Samlingsplatser för skidskolan väljer man vid bokningen. Skidskolor för nybörjare utgår från både Byn och Berget. Fortsättningsgrupperna samlas vid starten av Storbacken.")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commandsyncer"
  }, [_c('Loading', {
    attrs: {
      "show": !_vm.logs.length
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Synkronisering")]), _vm._v(" "), _c('h2', [_vm._v("Boenden")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodations', {
          accomodationId: ['accomodation', 'Boende-ID i databas eller slug', '']
        }, [
          '--update'
        ])
      }
    }
  }, [_vm._v("\n    Boenden\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodations', {}, [
          '--only-check-new'
        ])
      }
    }
  }, [_vm._v("\n    Endast nya boenden\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodationprices', {
          accomodationId: ['accomodation', 'Boende-ID i databas eller slug', ''],
          '--winter-prices': ['switch', 'VINTER: priser', true],
          '--winter-day-prices': ['switch', 'VINTER: dygnspriser', true],
          '--winter-availability': ['switch', 'VINTER: tillgänglighet', true],
          '--price-codes': ['text-readonly', 'Priskoder', 'all'],
          '--summer-prices': ['switch', 'SOMMAR: priser'],
          '--summer-availability': ['switch', 'SOMMAR: tillgänglighet'],
          '--next-winter-prices': ['switch', 'NÄSTA VINTER: priser', false, !_vm.SITE_CONFIG.next_season.winter.is_active],
          '--next-winter-availability': ['switch', 'NÄSTA VINTER: tillgänglighet', false, !_vm.SITE_CONFIG.next_season.winter.is_active],
        }, [])
      }
    }
  }, [_vm._v("\n    Boendepriser\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodation_show_web')
      }
    }
  }, [_vm._v("\n    Boenden: visa på webb\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodations_to_web')
      }
    }
  }, [_vm._v("\n    Till Wordpress\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Produkter")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:skiletting_products')
      }
    }
  }, [_vm._v("\n    Skidhyra\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:skipass')
      }
    }
  }, [_vm._v("\n    Liftkort\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:skischool')
      }
    }
  }, [_vm._v("\n    Skidskola\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Övrigt")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:promotion_codes')
      }
    }
  }, [_vm._v("\n    Kampanjkoder\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('cache:prefetch')
      }
    }
  }, [_vm._v("\n    Re-cache\n  ")]), _vm._v(" "), _vm._v("\n\n      \n  "), _c('hr'), _vm._v("\n      \n\n  Visar de " + _vm._s(_vm.count) + " senaste\n\n  "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.logs), function(log) {
    return _c('tbody', [_c('tr', {
      class: {
        success: log.success, failed: log.failed
      }
    }, [_c('td', [(log.success) ? _c('icon', {
      attrs: {
        "name": "punklista-check",
        "scale": 1
      }
    }) : _vm._e(), _vm._v(" "), (log.failed) ? _c('icon', {
      attrs: {
        "name": "error",
        "scale": 1
      }
    }) : _vm._e(), _vm._v(" "), (log.failed) ? _c('span', [_c('br'), _vm._v("Fel")]) : _vm._e(), _vm._v(" "), (!log.success && !log.failed) ? _c('span', [_vm._v("Kör...")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s((log.done || 0) + '/' + (log.total_count || 1)) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s((Math.min((((log.done || 0) / (log.total_count || 1)) * 100), 100).toLocaleString())) + "%\n        ")]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "white-space": "pre"
      }
    }, [_vm._v(_vm._s(_vm.moment(log.created_at).format('D MMM')))])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.moment(log.created_at).format('HH:mm:ss')) + "\n        ")]), _vm._v(" "), (log.success || log.failed) ? _c('td', [_vm._v("\n          " + _vm._s(_vm.moment(log.updated_at).format('HH:mm:ss')) + "\n        ")]) : _c('td', {
      attrs: {
        "title": log.time_remaining + ' sekunder'
      }
    }, [(log.time_remaining) ? _c('span', [_vm._v(_vm._s(_vm.moment().add(Math.abs(log.time_remaining), 'seconds').fromNow()))]) : _c('span', [_vm._v("nu")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(log.name))]), _c('br'), _vm._v(" "), _c('i', {
      domProps: {
        "innerHTML": _vm._s(log.arguments)
      }
    })])])])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.getList(true)
      }
    }
  }, [_vm._v("Fler")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Skapad")]), _vm._v(" "), _c('th', [_vm._v("ETA/Klart")]), _vm._v(" "), _c('th', [_vm._v("Jobb")])])])
}]}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [(_vm.$store.state.isOnSite) ? _c('OnSiteFooter', {
    staticStyle: {
      "z-index": "1000000"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": '500px',
      "min-width": "420px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.keycard.pool_lid) ? _c('div', [_c('div', {
    staticClass: "padding"
  }, [_c('h1', [_vm._v("Oladdade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v("Antal liftkort")]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "blocked info blue"
  }, [_vm._v("\n      Liftkortet kostar " + _vm._s(_vm._f("currency")(_vm.keycard.price)) + " och skickas hem till dig. Leveransen tar ca en vecka.\n      "), (_vm.SITE_CONFIG.site === 'branas') ? _c('span', [_vm._v("Du vet väl att du kan lägga till liftkort till din skidhyra eller till din boendebokning och få leverans tillsammans med nycklar eller skidutrustning.")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('span', [_vm._v("Du vet väl att du även kan lägga till liftkort till din skidhyra eller till din boendebokning.")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') ? _c('span', [_vm._v("Du vet väl att du kan lägga till liftkort till din skidhyra och få dem levererade tillsammans med skidutrustningen.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, [_c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1)])])]) : _c('div', {
    staticClass: "padding"
  }, [_c('h1', [_vm._v("Oladdade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "blocked info-box center"
  }, [_vm._v("\n      Oops, det finns inget oladdat liftkort att köpa här för tillfället. Kontakta gärna gästservice om du har några frågor: "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")])])])])
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "reload": function($event) {
        return _vm.fetch(true)
      }
    }
  }), _vm._v(" "), (!_vm.activeOrders.length && !_vm.upcomingOrders.length && !_vm.loading) ? _c('div', {
    staticClass: "no-orders"
  }, [_c('p', [_vm._v("Hittade inga planerade resor.")])]) : _vm._e(), _vm._v(" "), (_vm.activeOrders.length) ? _c('div', {
    staticClass: "booking-group"
  }, _vm._l((_vm.activeOrders), function(order) {
    return _c('PrettyOrder', {
      key: 'a' + order.resvid,
      attrs: {
        "order": order,
        "bookMoreCallback": _vm.bookMore
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.upcomingOrders.length) ? _c('div', {
    staticClass: "booking-group"
  }, _vm._l((_vm.upcomingOrders), function(order) {
    return _c('PrettyOrder', {
      key: 'u' + order.resvid,
      attrs: {
        "order": order,
        "bookMoreCallback": _vm.bookMore
      }
    })
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "setClass": ['no-padding'],
      "width": "500px"
    },
    on: {
      "close": _vm.closeLocalModal
    }
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      header: true, disabled: _vm.loading
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.school.full_title || _vm.school.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [(!_vm.params.activity) ? _c('div', [_c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 1.1
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('general.days-count')) + ":")]), _vm._v(" " + _vm._s(_vm.school.actual_days) + " " + _vm._s(_vm.$t('general.days')))], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "clock",
      "scale": 1.1
    }
  }), _vm._v(" " + _vm._s(_vm.school.minutes) + _vm._s(_vm.$t('general.minutes-short'))), (!_vm.params.activity) ? _c('span', [_vm._v("/" + _vm._s(_vm.$t('skischool.lesson')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "label",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(['SkiSchoolLocationMap'])
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skischool.gathering-site')) + " "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.3
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.skischool.show_site) ? _c('div', {
    staticClass: "location-box"
  }, [(_vm.school.site === 2) ? _c('strong', [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 1.6
    }
  }), _vm._v(" " + _vm._s(_vm.school.site_name))], 1) : _vm._e(), _vm._v(" "), (_vm.school.site === 1) ? _c('strong', [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 1.6
    }
  }), _vm._v(" " + _vm._s(_vm.school.site_name))], 1) : _vm._e(), _vm._v(" "), (!_vm.school.site) ? _c('strong', [_c('icon', {
    attrs: {
      "name": "gondol",
      "scale": 1.6
    }
  }), _vm._v(" " + _vm._s(_vm.school.site_name))], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skischool.branas.site-this-school', {
    site: _vm.school.site_name_help
  })))]), _vm._v(" "), (_vm.showMinParticipantsReq) ? _c('p', [_vm._v(_vm._s(_vm.groupParticipantsRequirementText))]) : _vm._e(), _vm._v(" "), (_vm.lowParticipantCountVariations && _vm.SITE_CONFIG.site === 'branas') ? _c('p', [_vm._v(_vm._s(_vm.lowParticipantCountVariationText))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skischool.show_site) ? _c('div', {
    staticClass: "location-box"
  }, [(_vm.$route.name === 'ski school overview') ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('skischool.kungsberget.site.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skischool.kungsberget.site.description')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skischool.kungsberget.site-help')))])]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'bike school overview') ? _c('div', [_c('strong', [_vm._v("Bron")]), _vm._v(" "), _c('p', [_vm._v("Vi samlas på bron mellan hyran och 8stols liften.")]), _vm._v(" "), _c('p', [_vm._v("Cykel och skyddsutrustning ingår ej i aktivitetsbokningen, men kan förbokas på "), _c('a', {
    attrs: {
      "href": "https://hyra.kungsberget.se"
    }
  }, [_vm._v("hyra.kungsberget.se")]), _vm._v(". Som deltagare tar du själv med dig liftkort.")]), _vm._v(" "), _c('p', [_vm._v("Kungsberget förbehåller sig rätten att vid 2 elever eller färre, ställa in kursen eller erbjuda ett annat kurstillfälle.")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.school.notice) ? _c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Viktig information")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "location-box notice"
  }, [_c('p', [_vm._v(_vm._s(_vm.school.notice))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      main: true, disabled: _vm.loading
    }
  }, [_c('div', {
    staticClass: "field size-75"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('general.pick-startdate'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.theBooking.theDate ? (_vm.moment(_vm.theBooking.theDate).format('D MMMM')) : _vm.$t('general.pick-startdate'),
      "bold-label": false,
      "validated": _vm.theBooking.theDate
    },
    on: {
      "clicked": _vm.openDateModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1), _vm._v(" "), (!_vm.$route.query.qty) ? _c('div', {
    class: {
      field: true, 'size-25': true, 'fully-disabled': !_vm.theBooking.theDate
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('general.number'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "combo": false,
      "options": _vm.options,
      "valuebinder": _vm.qty,
      "validated": _vm.theBooking.people.length && _vm.qty && _vm.theBooking.theDate
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.qty = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.theBooking.theDate) ? _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('general.pick-time')))]), _vm._v(" "), _c('div', {
    staticClass: "checkboxes"
  }, _vm._l((_vm.times), function(time) {
    return _c('div', [_c('Checkbox', {
      attrs: {
        "label": time.title,
        "label-position": "after",
        "value": time.value,
        "valuebinder": _vm.theBooking.time
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(_vm.theBooking, "time", $event)
        },
        "click": _vm.checkAvailability
      }
    })], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.available) ? _c('div', {
    staticClass: "error"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.reason)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.restrictionDateInfo) ? _c('div', {
    staticClass: "info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.restrictionDateInfo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bookingWarning) ? _c('div', {
    staticClass: "info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.bookingWarning)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.alreadyBooked) ? _c('div', {
    staticClass: "info"
  }, [_c('div', [_c('b', [_vm._v("Flera elever")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "location-box notice"
  }, [_c('p', [_vm._v(_vm._s(_vm.alreadyBookedMessage))])])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _vm._l((_vm.theBooking.people), function(person, index) {
    return (!_vm.$route.query.qty) ? _c('div', {
      staticClass: "field flex"
    }, [_c('div', {
      staticClass: "field size-75"
    }, [(_vm.theBooking.people.length == 1) ? _c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('general.name-on')) + " " + _vm._s(_vm.school.maxage <= 11 ?
      (_vm.$t('general.ages.the-child')) :
      (_vm.school.maxage >= 17 ? _vm.$t('general.the-skier') : _vm.$t('general.youth')))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]) : _c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('general.name-on')) + " " + _vm._s(_vm.school.maxage <= 11 ?
      (_vm.$t('general.ages.child')) :
      (_vm.school.maxage >= 17 ? _vm.$t('general.skier') : _vm.$t('general.skier'))) + " " + _vm._s(index + 1)), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (person.name),
        expression: "person.name"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('general.first-and-surname')
      },
      domProps: {
        "value": (person.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(person, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field size-25"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t('general.age'))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": true,
        "options": _vm.ages,
        "valuebinder": person.age,
        "validated": person.age !== '' && (person.age >= _vm.school.minage && person.age <= _vm.school.maxage),
        "label": _vm.$t('general.age')
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "age", $event)
        }
      }
    })], 1), _vm._v(" "), (_vm.showComments) ? _c('div', {
      staticClass: "field"
    }, [_c('div', [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.title'))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), (_vm.getWishesAsList(person.wishes).length) ? _c('button', {
      staticClass: "white small border",
      staticStyle: {
        "margin-top": "14px"
      },
      on: {
        "click": function (e) { return _vm.openWishes(index); }
      }
    }, [_c('icon', {
      attrs: {
        "name": "edit-blue",
        "scale": 1
      }
    }), _vm._v("\n              Ändra\n            ")], 1) : _vm._e()]), _vm._v(" "), (_vm.getWishesAsList(person.wishes).length) ? _c('div', [_c('ul', {
      staticStyle: {
        "margin-top": "0.5rem"
      }
    }, _vm._l((_vm.getWishesAsList(person.wishes)), function(wish) {
      return _c('li', {
        key: wish
      }, [_vm._v(_vm._s(wish))])
    }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.getWishesAsList(person.wishes).length) ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v("När du bokar privatlektion uppskattar vi om du anger önskemål.")]), _vm._v(" "), _c('button', {
      staticClass: "small border",
      on: {
        "click": function (e) { return _vm.openWishes(index); }
      }
    }, [_c('icon', {
      attrs: {
        "name": "plus-white",
        "scale": 1
      }
    }), _vm._v("\n              " + _vm._s(_vm.$t('skirental.wishes.add')) + "\n            ")], 1)]) : _vm._e()])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.theBooking.people.length && !_vm.$route.query.qty) ? _c('hr', {
    staticStyle: {
      "width": "100%"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGuardian && (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn')) ? _c('div', {
    staticClass: "field"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('general.name-guardian'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theBooking.guardian),
      expression: "theBooking.guardian"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('general.first-and-surname')
    },
    domProps: {
      "value": (_vm.theBooking.guardian)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theBooking, "guardian", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('general.phone'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theBooking.phone),
      expression: "theBooking.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "tel",
      "placeholder": _vm.$t('general.phone-number')
    },
    domProps: {
      "value": (_vm.theBooking.phone)
    },
    on: {
      "blur": _vm.fixPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theBooking, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-number"
  }, [_vm._v(_vm._s(_vm.$t('general.obs-format', {
    format: '+46701234567'
  })))])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info-call",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('general.special-needs-call', {
        phone: ("<b>" + _vm.bookingNumber + "</b>")
      }))
    }
  }), _vm._v(" "), (_vm.showMinParticipantsReq && _vm.SITE_CONFIG.site === 'branas') ? _c('p', {
    staticClass: "info-group-requirements"
  }, [_vm._v(_vm._s(_vm.groupParticipantsRequirementText))]) : _vm._e()], 2), _vm._v(" "), (!_vm.loadingAvailability) ? _c('div', {
    class: {
      footer: true, disabled: _vm.loading
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.params.activity) ? _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.$t('general.price-per-person')) + " "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.price)))])]) : _vm._e(), _vm._v(" "), (_vm.params.activity) ? _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.$t('general.price')) + ": "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.price, {
    freeIfZero: true
  })))])]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": !_vm.validated()
    },
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$t('general.pay-with-card') : _vm.$t('general.cta.book')) + " "), (!_vm.$store.state.isOnSite) ? _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    },
    on: {
      "click": _vm.addToCart
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      footer: true, disabled: _vm.loading
    },
    staticStyle: {
      "padding-top": "0"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "width": "100%"
    }
  }, [(_vm.$store.state.isOnSite) ? _c('button', {
    class: 'small white border',
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": !_vm.validated()
    },
    on: {
      "click": function($event) {
        return _vm.openCodeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.pay-cash')))]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.wishes.pick')))]), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'storstenshojden') ? _c('div', [(_vm.params.person.products[0].code.match(/MULTI/)) ? _c('div', [_c('h5', {
    staticClass: "multi"
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.multi-title')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "startSki",
      "iconscale": 2,
      "value": _vm.wishes.startSki,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.skis'),
        unchecked: _vm.$t('skirental.wishes.options.skis')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "startSnowboard",
      "iconscale": 2,
      "value": _vm.wishes.startSnowboard,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.snowboard'),
        unchecked: _vm.$t('skirental.wishes.options.snowboard')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('skirental.wishes.shoes')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "wideCalf",
      "iconscale": 2,
      "value": _vm.wishes.wideCalf,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.wideCalf'),
        unchecked: _vm.$t('skirental.wishes.options.wideCalf')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "wideFoot",
      "iconscale": 2,
      "value": _vm.wishes.wideFoot,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.wideFoot'),
        unchecked: _vm.$t('skirental.wishes.options.wideFoot')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "softShoes",
      "iconscale": 2,
      "value": _vm.wishes.softShoes,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.softShoes'),
        unchecked: _vm.$t('skirental.wishes.options.softShoes')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "hardShoes",
      "iconscale": 2,
      "value": _vm.wishes.hardShoes,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.hardShoes'),
        unchecked: _vm.$t('skirental.wishes.options.hardShoes')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.hasSkis) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.$t('skirental.wishes.skis')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "shortTurn",
      "iconscale": 2,
      "value": _vm.wishes.shortTurn,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.shortTurn'),
        unchecked: _vm.$t('skirental.wishes.options.shortTurn')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "longTurn",
      "iconscale": 2,
      "value": _vm.wishes.longTurn,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.longTurn'),
        unchecked: _vm.$t('skirental.wishes.options.longTurn')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasSnowboard) ? _c('div', [_c('h5', [_vm._v(_vm._s(_vm.$t('skirental.wishes.snowboard')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.wishes.foot-in-front', {
    name: _vm.params.person.name
  })))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "preferedFootLeft",
      "iconscale": 2,
      "value": _vm.wishes.preferedFootLeft,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.preferedFootLeft'),
        unchecked: _vm.$t('skirental.wishes.options.preferedFootLeft')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('SwitchButton', {
    attrs: {
      "store": "preferedFootRight",
      "iconscale": 2,
      "value": _vm.wishes.preferedFootRight,
      "sync": true,
      "labels": {
        checked: _vm.$t('skirental.wishes.options.preferedFootRight'),
        unchecked: _vm.$t('skirental.wishes.options.preferedFootRight')
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.site === 'branas') ? _c('h5', {
    staticClass: "multi"
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.other')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "full"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.wishes.other-help')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wishes.freeText),
      expression: "wishes.freeText"
    }],
    staticClass: "text-input",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.wishes.freeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wishes, "freeText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.save')))])])])
},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "650px",
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('skipass.pricelist-title')))]), _vm._v(" "), (_vm.showTabs) ? _c('div', {
    staticClass: "tab-buttons"
  }, [_c('button', {
    class: 'small ' + (_vm.activeTab === 'weekday' ? 'blue' : 'white') + ' border',
    on: {
      "click": function($event) {
        return _vm.switchTab('weekday')
      }
    }
  }, [_vm._v("Vardag")]), _vm._v(" "), _c('button', {
    class: 'small ' + (_vm.activeTab === 'weekend' ? 'blue' : 'white') + ' border',
    on: {
      "click": function($event) {
        return _vm.switchTab('weekend')
      }
    }
  }, [_vm._v("Helg")]), _vm._v(" "), _c('button', {
    class: 'small ' + (_vm.activeTab === 'premiere' ? 'blue' : 'white') + ' border',
    on: {
      "click": function($event) {
        return _vm.switchTab('premiere')
      }
    }
  }, [_vm._v("Premiärhelg")])]) : _vm._e(), _vm._v(" "), _c('table', [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "special-price-wrapper--title"
  }), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'branas' && _vm.SITE_CONFIG.site !== 'kungsberget') ? _c('th', [_c('b', [_vm._v("Barn")]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.children) + " år")]) : _vm._e(), _vm._v(" "), _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('general.ages.youth')))]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.youths) + "år")]), _vm._v(" "), _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('general.ages.adult')))]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.adults) + "år")]), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.seniors) ? _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('general.ages.senior')))]), _c('br'), _vm._v(_vm._s(_vm.SITE_CONFIG.skipass.ages.seniors) + "år")]) : _vm._e(), _vm._v(" "), _c('th', [_c('b', [_vm._v(_vm._s(_vm.$t('skipass.cards.parents')))]), _c('br'), _vm._v(" ")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.prices), function(price, key) {
    return (_vm.titles[key] && (price.youths || price.adults || price.parents)) ? _c('tr', [_c('td', {
      staticClass: "title"
    }, [_c('b', [_vm._v(_vm._s(_vm.titles[key]))])]), _vm._v(" "), _c('td', {
      staticClass: "special-price-wrapper"
    }, [(price.special_text) ? _c('span', {
      staticClass: "special-price"
    }, [_vm._v(_vm._s(price.special_text))]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'branas' && _vm.SITE_CONFIG.site !== 'kungsberget') ? _c('td', {
      staticClass: "price"
    }, [(price.children) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.children.price)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [(price.youths) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.youths.price))), (price.youths.asterisk) ? _c('span', [_vm._v(_vm._s(price.youths.asterisk))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [(price.adults) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.adults.price))), (price.adults.asterisk) ? _c('span', [_vm._v(_vm._s(price.adults.asterisk))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.seniors) ? _c('td', {
      staticClass: "price"
    }, [(price.seniors) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.seniors.price))), (price.seniors.asterisk) ? _c('span', [_vm._v(_vm._s(price.seniors.asterisk))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('td', {
      staticClass: "price"
    }, [(price.parents) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(price.parents.price))), (price.parents.asterisk) ? _c('span', [_vm._v(_vm._s(price.parents.asterisk))]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, _vm._l((_vm.asterisks), function(asterisk) {
    return _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(asterisk.asterisk + ' ' + asterisk.text)
      }
    })])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "reload": function($event) {
        return _vm.fetch(true)
      }
    }
  }), _vm._v(" "), (!_vm.archivedOrders.length && !_vm.loading) ? _c('div', {
    staticClass: "no-orders"
  }, [_c('p', [_vm._v("Hittade inga tidigare resor.")])]) : _vm._e(), _vm._v(" "), (_vm.archivedOrders.length) ? _c('div', {
    staticClass: "booking-group"
  }, [_c('h2', [_vm._v("Tidigare resor")]), _vm._v(" "), _c('table', {
    class: {
      disabled: _vm.loading
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.archivedOrders), function(orders) {
    return _c('tbody', [_c('tr', [_c('th', {
      staticStyle: {
        "background-color": "white",
        "text-align": "left"
      },
      attrs: {
        "colspan": "4"
      }
    }, [_c('h3', {
      staticStyle: {
        "margin-bottom": "0",
        "margin-top": "1em",
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(orders[0].season))])])]), _vm._v(" "), _vm._l((orders), function(order) {
      return _c('tr', {
        staticClass: "table-row"
      }, [_c('td', [_c('span', {
        staticClass: "mobile-title"
      }, [_vm._v("Bokningsnr")]), _vm._v("\n            " + _vm._s(order.resvid) + "\n          ")]), _vm._v(" "), _c('td', {
        staticClass: "center"
      }, [_c('span', {
        staticClass: "mobile-title"
      }, [_vm._v("Ankomst")]), _vm._v("\n            " + _vm._s(order.arrivaldate.substr(0, 10)) + "\n          ")]), _vm._v(" "), _c('td', {
        staticClass: "right"
      }, [_c('span', {
        staticClass: "mobile-title"
      }, [_vm._v("Summa")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(order.sum)))])]), _vm._v(" "), _c('td', {
        staticClass: "center wide"
      }, [_c('button', {
        staticClass: "white border small",
        on: {
          "click": function($event) {
            return _vm.goToBooking(order.headlid)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "info-blue",
          "scale": 1.3
        }
      }), _vm._v(" Visa bokning")], 1)])])
    })], 2)
  })], 2)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Bokningsnummer")]), _vm._v(" "), _c('th', {
    staticClass: "center"
  }, [_vm._v("Ankomst")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Summa")]), _vm._v(" "), _c('th', {
    staticClass: "center"
  }, [_vm._v("Information")])])])
}]}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('Loading', {
    attrs: {
      "show": !_vm.texts.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "admin-sub-nav"
  }, [_c('ul', [_vm._l((_vm.categories), function(cat) {
    return _c('li', {
      class: cat === _vm.category ? 'active' : ''
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setCat(cat)
        }
      }
    }, [_vm._v(_vm._s(_vm.cats[cat] || cat))])])
  }), _vm._v(" "), (_vm.category === 'skischoolgroup') ? _c('li', {
    staticClass: "language-selector",
    style: ('background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + _vm.flag + '.svg);')
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLanguage),
      expression: "selectedLanguage"
    }],
    attrs: {
      "id": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languages), function(lang) {
    return _c('option', {
      key: lang,
      domProps: {
        "value": lang
      }
    }, [_vm._v(_vm._s(lang))])
  }), 0)]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    class: 'admintextcontainer ' + (_vm.loading ? 'loading' : '')
  }, [_c('h1', [_vm._v("Texter")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.category === 'skilettingproduct') ? _c('div', [_c('label', {
    attrs: {
      "for": "sort"
    }
  }, [_vm._v("Sortera efter:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    attrs: {
      "id": "sort"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetchData]
    }
  }, _vm._l((_vm.availableSorts), function(s) {
    return _c('option', {
      key: s.value,
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.text))])
  }), 0), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.category === 'accomodationaddon') ? _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.id1),
        expression: "text.id1"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.id1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "id1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1),
        expression: "text.text1"
      }],
      domProps: {
        "value": (text.text1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2),
        expression: "text.text2"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (text.text2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text2", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(text.text2) ? _c('img', {
      staticStyle: {
        "height": "2em"
      },
      attrs: {
        "src": 'https://static.booking.branasgruppen.se/static/svg/addons/' + text.text2
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text3),
        expression: "text.text3"
      }],
      domProps: {
        "value": (text.text3)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text3", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text6),
        expression: "text.text6"
      }],
      domProps: {
        "value": (text.text6)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text6", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (text.text4),
        expression: "text.text4",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.text4)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text4", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text7),
        expression: "text.text7"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.text7)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text7", $event.target.value)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.category === 'pagetexts') ? _c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.slug),
        expression: "text.slug"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (text.slug)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "slug", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1),
        expression: "text.text1"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (text.text1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2),
        expression: "text.text2"
      }],
      attrs: {
        "rows": "10"
      },
      domProps: {
        "value": (text.text2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text2", $event.target.value)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.category === 'skilettingproduct') ? _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Pool-ID")]), _vm._v(" "), _c('th', [_vm._v("Rubrik")]), _vm._v(" "), _c('th', [_vm._v("Bild")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s('Underrubrik'))]), _vm._v(" "), _c('th', [_vm._v(_vm._s('Beskrivning'))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('th', [_vm._v("Grupperas med pool")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('th', [_vm._v("Bild (m. hjälm)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s('Kortare rubrik'))]), _vm._v(" "), _c('th', [_vm._v("Längdkategorier")])])]), _vm._v(" "), _vm._l((_vm.texts), function(text, index) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.id1),
        expression: "text.id1"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.id1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "id1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1),
        expression: "text.text1"
      }],
      domProps: {
        "value": (text.text1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text1", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(_vm._s(text.original)), _c('br'), _vm._v(_vm._s(text.meta))]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2),
        expression: "text.text2"
      }],
      domProps: {
        "value": (text.text2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text2", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(text.text2) ? _c('img', {
      staticStyle: {
        "height": "2em"
      },
      attrs: {
        "src": 'https://static.booking.branasgruppen.se/static/img/produkter/' + text.text2
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text3),
        expression: "text.text3"
      }],
      domProps: {
        "value": (text.text3)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text3", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text4),
        expression: "text.text4"
      }],
      domProps: {
        "value": (text.text4)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text4", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text7),
        expression: "text.text7"
      }],
      domProps: {
        "value": (text.text7)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text7", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.number1),
        expression: "text.number1"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.number1)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "number1", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.number2),
        expression: "text.number2"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.number2)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "number2", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.number3),
        expression: "text.number3"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (text.number3)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "number3", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text5),
        expression: "text.text5"
      }],
      domProps: {
        "value": (text.text5)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text5", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text6),
        expression: "text.text6"
      }],
      domProps: {
        "value": (text.text6)
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text, "text6", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [(_vm.bikeHeightCategories && _vm.bikeHeightCategories.length) ? _c('div', [_c('div', {
      staticStyle: {
        "font-size": "0.85em",
        "margin-bottom": "0.25rem",
        "max-width": "140px",
        "word-break": "break-word",
        "font-weight": "400"
      }
    }, _vm._l((_vm.getSelectedCategories(text.json1)), function(catId, catIndex) {
      return _c('span', {
        key: catId,
        staticStyle: {
          "display": "inline-block",
          "background-color": "#eee",
          "padding": "2px 6px",
          "border-radius": "4px",
          "margin-right": "4px",
          "margin-bottom": "4px"
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.getCategoryName(catId)) + "\n                ")])
    }), 0), _vm._v(" "), _c('button', {
      staticClass: "small white border tight",
      staticStyle: {
        "padding": "2px 6px",
        "font-size": "0.8em"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openSelectModal(text)
        }
      }
    }, [_vm._v(_vm._s(_vm.getSelectedCategories(text.json1).length ? 'Ändra' : 'Lägg till'))])]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "13"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._l((_vm.missingTexts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(text.id1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(text.original) + " | " + _vm._s(text.meta))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "11"
      }
    }, [_vm._v(" ")])])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.category === 'skischoolgroup') ? _c('table', [_vm._m(6), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', {
      style: (text.pool_ids && text.pool_ids.length ? '' : 'color: #AAA;')
    }, [_c('td', [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "margin-bottom": "2px"
      }
    }, [_vm._v(_vm._s(_vm.friendlySkiSchoolGroupId(text.id1)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "0.8em",
        "padding-left": "0.25rem"
      }
    }, [_vm._v(_vm._s(text.id1))]), _vm._v(" "), (text.product_names && text.product_names.length) ? _c('div', {
      staticStyle: {
        "font-size": "0.8em",
        "padding-left": "0.25rem",
        "padding-top": "0.25rem"
      }
    }, [_vm._v("\n              " + _vm._s(text.product_names.join(', ')) + "\n            ")]) : _vm._e(), _vm._v(" "), (text.pool_ids && text.pool_ids.length) ? _c('div', {
      staticStyle: {
        "font-size": "0.8em",
        "padding-left": "0.25rem",
        "padding-top": "0.25rem"
      }
    }, [_vm._v("\n              Pool(er): " + _vm._s(text.pool_ids.join(', ')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text1[_vm.selectedLanguage]),
        expression: "text.text1[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text1[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text1, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text2[_vm.selectedLanguage]),
        expression: "text.text2[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text2[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text2, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text3[_vm.selectedLanguage]),
        expression: "text.text3[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text3[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text3, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text4[_vm.selectedLanguage]),
        expression: "text.text4[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text4[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text4, _vm.selectedLanguage, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (text.text5[_vm.selectedLanguage]),
        expression: "text.text5[selectedLanguage]"
      }],
      domProps: {
        "value": (text.text5[_vm.selectedLanguage])
      },
      on: {
        "change": function($event) {
          return _vm.updateText(text)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(text.text5, _vm.selectedLanguage, $event.target.value)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('button', {
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Lägg till")])])])]), _vm._v(" "), (_vm.missingTexts.filter(function (t) { return t.category === _vm.category; }).length) ? _c('tbody', [_vm._m(7), _vm._v(" "), _vm._m(8)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.missingTexts), function(text, index) {
    return (text.category === _vm.category) ? _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s((text.pool_ids || []).join(', ')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((text.product_names || []).join(', ')))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.friendlySkiSchoolGroupId(text.id1)))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#777",
        "font-family": "monospace",
        "font-size": "0.85em",
        "margin-left": "8px"
      }
    }, [_vm._v("(" + _vm._s(text.id1) + ")")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addFromMissing(text, index)
        }
      }
    }, [_vm._v("Lägg till text")])])])]) : _vm._e()
  })], 2) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Pool-ID")]), _vm._v(" "), _c('th', [_vm._v("Rubrik")]), _vm._v(" "), _c('th', [_vm._v("Bild")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Beskrivning")]), _vm._v(" "), _c('th', [_vm._v("Plural")]), _vm._v(" "), _c('th', [_vm._v("Kopplad produkt")]), _vm._v(" "), _c('th', [_vm._v("Obl. städ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Kategori")]), _vm._v(" "), _c('th', [_vm._v("Nyckel")]), _vm._v(" "), _c('th', [_vm._v("Text")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Underrubrik"), _c('br'), _vm._v("ny skidhyra")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Ordning"), _c('br'), _vm._v("på grupp")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Ordning"), _c('br'), _vm._v("i grupp")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "13"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_vm._v("Produkter utan texter...")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "min-width": "180px"
    }
  }, [_vm._v("Grupp")]), _vm._v(" "), _c('th', [_vm._v("Rubrik")]), _vm._v(" "), _c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Förkunskaper")]), _vm._v(" "), _c('th', [_vm._v("Bildrubrik")]), _vm._v(" "), _c('th', [_vm._v("Önskemål")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_vm._v("Skolor utan matchande text")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Pool-ID")]), _vm._v(" "), _c('th', [_vm._v("Namn / Kod")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nyckel")]), _vm._v(" "), _c('th')])
}]}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.displayDate))]), _vm._v(" "), _c('div', {
    staticClass: "go-back"
  }, [_c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  })], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('router-view', {
    on: {
      "reload": function($event) {
        return _vm.fetch(true)
      }
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "inner-container"
  }, [_c('div', {
    staticClass: "snowflake"
  }), _vm._v(" "), _c('p', {
    staticClass: "booking-id text-sm"
  }, [_vm._v("\n    Bokningsnummer: " + _vm._s(_vm.order.resvid) + "\n  ")]), _vm._v(" "), (_vm.orderTypeSingle === 'accomodation') ? _c('div', {
    staticClass: "accomodation-outer"
  }, [_c('div', {
    staticClass: "accomodation-rows"
  }, _vm._l((_vm.order.details.rows.accomodation), function(row) {
    return _c('div', {
      key: row.rowid
    }, [(row.accommodation) ? _c('div', {
      staticClass: "accommodation"
    }, [_c('div', {
      staticClass: "accommodation-image",
      style: ((row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) ? 'background-image:url(' + (row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) + ')' : 'background-size: cover;')
    }), _vm._v(" "), _c('div', {
      staticClass: "booking-facts"
    }, [_c('p', {
      staticClass: "booking-title"
    }, [_vm._v("\n                " + _vm._s(row.accommodation.display_name || row.accommodation.description_title)), (row.accommodation.subtitle) ? _c('span', [_vm._v(" – " + _vm._s(row.accommodation.subtitle))]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "arrival-date"
    }, [_vm._v("\n                " + _vm._s(_vm._f("dateRange")([_vm.order.details.firstDate, _vm.order.details.lastDate], 'long', ' – ')) + "\n              ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "1.5rem"
      }
    }, [_vm._v("\n                Incheckning: " + _vm._s(row.accommodation.check_in_time)), _c('br'), _vm._v("\n                Utcheckning: " + _vm._s(row.accommodation.check_out_time) + "\n              ")]), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
      staticStyle: {
        "margin-top": "0.5rem"
      }
    }, [_vm._v("\n                " + _vm._s(row.accommodation.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].title) + ": \n                " + _vm._s(row.accommodation.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].description : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].description) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && row.accommodation.lock_type_id) ? _c('div', {
      staticStyle: {
        "margin-top": "0.5rem"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[row.accommodation.lock_type_id].title) + ": " + _vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[row.accommodation.lock_type_id].description) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2rem",
        "margin-bottom": "1rem"
      }
    }, [_c('UnitFacts', {
      attrs: {
        "unit": row.accommodation,
        "small": true
      }
    })], 1)])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "links only-large-screen"
  }, _vm._l((_vm.links(1)), function(link, key) {
    return _c('a', {
      key: 'links1-' + key,
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.orderTypeSingle !== 'accomodation') ? _c('div', [_c('div', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "other-image",
    style: ('background-image:url(' + 'https://cdn.branasgruppen.se/branas/app/uploads/2023/10/27141148/familjmedskidor_hero.jpg' + ');')
  }), _vm._v(" "), _c('div', {
    staticClass: "booking-facts"
  }, [_c('div', [_c('p', {
    staticClass: "booking-title"
  }, [_vm._v("\n              " + _vm._s(_vm.orderTypeVisual) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "arrival-date"
  }, [_vm._v("\n              " + _vm._s(_vm._f("dateRange")([_vm.order.details.firstDate, _vm.order.details.lastDate], 'long', ' – ')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "links only-large-screen"
  }, _vm._l((_vm.links(1)), function(link, key) {
    return _c('a', {
      key: 'links1-' + key,
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "booking-checkboxes"
  }, _vm._l((_vm.categories), function(cat) {
    return _c('div', {
      key: cat.slug,
      staticClass: "row-wrap"
    }, [_c('div', {
      staticClass: "row-header"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('Checkbox', {
      attrs: {
        "label": "",
        "label-position": "right",
        "value": cat.has
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "category"
    }, [_vm._v(_vm._s(cat.title))]), _vm._v(" "), (cat.slug === 'rental') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openRental = !_vm.openRental
        }
      }
    }, [_vm._v(_vm._s(_vm.openRental ? 'Dölj' : 'Visa'))]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (cat.slug === 'skipass') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openSkipass = !_vm.openSkipass
        }
      }
    }, [_vm._v(_vm._s(_vm.openSkipass ? 'Dölj' : (_vm.showQrCodeButton ? 'Visa mer, QR-koder' : 'Visa')))]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (cat.slug === 'skischool') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openSkischool = !_vm.openSkischool
        }
      }
    }, [_vm._v(_vm._s(_vm.openSkischool ? 'Dölj' : 'Visa'))]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (cat.slug === 'accomodation') ? _c('div', {
      staticClass: "actions"
    }, [(cat.has) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goToAccommodation(cat.product_slug)
        }
      }
    }, [_vm._v("Visa boende")]) : _vm._e(), _vm._v(" "), (!cat.has) ? _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookMoreWithLink(cat.link, _vm.order)
        }
      }
    }, [_vm._v("Boka nu")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row-content"
    }, [(_vm.openSkipass && cat.slug === 'skipass' && _vm.showQrCodeButton) ? _c('button', {
      staticClass: "button--rounded--outlined qr-button",
      on: {
        "click": _vm.openQrModal
      }
    }, [_vm._v("QR-koder till liftkortsautomat")]) : _vm._e(), _vm._v(" "), _c('PrettyOrderDetails', {
      key: cat.slug + 'pod' + (new Date()),
      attrs: {
        "order": _vm.order,
        "types": [cat.slug],
        "variant": "mini",
        "openRental": _vm.openRental,
        "openSkipass": _vm.openSkipass,
        "openSkischool": _vm.openSkischool,
        "bookMoreCallback": _vm.bookMore
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "links only-small-screen"
  }, _vm._l((_vm.links(1)), function(link, key) {
    return _c('a', {
      key: 'links1-' + key,
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])
  }), 0), _vm._v(" "), (_vm.addons.length) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "booking-checkboxes booking-checkboxes--addons"
  }, _vm._l((_vm.addons), function(addon) {
    return _c('div', {
      key: addon.lid,
      staticClass: "row-wrap"
    }, [_c('div', {
      staticClass: "row-header"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('Checkbox', {
      attrs: {
        "label": "",
        "label-position": "right",
        "value": _vm.hasAddons.indexOf(addon.lid) !== -1
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "category"
    }, [_vm._v(_vm._s(addon.arttext))]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [(!addon.added) ? _c('button', {
      staticClass: "button--rounded--outlined",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.bookAddon()
        }
      }
    }, [_vm._v("Boka")]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-box",
    staticStyle: {
      "margin": "4rem 0 2rem 0"
    }
  }, [_vm._v("\n      Vid ändringar kontakta gästservice på 054-13 26 00\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin": "4rem 2rem 2rem 2rem"
    }
  }, [_c('button', {
    staticClass: "button--rounded",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToBooking(_vm.order.headlid)
      }
    }
  }, [_vm._v("Fler detaljer")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outer-links"
  }, _vm._l((_vm.links(2)), function(link, key) {
    return _c('div', {
      key: 'links2-' + key
    }, [_c('div', {
      staticClass: "icon-wrapper"
    }, [_c('icon', {
      attrs: {
        "name": "arrow-white",
        "scale": 0.7
      }
    })], 1), _vm._v(" "), _c('a', {
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])])
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addon-title"
  }, [_c('h2', [_vm._v("Populära tillval")])])
}]}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-switcher"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/css/flag-icon.min.css"
    }
  }), _vm._v(" "), (_vm.type === 'dropdown') ? _c('div', {
    staticClass: "component dropdown"
  }, [(_vm.showTitle) ? _c('div', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Select your country")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('Dropdown', {
    attrs: {
      "options": _vm.countries,
      "validated": _vm.selectedCountry && _vm.selectedCountry.value,
      "value": _vm.selectedCountry ? _vm.selectedCountry.value : null,
      "label": _vm.label,
      "with-background": false,
      "bold-label": true,
      "type": "cleanlarge",
      "allow-empty": false,
      "combo": false
    },
    on: {
      "changed": _vm.changedCountry
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.params.title) ? _c('h1', [_vm._v(_vm._s(_vm.params.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.params.yes) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.params.yes()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.yes')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.ok) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.params.ok()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.okay')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.params.no) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.params.no()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.no')) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.params.buttons), function(btn) {
    return _c('button', {
      class: btn.class,
      on: {
        "click": function($event) {
          return btn.click()
        }
      }
    }, [_vm._v("\n      " + _vm._s(btn.title) + "\n    ")])
  })], 2), _vm._v(" "), (this.params.embed) ? _c(this.params.embed, {
    tag: "component",
    attrs: {
      "config": this.params
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', {
    staticClass: "uppercase center",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('skischool.explanation-title')))]), _vm._v(" "), _c('div', {
    staticClass: "items-list"
  }, _vm._l((_vm.infos), function(ref) {
    var title = ref.title;
    var description = ref.description;
    var color = ref.color;
    var text = ref.text;

    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-header"
    }, [_c('span', {
      staticClass: "circle",
      style: ({
        'background-color': color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "title",
      style: ({
        'color': color
      })
    }, [_vm._v(_vm._s(title))]), _c('span', {
      staticClass: "description"
    }, [_vm._v("— " + _vm._s(description))])]), _vm._v(" "), _c('div', {
      staticClass: "item-body"
    }, [_vm._v("\n        " + _vm._s(text) + "\n      ")])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "accomodation-info"
  }, [(_vm.showModal()) ? _c('Modal', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left-col default-image",
    style: ((_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) ? 'background-image:url(' + (_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) + ')' : 'background-size: cover;')
  }), _vm._v(" "), _c('div', {
    staticClass: "right-col"
  }, [_c('AccomodationPeriodConfirm', {
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    },
    on: {
      "gotprice": _vm.setExternalSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("\n      " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n      "), (_vm.unit.subtitle) ? _c('i', [_vm._v(_vm._s(_vm.unit.subtitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.unit.description_short || _vm.unit.description_longer)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "booking-box"
  }, [_c('h2', [_vm._v("Välj antal resenärer")]), _vm._v(" "), _c('p', [_vm._v("För att göra bokningen enklare behöver du fylla i antalet resenärer.\n      ")]), (_vm.SITE_CONFIG.skipass.ages.adults) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Vuxen "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.adults) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.adults,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeAdults($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.youths) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Ungdom "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.youths) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.youths,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeYouths($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.seniors) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Senior "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.seniors) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.seniors,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeSeniors($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.ages.children) ? _c('div', {
    staticStyle: {
      "padding-right": "4px"
    }
  }, [_c('b', [_vm._v("Barn "), _c('span', [_vm._v("(" + _vm._s(_vm.SITE_CONFIG.skipass.ages.children) + " år):")])]), _vm._v(" "), _c('CounterButton', {
    staticClass: "counter-button small",
    attrs: {
      "inline": true,
      "count": _vm.children,
      "min": 0,
      "suffix": "st"
    },
    on: {
      "changedCount": function($event) {
        return _vm.changeChildren($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    class: {
      disabled: !_vm.validated()
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(_vm._s(_vm.cartAccomodationObject.confirmed ? 'Spara' : 'Lägg till i varukorg') + " "), (!_vm.cartAccomodationObject.confirmed) ? _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.5
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'variant--' + _vm.variant
  }, [(_vm.types.indexOf('rental') !== -1 && _vm.extradetails('rental').length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openRental),
      expression: "openRental"
    }],
    staticClass: "more-details"
  }, [_vm._l((_vm.extradetails('rental')), function(person, k) {
    return _c('div', {
      key: k,
      staticClass: "person"
    }, [_c('div', {
      staticClass: "th"
    }, [_vm._v(_vm._s(Object.values(person)[0][0].skiername))]), _vm._v(" "), _vm._l((Object.values(person)), function(detail, kk) {
      return _c('div', {
        key: 'd' + kk,
        staticClass: "td"
      }, [_c('div', {
        staticClass: "details"
      }, [_vm._l((detail), function(detail2, kkk) {
        return _c('div', {
          key: 'd2' + kkk
        }, [(detail2.productname && detail2.productname.toLowerCase().indexOf('utkörning') !== -1) ? _c('span', [_vm._v(_vm._s(detail2.productname))]) : _c('span', [_vm._v(_vm._s(detail2.productname) + _vm._s(detail2.skierage ? ', ' + detail2.skierage.toLowerCase() : ''))])])
      }), _vm._v(" "), (_vm.skierAttributes(detail[0])) ? _c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(_vm.skierAttributes(detail[0])))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(detail[0].arrival))]), _vm._v(" "), (detail[0].days) ? _c('div', {
        staticClass: "text-sm",
        staticStyle: {
          "margin-top": "0.25rem"
        }
      }, [_vm._v(_vm._s(detail[0].days) + " dagar")]) : _vm._e()])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('button', {
    staticClass: "button--rounded--outlined",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bookMore('rental')
      }
    }
  }, [_vm._v("Boka mer")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(" ")])])])], 2) : _vm._e(), _vm._v(" "), (_vm.types.indexOf('skipass') !== -1 && _vm.extradetails('skipass').length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openSkipass),
      expression: "openSkipass"
    }],
    staticClass: "more-details"
  }, [_vm._l((_vm.extradetails('skipass')), function(person, k) {
    return _c('div', {
      key: k,
      staticClass: "person"
    }, [_c('div', {
      staticClass: "th"
    }, [_vm._v(_vm._s(Object.values(person)[0][0].skiername))]), _vm._v(" "), _vm._l((Object.values(person)), function(detail, kk) {
      return _c('div', {
        key: 'd' + kk,
        staticClass: "td"
      }, [_c('div', {
        staticClass: "details"
      }, _vm._l((detail), function(detail2, kkk) {
        return _c('div', {
          key: 'd2' + kkk
        }, [_vm._v(_vm._s(detail2.name))])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(detail[0].arrival))])])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('button', {
    staticClass: "button--rounded--outlined",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bookMore('skipass')
      }
    }
  }, [_vm._v("Boka mer")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(" ")])])])], 2) : _vm._e(), _vm._v(" "), (_vm.types.indexOf('skischool') !== -1 && _vm.extradetails('skischool').length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openSkischool),
      expression: "openSkischool"
    }],
    staticClass: "more-details"
  }, [_vm._l((_vm.extradetails('skischool')), function(person, k) {
    return _c('div', {
      key: k,
      staticClass: "person"
    }, [_c('div', {
      staticClass: "th"
    }, [_vm._v(_vm._s(Object.values(person)[0][0].skiername))]), _vm._v(" "), _vm._l((Object.values(person)), function(detail, kk) {
      return _c('div', {
        key: 'd' + kk,
        staticClass: "td"
      }, [_c('div', {
        staticClass: "details"
      }, [_vm._l((detail), function(detail2, kkk) {
        return _c('div', {
          key: 'd2' + kkk
        }, [_vm._v(_vm._s(detail2.name))])
      }), _vm._v(" "), (_vm.schoolerAttributes(detail[0])) ? _c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(_vm.schoolerAttributes(detail[0])))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(detail[0].arrival))])])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('button', {
    staticClass: "button--rounded--outlined",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bookMore('skischool')
      }
    }
  }, [_vm._v("Boka mer")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(" ")])])])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.fullsize ? 'isfullsize' : 'normal' + ' slideshow-wrapper'
  }, [(_vm.showNow || !_vm.fullsize) ? _c('agile', {
    ref: "main",
    staticClass: "main-slideshow",
    attrs: {
      "options": _vm.options1
    },
    on: {
      "beforeChange": function($event) {
        return _vm.syncThumbnails($event)
      }
    }
  }, [_vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "slide",
      on: {
        "click": function($event) {
          return _vm.openFullSlideShow(index)
        }
      }
    }, [_c('div', {
      staticClass: "blur"
    }), _vm._v(" "), _c('div', {
      staticClass: "image",
      style: ('background-image:url(' + image.path_corrected + ')')
    })])
  }), _vm._v(" "), _c('template', {
    slot: "prevButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg"
    }
  })]), _vm._v(" "), _c('template', {
    slot: "nextButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-right.svg"
    }
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.showNow || !_vm.fullsize) ? _c('agile', {
    ref: "thumbnails",
    staticClass: "thumbnails",
    attrs: {
      "options": _vm.options2
    }
  }, [_vm._l((_vm.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "slide thumbnail",
      on: {
        "click": function($event) {
          return _vm.$refs.main.goTo(index)
        }
      }
    }, [_c('div', {
      staticClass: "image",
      style: ('background-image:url(' + image.path_corrected + ')')
    })])
  }), _vm._v(" "), _c('template', {
    slot: "prevButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg"
    }
  })]), _vm._v(" "), _c('template', {
    slot: "nextButton"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-right.svg"
    }
  })])], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-width"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading
    }
  }, [_c('h1', [_vm._v("GDPR-rensa")]), _vm._v(" "), _c('label', [_vm._v("Välj datum att rensa från")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": false,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerRangeModal,
      "clicked-suffix": _vm.dateClear
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.clean
    }
  }, [_vm._v("Rensa online-registret innan " + _vm._s(_vm.formatDate(_vm.pickedStartDate)))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.env !== 'production') ? _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Bokning")]), _vm._v(" "), _c('ul', [(_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'accomodation list'
      }
    }
  }, [_vm._v("Boenden")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'addons'
      }
    }
  }, [_vm._v("Tillval")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.skiletting) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ski rental'
      }
    }
  }, [_vm._v("Skidhyra")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.skipass) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ski pass'
      }
    }
  }, [_vm._v("Liftkort")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.school) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: 'skidskola/oversikt?type=group'
      }
    }
  }, [_vm._v("Skidskola")])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.activities) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'activities'
      }
    }
  }, [_vm._v("Barnktiviteter")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Övriga sidor")]), _vm._v(" "), _c('ul', [(_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'my pages'
      }
    }
  }, [_vm._v("Mina sidor")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'shopping cart'
      }
    }
  }, [_vm._v("Varukorg")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Admin")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin'
      }
    }
  }, [_vm._v("Admin")])], 1), _vm._v(" "), (_vm.SITE_CONFIG.modules.accomodation) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-accomodations'
      }
    }
  }, [_vm._v("Boenden")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-settings'
      }
    }
  }, [_vm._v("Inställningar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-texts'
      }
    }
  }, [_vm._v("Texter")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-stats-orders'
      }
    }
  }, [_vm._v("Ordrar")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Inställningar")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Rensa varukorg och inställningar")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.clean()
      }
    }
  }, [_vm._v("Rensa varukorg, inställningar och logga ut")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.cleanCart()
      }
    }
  }, [_vm._v("Rensa varukorg")])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.setLocal()
      }
    }
  }, [_vm._v("Sätt backend-URL")]), _vm._v(" "), _c('h2', [_vm._v("Features")]), _vm._v(" "), _c('table', _vm._l((_vm.SITE_CONFIG.features), function(isActive, feature) {
    return _c('tr', {
      key: feature
    }, [_c('td', {
      staticStyle: {
        "padding-right": "5rem"
      }
    }, [_vm._v(_vm._s(feature))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(isActive ? '✅' : '❌'))])])
  }), 0), _vm._v(" "), _c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('table', _vm._l((_vm.SITE_CONFIG.settings), function(value, setting) {
    return _c('tr', {
      key: setting
    }, [_c('td', {
      staticStyle: {
        "padding-right": "5rem"
      }
    }, [_vm._v(_vm._s(setting))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    style: ((_vm.inline ? 'width:auto; display:inline-block;' : ''))
  }, [_c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: {
      round: true
    },
    attrs: {
      "disabled": _vm.count <= _vm.min
    },
    on: {
      "click": _vm.subtract
    }
  }, [_c('icon', {
    attrs: {
      "name": "Minus",
      "scale": 1.5
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "counter"
  }, [_c('strong', [_vm._v(_vm._s(_vm.count))]), _vm._v(_vm._s(_vm.suffix))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: {
      round: true
    },
    attrs: {
      "disabled": _vm.count >= _vm.max
    },
    on: {
      "click": _vm.add
    }
  }, [_c('icon', {
    attrs: {
      "name": "Plus",
      "scale": 1.5
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      cart: true, showing: _vm.showing, 'from-start': _vm.showFromStart, 'remote': !_vm.useStorage
    },
    style: (_vm.showFromStart ? 'position:static;' : '')
  }, [(_vm.showing && _vm.localCart.accomodations) ? _c('div', [(!_vm.useStorage) ? _c('div', [(_vm.localCart.rows.accomodation && _vm.localCart.rows.accomodation.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.accomodation')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows.accomodation), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.accommodation ? (row.accommodation.display_name || row.accommodation.description_title) : row.name))]), _vm._v(" "), (row.accommodation && row.accommodation.subtitle) ? _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    }, [_vm._v("\n              " + _vm._s(row.accommodation.subtitle) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (_vm.SITE_CONFIG.add_to_booking_open && _vm.localCart.can_add_to_booking) ? _c('div', {
      staticClass: "col count"
    }, [_c('button', {
      staticClass: "small white border",
      on: {
        "click": function($event) {
          return _vm.bookAddon(row)
        }
      }
    }, [_vm._v("Boka tillval")])]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.addon && _vm.localCart.rows.addon.length) ? _c('div', _vm._l((_vm.localCart.rows.addon), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.skipass && _vm.localCart.rows.skipass.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.skipass')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows.skipass), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.rental ? row.rental.name : row.name) + ", " + _vm._s(row.age_text))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    }, [_vm._v("\n              " + _vm._s(row.pickup === 'DELIVERY' ? 'Utkörning' : row.pickup) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.rental && _vm.localCart.rows.rental.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.equipment')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows.rental), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.rental ? row.rental.name : row.name) + _vm._s(row.age_text ? ', ' + row.age_text : ''))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    }, [_vm._v("\n              " + _vm._s(row.pickup === 'DELIVERY' ? 'Utkörning' : row.pickup) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.skischool && _vm.localCart.rows.skischool.length) ? _c('div', [_c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.school')))])]), _vm._v(" "), _vm._l((_vm.localCart.rows['skischool']), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px",
        "margin-bottom": "8px"
      }
    }, [_c('button', {
      staticClass: "small white border",
      on: {
        "click": function($event) {
          return _vm.rowInfo(row)
        }
      }
    }, [_vm._v("Info")])])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localCart.rows.other && _vm.localCart.rows.other.length) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.localCart.rows['other']), function(row, index) {
    return _c('div', {
      class: 'row ' + (row.cancelled ? 'cancelled' : '')
    }, [_c('div', {
      staticClass: "col type"
    }, [_c('span', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "2px",
        "margin-bottom": "8px",
        "font-weight": "300"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm._f("dateRange")([row.date_arrival, row.date_departure], 'D MMMM', ' - '))) + "\n          ")], 1), _vm._v(" "), (row.quantity != 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n            " + _vm._s(row.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n          ")]) : _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")((row.quantity * row.price))) + "\n          ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "col"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.sum')))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.total-neutrum')) + ": " + _vm._s(_vm._f("currency")(_vm.localCart.sum)))])])]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', [(_vm.localCart.accomodations.filter(function(object) {
    return object.confirmed;
  }).length || _vm.localCart.addons.filter(function(object) {
    return object.confirmed;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.accomodation')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.accomodations), function(accomodation, index) {
    return (accomodation.confirmed) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(accomodation.name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(accomodation.period.date_arrival, 'dddd')) + " - " + _vm._s(_vm.moment(accomodation.period.date_departure, 'dddd')) + "\n           \n        " + _vm._s(_vm.moment(accomodation.period.date_arrival, 'D MMMM')) + " - " + _vm._s(_vm.moment(accomodation.period.date_departure, 'D MMMM')) + "\n      ")], 1), _vm._v(" "), _c('div', {
      class: 'col count hide-on-small'
    }, [_vm._v("\n         \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(accomodation.quantity) * _vm.number(accomodation.price),
        "discounted": _vm.accomodationDiscountedPrice(accomodation)
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((_vm.number(accomodation.quantity) * _vm.number(accomodation.price)))) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'accomodations',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.localCart.addons), function(addon, index) {
    return (addon.confirmed && !addon.hide_for_guest) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(addon.title) + "\n        "), (addon.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[addon.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), (addon.editableQuantity || addon.quantity > 1) ? _c('div', {
      class: 'col count ' + (addon.quantity > 1 ? '' : 'hide-on-small')
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ":")]), _vm._v(" "), (addon.editableQuantity) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addon.quantity),
        expression: "addon.quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (addon.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addon, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(addon.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")])]) : _c('div', {
      class: 'col count ' + (addon.quantity > 1 ? '' : 'hide-on-small')
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      class: 'col price ' + (addon.discount ? 'has-discount' : '')
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(addon.quantity) * _vm.number(addon.price),
        "discounted": _vm.addonDiscountedPrice(addon)
      }
    }), _vm._v(" "), (addon.discount) ? _c('div', {
      staticClass: "discount"
    }, [(addon.discount.type === 'percentage' && addon.discount.code === 'rut') ? _c('div', [_vm._v("\n            " + _vm._s(_vm.$t('accomodation.cleaning-tax-reduction')) + ": -" + _vm._s(_vm._f("currency")(((_vm.number(addon.quantity) * _vm.number(addon.price)) * (addon.discount.amount / 100)))) + "\n          ")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [(!addon.locked) ? _c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'addons',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1) : _vm._e()]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), (
    _vm.localCart.skipasses.filter(function(object) {
      return object.confirmed && (parseInt(object.adults) || parseInt(object.youths) || parseInt(object.children) || parseInt(object.seniors));
    }).length ||
    _vm.localCart.skipasses.filter(function(object) {
      return object.confirmed && object.type === '';
    }).length
  ) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.skipass')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.skipasses), function(skipass, index) {
    return (skipass.confirmed && skipass.type === 'SKIPASS-ACCO') ? _c('div', [(!skipass.hideadults) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.ages.adult')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.adults),
        expression: "skipass.adults"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.adults)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "adults", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.adults) * _vm.number(skipass.adultsPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'adult', 'adults')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.adults) * _vm.number(skipass.adultsPrice)))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'adults'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e(), _vm._v(" "), (!skipass.hideseniors) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.ages.senior')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.seniors),
        expression: "skipass.seniors"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.seniors)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "seniors", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.seniors) * _vm.number(skipass.seniorsPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'senior', 'seniors')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.seniors) * _vm.number(skipass.seniorsPrice)))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'seniors'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e(), _vm._v(" "), (!skipass.hideyouths) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.ages.youth')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.youths),
        expression: "skipass.youths"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.youths)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "youths", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.youths) * _vm.number(skipass.youthsPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'youth', 'youths')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.youths) * _vm.number(skipass.youthsPrice)))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'youths'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e(), _vm._v(" "), (!skipass.hidechildren) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.days) + " " + _vm._s(_vm.$t('general.days')) + " / " + _vm._s(_vm.$t('general.child')) + "\n          "), (skipass.belongsTo > -1 && _vm.localCart.accomodations.filter(function(a) {
      return a.confirmed;
    }).length > 1) ? _c('div', {
      staticClass: "thin"
    }, [_vm._v(_vm._s(_vm.localCart.accomodations[skipass.belongsTo].name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date min-tablet"
    }, [_vm._v("\n           \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.children),
        expression: "skipass.children"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.children)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "children", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.children) * _vm.number(skipass.childrenPrice),
        "discounted": _vm.accomodationSkipassDiscountedPrice(skipass, 'child', 'children')
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.children) * _vm.number(skipass.childrenPrice)), {
      freeIfZero: true
    })) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index,
            age: 'children'
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', _vm._l((_vm.localCart.skipasses), function(skipass, index) {
    return (skipass.confirmed && (skipass.type === 'SKIPASS' || skipass.type === '')) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n          " + _vm._s(skipass.title) + " / " + _vm._s({
      'children': _vm.$t('general.ages.child'),
      'youths': _vm.$t('general.ages.youth'),
      'adults': _vm.$t('general.ages.adult'),
      'parents': _vm.$t('general.ages.parents'),
      'seniors': _vm.$t('general.ages.senior')
    } [skipass.age]) + "\n          / " + _vm._s(skipass.refill ? _vm.$t('skipass.load') : (skipass.keycardPrice ? _vm.$t('skipass.with-keycard') : '')) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n          " + _vm._s(_vm.moment(skipass.date_arrival, 'D MMMM')) + "\n        ")], 1), _vm._v(" "), _c('div', {
      staticClass: "col count"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('general.number')) + ": ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.quantity),
        expression: "skipass.quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (skipass.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_c('PriceView', {
      attrs: {
        "price": _vm.number(skipass.quantity) * (_vm.number(skipass.price) + (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0)),
        "discounted": skipass.discountedPrice && skipass.discountedPrice > 0 ? (_vm.number(skipass.quantity) * (_vm.number(skipass.discountedPrice) + (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0))) : (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0)
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")((_vm.number(skipass.quantity) * (_vm.number(skipass.price) + (skipass.keycardPrice ? _vm.number(skipass.keycardPrice) : 0))))) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skipasses',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.localCart.rentals.filter(function(object) {
    return object.confirmed;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.equipment')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.rentals), function(rental, index) {
    return (rental.confirmed) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(rental.name)), (rental.insurance) ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('skirental.incl-insurance')) + ")")]) : _vm._e(), _vm._v(" "), (rental.products || rental.addons) ? _c('ul', [_vm._l((rental.products), function(product) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(product.name) + "\n          ")])
    }), _vm._v(" "), _vm._l((rental.addons), function(product) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(product.name) + "\n          ")])
    }), _vm._v(" "), (rental.insurance) ? _c('li', {
      staticClass: "sub"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('skirental.insurance.text')) + " "), (!this.SITE_CONFIG.rental.insurance_per_product) ? _c('span', [_vm._v("(" + _vm._s(_vm._f("currency")(rental.insuranceSum)) + ")")]) : _vm._e()]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(rental.startDate, 'D MMMM')) + ", " + _vm._s((rental.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : rental.days) + " " + _vm._s((rental.priceType === 'night' ?
      ((_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'kungsberget') ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
        hours: _vm.SITE_CONFIG.rental.night_hours
      })) :
      (rental.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
    )) + "\n      ")], 1), _vm._v(" "), _c('div', {
      class: 'col count ' + (rental.quantity > 1 ? '' : 'hide-on-small')
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), (_vm.SITE_CONFIG.rental.insurance_per_product) ? _c('div', {
      staticClass: "col price"
    }, [(_vm.localCart.campaignCode) ? _c('div', [_c('PriceView', {
      attrs: {
        "price": _vm.getProductPrice(rental),
        "discounted": _vm.getProductPrice(rental, true)
      }
    })], 1) : _vm._e(), _vm._v(" "), (!_vm.localCart.campaignCode) ? _c('div', [_vm._v("\n          " + _vm._s(_vm._f("currency")((rental.quantity * rental.price))) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'rentals',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.localCart.products || [])), function(product, index) {
    return (_vm.SITE_CONFIG.rental.delivery_fee_active && parseInt(product.poolId, 10) === parseInt(_vm.SITE_CONFIG.rental.delivery_fee_pool_lid, 10)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(product.name) + "\n        "), _c('div', {
      staticClass: "thin",
      staticStyle: {
        "font-weight": "300",
        "font-size": "12px",
        "margin-top": "4px"
      }
    }, [_vm._v("Utkörning till " + _vm._s((_vm.localCart.deliveryTo && _vm.localCart.deliveryTo.name) ? _vm.localCart.deliveryTo.name : 'ditt boende'))])]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }), _vm._v(" "), _c('div', {
      class: 'col count ' + (product.quantity > 1 ? '' : 'hide-on-small')
    }, [(product.quantity > 1) ? _c('span', [_vm._v("\n          " + _vm._s(product.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]) : _c('span', [_vm._v("\n           \n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((product.quantity * product.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.removeDelivery()
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), (_vm.localCart.skischools.filter(function(object) {
    return true;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.school')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.skischools), function(school, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(school.name) + "\n        "), (school.people.length) ? _c('ul', _vm._l((school.people), function(person) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(person.name) + "\n          ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(school.date, 'D MMMM')) + ", " + _vm._s(school.days) + " " + _vm._s(_vm.$t('general.days')) + ", " + _vm._s(school.time) + "\n      ")], 1), _vm._v(" "), (school.quantity > 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n        " + _vm._s(school.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n      ")]) : _c('div', {
      staticClass: "col count hide-on-small"
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((school.quantity * school.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'skischools',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')])
  }), _vm._v(" "), ((_vm.localCart.activities || []).filter(function(object) {
    return true;
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('general.activities')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.localCart.activities), function(activity, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(activity.name) + "\n        "), (activity.people.length) ? _c('ul', _vm._l((activity.people), function(person) {
      return _c('li', {
        staticClass: "sub"
      }, [_vm._v("\n            " + _vm._s(person.name) + "\n          ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }, [_c('icon', {
      attrs: {
        "name": "calendar-blue",
        "scale": 1.5
      }
    }), _vm._v("\n        " + _vm._s(_vm.moment(activity.date, 'D MMMM')) + ", " + _vm._s(activity.days) + " " + _vm._s(_vm.$t('general.days')) + ", " + _vm._s(activity.time) + "\n      ")], 1), _vm._v(" "), (activity.quantity > 1) ? _c('div', {
      staticClass: "col count"
    }, [_vm._v("\n        " + _vm._s(activity.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n      ")]) : _c('div', {
      staticClass: "col count hide-on-small"
    }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((activity.quantity * activity.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'activities',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')])
  }), _vm._v(" "), ((_vm.localCart.products || []).filter(function(object) {
    return !_vm.SITE_CONFIG.rental.delivery_fee_active || parseInt(object.poolId, 10) !== parseInt(_vm.SITE_CONFIG.rental.delivery_fee_pool_lid, 10);
  }).length) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Produkter")])]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.localCart.products || [])), function(product, index) {
    return (!_vm.SITE_CONFIG.rental.delivery_fee_active || parseInt(product.poolId, 10) !== parseInt(_vm.SITE_CONFIG.rental.delivery_fee_pool_lid, 10)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col type"
    }, [_vm._v("\n        " + _vm._s(product.name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col date"
    }), _vm._v(" "), _c('div', {
      class: 'col count hide-on-small'
    }, [(product.editableQuantity === false) ? _c('span', [_vm._v("\n          " + _vm._s(product.quantity) + " " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")]) : _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.quantity),
        expression: "product.quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (product.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(product, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "col actions"
    }), _vm._v(" "), _c('div', {
      staticClass: "col price"
    }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((product.quantity * product.price))) + "\n      ")]), _vm._v(" "), (_vm.useStorage) ? _c('div', {
      staticClass: "col trash"
    }, [_c('button', {
      staticClass: "small trash border",
      on: {
        "click": function($event) {
          return _vm.localRemoveCartItem({
            type: 'products',
            index: index
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _c('div')]) : _vm._e()
  }), _vm._v(" "), (_vm.hasDelivery && (!_vm.SITE_CONFIG.rental.delivery_fee_active || _vm.SITE_CONFIG.rental.delivery_fee_price <= 0 || _vm.localCart.parent_has_delivery_fee)) ? _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Utkörning")])]) : _vm._e(), _vm._v(" "), (_vm.hasDelivery && (!_vm.SITE_CONFIG.rental.delivery_fee_active || _vm.SITE_CONFIG.rental.delivery_fee_price <= 0 || _vm.localCart.parent_has_delivery_fee)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col type",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        Utkörning till " + _vm._s((_vm.localCart.deliveryTo && _vm.localCart.deliveryTo.name) ? _vm.localCart.deliveryTo.name : 'ditt boende') + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col date"
  }), _vm._v(" "), _c('div', {
    class: 'col count hide-on-small'
  }), _vm._v(" "), _c('div', {
    staticClass: "col actions"
  }), _vm._v(" "), _c('div', {
    staticClass: "col price"
  }, [(_vm.SITE_CONFIG.rental.delivery_fee_active && _vm.localCart.parent_has_delivery_fee) ? _c('span') : _c('span', [_vm._v(_vm._s(_vm._f("currency")(0, {
    freeIfZero: true
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "col trash"
  }, [_c('button', {
    staticClass: "small trash border",
    on: {
      "click": function($event) {
        return _vm.removeDelivery()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.5
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "col"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('general.sum')))])]), _vm._v(" "), (_vm.cart.campaignCode) ? _c('div', {
    staticClass: "col",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.total-neutrum')) + ": \n        "), _c('PriceView', {
    attrs: {
      "price": _vm.totalPrice(false),
      "discounted": _vm.totalPrice(true)
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.cart.campaignCode) ? _c('div', {
    staticClass: "col",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.total-neutrum')) + ": " + _vm._s(_vm._f("currency")(_vm.totalPrice())))]) : _vm._e()]), _vm._v(" "), (!_vm.showFromStart) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col right"
  }, [_c('button', {
    staticClass: "small light-blue",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.closeCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.continue-booking')))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.pay()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.to-checkout')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white"
    }
  })], 1)])]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-trigger",
    attrs: {
      "id": "cart-trigger"
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "category-header"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Övrigt")])])
}]}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'dropdown-wrapper ' + (_vm.isOpen ? 'active' : '') + ' ' + (_vm.validated ? 'validated' : '') + ' type--' + _vm.type + ' ' + (_vm.error ? 'error' : '')
  }, [_c('label', {
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.prefixicon) ? _c('span', {
    staticClass: "prefix"
  }, [(!_vm.validated) ? _c('icon', {
    attrs: {
      "name": _vm.prefixicon,
      "scale": 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validated) ? _c('icon', {
    attrs: {
      "name": _vm.prefixiconValidated,
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.combo && _vm.isOpen) ? _c('div', {
    staticClass: "value-editor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      },
      "keyup": function($event) {
        return _vm.setValueFromTyping($event, {
          value: _vm.search
        })
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.combo && !_vm.isOpen) ? _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLabel)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.combo && !_vm.valuebinder) ? _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLabel)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.combo && _vm.valuebinder) ? _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLabel + ' ' + _vm.valueSuffix)
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "suffix",
    on: {
      "click": _vm.clickSuffix
    }
  }, [(_vm.type === 'large' && _vm.allowEmpty) ? _c('icon', {
    attrs: {
      "name": _vm.validated ? 'circle-green-minus' : 'chevron-down',
      "scale": _vm.validated ? 1.6 : 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'large' && !_vm.allowEmpty) ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'clean') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'language') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'country') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'cleanlarge') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'month') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1.2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'mini') ? _c('icon', {
    attrs: {
      "name": "sort-blue",
      "scale": 1
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    ref: "options",
    staticClass: "options",
    style: ('max-height:' + this.optionHeight + 'px;')
  }, [_vm._l((_vm.filteredOptions), function(option) {
    return _c('div', {
      class: {
        selected: (option.value === _vm.valuebinderComputed), option: true, 'option-row': !option.separator, separator: option.separator
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setValue(option)
        }
      }
    }, [(_vm.type === 'clean') ? _c('Checkbox', {
      attrs: {
        "label-position": "after",
        "label": "",
        "value": option.value,
        "valuebinder": _vm.tempValue,
        "size": 16
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.tempValue = $event
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'language') ? _c('div', {
      staticClass: "flag",
      style: ('background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + option.flag + '.svg)')
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'country') ? _c('div', {
      staticClass: "flag",
      style: ('background-image: url(' + option.flag + ')')
    }) : _vm._e(), _vm._v(" "), _c('b', {
      staticStyle: {
        "margin-left": "7px"
      },
      domProps: {
        "innerHTML": _vm._s(option.title)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.subtitle))]), _vm._v(" "), (option.price1) ? _c('span', {
      class: {
        price: true,
          marked: option.marked
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(option.price1)))]) : _vm._e(), _vm._v(" "), (_vm.type === 'language') ? _c('Checkbox', {
      attrs: {
        "label-position": "after",
        "label": "",
        "value": option.value,
        "valuebinder": _vm.tempValue,
        "size": 16
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.tempValue = $event
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'country') ? _c('Checkbox', {
      attrs: {
        "label-position": "after",
        "label": "",
        "value": option.value,
        "valuebinder": _vm.tempValue,
        "size": 16
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.tempValue = $event
        }
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative"
  }, [_c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  }), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [(parseInt(_vm.$route.params.person)) ? _c('div', {
    staticClass: "remove-user",
    on: {
      "click": function($event) {
        return _vm.remove(_vm.index)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.remove-title', {
    skier: ''
  })) + " "), _c('button', {
    staticClass: "white small border"
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.4
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'component ' + (_vm.allProducts.length >= 3 ? 'wider' : '')
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.pick-products', {
    skier: ''
  })) + " " + _vm._s(_vm.person.name))]), _vm._v(" "), _c('div', {
    staticClass: "blue-bar"
  }, [(_vm.selectedType === 'package') ? _c('b', [_vm._v(_vm._s(_vm.$t('skirental.package', {
    package: ''
  })) + " " + _vm._s(_vm.categories[_vm.selectedCategory]) + ":")]) : _vm._e(), _vm._v(" "), (_vm.selectedType === 'single') ? _c('b', [_vm._v(_vm._s(_vm.categories[_vm.selectedCategory]) + ":")]) : _vm._e(), _vm._v(" "), (_vm.person.type !== 'single' && _vm.person.type !== 'package') ? _c('b', [(_vm.person.onlySkipass) ? _c('b', [_vm._v(_vm._s(_vm.$t('general.skipass')) + ":")]) : _vm._e()]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.ages[_vm.person.age]) + "\n      "), (_vm.selectedLevel === 'beginner') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.beginner')))]) : _vm._e(), _vm._v(" "), (_vm.selectedLevel === 'intermediate') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.average')))]) : _vm._e(), _vm._v(" "), (_vm.selectedLevel === 'advanced') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.advanced')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.$route.query['from-single']) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Du tittar nu på våra paketerbjudanden, dessa har ett förmånligare pris än enskilda produkter. Vill du gå tillbaka till "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToSingle()
      }
    }
  }, [_vm._v("våra enstaka produkter")]), _vm._v(" istället?\n      ")]) : _vm._e()]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      flex: true, disabled: _vm.loading
    }
  }, _vm._l((_vm.allProducts), function(item) {
    return _c('div', {
      class: {
        box: true, active: (_vm.selectedProducts.indexOf(item) !== -1)
      },
      attrs: {
        "title": (_vm.$store.state.isDebugging) ? item.pool_lid : ''
      },
      on: {
        "click": function($event) {
          return _vm.setActive(item)
        }
      }
    }, [_c('div', {
      staticClass: "image default-image",
      style: (item.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + item.image + ')' : 'background-size:cover;')
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.smalltext) ? _c('p', {
      staticClass: "smalltext"
    }, [_vm._v(_vm._s(item.smalltext))]) : _vm._e(), _vm._v(" "), (item.subtitle) ? _c('p', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(item.subtitle))]) : _vm._e(), _vm._v(" "), _c('p', [(!item.buy) ? _c('span', [_vm._v(_vm._s((_vm.person.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : _vm.person.days) + " " + _vm._s((_vm.person.priceType === 'night' ?
      (_vm.SITE_CONFIG.site === 'vallasen' ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
        hours: _vm.SITE_CONFIG.rental.night_hours
      })) :
      (_vm.person.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
    )))]) : _vm._e(), _vm._v(" "), (item.buy) ? _c('span', [_vm._v(_vm._s(_vm.$t('general.buy')))]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(item['price_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')])))]), _vm._v(" "), (item['price_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')] !== item['price_' + 'original_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')]) ? _c('span', {
      staticClass: "original-price"
    }, [_vm._v(_vm._s(_vm._f("currency")(item['price_' + 'original_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')])))]) : _vm._e()]), _vm._v(" "), _c('div', [(item.description) ? _c('button', {
      staticClass: "float-left outline-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(item)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 1.4
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.info-short')))], 1) : _vm._e(), _vm._v(" "), _c('button', {
      class: {
        small: true, green: (_vm.selectedProducts.indexOf(item) !== -1), 'float-right': true
      }
    }, [_vm._v("\n            " + _vm._s(_vm.selectedProducts.indexOf(item) !== -1 ? _vm.$t('general.picked') : _vm.$t('general.pick')) + "\n          ")]), _vm._v(" "), ((_vm.selectedProducts.indexOf(item) !== -1)) ? _c('button', {
      class: 'small trash border float-right'
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.3
      }
    })], 1) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.showPackageInfo) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Du har valt produkter som ingår i paketerbjudanden, dessa har ett förmånligare pris än enskilda produkter. Vill du kolla på "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToPackages()
      }
    }
  }, [_vm._v("våra paket")]), _vm._v(" istället?\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center space-3"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.selectedProducts.length === 0 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-on')))])])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component",
    attrs: {
      "id": "app",
      "data-site": _vm.currentRoute
    }
  }, [_c('AddonBookingHeader'), _vm._v(" "), _c('Cart'), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.currentModal) ? _c(_vm.currentModal.component, {
    tag: "div",
    attrs: {
      "params": _vm.getCurrentModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getCurrentTimeoutModal) ? _c(_vm.currentTimeoutModal.component, {
    tag: "div",
    attrs: {
      "params": _vm.getCurrentTimeoutModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "cart-background"
  }), _vm._v(" "), (_vm.$store.state.isDebugging) ? _c('div', {
    staticClass: "debugging",
    on: {
      "click": function($event) {
        _vm.$store.state.isDebugging = false
      }
    }
  }, [_vm._v("\n    API: " + _vm._s(_vm.apiUrl) + "        \n    "), _vm._l((_vm.languages), function(lang) {
    return _c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setLanguage(lang)
        }
      }
    }, [_vm._v(_vm._s(lang))])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('WebFooter') : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.env !== 'production' && _vm.SITE_CONFIG.is_production) ? _c('div', {
    staticClass: "production-mode-alert"
  }, [_vm._v("\n    ⚠️ Produktionsläge ⚠️\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.params.title || 'Välj'))]), _vm._v(" "), _c('div', {
    staticClass: "multiselect-container"
  }, [_vm._l((_vm.params.options), function(option) {
    return _c('div', {
      key: option.id,
      staticClass: "option-row"
    }, [_c('Checkbox', {
      attrs: {
        "label": option.name,
        "label-position": "right",
        "value": true,
        "valuebinder": _vm.localSelection[option.id],
        "type": "checkbox",
        "special-class": "wishes"
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(_vm.localSelection, option.id, $event)
        }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s('Spara'))])])])
},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "code"
  })
},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Kassa\n")])
},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(!_vm.isDiscounted) ? _c('span', {
    class: 'price'
  }, [_vm._v("\n    " + _vm._s(_vm._f("currency")(_vm.priceOriginal)) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isDiscounted) ? _c('span', {
    class: 'price price--discounted'
  }, [_c('span', {
    staticClass: "price--original"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.priceOriginal)))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "price--discounted"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.priceDiscounted)))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'datepicker datepicker-' + _vm.type
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('span', [_c('button', {
    class: 'prev' + (_vm.canGoToPrevious ? '' : ' disabled'),
    on: {
      "click": _vm.prevMonth
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-left",
      "scale": 0.7
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "month"
  }, [_c('Dropdown', {
    ref: "monthDropdown",
    attrs: {
      "options": _vm.validMonths,
      "validated": false,
      "value": '',
      "label": "",
      "with-background": false,
      "bold-label": false,
      "allow-empty": false,
      "combo": false,
      "type": "month"
    },
    on: {
      "changed": _vm.updateMonthFromPicker
    }
  })], 1), _vm._v(" "), _c('span', [_c('button', {
    class: 'next' + (_vm.canGoToNext ? '' : ' disabled'),
    on: {
      "click": _vm.nextMonth
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right",
      "scale": 0.7
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dates"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr"
  }, _vm._l((_vm.days), function(day) {
    return _c('div', {
      staticClass: "th"
    }, [_vm._v("\n            " + _vm._s(day.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, _vm._l((_vm.weeks), function(week) {
    return _c('div', {
      staticClass: "tr"
    }, _vm._l((week.days), function(day, index) {
      return _c('div', {
        staticClass: "td"
      }, [(!index) ? _c('span', {
        staticClass: "week-number"
      }, [_vm._v("\n              v." + _vm._s(_vm._f("date")(week.days[0].value, 'W')) + "\n            ")]) : _vm._e(), _vm._v(" "), (day.visible) ? _c('button', {
        class: [
          'day',
          day.active && 'active',
          day.activeRange && 'active-range',
          day.activeEnd && 'active-end',
          day.current && 'current',
          day.unavailable && 'unavailable',
          day.special && 'special' ],
        attrs: {
          "disabled": !day.enabled
        },
        on: {
          "click": function($event) {
            return _vm.setValue(day)
          }
        }
      }, [_c('popper', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showPopper(day)),
          expression: "showPopper(day)"
        }],
        attrs: {
          "trigger": "hover",
          "options": {
            placement: 'right'
          }
        }
      }, [_c('div', {
        staticClass: "popper"
      }, [_c('div', [_vm._v("Fullbokat")])]), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "reference"
        },
        slot: "reference"
      }, [_vm._v("\n                " + _vm._s(day.label) + "\n              ")])]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.showPopper(day)),
          expression: "!showPopper(day)"
        }]
      }, [_vm._v("\n              " + _vm._s(day.label) + "\n            ")])], 1) : _vm._e()])
    }), 0)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "1120px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.isSummer ? _vm.SITE_CONFIG.skischool.map_summer : _vm.SITE_CONFIG.skischool.map
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.activeFiltersCount > 0) ? _c('div', {
    staticClass: "active-filters-list"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Valda filter:")]), _vm._v(" "), _c('ul', _vm._l((_vm.activeFilters), function(value, filter) {
    return _c('li', [_c('FilterListItem', {
      attrs: {
        "filter": filter,
        "label": (filter === 'locationId' ? ('Område: ' + _vm.area(value)) : null),
        "value": value
      },
      on: {
        "click": function($event) {
          _vm.awaitFilter();
          _vm.resetAccomodationsFilter(filter)
        }
      }
    })], 1)
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.poolCount > 1) ? _c('span', {
    staticClass: "text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.unitCount))]), _vm._v(" resultat (över " + _vm._s(_vm.poolCount) + " områden),\n      "), _c('span', [_vm._v(_vm._s(_vm.selectedFilterObject.explanation))])]) : _vm._e(), _vm._v(" "), (_vm.poolCount <= 1) ? _c('span', {
    staticClass: "text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.unitCount))]), _vm._v(" resultat\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeFiltersCount > 0 || _vm.$store.state.accomodationsFilter.freeSearch),
      expression: "activeFiltersCount > 0 || $store.state.accomodationsFilter.freeSearch"
    }],
    ref: "resetButton",
    staticClass: "reset-button reset-filter-text",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n        Återställ filter "), _c('icon', {
    attrs: {
      "name": "Reset",
      "scale": 1.3
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sort-filter"
  }, [_c('Dropdown', {
    attrs: {
      "options": _vm.filters,
      "validated": _vm.selectedFilter && _vm.selectedFilter.value,
      "value": _vm.selectedFilter,
      "label": (_vm.selectedFilter && _vm.selectedFilter.value) ? ('Sortering: ' + (_vm.selectedFilter.title)) : 'Sortera efter',
      "with-background": true,
      "bold-label": true,
      "type": "clean"
    },
    on: {
      "changed": _vm.changedSorting,
      "clicked-suffix": function($event) {
        return _vm.changedSorting({})
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'scanner-container ' + (_vm.waitingForClose ? 'scanner-container--frozen' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanning || _vm.starting),
      expression: "scanning || starting"
    }],
    class: 'video-wrapper ' + (_vm.waitingForClose ? 'video-wrapper--frozen' : '')
  }, [_c('video', {
    ref: "video",
    staticClass: "scanner-video",
    attrs: {
      "autoplay": "",
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scanner-overlay"
  }, [_c('div', {
    class: 'scanner-area ' + (_vm.partialOk ? 'scanner-area--partial-ok' : '')
  }, [(_vm.waitingForClose) ? _c('div', {
    staticClass: "scanner-result-scanned"
  }, [_c('pre', [_vm._v(_vm._s(_vm.formattedResult))])]) : _vm._e()])])]), _vm._v(" "), ( false) ? _c('div', {
    class: 'scanner-loading ' + (_vm.loading ? 'scanner-loading--loading' : '')
  }, [_vm._v("\n    Scanning...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "scanner-error"
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scanner-result"
  }, [( false) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.scanRawResult) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.starting && !_vm.scanning && !_vm.error) ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        return _vm.startCamera()
      }
    }
  }, [_vm._v("Starta om skanning")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "modal-relative",
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [(_vm.showDate) ? _c('div', {
    class: {
      'dropdown-wrap-wrapper': true, 'disabled': _vm.loading, 'visible': !_vm.loading
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-date')))]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": _vm.pickedStartDate,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.showDate && _vm.isSeason) ? _c('div', {
    staticClass: "box info",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.pickup-seasoncard')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.pickup-seasoncard-instructions-1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.obs')))]), _vm._v(" " + _vm._s(_vm.$t('skipass.pickup-seasoncard-instructions-2')))])]) : _vm._e(), _vm._v(" "), (_vm.showDate) ? _c('div', {
    staticClass: "box info",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.hasRefill) ? _c('p', [_vm._v("För laddade liftkort: välj "), _c('strong', [_vm._v("första åkdag")]), _vm._v(".")]) : _vm._e(), _vm._v(" "), (_vm.hasRefill && _vm.hasNonRefill) ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.hasNonRefill) ? _c('p', [_vm._v("För nya liftkort: välj den dag du vill "), _c('strong', [_vm._v("hämta")]), _vm._v(" ditt liftkort.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasNonRefill) ? _c('div', {
    class: 'space center info-wrapper'
  }, [(_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center"
  }, [_vm._v("När ska liftkorten börja användas?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationAfterCheckinText,
      "value": 'delivery',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationBeforeCheckinText,
      "value": 'pickup',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.SETTING('SettingSkipassMachineInfo').title + '<br />')
    }
  }), _vm._v(" "), _vm._l((_vm.SETTING('SettingSkipassMachineInfo').paragraphs), function(paragraph, index) {
    return _c('p', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines') && _vm.hasNonRefill) ? _c('div', {
    staticClass: "space center info-wrapper"
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("Var vill du hämta liftkorten?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Byn",
      "value": 'by',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Berget",
      "value": 'berg',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    class: (!_vm.validated ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$t('general.pay-with-card') : _vm.$t('general.add-to-cart')))])])])
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agile",
    class: {
      'agile--auto-play': _vm.settings.autoplay, 'agile--disabled': _vm.settings.unagile, 'agile--fade': _vm.settings.fade && !_vm.settings.unagile, 'agile--rtl': _vm.settings.rtl
    }
  }, [_c('div', {
    ref: "list",
    staticClass: "agile__list"
  }, [_c('div', {
    ref: "track",
    staticClass: "agile__track",
    style: ({
      transform: ("translate(" + (_vm.translateX + _vm.marginX) + "px)"),
      transition: ("transform " + (_vm.settings.timing) + " " + _vm.transitionDelay + "ms")
    }),
    on: {
      "mouseover": function($event) {
        return _vm.handleMouseOver('track')
      },
      "mouseout": function($event) {
        return _vm.handleMouseOut('track')
      }
    }
  }, [(_vm.clonedSlides) ? _c('div', {
    ref: "slidesClonedBefore",
    staticClass: "agile__slides agile__slides--cloned"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "slides",
    staticClass: "agile__slides agile__slides--regular"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.clonedSlides) ? _c('div', {
    ref: "slidesClonedAfter",
    staticClass: "agile__slides agile__slides--cloned"
  }, [_vm._t("default")], 2) : _vm._e()])]), _vm._v(" "), (!_vm.settings.unagile && (_vm.settings.navButtons || _vm.settings.dots)) ? _c('div', {
    staticClass: "agile__actions"
  }, [(_vm.settings.navButtons && !_vm.settings.unagile) ? _c('button', {
    ref: "prevButton",
    staticClass: "agile__nav-button agile__nav-button--prev",
    attrs: {
      "disabled": !_vm.canGoToPrev,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToPrev(), _vm.restartAutoPlay()
      }
    }
  }, [_vm._t("prevButton", [_vm._v("←")])], 2) : _vm._e(), _vm._v(" "), (_vm.settings.dots && !_vm.settings.unagile) ? _c('ul', {
    ref: "dots",
    staticClass: "agile__dots"
  }, _vm._l((_vm.slidesCount), function(n) {
    return _c('li', {
      key: n,
      staticClass: "agile__dot",
      class: {
        'agile__dot--current': n - 1 === _vm.currentSlide
      },
      on: {
        "mouseover": function($event) {
          return _vm.handleMouseOver('dot')
        },
        "mouseout": function($event) {
          return _vm.handleMouseOut('dot')
        }
      }
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goTo(n - 1), _vm.restartAutoPlay()
        }
      }
    }, [_vm._v(_vm._s(n))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.settings.navButtons && !_vm.settings.unagile) ? _c('button', {
    ref: "nextButton",
    staticClass: "agile__nav-button agile__nav-button--next",
    attrs: {
      "disabled": !_vm.canGoToNext,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToNext(), _vm.restartAutoPlay()
      }
    }
  }, [_vm._t("nextButton", [_vm._v("→")])], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    class: {
      disabled: _vm.loading, 'max-width': true
    }
  }, [_c('h1', [_vm._v("Översättningar")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.generateTranslations()
      }
    }
  }, [_vm._v("Skapa översättningar")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.generateTranslationsFromFiles()
      }
    }
  }, [_vm._v("Skapa översättningar utifrån befintliga översättningar")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.getFile('en')
      }
    }
  }, [_vm._v("Hämta engelsk fil")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.getFile('da')
      }
    }
  }, [_vm._v("Hämta dansk fil")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }, [_vm._v("Ladda upp fil")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.unit) ? _c('div', {}) : _vm._e()])]), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "h1"
  }, [_c('h1', [_vm._v(_vm._s((_vm.unit.display_name || _vm.unit.description_title)))])]), _vm._v(" "), _c('div', {
    staticClass: "special-periods"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        Specialveckor\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row"
  }, [_c('th', [_c('b', [_vm._v("Helg")])]), _vm._v(" "), _c('th', [_vm._v("\n            Datum\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Pris\n          ")])]), _vm._v(" "), _vm._l((_vm.unit.prices_special), function(price, index) {
    return _c('tr', [_c('td', [_c('b', {
      domProps: {
        "innerHTML": _vm._s(price.title)
      }
    })]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(price.days)
      }
    }), _vm._v(" "), _c('td', [(price.period.free) ? _c('span', {
      class: {
        price: true, selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == price.period.period && _vm.cartAccomodationObject.period.week == price.period.week)
      },
      on: {
        "click": function($event) {
          _vm.chooseAccomodation({
            pool_lid: _vm.unit.pool_lid,
            unit_lid: _vm.unit.unit_lid,
            period: price.period,
            week: price.period.week,
            name: (_vm.unit.display_name || _vm.unit.description_title),
            capacity: _vm.unit.capacity,
            price: price.period.price
          })
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(price.period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (!price.period.free) ? _c('span', {
      staticClass: "taken"
    }, [_vm._v("\n              uthyrd\n            ")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "normal-periods"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        PRISÖVERSIKT\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.meta_super_titles), function(meta, index) {
    return _c('th', {
      staticClass: "period-super-title",
      attrs: {
        "colspan": _vm.meta_periods.length / _vm.meta_super_titles.length
      }
    }, [_vm._v("\n            " + _vm._s(meta) + "\n          ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "title-row"
  }, [_c('th', {
    staticClass: "week-indicator"
  }, [_c('b', [_vm._v("Vecka")])]), _vm._v(" "), _vm._l((_vm.meta_periods), function(period) {
    return _c('th', {
      staticClass: "week-day-title"
    }, [_vm._v("\n            " + _vm._s(period.days) + "\n          ")])
  })], 2), _vm._v(" "), _vm._l((_vm.unit.prices), function(week, index) {
    return (index >= _vm.meta_weeks[0] && index <= _vm.meta_weeks[1]) ? _c('tr', [_c('td', {
      staticClass: "week-indicator",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('b', [_vm._v("v." + _vm._s(week.week))]), _vm._v(" "), _c('popper', {
      attrs: {
        "trigger": "click",
        "options": {
          placement: 'right'
        }
      }
    }, [_c('div', {
      staticClass: "popper"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.showDates(week.periods))
      }
    })]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("\n                Datum\n              ")])])], 1), _vm._v(" "), _vm._l((week.periods), function(period) {
      return _c('td', [(period && period.free) ? _c('span', {
        class: {
          price: true, selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == period.period && _vm.cartAccomodationObject.period.week == period.week)
        },
        on: {
          "click": function($event) {
            _vm.chooseAccomodation({
              pool_lid: _vm.unit.pool_lid,
              unit_lid: _vm.unit.unit_lid,
              period: period,
              week: week.week,
              name: (_vm.unit.display_name || _vm.unit.description_title),
              capacity: _vm.unit.capacity,
              price: period.price
            })
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (period && !period.free) ? _c('span', {
        staticClass: "taken"
      }, [_vm._v("\n              uthyrd\n            ")]) : _vm._e()])
    })], 2) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin-top": "15px"
    }
  }), _vm._v(" "), (!_vm.loaded) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Tillgängligheten uppdaterades senast " + _vm._s(_vm._f("fromNow")(_vm.meta_updated)) + "... De laddas nu om, var god vänta...")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'campaign-code ' + _vm.cssStateClasses
  }, [(_vm.isValid === _vm.CODE_STATE.NOT_TRIED || _vm.isValid === _vm.CODE_STATE.CHECKING || _vm.isValid === _vm.CODE_STATE.INVALID) ? _c('div', [_c('p', [_vm._v("Har du en kampanjkod? Använd den här.")]), _vm._v(" "), _c('div', {
    staticClass: "code-wrapper"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    class: {
      error: !!_vm.errorMessage
    },
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tryCode($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('Loading', {
    attrs: {
      "text": 'Kontrollerar kampanjkod ' + _vm.code + '...',
      "show": _vm.isValid === _vm.CODE_STATE.CHECKING,
      "static": true
    }
  }), _vm._v(" "), (_vm.isValid !== _vm.CODE_STATE.CHECKING) ? _c('button', {
    staticClass: "small",
    attrs: {
      "disabled": !_vm.code
    },
    on: {
      "click": _vm.tryCode
    }
  }, [_vm._v("Använd")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    class: 'error-message'
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isValid === _vm.CODE_STATE.VALID || _vm.isValid === _vm.CODE_STATE.REMOVING) ? _c('div', {
    staticClass: "code-wrapper"
  }, [_c('div', {
    staticClass: "code-wrapper-inner"
  }, [_c('div', {
    staticStyle: {
      "padding-right": "1em"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "1em 0"
    }
  }, [_vm._v("Bokar med kampanjkod: "), _c('b', [_vm._v(_vm._s(_vm.code))])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.removeCode
    }
  }, [_vm._v("Ta bort")])])]), _vm._v(" "), (_vm.requiresExtraInput) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "580px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.requiresExtraInputMessage)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraInput),
      expression: "extraInput"
    }],
    class: {
      error: !!_vm.errorMessage
    },
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.extraInput)
    },
    on: {
      "keyup": _vm.updateExtraInfo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.extraInput = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "940px"
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('img', {
    staticClass: "high-five",
    attrs: {
      "src": 'https://static.booking.branasgruppen.se/static/img/bjorn.svg'
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('general.highfive')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.localClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-to-cart')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('general.cart-upsell-title')))]), _vm._v(" "), _c('CompletedBookings', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('SkiRentalDiscount', {
    attrs: {
      "click-link": "/skidhyra"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "box center"
  }, [( true) ? _c('img', {
    staticStyle: {
      "height": "40px",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg"
    }
  }) : _vm._e(), _vm._v(" "), ( true) ? _c('p', [_vm._v("\n      Du kan strax hitta din bokning under\n      "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.myPage
    }
  }, [_vm._v("Mina sidor")]), _vm._v("\n      .\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.signedin) ? _c('CheckUpdateAddress') : _vm._e(), _vm._v(" "), _c('CollectorCheckout', {
    attrs: {
      "initial-public-token": _vm.publicToken
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-listing"
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "collapsed",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = true
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [(_vm.SITE_CONFIG.skischool.map) ? _c('button', {
    staticClass: "btn white border small",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal(['SkiSchoolLocationMap'])
      }
    }
  }, [_c('span', {
    staticClass: "min-tablet"
  }, [_vm._v(_vm._s(_vm.$t('skischool.map-gathering-sites')))]), _vm._v(" "), _c('span', {
    staticClass: "max-mobile"
  }, [_vm._v(_vm._s(_vm.$t('skischool.map')))]), _vm._v(" "), _c('icon', {
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn white border small"
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book')) + " / " + _vm._s(_vm.$t('general.pick-time')))])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down-white"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.expanded) ? _c('div', {
    staticClass: "expanded"
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = false
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('general.close')))]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('table', [_c('thead', [_c('tr', [(_vm.SITE_CONFIG.skischool.show_site) ? _c('th', {
    staticClass: "min-tablet",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(['SkiSchoolLocationMap'])
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('skischool.gathering-site')) + " "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.3
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [((['branas', 'kungsberget'].indexOf(_vm.SITE_CONFIG.site) !== -1) || !_vm.info.is_private) ? _c('span', [_vm._v(_vm._s(_vm.$t('general.days')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('general.people-count')))])]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('general.time')) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('general.price')) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  })])]), _vm._v(" "), _c('transition-group', {
    staticClass: "animate-pool-list",
    attrs: {
      "name": "animate-pool-list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.courses), function(course, index) {
    return _c('tr', {
      key: course.id,
      staticClass: "animate-pool-list-item",
      class: {
        odd: index % 2
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(course)
        }
      }
    }, [(_vm.SITE_CONFIG.skischool.show_site) ? _c('td', {
      staticClass: "site",
      attrs: {
        "scope": "row"
      }
    }, [(course.site === 2) ? _c('span', [_c('icon', {
      attrs: {
        "name": "berget",
        "scale": 1.4
      }
    }), _vm._v(_vm._s(course.site_name))], 1) : (course.site === 1) ? _c('span', [_c('icon', {
      attrs: {
        "name": "byn",
        "scale": 1.4
      }
    }), _vm._v(_vm._s(course.site_name))], 1) : _c('span', [_c('icon', {
      attrs: {
        "name": "gondol",
        "scale": 1.4
      }
    }), _vm._v(_vm._s(course.site_name))], 1)]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "unit-title",
      attrs: {
        "scope": "row"
      }
    }, [((['branas', 'kungsberget'].indexOf(_vm.SITE_CONFIG.site) !== -1) || !_vm.info.is_private) ? _c('span', [(course.force_display_name) ? _c('span', [_c('strong', [_vm._v(_vm._s(course.display_name))])]) : _vm._e(), _vm._v(" "), (!course.force_display_name) ? _c('span', [(course.availableDays.length === 1 && _vm.showWhichDays) ? _c('span', [(course.availableDays[0] === course.availableEndDays[0]) ? _c('strong', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("join")(_vm._f("weekday")(course.availableDays)))) + ", ")]) : _c('strong', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("join")(_vm._f("weekday")(course.availableDays)))) + "-" + _vm._s(_vm._f("capitalize")(_vm._f("join")(_vm._f("weekday")(course.availableEndDays)))) + ", ")])]) : _vm._e(), _vm._v(" "), (course.days > 1) ? _c('strong', [_vm._v(_vm._s(course.days) + " " + _vm._s(_vm.$t('general.days'))), (course.during_christmas) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.christmas')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (course.days === 1) ? _c('strong', [_vm._v(_vm._s(course.days) + " " + _vm._s(_vm.$t('general.day'))), (course.during_christmas) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.christmas')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _c('span', [_c('strong', [_vm._v(_vm._s(course.min_participants))]), _vm._v(" " + _vm._s(_vm.$t('general.pieces-short')))])]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_c('icon', {
      attrs: {
        "name": "clock",
        "scale": 1.1
      }
    }), _vm._v(" " + _vm._s(course.minutes) + _vm._s(_vm.$t('general.minutes-short')) + "/" + _vm._s(_vm.$t('skischool.lesson')) + "\n              ")], 1), _vm._v(" "), _c('td', {
      staticClass: "unit-title",
      attrs: {
        "scope": "row"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(course.priceMax)))])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('div', [(_vm.$store.state.isDebugging) ? _c('span', [_vm._v("\n                    " + _vm._s(course.id) + "/" + _vm._s(course.pool_lid) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "outline-button price-info-bt",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(course)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('general.cta.book')))])])])])
  }), 0)], 1)])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('header', [_vm._t("header")], 2), _vm._v(" "), _c('main', [_vm._t("default")], 2), _vm._v(" "), _c('footer', [_vm._t("footer")], 2)])
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "set-class": 'no-padding',
      "wide": false,
      "width": '500px',
      "min-width": "320px",
      "show-close": true
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [_c('div', [(_vm.passes.length) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.existing-booking-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.existing-booking-text')))])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passes.length) ? _c('div', {
    staticClass: "padding center"
  }, [(_vm.passes.length) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goOn()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.existing-booking-continue')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.people-count-title')))]), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v(_vm._s(_vm.$t('skipass.count-title')))]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "blocked info blue"
  }, [_c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.openPriceList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.see-pricelist')))])]), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, [_c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.begin-booking')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "blocked info green"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.children-free-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.children-free-text').replace('55', _vm.SITE_CONFIG.skipass.keycard_price)))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.params.componentType || 'Modal', {
    tag: "component",
    attrs: {
      "set-class": "no-padding",
      "clickOutside": _vm.clickOutside
    },
    on: {
      "close": _vm.closeTheModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  })]), _vm._v(" "), _c('div', {
    class: {
      'modal-content': true, disabled: (!_vm.open && !_vm.params.allowPrevious)
    }
  }, [_c('div', {
    staticClass: "datepicker-modal-content notranslate"
  }, [_c('div', {
    staticClass: "datepicker"
  }, [(!_vm.theStartDate || _vm.params.startDateOnly) ? _c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-startdate')))]) : _c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-enddate')))]), _vm._v(" "), _c('Datepicker', {
    ref: "pickerDate",
    attrs: {
      "type": _vm.params.type,
      "validDate": _vm.validStartDate,
      "validRangeDate": _vm.validRangeDate,
      "value": _vm.startDate,
      "value-end": _vm.endDate,
      "range": _vm.selectRange,
      "select-range": _vm.selectRange,
      "allow-previous": _vm.params.allowPrevious,
      "disabledDays": _vm.getDisabledDays,
      "specialDays": _vm.getSpecialDays,
      "startMonth": _vm.params.startMonth,
      "showAllMonths": _vm.params.showAllMonths
    },
    on: {
      "change": _vm.changedStartDate,
      "change-end": _vm.changedEndDate,
      "month-change": _vm.updateMonth
    }
  }), _vm._v(" "), (_vm.infoMessage) ? _c('div', {
    staticClass: "footer green"
  }, [(_vm.infoMessage !== '-') ? _c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', [_vm._v("Första tillgängliga tid för hämtning av liftkort denna dag är "), _c('b', [_vm._v(_vm._s(_vm.infoMessage))])])], 1) : _vm._e(), _vm._v(" "), (_vm.infoMessage === '-') ? _c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', [_vm._v("Det finns inga tider kvar denna dag")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSummerSeason) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "info info--big"
  }, [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title) ? _c('div', [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info1) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info1)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2) ? _c('div', {
    staticStyle: {
      "width": "1.5em",
      "height": "1.5em",
      "background-color": "#005580",
      "border-radius": "50%",
      "vertical-align": "middle",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2)
    }
  })]), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3) ? _c('div', {
    staticStyle: {
      "width": "1.5em",
      "height": "1.5em",
      "background-color": "#bfd9e1",
      "border-radius": "50%",
      "vertical-align": "middle",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3)
    }
  })]), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info4) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info4)
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[0]) ? _c('div', {
    staticClass: "footer green"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[0])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.theStartDate && _vm.selectRange) ? _c('div', {
    staticClass: "info",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.infoOnPicked ? _vm.params.infoOnPicked : (_vm.params.disableSingle ? 'Du måste boka minst två dagar' : _vm.$t('skirental.pick-enddate')))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theStartDate && !_vm.theEndDate && !_vm.params.disableSingle),
      expression: "theStartDate && !theEndDate && !params.disableSingle"
    }]
  }, [(_vm.selectRange) ? _c('span', [(_vm.showNight) ? _c('button', {
    staticClass: "datepicker-bt block",
    staticStyle: {
      "margin-bottom": "6px"
    },
    on: {
      "click": function($event) {
        return _vm.selectDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.day-options.day')) + " " + _vm._s(_vm._f("date")(_vm.theStartDate)))]) : _vm._e(), _vm._v(" "), (_vm.showNight) ? _c('button', {
    staticClass: "datepicker-bt block",
    on: {
      "click": function($event) {
        return _vm.selectNight()
      }
    }
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.site === 'vallasen' ?
    _vm.$t('skirental.day-options.night') :
    (_vm.SITE_CONFIG.site === 'ulricehamn' ?
      (_vm.$t('skirental.day-options.hours', {
        hours: _vm.SITE_CONFIG.rental.night_hours
      }) + '/' + _vm.$t('general.night')) :
      _vm.$t('skirental.day-options.night')
    )) + " " + _vm._s(_vm._f("date")(_vm.theStartDate)))]) : _vm._e(), _vm._v(" "), (!_vm.showNight) ? _c('button', {
    staticClass: "datepicker-bt block",
    on: {
      "click": function($event) {
        return _vm.selectDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.day-options.one-day')) + " " + _vm._s(_vm._f("date")(_vm.theStartDate)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.selectRange) ? _c('button', {
    staticClass: "datepicker-bt block",
    on: {
      "click": function($event) {
        return _vm.selectDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.params.terminology ? _vm.params.terminology : _vm.$t('general.cta.book')))]) : _vm._e()]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theStartDate && !_vm.selectRange && _vm.theEndDate),
      expression: "theStartDate && !selectRange && theEndDate"
    }],
    staticClass: "datepicker-bt",
    on: {
      "click": function($event) {
        return _vm.chooseDates('day')
      }
    }
  }, [_vm._v(_vm._s(_vm.params.terminology ? _vm.params.terminology : _vm.$t('general.cta.book')) + "\n            "), (_vm.params.type === 'skiletting' && _vm.hasClosedDays) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.numberOfDays) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(_vm._f("dateRange")([_vm.theStartDate, _vm.theEndDate])) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "width-limit"
  }, [(!_vm.theStartDate) ? _c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.info ? _vm.params.info : _vm.$t('skirental.departure-usage-info'))
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[4]) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[4])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[3]) ? _c('div', {
    staticClass: "footer green"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[3])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[2]) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[2])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[1]) ? _c('div', {
    staticClass: "footer green"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[1])
    }
  })], 1)]) : _vm._e()], 1)])]), _vm._v(" "), (!_vm.open && !_vm.params.allowPrevious) ? _c('div', {
    staticClass: "overlay-no-dates"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.closedMessage)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.closeTheModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.okay')))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number) ? _c('div', [_c('div', {
    staticClass: "addon-booking-header brand--bg--dark"
  }, [(_vm.canRemoveConnection) ? _c('a', {
    staticClass: "transparent",
    attrs: {
      "href": "#/varukorg"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeConnection()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times-white",
      "scale": 2
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/varukorg"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeConnection()
      }
    }
  }, [(_vm.canRemoveConnection) ? _c('span', [_vm._v("Avsluta tilläggsbokning")]) : _vm._e(), _vm._v(" "), (!_vm.canRemoveConnection) ? _c('span', [_vm._v("Tilläggsbokning")]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "white number",
    attrs: {
      "href": "#/mina-sidor"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBooking()
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$store.state.cart.addToOrder.number))])])]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addon-booking-header addon-booking-header--right brand--bg--dark"
  }, [_c('a', {
    staticClass: "white",
    attrs: {
      "href": "#/mina-sidor"
    }
  }, [_c('i', {
    staticClass: "fal fa-lock-alt"
  }), _vm._v("\n      Mina sidor\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "white",
    attrs: {
      "href": "#/varukorg"
    }
  }, [_c('i', {
    staticClass: "fal fa-shopping-cart"
  }), _vm._v("\n      Varukorg\n    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#modal_live-booking",
      "rel": "modal:open"
    }
  }, [_c('span', [_vm._v("Boka online")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])
}]}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.modules_open.skiletting.open && _vm.SITE_CONFIG.rental.currently_discounted) ? _c('div', {
    class: {
      'discount-offer': true, 'clickable': _vm.clickLink
    },
    on: {
      "click": _vm.goToLink
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h3', [_vm._v("Kampanj på skidhyra")]), _vm._v(" "), _c('p', [_vm._v("* 10% rabatt när du bokar komplett utrustningspaket för hela din boendeperiod.\n      "), (_vm.SITE_CONFIG.site === 'branas') ? _c('span', [_vm._v("Söndag-torsdag, torsdag-söndag och söndag till söndag.")]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas') ? _c('p', {
    staticClass: "smaller"
  }, [_vm._v("(gäller t.o.m. 30/11 2023)")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('p', {
    staticClass: "smaller"
  }, [_vm._v("(gäller t.o.m. 30/11 2023)")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash"
  }, [_vm._v("Just nu "), _c('div', {
    staticClass: "larger"
  }, [_vm._v("10% rabatt*")])])
}]}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "addon-image"
  }), _vm._v(" "), _c('h2', [_vm._v("Köp eller ladda liftkort")]), _vm._v(" "), _c('p', [_vm._v(_vm._s('Våra liftkort är så kallade keycards. Kortet kostar 55 kr och laddas för perioden du vill åka skidor. Barn 0–6 år med hjälm åker gratis med keycard som laddas kostnadsfritt. Tips! Spara ditt keycard, det går att ladda igen vid nästa besök och fungerar både i Branäs och Kungsberget.'.replace('55', _vm.SITE_CONFIG.skipass.keycard_price)))])])
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, disabled: _vm.loading
    }
  }, [(_vm.isNew) ? _c('h1', [_vm._v("Skapa lösenord")]) : _c('h1', [_vm._v("Återställ lösenord")]), _vm._v(" "), (!_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Ange ett nytt, säkert lösenord nedan (minst 6 tecken långt)")]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("Nytt lösenord")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    attrs: {
      "placeholder": "Nytt lösenord",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.save()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "new_password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('p', {
    staticClass: "success-message"
  }, [_vm._v(_vm._s(_vm.successMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "block",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Spara")])])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Du är redan inloggad. "), _c('router-link', {
    attrs: {
      "to": {
        name: 'my pages'
      }
    }
  }, [_vm._v("Klicka här")]), _vm._v(" om du vill gå till dina sidor.")], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "show-close": _vm.canClose,
      "width": "550px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [(_vm.paramsType === 'without-delivery') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.people-count-title')))]) : _vm._e(), _vm._v(" "), (_vm.guidedRentals.length) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.existing-booking-title')))], 1), _vm._v(" "), _c('p', [_vm._v("Du har en påbörjad bokning i varukorgen. Du kommer att radera den bokningen om du fortsätter. Klicka på "), _c('i', [_vm._v("\"Fortsätt tidigare bokning\"")]), _vm._v(" för att ändra den påbörjade bokningen istället.")])]) : _vm._e(), _vm._v(" "), (_vm.guidedRentals.length) ? _c('div', {
    staticClass: "blocked center"
  }, [(_vm.guidedRentals.length) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goOn()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.existing-booking-continue')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.paramsType === 'with-delivery' && _vm.accomodation) ? _c('h1', {
    staticClass: "accomodation-title"
  }, [_vm._v(_vm._s(_vm.accomodation.name))]) : _vm._e()]), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('div', [(!_vm.loggedIn && !_vm.accomodation) ? _c('div', [_c('div', {
    staticClass: "blocked info",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.find-accomodation')))], 1), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('skirental.free-delivery-text', {
    clickhere: ''
  })) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'accomodation list'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.clickhere')))]), _vm._v(".\n        ")], 1)]), _vm._v(" "), _c('Login', {
    on: {
      "login": _vm.onLogin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn || _vm.accomodations.length) ? _c('div', [(_vm.accomodation) ? _c('AccomodationPeriodConfirm', {
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure,
      "small": true,
      "check-availability": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (!_vm.accomodations.length && !_vm.loading) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.no-accomodation-title')))], 1), _vm._v(" "), (!_vm.foundNotAllowedDelivery) ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.no-accomodation-text')))]) : _vm._e(), _vm._v(" "), (_vm.foundNotAllowedDelivery) ? _c('p', [_vm._v("Vi hittade inga boenden där utkörning är möjligt.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.accomodations.length > 1) ? _c('div', {
    staticClass: "blocked"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('skirental.pick-accomodation')))]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.accomodationsToSelect,
      "valuebinder": _vm.selectedAccomodation,
      "validated": _vm.accomodation,
      "label": !_vm.accomodation ? _vm.$t('skirental.pick-accomodation') : _vm.accomodation.name,
      "allow-empty": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.selectedAccomodation = $event
      },
      "changed": _vm.changedAccomodation
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.accomodations.length) ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.possibleWithStorage) ? _c('div', {
    staticClass: "blocked info test"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v("Obs! Nattförvaring")], 1), _vm._v(" "), _c('p', [_vm._v("Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.")]), _vm._v(" "), (_vm.accomodations.length > 1) ? _c('p', [_vm._v(" ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.possibleWithDelivery) ? _c('div', {
    staticClass: "blocked info extra-info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.close-time-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.close-time-text-1')))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithoutDelivery($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.clickhere')))]), _vm._v(" " + _vm._s(_vm.$t('skirental.delivery.close-time-text-2', {
    clickhere: ''
  })))])]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (_vm.paramsType === 'without-delivery' || (_vm.accomodation && _vm.possibleWithDelivery)) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v(_vm._s(_vm.$t('general.people-count')))]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'without-delivery' || (_vm.accomodation && _vm.possibleWithDelivery)) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.begin-booking')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery' && _vm.SITE_CONFIG.rental.delivery_fee_active && _vm.SITE_CONFIG.rental.delivery_fee_price > 0 && !_vm.$store.state.cart.parent_has_delivery_fee && !(_vm.accomodation && _vm.accomodation.parent_has_delivery_fee)) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s('Utkörningsavgift'))], 1), _vm._v(" "), _c('p', [_vm._v("Utkörning kostar " + _vm._s(_vm.SITE_CONFIG.rental.delivery_fee_price) + " kr per bokning.")])]) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.time-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.time-text')))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules.accomodation && !_vm.$store.state.isOnSite) ? _c('div', {
    staticClass: "blocked info"
  }, [(_vm.paramsType === 'without-delivery') ? _c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.delivery')))], 1) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.pickup')))], 1) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'without-delivery') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.delivery-text')) + "\n      "), (!_vm.addonBooking) ? _c('span', [_vm._v("\n        Gör en tilläggsbokning från "), _c('a', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithDelivery($event)
      }
    }
  }, [_vm._v("Mina sidor")]), _vm._v(" istället.\n      ")]) : _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithDelivery($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.delivery.click-here')))])])]) : _vm._e(), _vm._v(" "), (_vm.paramsType === 'with-delivery') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.delivery.pickup-text')) + " "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.openWithoutDelivery($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.delivery.click-here')))])]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "modal-relative",
    attrs: {
      "wide": false,
      "width": "520px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('p', {
    staticClass: "required-notice"
  }, [_c('span', [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t('general.mandatory-fields')))]), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('div', [(!_vm.people[0].delivery && _vm.SITE_CONFIG.accomodations.show_site) ? _c('label', {
    class: 'uppercase ' + (_vm.$store.state.isOnSite ? '' : ''),
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(['SkiSchoolLocationMap', {
          markers: _vm.SITE_CONFIG.rental.coordinates
        }])
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.extradition-point')) + " "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1.3
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.people[0].delivery && _vm.SITE_CONFIG.accomodations.show_site) ? _c('div', {
    class: 'box places ' + (_vm.$store.state.isOnSite ? '' : '') + (_vm.showError('place') ? ' box-error' : '')
  }, [(!_vm.$store.state.isOnSite || _vm.site == 1) ? _c('div', [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 1.8
    }
  }), _vm._v(" " + _vm._s(_vm.$t('general.sites.valley')) + "\n        "), (!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label": '',
      "value": 1,
      "valuebinder": _vm.site
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite || _vm.site == 2) ? _c('div', [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 1.8
    }
  }), _vm._v(" " + _vm._s(_vm.$t('general.sites.top')) + "\n        "), (!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label": '',
      "value": 2,
      "valuebinder": _vm.site
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showTimePicker) ? _c('div', [_c('label', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-time'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), (['vallasen', 'ulricehamn'].indexOf(_vm.SITE_CONFIG.site) !== -1) ? _c('p', [_vm._v("På grund av rådande restriktioner och er säkerhet har vi valt att begränsa antalet hyrutrustningar som lämnas ut vid en viss tidpunkt. Det är därför viktigt att ni här nedanför väljer den tid ni tänkt hämta er utrustning och är noga med att komma på utsatt tid.")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'box checkboxes' + (_vm.showError('time') ? ' box-error' : '')
  }, _vm._l((_vm.times), function(time) {
    return _c('div', {
      class: (!time.available) ? 'disabled' : ''
    }, [_c('Checkbox', {
      attrs: {
        "label": (time.title),
        "sublabel": ((time.available && ['vallasen', 'ulricehamn'].indexOf(_vm.SITE_CONFIG.site) !== -1) ? ('' + time.available + ' kvar') : ''),
        "label-position": "after",
        "value": time.value,
        "valuebinder": _vm.pickupTime
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.pickupTime = $event
        }
      }
    })], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t('general.mobilephonenumber')) + " (" + _vm._s(_vm.$t('general.for-sms')) + ")"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    class: 'box phone' + (_vm.showError('phone') ? ' box-error' : '')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.fixPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-number"
  }, [_vm._v(_vm._s(_vm.$t('general.obs-format', {
    format: '+46701234567'
  })))])]), _vm._v(" "), (_vm.showReceiptPicker) ? _c('div', {
    staticClass: "receipt-wrapper"
  }, [_c('label', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.$t('general.digital-receipt'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    class: 'box checkboxes' + (_vm.showError('receipt') ? ' box-error' : '')
  }, [_c('Checkbox', {
    attrs: {
      "label": _vm.$i18n.t('general.yes'),
      "label-position": "right",
      "value": true,
      "valuebinder": _vm.receipt
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.receipt = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": _vm.$i18n.t('general.no'),
      "label-position": "right",
      "value": false,
      "valuebinder": _vm.receipt
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.receipt = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showInsurance) ? _c('div', {
    class: 'box insurance' + (_vm.showError('insurance') ? ' box-error' : '')
  }, [_c('h3', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openPdf()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "avbestallning",
      "scale": 2
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('skirental.insurance.title'))), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "info-blue-white-bg",
      "scale": 1
    }
  })], 1)], 1), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.branas')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.kungsberget')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.vallasen')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'ulricehamn') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.ulricehamn')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'storstenshojden') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.branas')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'tolvmannabacken') ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.insurance.branas')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "insurance-table"
  }, [_vm._l((_vm.people), function(person) {
    return (_vm.offerInsurance(person)) ? _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n          " + _vm._s(person.name) + "\n          "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.insuranceSum(person))))])]), _vm._v(" "), _c('div', {
      staticClass: "checkboxes"
    }, [_c('Checkbox', {
      class: {
        error: _vm.markInsurance
      },
      attrs: {
        "label": _vm.$i18n.t('general.yes'),
        "label-position": "left",
        "value": true,
        "valuebinder": person.insurance
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "insurance", $event)
        }
      }
    }), _vm._v(" "), _c('Checkbox', {
      class: {
        error: _vm.markInsurance
      },
      attrs: {
        "label": _vm.$i18n.t('general.no'),
        "label-position": "left",
        "value": false,
        "valuebinder": person.insurance
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "insurance", $event)
        }
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "tr summarizer"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('skirental.insurance.total')))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalPrice)))])])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.showSaveDetails) ? _c('div', {
    class: 'box insurance' + (_vm.showError('saving') ? ' box-error' : '')
  }, [_c('h3', [_vm._v("\n      Spara åkare\n    ")]), _vm._v(" "), _c('p', [_vm._v("Vill du spara uppgifter om åkare?")]), _vm._v(" "), _c('div', {
    staticClass: "insurance-table"
  }, _vm._l((_vm.people), function(person) {
    return _c('div', {
      staticClass: "tr",
      class: {
        disabled: !_vm.whatChanged(person)
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n          " + _vm._s(person.name) + "\n          "), _c('b', [_vm._v(_vm._s(_vm.whatChangedLabel(_vm.whatChanged(person))))])]), _vm._v(" "), (_vm.whatChanged(person)) ? _c('div', {
      staticClass: "checkboxes"
    }, [_c('Checkbox', {
      attrs: {
        "label": _vm.$i18n.t('general.yes'),
        "label-position": "left",
        "value": true,
        "valuebinder": person.saveDetails
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "saveDetails", $event)
        }
      }
    }), _vm._v(" "), _c('Checkbox', {
      attrs: {
        "label": _vm.$i18n.t('general.no'),
        "label-position": "left",
        "value": false,
        "valuebinder": person.saveDetails
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "saveDetails", $event)
        }
      }
    })], 1) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.canUseCode && _vm.$store.state.isOnSite) ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.pay-cash')))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'storstenshojden') ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v("Förbokad skidutrustning hämtas i skiduthyrningen i södra Storstenshöjden.")])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen' && _vm.onlySkipass) ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.only-skipass')))])]) : _vm._e(), _vm._v(" "), (_vm.productsAvailable === null) ? _c('div', {
    staticClass: "box info"
  }, [_c('p', [_vm._v("Kontrollerar tillgänglighet...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.canUseCode) ? _c('button', {
    class: 'small white border ' + (!_vm.validated ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.openCodeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$i18n.t('general.pay-cash') : _vm.$i18n.t('general.pay-with-code')))]) : _vm._e(), _vm._v("\n     \n    "), _c('button', {
    class: (!_vm.validated ? 'disabled' : '') + ' ' + 'margin-bottom',
    on: {
      "click": function($event) {
        return _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.isOnSite ? _vm.$t('general.pay-with-card') : _vm.$t('general.add-to-cart')))]), _vm._v(" "), (_vm.canUseCode && (_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') && _vm.$store.state.isOnSite) ? _c('button', {
    class: 'small white border ' + (!_vm.validated ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.openCodeModal(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$i18n.t('general.pay-with-code')))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title) ? _c('h2', [_vm._v("OBS! " + _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "4px"
    }
  }, [_c('button', {
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Välj " + _vm._s(_vm._f("dateRange")([_vm.params.startDate, _vm.params.endDate])))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("\n       \n    ")]), _vm._v(" "), _c('a', {
    staticClass: "small-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("Avbryt och sök nya datum")])])])
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'datepicker-field ' + (_vm.isSelected ? 'selected' : ''),
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('span', {
    staticClass: "prefix"
  }, [_c('icon', {
    attrs: {
      "name": "calendar",
      "scale": 1.6
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n    " + _vm._s(_vm.formattedValue) + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "suffix"
  }, [(!_vm.isSelected) ? _c('icon', {
    attrs: {
      "name": "chevron-down",
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSelected) ? _c('icon', {
    attrs: {
      "name": "circle-green-minus",
      "scale": 1.5
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.reMount
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Dina bokade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "people max-width"
  }, _vm._l((_vm.people), function(person, index) {
    return (person.guideCompleted) ? _c('div', {
      class: {
        person: true, opened: (_vm.currentIndex === index), completed: person.guideFullyCompleted
      }
    }, [_c('div', {
      staticClass: "blue-bar",
      on: {
        "click": function($event) {
          return _vm.setActive(_vm.currentIndex !== index ? index : -1)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "green-check",
        "scale": 1.8
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v("Åkare " + _vm._s(index + 1) + ":")]), _vm._v(" "), (_vm.days(person.age).find(function(day) {
      return day.value === person.days
    })) ? _c('span', {
      staticClass: "package"
    }, [_vm._v("\n          " + _vm._s(_vm.days(person.age).find(function(day) {
      return day.value === person.days
    }).title) + " /\n          " + _vm._s(_vm.ages[person.age]) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_c('span', [_c('b', [_vm._v("Pris:")]), _vm._v(" " + _vm._s(_vm._f("currency")((person.price + (person.keycardPrice ? person.keycardPrice : 0)))))])]), _vm._v(" "), _c('span', {
      staticClass: "change",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setActive(index)
        }
      }
    }, [_c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(index)
        }
      }
    }, [_c('button', {
      staticClass: "small white tight"
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.2
      }
    })], 1)])])]), _vm._v(" "), (_vm.currentIndex !== index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          Visa\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-green",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          Stäng\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue-up",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue-up",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "animate-filter"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.currentIndex === index)),
        expression: "(currentIndex === index)"
      }],
      staticClass: "ski-pass-user-wrapper"
    }, [_c('div', {
      staticClass: "inner-width"
    }, [_c('div', {
      class: 'content'
    }, [_c('label', [_vm._v("Ålder")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.ages[person.age]) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])])]), _vm._v(" "), _c('div', {
      class: 'content ' + (person.age ? '' : 'disabled')
    }, [_c('label', [_vm._v("Antal dagar")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.days(person.age).find(function(day) {
      return day.value === person.days
    }).title) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])])]), _vm._v(" "), (person.refill) ? _c('div', {
      class: 'content'
    }, [_c('label', [_vm._v("Ditt keycardnummer")]), _vm._v(" "), (person.pass && person.pass.number) ? _c('div', [_vm._v("\n              " + _vm._s(person.pass.number) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])]) : _c('div', [_vm._v("\n              " + _vm._s(person.cardPrefix) + "-" + _vm._s(person.cardNumber) + "   "), _c('a', {
      staticStyle: {
        "text-decoration": "underline"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.goToUser(_vm.currentIndex)
        }
      }
    }, [_vm._v(" ändra ")])])]) : _vm._e()])])])], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "max-width align-right"
  }, [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "heading-products"
  }, [_vm._v("Sammanställning")]), _vm._v(" "), _c('div', {
    staticClass: "sum-bar"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n      Totalt:\n      "), _c('b', [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.sum)) + "\n      ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center button-confirm space-3 "
  }, [(_vm.nextIndex) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Gå vidare till nästa åkare")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    staticClass: "small white border big",
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.addPerson()
      }
    }
  }, [_vm._v("Lägg till ny åkare")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('span', {
    staticStyle: {
      "margin-left": "15px",
      "margin-right": "15px"
    }
  }, [_vm._v(" ... eller ... ")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.doSkipass()
      }
    }
  }, [_vm._v("Slutför bokning")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.click
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_c('icon', {
    attrs: {
      "name": "arrow",
      "scale": 1.2
    }
  }), _vm._v("\n    " + _vm._s(_vm.text ? _vm.text : _vm.$t('general.back')) + "\n  ")], 1)])
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "wide": false,
      "width": "800px",
      "show-close": false
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.currentPaymentState == 'before-and-during-payment') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.before-and-during-payment--skirental')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'syncing') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.syncing')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.error')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error-on-sync') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.error-on-sync')))]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'success') ? _c('h1', [_vm._v(_vm._s(_vm.$t('general.payment.titles.success')))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "handler"
  }), _vm._v(" "), (_vm.currentPaymentState == 'before-and-during-payment') ? _c('h2', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t('general.payment.to-pay')) + ":   "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.sum)))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'before-and-during-payment') ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'before-and-during-payment') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    staticClass: "pulsing",
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.insert-card-instructions')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), (!_vm.canCancel) ? _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.cancel-instructions'))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "white border",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.localCloseModal(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.cancel')))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'syncing') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('general.payment.syncing')))]), _vm._v(" "), _c('CreatingOrder', {
    attrs: {
      "method": "chip",
      "hash": _vm.hash,
      "show-texts": false,
      "do-redirect": false
    },
    on: {
      "callback": _vm.onSyncCallback
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/error.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.messages[0].message))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'error-on-sync') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/error.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.sync-error')))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState == 'success') ? _c('div', {
    staticClass: "info-image center"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.synced-remember-reciept')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.payment.your-order-number')) + ":")]), _vm._v(" "), _c('p', {
    staticClass: "order-number"
  }, [_vm._v(_vm._s(_vm.orderNumber))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v(_vm._s(_vm.$t('general.payment.closing', {
    seconds: 10
  })))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState === 'error') ? _c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.resetPayment()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.try-again')))]), _vm._v(" "), _c('button', {
    staticClass: "white",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.cancel-booking')))])]) : _vm._e(), _vm._v(" "), (_vm.currentPaymentState === 'error-on-sync') ? _c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.try-again')))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', _vm._l((_vm.messages), function(ref) {
    var message = ref.message;

    return _c('p', [_vm._v(_vm._s(message))])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.$store.state.isDebugging) ? _c('div', {
    staticClass: "debugging"
  }, [_vm._v("\n    Simulera:\n    "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalInsert()
      }
    }
  }, [_vm._v("Sätt i kort")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalCode()
      }
    }
  }, [_vm._v("Ange kod")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalApprove()
      }
    }
  }, [_vm._v("Godkänn")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.simulateTerminalCancel()
      }
    }
  }, [_vm._v("Avbryt")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "545px",
      "setClass": "no-padding-ever",
      "closeText": "Nej tack, gå till varukorgen",
      "showClose": false
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('div', {
    staticClass: "delivery-wrapper"
  }, [(_vm.possibleWithDelivery && (!_vm.SITE_CONFIG.rental.delivery_fee_active || _vm.SITE_CONFIG.rental.delivery_fee_price <= 0)) ? _c('h2', [_vm._v("Spara tid – förboka utrustning med gratis utkörning\n      "), (_vm.accomodationsToSelect.length > 1) ? _c('span', [_vm._v("till " + _vm._s(_vm.accomodationsToSelect[0].title))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery && _vm.SITE_CONFIG.rental.delivery_fee_active && _vm.SITE_CONFIG.rental.delivery_fee_price > 0) ? _c('h2', [_vm._v("Spara tid – förboka utrustning med utkörning\n      "), (_vm.accomodationsToSelect.length > 1) ? _c('span', [_vm._v("till " + _vm._s(_vm.accomodationsToSelect[0].title))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.possibleWithDelivery) ? _c('h2', [_vm._v("Spara tid – förboka utrustning\n    ")]) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery) ? _c('ul', [_c('li', [_vm._v("Allt är klart när du kommer hit.")]), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery_fee_active && _vm.SITE_CONFIG.rental.delivery_fee_price > 0) ? _c('li', [_vm._v("Valfri utkörning (" + _vm._s(_vm.SITE_CONFIG.rental.delivery_fee_price) + " kr per bokning).")]) : _c('li', [_vm._v("Gratis utkörning och hämtning.")]), _vm._v(" "), _c('li', [_vm._v("Mer tid till skidåkning!")])]) : _vm._e(), _vm._v(" "), (_vm.possibleWithStorage) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1
    }
  }), _vm._v(" Obs! Nattförvaring")], 1), _vm._v(" "), _c('p', [_vm._v("Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.")]), _vm._v(" "), (_vm.accomodations.length > 1) ? _c('p', [_vm._v(" ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.accomodation)) ? _c('div', {
    staticClass: "blocked"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v(_vm._s(_vm.$t('general.people-count')))]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery && (!_vm.SITE_CONFIG.rental.delivery_fee_active || _vm.SITE_CONFIG.rental.delivery_fee_price <= 0)) ? _c('button', {
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v("Boka gratis utkörning av utrustning")]) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery && _vm.SITE_CONFIG.rental.delivery_fee_active && _vm.SITE_CONFIG.rental.delivery_fee_price > 0) ? _c('button', {
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v("Boka utkörning av utrustning")]) : _vm._e(), _vm._v(" "), (_vm.possibleWithDelivery) ? _c('button', {
    staticClass: "white border",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        return _vm.startBookingNormal()
      }
    }
  }, [_vm._v("Boka utrustning att hämta själv")]) : _vm._e(), _vm._v(" "), (!_vm.possibleWithDelivery) ? _c('button', {
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        return _vm.startBookingNormal()
      }
    }
  }, [_vm._v("Boka utrustning")]) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "close-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.doClose()
      }
    }
  }, [_vm._v("Nej tack, jag bokar senare")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  })])
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "center",
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.measure-foot-text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/fot-mata.svg"
    }
  })]), _vm._v(" "), (_vm.showDinText) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.measure-foot-din'))
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-page-component"
  }, [_c('div', {
    staticClass: "inner"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "login"
  }, [_c('Login', {
    on: {
      "login": _vm.login
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('div', {
    staticClass: "my-name"
  }, [_c('h1', [_vm._v("Välkommen " + _vm._s(_vm.user.name1) + "!")]), _vm._v(" "), _c('p', [_vm._v("Ditt kundnummer är: " + _vm._s(_vm.user.addrlid))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-buttons"
  }, [_c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'journey')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'journey')
      }
    }
  }, [_c('span', [_vm._v("Mina bokningar")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'bookings')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'bookings')
      }
    }
  }, [_c('span', [_vm._v("Tidigare")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'details')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'details')
      }
    }
  }, [_c('span', [_vm._v("Mina uppgifter")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'password')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'password')
      }
    }
  }, [_c('span', [_vm._v("Ändra lösenord")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'logout')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'logout')
      }
    }
  }, [_c('span', [_vm._v("Logga ut")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-wrapper"
  }, [_c('router-view')], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "AccomodationsFilter"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', [_vm._v(_vm._s( /* This is just an empty flex item that makes the spacing look good! */ ))]), _vm._v(" "), _c('div', {
    class: {
      field: true, date: true, disabled: (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number)
    }
  }, [_c('div', {
    staticClass: "label-wrapper"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Välj datum")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "label": _vm.$store.state.accomodationsFilter.date.startDate ? (
        _vm.moment(_vm.$store.state.accomodationsFilter.date.startDate).format('D[/]M') +
        ' - ' +
        _vm.moment(_vm.$store.state.accomodationsFilter.date.endDate).format('D[/]M')
      ) : 'När som helst',
      "bold-label": false,
      "validated": _vm.$store.state.accomodationsFilter.date.startDate
    },
    on: {
      "clicked": _vm.openDatePicker,
      "clicked-suffix": _vm.dateClear
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field field-beds"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Antal bäddar")]), _vm._v(" "), _c('CounterButton', {
    attrs: {
      "label": "Antal bäddar",
      "count": _vm.$store.state.accomodationsFilter.beds
    },
    on: {
      "changedCount": function($event) {
        _vm.awaitFilter({
          waitForUser: true,
          callback: function() {
            _vm.changeBeds($event);
          }
        });
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field field-bedrooms"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Antal sovrum")]), _vm._v(" "), _c('CounterButton', {
    attrs: {
      "label": "Antal sovrum",
      "count": _vm.$store.state.accomodationsFilter.bedrooms
    },
    on: {
      "changedCount": function($event) {
        _vm.awaitFilter({
          waitForUser: true,
          callback: function() {
            _vm.changeRooms($event);
          }
        });
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field field-filter-button"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.filtersToggle
    },
    attrs: {
      "label": "Fler filter",
      "closeLabel": "Stäng filter",
      "icon": "Filter",
      "iconscale": 1.5,
      "status": _vm.filtersToggle
    },
    on: {
      "clicked": _vm.toggleFilters
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hide-on-mobile"
  }, [_vm._v(_vm._s( /* This is just an empty flex item that makes the spacing look good! */ ))])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [_c('AccomodationsFilterSub', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtersToggle),
      expression: "filtersToggle"
    }]
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.modules_open.school.open) ? _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('strong', [_vm._v(_vm._s(_vm.count))]), _vm._v(" " + _vm._s(_vm.$t('general.number-results', {
    count: ''
  })) + "\n    "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeFiltersCount > 0),
      expression: "activeFiltersCount > 0"
    }],
    ref: "resetButton",
    staticClass: "reset-button reset-filter-text",
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.reset-filter')) + " "), _c('icon', {
    attrs: {
      "name": "Reset",
      "scale": 1.3
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.activeFiltersCount > 0) ? _c('div', {
    staticClass: "active-filters-list"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.picked-filters')))]), _vm._v(" "), _c('ul', _vm._l((_vm.activeFilters), function(value, filter) {
    return _c('li', [_c('FilterListItem', {
      attrs: {
        "filter": filter,
        "label": value
      },
      on: {
        "click": function($event) {
          _vm.resetSkiSchoolFilter(filter);
          _vm.emit();
        }
      }
    })], 1)
  }), 0)]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "z-index": _vm.params.zIndex || null,
      "width": "450px",
      "show-close": false
    },
    on: {
      "close": _vm.goOn
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.timeout.hm')))]), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.timeout.question')))]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('p', [_vm._v("Din bokning är reserverad. Eftersom du har lämnat din bokning kommer det du har reserverat att släppas fritt för andra att boka snart.")]) : _vm._e(), _vm._v(" "), (_vm.params.inactive && _vm.params.inactive()) ? _c('div', [(_vm.$store.state.isOnSite) ? _c('p', [_vm._v(_vm._s(_vm.$t('skirental.timeout.text')))]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('p', [_vm._v("Tid kvar:")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.params.inactive()) ? _c('h2', [_vm._v(_vm._s(_vm.timeLeft()))]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.goOn
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.timeout.cta-continue')))]), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('button', {
    staticClass: "white",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.timeout.cta-cancel')))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activeLock) ? _c('div', {
    class: {
      wrap: true, marked: (_vm.seconds < 60)
    }
  }, [_vm._v("\n  Ditt bokning är reserverad. Du behöver slutföra din bokning innan följande tid är slut: "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v("\n   "), (true) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.extend_time()
      }
    }
  }, [_vm._v("Förläng")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header",
    style: ('background-image:url(' + (_vm.unit && _vm.unit.pool && _vm.unit.pool.image) + ')')
  }, [(_vm.unit) ? _c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n      ")]) : _vm._e()])]), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    class: [
      'tab',
      _vm.activeTab === 'info' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('info')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "info-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Beskrivning")])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'images' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('images')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "img-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "img-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Bilder")])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'map' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('map')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "map-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "map-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Karta")])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'video' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('video')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "play-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "play-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Film")])], 1)]), _vm._v(" "), (_vm.activeTab === 'info') ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.unit.description_full))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'images') ? _c('div', {
    staticClass: "images"
  }, [_c('agile', {
    attrs: {
      "arrows": true,
      "speed": 200,
      "timing": 'linear',
      "fade": false,
      "autoplay": false,
      "arrow": "<img src=\"https://static.booking.branasgruppen.se/static/svg/arrow-slideshow-left.svg\" />"
    }
  }, _vm._l((_vm.unit.images), function(image) {
    return _c('div', {
      staticClass: "slide"
    }, [_c('img', {
      attrs: {
        "src": image.path_corrected
      }
    })])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'video') ? _c('div', {
    staticClass: "video"
  }, [_c('Vimeo', {
    attrs: {
      "url": _vm.unit.pool.video
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [(_vm.arrival) ? _c('AccomodationPeriodConfirm', {
    staticClass: "tighter",
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.tempCartAccomodation.period) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.openModal(['UnitPriceModal', {
          unit: _vm.unit
        }])
      }
    }
  }, [_vm._v("Priser och tillgänglighet "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.tempCartAccomodation.period) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.chooseAccomodation({
          pool_lid: _vm.unit.pool_lid,
          unit_lid: _vm.unit.unit_lid,
          period: _vm.$store.state.tempCartAccomodation.period,
          week: _vm.$store.state.tempCartAccomodation.period.week,
          name: (_vm.unit.display_name || _vm.unit.description_title),
          capacity: _vm.unit.capacity,
          price: _vm.$store.state.tempCartAccomodation.period.price
        })
      }
    }
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.2
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Ta bort\n      ")], 1) : _vm._e(), _vm._v(" "), _c('UnitFacts', {
    attrs: {
      "unit": _vm.unit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      banner: true, quick: _vm.quick
    }
  }, [_c('h1', [_vm._v("LIFTKORT OCH KEYCARD")]), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'branas') ? _c('img', {
    staticClass: "badge",
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/img/badge-lifkort.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "info center"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Liftkort och säsongskort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.day_online && !_vm.SITE_CONFIG.skipass.season_online) ? _c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Liftkort")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Säsongskort")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && _vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_vm._v("Ladda och köp")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && !_vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [(!_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('span', [_vm._v("Köp säsongskort")]) : _c('span', [_vm._v("Köp liftkort")])]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.buy_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open('SkiPassPickDateKeycard')
      }
    }
  }, [_vm._v("Köp laddningsbart liftkort")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.buy_enabled && _vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_vm._v("Ladda liftkort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && !_vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToLoading()
      }
    }
  }, [_vm._v("Ladda liftkort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && _vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToLoading()
      }
    }
  }, [_vm._v("Bara ladda")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Slipp köer och åk direkt ut i backen")])])
}]}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "show-close": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', [_vm._v("QR-koder")])])])]), _vm._v(" "), (_vm.hasValidCodes && _vm.hasCodes) ? _c('div', {
    staticClass: "qr-code-wrapper"
  }, _vm._l((_vm.params.order.qrCodes), function(code, index) {
    return _c('div', {
      key: index,
      staticClass: "qr-code"
    }, [_c('h3', [_vm._v(_vm._s(code.product))]), _vm._v(" "), _c('img', {
      staticClass: "qr",
      attrs: {
        "src": _vm.qrUrl(code.ordernumber)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(code.ordernumber))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.hasValidCodes && _vm.hasCodes) ? _c('div', [_c('p', [_vm._v("QR-koderna aktiveras några dagar innan ankomst.")])]) : _vm._e(), _vm._v(" "), (!_vm.hasValidCodes && !_vm.hasCodes) ? _c('div', [_c('p', [_vm._v("Det finns inga giltiga QR-koder.")])]) : _vm._e(), _vm._v(" "), (_vm.isCreating) ? _c('button', {
    staticClass: "small white border",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Stäng")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading,
      "text": _vm.$t('general.cancelling')
    }
  }), _vm._v(" "), _c('div', {
    class: {
      loading: _vm.loading
    }
  }, [(!_vm.purchaseCompleted) ? _c('div', {
    staticClass: "cancel-info"
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "cancel-info-span"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.fill-details')))]), _c('br'), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.cancel')))])])]) : _vm._e(), _vm._v(" "), (!_vm.purchaseCompleted) ? _c('div', {
    staticClass: "danish-info"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0.5em 1em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('general.contact_guest_service.payment', {
        phone: '<a href=\'tel:054-13 26 00\'>054-13 26 00</a>'
      }))
    }
  })]) : _vm._e(), _vm._v(" "), _c('BookingTimer', {
    attrs: {
      "currently-paying": true
    },
    on: {
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.SITE_CONFIG.payment_service === 'klarna') ? _c('KlarnaCheckout') : (_vm.SITE_CONFIG.payment_service === 'collector') ? _c('CollectorCheckout', {
    on: {
      "purchase-completed": _vm.handlePurchaseCompleted
    }
  }) : _c('div', [_vm._v("There’s no configured payment service (" + _vm._s(_vm.SITE_CONFIG.payment_service) + ")")])], 1), _vm._v(" "), _c('OrderCheckForCancellation')], 1)
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-group-listing"
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "collapsed",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = true
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [(_vm.unitCount > 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa alla " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e(), _vm._v(" "), (_vm.unitCount === 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down-white"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.expanded) ? _c('div', {
    staticClass: "expanded"
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = false
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Stäng")]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.groupedUnits), function(group, index) {
    return _c('div', {
      key: group.key,
      staticClass: "animate-pool-list-item",
      class: {
        odd: index % 2
      }
    }, [_c('AccomodationsListUnitsList', {
      attrs: {
        "units": group.units,
        "grouping": group.title
      }
    })], 1)
  }), 0)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true,
      "width": "1900px"
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_vm._v("ID: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.id))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ankomst: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.arrival))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Avresa: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.departure))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Skapad: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.order.created_at, 'short-with-full-time')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Uppdaterad: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.order.updated_at, 'short-with-full-time')) + "     /     " + _vm._s(_vm._f("date")(_vm.order.touched_at, 'short-with-full-time')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kommer att avbokas (när inte betald): ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.order.valid_to_when_unpayed, 'short-with-full-time')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kort-ID: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.ext_chip_hash))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Betal-ID: ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.order.ext_klarna_id) + "\n          ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Betalstatus: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.pretty_klarna_status || '-') + " (" + _vm._s(_vm.order.ext_klarna_status || '-') + ")")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.pretty_status || '-') + " (" + _vm._s(_vm.order.status || '-') + ")")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ordernummer: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.number) + " " + _vm._s(_vm.order.ext_r360_id ? ' / ' + _vm.order.ext_r360_id : ''))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fel: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.has_error ? 'Ja' : '-'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Felkod: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.error_code))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Betalmetod: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.payment_method) + " - " + _vm._s(_vm.order.sub_payment_method))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Orderkälla: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.order_source))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Summa: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm.order.line_sum)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("PIN: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.pincode))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Synkad till r360: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.synced_with_r360 ? 'Ja' : 'Nej'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Säkerhetskontroll - har bytt kund: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.status_customer_set ? 'Ja' : 'Nej'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Säkerhetskontroll - betalslagen: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.status_fully_payed ? 'Ja' : 'Nej'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Avbokad: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.canceled ? 'Ja' : 'Nej'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("IP: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.user_ip))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("User agent: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.user_ua))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Användare: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.order.user ? _vm.order.user.ext_r360_id : '-'))])])])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Typ")]), _vm._v(" "), _c('th', [_vm._v("Produkt")]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Åld.")]), _vm._v(" "), _c('th', [_vm._v("Ankomst")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Avresa")]), _vm._v(" "), _c('th', [_vm._v("Ant.")]), _vm._v(" "), _c('th', [_vm._v("Pris st.")]), _vm._v(" "), _c('th', [_vm._v("Pris 360")]), _vm._v(" "), _c('th', [_vm._v("DBID")]), _vm._v(" "), _c('th', [_vm._v("Namn")]), _vm._v(" "), _c('th', [_vm._v("Skostl.")]), _vm._v(" "), _c('th', [_vm._v("Vikt")]), _vm._v(" "), _c('th', [_vm._v("Längd")]), _vm._v(" "), _c('th', [_vm._v("Utkörn.")]), _vm._v(" "), _c('th', [_vm._v("Önskm.")]), _vm._v(" "), _c('th', [_vm._v("Tfn")]), _vm._v(" "), _c('th', [_vm._v("Plats")]), _vm._v(" "), _c('th', [_vm._v("Målsman")]), _vm._v(" "), _c('th', [_vm._v("Fskrng")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.lines), function(line) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(line.pretty_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.lid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.age))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.arrival))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.departure))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(line.price_per_piece)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(line.ext_price)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.period_dbid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.person_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.person_shoesize))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.person_weight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.person_length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.delivery))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.wishes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.site))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.guardian))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.insurance))])])
  }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Statusändringar")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("När")]), _vm._v(" "), _c('th', [_vm._v("Ny status")]), _vm._v(" "), _c('th', [_vm._v("Bytt kund (1)")]), _vm._v(" "), _c('th', [_vm._v("Betalslagen (1)")]), _vm._v(" "), _c('th', [_vm._v("Bytt kund (2)")]), _vm._v(" "), _c('th', [_vm._v("Betalslagen (2)")]), _vm._v(" "), _c('th', [_vm._v("Felkod")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.changes), function(change, key) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(change.created_at, 'short-with-full-time')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.pretty_status !== (_vm.changes[key + 1] ? _vm.changes[key + 1].pretty_status : '---') ? change.pretty_status : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.safety_status_customer_set !== (_vm.changes[key + 1] ? _vm.changes[key + 1].safety_status_customer_set : null) ? 'Ja' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.safety_status_fully_payed !== (_vm.changes[key + 1] ? _vm.changes[key + 1].safety_status_fully_payed : null) ? 'Ja' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.status_customer_set !== (_vm.changes[key + 1] ? _vm.changes[key + 1].status_customer_set : null) ? 'Ja' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.status_fully_payed !== (_vm.changes[key + 1] ? _vm.changes[key + 1].status_fully_payed : null) ? 'Ja' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.error_code))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'SwitchButton ' + (_vm.icon ? 'has-icon' : 'no-icon'),
    style: (_vm.componentStyle)
  }, [(_vm.icon) ? _c('span', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon,
      "scale": _vm.iconscale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'before' && _vm.toggled) ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.labelChecked))]) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'before' && !_vm.toggled) ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.labelUnchecked))]) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'after') ? _c('span', {
    staticClass: "label",
    staticStyle: {
      "float": "right",
      "line-height": "26px",
      "margin-left": "10px",
      "text-transform": "none"
    }
  }, [_vm._v(_vm._s(_vm.labelChecked))]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "vue-js-switch",
    class: {
      toggled: _vm.toggled, disabled: _vm.disabled
    }
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'field field--' + _vm.type,
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeText($event)
      },
      "blur": _vm.changeText
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffix"
  }, [_c('icon', {
    attrs: {
      "name": "Search-white",
      "scale": 1.5
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px",
      "show-close": false
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [_c('h2', [_vm._v("Din reservation har gått ut")]), _vm._v(" "), _c('p', [_vm._v("Din reservation i varukorgen har gått ut. Andra gäster kan boka det som var reserverat av dig.")]), _vm._v(" "), _c('p', [_vm._v("Klicka nedan för att gå till varukorgen, där kan du prova att boka igen.")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToCart()
      }
    }
  }, [_vm._v("Okej, gå till varukorgen")])])])
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      emptypage: _vm.showEmptyPage
    }
  }, [_c('div', {
    class: 'banner site-' + _vm.SITE_CONFIG.site
  }, [_c('div', {
    class: {
      flexer: true
    }
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$t('general.cta.book')) + "\n        "), _c('span', [_vm._v(_vm._s(_vm.$t('general.skirental')))]), (_vm.SITE_CONFIG.skischool.onsite) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.school')))]) : _vm._e(), (_vm.SITE_CONFIG.skischool.onsite) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.skipass')))]) : _vm._e()]), _vm._v(" "), _c('LanguageSwitcher', {
    class: {
      disabled: _vm.loading
    },
    attrs: {
      "type": "row"
    },
    on: {
      "clickedlanguage": _vm.setLoading,
      "pickedlanguage": _vm.pickedLanguage
    }
  }), _vm._v(" "), _c('div', {
    class: {
      buttons: true, show: (_vm.hasPickedLanguage && !_vm.onlySkirental), disabled: _vm.loading
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.goToSkirental()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.skirental')))]), _vm._v(" "), (_vm.SITE_CONFIG.skischool.onsite) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goToSkischool()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.school')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.onsite) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goToSkipass()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.skipass')))]) : _vm._e()])], 1)]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.showEmptyPage || _vm.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subFilter"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column column-beds"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Antal bäddar")]), _vm._v(" "), _c('CounterButton', {
    staticClass: "small",
    attrs: {
      "count": _vm.$store.state.accomodationsFilter.beds
    },
    on: {
      "changedCount": function($event) {
        _vm.awaitFilter({
          waitForUser: true,
          callback: function() {
            _vm.changeBeds($event);
          }
        });
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column column-bedrooms"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Antal Sovrum")]), _vm._v(" "), _c('CounterButton', {
    staticClass: "small",
    attrs: {
      "count": _vm.$store.state.accomodationsFilter.bedrooms
    },
    on: {
      "changedCount": function($event) {
        _vm.awaitFilter({
          waitForUser: true,
          callback: function() {
            _vm.changeRooms($event);
          }
        });
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "sauna",
      "icon": "bastu",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.sauna,
      "sync": true,
      "labels": {
        checked: 'Bastu',
        unchecked: 'Bastu'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "direct_incheck",
      "icon": "direkt-incheck-black",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.direct_incheck,
      "sync": true,
      "labels": {
        checked: _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title,
        unchecked: _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "fireplace",
      "icon": "kamin",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.fireplace,
      "sync": true,
      "labels": {
        checked: 'Öppen spis',
        unchecked: 'Öppen spis'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "pets",
      "icon": "husdjur",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.pets,
      "sync": true,
      "labels": {
        checked: 'Husdjur',
        unchecked: 'Husdjur'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "dishwasher",
      "icon": "diskmaskin",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.dishwasher,
      "sync": true,
      "labels": {
        checked: 'Diskmaskin',
        unchecked: 'Diskmaskin'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "dryer_cabinet",
      "icon": "torkskap-blue",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.dryer_cabinet,
      "sync": true,
      "labels": {
        checked: 'Torkskåp',
        unchecked: 'Torkskåp'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "washing_machine",
      "icon": "tvattmaskin",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.washing_machine,
      "sync": true,
      "labels": {
        checked: 'Tvättmaskin',
        unchecked: 'Tvättmaskin'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.filters.chargeStation) ? _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "chargeStation",
      "icon": "laddstolpe",
      "iconscale": 2.3,
      "value": _vm.$store.state.accomodationsFilter.chargeStation,
      "sync": true,
      "labels": {
        checked: 'Laddstolpe',
        unchecked: 'Laddstolpe'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "cleaning",
      "icon": "stadning",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.cleaning,
      "sync": true,
      "labels": {
        checked: 'Slutstäd ingår',
        unchecked: 'Slutstäd ingår i priset'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.filters.childFriendly) ? _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "child_friendly",
      "icon": "smiley-blue",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.child_friendly,
      "sync": true,
      "labels": {
        checked: 'Extra barnanpassat',
        unchecked: 'Extra barnanpassat'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('SwitchButton', {
    attrs: {
      "store": "internet",
      "icon": "wifi-blue",
      "iconscale": 2,
      "value": _vm.$store.state.accomodationsFilter.internet,
      "sync": true,
      "labels": {
        checked: 'Wi-Fi',
        unchecked: 'Wi-Fi'
      }
    },
    on: {
      "toggle": function($event) {
        _vm.awaitFilter();
        _vm.toggleFilterSwitch($event);
      }
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('OutlineButton', {
    class: {
      active: _vm.mapToggle
    },
    attrs: {
      "label": "Välj via karta",
      "closeLabel": "Stäng karta",
      "status": _vm.mapToggle,
      "icon": "map",
      "iconscale": 2
    },
    on: {
      "clicked": _vm.openMap
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column flex-grow"
  }, [_c('TextInput', {
    attrs: {
      "placeholder": "Sök på stugnamn/område",
      "value": _vm.getFreeSearch
    },
    on: {
      "change": _vm.changeFreeSearch
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(!_vm.scanningOpen) ? _c('h1', [_vm._v(_vm._s(_vm.$t('skipass.refill-header')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blocked tab-picker center"
  }, [_c('label', {
    staticClass: "uppercase"
  }, [_vm._v("Välj sparat eller lägg in ett nytt")]), _vm._v(" "), _c('div', {
    class: 'box checkboxes'
  }, [_c('Checkbox', {
    attrs: {
      "special-class": "skipass-user",
      "label": "Nytt",
      "label-position": "right",
      "value": false,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "special-class": "skipass-user",
      "label": "Sparat",
      "label-position": "right",
      "value": true,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  })], 1)]), _vm._v(" "), (_vm.tabSaved) ? _c('div', {
    staticClass: "tab-saved"
  }, [(!_vm.loggedIn) ? _c('div', [_c('Login', {
    on: {
      "login": _vm.onLogin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn && !_vm.skipasses.length && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v("Inga liftkort")], 1), _vm._v(" "), (_vm.foundNotAllowedDelivery) ? _c('p', [_vm._v("Vi hittade inga sparade liftkort.")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.loading) ? _c('div', [_c('div', {
    staticClass: "blocked center"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading,
      "static": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.skipasses.length) ? _c('div', [_c('div', {
    staticClass: "blocked center"
  }, [_c('b', [_vm._v("Välj bland dina kort")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.skipassesAsSelect,
      "valuebinder": _vm.cardId,
      "validated": _vm.cardId,
      "label": "Välj liftkort"
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.cardId = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.cardId
    },
    on: {
      "click": function($event) {
        return _vm.useNumber()
      }
    }
  }, [_vm._v("Använd")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.tabSaved) ? _c('div', {
    staticClass: "tab-new"
  }, [(!_vm.scanningOpen) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('skipass.enter-number')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "number-wrapper"
  }, [_c('Dropdown', {
    attrs: {
      "options": _vm.options,
      "valuebinder": _vm.prefix,
      "validated": _vm.prefix,
      "value-as-label": true,
      "label": "00"
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.prefix = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.pattern),
      expression: "pattern"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    class: {
      validated: _vm.validate(), error: _vm.error()
    },
    attrs: {
      "type": "tel",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.scanningOpen = true
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "camera-white",
      "scale": 2
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.scanningOpen) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs.scanner.shutdown();
        _vm.scanningOpen = false
      }
    }
  }, [_vm._v("Avbryt skanning")]), _vm._v(" "), _c('Scanner', {
    ref: "scanner",
    attrs: {
      "on-success": _vm.onScannerSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.wasScanned && _vm.error()) ? _c('div', {
    staticClass: "blocked center info error-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v("Ogiltigt kortnummer")], 1), _vm._v(" "), _c('p', [_vm._v("Vänligen korrigera manuellt eller försök skanna igen. Observera att gamla liftkort inte alltid kan skannas.")])]) : _vm._e(), _vm._v(" "), (!_vm.scanningOpen) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.setNumber()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.add-number')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.old-keycard-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.old-keycard-text')))])]), _vm._v(" "), _c('div', {
    staticClass: "blocked center keycard-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/img/liftkort-nr.jpg"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.type + '-wrapper ' + (_vm.valuebinder === _vm.value ? 'active' : '') + (_vm.below ? ' below' : '') + (_vm.disabled ? ' disabled' : '') + (_vm.specialClass ? ' ' + _vm.specialClass : ''),
    on: {
      "click": _vm.updateValue
    }
  }, [_c('span', [(_vm.labelPosition === 'before' || _vm.labelPosition === 'left') ? _c('label', {
    class: _vm.labelPosition
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "the-graphics",
    style: (_vm.style)
  }), _vm._v(" "), (_vm.labelPosition === 'after') ? _c('label', {
    class: _vm.labelPosition,
    staticStyle: {
      "display": "block",
      "text-align": "center",
      "margin-top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'right') ? _c('label', {
    class: _vm.labelPosition
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "center",
    attrs: {
      "wide": true,
      "fullwide": true,
      "show-close": true,
      "click-outside": false
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('Slideshow', {
    staticStyle: {
      "width": "100vw",
      "max-width": "100%"
    },
    attrs: {
      "images": _vm.params.images,
      "fullsize": true,
      "image": _vm.params.image
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "component",
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus),
      expression: "getStatus"
    }],
    attrs: {
      "name": _vm.icon,
      "scale": _vm.iconscale
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus),
      expression: "getStatus"
    }],
    staticClass: "inline-block"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus),
      expression: "!getStatus"
    }],
    staticClass: "inline-block icon"
  }, [_vm._v(_vm._s(_vm.closeLabel) + " "), _c('icon', {
    attrs: {
      "name": "times-white",
      "scale": 1
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'facts' + (_vm.small ? ' small' : '')
  }, [_c('div', {
    class: 'fact ' + (_vm.unit.bedrooms ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "antal rum",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Sovrum (" + _vm._s(_vm.unit.bedrooms) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.bedrooms))])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.living_area ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "area",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Boarea (" + _vm._s(_vm.unit.living_area) + "m"), _c('sup', [_vm._v("2")]), _vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v(_vm._s(_vm.unit.living_area) + "m"), _c('sup', [_vm._v("2")])])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.internet ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "wifi",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Wi-Fi")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.washing_machine ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "tvattmaskin-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tvättmaskin")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.terrace_balcony ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "balkong",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Balkong/altan")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.dishwasher ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "diskmaskin-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Diskmaskin")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.pets_allowed ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "husdjur-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Husdjur tillåtna")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.sauna ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "bastu-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Bastu")])], 1), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    class: 'fact ' + 'active'
  }, [_c('icon', {
    attrs: {
      "name": "direkt-incheck-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.unit.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].title))])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    class: 'fact ' + (_vm.unit.lock_type_id ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "direkt-incheck-black",
      "scale": 1.6
    }
  }), _vm._v("\n      " + _vm._s(_vm.unit.lock_type_id ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].title : Object.values(_vm.SITE_CONFIG.settings.SettingLockTypes.texts).map(function(item) {
    return item.title;
  }).join(' / ')) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.handicap_rooms ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "handikapp",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Handikappanpassat")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.dryer_cabinet ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "torkskap",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Torkskåp")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.toilets ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "wc",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("WC (" + _vm._s(_vm.unit.toilets) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.toilets))])], 1), _vm._v(" "), (_vm.SITE_CONFIG.site != 'branas') ? _c('div', {
    class: 'fact ' + (_vm.unit.hot_tub ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "badtunna",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Badtunna")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.extra_beds ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "sangar",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Extrabäddar (" + _vm._s(_vm.unit.extra_beds) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.extra_beds))])], 1), _vm._v(" "), (_vm.unit.final_cleaning_included && !_vm.unit.has_mandatory_cleaning) ? _c('div', {
    class: 'fact ' + 'active'
  }, [_c('icon', {
    attrs: {
      "name": "stadning-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Slutstäd (ingår)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("Ingår")])], 1) : _vm._e(), _vm._v(" "), (!_vm.unit.final_cleaning_included && !_vm.unit.has_mandatory_cleaning) ? _c('div', {
    class: 'fact ' + (_vm.unit.final_cleaning_available ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "stadning-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Slutstäd (tillval)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("Tillval")])], 1) : _vm._e(), _vm._v(" "), (_vm.unit.has_mandatory_cleaning) ? _c('div', {
    class: 'fact ' + (_vm.unit.final_cleaning_available ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "stadning-black",
      "scale": 1.6
    }
  }), _vm._v("\n      Slutstäd (obligatoriskt)\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.child_friendly ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "smiley-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Extra barnanpassat")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.beds ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "sangar",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Bäddar (" + _vm._s(_vm.unit.beds) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.beds))])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.fireplace ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "kamin-sv",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Öppen spis")])], 1), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.filters.chargeStation) ? _c('div', {
    class: 'fact ' + (_vm.unit.charging_post ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "laddstolpe-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Laddstolpe")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (!_vm.small && _vm.unit.pool.map_link) ? _c('a', {
    staticClass: "button white small border map-bt",
    attrs: {
      "target": "_blank",
      "href": _vm.unit.pool.map_link
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": 2
    }
  }), _vm._v(" Se områdeskarta\n    "), _c('icon', {
    staticClass: "dowload-icon",
    attrs: {
      "name": "download",
      "scale": 1.5
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.small) ? _c('div', {
    staticClass: "facts special-fact"
  }, [_c('div', {
    staticClass: "fact active"
  }, [_c('icon', {
    attrs: {
      "name": "avstand-lift",
      "scale": 1.7
    }
  }), _vm._v(" "), _c('b', [_vm._v("Avstånd pist:")]), _vm._v(" " + _vm._s(_vm.unit.distance_to_pist) + "m\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "fact active"
  }, [_c('icon', {
    attrs: {
      "name": "gondol-lift",
      "scale": 1.7
    }
  }), _vm._v(" "), _c('b', [_vm._v("Avstånd lift:")]), _vm._v(" " + _vm._s(_vm.unit.distance_to_skilift) + "m\n    ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.small && (_vm.unit.check_in_time || _vm.unit.check_out_time)) ? _c('div', {
    staticClass: "facts special-fact"
  }, [_c('div', {
    staticClass: "fact active",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Incheckning:")]), _vm._v(" " + _vm._s(_vm.unit.check_in_time) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "fact active",
    staticStyle: {
      "width": "100%",
      "padding-top": "0"
    }
  }, [_c('b', [_vm._v("Utcheckning:")]), _vm._v(" " + _vm._s(_vm.unit.check_out_time) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.small && _vm.SITE_CONFIG.accomodations.show_site && (_vm.unit.facility && _vm.unit.facility.id === 2006)) ? _c('div', {
    staticClass: "facility-area"
  }, [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 2.25
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Berget")]), _vm._v(" "), _c('p', [_vm._v("I Branäsbergets stugor och lägenheter får du en fantastisk utsikt över dalen och närhet till skidåkning, pulkabackar och längdspår. Uppe på berget finns skiduthyrning, shop, livsmedelsbutik och restauranger.")])], 1) : _vm._e(), _vm._v(" "), (!_vm.small && _vm.SITE_CONFIG.accomodations.show_site && (_vm.unit.facility && _vm.unit.facility.id === 2007)) ? _c('div', {
    staticClass: "facility-area"
  }, [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 2.25
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Dalen")]), _vm._v(" "), _c('p', [_vm._v("I Branäsdalen finns både lägenheter och större fjällstugor, med nära till allt du behöver. I Branäsdalen har du nära till skiduthyrning, restaurang, shop och en livsmedelsbutik.")])], 1) : _vm._e(), _vm._v(" "), (!_vm.small && _vm.SITE_CONFIG.accomodations.show_site && (_vm.unit.facility && _vm.unit.facility.id === 2020)) ? _c('div', {
    staticClass: "facility-area"
  }, [_c('icon', {
    attrs: {
      "name": "mattesdalen",
      "scale": 2.25
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Mattesdalen")]), _vm._v(" "), _c('p', [_vm._v("I Mattesdalen finns både lägenheter och större, moderna fjällstugor. Bor du här har du nära till både 4-stolslift och 6-stolslift som snabbt tar dig upp till toppen och resten av skidområdet.")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true,
      "width": "1400px",
      "set-class": "no-padding-mobile"
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header default-image",
    style: ((_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) ? 'background-image:url(' + (_vm.unit && (_vm.unit.image || (_vm.unit.pool && _vm.unit.pool.image))) + ')' : 'background-size: cover;')
  }, [(_vm.unit) ? _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "heading-inner"
  }, [_vm._v("\n          " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n          "), (_vm.unit.subtitle) ? _c('i', [_vm._v(_vm._s(_vm.unit.subtitle))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (_vm.$store.state.accomodationView && _vm.$store.state.accomodationView === 'images') ? _c('div', {
    staticClass: "notification center"
  }, [_c('p', [_vm._v("Du visar nu våra boenden i ett specialläge där du kan ladda ner bilder.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToNormal()
      }
    }
  }, [_vm._v("Gå till vanliga visningsläget")])])]) : _vm._e(), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right max-tablet "
  }, [(_vm.arrival) ? _c('AccomodationPeriodConfirm', {
    staticClass: "tighter",
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    },
    on: {
      "gotprice": _vm.setPeriod
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.params.arrival) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.openPriceList(_vm.unit)
      }
    }
  }, [_vm._v("Priser och tillgänglighet "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && _vm.period && _vm.period.free) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.chooseAccomodation({
          pool_lid: _vm.unit.pool_lid,
          unit_lid: _vm.unit.unit_lid,
          period: _vm.period,
          week: _vm.period.week,
          name: (_vm.unit.display_name || _vm.unit.description_title),
          capacity: _vm.unit.capacity,
          price: _vm.period.price
        })
      }
    }
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && !_vm.period) ? _c('button', {
    staticClass: "disabled"
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v("Den valda perioden är tyvärr upptagen. Leta gärna andra perioder genom att klicka på \"Ändra datum\" ovan.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "max-tablet save-mobile"
  }, [(!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara och jämför\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Sparad för jämförelse\n        ")], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    class: [
      'tab',
      _vm.activeTab === 'info' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('info')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "info-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "min-tablet"
  }, [_vm._v("Beskrivning")]), _vm._v(" "), _c('span', {
    staticClass: "max-mobile"
  }, [_vm._v("Info")])])], 1), _vm._v(" "), _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'images' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('images')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "img-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "img-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Bilder")])], 1), _vm._v(" "), (!(_vm.unit && _vm.unit.pool) || !_vm.unit.pool.hide_map) ? _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'map' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('map')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "map-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "map-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Karta")])], 1) : _vm._e(), _vm._v(" "), ((_vm.unit && _vm.unit.pool) && _vm.unit.pool.video) ? _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'video' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('video')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "play-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "play-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Film")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: [
      'fact',
      'tab',
      _vm.activeTab === 'fact' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('fact')
      }
    }
  }, [_c('icon', {
    staticClass: "icon icon-inactive",
    attrs: {
      "name": "facts-unit",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "icon icon-active",
    attrs: {
      "name": "facts-unit-white",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('div', [_vm._v("Fakta")])], 1)]), _vm._v(" "), (_vm.activeTab === 'info') ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.unit.description_full))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'images') ? _c('div', {
    staticClass: "images"
  }, [_c('Slideshow', {
    attrs: {
      "images": _vm.unit.images
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'video') ? _c('div', {
    staticClass: "video"
  }, [_c('Vimeo', {
    attrs: {
      "url": _vm.unit.pool.video
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'fact') ? _c('div', {
    staticClass: "fact min-mobile"
  }, [(!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].description))])])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && _vm.unit.lock_type_id) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].description))])])]) : _vm._e(), _vm._v(" "), (_vm.unit.dishwasher_usp) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "dishwasher-filled",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_text))])])]) : _vm._e(), _vm._v(" "), _c('UnitFacts', {
    attrs: {
      "unit": _vm.unit
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-right facts-desktop"
  }, [(_vm.arrival) ? _c('AccomodationPeriodConfirm', {
    staticClass: "tighter",
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure
    },
    on: {
      "gotprice": _vm.setPeriod
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.params.arrival) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.openPriceList(_vm.unit)
      }
    }
  }, [_vm._v("Priser och tillgänglighet "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && _vm.period && _vm.period.free) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.chooseAccomodation({
          pool_lid: _vm.unit.pool_lid,
          unit_lid: _vm.unit.unit_lid,
          period: _vm.period,
          week: _vm.period.week,
          name: (_vm.unit.display_name || _vm.unit.description_title),
          capacity: _vm.unit.capacity,
          price: _vm.period.price
        })
      }
    }
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.arrival && !_vm.period) ? _c('button', {
    staticClass: "disabled"
  }, [_vm._v("Välj "), _c('icon', {
    attrs: {
      "name": "cart-white",
      "scale": 1.4
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period && !_vm.period.free) ? _c('div', {
    staticClass: "alert"
  }, [_c('p', [_vm._v("Den valda perioden är tyvärr upptagen. Leta gärna andra perioder genom att klicka på \"Ändra datum\" ovan.")])]) : _vm._e(), _vm._v(" "), (!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara och jämför\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Sparad för jämförelse\n      ")], 1) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.direct_incheck ? 1 : 0].description))])])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && _vm.unit.lock_type_id) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "direktincheck",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].description))])])]) : _vm._e(), _vm._v(" "), (_vm.unit.dishwasher_usp) ? _c('div', {
    staticClass: "flex marked-usp"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "name": "dishwasher-filled",
      "scale": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_title))]), _vm._v(" "), _c('p', {
    staticClass: "information-text"
  }, [_vm._v(_vm._s(_vm.unit.dishwasher_usp_text))])])]) : _vm._e(), _vm._v(" "), _c('UnitFacts', {
    attrs: {
      "unit": _vm.unit
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.unit) ? _c('div', {
    staticClass: "max-tablet save-mobile"
  }, [(!_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart",
      "scale": 1.5
    }
  }), _vm._v(" Spara och jämför\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isFavorite(_vm.unit.id)) ? _c('button', {
    staticClass: "white small border",
    on: {
      "click": function($event) {
        return _vm.toggleFavorite(_vm.unit.id)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "heart-red",
      "scale": 1.5
    }
  }), _vm._v(" Sparad för jämförelse\n    ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "960px",
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "heading"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h1"
  }, [_c('h1', [_vm._v("Din bokning: " + _vm._s(_vm.order.resvid))])]), _vm._v(" "), (!_vm.onlyMore) ? _c('div', [(_vm.showQrCodeButton) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.openQrModal
    }
  }, [_vm._v("Visa QR-koder till liftkortsautomat")])]) : _vm._e(), _vm._v(" "), ((_vm.order && _vm.order.pickups ? _vm.order.pickups : []).length > 1 && _vm.SITE_CONFIG.site === 'branas') ? _c('div', {
    staticClass: "info",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_c('b', [_vm._v("OBS!")]), _vm._v(" Du har flera utlämningsställen valda för din bokning (" + _vm._s(_vm.order.pickups.join(', ')) + "). Kontakta gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" om du vill ändra.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container",
    class: {
      disabled: _vm.loading
    }
  }, [_c('Cart', {
    attrs: {
      "use-storage": false,
      "order": _vm.order,
      "show-from-start": true
    },
    on: {
      "loading": function($event) {
        _vm.loading = true
      },
      "loadingcomplete": function($event) {
        _vm.loading = false
      },
      "changed": function($event) {
        _vm.reloadParent();
        _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), ( false) ? _c('div', [_c('h2', [_vm._v("Komplettera din bokning:")]), _vm._v(" "), _c('div', {
    staticClass: "info",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.onlyMore) ? _c('div', [_vm._v("\n          För att boka tillägg till din boendebokning, såsom städ, linne eller matpåsar, välj ”Boka tillval” ovan.\n          "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v("\n        Du kan bara komplettera din bokning med bokningar inom samma datum som din grundbokning.\n      ")]), _vm._v(" "), (_vm.SITE_CONFIG.add_to_booking_open) ? _c('div', [_c('CompletedBookings', {
    attrs: {
      "add": true,
      "order-number": _vm.order.resvid,
      "order-number-numeric": _vm.order.headlid,
      "date-start": _vm.order.dateStart,
      "date-end": _vm.order.dateEnd,
      "helper-pool": _vm.order.firstAccomodationPoolLid,
      "helper-unit": _vm.order.firstAccomodationUnitLid
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.add_to_booking_open) ? _c('div', [_c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("Vid ändringar eller tillägg av din bokning, vänligen ring gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(".")])]) : _vm._e()]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('Loading', {
    attrs: {
      "show": !_vm.data.length
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.sync
    }
  }, [_vm._v("Ladda om")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.types), function(v, key) {
    return _c('button', {
      class: (v.active ? 'active' : '') + ' type--' + v.severity,
      on: {
        "click": function($event) {
          return _vm.filterSync(key)
        }
      }
    }, [_vm._v(_vm._s(v.emoji) + " " + _vm._s(v.label))])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.data), function(n) {
    return _c('tbody', {
      class: (n.expanded ? 'expanded ' : ''),
      on: {
        "click": function($event) {
          n.expanded = true
        }
      }
    }, [_c('tr', [_c('td', [_vm._v("#" + _vm._s(n.id))]), _vm._v(" "), _c('td', {
      class: 'type--' + n.severity
    }, [_vm._v(_vm._s(n.emoji) + " " + _vm._s(n.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(JSON.parse(n.context).other.PATH_INFO || JSON.parse(n.context).other.laravel_path))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(JSON.parse(n.exception).subject))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(JSON.parse(n.exception).msg || JSON.parse(n.exception).error)
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(n.created_at))])]), _vm._v(" "), (n.expanded) ? _c('tr', [_c('th', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("Kontext")]), _vm._v(" "), _c('th', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("Felväg")])]) : _vm._e(), _vm._v(" "), (n.expanded) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('table', [_vm._l((JSON.parse(n.context)), function(a, b) {
      return (n.context && b !== 'other') ? _c('tr', [_c('th', [_vm._v(_vm._s(b) + ":")]), _c('td', [_vm._v(_vm._s(a))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((JSON.parse(n.context).other), function(a, b) {
      return (n.context) ? _c('tr', [_c('th', [_vm._v(_vm._s(b) + ":")]), _c('td', [_vm._v(_vm._s(a))])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('button', {
      staticClass: "btn white border small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          n.expanded = false
        }
      }
    }, [_vm._v("Stäng")])])])], 2)]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      },
      domProps: {
        "innerHTML": _vm._s('<pre>' + (JSON.parse(n.exception).trace || '').replace(/\n/g, '<br>') + '</pre>')
      }
    })]) : _vm._e()])
  })], 2)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Typ")]), _vm._v(" "), _c('th', [_vm._v("Väg")]), _vm._v(" "), _c('th', [_vm._v("Ämne")]), _vm._v(" "), _c('th', [_vm._v("Meddelande/fel")]), _vm._v(" "), _c('th', [_vm._v("Skapad")])])
}]}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Datumfält")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.propertyValues,
      "valuebinder": _vm.property,
      "label": "Datumvärde",
      "validated": false,
      "show-label-subtitle": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.property = $event
      },
      "changed": function($event) {
        return _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Period")]), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": false,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerRangeModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Betalda")]), _vm._v(" "), _vm._l((_vm.payedYesno), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedPayed[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggledPayed(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Betalmetod")]), _vm._v(" "), _vm._l((_vm.payTypes), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedPayTypes[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.togglePayType(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Betalmetod mobilhyra")]), _vm._v(" "), _vm._l((_vm.subPayTypes), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedSubPayTypes[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleSubPayType(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Orderkälla")]), _vm._v(" "), _vm._l((_vm.orderSources), function(option) {
    return _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedOrderSources[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleOrderSource(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Resultat")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.perPageOptions,
      "valuebinder": _vm.perPage,
      "label": "Per sida",
      "validated": false,
      "show-label-subtitle": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.perPage = $event
      },
      "changed": function($event) {
        return _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Vy")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.groupOptions,
      "valuebinder": _vm.groupBy,
      "label": "Vy",
      "validated": false,
      "show-label-subtitle": false
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.groupBy = $event
      },
      "changed": function($event) {
        return _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), (this.groupBy === 'line') ? _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Ordertyp")]), _vm._v(" "), _vm._l((_vm.types), function(option) {
    return (_vm.SITE_CONFIG.modules[option.module]) ? _c('button', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          small: true,
          checked: (_vm.selectedTypes[option.value]),
      },
      on: {
        "click": function($event) {
          return _vm.toggleType(option.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.title) + "\n    ")]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "white border",
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "Reset",
      "scale": 2
    }
  })], 1)]), _vm._v(" "), (_vm.showDirectSearch) ? _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Direktsök")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "short",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('label', [_vm._v("Gäst")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQueryName),
      expression: "searchQueryName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchQueryName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQueryName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n    Visar: "), _c('b', [_vm._v(_vm._s(_vm.from))]), _vm._v("-"), _c('b', [_vm._v(_vm._s(_vm.to))]), _vm._v(" av "), _c('b', [_vm._v(_vm._s(_vm.total))]), _vm._v("\n         \n    Sida:\n    "), _vm._l((_vm.pages), function(p) {
    return _c('div', {
      class: 'button small border ' + ((p == _vm.page) ? '' : 'white'),
      on: {
        "click": function($event) {
          return _vm.changePage(p)
        }
      }
    }, [_vm._v(_vm._s(p))])
  })], 2), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getExcelReportLink
    }
  }, [_vm._v("Exportera som Excel")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'created_at')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('created_at')
      }
    }
  }, [_vm._v("Skapad")]), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'pretty_type')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('pretty_type')
      }
    }
  }, [_vm._v("Typ")]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'person_name')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('person_name')
      }
    }
  }, [_vm._v("Namn")]) : _vm._e(), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'arrival')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('arrival')
      }
    }
  }, [_vm._v("Från")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'departure')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('departure')
      }
    }
  }, [_vm._v("Till")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'has_error')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('has_error')
      }
    }
  }, [_vm._v("Fel")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'status')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('status')
      }
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'line_sum')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('line_sum')
      }
    }
  }, [_vm._v("Summa")]), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'line_sum_skirental')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('line_sum_skirental')
      }
    }
  }, [_vm._v("Hyra")]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'line_sum_skischool')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('line_sum_skischool')
      }
    }
  }, [_vm._v("Skola")]) : _vm._e(), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'pretty_klarna_status')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('pretty_klarna_status')
      }
    }
  }, [_vm._v("Betalstatus")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'number')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('number')
      }
    }
  }, [_vm._v("Ordernr.")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'order_source')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('order_source')
      }
    }
  }, [_vm._v("Källa")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'payment_method')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('payment_method')
      }
    }
  }, [_vm._v("Betalmetod")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'sub_payment_method')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('sub_payment_method')
      }
    }
  }, [_vm._v("Hyra")]), _vm._v(" "), _c('th', {
    class: {
      active: (_vm.sortKey == 'synced_with_r360')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('synced_with_r360')
      }
    }
  }, [_vm._v("Synkad "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('span', [_vm._v("360")]) : _c('span', [_vm._v("Skibar")])]), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'status_customer_set')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('status_customer_set')
      }
    }
  }, [_vm._v("Kund")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('th', {
    class: {
      active: (_vm.sortKey == 'status_fully_payed')
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('status_fully_payed')
      }
    }
  }, [_vm._v("Bet")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l(((_vm.reverse ? _vm.orderBy(_vm.data, _vm.sortKey).reverse() : _vm.orderBy(_vm.data, _vm.sortKey))), function(order, index) {
    return _c('tr', {
      class: {
        warning: (order.pretty_status_simple < 4),
          error: (!order.number || order.has_error || order.error_code || !order.synced_with_r360),
          active: order.active,
          dimmed: (order.pretty_status_simple < 9 && order.order_source === 'web'),
          okay: (order.pretty_status_simple >= 9),
          notpayed: (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn' && !order.status_fully_payed && order.order_source === 'web'),
          customernotset: (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn' && !order.status_customer_set && order.order_source === 'web'),
          canceled: order.canceled
      },
      on: {
        "click": function($event) {
          return _vm.openOrder(order, index)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(order.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(order.created_at, 'short-with-time')))]), _vm._v(" "), (_vm.groupBy === 'line') ? _c('td', [_vm._v(_vm._s(order.pretty_type))]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'line') ? _c('td', [_vm._v(_vm._s(order.person_name))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.arrival))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.departure))]), _vm._v(" "), _c('td', {
      class: {
        mark: order.error_code
      }
    }, [_vm._v(_vm._s(order.error_code))]), _vm._v(" "), _c('td', {
      class: {
        mark: order.pretty_status_simple < 4
      }
    }, [_vm._v(_vm._s(order.pretty_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(order.line_sum, {
      symbol: false
    })))]), _vm._v(" "), (_vm.groupBy === 'head') ? _c('td', [_vm._v(_vm._s(_vm._f("currency")(order.line_sum_skirental, {
      symbol: false
    })))]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'head') ? _c('td', [_vm._v(_vm._s(_vm._f("currency")(order.line_sum_skischool, {
      symbol: false
    })))]) : _vm._e(), _vm._v(" "), _c('td', {
      class: {
        mark: order.status === 'checkout_complete'
      }
    }, [_vm._v(_vm._s(order.pretty_klarna_status))]), _vm._v(" "), _c('td', {
      class: {
        mark: !order.number
      }
    }, [_vm._v(_vm._s(order.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.payment_method))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.sub_payment_method))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.synced_with_r360 ? 'Ja' : 'NEJ'))]), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('td', [_vm._v(_vm._s(order.status_customer_set ? 'Ja' : (order.source === 'web' ? 'NEJ' : '-')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site !== 'vallasen' && _vm.SITE_CONFIG.site !== 'ulricehamn') ? _c('td', [_vm._v(_vm._s(order.status_fully_payed ? 'Ja' : (order.source === 'web' ? 'NEJ' : '-')))]) : _vm._e()])
  }), 0), _vm._v(" "), _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th') : _vm._e(), _vm._v(" "), (_vm.groupBy === 'line') ? _c('th') : _vm._e(), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm._f("currency")(_vm.sum)))]), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', [_vm._v(_vm._s(_vm._f("currency")(_vm.sumSkirental)))]) : _vm._e(), _vm._v(" "), (_vm.groupBy === 'head') ? _c('th', [_vm._v(_vm._s(_vm._f("currency")(_vm.sumSkischool)))]) : _vm._e(), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n    Sida:\n    "), _vm._l((_vm.pages), function(p) {
    return _c('div', {
      class: 'button small border ' + ((p == _vm.page) ? '' : 'white'),
      on: {
        "click": function($event) {
          return _vm.changePage(p)
        }
      }
    }, [_vm._v(_vm._s(p))])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('router-view', {
    key: _vm.$route.params.orderId
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "50vw",
      "min-width": "50vw"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', {
    staticClass: "uppercase center",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Vanliga frågor")]), _vm._v(" "), _vm._l((_vm.faqs), function(ref, index) {
    var question = ref.question;
    var answer = ref.answer;

    return _c('div', {
      key: question,
      staticClass: "items-list"
    }, [_c('Collapsable', {
      attrs: {
        "title": question,
        "content": answer
      }
    })], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.change
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.isWinter) ? _c('h2', [_vm._v(_vm._s(_vm.$t('texts.texts-skischool-header-top-title')))]) : _vm._e(), _vm._v(" "), (_vm.isSummer) ? _c('h2', [_vm._v("Välj vilken cykelskola som passar dig bäst")]) : _vm._e(), _vm._v(" "), (!_vm.isSummer) ? _c('div', {
    class: {
      disabled: _vm.loading, notification: true, 'notification--transparent': true
    }
  }, [_c('b', {
    staticClass: "can-have-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('texts.texts-skischool-header-title'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "can-have-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('texts.texts-skischool-header-text'))
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('OutlineButton', {
    staticClass: "max-mobile",
    class: {
      active: _vm.expanded
    },
    attrs: {
      "label": _vm.$t('skischool.more-filters'),
      "closeLabel": _vm.$t('skischool.close-filters'),
      "icon": "Filter",
      "iconscale": 1.5,
      "status": _vm.expanded
    },
    on: {
      "clicked": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  })], 1), _vm._v(" "), _c('SkiSchoolFilter', {
    class: {
      disabled: _vm.loading, filter: true, opened: _vm.expanded
    },
    attrs: {
      "season": _vm.isSummer ? 'summer' : 'winter'
    },
    on: {
      "change": _vm.change
    }
  }), _vm._v(" "), _c('SkiSchoolFilterInfo', {
    attrs: {
      "count": _vm.count
    },
    on: {
      "change": _vm.change
    }
  })], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading,
      "text": _vm.$t('skischool.applying-filters')
    }
  }), _vm._v(" "), _c('SkiSchoolList', {
    class: {
      disabled: _vm.loading
    },
    attrs: {
      "data": _vm.data,
      "count": _vm.count
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.type + '-wrapper ' + (_vm.value ? 'active' : '') + (_vm.below ? ' below' : '') + (_vm.disabled ? ' disabled' : '')
  }, [_c('span', [(_vm.labelPosition === 'before' || _vm.labelPosition === 'left') ? _c('label', {
    class: _vm.labelPosition
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "the-graphics",
    style: (_vm.style)
  }), _vm._v(" "), (_vm.labelPosition === 'after') ? _c('label', {
    class: _vm.labelPosition,
    staticStyle: {
      "display": "block",
      "text-align": "center",
      "margin-top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.labelPosition === 'right') ? _c('label', {
    class: _vm.labelPosition
  }, [_vm._v(_vm._s(_vm.label)), (_vm.sublabel) ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v(_vm._s(_vm.sublabel))]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasChanges) ? _c('div', [_c('h1', [_vm._v("Uppdatera uppgifter")]), _vm._v(" "), _c('p', [_vm._v("Vill du uppdatera ditt konto med följande uppgifter?")]), _vm._v(" "), _c('table', _vm._l((_vm.config.changes), function(change) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(change.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.to))])])
  }), 0), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading
    }
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Ja, uppdatera")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Nej")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.goToMyPages
    }
  }, [_vm._v("Gå till mina sidor")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    staticClass: "center",
    attrs: {
      "wide": false,
      "show-close": false,
      "width": "400px"
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('p', [_c('b', [_vm._v("Du har redan ett boende i varukorgen")])]), _vm._v(" "), (_vm.accomodation && _vm.accomodation.name) ? _c('h1', {
    staticClass: "accomodation-title"
  }, [_vm._v(_vm._s(_vm.accomodation.name))]) : _vm._e(), _vm._v(" "), (_vm.accomodation) ? _c('AccomodationPeriodConfirm', {
    attrs: {
      "unit": _vm.unit,
      "arrival": _vm.arrival,
      "departure": _vm.departure,
      "small": true
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Om du vill boka flera boenden i samma bokning måste du välja samma datum.")]), _vm._v(" "), (!_vm.is_free) ? _c('p', [_vm._v("Den valda perioden är dock inte tillgänglig för detta boende.")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.is_free) ? _c('button', {
    staticClass: "small",
    on: {
      "click": _vm.goToInfo
    }
  }, [_vm._v("Okej, gå vidare och boka")]) : _vm._e(), _vm._v(" "), (!_vm.is_free) ? _c('button', {
    staticClass: "small",
    on: {
      "click": _vm.goToSearch
    }
  }, [_vm._v("Okej, gå tillbaka till sök")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5px"
    }
  }), _vm._v(" "), (_vm.is_free) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.goToSearch
    }
  }, [_vm._v("Tillbaka")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.goToCart
    }
  }, [_vm._v("Avbryt och gå till varukorg")])], 1)
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [(_vm.$store.state.isOnSite) ? _c('OnSiteFooter', {
    staticStyle: {
      "z-index": "1000000"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "540px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [(_vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('div', {
    staticClass: "keycard-splasch"
  }, [_vm._v("Just nu "), _c('div', {
    staticClass: "larger"
  }, [_vm._v("10% rabatt*")])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "center"
  }, [_vm._v("Boka liftkort"), _c('br')]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "skipass-holder"
  }, [_c('div', {
    staticClass: "image"
  }), _vm._v(" "), _c('div', {
    staticClass: "padded"
  }, [_c('ul', [_c('li', [_vm._v("Enkelt! Liftkort för hela vistelsen.")]), _vm._v(" "), _c('li', [_vm._v("Smidigt! Liftkorten klara vid ankomst.")]), _vm._v(" "), _c('li', [_vm._v("Snabbt! Åk direkt ut i backen.")])])])]), _vm._v(" "), (!_vm.skipassBlocked) ? _c('div', {
    class: 'center ' + (_vm.loading ? 'disabled' : '')
  }, [_c('div', {}, [_c('table', {
    staticClass: "skipass-table"
  }, [_c('tr', [(_vm.cartAccomodationObject.period) ? _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.cartAccomodationObject.period.date_arrival) + " - " + _vm._s(_vm.cartAccomodationObject.period.date_departure) + " "), _c('span', [_vm._v("(" + _vm._s(_vm.noOfDays()) + " dagar)")])]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.adults),
      expression: "cartSkipassObject.adults"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.adults)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "adults", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Vuxna\n          ")]), _vm._v(" "), _c('td', [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.adultPrice(false))))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.youths),
      expression: "cartSkipassObject.youths"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.youths)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "youths", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Ungdom\n          ")]), _vm._v(" "), _c('td', [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.youthPrice(false))))]) : _vm._e()])]), _vm._v(" "), (this.seniorPricelistPrice) ? _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.seniors),
      expression: "cartSkipassObject.seniors"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.seniors)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "seniors", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Senior\n          ")]), _vm._v(" "), _c('td', [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.seniorPrice(false))))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cartSkipassObject.children),
      expression: "cartSkipassObject.children"
    }],
    attrs: {
      "type": "number",
      "readonly": _vm.cartSkipassObject.confirmed
    },
    domProps: {
      "value": (_vm.cartSkipassObject.children)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cartSkipassObject, "children", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Barn\n          ")]), _vm._v(" "), _c('td', {
    class: {
      'children-price': !_vm.childPrice(false)
    }
  }, [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.childPrice(false), {
    freeIfZero: true
  })))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    attrs: {
      "type": "number",
      "readonly": ""
    },
    domProps: {
      "value": _vm.noOfSkipasses()
    }
  })]), _vm._v(" "), _c('td', [_vm._v("\n            Liftkort\n          ")]), _vm._v(" "), _c('td', {
    class: {
      'children-price': (!_vm.keycardTotalPrice() && parseInt(_vm.cartSkipassObject.children, 10))
    }
  }, [(!_vm.loading) ? _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.keycardTotalPrice(), {
    freeIfZero: true
  })))]) : _vm._e()])]), _vm._v(" "), (!_vm.loading) ? _c('tr', {
    staticClass: "summarizer"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [((_vm.originalPrice() > _vm.totalPrice()) && _vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('span', [_c('span', {
    staticClass: "smaller"
  }, [_vm._v("Ord pris:")]), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.originalPrice())) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "offsetter"
  }, [_c('span', [_vm._v("Totalt pris")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalPrice())))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.skipassBlocked) ? _c('div', {
    class: 'space center info-wrapper ' + (_vm.loading ? 'disabled' : '')
  }, [(_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center"
  }, [_vm._v("När ska liftkorten börja användas?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": !_vm.deliveryAllowed,
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationAfterCheckinText,
      "value": 'delivery',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": _vm.skiPassAccomodationBeforeCheckinText,
      "value": 'pickup',
      "valuebinder": _vm.delivery_type,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.delivery_type = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_ACTIVE('FeatureUseSkipassMachines')) ? _c('div', [_c('h2', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.SETTING('SettingSkipassMachineInfo').title + '<br />')
    }
  }), _vm._v(" "), _vm._l((_vm.SETTING('SettingSkipassMachineInfo').paragraphs), function(paragraph, index) {
    return _c('p', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.FEATURE_IS_NOT_ACTIVE('FeatureUseSkipassMachines') && _vm.delivery_type === 'pickup') ? _c('div', [_c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "center"
  }, [_vm._v("Var vill du hämta liftkorten?"), _c('br')]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Dalen",
      "value": 'by',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": "",
      "sublabel": "Berget",
      "value": 'berg',
      "valuebinder": _vm.site,
      "size": 24,
      "below": true
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.site = $event
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.skipassBlocked) ? _c('div', {
    staticClass: "space center bt-wrapper"
  }, [(!_vm.cartSkipassObject.confirmed) ? _c('button', {
    class: 'no-hover ' + (_vm.loading ? 'disabled' : ''),
    attrs: {
      "disabled": !_vm.validatedSkipasses()
    },
    on: {
      "click": function($event) {
        return _vm.cartSkipasses()
      }
    }
  }, [_vm._v("Ja, Förboka och spara tid")]) : _vm._e(), _vm._v(" "), (!_vm.cartSkipassObject.confirmed) ? _c('button', {
    class: 'small-key ' + (_vm.loading ? 'disabled' : ''),
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Nej, bokar senare")]) : _vm._e(), _vm._v(" "), (_vm.cartSkipassObject.confirmed) ? _c('button', {
    staticClass: "small green",
    on: {
      "click": function($event) {
        return _vm.removeSkipasses()
      }
    }
  }, [_vm._v(_vm._s(_vm.noOfSkipasses()) + " st valda")]) : _vm._e(), _vm._v(" "), (_vm.cartSkipassObject.confirmed) ? _c('button', {
    staticClass: "small trash border",
    on: {
      "click": function($event) {
        return _vm.removeSkipasses()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.7
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('div', [(false) ? _c('p', {
    staticClass: "notice"
  }, [(!_vm.skipassBlocked) ? _c('span', [_c('span', {
    domProps: {
      "innerHTML": _vm._s('* ' + _vm.SITE_CONFIG.accomodations.skipass_currently_discounted_text)
    }
  }), _c('br')]) : _vm._e(), _vm._v("\n      * "), _c('b', [_vm._v("Vi bjuder")]), _vm._v(" på kostnaden för kortet (ord. pris 55:-/st) när du bokar boende (gäller hela säsongen, kan inte läggas till i efterhand).\n    ")]) : _vm._e(), _vm._v(" "), (_vm.skipassBlocked) ? _c('div', {}, [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v("Just nu erbjuder vi 10% rabatt på liftkort när du bokar för hela boende-perioden. "), _c('b', [_vm._v("Ring oss på")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" senast den " + _vm._s(_vm.SITE_CONFIG.accomodations.skipass_currently_discounted_pretty_date) + " för att ta del av erbjudandet.")]), _vm._v(" "), _c('p', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.skipassBlocked) ? _c('div', {
    staticClass: "space center bt-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Okej")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.accomodations.skipass_currently_discounted) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.skipassBlocked) ? _c('p', {
    staticClass: "notice"
  }, [_c('b', [_vm._v("Ring oss på")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" för att boka liftkort till detta boende.")]) : _vm._e(), _vm._v(" "), (_vm.skipassBlocked) ? _c('div', {
    staticClass: "space center bt-wrapper"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Okej")])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emailreport"
  }, [_c('h1', [_vm._v("Rapporter")]), _vm._v(" "), _c('div', {
    staticClass: "report-inputs-wrapper"
  }, [_c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Ankomst från"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from),
      expression: "from"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.from = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Ankomst till"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.to),
      expression: "to"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.to = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Kod"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Rader")]), _vm._v(" "), _c('div', {
    staticClass: "checkboxes-container"
  }, _vm._l((_vm.lineTypeOptions), function(option) {
    return _c('label', {
      key: 'line_type' + option.value,
      staticStyle: {
        "font-weight": "normal"
      }
    }, [(option.text !== 'disabled') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.line_types[option.value]),
        expression: "line_types[option.value]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.line_types[option.value]) ? _vm._i(_vm.line_types[option.value], null) > -1 : (_vm.line_types[option.value])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.line_types[option.value],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.line_types, option.value, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.line_types, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.line_types, option.value, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (option.text !== 'disabled') ? _c('span', [_vm._v(_vm._s(option.text))]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Källa")]), _vm._v(" "), _c('div', {
    staticClass: "checkboxes-container"
  }, _vm._l((_vm.orderSourceOptions), function(option) {
    return _c('label', {
      key: 'order_source' + option.value,
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_sources[option.value]),
        expression: "order_sources[option.value]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.order_sources[option.value]) ? _vm._i(_vm.order_sources[option.value], null) > -1 : (_vm.order_sources[option.value])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.order_sources[option.value],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.order_sources, option.value, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.order_sources, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.order_sources, option.value, $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(option.text) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Minst antal dagar"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_min),
      expression: "days_min"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.days_min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Max antal dagar"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_max),
      expression: "days_max"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.days_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_max = $event.target.value
      }
    }
  }), _c('br')])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help"
  }, [_vm._v("Detta filter funkar inte på alla typer av rader, t.ex. boendetillval")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.getReportEmailLink()
    },
    on: {
      "click": _vm.showInfo
    }
  }, [_vm._v("Huvud: Epost/tfn")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("Rapporten innehåller e-postadresser och telefonnummer.")])]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.getReportEmailExtendedLink()
    },
    on: {
      "click": _vm.showInfo
    }
  }, [_vm._v("Rader: E-post/tfn/mer")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.getReportCodesWithExtraInfoLink()
    },
    on: {
      "click": _vm.showInfo
    }
  }, [_vm._v("Huvud: Med kod")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("Rapporten innehåller kundinfo, boende, kod, bokning samt fritextfält för kodbokningar.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "info"
  }, [_vm._v("Rapporten innehåller e-postadresser, telefonnummer, produktkod, pool-ID, antal dagar samt ankomstdatum för "), _c('b', [_vm._v("varje bokningsrad")]), _vm._v(".")])
}]}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'background-blue ' + 'step-' + _vm.stage
  }, [_c('div', {
    style: (!_vm.SITE_CONFIG.modules_open.skiletting.open ? 'visibility: hidden;' : '')
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps,
      "theme": "light"
    }
  }), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e()], 1), _vm._v(" "), _c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  }), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [(parseInt(_vm.$route.params.person)) ? _c('div', {
    staticClass: "remove-user",
    on: {
      "click": function($event) {
        return _vm.remove(_vm.index)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.remove-title', {
    skier: ''
  })) + " "), _c('button', {
    staticClass: "white small"
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.4
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('div', {
    class: 'content center a-step step-' + 10
  }, [(_vm.$route.params.person === '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-first-skier')))]) : _vm._e(), _vm._v(" "), (_vm.$route.params.person !== '0') ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.book-skier-x', {
    number: parseInt(_vm.$route.params.person) + 1
  })))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'box checkboxes',
    staticStyle: {
      "margin-bottom": "1.5rem"
    }
  }, [_c('Checkbox', {
    attrs: {
      "special-class": "rental-user",
      "label": "Ny",
      "label-position": "right",
      "value": false,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "special-class": "rental-user",
      "label": "Sparad",
      "label-position": "right",
      "value": true,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.tabSaved) ? _c('div', {
    staticClass: "flex"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "control"
  }, [_c('Login', {
    on: {
      "login": _vm.onLogin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn && !_vm.skiers.length && !_vm.loadingSkiers) ? _c('div', [_c('div', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('Note', {
    attrs: {
      "title": "Inga åkare",
      "color": "white"
    }
  }, [_c('p', [_vm._v("Vi hittade inga sparade åkare.")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.loadingSkiers) ? _c('div', [_c('div', {
    staticClass: "control"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loadingSkiers,
      "static": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.skiers.length) ? _c('div', [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "label no-left-margin"
  }, [_vm._v("Välj bland dina åkare")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.skiersAsSelect,
      "valuebinder": _vm.skierId,
      "validated": _vm.skierId,
      "label": "Välj åkare"
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.skierId = $event
      },
      "changed": _vm.setSkier
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.tabSaved) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "label no-left-margin"
  }, [_vm._v(_vm._s(_vm.$t('general.name')))]), _vm._v(" "), _c('div', {
    class: 'flex flexer ' + (_vm.validatedName ? 'selected' : '')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "nameInput",
    staticClass: "input",
    attrs: {
      "tabindex": "0",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "focus": _vm.inValidateName,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.validateName($event);
        _vm.validateStep10($event);
      },
      "blur": function($event) {
        _vm.validateName($event);
        _vm.validateStep10($event);
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffix",
    on: {
      "click": _vm.focusName
    }
  }, [(!_vm.validatedName) ? _c('icon', {
    attrs: {
      "name": "empty",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validatedName) ? _c('icon', {
    attrs: {
      "name": "circle-green-minus",
      "scale": 1.5
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('div', {
    class: 'content center a-step step-' + 13 + (_vm.stage < 13 ? ' disabled' : '')
  }, [(parseInt(_vm.$route.params.person) > 0) ? _c('div', {
    staticClass: "inline-block min-width white-text"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('skirental.rental-period-title')) + ": "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDate(_vm.pickedStartDate))
    }
  })])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skirental.rental-period-text')))])]) : _vm._e(), _vm._v(" "), (_vm.delivery) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_c('div', {
    staticClass: "inline-block min-width white-text",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.delivery.title')))], 1), _vm._v(" "), _c('ul', [_vm._l((_vm.deliveryMessages), function(message, index) {
    return _c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(message)
      }
    }, [_vm._v(_vm._s(message))])
  }), _vm._v(" "), (_vm.possibleWithStorage) ? _c('li', [_c('strong', [_vm._v("OBS! Nattförvaring.")]), _vm._v(" Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.")]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.$route.params.person) === 0) ? _c('div', {
    staticClass: "inline-block min-width"
  }, [(_vm.stage <= 13) ? _c('label', {
    staticClass: "label no-left-margin"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-days')))]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    ref: "dateDropdown",
    attrs: {
      "prefixicon": "calendar",
      "prefixicon-validated": "calendar-white",
      "tabindex": "0",
      "options": [],
      "validated": _vm.selectedDays,
      "label": '' + _vm.formatDate(_vm.pickedStartDate) + '',
      "bold-label": false
    },
    on: {
      "clicked": _vm.datepickerRangeModal,
      "clicked-suffix": _vm.dateClear
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stage >= 10) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.stage >= 10) ? _c('div', {
    class: 'content inline-block a-step step-' + 16 + (_vm.stage > 10 ? ' inline-block' : '') + ' ' + (_vm.stage < 16 ? ' disabled' : '')
  }, [(_vm.stage <= 16) ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-age')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.options), function(option) {
    return ((!_vm.selectedAge || _vm.selectedAge === option.value)) ? _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.selectedAge === option.value),
          'has-description': option.subtitle
      },
      on: {
        "click": function($event) {
          return _vm.setAge(option.value)
        }
      }
    }, [_vm._v("\n            " + _vm._s(option.title) + "\n            "), (option.subtitle /*&& stage === 16*/ ) ? _c('span', [_vm._v(_vm._s(option.subtitle))]) : _vm._e()]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.stage == 20) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 20) ? _c('div', {
    class: 'content a-step step-' + 20 + (_vm.stage > 16 ? ' inline-block' : '')
  }, [(_vm.stage <= 20) ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('skirental.what-to-rent')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.categories), function(category) {
    return (((!_vm.selectedCategory || _vm.selectedCategory === category.slug) && (!category.parent) && category.name)) ? _c('div', {
      class: {
        button: true,
          underlined: true,
          'small-text': true,
          checked: (_vm.selectedCategory === category.slug)
      },
      domProps: {
        "innerHTML": _vm._s((_vm.selectedCategory === 'other') ? ((
          _vm.subCategories && _vm.subCategories[_vm.selectedSubCategory] && _vm.subCategories[_vm.selectedSubCategory].name
        ) ? _vm.subCategories[_vm.selectedSubCategory].name : _vm.$t('skirental.other-equipment')) : category.name)
      },
      on: {
        "click": function($event) {
          return _vm.setCategory1(category.slug, category)
        }
      }
    }) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.stage == 30) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 30) ? _c('div', {
    class: 'content a-step step-' + 30 + (_vm.stage > 16 ? ' inline-block' : '')
  }, [_c('div', {
    staticClass: "label max-mobile label-products"
  }, [_vm._v(_vm._s(_vm.$t('skirental.what-to-rent')))]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, _vm._l((_vm.products), function(product, key) {
    return ((!_vm.selectedType || _vm.selectedType === key) && _vm.showProduct(key)) ? _c('div', {
      class: {
        button: true,
          'small-text': true,
          white: true,
          checked: (_vm.selectedType === key),
          'has-description': (product.description && _vm.stage === 30)
      },
      on: {
        "click": function($event) {
          return _vm.setType(key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(product.title) + "\n            "), (_vm.stage == 30) ? _c('span', [_vm._v(_vm._s(product.description))]) : _vm._e()]) : _vm._e()
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.stage >= 40) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.stage >= 40) ? _c('div', {
    class: 'content a-step step-' + 40
  }, [_c('h1', {
    staticClass: "level-phone"
  }, [_vm._v(_vm._s(_vm.$t('skirental.pick-level')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    class: 'box ' + (_vm.searchPackage === 'beginner' ? 'active' : ''),
    on: {
      "click": function($event) {
        return _vm.setPackage('beginner')
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('general.levels.beginner')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.2')))])]), _vm._v(" "), _c('button', {
    staticClass: "block ski-bt"
  }, [_vm._v(_vm._s(_vm.$t('general.pick')))])]), _vm._v(" "), _c('div', {
    class: 'box ' + (_vm.selectedAge !== 'children' ? 'larger' : '') + ' ' + (_vm.searchPackage === 'intermediate' ? 'active' : ''),
    on: {
      "click": function($event) {
        return _vm.setPackage('intermediate')
      }
    }
  }, [(_vm.selectedAge !== 'children') ? _c('div', {
    staticClass: "banner"
  }, [_vm._v(_vm._s(_vm.$t('general.popular-choice')))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('general.levels.average')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.4')))])]), _vm._v(" "), _c('button', {
    staticClass: "block ski-bt"
  }, [_vm._v(_vm._s(_vm.$t('general.pick')))])]), _vm._v(" "), (_vm.selectedAge !== 'children') ? _c('div', {
    class: 'box ' + (_vm.searchPackage === 'advanced' ? 'active' : ''),
    on: {
      "click": function($event) {
        return _vm.setPackage('advanced')
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('general.levels.advanced')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.5')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('skirental.level-bullets.6')))])]), _vm._v(" "), _c('button', {
    staticClass: "block ski-bt"
  }, [_vm._v(_vm._s(_vm.$t('general.pick')))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [(_vm.currentStepValid || (_vm.stage === 10 || _vm.stage === 13)) ? _c('button', {
    staticClass: "block border",
    attrs: {
      "disabled": !_vm.currentStepValid
    },
    on: {
      "click": _vm.goForward
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-on')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": true,
      "width": "1300px",
      "normal-width": "90vw",
      "set-class": "no-padding-mobile"
    },
    on: {
      "close": _vm.closeModalLocal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.unit) ? _c('div', {}) : _vm._e()])]), _vm._v(" "), (_vm.unit && _vm.open) ? _c('div', {
    class: 'modal-content active-tab-' + _vm.activeTab
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h1",
    class: {
      'has-subtitle': _vm.unit.subtitle
    }
  }, [_c('h1', [_vm._v("\n        " + _vm._s((_vm.unit.display_name || _vm.unit.description_title)) + "\n        "), (_vm.unit.subtitle) ? _c('i', [_vm._v(_vm._s(_vm.unit.subtitle))]) : _vm._e()])]), _vm._v(" "), (_vm.confirmedAccomodations.length && !_vm.editing) ? _c('div', {
    staticClass: "multiple-accomodations"
  }, [_vm._v("\n      Du har redan ett boende i varukorgen. Om du vill boka flera boenden i samma bokning måste du välja samma datum ("), _c('span', [_vm._v(_vm._s(_vm._f("dateRange")([_vm.confirmedAccomodations[0].period.date_arrival, _vm.confirmedAccomodations[0].period.date_departure], 'D MMMM', ' - ')))]), _vm._v(").\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'calendar-periods': true
    }
  }, [_c('div', {
    staticClass: "calendar-header center"
  }, [_c('div', [_c('label', {
    staticClass: "calendar-helper-text min-desktop"
  }, [_c('icon', {
    attrs: {
      "name": "calendar-blue",
      "scale": 2
    }
  }), _c('br'), _vm._v("\n            Öppna kalendervy för:\n          ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "calendar-buttons"
  }, [(this.validStartDatesWinter.length) ? _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.winterCalendarOpen
    },
    style: ('order: ' + _vm.getButtonOrderFor('winter')),
    attrs: {
      "label": _vm.getButtonLabelFor('winter'),
      "closeLabel": _vm.getButtonLabelFor('winter'),
      "icon": "skiing",
      "iconscale": 2.5,
      "status": _vm.winterCalendarOpen
    },
    on: {
      "clicked": _vm.toggleWinterCalendar
    }
  }) : _vm._e(), _vm._v(" "), (this.validStartDatesSummer.length) ? _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.summerCalendarOpen
    },
    style: ('order: ' + _vm.getButtonOrderFor('summer')),
    attrs: {
      "label": _vm.getButtonLabelFor('summer'),
      "closeLabel": _vm.getButtonLabelFor('summer'),
      "icon": "biking",
      "iconscale": 2.5,
      "status": _vm.summerCalendarOpen
    },
    on: {
      "clicked": _vm.toggleSummerCalendar
    }
  }) : _vm._e(), _vm._v(" "), (this.validStartDatesNextWinter.length) ? _c('OutlineButton', {
    staticClass: "filter-bt",
    class: {
      active: _vm.nextWinterCalendarOpen
    },
    style: ('order: ' + _vm.getButtonOrderFor('next_winter')),
    attrs: {
      "label": _vm.getButtonLabelFor('next_winter'),
      "closeLabel": _vm.getButtonLabelFor('next_winter'),
      "icon": "skiing",
      "iconscale": 2.5,
      "status": _vm.nextWinterCalendarOpen
    },
    on: {
      "clicked": _vm.toggleNextWinterCalendar
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    class: {
      calendar: true, opened: _vm.winterCalendarOpen
    }
  }, [_c('DatepickerRangeModal', {
    attrs: {
      "params": {
        componentType: 'ModalFaker',
        clickOutside: false,
        validDates: this.validStartDatesWinter,
        disabledDays: this.disabledDays,
        specialDays: this.specialDays,
        onPickStart: this.updateEndDate,
        pickedStartDate: null,
        pickedEndDate: null,
        terminology: 'Välj',
        onClose: this.onPicked,
        infoOnPicked: 'Välj slutdatum',
        info: 'Välj vilken dag du vill bo från',
        disableSingle: true,
        open: this.SITE_CONFIG.modules_open.accomodation.open,
        closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
        startMonth: this.startMonth('winter')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      calendar: true, opened: _vm.summerCalendarOpen
    }
  }, [_c('DatepickerRangeModal', {
    attrs: {
      "params": {
        componentType: 'ModalFaker',
        clickOutside: false,
        validDates: this.validStartDatesSummer,
        disabledDays: this.disabledDays,
        specialDays: this.specialDays,
        onPickStart: this.updateEndDate,
        pickedStartDate: null,
        pickedEndDate: null,
        terminology: 'Välj',
        onClose: this.onPicked,
        infoOnPicked: 'Välj slutdatum',
        info: 'Välj vilken dag du vill bo från',
        disableSingle: true,
        open: this.SITE_CONFIG.modules_open.accomodation.open,
        closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
        startMonth: this.startMonth('summer')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      calendar: true, opened: _vm.nextWinterCalendarOpen
    }
  }, [_c('DatepickerRangeModal', {
    attrs: {
      "params": {
        componentType: 'ModalFaker',
        clickOutside: false,
        validDates: this.validStartDatesNextWinter,
        disabledDays: this.disabledDays,
        specialDays: this.specialDays,
        onPickStart: this.updateEndDate,
        pickedStartDate: null,
        pickedEndDate: null,
        terminology: 'Välj',
        onClose: this.onPicked,
        infoOnPicked: 'Välj slutdatum',
        info: 'Välj vilken dag du vill bo från',
        disableSingle: true,
        open: this.SITE_CONFIG.modules_open.accomodation.open,
        closed_message: this.SITE_CONFIG.modules_open.accomodation.closed_message,
        startMonth: this.startMonth('next_winter')
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "max-tablet"
  }, [_c('div', {
    staticClass: "tabs-header center"
  }, [_c('label', [_vm._v("Välj period")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [(_vm.unit.prices_special_length) ? _c('div', {
    class: [
      'tab',
      _vm.activeTab === 'special' && 'active' ],
    on: {
      "click": function($event) {
        return _vm.setTab('special')
      }
    }
  }, [_c('div', [_vm._v("Populära perioder 2026/27")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.meta_super_titles), function(value, index) {
    return _c('div', {
      class: [
        'tab',
        _vm.activeTab === (index + 1) && 'active' ],
      on: {
        "click": function($event) {
          return _vm.setTab(index + 1)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(value))])])
  })], 2)]), _vm._v(" "), (_vm.unit.prices_special_length) ? _c('div', {
    staticClass: "special-periods"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        Populära perioder 2026/2027\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row week-title-row"
  }, [_c('th', [_c('b', [_vm._v(" ")])]), _vm._v(" "), _c('th', [_vm._v("\n            Datum\n          ")]), _vm._v(" "), _c('th', [_vm._v("\n            Pris\n          ")])]), _vm._v(" "), _vm._l((_vm.sortedSpecialPrices), function(price) {
    return _c('tr', [_c('td', [_c('b', {
      domProps: {
        "innerHTML": _vm._s(price.title)
      }
    }), _vm._v(" "), (price.notes) ? _c('div', {
      staticClass: "smaller"
    }, [_vm._v(_vm._s(price.notes))]) : _vm._e()]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(price.days)
      }
    }), _vm._v(" "), _c('td', {
      class: {
        notvalid: _vm.validPeriod && (price.period && (price.period.date_arrival + '-' + price.period.date_departure) != _vm.validPeriod)
      }
    }, [(price.period.free) ? _c('span', {
      class: {
        price: true,
          selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == price.period.period && _vm.cartAccomodationObject.period.week == price.period.week)
      },
      on: {
        "click": function($event) {
          _vm.chooseAccomodation({
            pool_lid: _vm.unit.pool_lid,
            unit_lid: _vm.unit.unit_lid,
            period: price.period,
            week: price.period.week,
            name: (_vm.unit.display_name || _vm.unit.description_title),
            capacity: _vm.unit.capacity,
            price: price.period.price
          })
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(price.period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (!price.period.free) ? _c('span', {
      staticClass: "taken"
    }, [_vm._v("\n              -\n            ")]) : _vm._e()])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.unit.prices_length) ? _c('div', {
    class: {
      'normal-periods': true, 'no-specials': !_vm.unit.prices_special_length
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        PRISÖVERSIKT VINTER 2026/2027\n      ")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "title-row"
  }, [_c('th'), _vm._v(" "), _vm._l((_vm.meta_super_titles), function(meta, index) {
    return (meta) ? _c('th', {
      class: 'period-super-title',
      attrs: {
        "colspan": _vm.meta_super_titles_colspan[index]
      }
    }, [_vm._v("\n            " + _vm._s(meta) + "\n          ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "title-row week-title-row"
  }, [_c('th', {
    staticClass: "week-indicator"
  }, [_c('b', [_vm._v("Vecka")])]), _vm._v(" "), _vm._l((_vm.meta_periods), function(period, index) {
    return _c('th', {
      class: 'week-day-title index-' + _vm.belongsToCol(index)
    }, [_vm._v("\n            " + _vm._s(period.days) + "\n          ")])
  })], 2), _vm._v(" "), _vm._l((_vm.unit.prices), function(week, index) {
    return (index >= _vm.meta_weeks[0] && index <= _vm.meta_weeks[1]) ? _c('tr', [_c('td', {
      staticClass: "week-indicator",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('b', [_vm._v("v." + _vm._s(week.week))]), _vm._v(" "), _c('popper', {
      attrs: {
        "trigger": "click",
        "options": {
          placement: 'right'
        }
      }
    }, [_c('div', {
      staticClass: "popper"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.showDates(week.periods))
      }
    })]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_vm._v("\n                Datum\n              ")])])], 1), _vm._v(" "), _vm._l((week.periods), function(period, key, index) {
      return _c('td', {
        class: (_vm.validPeriod && (period && (period.date_arrival + '-' + period.date_departure) != _vm.validPeriod) ? 'notvalid' : '') + ' p index-' + _vm.belongsToCol(index)
      }, [(period && period.free && !period.hide && !period.note) ? _c('span', {
        class: {
          price: true,
            selected: (_vm.cartAccomodationObject && _vm.cartAccomodationObject.period && (_vm.cartAccomodationObject.unitLid == _vm.unit.unit_lid && _vm.cartAccomodationObject.poolLid == _vm.unit.pool_lid) && _vm.cartAccomodationObject.period.period == period.period && _vm.cartAccomodationObject.period.week == period.week)
        },
        on: {
          "click": function($event) {
            _vm.chooseAccomodation({
              pool_lid: _vm.unit.pool_lid,
              unit_lid: _vm.unit.unit_lid,
              period: period,
              week: week.week,
              name: (_vm.unit.display_name || _vm.unit.description_title),
              capacity: _vm.unit.capacity,
              price: period.price
            })
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm._f("currency")(period.price)) + "\n            ")]) : _vm._e(), _vm._v(" "), (period && !period.free && !period.hide && !period.note) ? _c('span', {
        staticClass: "taken"
      }, [_vm._v("\n              -\n            ")]) : _vm._e(), _vm._v(" "), (period && period.note) ? _c('span', {
        staticClass: "price-note"
      }, [_vm._v("\n              *\n            ")]) : _vm._e(), _vm._v(" "), (!period) ? _c('span', {
        staticClass: "taken"
      }, [_vm._v("\n              -\n            ")]) : _vm._e()])
    })], 2) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.unit.prices_length && !_vm.unit.prices_special_length && !_vm.unit.prices_summer_length) ? _c('div', [_c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Det går för tillfället inte att visa några priser eller lediga perioder för detta boende. Kom tillbaka snart eller ring gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin-top": "15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.notes) ? _c('div', {
    staticClass: "info-transparent"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', [_c('b', [_vm._v("*")]), _vm._v(" " + _vm._s(note) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), ((_vm.unit.tags || []).indexOf('SATURDAY_ACCOMMODATION') !== -1 && _vm.SITE_CONFIG.settings.SettingAccommodationPriceViewInfo) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.settings.SettingAccommodationPriceViewInfo)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_limit_text) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_limit_text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.special_info1) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.special_info1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.closed_slopes) ? _c('div', {
    staticClass: "info",
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.closed_slopes)
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.open) ? _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('p', [_vm._v(_vm._s(_vm.closedMessage))])])]) : _vm._e(), _vm._v(" "), (false) ? _c('pre', [_vm._v(_vm._s(_vm.unit))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, disabled: _vm.loading, 'component--box': true
    }
  }, [_c('div', {
    staticClass: "component__inner"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("Nytt lösenord")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    attrs: {
      "placeholder": "Nytt lösenord",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "new_password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Repetera lösenord")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password_confirm),
      expression: "user.new_password_confirm"
    }],
    attrs: {
      "placeholder": "Repetera lösenord",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.new_password_confirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "new_password_confirm", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "button--rounded",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Spara")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_vm._l((_vm.data), function(maxages, minage) {
    return (_vm.SITE_CONFIG.modules_open.school.open) ? _c('div', _vm._l((maxages), function(schools, maxage) {
      return _c('div', {
        staticClass: "list"
      }, [_c('div', {
        staticClass: "list-header"
      }, [(_vm.isPrivate(schools) && (_vm.isSnowboard(schools) || _vm.$route.query.type === 'snowboard')) ? _c('span', [_vm._v(_vm._s((_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') ? _vm.$t('skischool.types-singular.private-snowboard') : _vm.$t('skischool.types.private-snowboard')))]) : (_vm.isPrivate(schools) || _vm.$route.query.type === 'private') ? _c('span', [_vm._v(_vm._s((_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') ? _vm.$t('skischool.types-singular.private') : _vm.$t('skischool.types.private')))]) : (maxage < 70) ? _c('span', [_vm._v(_vm._s(minage !== maxage ? minage + '-' + maxage : minage) + " " + _vm._s(_vm.$t('general.years')))]) : (maxage >= 70 && minage <= 0) ? _c('span', [(_vm.$route.query.type === 'group') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.types.group')))]) : _vm._e(), _vm._v(" "), (_vm.$route.query.type === 'snowboard') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.types.snowboard')))]) : _vm._e()]) : (maxage >= 70 && minage > 0) ? _c('span', [_vm._v(_vm._s(minage) + "+ " + _vm._s(_vm.$t('general.years')))]) : _vm._e()]), _vm._v(" "), _c('transition-group', {
        staticClass: "animate-list separator",
        attrs: {
          "name": "animate-list",
          "tag": "ul"
        }
      }, _vm._l((schools), function(level) {
        return _c('div', {
          key: (level.info.level + '-' + minage + '-' + maxage),
          staticClass: "animate-list-item area-wrapper"
        }, [_c('SkiSchoolListPool', {
          attrs: {
            "level": level
          }
        })], 1)
      }), 0)], 1)
    }), 0) : _vm._e()
  }), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.school.open) ? _c('div', {
    staticClass: "no-results"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.school.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.school.open && (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget')) ? _c('div', [(!_vm.count) ? _c('div', {
    staticClass: "no-results"
  }, [_c('b', [_vm._v("Inga sökresultat")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('p', [_vm._v("För alla vuxna erbjuder vi endast privatlektioner.")]) : _vm._e()]) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Hittar du inte det du söker, skicka in en skidskoleförfrågan via "), _c('a', {
    attrs: {
      "href": "/gastservice/kontakta-oss/"
    }
  }, [_vm._v("vårt formulär")]), _vm._v(".")])
}]}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: 'awaiting awaiting-' + (_vm.static ? 'static' : '')
  }, [_c('div', {
    class: 'text ' + (_vm.show ? 'visible' : '')
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('br'), _vm._v(" "), _vm._m(0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-dots dark-gray"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')])
}]}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-header",
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), (_vm.isActive()) ? _c('span', {
    staticClass: "icon"
  }, [_vm._v("-")]) : _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggle()
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive()),
      expression: "isActive()"
    }],
    staticClass: "item-body",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "turn-the-phone"
  }, [_c('div', {
    staticClass: "turn-the-phone__circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "turn-the-phone__message"
  }, [_vm._v("Vänd telefonen för att visa listan.")]), _vm._v(" "), _c('button', {
    staticClass: "go-back",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Gå tillbaka")])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading,
      "text": "Hämtar boenden"
    }
  }), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.isAwaitingFilter,
      "text": "Laddar skillnader"
    }
  }), _vm._v(" "), _c('div', {
    class: {
      component: true, disabled: (_vm.loading || _vm.isAwaitingFilter)
    }
  }, [_c('h1', [_vm._v("Jämför upp till 3 boenden")]), _vm._v(" "), _c('div', {
    class: {
      disabled: (_vm.accomodations.length <= 1)
    },
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('SwitchButton', {
    attrs: {
      "icon": "compare",
      "iconscale": 2,
      "value": false,
      "sync": false,
      "labels": {
        checked: 'Visar skillnader',
        unchecked: 'Visa skillnader'
      }
    },
    on: {
      "toggle": _vm.changeValue
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Jämför intressanta boenden. Du kan också klicka på filtret visa skillnader för att bara se det som skiljer valda boenden.")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_vm._l((_vm.accomodations), function(unit, key) {
    return _c('div', [_c('div', {
      staticClass: "image",
      style: ('background-image:url(' + (unit && unit.pool && unit.pool.image) + ')')
    }, [(_vm.fromMemory) ? _c('div', {
      staticClass: "icon-bg"
    }, [_c('button', {
      staticClass: "white small border",
      on: {
        "click": function($event) {
          return _vm.removeFavoriteLocal(key)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 2
      }
    })], 1)]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v(_vm._s((unit.display_name || unit.description_title)))]), _vm._v(" "), _c('button', {
      staticClass: "medium",
      on: {
        "click": function($event) {
          return _vm.openInfo(unit)
        }
      }
    }, [_vm._v("Info/boka")]), _vm._v(" "), _c('button', {
      staticClass: "medium white border",
      on: {
        "click": function($event) {
          return _vm.openMap(unit)
        }
      }
    }, [_vm._v("Visa på karta "), _c('icon', {
      attrs: {
        "name": "map-blue",
        "scale": 1.7
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "fact-container"
    }, [(!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('bedrooms'))) ? _c('div', {
      class: 'fact ' + (unit.bedrooms ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "antal rum",
        "scale": 1.4
      }
    }), _vm._v("\n          Sovrum (" + _vm._s(unit.bedrooms) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('living_area'))) ? _c('div', {
      class: 'fact ' + (unit.living_area ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "area",
        "scale": 1.4
      }
    }), _vm._v("\n          Boarea (" + _vm._s(unit.living_area) + "m2)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('internet'))) ? _c('div', {
      class: 'fact ' + (unit.internet ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "wifi",
        "scale": 1.4
      }
    }), _vm._v("\n          Wi-Fi\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('washing_machine'))) ? _c('div', {
      class: 'fact ' + (unit.washing_machine ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "tvattmaskin-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Tvättmaskin\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('terrace_balcony'))) ? _c('div', {
      class: 'fact ' + (unit.terrace_balcony ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "balkong",
        "scale": 1.4
      }
    }), _vm._v("\n          Balkong/altan\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('dishwasher'))) ? _c('div', {
      class: 'fact ' + (unit.dishwasher ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "diskmaskin-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Diskmaskin\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('pets_allowed'))) ? _c('div', {
      class: 'fact ' + (unit.pets_allowed ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "husdjur-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Husdjur tillåtna\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('sauna'))) ? _c('div', {
      class: 'fact ' + (unit.sauna ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "bastu-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Bastu\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active && (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('direct_incheck')))) ? _c('div', {
      class: 'fact ' + 'active'
    }, [_c('icon', {
      attrs: {
        "name": "direkt-incheck-black",
        "scale": 1.4
      }
    }), _vm._v("\n          " + _vm._s(unit.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].title) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active && (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('lock_type_id')))) ? _c('div', {
      class: 'fact ' + (unit.lock_type_id ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "direkt-incheck-black",
        "scale": 1.4
      }
    }), _vm._v("\n          " + _vm._s(unit.lock_type_id ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].title : Object.values(_vm.SITE_CONFIG.settings.SettingLockTypes.texts).map(function(item) {
      return item.title;
    }).join(' / ')) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('handicap_rooms'))) ? _c('div', {
      class: 'fact ' + (unit.handicap_rooms ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "handikapp",
        "scale": 1.4
      }
    }), _vm._v("\n          Handikappanpassat\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('dryer_cabinet'))) ? _c('div', {
      class: 'fact ' + (unit.dryer_cabinet ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "torkskap",
        "scale": 1.4
      }
    }), _vm._v("\n          Torkskåp\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('toilets'))) ? _c('div', {
      class: 'fact ' + (unit.toilets ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "wc",
        "scale": 1.4
      }
    }), _vm._v("\n          WC (" + _vm._s(unit.toilets) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), ((!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('hot_tub'))) && _vm.SITE_CONFIG.site != 'branas') ? _c('div', {
      class: 'fact ' + (unit.hot_tub ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "badtunna",
        "scale": 1.4
      }
    }), _vm._v("\n          Badtunna\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('extra_beds'))) ? _c('div', {
      class: 'fact ' + (unit.extra_beds ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "sangar",
        "scale": 1.4
      }
    }), _vm._v("\n          Extrabäddar (" + _vm._s(unit.extra_beds) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('final_cleaning_included'))) ? _c('div', {
      class: 'fact ' + (unit.final_cleaning_included ? 'active' : '')
    }, [_c('div', [_c('icon', {
      attrs: {
        "name": "stadning-black",
        "scale": 1.4
      }
    }), _vm._v("\n            Slutstäd (ingår)\n          ")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('final_cleaning_available'))) ? _c('div', {
      class: 'fact ' + (unit.final_cleaning_available ? 'active' : '')
    }, [_c('div', [_c('icon', {
      attrs: {
        "name": "stadning-black",
        "scale": 1.4
      }
    }), _vm._v("\n            Slutstäd (tillval)\n          ")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('child_friendly'))) ? _c('div', {
      class: 'fact ' + (unit.child_friendly ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "smiley-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Extra barnanpassat\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('beds'))) ? _c('div', {
      class: 'fact ' + (unit.beds ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "sangar",
        "scale": 1.4
      }
    }), _vm._v("\n          Bäddar (" + _vm._s(unit.beds) + "st)\n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('fireplace'))) ? _c('div', {
      class: 'fact ' + (unit.fireplace ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "kamin",
        "scale": 1.4
      }
    }), _vm._v("\n          Öppen spis\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.filters.chargeStation && (!_vm.onlyDifferences || (_vm.onlyDifferences && _vm.differs('charging_post')))) ? _c('div', {
      class: 'fact ' + (unit.charging_post ? 'active' : '')
    }, [_c('icon', {
      attrs: {
        "name": "laddstolpe-black",
        "scale": 1.4
      }
    }), _vm._v("\n          Laddstolpe\n        ")], 1) : _vm._e()])])
  }), _vm._v(" "), (_vm.accomodations.length < 3 && _vm.fromMemory) ? _c('div', {
    on: {
      "click": _vm.goToAccomodations
    }
  }, [_c('div', {
    staticClass: "add-icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', {
    staticClass: "add-more"
  }, [_vm._v("Lägg till fler boenden "), _c('br'), _vm._v(" och jämför")])
}]}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'pretty-order ' + _vm.order.status
  }, [(_vm.orderTypeSingle === 'accomodation') ? _c('div', _vm._l((_vm.order.details.rows.accomodation), function(row) {
    return _c('div', {
      key: row.rowid
    }, [(row.accommodation) ? _c('div', {
      staticClass: "accommodation"
    }, [_c('div', {
      staticClass: "accommodation-image",
      style: ((row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) ? 'background-image:url(' + (row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) + ')' : 'background-size: cover;')
    }), _vm._v(" "), _c('div', {
      staticClass: "booking-facts"
    }, [_c('p', {
      staticClass: "booking-id"
    }, [_vm._v("\n              Bokningsnummer: " + _vm._s(_vm.order.resvid) + "\n            ")]), _vm._v(" "), _c('p', {
      staticClass: "booking-title"
    }, [_vm._v("\n              " + _vm._s(row.accommodation.display_name || row.accommodation.description_title)), (row.accommodation.subtitle) ? _c('span', [_vm._v(" – " + _vm._s(row.accommodation.subtitle))]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "arrival-date"
    }, [_vm._v("\n              " + _vm._s(_vm._f("dateRange")([_vm.order.details.firstDate, _vm.order.details.lastDate], 'long', ' – ')) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "spacer",
      staticStyle: {
        "margin-top": "1.5rem"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goToBooking(_vm.order.headlid)
        }
      }
    }, [_vm._v("Visa bokning")])])]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.orderTypeSingle !== 'accomodation') ? _c('div', [_c('div', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "other-image",
    style: ('background-image:url(' + 'https://cdn.branasgruppen.se/branas/app/uploads/2023/10/27141148/familjmedskidor_hero.jpg' + ');')
  }), _vm._v(" "), _c('div', {
    staticClass: "booking-facts"
  }, [_c('div', [_c('p', {
    staticClass: "booking-id"
  }, [_vm._v("\n              Bokningsnummer: " + _vm._s(_vm.order.resvid) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "booking-title"
  }, [_vm._v("\n              " + _vm._s(_vm.orderTypeVisual) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "arrival-date"
  }, [_vm._v("\n              " + _vm._s(_vm._f("date")(_vm.order.details.firstDate, 'long', ' – ')) + "\n            ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "book-more",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToBooking(_vm.order.headlid)
      }
    }
  }, [_vm._v("Visa bokning")])])])]), _vm._v(" "), _c('PrettyOrderDetails', {
    attrs: {
      "order": _vm.order,
      "types": ['rental', 'skipass', 'skischool'],
      "openRental": true,
      "openSkipass": true,
      "openSkischool": true,
      "bookMoreCallback": _vm.bookMoreCb
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unitShow) ? _c('div', {
    class: 'units-left units-left--' + _vm.getCriticalLevel
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "width": "16px",
      "height": "16px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getUnitsLeft) + " " + _vm._s(_vm.getTypeText) + " kvar")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Search")]), _vm._v("\n      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\n      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\n      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n    ")])])
}]}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "600px",
      "min-width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', [_vm._v("Parametrar för synkronisering")]), _vm._v(" "), _c('h3', [_vm._v("Anpassa parametrar")]), _vm._v(" "), _vm._l((_vm.params.args1), function(arg, key) {
    return _c('div', {
      class: arg.length >= 4 && arg[3] ? 'disabled' : ''
    }, [(arg[0] === 'accomodation') ? _c('div', {
      staticClass: "field"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.accomodationFilter),
        expression: "accomodationFilter"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": "Sök boende"
      },
      domProps: {
        "value": (_vm.accomodationFilter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.accomodationFilter = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.pools.length) ? _c('div', {
      staticClass: "list"
    }, [_c('table', _vm._l((_vm.filteredPools), function(pool, key) {
      return _c('tbody', {
        class: {
          active: pool.active
        },
        on: {
          "click": function($event) {
            return _vm.setPoolActive(pool.id, pool)
          }
        }
      }, [_c('tr', [_c('th', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_vm._v(_vm._s(pool.display_name || pool.name) + " (" + _vm._s(pool.unit_count) + " st)")])]), _vm._v(" "), _vm._l((pool.units), function(unit, k) {
        return _c('tr', {
          class: {
            active: unit.active
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.setUnitActive(unit.id, pool.id)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(unit.description_title || unit.name))])])
      })], 2)
    }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.pools.length) ? _c('div', {
      staticClass: "list"
    }, [_vm._v("\n        laddar...\n      ")]) : _vm._e(), _vm._v("\n\n      " + _vm._s(_vm.selectedCount || 'Alla') + " boenden valda\n    ")]) : _vm._e(), _vm._v(" "), (arg[0] === 'switch') ? _c('div', {
      staticClass: "field"
    }, [_c('SwitchButton', {
      attrs: {
        "store": key,
        "iconscale": 2,
        "value": arg[2],
        "sync": false,
        "labels": {
          checked: arg[1],
          unchecked: arg[1]
        }
      },
      on: {
        "toggle": _vm.toggle
      }
    })], 1) : _vm._e(), _vm._v(" "), (arg[0] === 'text') ? _c('div', {
      staticClass: "field"
    }, [_vm._v("\n      " + _vm._s(arg[1]) + "\n      "), _c('input', {
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": arg[2]
      },
      on: {
        "keyup": function($event) {
          return _vm.updateArg1($event, key)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (arg[0] === 'text-readonly') ? _c('div', {
      staticClass: "field"
    }, [_vm._v("\n      " + _vm._s(arg[1]) + "\n      "), _c('input', {
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": arg[2]
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('h3', [_vm._v("Övriga parametrar")]), _vm._v(" "), _vm._l((_vm.params.args2), function(arg, key) {
    return _c('div', [_vm._v("\n    " + _vm._s(arg) + "\n  ")])
  }), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.goOn
    }
  }, [_vm._v("Kör")])], 2)
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.SITE_CONFIG.payment_service === 'collector') ? _c('CollectorCheckoutConfirmation') : (_vm.SITE_CONFIG.payment_service === 'klarna') ? _c('KlarnaCheckoutConfirmation') : _vm._e(), _vm._v(" "), _c('OrderCheckForCancellation')], 1)
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'only-collect-in-shop': !_vm.SITE_CONFIG.rental.delivery
    }
  }, [_c('div', {
    class: {
      banner: true, quick: _vm.quick
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.page.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('SkiRentalDiscount'), _vm._v(" "), _c('div', {
    staticClass: "offer-wrapper"
  }, [_c('div', {
    staticClass: "offer-box without-delivery min-tablet",
    on: {
      "click": function($event) {
        return _vm.openWithoutDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "image blue"
  }, [_c('icon', {
    attrs: {
      "name": "hamta-sjalv",
      "scale": 5
    }
  }), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-and-pickup-with-br'))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('h2', [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['without-delivery-content-desktop'])
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-and-pickup')))]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e()])])]), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery) ? _c('div', {
    staticClass: "offer-box with-delivery min-tablet",
    on: {
      "click": function($event) {
        return _vm.openWithDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "image red"
  }, [_c('icon', {
    attrs: {
      "name": "utkorning",
      "scale": 6
    }
  }), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-with-delivery-to-accomodation'))
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['with-delivery-content-desktop'])
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-with-delivery')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "items-list max-mobile",
    on: {
      "click": function($event) {
        return _vm.openWithoutDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "test"
  }, [_c('div', {
    staticClass: "item-image blue"
  }, [_c('icon', {
    attrs: {
      "name": "hamta-sjalv",
      "scale": 3.8
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_c('div', {}, [(_vm.SITE_CONFIG.rental.delivery) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-and-pickup-with-br'))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('h2', [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['without-delivery-content-mobile'])
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [(_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-and-pickup')))]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e()])])]), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery) ? _c('div', {
    staticClass: "items-list max-mobile",
    on: {
      "click": function($event) {
        return _vm.openWithDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "test"
  }, [_c('div', {
    staticClass: "item-image"
  }, [_c('icon', {
    attrs: {
      "name": "utkorning",
      "scale": 4
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_c('div', {}, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-with-delivery-to-accomodation'))
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['with-delivery-content-mobile'])
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper red-button"
  }, [_c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-with-delivery')))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embed-container"
  })
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center component"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.payment-code-confirmation')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.bookingnumber')) + ":")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.number))])])])
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "ingress"
  }, [_vm._v("BOKA VÅRA FÖRMÅNLIGA PERIODLIFTKORT")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("HELGKORT")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("KORTVECKA")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("VECKA")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Under jul och nyår ger vi helg- och kortveckopriser på våra 4- och 5-dagarskort (när kortet följer boendeperioden), priset är justerat i onlinebokningen.")]), _vm._v(" "), _c('Collapsable', {
    attrs: {
      "title": "Så fungerar det med liftkort",
      "content": "\n    <p>I Branäs använder vi ett så kallat keycard på vilket du kan ladda ditt liftkort. Du använder sedan detta kort för att komma in till liftarna. Du laddar kortet med den tid du vill åka skidor, från tre timmar och uppåt.</p>\n    <p>Alla barn under åtta år åker gratis. De behöver dock ett keycard för att kunna åka och det kostar 55kr. När du har köpt ett keycard så kan du spara det till nästa säsong och det fungerar dessutom i våra övriga anläggningar som exempelvis Kungsberget och Vallåsen.</p>\n    <div class='clickable button-box'>\n        <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p>\n    </p>\n    "
    }
  }), _vm._v(" "), _c('Collapsable', {
    attrs: {
      "title": "Här köper du liftkort",
      "content": "\n    <p>Du kan köpa ditt liftkort redan nu på webben. Då kan du köpa ett helt nytt liftkort eller ladda på ett befintligt keycard, se ”Så fungerar det med liftkort” här ovanför, för att läsa mer om liftkort och keycard.</p>\n    <div class='clickable button-box'>\n        <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p> </p>\n    <p>Du kan också köpa liftkortet på plats i Branäs, i våra infocenter, skidhyrorna, sportshopen och i våra närlivsbutiker. På pistkartan hittar du inköpsställen för våra liftkort.</p>\n    <div class='clickable button-box small-button'>\n        <a href='/skidakning/backar-och-liftar/#pistkartor'>Till våra pistkartor   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p>\n    </p>\n    "
    }
  }), _vm._v(" "), _c('Collapsable', {
    attrs: {
      "title": "Tips - Undvik köer, köp dina liftkort på webben!",
      "content": "\n    <p>Om du köper dina liftkort redan nu på webben så levereras de direkt i ert incheckningskuvert när ni kommer fram. På så sätt slipper ni börja semestern med att köa och kan snabbt ge er ut i backarna.</p>\n    <div class='clickable button-box'>\n        <a href='/boka/boka-online/#search/1001'>Köp liftkort   </a><i class='fa fa-arrow-right'></i>\n    </div>\n    <p>\n    </p>\n    "
    }
  }), _vm._v(" "), _vm._m(4)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Köper du våra periodkort får du alltid förmånliga priser."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("(Gäller tor-sön)"), _c('br')]), _vm._v("Vuxen: 1240:-"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('br')]), _vm._v("Ungdom: 960:-")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("(Gäller sön-tor)"), _c('br')]), _vm._v("Vuxen: 1520:-"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('br')]), _vm._v("Ungdom: 1225:-")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("(Gäller sön-sön eller tor-tor)"), _c('br')]), _vm._v("Vuxen: 1830:-"), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_c('br')]), _vm._v("Ungdom: 1420:-")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "following-info"
  }, [_c('h2', {
    attrs: {
      "id": "ladda-liftkort"
    }
  }, [_vm._v("Ladda liftkort")]), _vm._v(" "), _c('p', [_vm._v("Har ni redan befintliga keycard hemma? Ladda korten enkelt via ”Ladda liftkort” nedan. Liftkortet kan användas när som helst under säsongen och aktiveras när du använder det första gången.")]), _vm._v(" "), _c('p', [_vm._v("”Ladda liftkort” öppnar under hösten 2017, önskar ni ladda era keycard redan nu ring oss på 054-13 26 00 eller klicka er in på vår "), _c('a', {
    attrs: {
      "href": "/boka/boka-online/#search/1001"
    }
  }, [_vm._v("onlinebokning")]), _vm._v(".")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("1. "), _c('strong', [_vm._v("Ladda")]), _vm._v(" ditt keycard med önskat antal åkdagar.")]), _vm._v(" "), _c('p', [_vm._v("2. "), _c('strong', [_vm._v("Betala")]), _vm._v(" med kort eller via Swish.")]), _vm._v(" "), _c('p', [_vm._v("3. Nu är det bara att åka!")]), _vm._v(" "), _c('div', {
    staticClass: "clickable button-box center"
  }, [_c('a', {
    attrs: {
      "href": "https://hyra.branas.se/liftkort",
      "target": "_blank"
    }
  }, [_vm._v("Ladda liftkort   ")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "gratis-for-barn"
    }
  }, [_vm._v("Gratis för barn")]), _vm._v(" "), _c('p', [_vm._v("I Branäs är alla aktiviteter gratis för barn med liftkort. Är barnen under åtta år bjuder vi dessutom på liftkortet. Men glöm inte att barnen behöver ett eget keycard som kostar 55kr, läs mer om liftkort och keycard under boxen ”"), _c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("Så fungerar det med liftkort”")]), _c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v(" här ovanför.")]), _vm._v(" "), _c('br'), _c('strong', [_c('span', {
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v("För lite extra energipåfyllning ute i backen bjuder vi alla barn på varm ekologisk saft.")])])]), _vm._v(" "), _c('p', [_vm._v("Se mer om alla "), _c('a', {
    attrs: {
      "title": "För barn",
      "href": "/barn-bjornbusen-branas/"
    }
  }, [_vm._v("roliga aktiviteter som är gratis för barn")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "dela-liftkort"
    }
  }, [_vm._v("Dela liftkort med föräldrakortet")]), _vm._v(" "), _c('p', [_vm._v("Föräldrakortet är perfekt för föräldrar som reser till Branäs med små barn. Köp ett kort gemensamt och dela med din partner, en av er kan vara med barnen och en kan åka skidor.")]), _vm._v(" "), _c('div', {
    staticClass: "clickable button-box center"
  }, [_c('a', {
    attrs: {
      "href": "/boka/boka-online/#search/1001"
    }
  }, [_vm._v("Köp liftkort online   ")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "priser-for-liftkort"
    }
  }, [_vm._v("Priser och varianter")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "has-image"
  }, [_c('img', {
    staticClass: "alignnone size-medium wp-image-6860",
    attrs: {
      "src": "https://www.branas.se/wp-content/uploads/2016/12/skidskola-470x385.jpg",
      "alt": "skidskola",
      "width": "470",
      "height": "385"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("liftkort 2017-18")]), _vm._v(" "), _c('table', {
    staticClass: "responsive price-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Vuxen")]), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Ungdom")]), _vm._v(" "), _c('th', {
    staticClass: "number"
  }, [_vm._v("Föräldrakort")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("3 timmar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 360")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 285")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 dag")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 405")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 315")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 570")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 795")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 625")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1110")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1140")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 905")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1600")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Långhelg (to–sö)")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v("1240")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 960")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1740")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1455")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1140")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2040")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kortvecka (sö–to)")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1520")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1225")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2130")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1725")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1375")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2420")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vecka (6–8 dagar)")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1830")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1420")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2560")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("9 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1950")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1525")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2730")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2120")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1610")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2970")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("11 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2340")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1690")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2970")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("12 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2470")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1770")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3460")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("13 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2640")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1860")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3700")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("14 dagar")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 2760")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 1950")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3860")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Säsongskort")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 4595")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  }, [_vm._v(" 3495")]), _vm._v(" "), _c('td', {
    staticClass: "number"
  })])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h3', [_vm._v("Priskategorier")]), _vm._v(" "), _c('p', [_vm._v("Vuxen: 18 år-\n          "), _c('br'), _vm._v(" Ungdom: 7-17 år\n          "), _c('br'), _vm._v(" Barn: 0-6 år")]), _vm._v(" "), _c('p', [_vm._v("Keycard krävs för att kunna ladda på ett liftkort, det kostar 55 kr. Spara ditt Keycard till nästa säsong och ladda det på nytt.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "clickable button-box center"
  }, [_c('a', {
    attrs: {
      "href": "/boka/boka-online/#search/1001"
    }
  }, [_vm._v("Köp liftkort online   ")]), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])
}]}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'field field--' + _vm.type,
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label) + " "), (_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "keyup": [_vm.changeText, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeText($event)
      }],
      "blur": _vm.changeText
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'unit-listing' + (_vm.grouping ? ' unit-listing--grouping' : '')
  }, [_c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "collapsed",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = true
      }
    }
  }, [(_vm.grouping) ? _c('div', {
    staticClass: "grouping"
  }, [_vm._v(_vm._s(_vm.grouping))]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [(_vm.unitCount > 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa alla " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e(), _vm._v(" "), (_vm.unitCount === 1) ? _c('button', {
    staticClass: "expanding-button"
  }, [_vm._v("Visa " + _vm._s(_vm.unitCount) + " boendealternativ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [(_vm.unitCount > 1) ? _c('button', {
    staticClass: "button small white button-expand"
  }, [_vm._v("Visa alla " + _vm._s(_vm.unitCount) + " boendealternativ "), _c('icon', {
    attrs: {
      "name": "chevron-down-blue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.unitCount === 1) ? _c('button', {
    staticClass: "button small white button-expand"
  }, [_vm._v("Visa " + _vm._s(_vm.unitCount) + " boendealternativ "), _c('icon', {
    attrs: {
      "name": "chevron-down-blue"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "button-square"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down-white"
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.expanded) ? _c('div', {
    staticClass: "expanded"
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isManuallyExpanded = false
      }
    }
  }, [(_vm.grouping) ? _c('div', {
    staticClass: "grouping"
  }, [_vm._v(_vm._s(_vm.grouping))]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("Stäng")]) : _vm._e(), _vm._v(" "), (_vm.grouping) ? _c('div', {
    staticClass: "text"
  }, [_c('button', {
    staticClass: "button small white button-expand"
  }, [_vm._v("Stäng "), _c('icon', {
    attrs: {
      "name": "chevron-up-blue"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.grouping) ? _c('div', {
    staticClass: "button-square"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('span', {
    staticClass: "min-tablet"
  }, [_vm._v("Namn")]), _vm._v(" "), _c('span', {
    staticClass: "max-mobile"
  }, [_vm._v("Boende")])]), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('beds')
      }
    }
  }, [_vm._v("\n                Bäddar\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('beds')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('bedrooms')
      }
    }
  }, [_vm._v("\n                Sovrum\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('bedrooms')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('living_area')
      }
    }
  }, [_vm._v("\n                Boarea\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('living_area')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "sortable min-tablet",
    attrs: {
      "scope": "col"
    },
    on: {
      "click": function($event) {
        return _vm.sort('distance_to_pist')
      }
    }
  }, [_vm._v("\n                Pist\n                "), _c('TableSortIndicator', {
    attrs: {
      "current": _vm.isSorted('distance_to_pist')
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Typ")]), _vm._v(" "), _c('th', {
    staticClass: "no-padding min-tablet",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Jämför boende")]), _vm._v(" "), _c('th', {
    staticClass: "min-tablet",
    attrs: {
      "scope": "col"
    }
  })])]), _vm._v(" "), _c('transition-group', {
    staticClass: "animate-pool-list",
    attrs: {
      "name": "animate-pool-list",
      "tag": "tbody"
    }
  }, _vm._l((_vm.sortedUnits), function(unit, index) {
    return _c('tr', {
      key: unit.id,
      staticClass: "animate-pool-list-item",
      class: {
        odd: index % 2
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(unit)
        }
      }
    }, [_c('th', {
      staticClass: "wrap unit-title",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                " + _vm._s((unit.display_name || unit.description_title)) + "\n                "), (unit.subtitle) ? _c('i', [_vm._v(_vm._s(unit.subtitle))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.accomodationsFilter.date.endDate) ? _c('AccomodationUnitsLeft', {
      attrs: {
        "units-total": unit.unit_count,
        "units-left": _vm.getUnitsLeft(unit.id),
        "unit-type": unit.accomodationtype,
        "unit-title": (unit.display_name || unit.description_title),
        "unit-show": (unit.unit_lid <= 0)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$store.state.accomodationsFilter.date.endDate) ? _c('b', {
      staticClass: "max-mobile"
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.getPrice(unit.id))))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "facts max-mobile"
    }, [_c('div', [_c('b', [_vm._v("Sängar: ")]), _vm._v(" " + _vm._s(unit.beds)), (unit.extra_beds) ? _c('span', [_vm._v("+" + _vm._s(unit.extra_beds))]) : _vm._e()]), _vm._v(" "), (unit.living_area) ? _c('div', [_c('b', [_vm._v("Boarea: ")]), _vm._v(_vm._s(unit.living_area) + "m"), _c('sup', [_vm._v("2")])]) : _vm._e(), _vm._v(" "), (unit.distance_to_pist) ? _c('div', [_c('b', [_vm._v("Pist: ")]), _vm._v(" " + _vm._s(unit.distance_to_pist) + "m")]) : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Sovrum: ")]), _vm._v(" " + _vm._s(unit.bedrooms))]), _vm._v(" "), (unit.accomodationtype) ? _c('div', [_c('b', [_vm._v("Typ: ")]), _vm._v(" " + _vm._s(unit.accomodationtype.value))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.beds)), (unit.extra_beds) ? _c('span', [_vm._v("+" + _vm._s(unit.extra_beds))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.bedrooms))]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.living_area) + "m"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.distance_to_pist ? unit.distance_to_pist + 'm' : ''))]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_vm._v(_vm._s(unit.accomodationtype ? unit.accomodationtype.value : ''))]), _vm._v(" "), _c('td', {
      staticClass: "min-tablet"
    }, [_c('div', {
      class: {
        'favorite-icon-wrapper': true,
        'active': _vm.isFavorite(unit.id)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFavorite(unit.id)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('div', [(!_vm.$store.state.accomodationsFilter.date.endDate) ? _c('button', {
      staticClass: "outline-button price-info-bt",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openPriceList(unit)
        }
      }
    }, [_vm._v("Prislista")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.accomodationsFilter.date.endDate) ? _c('b', {
      staticClass: "the-price",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openPriceList(unit)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.getPrice(unit.id))))]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "outline-button price-info-bt",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInfo(unit)
        }
      }
    }, [_vm._v(_vm._s((_vm.$store.state.accomodationsFilter.date.endDate ? 'Info/boka' : 'Info')))]), _vm._v(" "), _c('div', {
      class: {
        'favorite-icon-wrapper': true,
        'active': _vm.isFavorite(unit.id),
          'max-mobile': true
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleFavorite(unit.id)
        }
      }
    })])])])
  }), 0)], 1)])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-page-component"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('Login', {
    on: {
      "login": _vm.login,
      "logout": _vm.logout
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('h2', [_vm._v("Behöver du mer än " + _vm._s(_vm.params.addon.plural[0] || 'en') + " " + _vm._s(_vm.params.addon.plural[1] || _vm.params.addon.arttext) + "?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.params.addon.plural[0] || 'En') + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.params.addon.plural[2] || _vm.params.addon.arttext))]), _vm._v(" finns alltid i boendet, här lägger du till ytterligare en eller flera "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.params.addon.plural[3] || _vm.params.addon.arttext))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Ja, lägg till")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Nej, det räcker med " + _vm._s(_vm.params.addon.plural[0] || 'en'))])])
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    class: {
      flex: true, 'use-login': _vm.SITE_CONFIG.use_login
    }
  }, [(_vm.SITE_CONFIG.use_login) ? _c('div', [(!_vm.loggedIn) ? _c('h2', [_vm._v(_vm._s(_vm.$t('user.login-title')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blocked info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('texts.texts-checkout_login_info'))
    }
  })]), _vm._v(" "), _c('Login')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [(_vm.SITE_CONFIG.use_login) ? _c('div', [(!_vm.loggedIn) ? _c('h2', [_vm._v(_vm._s(_vm.$t('user.login-go-on-anyway')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "choices"
  }, [_c('div', [(!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": _vm.yes,
      "value": 1,
      "valuebinder": _vm.gdpr_newsletter
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.gdpr_newsletter = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(!_vm.$store.state.isOnSite) ? _c('Checkbox', {
    attrs: {
      "label-position": "after",
      "label": _vm.no,
      "value": 0,
      "valuebinder": _vm.gdpr_newsletter
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.gdpr_newsletter = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n        Bokar du för ett företag, kontakta oss på "), _c('a', {
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "href": "tel:054132600"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(".\n      ")]), _vm._v(" "), (_vm.showCountrySelector) ? _c('div', {
    staticClass: "text",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_c('b', [_vm._v("Select your country")]), _vm._v(" "), _c('CountrySwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    class: {
      small: true, disabled: !_vm.valid
    },
    staticStyle: {
      "margin-top": "8px"
    },
    on: {
      "click": _vm.click
    }
  }, [_vm._v(_vm._s(_vm.$store.state.cart.pincode ? _vm.$t('user.send-order') : _vm.$t('user.to-payment')))]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "margin-top": "1.5rem",
      "margin-bottom": "1.5rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('texts.texts-gdpr_text'))
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.school')))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('skischool.pick-school-title')))]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('skischool.description')) + "\n          "), (_vm.SITE_CONFIG.site === 'vallasen') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.vallasen-gathering')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'ulricehamn') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.ulricehamn-gathering')))]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.skischool.map) ? _c('OutlineButton', {
    attrs: {
      "label": _vm.$t('skischool.show-gathering'),
      "icon": "map",
      "iconscale": 1.7
    },
    on: {
      "clicked": _vm.openLocationMap
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.schools), function(ref) {
    var name = ref.name;
    var list = ref.list;
    var bookable = ref.bookable;
    var image = ref.image;
    var type = ref.type;
    var show = ref.show;

    return (show) ? _c('div', {
      staticClass: "items-list"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.openBooking(type)
        }
      }
    }, [_c('div', {
      staticClass: "item-image",
      style: ('background-image:url(https://static.booking.branasgruppen.se/static/img/Skidskola/' + image + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "item-body"
    }, [_c('div', {}, [_c('h2', [_vm._v(_vm._s(name))]), _vm._v(" "), _c('ul', _vm._l((list), function(name) {
      return _c('li', [_vm._v(_vm._s(name))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "buttons min-tablet"
    }, [_c('div', {
      staticClass: "spacer"
    }), _vm._v(" "), (bookable) ? _c('button', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
      thing: ''
    })) + " " + _vm._s(name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "buttons max-mobile"
    }, [_c('div', {
      staticClass: "spacer"
    }), _vm._v(" "), (bookable) ? _c('button', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
      thing: ''
    })) + " " + _vm._s(name))]) : _vm._e()])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "country-switcher"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/css/flag-icon.min.css"
    }
  }), _vm._v(" "), (_vm.type === 'dropdown') ? _c('div', {
    staticClass: "component dropdown"
  }, [(_vm.showTitle) ? _c('div', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Select your country")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "max-width"
  }, [_c('Dropdown', {
    attrs: {
      "options": _vm.countries,
      "validated": _vm.selectedCountry && _vm.selectedCountry.value,
      "value": _vm.selectedCountry ? _vm.selectedCountry.value : null,
      "label": _vm.label,
      "with-background": true,
      "bold-label": true,
      "type": "country",
      "allow-empty": false,
      "combo": false
    },
    on: {
      "changed": _vm.changedCountry
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.localSetting && _vm.localSetting.db) ? _c('div', {
    class: 'setting ' + (this.loading ? ' setting--loading' : '') + (!_vm.localSetting.db.in_use ? ' setting--not-in-use' : '') + (!_vm.localSetting.can_edit ? ' setting--disabled' : '')
  }, [_c('div', {
    staticClass: "setting__title"
  }, [(_vm.localSetting.raw && _vm.localSetting.raw.season && _vm.localSetting.raw.season === 'summer') ? _c('img', {
    staticClass: "setting__icon",
    attrs: {
      "src": "https://www.branas.se/app/themes/branasgruppen-core/assets/images/weather/sun.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.localSetting.raw && _vm.localSetting.raw.season && _vm.localSetting.raw.season === 'winter') ? _c('img', {
    staticClass: "setting__icon",
    attrs: {
      "src": "https://www.branas.se/app/themes/branasgruppen-core/assets/images/icons/snowflake-icon.svg"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "setting__active"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSetting.db.in_use),
      expression: "localSetting.db.in_use"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localSetting.db.in_use) ? _vm._i(_vm.localSetting.db.in_use, null) > -1 : (_vm.localSetting.db.in_use)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.localSetting.db.in_use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localSetting.db, "in_use", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localSetting.db, "in_use", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localSetting.db, "in_use", $$c)
        }
      }, function($event) {
        return _vm.updateSetting(_vm.localSetting.db)
      }]
    }
  })]), _vm._v("\n\n      " + _vm._s(_vm.localSetting.title || _vm.localSetting.db.key) + "\n\n      "), _c('div', {
    staticClass: "setting__description"
  }, [(_vm.localSetting.db.description) ? _c('div', [_vm._v(_vm._s(_vm.localSetting.db.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "setting__details"
  }, [_c('div', [_vm._v("Tillåter HTML: "), _c('span', [_vm._v(_vm._s(_vm.localSetting.html ? '✓' : '⨉'))])]), _vm._v(" "), (_vm.localSetting.db.example) ? _c('div', [_vm._v("Exempel: "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localSetting.db.example)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.localSetting.db.default_value) ? _c('div', [_vm._v("Standard: " + _vm._s(_vm.localSetting.db.default_value))]) : _vm._e(), _vm._v(" "), (_vm.localSetting.db.updated_at) ? _c('div', [_vm._v("Senast ändrad: " + _vm._s(_vm._f("fromNow")(_vm.localSetting.db.updated_at)))]) : _vm._e()])]), _vm._v(" "), (_vm.localSetting.db.in_use) ? _c('div', {
    class: 'setting__editor setting__editor--' + (_vm.localSetting.db.key.replace('.', '-'))
  }, [(_vm.setting.editor === 'boolean') ? _c('div', [_c('div', {
    staticStyle: {
      "width": "105px"
    }
  }, [_c('SwitchButton', {
    attrs: {
      "store": _vm.localSetting.db.key,
      "iconscale": 2,
      "value": _vm.localSetting.db.value,
      "sync": false,
      "labels": {
        checked: 'Ja',
        unchecked: 'Nej'
      }
    },
    on: {
      "toggle": _vm.toggle
    }
  })], 1)]) : (_vm.setting.editor === 'date') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSetting.db.value),
      expression: "localSetting.db.value"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.localSetting.db.value)
    },
    on: {
      "change": function($event) {
        return _vm.updateSetting(_vm.localSetting.db)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localSetting.db, "value", $event.target.value)
      }
    }
  })]) : (_vm.setting.editor === 'tablelist') ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.75rem",
      "display": "flex",
      "gap": "0.5rem",
      "align-items": "center",
      "flex-wrap": "wrap"
    }
  }, [(!_vm.sortingEnabled && _vm.localSetting.db.value.length > 2 && _vm.localSetting.edit_settings.sortable) ? _c('button', {
    staticClass: "button small white border",
    staticStyle: {
      "padding": "4px 10px",
      "font-size": "0.85em"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.enableSorting($event)
      }
    }
  }, [_vm._v(_vm._s('Ändra ordning'))]) : _vm._e(), _vm._v(" "), (_vm.sortingEnabled) ? _c('button', {
    staticClass: "small green",
    staticStyle: {
      "padding": "4px 10px",
      "font-size": "0.85em"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveSorting($event)
      }
    }
  }, [_vm._v(_vm._s('Spara'))]) : _vm._e(), _vm._v(" "), (_vm.sortingEnabled) ? _c('button', {
    staticClass: "small border",
    staticStyle: {
      "padding": "4px 10px",
      "font-size": "0.85em"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelSorting($event)
      }
    }
  }, [_vm._v(_vm._s('Avbryt'))]) : _vm._e()]), _vm._v(" "), _c('table', {
    class: 'multi-value-table multi-value-table--' + _vm.localSetting.edit_settings.columns + (_vm.sortingEnabled ? ' sorting-active' : '')
  }, [_c('tbody', _vm._l((_vm.localSetting.db.value), function(row, rowIndex) {
    return _c('tr', {
      key: _vm.localSetting.db.key + '-' + rowIndex,
      class: (rowIndex === _vm.localSetting.db.value.length - 1 ? 'multi-value-table--last' : '') + (_vm.sortingEnabled ? ' draggable-row' : '') + (_vm.sortingEnabled && _vm.dragOverIndex === rowIndex ? ' drag-over' : ''),
      attrs: {
        "draggable": _vm.sortingEnabled && rowIndex < _vm.localSetting.db.value.length - 1
      },
      on: {
        "dragstart": function($event) {
          return _vm.dragStart($event, rowIndex)
        },
        "dragenter": function($event) {
          return _vm.dragEnter(rowIndex)
        },
        "dragend": _vm.dragEnd,
        "dragover": function($event) {
          $event.preventDefault();
        },
        "drop": function($event) {
          return _vm.dropRow($event, rowIndex)
        }
      }
    }, [_vm._l((row), function(col, colIndex) {
      return _c('td', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.localSetting.edit_settings.column_types || _vm.localSetting.edit_settings.column_types[colIndex] !== 'hidden'),
          expression: "!localSetting.edit_settings.column_types || localSetting.edit_settings.column_types[colIndex] !== 'hidden'"
        }],
        key: colIndex
      }, [(_vm.localSetting.edit_settings.column_types && _vm.localSetting.edit_settings.column_types[colIndex] === 'singleline') ? _c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localSetting.db.value[rowIndex][colIndex]),
          expression: "localSetting.db.value[rowIndex][colIndex]"
        }],
        attrs: {
          "type": "text",
          "disabled": _vm.sortingEnabled,
          "placeholder": _vm.localSetting.edit_settings.column_help && _vm.localSetting.edit_settings.column_help[colIndex] || 'Värde'
        },
        domProps: {
          "value": (_vm.localSetting.db.value[rowIndex][colIndex])
        },
        on: {
          "change": function($event) {
            return _vm.updateSetting(_vm.localSetting.db)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.localSetting.db.value[rowIndex], colIndex, $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.localSetting.edit_settings.column_types && _vm.localSetting.edit_settings.column_types[colIndex] === 'text') ? _c('div', [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.localSetting.db.value[rowIndex][colIndex]),
          expression: "localSetting.db.value[rowIndex][colIndex]"
        }],
        attrs: {
          "disabled": _vm.sortingEnabled,
          "placeholder": _vm.localSetting.edit_settings.column_help && _vm.localSetting.edit_settings.column_help[colIndex] || 'Värde'
        },
        domProps: {
          "value": (_vm.localSetting.db.value[rowIndex][colIndex])
        },
        on: {
          "change": function($event) {
            return _vm.updateSetting(_vm.localSetting.db)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.localSetting.db.value[rowIndex], colIndex, $event.target.value)
          }
        }
      })]) : _vm._e()])
    }), _vm._v(" "), _c('td', {
      staticClass: "multi-value-table--counter"
    }, [(_vm.sortingEnabled && rowIndex < _vm.localSetting.db.value.length - 1) ? _c('span', {
      staticStyle: {
        "font-size": "1.1em",
        "cursor": "grab"
      }
    }, [_vm._v("☰")]) : (rowIndex === _vm.localSetting.db.value.length - 1) ? _c('span', [_vm._v("Ny")]) : _vm._e()])], 2)
  }), 0)])]) : (_vm.setting.editor === 'translator') ? _c('div', [_c('table', {
    class: 'multi-value-table multi-value-table--' + _vm.SITE_CONFIG.languages.full.length
  }, [_c('tbody', [_c('tr', _vm._l((_vm.SITE_CONFIG.languages.full), function(lang, langIndex) {
    return _c('td', {
      key: langIndex
    }, [_c('label', [_c('img', {
      attrs: {
        "src": 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + lang.flag + '.svg',
        "width": "12"
      }
    }), _vm._v("\n                  " + _vm._s(lang.title) + "\n                ")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localSetting.db.value[lang.value]),
        expression: "localSetting.db.value[lang.value]"
      }],
      domProps: {
        "value": (_vm.localSetting.db.value[lang.value])
      },
      on: {
        "change": function($event) {
          return _vm.updateSetting(_vm.localSetting.db)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.localSetting.db.value, lang.value, $event.target.value)
        }
      }
    })])
  }), 0)])])]) : _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSetting.db.value),
      expression: "localSetting.db.value"
    }],
    attrs: {
      "placeholder": "Värde"
    },
    domProps: {
      "value": (_vm.localSetting.db.value)
    },
    on: {
      "change": function($event) {
        return _vm.updateSetting(_vm.localSetting.db)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localSetting.db, "value", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.setting.editor === 'image') ? _c('div', {
    staticClass: "image-preview"
  }, [_c('a', {
    attrs: {
      "href": _vm.localSetting.db.value,
      "target": "_blank"
    }
  }, [(_vm.localSetting.db.value) ? _c('img', {
    attrs: {
      "src": _vm.localSetting.db.value
    }
  }) : _vm._e()])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "427px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h1', [_vm._v("Dela dina sparade bokningar")]), _vm._v(" "), _c('p', [_vm._v("Klicka på "), _c('b', [_vm._v("kopiera länken")]), _vm._v(" nedan och klistra in länken och dela den. Du kan också spara den som en av dina favoriter i webbläsaren.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    ref: "copyText",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.link
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "medium",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Kopiera länken")])])])
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, 'waiting-for-filter': _vm.isAwaitingFilter
    }
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('transition-group', {
    staticClass: "animate-list",
    attrs: {
      "name": "animate-list",
      "tag": "ul",
      "aria-label": "Lista över boendeområden"
    }
  }, [(!_vm.SITE_CONFIG.modules_open.accomodation.open) ? _c('li', {
    key: -2,
    class: 'animate-list-item no-results result-count-0'
  }, [_c('b', [_vm._v("Stängt")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.accomodation.closed_message))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredPools), function(pool, index) {
    return _c('li', {
      key: pool.id,
      staticClass: "animate-list-item area-wrapper",
      attrs: {
        "aria-label": 'Område: ' + (pool.display_name || pool.name)
      }
    }, [(_vm.areaTitle(pool, index)) ? _c('div', {
      staticClass: "list-header"
    }, [_c('span', [_vm._v(_vm._s(_vm.areaTitle(pool, index)))])]) : _vm._e(), _vm._v(" "), _c('AccomodationsListPool', {
      attrs: {
        "pool": pool,
        "locations": _vm.locations
      }
    })], 1)
  }), _vm._v(" "), _c('li', {
    key: -1,
    class: 'animate-list-item no-results result-count-' + _vm.filteredPools.length,
    attrs: {
      "role": "note"
    }
  }, [_c('strong', [_vm._v("Dina filterval gav ingen träff")]), _vm._v(" "), _c('p', [_vm._v("Dina filterval gav ingen träff, ta bort filter eller återställ och börja om.")])])], 2) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "margin-top"
  }, [_c('li', [(_vm.$store.state.accomodationsFilter.freeSearch) ? _c('AccomodationsListUnitsList', {
    attrs: {
      "units": _vm.allUnits
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.click
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_c('icon', {
    attrs: {
      "name": "arrow",
      "scale": 1.2
    }
  }), _vm._v("\n    " + _vm._s(_vm.text ? _vm.text : _vm.$t('general.back')) + "\n  ")], 1)])
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "box center"
  }, [(!_vm.signedin && !_vm.wasSignedIn) ? _c('Loading', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "show": true,
      "static": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.signedin && !_vm.wasSignedIn) ? _c('img', {
    staticStyle: {
      "height": "40px",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.signedin && !_vm.error) ? _c('p', [_vm._v("Din bokning behandlas. Om du stannar kvar på den här sidan kommer du snart att automatiskt bli inloggad.")]) : _vm._e(), _vm._v(" "), (_vm.signedin && _vm.wasSignedIn) ? _c('p', [_vm._v("Du kan strax hitta din bokning under "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.myPage
    }
  }, [_vm._v("Mina sidor")]), _vm._v(".")]) : _vm._e(), _vm._v(" "), (_vm.signedin && !_vm.wasSignedIn) ? _c('p', [_vm._v("Du är nu inloggad och kan strax hitta din bokning under "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.myPage
    }
  }, [_vm._v("Mina sidor")]), _vm._v(".")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.signedin) ? _c('CheckUpdateAddress') : _vm._e(), _vm._v(" "), _c('div', {
    ref: "klarnaCode",
    staticStyle: {
      "overflow-x": "hidden"
    },
    attrs: {
      "id": "klarna-checkout-container"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normalWidth": "800px",
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('Vimeo', {
    attrs: {
      "url": _vm.params.url
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons"
  }, [(_vm.show('accomodation')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('accomodations', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/boenden')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "boende",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.accomodation')
  })) + "\n    "), (_vm.has('accomodations', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('accomodations', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && !_vm.add && !_vm.has('accomodations', true)) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra', false, true)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && !_vm.add && _vm.has('accomodations', true)) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra?quick=1&delivery=1', false, true)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && _vm.add) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra?quick=1')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skiletting') && _vm.add) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('rentals', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidhyra?quick=1&delivery=1')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "utrustning",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('skirental.book-with-delivery')) + "\n    "), (_vm.has('rentals', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('rentals', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('skipass') && !_vm.has('products')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('skipasses', true) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/liftkort?quick=1')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "liftkort",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.skipass')
  })) + "\n    "), (_vm.has('skipasses', true)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('skipasses', true)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('school')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('skischools', false) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/skidskola/oversikt?type=group')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "skidskola",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.school')
  })) + "\n    "), (_vm.has('skischools', false)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('bikeschool')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('bikeschool', false) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo('/cykelskola/oversikt?type=group')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "biking-white",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: 'Cykelskola'
  })) + "\n    "), (_vm.has('bikeschools', false)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.show('activities')) ? _c('button', {
    class: 'medium white border checkout' + (_vm.has('activities', false) ? ' checked' : ''),
    on: {
      "click": function($event) {
        return _vm.goTo(null, '/barn-bjornbusen-branas/')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "aktiviteter",
      "scale": 3.2
    }
  }), _vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.childrenactivities')
  })) + "\n    "), (_vm.has('activities', false)) ? _c('icon', {
    staticClass: "punktlista",
    attrs: {
      "name": "punklista-check",
      "scale": 1.5
    }
  }) : _vm._e(), _vm._v(" "), (_vm.has('activities', false)) ? _c('icon', {
    attrs: {
      "name": "green-dark-check",
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px",
      "show-close": !_vm.isCreating
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(!_vm.isCreating) ? _c('div', {
    staticClass: "last-checks"
  }, [_c('h2', [_vm._v("Kontaktuppgifter")]), _vm._v(" "), (!_vm.isAddonBooking) ? _c('div', [_c('p', [_vm._v("Komplettera eller säkerställ att följande uppgifter stämmer.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("OBS!")]), _vm._v(" Det är dessa uppgifter vi använder för att nå dig. Det är viktigt att informationen är korrekt.")])]) : _vm._e(), _vm._v(" "), (_vm.isAddonBooking) ? _c('div', [_c('p', [_vm._v("Följande kontaktuppgifter är registrerade på din bokning, kontrollera att de stämmer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("Om du behöver uppdatera uppgifterna kan du göra det direkt under "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.goToMyPages
    }
  }, [_vm._v("Mina sidor")]), _vm._v(" eller genom att kontakta gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading,
      "static": true
    }
  }), _vm._v(" "), (!_vm.loading && !_vm.isAddonBooking) ? _c('div', [_c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Ditt telefonnummer",
      "value": _vm.phone
    },
    on: {
      "change": _vm.updatePhone
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v(_vm._s(_vm.$t('general.obs-format', {
    format: '+46701234567'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "name-input"
  }, [_c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Ditt förnamn",
      "value": _vm.name
    },
    on: {
      "change": _vm.updateFirstName
    }
  }), _vm._v(" "), _c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Efternamn",
      "value": _vm.lastName
    },
    on: {
      "change": _vm.updateLastName
    }
  })], 1), _vm._v(" "), _c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Din e-postadress",
      "value": _vm.email
    },
    on: {
      "change": _vm.updateEmail
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Ditt land "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('CountrySwitcherNormal', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    }
  }), _vm._v(" "), (!_vm.smsSent && _vm.errors.length) ? _c('div', {
    staticClass: "error-message"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.enableQuickLogin) ? _c('div', {
    staticClass: "info-box--blue"
  }, [_c('p', [_vm._v(_vm._s(_vm.enableQuickLogin))]), _vm._v(" "), (this.loggedIn) ? _c('p', [_vm._v("Notera att du kommer att bli utloggad från det konto du nu är inloggad på.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.errors2.length) ? _c('div', {
    staticClass: "error-message"
  }, _vm._l((_vm.errors2), function(error) {
    return _c('p', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.smsSent) ? _c('div', [(_vm.enableQuickLogin) ? _c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.sendCodeSms
    }
  }, [_vm._v("Skicka SMS-kod")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), (_vm.enableQuickLogin) ? _c('button', {
    staticClass: "small white border",
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkDetails
    }
  }, [_vm._v("Fortsätt")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.smsSent) ? _c('div', [_c('LabelInput', {
    attrs: {
      "required": true,
      "label": "Ange koden som du fått via SMS",
      "value": _vm.smsCode
    },
    on: {
      "change": _vm.updateSmsCode
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkCode
    }
  }, [_vm._v("Verifiera")])], 1) : _vm._e(), _vm._v(" "), (!_vm.enableQuickLogin) ? _c('div', [_c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkDetails
    }
  }, [_vm._v("Fortsätt")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.isAddonBooking) ? _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('b', [_vm._v("Ditt telefonnummer:")]), _c('br'), _vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ditt namn:")]), _c('br'), _vm._v(_vm._s(_vm.name) + " " + _vm._s(_vm.lastName))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Din e-postadress:")]), _c('br'), _vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Ditt land:")]), _c('br'), _vm._v(_vm._s(_vm.country))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": _vm.checkDetails
    }
  }, [_vm._v("Fortsätt")]), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.localCloseModal
    }
  }, [_vm._v("Gå tillbaka")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isCreating) ? _c('CreatingOrder', {
    attrs: {
      "show-texts": true,
      "do-redirect": _vm.doRedirect
    },
    on: {
      "callback": _vm.onSyncCallback
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCreating) ? _c('button', {
    staticClass: "small white border",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Avbryt")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'the-banner': true, 'auto-pay': _vm.$route.query.pay
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Timeline', {
    attrs: {
      "show-time-line": _vm.cart.accomodations.filter(function(a) {
        return a.confirmed;
      }).length,
      "steps": _vm.timelineSteps
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-color-faded"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.$store.state.cart.addToOrder || !_vm.$store.state.cart.addToOrder.accomodationRow) ? _c('div', {
    staticClass: "optional-booking min-tablet"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.make-it-easier')))]), _vm._v(" "), _c('CompletedBookings', {
    staticStyle: {
      "margin-top": "0"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('general.your-cart')))]), _vm._v(" "), _c('Cart', {
    attrs: {
      "show-from-start": true
    }
  }), _vm._v(" "), (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number) ? _c('div', {
    staticClass: "appending-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('general.when-you-click', {
    number: ''
  })) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'my booking',
        params: {
          bookingNumber: _vm.$store.state.cart.addToOrder.numeric
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.cart.addToOrder.number))]), (_vm.$store.state.cart.addToOrder.dateStart) ? _c('span', [_vm._v(" (" + _vm._s(_vm._f("dateRange")([_vm.$store.state.cart.addToOrder.dateStart, _vm.$store.state.cart.addToOrder.dateEnd])) + ")")]) : _vm._e(), _vm._v(".")], 1), _vm._v(" "), (_vm.$store.state.cart.addToOrder.accomodationRow) ? _c('p', [_vm._v("Bokningen kommer att kopplas till boendet "), _c('b', [_vm._v(_vm._s(_vm.$store.state.cart.addToOrder.accomodationName))]), _vm._v(" (" + _vm._s(_vm._f("dateRange")([_vm.$store.state.cart.addToOrder.accomodationDateArrival, _vm.$store.state.cart.addToOrder.accomodationDateDeparture])) + ").")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.new-order', {
    clickhere: ''
  }))), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.removeOrderLink()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.clickhere')))]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.cart.addToOrder || !_vm.$store.state.cart.addToOrder.accomodationRow) ? _c('div', {
    staticClass: "optional-booking max-mobile",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.make-it-easier')))]), _vm._v(" "), _c('CompletedBookings', {
    staticStyle: {
      "margin-top": "0"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-color-faded related-orders"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.openRelatedOrders.length) ? _c('div', {
    staticClass: "appending-info",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('p', [_vm._v("Det finns en annan tilläggsbokning som inte har betalats. Avbryt den innan du går vidare.")]), _vm._v(" "), _c('table', {
    staticClass: "order-table"
  }, _vm._l((_vm.openRelatedOrders), function(order, index) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm._f("date")(order.created_at, 'short-with-time')) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("currency")(order.sum)) + "\n            ")]), _vm._v(" "), _c('td', [_c('a', {
      class: 'button small' + (order.vue_working_status ? ' disabled' : ''),
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.cancelOrder(index)
        }
      }
    }, [_vm._v("Avbryt")])]), _vm._v(" "), _c('td', [(order.vue_working_status) ? _c('span', [_vm._v("Avbryter...")]) : _vm._e()])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), (_vm.showTryPayment) ? _c('div', {
    staticClass: "bg-color-faded"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bottom-buttons-wrapper"
  }, [_c('div', [_c('CheckoutCodeModal')], 1), _vm._v(" "), _c('div', {
    class: {
      'disabled': !_vm.enableTryPayment
    },
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.tryPayment()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.pay')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.5
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.wishes.pick')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "1.5rem",
      "margin-top": "1rem"
    }
  }, [_vm._v("Du kan välja flera. Om du inte har några särskilda önskemål, välj det nedan.")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex"
  }, _vm._l((_vm.getWishes()), function(wish) {
    return _c('div', {
      key: wish.key
    }, [_c('Checkbox', {
      attrs: {
        "label": wish.label,
        "label-position": "right",
        "value": true,
        "valuebinder": _vm.wishes[wish.key],
        "type": "checkbox",
        "special-class": "wishes"
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(_vm.wishes, wish.key, $event)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "multi"
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.other')))]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "width": "100%",
      "max-width": "500px"
    }
  }, [_c('div', {
    staticClass: "full"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.wishes.other-help')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wishes.freeText),
      expression: "wishes.freeText"
    }],
    staticClass: "text-input",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.wishes.freeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wishes, "freeText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.save')))])])])
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [_c('h2', [_vm._v("RUT-avdrag")]), _vm._v(" "), _c('p', [_vm._v("Genom att ange ditt personnummer nedan kan du få RUT-avdrag för denna tjänst.")]), _vm._v(" "), _c('p', [_vm._v("Ange 12 siffror i formatet ÅÅÅÅMMDD-XXXX. "), (_vm.isSwedish) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v("För att kunna ansöka om RUT krävs att du betalar skatt i Sverige.")]) : _vm._e()]), _vm._v(" "), (!_vm.isSwedish) ? _c('p', {
    staticClass: "bold"
  }, [_vm._v("Det verkar som att du inte bokar från Sverige - för att kunna ansöka om RUT krävs att du betalar skatt i Sverige.")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("För att kunna nyttja RUT-avdrag krävs att "), _c('b', [_vm._v("städningen utförs samma år som betalning genomförs")]), _vm._v(". I annat fall finns risk för avslag hos Skatteverket. Det går bra att lägga till i efterhand via Mina sidor eller genom att ringa oss på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054‑13 26 00")]), _vm._v(".")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssn),
      expression: "ssn"
    }],
    class: {
      error: _vm.error
    },
    attrs: {
      "placeholder": "ÅÅÅÅMMDD-XXXX",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ssn)
    },
    on: {
      "keydown": function($event) {
        _vm.error = ''
      },
      "keyup": _vm.addDash,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssn = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.error) ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error-text"
  }, [_c('br'), _vm._v(_vm._s(_vm.error)), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Välj rutavdrag")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Jag vill inte ha rutavdrag")])])
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.language_switcher === true || (_vm.$store.state.isOnSite && _vm.SITE_CONFIG.language_switcher === 'onsite')) ? _c('div', {
    staticClass: "language-switcher"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/css/flag-icon.min.css"
    }
  }), _vm._v(" "), (_vm.type === 'row') ? _c('div', {
    staticClass: "component row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "languages"
  }, _vm._l((_vm.languages), function(lang) {
    return _c('div', {
      class: {
        language: true, active: (lang.value === _vm.selectedLanguage.value || !_vm.pickedLanguage)
      },
      on: {
        "click": function($event) {
          return _vm.setLanguage(lang)
        }
      }
    }, [_c('div', {
      staticClass: "flag",
      style: ('background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + lang.flag + '.svg)')
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.type === 'dropdown') ? _c('div', {
    staticClass: "component dropdown"
  }, [(_vm.showTitle) ? _c('div', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Select your language")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "max-width"
  }, [_c('Dropdown', {
    attrs: {
      "options": _vm.languages,
      "validated": _vm.selectedLanguage && _vm.selectedLanguage.value,
      "value": _vm.selectedLanguage.value,
      "label": _vm.label,
      "with-background": true,
      "bold-label": true,
      "type": "language",
      "allow-empty": false
    },
    on: {
      "changed": _vm.changedLanguage
    }
  })], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Välj språk")]), _vm._v(" "), _c('span', [_vm._v("Select language")])])
}]}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [(!_vm.$store.state.accomodationsFilter.freeSearch) ? _c('div', {
    staticClass: "body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.expand()
      }
    }
  }, [_c('div', {
    staticClass: "image default-image",
    style: ((_vm.pool && (_vm.pool.image_thumbnail || _vm.pool.image)) ? 'background-image:url(' + (_vm.pool.image_thumbnail || _vm.pool.image) + ')' : 'background-size: cover;')
  }, [(!_vm.pool.hide_map) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": _vm.pool.units[0].facility ? 'Öppna karta över ' + _vm.locations[_vm.pool.units[0].facility.id].title : 'Öppna karta över området'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMap()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": "2.1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.pool.video) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Starta film som visar ' + (_vm.pool.display_name || _vm.pool.name)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMovie()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "film",
      "scale": "2.1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.show_site && _vm.pool.units[0].facility && _vm.locations[_vm.pool.units[0].facility.id]) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Läs mer information om ' + (_vm.locations[_vm.pool.units[0].facility.id].title)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openLocationInfo()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": _vm.locations[_vm.pool.units[0].facility.id].slug,
      "scale": "2.1"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details-start"
  }, [_c('p', {
    staticClass: "area-title",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Område:")]), _vm._v(" "), _c('h2', [_vm._v("\n          " + _vm._s((_vm.pool.display_name || _vm.pool.name)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v(_vm._s(_vm.pool.short_description))])]), _vm._v(" "), (_vm.bulletPoints.length) ? _c('ul', {
    staticClass: "features",
    attrs: {
      "aria-label": (_vm.pool.display_name || _vm.pool.name) + ' i korthet'
    }
  }, _vm._l((_vm.bulletPoints), function(point) {
    return _c('li', [_c('span', [_vm._v(_vm._s(point))])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-end"
  }, [(!_vm.pool.hide_map) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": _vm.pool.units[0].facility ? 'Öppna karta över ' + _vm.locations[_vm.pool.units[0].facility.id].title : 'Öppna karta över området'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMap()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Karta\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.pool.video) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Starta film som visar ' + (_vm.pool.display_name || _vm.pool.name)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openMovie()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "film",
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Film\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.pool.units[0].facility && _vm.locations[_vm.pool.units[0].facility.id]) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": _vm.pool.units[0].facility ? 'Läs mer information om ' + (_vm.locations[_vm.pool.units[0].facility.id].title) : 'Läs mer information om området'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openLocationInfo()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": _vm.locations[_vm.pool.units[0].facility.id].slug,
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.locations[_vm.pool.units[0].facility.id].title) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.pool.map_link) ? _c('button', {
    staticClass: "link",
    attrs: {
      "aria-label": 'Öppna karta över ' + (_vm.pool.display_name || _vm.pool.name)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openAreaMap()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pdf-blue",
      "scale": "2.1"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Områdeskarta\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.lowestUnitPrice > 0) ? _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Pris från")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(_vm.lowestUnitPrice)) + "\n          ")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.display_as_group_pools[_vm.pool.id]) ? _c('AccomodationsListUnitsGroup', {
    ref: "unitList",
    attrs: {
      "pool": _vm.pool
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.accomodations.display_as_group_pools[_vm.pool.id]) ? _c('AccomodationsListUnitsList', {
    ref: "unitList",
    attrs: {
      "units": _vm.pool.units
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-page-component admin-outer-wrapper"
  }, [_c('div', {
    staticClass: "admin-nav"
  }, [_c('ul', [(_vm.can('settings')) ? _c('li', {
    class: _vm.$route.name === 'admin-settings' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-settings'
      }
    }
  }, [_vm._v("Inställningar")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('accomodations')) ? _c('li', {
    class: _vm.$route.name === 'admin-accomodations' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-accomodations'
      }
    }
  }, [_vm._v("Boende")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('commands')) ? _c('li', {
    class: _vm.$route.name === 'admin-command-sync' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-command-sync'
      }
    }
  }, [_vm._v("Synka")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('texts')) ? _c('li', {
    class: _vm.$route.name === 'admin-texts' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-texts'
      }
    }
  }, [_vm._v("Texter")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('orderlist')) ? _c('li', {
    class: _vm.$route.name === 'admin-stats-orders' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-stats-orders'
      }
    }
  }, [_vm._v("Ordrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('emailreport')) ? _c('li', {
    class: _vm.$route.name === 'admin-email-report' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-email-report'
      }
    }
  }, [_vm._v("E-postrapport")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('notifications')) ? _c('li', {
    class: _vm.$route.name === 'admin-notifications' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-notifications'
      }
    }
  }, [_vm._v("Logg")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('gdpr')) ? _c('li', {
    staticClass: "disabled",
    class: _vm.$route.name === 'admin-gdpr-cleanup' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-gdpr-cleanup'
      }
    }
  }, [_vm._v("GDPR")])], 1) : _vm._e(), _vm._v(" "), (_vm.can('translations')) ? _c('li', {
    staticClass: "disabled",
    class: _vm.$route.name === 'admin-translations' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'admin-translations'
      }
    }
  }, [_vm._v("Översättning")])], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Gå till logga ut")])], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "960px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      }
    }
  }, [_c('div', {
    class: 'map-background map-background--' + _vm.SITE_CONFIG.site + ' type--' + _vm.params.type,
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, disabled: _vm.loading, 'component--box': true
    }
  }, [_c('div', {
    staticClass: "tab-buttons"
  }, [_c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'details')
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'details';
        _vm.errorMessage = ''
      }
    }
  }, [_c('span', [_vm._v("Uppgifter")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'skiers')
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'skiers';
        _vm.errorMessage = ''
      }
    }
  }, [_c('span', [_vm._v("Åkare")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'passes')
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'passes';
        _vm.errorMessage = ''
      }
    }
  }, [_c('span', [_vm._v("Liftkort")])])]), _vm._v(" "), _c('div', {
    staticClass: "component__inner"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (_vm.activeTab === 'details') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('h2', {
    staticClass: "wide"
  }, [_vm._v("Mina uppgifter")]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Förnamn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name1),
      expression: "user.name1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Förnamn"
    },
    domProps: {
      "value": (_vm.user.name1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Efternamn")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name2),
      expression: "user.name2"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Efternamn"
    },
    domProps: {
      "value": (_vm.user.name2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("Gatuadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr1),
      expression: "user.addr1"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Gatuadress"
    },
    domProps: {
      "value": (_vm.user.addr1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "addr1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Postnummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr3),
      expression: "user.addr3"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Postnummer"
    },
    domProps: {
      "value": (_vm.user.addr3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "addr3", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('label', [_vm._v("Stad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr4),
      expression: "user.addr4"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Stad"
    },
    domProps: {
      "value": (_vm.user.addr4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "addr4", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("Land")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.addr5),
      expression: "user.addr5"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "addr5", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.filteredCountries), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.title))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("Telefonnummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.mobile_phone),
      expression: "user.mobile_phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Telefonnummer"
    },
    domProps: {
      "value": (_vm.user.mobile_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mobile_phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item wide"
  }, [_c('label', [_vm._v("E-postadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "E-postadress"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'skiers') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('h2', {
    staticClass: "wide"
  }, [_vm._v("Sparade åkare")]), _vm._v(" "), _c('div', {
    staticClass: "people wide"
  }, [_vm._l((_vm.skiers), function(skier, index) {
    return _c('div', {
      key: index,
      staticClass: "person"
    }, [(skier.deleted_at) ? _c('Note', {
      attrs: {
        "color": "warning",
        "icon": "trash",
        "align": "left"
      }
    }, [_c('p', [_vm._v(_vm._s(skier.first_name || 'Åkaren') + " tas bort när du sparar")])]) : _vm._e(), _vm._v(" "), (!skier.deleted_at) ? _c('div', [_c('div', {
      staticClass: "name-wrapper"
    }, [_c('div', {
      staticClass: "firstname detail-item"
    }, [_c('label', [_vm._v("Förnamn")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.first_name),
        expression: "skier.first_name"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Förnamn"
      },
      domProps: {
        "value": (skier.first_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "first_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "delete detail-item"
    }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
      staticClass: "button--rounded--outlined--red",
      on: {
        "click": function($event) {
          return _vm.deleteSkier(skier, index)
        }
      }
    }, [_vm._v("Ta bort")])])]), _vm._v(" "), _c('div', {
      staticClass: "multi-details"
    }, [_c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Ålder")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.age),
        expression: "skier.age"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Ålder"
      },
      domProps: {
        "value": (skier.age)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "age", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Längd")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_height),
        expression: "skier.measurement_height"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Längd"
      },
      domProps: {
        "value": (skier.measurement_height)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_height", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Vikt")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_weight),
        expression: "skier.measurement_weight"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Vikt"
      },
      domProps: {
        "value": (skier.measurement_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_weight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Skostorlek")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_shoe_size),
        expression: "skier.measurement_shoe_size"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Skostorlek"
      },
      domProps: {
        "value": (skier.measurement_shoe_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_shoe_size", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-item"
    }, [_c('label', [_vm._v("Klädstorlek")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skier.measurement_clothsize),
        expression: "skier.measurement_clothsize"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Klädstorlek"
      },
      domProps: {
        "value": (skier.measurement_clothsize)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skier, "measurement_clothsize", $event.target.value)
        }
      }
    })])])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "button--rounded button--green",
    on: {
      "click": function($event) {
        return _vm.createNewSkier()
      }
    }
  }, [_vm._v("Lägg till åkare")])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'passes') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('h2', {
    staticClass: "wide"
  }, [_vm._v("Sparade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "people wide"
  }, [_vm._l((_vm.skipasses), function(skipass, index) {
    return _c('div', {
      key: index,
      staticClass: "person"
    }, [(skipass.deleted_at) ? _c('Note', {
      attrs: {
        "color": "warning",
        "icon": "trash",
        "align": "left"
      }
    }, [_c('p', [_vm._v(_vm._s(skipass.name || 'Liftkortet') + " tas bort när du sparar")])]) : _vm._e(), _vm._v(" "), (!skipass.deleted_at) ? _c('div', [_c('div', {
      staticClass: "name-wrapper"
    }, [_c('div', {
      staticClass: "firstname detail-item"
    }, [_c('label', [_vm._v("Namn på liftkort")]), _vm._v(" "), _c('p', [_vm._v("(om du vill komma ihåg vems det är)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.name),
        expression: "skipass.name"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Namn på liftkort"
      },
      domProps: {
        "value": (skipass.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "delete detail-item"
    }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
      staticClass: "button--rounded--outlined--red",
      on: {
        "click": function($event) {
          return _vm.deleteSkipass(skipass, index)
        }
      }
    }, [_vm._v("Ta bort")])])]), _vm._v(" "), _c('div', {
      staticClass: "detail-item wide"
    }, [_c('label', [_vm._v("Nummer")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (skipass.number),
        expression: "skipass.number"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Nummer"
      },
      domProps: {
        "value": (skipass.number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(skipass, "number", $event.target.value)
        }
      }
    })])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "button--rounded",
    on: {
      "click": function($event) {
        return _vm.createNewSkipass()
      }
    }
  }, [_vm._v("Lägg till liftkort")])])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "button--rounded",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Spara")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_vm._l((_vm.people), function(person, index) {
    return _c('div', [_c('div', {
      staticClass: "blue-bar"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(person.name) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "package"
    }, [(person.type === 'package') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ", paket")]) : _vm._e(), _vm._v(" "), (person.type === 'single') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ":")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.ages[person.age]) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "level"
    }, [(person.searchPackage === 'beginner') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Nybörjare")]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'intermediate') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Medelgod")]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'advanced') ? _c('span', [_c('b', [_vm._v("Nivå:")]), _vm._v(" Avancerad")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "date right"
    }, [_c('span', [_c('b', [_vm._v("Datum:")]), _vm._v(" " + _vm._s(_vm.dateRange(person)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "inner-width"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Längd (cm)")]), _vm._v("\n          " + _vm._s(person.lengthCm) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Vikt (kg)")]), _vm._v("\n          " + _vm._s(person.weight) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Skostorlek")]), _vm._v("\n          " + _vm._s(person.shoeSize) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, _vm._l((person.wishes), function(wish, key) {
      return (wish) ? _c('div', [_vm._v(_vm._s(_vm.wishesLabels[key]))]) : _vm._e()
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "addon--inner-width"
    }, [_c('div', {
      staticClass: "addons inner-width"
    }, [_c('div', {
      staticClass: "products"
    }, [_c('table', [_vm._l((person.products), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product && product.price) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _vm._l((person.addons), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product && product.price) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _c('tr', {
      staticClass: "total"
    }, [_c('td', [_vm._v("\n                Pris åkare " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((
      person.products.reduce(function(a, product) {
        return a + product.price
      }, 0) +
      person.addons.reduce(function(a, product) {
        return a + product.price
      }, 0)
    ))))])])])], 2)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "sum-bar"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n      Totalt:\n      "), _c('b', [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.sum)) + "\n      ")])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Login', {
    ref: "login",
    on: {
      "login": _vm.login
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "460px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "addon-image default-image",
    style: (_vm.params.addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + _vm.params.addon.image + ');' : 'background-size: cover;')
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.params.addon.arttext))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.params.addon.desc2))]), _vm._v(" "), (_vm.params.addon.included) ? _c('p', [_vm._v("1 st "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.params.addon.arttext))]), _vm._v(" ingår alltid i ditt boende. Antalet du väljer är utöver det som redan ingår.")]) : _vm._e(), _vm._v(" "), (_vm.params.addon.auto !== 'T') ? _c('div', {
    staticClass: "buttons"
  }, [(!_vm.params.addon.added && _vm.params.addon.max_qty > 1) ? _c('span', {
    staticClass: "quantity"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.addon.qtySelected),
      expression: "params.addon.qtySelected"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.params.addon.qtySelected)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params.addon, "qtySelected", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("st")])]) : _vm._e(), _vm._v(" "), (_vm.params.addon.added) ? _c('button', {
    class: 'small ' + (_vm.params.addon.added ? 'green' : '') + '',
    on: {
      "click": function($event) {
        return _vm.removeArticle(_vm.params.addon)
      }
    }
  }, [_vm._v(_vm._s(_vm.params.addon.qtySelected) + "st valda")]) : _vm._e(), _vm._v(" "), (_vm.params.addon.added) ? _c('button', {
    class: 'small trash border',
    on: {
      "click": function($event) {
        return _vm.removeArticle(_vm.params.addon)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.3
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.params.addon.added && !_vm.params.addon.rut) ? _c('button', {
    class: {
      small: true, disabled: !_vm.params.addon.qtySelected
    },
    on: {
      "click": function($event) {
        return _vm.chooseArticle(_vm.params.addon)
      }
    }
  }, [_vm._v("Välj")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.params.addon.auto === 'T') ? _c('p', [_vm._v("\n    " + _vm._s(_vm.params.addon.autoTextLong || 'Detta tillval är obligatoriskt för detta boende.') + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "component"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center component"
  }, [_c('h1', [_vm._v("Tack för din betalning!")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Ditt bokningsnummer:")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.reservationNumber))])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Betalmetod:")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.paymentMethod))])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Summa:")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.paymentAmount)))])])])
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.reMount
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.people[_vm.currentIndex]) ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.enter-details', {
    name: ''
  })) + " " + _vm._s(_vm.people[_vm.currentIndex].name))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.people), function(person, index) {
    return (person.guideCompleted) ? _c('div', {
      class: {
        person: true, opened: (_vm.currentIndex === index), completed: (person.guideFullyCompleted && _vm.currentIndex !== index)
      }
    }, [_c('div', {
      staticClass: "blue-bar",
      on: {
        "click": function($event) {
          return _vm.setActive(_vm.currentIndex !== index ? index : -1)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(person.name) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "package max-tablet"
    }, [(person.type === 'package') ? _c('b', [_vm._v(_vm._s(_vm.$t('skirental.package', {
      package: ''
    })) + " " + _vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ":")]) : _vm._e(), _vm._v(" "), (person.type === 'single') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ":")]) : _vm._e(), _vm._v(" "), (person.type !== 'single' && person.type !== 'package') ? _c('b', [(person.onlySkipass) ? _c('b', [_vm._v(_vm._s(_vm.$t('general.skipass')) + ":")]) : _vm._e()]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.ages[person.age]) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "level max-tablet"
    }, [(person.searchPackage === 'beginner') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.beginner')))]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'intermediate') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.average')))]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'advanced') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.level.advanced')))]) : _vm._e()]), _vm._v(" "), (!_vm.hasClosedDaysInRange(person)) ? _c('span', {
      staticClass: "date max-tablet"
    }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.date')) + ":")]), _vm._v(" " + _vm._s(_vm._f("dateRange")(_vm.dateRange(person), 'long')))])]) : _vm._e(), _vm._v(" "), (_vm.hasClosedDaysInRange(person)) ? _c('span', {
      staticClass: "date max-tablet"
    }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.date')) + ":")]), _vm._v(" " + _vm._s(person.days) + " " + _vm._s(_vm.$t('general.days')))])]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === index) ? _c('span', {
      staticClass: "change max-tablet"
    }, [_c('button', {
      staticClass: "small white tight",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(index)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.currentIndex !== index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.show')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-green",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.close')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-up-white",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-up-white",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "animate-filter"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.currentIndex === index)),
        expression: "(currentIndex === index)"
      }]
    }, [_c('div', {
      staticClass: "inner-width"
    }, [_c('div', {
      staticClass: "flex sizes-list"
    }, [(_vm.required(index, 'lengthCm')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.measurements.length-your')) + " (" + _vm._s(_vm.$t('skirental.measurements.centimeter-short')) + ")"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": true,
        "options": _vm.lengthOptionsCalculated(person),
        "valuebinder": person.lengthCm,
        "label": _vm.$t('skirental.example-centimeter'),
        "validated": person.lengthCm && !_vm.showError(index, 'lengthCm', true),
        "error": _vm.showError(index, 'lengthCm', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "lengthCm", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'lengthCm')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'weight')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.measurements.weight')) + " (" + _vm._s(_vm.$t('skirental.measurements.kilogram-short')) + ")"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": true,
        "options": _vm.lengthOptions[person.age].weightOptions,
        "valuebinder": person.weight,
        "label": _vm.$t('skirental.example-kilogram'),
        "validated": person.weight && !_vm.showError(index, 'weight', true),
        "error": _vm.showError(index, 'weight', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "weight", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'weight')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'shoeSize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.measurements.shoesize'))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v(" "), _c('button', {
      staticClass: "small white border tight",
      on: {
        "click": function($event) {
          return _vm.openModal(['SkiRentalFoot', {
            index: index
          }])
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 1
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.info-short')))], 1)]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.shoesizeOptionsCalculated(person),
        "valuebinder": person.shoeSize,
        "label": _vm.$t('general.pick'),
        "validated": person.shoeSize && !_vm.showError(index, 'shoeSize', true),
        "error": _vm.showError(index, 'shoeSize', true),
        "show-label-subtitle": true
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "shoeSize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'shoeSize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'jacketsize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Jackstorlek (unisex)"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.productSizes(person, '_jacketsizes'),
        "valuebinder": person.jacketsize,
        "label": 'Jackstorlek',
        "validated": person.jacketsize && !_vm.showError(index, 'jacketsize', true),
        "error": _vm.showError(index, 'jacketsize', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "jacketsize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'jacketsize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'pantsize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Byxstorlek (unisex)"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.productSizes(person, '_pantsizes'),
        "valuebinder": person.pantsize,
        "label": 'Byxstorlek',
        "validated": person.pantsize && !_vm.showError(index, 'pantsize', true),
        "error": _vm.showError(index, 'pantsize', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "pantsize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'pantsize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'clothsize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Klädstorlek"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.lengthOptions[person.age].clothSizeOptions,
        "valuebinder": person.clothsize,
        "label": 'Klädstorlek',
        "validated": person.clothsize && !_vm.showError(index, 'clothsize', true),
        "error": _vm.showError(index, 'clothsize', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "clothsize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'clothsize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget' || _vm.SITE_CONFIG.site === 'storstenshojden') ? _c('div', [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.title')))]), _vm._v(" "), _vm._l((person.wishes), function(wish, key) {
      return (wish && key !== 'hasWishes') ? _c('FilterListItem', {
        key: key,
        attrs: {
          "label": _vm.wishesLabels[key],
          "value": key
        },
        on: {
          "click": function($event) {
            return _vm.removeWish(index, key)
          }
        }
      }) : _vm._e()
    }), _vm._v(" "), (!person.wishes.hasWishes) ? _c('button', {
      staticClass: "border-bottom underlined small-text wishes-bt",
      on: {
        "click": _vm.openWishes
      }
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.add')))]) : _vm._e(), _vm._v(" "), (person.wishes.hasWishes) ? _c('button', {
      staticClass: "border-bottom underlined small-text wishes-bt",
      on: {
        "click": _vm.openWishes
      }
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.change')))]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showError(index, 'lengthCm', true)),
        expression: "showError(index, 'lengthCm', true)"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.showError(index, 'lengthCm')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showError(index, 'weight', true) && !_vm.showError(index, 'lengthCm', true)),
        expression: "showError(index, 'weight', true) && !showError(index, 'lengthCm', true)"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.showError(index, 'weight')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showError(index, 'shoeSize', true) && !_vm.showError(index, 'lengthCm', true) && !_vm.showError(index, 'weight', true)),
        expression: "showError(index, 'shoeSize', true) && !showError(index, 'lengthCm', true) && !showError(index, 'weight', true)"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.showError(index, 'shoeSize')))])]), _vm._v(" "), _c('div', {
      staticClass: "--inner-width"
    }, [_c('div', {
      staticClass: "addons inner-width"
    }, [(!person.onlySkipass && person.possibleAddons && person.possibleAddons.length) ? _c('h4', [_vm._v(_vm._s(_vm.$t('skirental.rent-addon')))]) : _vm._e(), _vm._v(" "), (!person.onlySkipass) ? _c('div', {
      staticClass: "addon-list"
    }, _vm._l((person.possibleAddons), function(product) {
      return (_vm.showProduct(index, product)) ? _c('div', {
        class: {
          active: _vm.productIsAdded(index, product)
        }
      }, [_c('div', {
        class: {
          image: true, 'default-image': true, 'has-description': !!product.description
        },
        style: (product.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + product.image + ')' : 'background-size:cover;'),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.infoPopup(product)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "info-blue",
          "scale": 0.9
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('h4', [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s((person.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : person.days) + " " + _vm._s((person.priceType === 'night' ?
        (_vm.SITE_CONFIG.site === 'vallasen' ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
          hours: _vm.SITE_CONFIG.rental.night_hours
        })) :
        (person.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
      )) + "\n              ")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(product['price_' + person.days + (person.priceType === 'night' ? '_night' : '')])))]), _vm._v(" "), _c('button', {
        class: {
          small: true,
            green: _vm.productIsAdded(index, product),
            'float-right': true
        },
        on: {
          "click": function($event) {
            return _vm.addAddon(index, product)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.productIsAdded(index, product) ? _vm.$t('general.picked') : _vm.$t('general.pick')) + "\n              ")])])]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), (!person.onlySkipass && person.possibleBuy && person.possibleBuy.length) ? _c('h4', [_vm._v(_vm._s(_vm.$t('skirental.buy-addon')))]) : _vm._e(), _vm._v(" "), (!person.onlySkipass) ? _c('div', {
      staticClass: "addon-list"
    }, _vm._l((person.possibleBuy), function(product) {
      return (_vm.showProduct(index, product)) ? _c('div', {
        class: {
          active: _vm.productIsAdded(index, product)
        }
      }, [_c('div', {
        class: {
          image: true, 'default-image': true, 'has-description': !!product.description
        },
        style: (product.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + product.image + ')' : 'background-size:cover;'),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.infoPopup(product)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "info-blue",
          "scale": 0.9
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('h4', [_vm._v(_vm._s(product.name))]), _vm._v(" "), ((product.code || '').match(/liftkort|skipass/ig)) ? _c('p', [_vm._v("\n                " + _vm._s((person.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : person.days) + " " + _vm._s((person.priceType === 'night' ?
        (_vm.SITE_CONFIG.site === 'vallasen' ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
          hours: _vm.SITE_CONFIG.rental.night_hours
        })) :
        (person.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
      )) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(product['price_' + person.days + (person.priceType === 'night' ? '_night' : '')])))]), _vm._v(" "), _c('button', {
        class: {
          small: true,
            green: _vm.productIsAdded(index, product),
            'float-right': true
        },
        on: {
          "click": function($event) {
            return _vm.addAddon(index, product)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.productIsAdded(index, product) ? _vm.$t('general.picked') : _vm.$t('general.pick')) + "\n              ")])])]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "products"
    }, [_c('div', {
      staticClass: "heading-products"
    }, [_vm._v(_vm._s(_vm.$t('general.summary')))]), _vm._v(" "), _c('table', [_vm._l((person.products), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _vm._l((person.addons), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery_fee_active && _vm.hasDelivery && !_vm.parentHasFee) ? _c('tr', {
      staticClass: "delivery-fee-row"
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm.SITE_CONFIG.rental.delivery_fee_name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.SITE_CONFIG.rental.delivery_fee_price)))])])]) : _vm._e(), _vm._v(" "), _c('tr', {
      staticClass: "total"
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm.$t('general.price')) + " " + _vm._s(person.name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((
      person.products.reduce(function(a, product) {
        return a + product.price
      }, 0) +
      person.addons.reduce(function(a, product) {
        return a + product.price
      }, 0)
    ))))])])])], 2)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "sum-bar"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.total-neutrum')) + ":\n      "), _c('b', [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.sum)) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "center space-3 button-confirm"
  }, [(_vm.nextIndex) ? _c('button', {
    class: {
      disabled: !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-on-to-next-skier')))]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    class: {
      small: true, white: true, border: true, big: true, disabled: !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.addPerson()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.add-skier')))]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('span', {
    staticStyle: {
      "margin-left": "15px",
      "margin-right": "15px"
    }
  }, [_vm._v(" ... " + _vm._s(_vm.$t('general.or')) + " ... ")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    class: {
      disabled: !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.doRental()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.complete-booking')))]) : _vm._e()])], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: [
      'component',
      'outline-button',
      _vm.active && 'active',
      _vm.label && 'has-text'
    ],
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.icon) ? _c('icon', {
    attrs: {
      "name": _vm.icon,
      "scale": _vm.iconscale
    }
  }) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cancel')))])])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.errorCode) ? _c('div', [(_vm.showTexts) ? _c('h2', [_vm._v(_vm._s(_vm.$t('general.creating-order')))]) : _vm._e(), _vm._v(" "), (_vm.showTexts) ? _c('p', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.showTexts) ? _c('p', [_vm._v(_vm._s(_vm.$t('general.creating-hang-on')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "inner",
    style: ('width:' + _vm.percentage + '%')
  })]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.percentage) + "%")])]) : _vm._e(), _vm._v(" "), (_vm.errorCode && _vm.showTexts) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('general.we-got-error')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), (!_vm.errorMessage && !_vm.errorMessages.length) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('general.we-got-error-info', {
        phone: '<a href=\'tel:054-13 26 00\'>054&#8209;13&nbsp;26&nbsp;00</a>'
      }))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errorMessages.length) ? _c('ul', {
    staticClass: "error"
  }, _vm._l((_vm.errorMessages), function(message) {
    return _c('li', _vm._l((message), function(m) {
      return _c('span', {
        domProps: {
          "innerHTML": _vm._s(m)
        }
      })
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.codes.length) ? _c('ul', {
    staticClass: "error"
  }, _vm._l((_vm.codes), function(code) {
    return _c('li', [_vm._v(_vm._s(code[1]) + " (" + _vm._s(_vm.$t('general.error-code-code')) + " " + _vm._s(code[0]) + ")")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.order) ? _c('p', [_vm._v(_vm._s(_vm.$t('general.your-reference-number')) + ": "), _c('b', [_vm._v("#" + _vm._s(_vm.order.id))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('general.close')))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.isDebugging) ? _c('div', {
    staticClass: "component",
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "left": "0",
      "background-color": "white",
      "z-index": "10000",
      "height": "35px",
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Tid:\n  " + _vm._s(_vm.time) + "\n  " + _vm._s(_vm.seconds) + "\n")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'notification ' + _vm.colorClass + ' ' + _vm.alignClass,
    attrs: {
      "role": "note"
    }
  }, [_c('div', {
    class: 'flexer' + (_vm.icon ? ' has-icon' : '')
  }, [(_vm.icon) ? _c('Icon', {
    attrs: {
      "name": _vm.icon,
      "scale": "1.2"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.title) ? _c(_vm.elementTag, {
    tag: "component"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (_vm.isAddonBooking) ? _c('h1', [_vm._v("Snart dags för din semester!")]) : _c('h1', [_vm._v("Snart är din semester bokad!")]), _vm._v(" "), _c('p', {
    staticClass: "ingress"
  }, [_vm._v("Gör den mer bekväm med våra tillval:")]), _vm._v(" "), _c('div', {
    staticClass: "bg-color-faded"
  }, [_c('div', {
    staticClass: "addons"
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("BOKA TILLVAL TILL ERT BOENDE")]), _vm._v(" "), (true) ? _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em"
    }
  }, [_vm._v("En barnsäng och barnstol ingår alltid i våra boenden.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.addons), function(addon) {
    return (!addon.hide_for_guest) ? _c('div', {
      class: 'addon center ' + (addon.added ? 'selected' : '') + ' ' + (addon.auto === 'T' ? 'auto' : ''),
      attrs: {
        "title": (_vm.$store.state.isDebugging) ? addon.lid : ''
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.chooseArticle(addon)
        }
      }
    }, [_c('div', {
      staticClass: "addon-image default-image",
      style: (addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + addon.image + ');' : 'background-size: cover;'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(addon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 0.9
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "addon-content"
    }, [_c('b', [_vm._v(_vm._s(addon.arttext))]), _vm._v(" "), _c('p', [_c('span', {
      staticStyle: {
        "font-weight": "700"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(((
      (addon.rut && (_vm.$store.state.cart.ssn || !addon.added))
    ) ? (parseFloat(addon.curraprice) * 0.5) : addon.curraprice))))]), (!addon.rut && !addon.single_count && addon.max_qty > 1) ? _c('span', [_vm._v("/st")]) : _vm._e(), _vm._v(" "), ((
      (addon.rut && (_vm.$store.state.cart.ssn || !addon.added))
    )) ? _c('span', {
      staticClass: "with-rut"
    }, [_vm._v("med RUT-avdrag")]) : _vm._e()]), _vm._v(" "), (addon.auto !== 'T') ? _c('div', {
      staticClass: "input-wrapper",
      staticStyle: {
        "text-align": "left"
      }
    }, [(!addon.added && addon.max_qty > 1 && !addon.single_count) ? _c('span', {
      staticClass: "quantity",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addon.qtySelected),
        expression: "addon.qtySelected"
      }],
      attrs: {
        "type": "number",
        "min": addon.min_qty,
        "max": addon.max_qty
      },
      domProps: {
        "value": (addon.qtySelected)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addon, "qtySelected", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("st")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small ' + (addon.added ? 'green' : '') + '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [(addon.max_qty > 1 && !addon.single_count) ? _c('span', [_vm._v("\n                " + _vm._s(addon.qtySelected) + "st valda\n              ")]) : _c('span', [_vm._v("\n                Vald\n              ")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small trash border',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.3
      }
    })], 1) : _vm._e(), _vm._v(" "), (!addon.added) ? _c('button', {
      class: {
        small: true, disabled: !addon.qtySelected
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.chooseArticle(addon)
        }
      }
    }, [_vm._v("Välj")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (addon.auto === 'T') ? _c('div', {
      staticClass: "input-wrapper",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('button', {
      class: 'small ' + 'green' + ' non-clickable'
    }, [_c('span', [_vm._v("\n                " + _vm._s(addon.autoText || 'Obligatoriskt') + "\n              ")])])]) : _vm._e()])]) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.groceryBags.length) ? _c('div', {
    staticClass: "addons grocery-bags"
  }, [_c('h2', {
    staticClass: "center"
  }, [_vm._v("GÖR DIN RESA ÄNNU MER BEKVÄM")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.groceryBags), function(addon) {
    return _c('div', {
      class: 'addon center ' + (addon.added ? 'selected' : ''),
      attrs: {
        "title": (_vm.$store.state.isDebugging) ? addon.lid : ''
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleArticle(addon)
        }
      }
    }, [_c('div', {
      staticClass: "addon-image default-image",
      style: (addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + addon.image + ');' : 'background-size: cover;'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(addon)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "addon-content"
    }, [_c('h2', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(addon)
        }
      }
    }, [_vm._v(_vm._s(addon.arttext) + "  "), _c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 1
      }
    })], 1), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('p', [_c('span', {
      staticStyle: {
        "font-weight": "700",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(addon.curraprice)))]), _vm._v("/st")]), _vm._v(" "), _c('div', {
      staticClass: "input-wrapper",
      staticStyle: {
        "text-align": "center"
      }
    }, [(!addon.added && addon.max_qty > 1 && !addon.single_count) ? _c('span', {
      staticClass: "quantity",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addon.qtySelected),
        expression: "addon.qtySelected"
      }],
      attrs: {
        "type": "number",
        "min": addon.min_qty,
        "max": addon.max_qty
      },
      domProps: {
        "value": (addon.qtySelected)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addon, "qtySelected", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("st")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small ' + (addon.added ? 'green' : '') + '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [_c('span', [_vm._v("\n                Vald\n              ")])]) : _vm._e(), _vm._v(" "), (addon.added) ? _c('button', {
      class: 'small trash border',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeArticle(addon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.3
      }
    })], 1) : _vm._e(), _vm._v(" "), (!addon.added) ? _c('button', {
      class: {
        small: true, disabled: !addon.qtySelected
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.chooseArticle(addon)
        }
      }
    }, [_vm._v("Välj")]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.lateArrivalObject) ? _c('div', {
    staticClass: "center spacing"
  }, [_c('div', {
    staticClass: "late-arrival"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_c('b', [_vm._v("\n            Sen ankomst\n            "), _c('span', {
    staticStyle: {
      "position": "relative",
      "top": "-2px",
      "left": "5px",
      "cursor": "pointer",
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.openLateCheckinInfo()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1
    }
  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Sen incheckning, efter kl " + _vm._s(_vm.lateArrivalTime) + ".")])]), _vm._v(" "), _c('p', {
    staticClass: "checkboxes"
  }, [_c('Checkbox', {
    class: {
      error: _vm.markLate
    },
    attrs: {
      "label": "JA",
      "label-position": "after",
      "value": true,
      "valuebinder": _vm.lateArrival
    },
    on: {
      "click": function($event) {
        _vm.unmarkLateError();
        _vm.toggleLate({
          value: true
        });
      },
      "update:valuebinder": function($event) {
        _vm.lateArrival = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    class: {
      error: _vm.markLate
    },
    attrs: {
      "label": "NEJ",
      "label-position": "after",
      "value": false,
      "valuebinder": _vm.lateArrival
    },
    on: {
      "click": function($event) {
        _vm.unmarkLateError();
        _vm.toggleLate({
          value: false
        });
      },
      "update:valuebinder": function($event) {
        _vm.lateArrival = $event
      }
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isSummerSeason) ? _c('div', {
    staticClass: "cancellation-insurance"
  }, [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title) ? _c('h3', [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1
    }
  }), _vm._v(" " + _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title))], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3) ? _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cancellationInsuranceEnabled && _vm.cancellationInsuranceObject) ? _c('div', {
    staticClass: "cancellation-insurance"
  }, [_vm._m(1), _vm._v(" "), _c('h3', [_c('icon', {
    attrs: {
      "name": "avbestallning",
      "scale": 2
    }
  }), _vm._v(" Avbeställningskydd "), _c('em', [_vm._v(_vm._s(_vm._f("currency")(_vm.cancellationInsuranceObject.curraprice)))])], 1), _vm._v(" "), _c('p', [_vm._v("Branäsgruppen erbjuder ett av branschens mest generösa om- och avbokningsskydd. Det innebär att om du har köpt vårt om- och avbeställningsskydd kan du fritt omboka eller avboka fram tills dess att det är 20 dagar kvar till ankomst. Du behöver inget skäl eller intyg. När det är 20 dagar kvar eller mindre till ankomst kan du med ett giltigt skäl och ett intyg om- eller avboka mot en expeditionsavgift på 200 kr. Läs mer i våra bokningsregler. ")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.cancellationInsuranceObject.text)
    }
  }), _vm._v(" "), _c('p', [_c('Checkbox', {
    class: {
      error: _vm.markInsurance, 'non-clickable': _vm.cancellationInsuranceObject.free
    },
    attrs: {
      "label": "JA",
      "label-position": "after",
      "value": true,
      "valuebinder": _vm.cancellationInsurance
    },
    on: {
      "click": function($event) {
        return _vm.unmarkInsuranceError()
      },
      "update:valuebinder": function($event) {
        _vm.cancellationInsurance = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    class: {
      error: _vm.markInsurance, disabled: _vm.cancellationInsuranceObject.free
    },
    attrs: {
      "label": "NEJ",
      "label-position": "after",
      "value": false,
      "valuebinder": _vm.cancellationInsurance
    },
    on: {
      "click": function($event) {
        return _vm.unmarkInsuranceError()
      },
      "update:valuebinder": function($event) {
        _vm.cancellationInsurance = $event
      }
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "2em",
      "padding-bottom": "2em"
    }
  }, [_c('button', {
    class: {
      disabled: !_vm.validated()
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Nästa")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "font-size": "11px"
    }
  }, [_vm._v("För 4 personer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "required-notice"
  }, [_c('span', [_vm._v("*")]), _vm._v(" Obligatoriska fält")])
}]}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: {
      'filter-list-item': true, disabled: (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number && _vm.filter === 'date')
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.computedIcon) ? _c('icon', {
    staticClass: "icon",
    attrs: {
      "name": _vm.computedIcon,
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.computedLabel))]), _vm._v(" "), _c('span', {
    staticClass: "close"
  }, [_c('icon', {
    attrs: {
      "name": "times",
      "scale": 0.8
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, disabled: _vm.loading
    }
  }, [(_vm.isNew) ? _c('h1', [_vm._v("Skapa lösenord")]) : _c('h1', [_vm._v("Glömt lösenord")]), _vm._v(" "), (!_vm.loggedIn) ? _c('div', [(_vm.isNew) ? _c('p', [_vm._v("Ange din e-postadress nedan för att få instruktioner om hur du skapar ditt lösenord.")]) : _c('p', [_vm._v("Ange din e-postadress nedan för att få instruktioner om hur du återställer ditt lösenord.")]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("E-postadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "placeholder": "Din e-postadress",
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.save()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage)), _c('br'), _c('br'), _vm._v("Ring gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" om du behöver hjälp."), _c('br'), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "block",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Begär nytt lösenord")])])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Du är redan inloggad. "), _c('router-link', {
    attrs: {
      "to": "{name: 'my pages'}"
    }
  }, [_vm._v("Klicka här")]), _vm._v(" om du vill gå till dina sidor.")], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ })
],[324]);


// WEBPACK FOOTER //
// static/js/app.6733d625b9b88721aac4.js